/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/myevents/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(207);
	__webpack_require__(177);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(12);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dateFormat = __webpack_require__(70);
	
	/**
	 * Type coercion from anything to int or 0
	 * @param str
	 * NOTE By design this takes one argument (so it can be directly used in mapping functions)
	 * @returns {*|number}
	 */
	var toInt = function(str){//NOTE By design this takes one argument (so it can be directly used in mapping functions)
		return _.parseInt(_.isString(str) ? str.replace(/[^\-0-9.]/g, '') : str, 10) || 0;
	};
	
	/**
	 * Type coercion from anything to float or 0
	 * @param str
	 * NOTE By design this takes one argument (so it can be directly used in mapping functions)
	 * @returns {*|number}
	 */
	var toFloat = function(str){//NOTE By design this takes one argument (so it can be directly used in mapping functions)
		  return parseFloat(_.isString(str) ? str.replace(/[^\-0-9.]/g, '') : str) || 0;
	};
	
	/**
	 * Take a balboa ISO8601 datetime and turn it into a js date
	 * @param timestamp
	 */
	var convertFromISO8601 = function(timestamp){
		var day = _.map(timestamp.split(/\D/), toInt);
		day[1] -= 1;
		var d = new Date(Date.UTC.apply(Date, day));
		return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
	};
	
	/**
	 * Our own ISO8601 formatter, since Date.toISOString() converts
	 * to UTC first, and we don't want that.
	 *
	 * @param date
	 * @returns string
	 */
	var returnISO8601 = (function(){
		var pad = function(number){
			if(number < 10){
				return '0' + number;
			}
			return number;
		};
		return function(date){
			return date.getFullYear() +
				'-' + pad(date.getMonth() + 1) +
				'-' + pad(date.getDate()) +
				'T' + pad(date.getHours()) +
				':' + pad(date.getMinutes()) +
				':' + pad(date.getSeconds());
		};
	}());
	
	var FIX_fromISO8601 = function(obj, fields){
		_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
			if(_.has(obj, field + '_ISO8601') && _.has(obj, field)){
				obj[field] = obj[field] < 1 ? null : convertFromISO8601(obj[field + '_ISO8601']);
			}
		});
		return obj;
	};
	var FIX_fromISO8601_or_DateConstructor = function(obj, fields){
		_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
			if(_.has(obj, field + '_ISO8601') && _.has(obj, field)){
				obj[field] = obj[field] < 1 ? null : convertFromISO8601(obj[field + '_ISO8601']);
			}else if(_.has(obj, field)){
				obj[field] = new Date(obj[field]);
			}
		});
		return obj;
	};
	var FIX_toISO8601 = function(obj, fields){
		_.each(_.filter(_.flattenDeep([fields]), _.isString), function(field){
			if(_.has(obj, field)){
				obj[field + '_ISO8601'] = _.isDate(obj[field]) ? returnISO8601(obj[field]) : null;
			}
		});
		return obj;
	};
	
	var cleanup_ids = function(ids){
		return _.uniq(_.filter(_.map(ids, toInt), function(id){
			return id > 0;
		}));
	};
	
	var toMpURL = function(url, bureau_id){
		if((typeof MP !== 'undefined') && _.isFunction(MP && MP.toMpURL)){
			return MP.toMpURL(url, bureau_id);
		}
		return url;
	};
	
	var StoredFile_Balboa3toJS = function(StoredFile){
		StoredFile.id = toInt(StoredFile.id);
		StoredFile.eid = toInt(StoredFile.eid);
		StoredFile.sids = cleanup_ids(StoredFile.sids);
		StoredFile.postdate = StoredFile.postdate < 1 ? null : convertFromISO8601(StoredFile.postdate_iso8601);
		return StoredFile;
	};
	var StoredFile_JStoBalboa3 = function(StoredFile){
		if(_.isDate(StoredFile.postdate)){
			StoredFile.postdate_iso8601 = returnISO8601(StoredFile.postdate);
		}
		return StoredFile;
	};
	
	var fixMPcontractDates = function(MPcontract){
		_.each(['created', 'buyer_signed', 'speaker_signed'], function(field){
			if(MPcontract[field] !== false){
				MPcontract[field] = convertFromISO8601(MPcontract[field + '_ISO8601']);
			}
		});
		return MPcontract;
	};
	
	var isNumber = function(n){//What does NaN stand for? ... yep Not a Number!
		return _.isNumber(n) && !_.isNaN(n);
	};
	
	var isValue = function(obj){
		return !_.isObject(obj) && !_.isArray(obj);
	};
	
	var isBlank = function(str){
		return _.isEmpty(str) || !_.isString(str) || str.trim().length === 0;
	};
	
	/**
	 * Get a value out of a nested data structure at a given path.
	 *
	 * 5 === getIn({a: {b: 5}}, ['a', 'b'])
	 * 5 === getIn({a: {b: [1, 5]}}, ['a', 'b', 1])
	 */
	var getIn = function(obj, path){
		if(!_.isArray(path)){
			return null;
		}
		if(_.isEmpty(path)){
			return obj;
		}
		var key = _.first(path);
		if(_.has(obj, key)){
			return getIn(obj[key], _.tail(path));
		}
		return null;
	};
	
	
	/**
	 * deepDiff
	 * Compares two values, returns all the paths that are either, the same, added, removed, or changed.
	 *
	 */
	var deepDiff = function deepDiff(a, b, path){
		if(_.isFunction(a) || _.isFunction(b)){
			return null;
		}
	
		path = _.isArray(path) ? path : [];
	
		var diff = {
			same: [],
			added: [],
			removed: [],
			changed: []
		};
	
		if(isValue(a) || isValue(b)){
			if(a === b){
				diff.same = [path];
			}else if(_.isUndefined(a)){
				diff.added = [path];
			}else if(_.isUndefined(b)){
				diff.removed = [path];
			}else{
				diff.changed = [path];
			}
	
		}else{
			_.each(_.uniq(_.keys(a).concat(_.keys(b))), function(key){
				if(diff === null){
					return;
				}
				var d = deepDiff(a[key], b[key], path.concat([key]));
				if(d === null){
					diff = null;
					return;
				}
	
				_.each(diff, function(v, type){
					if(_.isArray(d[type]) && d[type].length > 0){
						diff[type] = diff[type].concat(d[type]);
					}
				});
			});
		}
		return diff;
	};
	
	var flagsAsMap_to_Flags = function(flags_as_map){
		return _.reduce(flags_as_map, function(total, f) {
			return total + (f.is_set ? f.intval : 0);
		}, 0);
	};
	
	var convertBalboa3ToJS = {
		Flight: function(flight){
			flight.id = toInt(flight.id);
			flight.eid = toInt(flight.eid);
			flight.cost = toFloat(flight.cost);
			flight.legs = _.map(flight.legs, function(leg){
				leg.id = toInt(leg.id);
				leg.legcost = toFloat(leg.legcost);
				return FIX_fromISO8601_or_DateConstructor(leg, ['legleave', 'legarrive']);
			});
			return flight;
		},
		Hotel: function(hotel){
			hotel.id = toInt(hotel.id);
			hotel.eid = toInt(hotel.eid);
			return FIX_fromISO8601(hotel, ['checkindate', 'checkoutdate']);
		},
		Ground: function(ground){
			ground.id = toInt(ground.id);
			ground.eid = toInt(ground.eid);
			ground.cost = toFloat(ground.cost);
			return FIX_fromISO8601(ground, 'starttime');
		},
		Service: function(item){
			item.fee = toFloat(item.fee);
			return FIX_fromISO8601(item, 'due');
		}
	};
	
	module.exports = {
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Functions for eSpeakers Data
		get_selected_speaker_id: function(event){
			if(!event || !_.isArray(event.sids)){
				return null;
			}
			var sid = toInt(_.first(event.sids));
			return sid > 0 ? sid : null;
		},
		venue_to_string: function(venue){
			var parts = [];
			if(venue && venue.address){
				parts.push(venue.address);
			}
			//building
			if(venue && venue.city){
				parts.push(venue.city);
			}
			if(venue && venue.st){
				parts.push(venue.st);
			}
			if(venue && venue.country){
				parts.push(venue.country);
			}
			if(venue && venue.zip){
				parts.push(venue.zip);
			}
			return parts.join(', ');
		},
		get_shortlist_speaker_ids: function(event){
			return event.MPshortlist && _.isArray(event.MPshortlist.speaker_ids) ? event.MPshortlist.speaker_ids : [];
		},
		toMpURL: toMpURL,
		get_shortlist_url: function(event){
			return '#/shortlist/' + event.eid;
		},
		get_contract_url: function(event){
			return '#/contract/' + event.eid;
		},
		get_payments_url: function(event){
			return event.MPcontract && event.MPcontract.id > 0 ? toMpURL('/payment/view/' + event.MPcontract.id) : null;
		},
		get_review_url: function(event){
			var sid = this.get_selected_speaker_id(event);
			return toMpURL('/speaker/review/' + sid + '?event_id=' + event.eid);
		},
		isEventReadyForBuyerReview: function(event){
			var today = new Date();
			return today >= event.stoptime;
			//return event.MPcontract && event.MPcontract.contract_in_force && event.MPpayment && event.MPpayment.event_is_paid_for;
		},
		get_buyername_for_event: function(event){
			var buyer_names = _.map(event && event.Buyers, function(Buyer){
				return Buyer.firstname + ' ' + Buyer.lastname;
			});
			if(buyer_names.length === 0){
				buyer_names = ['the Buyer'];
			}
			return buyer_names.join(', ');
		},
		getEventVersionIdentifier: function(event){
			if(event && event.eid > 0 && event.modified){
				return event.eid + '-' + event.modified;
			}
			return null;
		},
		StoredFile_Balboa3toJS: StoredFile_Balboa3toJS,
		StoredFile_JStoBalboa3: StoredFile_Balboa3toJS,
		fixMPcontractDates: fixMPcontractDates,
		convertBalboa3ToJS: convertBalboa3ToJS,
		convertBalboa3EventToJSEvent: function(event){
			event.eid = toInt(event.eid);
			event.sids = cleanup_ids(event.sids);
			event.bureauID = toInt(event.bureauID);
	
			event.companyID = toInt(event.companyID);
			event.presentingproductid = toInt(event.presentingproductid);
	
			event.topics = _.map(event.topics, function(topic){
				return topic.replace(/\//g, ' / ').trim();
			});
	
			if(event.MPcontract){
				event.MPcontract = fixMPcontractDates(event.MPcontract);
			}
	
			if(event.budget_min > 0 && event.budget_max === 0){
				event.budget_max = Infinity;
			}
	
			event = FIX_fromISO8601(event, 'created');
			event = FIX_fromISO8601(event, 'ccDateTime');
			event = FIX_fromISO8601(event, 'modified');
	
			event.Stagetime = _.map(event.Stagetime, function(stagetime){
				stagetime.venueid = toInt(stagetime.venueid);
				return FIX_fromISO8601(stagetime, ['starttime', 'stoptime', 'avchecktime']);
			});
	
			event.starttime = _.min(event.Stagetime,function(stagetime){
				return _.isDate(stagetime.starttime) ? stagetime.starttime.getTime() : 0;
			}).starttime;
	
			event.stoptime = _.max(event.Stagetime,function(stagetime){
				return _.isDate(stagetime.stoptime) ? stagetime.stoptime.getTime() : 0;
			}).stoptime;
	
			event.Note = _.map(event.Note, function(note){
				return FIX_fromISO8601(note, 'datetime');
			});
	
			_.each(["Flight", "Hotel", "Ground", "Service"], function(key){
				event[key] = _.map(event[key], convertBalboa3ToJS[key]);
			});
	
			_.each(event.VideoCoaching, function(p){
				_.each(p.sessions, function(s){
					s = FIX_fromISO8601(s, "startdate");
				});
			});
	
			event.EventTodo = _.map(event.EventTodo, function(todo){
				todo.id = toInt(todo.id);
				todo.eid = toInt(todo.eid);
				todo.status = toInt(todo.status);
				todo.vieworder = toInt(todo.vieworder);
				todo.from_list_id = toInt(todo.from_list_id);
				todo.from_list_sid = toInt(todo.from_list_sid);
				return FIX_fromISO8601(todo, 'statusdate');
			});
			event.storedfiles = _.map(event.storedfiles, StoredFile_Balboa3toJS);
			event.todolistids = _.map(_.isString(event.todolistids) && event.todolistids.split(','), function(part){
				if (part.indexOf('|') > 0) {
					var split = part.split('|');
					return {sid: toInt(split[0]), listid: toInt(split[1])};
				} else {
					return part;
				}
			});
	
			return event;
		},
		convertJSEventToBalboa3Event: function(event){
			if(!_.isPlainObject(event) || !_.has(event, 'eid')){
				return null;
			}
			event = FIX_toISO8601(event, 'created');
			event = FIX_toISO8601(event, 'ccDateTime');
			event.Stagetime = _.map(event.Stagetime, function(stagetime){
				return FIX_toISO8601(stagetime, ['starttime', 'stoptime', 'avchecktime']);
			});
			event.Note = _.map(event.Note, function(note){
				return FIX_toISO8601(note, 'datetime');
			});
			event.Flight = _.map(event.Flight, function(flight){
				flight.legs = _.map(flight.legs, function(leg){
					return FIX_toISO8601(leg, ['legarrive', 'legleave']);
				});
				return flight;
			});
			event.Hotel = _.map(event.Hotel, function(hotel){
				return FIX_toISO8601(hotel, ['checkindate', 'checkoutdate']);
			});
			event.Ground = _.map(event.Ground, function(ground){
				return FIX_toISO8601(ground, 'starttime');
			});
			event.EventTodo = _.map(event.EventTodo, function(todo){
				todo.vieworder = toInt(todo.vieworder);
				return FIX_toISO8601(todo, 'statusdate');
			});
			event.Service = _.map(event.Service, function(todo){
				return FIX_toISO8601(todo, 'due');
			});
			event.storedfiles = _.map(event.storedfiles, StoredFile_JStoBalboa3);
			event.todolistids = _.map(_.filter(event.todolistids, function(todolist){
				return (
					(_.has(todolist, ["sid"]) && _.has(todolist, ["listid"])) && (_.isNumber(todolist.sid) && !_.isNaN(todolist.sid) && todolist.sid > 0 && _.isNumber(todolist.listid) && !_.isNaN(todolist.listid))
					||
					(!_.has(todolist, ["sid"]) && !_.has(todolist, ["listid"]) && (_.parseInt(todolist) > 0))
				);
			}),function(todolist){
				if (_.has(todolist, ["sid"]) && _.has(todolist, ["listid"])) {
					return todolist.sid + '|' + todolist.listid;
				} else {
					return todolist;
				}
			}).join(',');
	
			_.each(event.VideoCoaching, function(p){
				p.sessions = _.map(p.sessions, function(s){
					s.flags = flagsAsMap_to_Flags(s.flags_as_map);
					return FIX_toISO8601(s, "startdate");
				});
			});
	
			if(_.has(event, "flags_as_map")){
				event.flags = flagsAsMap_to_Flags(event.flags_as_map);
			}
	
			event.isPersonal = !!event.isPersonal;
			if(_.has(event, 'isPersonal_ISO8601')){
				delete event.isPersonal_ISO8601;
			}
			return event;
		},
	
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Formatting Functions
		get_initials: function(name){
			return name.replace(/\W*(\w)\w*/g, '$1.').toUpperCase();
		},
		format_number: function(num, num_decimals){
			num = _.isString(num) ? parseFloat(num) : num;
			if(!_.isNumber(num) || _.isNaN(num)){
				return '0';
			}
			if(_.isNumber(num_decimals) && num_decimals >= 0){
				num = num.toFixed(num_decimals);
			}
			return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
		format_currency: function(price, num_decimals){
			return '$' + this.format_number(price, num_decimals);
		},
		format_budget_range: function(price_range, msg_on_free){
	        var self = this;
	        var prices = !_.isArray(price_range) ? [] : _.uniq(_.sortBy(_.filter(_.map(price_range, function(price){
	            return price == Infinity || price == -Infinity ? price : _.parseInt(price);
	        }), function(price){
	            return price >= -1;
	        })), true);
	
	        if(prices.length === 1 && prices[0] === -1){
	            return _.isString(msg_on_free) ? msg_on_free : '(to be determined)';
	        }
	        if(prices.length === 1 && prices[0] === 0){
	            return _.isString(msg_on_free) ? msg_on_free : '(free)';
	        }
	        if(prices.length === 2 && prices[1] === Infinity){
	            return 'More than ' + self.format_currency(prices[0], 0);
	        }
	        return _.map(prices,function(price){
	            return self.format_currency(price, 0);
	        }).join(' - ');
	    },
	
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Date Functions
		convertFromISO8601: convertFromISO8601,
		returnISO8601: returnISO8601,
		format_date: dateFormat,
		get_n_days_in_month: function(year, month){
			return [31, ((((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		},
		get_day_of_week: function(day_input, use_short){
			var day = parseInt(day_input);
			if(!_.isNumber(day) || _.isNaN(day)){
				return day_input;
			}
			day = (day - 1) % 7;
			day = day < 0 ? 7 + day : day;
			return dateFormat.i18n.dayNames[!use_short ? day + 7 : day];
		},
		get_month_name: function(month_input, use_short){
			var month = parseInt(month_input);
			if(!_.isNumber(month) || _.isNaN(month)){
				return month_input;
			}
			month = (month - 1) % 12;
			month = month < 0 ? 12 + month : month;
			return _.isNumber(month) ? dateFormat.i18n.monthNames[!use_short ? month + 12 : month] : month;
		},
		build_calendar_weeks: function(year, month, must_be_six_weeks){
			var d = new Date(year, month - 1, 1, 0, 0, 0, 0);
			var daysInPrevMonth = d.getMonth() === 0 ? this.get_n_days_in_month(d.getFullYear() - 1, 11) : this.get_n_days_in_month(d.getFullYear(), d.getMonth() - 1);
			var daysInThisMonth = this.get_n_days_in_month(d.getFullYear(), d.getMonth());
			var dayOfWeekStartsOn = d.getDay();
			var dateI = 1;
			var i;
			var weeks = [];
	
			var curWeek = [];
			for(i = 0; i < dayOfWeekStartsOn; i++){
				curWeek.push({date: daysInPrevMonth - (dayOfWeekStartsOn - i) + 1, out_of_month: true});
			}
			while(dateI <= daysInThisMonth){
				if(curWeek.length === 7){
					weeks.push(curWeek);
					curWeek = [];
				}
				curWeek.push({date: dateI});
				dateI++;
			}
			if(curWeek.length > 0){
				var daysToAdd = 7 - curWeek.length;
				for(i = 0; i < daysToAdd; i++){
					curWeek.push({date: i + 1, out_of_month: true});
				}
				weeks.push(curWeek);
				if(must_be_six_weeks){
					while(weeks.length < 6){
						curWeek = [];
						var j;
						for(j = 0; j < 7; j++){
							curWeek.push({date: i + 1, out_of_month: true});
							i++;
						}
						weeks.push(curWeek);
					}
				}
			}
			return weeks;
		},
	
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Browser env related
		wrapPreventDefault: function(fn){
			return function(e){
				if(e && e.preventDefault){
					e.preventDefault();
				}
				if(e && e.stopPropagation){
					e.stopPropagation();
				}
				fn.call(this, e);
			};
		},
		encode_redir: function(url){
			return url.replace(/_/g, 'mrunderscore').replace(/\//g, '_');
		},
		decode_redir: function(url){
			return url.replace(/_/g, '/').replace(/mrunderscore/g, '_');
		},
		phpCompatibleParams: function(params){
			var parts = [];
			_.each(params, function(value, key){
				if(value === null || _.isUndefined(value))
					return;
				var is_this_array = _.isArray(value);
				if(!is_this_array){
					value = [value];
				}
	
				_.each(value, function(v){
					if(_.isObject(v)){
						v = JSON.stringify(v);
					}
					parts.push(encodeURIComponent(key) + (is_this_array ? '[]' : '') + '=' + encodeURIComponent(v));
				});
			});
			return parts.join('&');
		},
	
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Data functions
		toInt: toInt,
		toFloat: toFloat,
		getIn: getIn,
		isValue: isValue,
		isBlank: isBlank,
		isNumber: isNumber,
		deepDiff: deepDiff,
		cleanup_ids: cleanup_ids,
		is_valid_email: (function(){
			//RFC882 email validator
			var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
			var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
			var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
			var sQuotedPair = '\\x5c[\\x00-\\x7f]';
			var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
			var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
			var sDomain_ref = sAtom;
			var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
			var sWord = '(' + sAtom + '|' + sQuotedString + ')';
			var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
			var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
			var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
			var sValidEmail = '^' + sAddrSpec + '$'; // as whole string
	
			var reValidEmail = new RegExp(sValidEmail);
	
			return function(email){
				return reValidEmail.test(email);
			};
		}())
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global AUTHED_USER_SESSION, LAST_LOGIN_USERNAME, PRIVATE_LABEL_CONFIG, localStorage */
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var doIHaveAccess = __webpack_require__(384);
	var hasLocalstorage = __webpack_require__(415);
	
	var session_data = typeof AUTHED_USER_SESSION !== "undefined" ? AUTHED_USER_SESSION : {};
	var last_login_username = typeof LAST_LOGIN_USERNAME !== "undefined" && _.isString(LAST_LOGIN_USERNAME) ? LAST_LOGIN_USERNAME : "";
	var private_label_config = typeof PRIVATE_LABEL_CONFIG !== "undefined" ? PRIVATE_LABEL_CONFIG : {};
	var st_usertype = _.get(session_data, "balboa.st_usertype", null);
	
	var companyIdsICanRead = _.map(session_data.companies, function (company) {
	  return _.get(company, ["COMPANY_ID"]);
	}); //used for team-admin privatelabels //TODO get from authentication data
	var companyIdsICanWrite = _.map(session_data.companies, function (company) {
	  return _.get(company, ["COMPANY_ID"]);
	}); //used for team-admin privatelabels //TODO get from authentication data
	var selectedCompany = function selectedCompany() {
	  var company = hasLocalstorage() ? _.parseInt(localStorage.getItem("lastSelectedCompany"), 10) : -1;
	  return company;
	};
	var activeCompany = _.has(session_data.companies, [selectedCompany()]) ? _.get(session_data.companies, [selectedCompany()]) : !_.isNull(session_data.company) ? session_data.company : _.head(_.map(session_data.companies, function (c) {
	  return c;
	})); //the currently selected company; used for team-admin privatelabels
	// _.set(private_label_config, ["privatelabel_code"], _.get(session_data, ["company", "abbreviation"]);
	var activeCompanyIds = _.map(_.filter(session_data.companies, function (company) {
	  return _.get(company, ["COMPANY_ID"]) === _.get(activeCompany, ["COMPANY_ID"]) || _.get(company, ["PARENT_ID"]) === _.get(activeCompany, ["COMPANY_ID"]);
	}), function (company) {
	  return _.get(company, ["COMPANY_ID"]);
	});
	
	var packages = {
	  STARTER: 7,
	  PLUS: 6,
	  PROFESSIONAL: 5,
	  PRO: 5
	};
	
	var getSIDsAtPackageLevel = function getSIDsAtPackageLevel(level) {
	  if (!_.isString(level) || !packages[level.toUpperCase()]) {
	    return null;
	  }
	  var level_num = packages[level.toUpperCase()];
	  return _.map(_.filter(_.pairs(_.mapValues(session_data.permissions, "version")), function (pair) {
	    return pair[1] === level_num;
	  }), function (pair) {
	    return _.parseInt(pair[0]);
	  });
	};
	
	var MY_USERNAME = _.get(session_data, "balboa.username");
	MY_USERNAME = _.isString(MY_USERNAME) ? MY_USERNAME.trim().toUpperCase() : "";
	
	var all_sids_i_have_permission_for = _.keys(session_data.permissions);
	all_sids_i_have_permission_for = _.filter(all_sids_i_have_permission_for, function (sid) {
	  var r = _.contains(_.get(session_data.permissions, [sid, "companies"], []), _.get(activeCompany, ["COMPANY_ID"]));
	  return r;
	});
	
	all_sids_i_have_permission_for = esUtils.cleanup_ids(all_sids_i_have_permission_for);
	
	//console.log("activeCompany", activeCompany);
	//console.log("private_label_config", private_label_config);
	module.exports = {
	  MY_USERNAME: MY_USERNAME,
	  balboa: session_data.balboa || {},
	  companies: session_data.companies || {},
	  permissions: session_data.permissions || {},
	  getSIDsAtPackageLevel: getSIDsAtPackageLevel,
	  is_logged_in: !_.isEmpty(MY_USERNAME),
	  last_login_username: last_login_username,
	  all_sids_i_have_permissions_for: all_sids_i_have_permission_for,
	  helpurl: private_label_config.helpurl,
	  is_st_family: "st" === (_.get(private_label_config, ["privatelabel_code"]) || '').toLowerCase() || _.includes(["sti", "stc", "mr", "st", "cls", "rs", "tnp"], (_.get(activeCompany, ["ABBREVIATION"]) || '').toLowerCase()),
	  is_st: "st" === (_.get(private_label_config, ["privatelabel_code"]) || '').toLowerCase() || _.includes(["sti", "stc", "st"], (_.get(activeCompany, ["ABBREVIATION"]) || '').toLowerCase()),
	  is_cs: "cs" === (_.get(private_label_config, ["privatelabel_code"]) || '').toLowerCase() || _.includes(["cs"], (_.get(activeCompany, ["ABBREVIATION"]) || '').toLowerCase()),
	  is_privatelabel: _.get(private_label_config, ["is_privatelabel"], false),
	  privatelabel_code: _.get(activeCompany, ["ABBREVIATION"], _.get(private_label_config, ["privatelabel_code"])),
	  is_cognito: !!private_label_config.is_cognito,
	  is_beta: !!private_label_config.is_beta,
	  is_staging: !!private_label_config.is_staging,
	  companyIdsICanWrite: companyIdsICanWrite,
	  companyIdsICanRead: companyIdsICanRead,
	  activeCompany: activeCompany,
	  activeCompanyIds: activeCompanyIds,
	  st_usertype: st_usertype,
	
	  /**
	   * This is the primary way of determining what permissions the logged in user has for given sid(s)
	   *
	   * doIHaveAccess.admin.all(sids) -> true/false
	   *    - do you have admin level for ALL the sids?
	   *
	   * doIHaveAccess.admin.any(sids) -> true/false
	   *    - do you have admin level for ANY of the sids?
	   *
	   * doIHaveAccess.admin.getSIDs() -> sids
	   *    - get all the sids you have admin for
	   *
	   * You can swap out "admin" for any of the access levels defined in access_type_to_user_classes.
	   */
	  doIHaveAccess: doIHaveAccess(session_data, private_label_config),
	
	  getLastSelectedSID: function getLastSelectedSID() {
	    if (session_data.is_st_family) {
	      //ST wants to always default to -- all speakers --
	      return 0;
	    }
	
	    //don't use esUtils.toInt b/c it defaults to 0 on NaN. We don't want it to default to all-speakers (sid===0)
	    var sid = hasLocalstorage() ? _.parseInt(localStorage.getItem("lastSelectedSID"), 10) : -1;
	
	    return _.has(session_data.permissions, sid) || sid === 0 //0 means all speakers
	    ? sid : esUtils.toInt(_.first(_.keys(session_data.permissions)));
	  },
	  setLastSelectedSID: function setLastSelectedSID(sid) {
	    if (!hasLocalstorage()) {
	      return; //no local storage, don't worry about it
	    }
	    localStorage.setItem("lastSelectedSID", sid);
	  },
	
	  getLastSelectedCompany: selectedCompany,
	  setLastSelectedCompany: function setLastSelectedCompany(company) {
	    if (!hasLocalstorage()) {
	      return; //no local storage, don't worry about it
	    }
	    //console.log("Saving lastSelectedCompany: ", company);
	    localStorage.setItem("lastSelectedCompany", company);
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(37);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	
	var ErrorAlert = dd.createClass({
		render: function(){
			if(!this.props.message){
				return dd.div();
			}
			return dd.div({className: 'alert alert-danger'},
				this.props.message
			);
		}
	});
	
	module.exports = ErrorAlert;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(29);
	
	var tags = [
	  "a",
	  "abbr",
	  "address",
	  "area",
	  "article",
	  "aside",
	  "audio",
	  "b",
	  "base",
	  "bdi",
	  "bdo",
	  "big",
	  "blockquote",
	  "body",
	  "br",
	  "button",
	  "canvas",
	  "caption",
	  "circle",
	  "cite",
	  "clipPath",
	  "code",
	  "col",
	  "colgroup",
	  "data",
	  "datalist",
	  "dd",
	  "defs",
	  "del",
	  "details",
	  "dfn",
	  "dialog",
	  "div",
	  "dl",
	  "dt",
	  "ellipse",
	  "em",
	  "embed",
	  "fieldset",
	  "figcaption",
	  "figure",
	  "footer",
	  "form",
	  "g",
	  "h1",
	  "h2",
	  "h3",
	  "h4",
	  "h5",
	  "h6",
	  "head",
	  "header",
	  "hr",
	  "html",
	  "i",
	  "iframe",
	  "img",
	  "injection",
	  "input",
	  "ins",
	  "kbd",
	  "keygen",
	  "label",
	  "legend",
	  "li",
	  "line",
	  "linearGradient",
	  "link",
	  "main",
	  "map",
	  "mark",
	  "mask",
	  "menu",
	  "menuitem",
	  "meta",
	  "meter",
	  "nav",
	  "noscript",
	  "object",
	  "ol",
	  "optgroup",
	  "option",
	  "output",
	  "p",
	  "param",
	  "path",
	  "pattern",
	  "picture",
	  "polygon",
	  "polyline",
	  "pre",
	  "progress",
	  "q",
	  "radialGradient",
	  "rect",
	  "rp",
	  "rt",
	  "ruby",
	  "s",
	  "samp",
	  "script",
	  "section",
	  "select",
	  "small",
	  "source",
	  "span",
	  "stop",
	  "strong",
	  "style",
	  "sub",
	  "summary",
	  "sup",
	  "svg",
	  "table",
	  "tbody",
	  "td",
	  "text",
	  "textarea",
	  "tfoot",
	  "th",
	  "thead",
	  "time",
	  "title",
	  "tr",
	  "track",
	  "tspan",
	  "u",
	  "ul",
	  "var",
	  "video",
	  "wbr"
	];
	
	var DOM = {};
	tags.forEach(function(tag){
	  DOM[tag] = React.createFactory(tag);
	});
	
	module.exports = DOM;
	module.exports.createClass = function(o){
	  return React.createFactory(React.createClass(o));
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var LoadingBar = __webpack_require__(85);
	
	__webpack_require__(186);
	
	module.exports = dd.createClass({
		render: function(){
			var text = this.props.text;
			var glass = this.props.glass;
			var children = this.props.children;
			var is_loading = this.props.is_loading;
	
			//NOTE using lots of terinary operators on purpose. Why? so you don't unmount then remount the children frequently (causes forms to reset to the initial state when saving)
			return dd.div({className: 'LoadingWrap ' + (is_loading ? (glass ? 'relative' : 'text-center') : '')},
	
				is_loading && glass ? dd.div({className: 'waitGlass'},
					dd.div({className: 'circleG'},
						dd.div({className: 'circleG circleG_1'}),
						dd.div({ className: 'circleG circleG_2'}),
						dd.div({className: 'circleG circleG_3'})
					)
				) : null,
	
				is_loading && !glass ? null : children,
	
				is_loading && !glass ? dd.h4({}, this.props.text || 'Loading...') : null,
				is_loading && !glass ? LoadingBar() : null
			);
		}
	});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	var optional = function optional() {
	  return true;
	};
	
	var buildAddressFields = function buildAddressFields(Displaylists, data) {
	  return {
	    address: {
	      label: "Address",
	      type: "textarea",
	      placeholder: "Street Address",
	      validate: optional
	    },
	    city: {
	      label: "City",
	      type: "text",
	      placeholder: "City",
	      validate: optional
	    },
	    st: {
	      label: "State/Prov",
	      type: "esState",
	      Displaylists: Displaylists,
	      country: data && data.country || null,
	      validate: optional
	    },
	    zip: {
	      label: "Postal code",
	      type: "text",
	      placeholder: "Zip/Postal code",
	      validate: optional
	    },
	    country: {
	      label: "Country",
	      type: "esCountry",
	      validate: optional,
	      Displaylists: Displaylists
	    }
	  };
	};
	
	var extractIdsFromKeys = function extractIdsFromKeys(data, regex) {
	  return _.uniq(_.map(_.filter(_.keys(data), function (key) {
	    return regex.test(key);
	  }), function (key) {
	    return _.parseInt(regex.exec(key)[1]);
	  }));
	};
	
	var filterKeysOut = function filterKeysOut(data, regex) {
	  return _.object(_.reject(_.pairs(data), function (pair) {
	    return regex.test(pair[0]);
	  }));
	};
	
	var floatOr0 = function floatOr0(num) {
	  var n = parseFloat(num);
	  if (_.isNaN(n)) {
	    return 0;
	  }
	  return n;
	};
	
	/**
	 * Used everywhere a dropdown list of speakers is shown
	 *
	 * @param Displaylists
	 * @param include_archived
	 * @returns {*}
	 */
	var getSpeakerNamesBySid = function getSpeakerNamesBySid(Displaylists) {
	  var include_archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var common_actionlist_sid = Displaylists && Displaylists.universal && Displaylists.universal.USE_COMMON_ACTIONLISTS_SID || null,
	      user_has_access_to_common_actionlist_sid = _.includes(AuthedUserSession.all_sids_i_have_permissions_for, common_actionlist_sid);
	
	  //don't bother sorting these b/c js objects with numeric keys forces its own sorting
	  return _.object(_.compact(_.map(Displaylists && Displaylists.perspeaker, function (_ref) {
	    var sid = _ref.sid,
	        name_first = _ref.name_first,
	        name_last = _ref.name_last,
	        name_full = _ref.name_full,
	        companies = _ref.companies,
	        archived = _ref.archived;
	
	    if (!_.contains(companies, _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) {
	      return null;
	    }
	    if (!include_archived && archived) {
	      return null;
	    }
	    var displayname = _.isString(name_full) ? name_full.trim() : "";
	    if (!esUtils.isBlank(name_first) && !esUtils.isBlank(name_last)) {
	      displayname = name_last.trim() + ", " + name_first.trim();
	    }
	    return esUtils.isBlank(displayname) || !user_has_access_to_common_actionlist_sid && sid == common_actionlist_sid ? null : [sid, displayname];
	  })));
	};
	
	/**
	 * Used to build the dropdown for empire mode (where superadmin has access to all speakers regardless of active company)
	 *
	 * @param Displaylists
	 * @param include_archived
	 * @returns {*}
	 */
	var getSpeakerNamesBySidForEveryCompany = function getSpeakerNamesBySidForEveryCompany(Displaylists) {
	  var include_archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var r = _.map(Displaylists && Displaylists.perspeaker, function (_ref2) {
	    var sid = _ref2.sid,
	        name_first = _ref2.name_first,
	        name_last = _ref2.name_last,
	        name_full = _ref2.name_full,
	        archived = _ref2.archived;
	
	    if (archived) {
	      return null;
	    }
	    var displayname = _.isString(name_full) ? name_full.trim() : "";
	    if (!esUtils.isBlank(name_first) && !esUtils.isBlank(name_last)) {
	      displayname = name_last.trim() + ", " + name_first.trim();
	    }
	    return [sid, displayname];
	  });
	
	  return _.object(_.compact(r));
	};
	
	module.exports = {
	  optional: optional,
	  buildAddressFields: buildAddressFields,
	  extractIdsFromKeys: extractIdsFromKeys,
	  filterKeysOut: filterKeysOut,
	  floatOr0: floatOr0,
	  getSpeakerNamesBySid: getSpeakerNamesBySid,
	  getSpeakerNamesBySidForEveryCompany: getSpeakerNamesBySidForEveryCompany,
	  v: {
	    optional: optional,
	    required: function required(value, field) {
	      var valid = false;
	      if (_.isBoolean(value)) {
	        valid = value === true;
	      } else if (_.isNumber(value)) {
	        valid = value !== 0;
	      } else if (_.isDate(value)) {
	        valid = true;
	      } else {
	        valid = !_.isEmpty(value);
	      }
	      return valid || (field.label || field.name) + " is required";
	    },
	    blankOr: function blankOr(otherValidator) {
	      return function (value) {
	        return esUtils.isBlank(value) || otherValidator(value);
	      };
	    },
	    integer: function integer(value) {
	      return (/^\s*[-+]?[0-9]+\s*$/.test(value) || "Enter a number"
	      );
	    },
	    positive_integer: function positive_integer(value) {
	      return (/^\s*[0-9]+\s*$/.test(value) || "Enter a whole number"
	      );
	    },
	    percent: function percent(value) {
	      var n = esUtils.toInt(value);
	      return (/^\s*[0-9]+\s*$/.test(value) && n >= 0 && n <= 100 || "Enter a whole number between 0 and 100"
	      );
	    },
	    currency: function currency(value) {
	      var validAmount = /^ *\-? *[$]? *\-? *[0-9,]*[.]?[0-9]?[0-9]? *$/i;
	      return validAmount.test(value) && value.toString().trim().length > 0 || "Enter a dollar amount";
	    },
	    limitInputLength: function limitInputLength(length) {
	      return function (value) {
	        return esUtils.isBlank(value) || value.length <= length || "This field must be less than " + length + " characters";
	      };
	    }
	  }
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var radio = __webpack_require__(37);
	var RadioMixin = __webpack_require__(98);
	
	(function(){
		//The purpose is to ensure only one modal at a time is rendered to the page, so they don't stack on top of each other
	
		//This is a way of queuing all modals that whish to be displayed
		var modals_queue = [];
	
		var update = function(new_shown_modals){
			modals_queue = new_shown_modals;
			radio("ESPModal_setVisible").broadcast(_.first(modals_queue));
		};
	
		radio("ESPModal_please_show_me").subscribe(function(modal_id){
			update(_.unique(modals_queue.concat([modal_id])));
		});
		radio("ESPModal_good_bye").subscribe(function(modal_id){
			update(_.without(modals_queue, modal_id));
		});
	}());
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function(){
			return {is_visible: false, my_modal_id: _.uniqueId("ESPModal")};
		},
		Radio_setup: function(){
			return {
				ESPModal_setVisible: function(modal_id){
					if(modal_id === this.state.my_modal_id){
						if(!this.state.is_visible){
							this.setState({is_visible: true});
						}
					}
				}
			};
		},
		componentDidMount: function(){
			radio("ESPModal_please_show_me").broadcast(this.state.my_modal_id);
		},
		componentWillUnmount: function(){
			radio("ESPModal_good_bye").broadcast(this.state.my_modal_id);
		},
		render: function(){
			if(!this.state.is_visible){
				return dd.span();
			}
			var title = this.props.title;
			var onClose = this.props.onClose;
	
			var buttons = [];
			if(_.isArray(this.props.buttons)){
				buttons = this.props.buttons;
			}else{
				if(_.isFunction(onClose)){
					buttons.push({name: 'Close', onClick: onClose, className: 'btn btn-default'});
				}
			}
	
			return dd.div(null,
				dd.div({className: 'modal fade in', tabIndex: -1, role: 'dialog', style: {display: 'block'}},
					dd.div({className: 'modal-dialog'},
						dd.div({className: 'modal-content'},
							!title ? null : dd.div({className: 'modal-header'},
								!_.isFunction(onClose) ? null : dd.button({type: 'button', className: 'close', onClick: onClose},
									'x'
								),
								dd.h4({className: 'modal-title'}, title),
								this.props.header
							),
							dd.div({className: 'modal-body'},
								this.props.children
							),
							buttons.length === 0 ? null : dd.div({className: 'modal-footer'},
								_.map(buttons, function(button, i){
									return dd.button({
											key: i,
											type: 'button',
											className: button.className,
											onClick: button.onClick
										},
										button.name
									);
								})
							)
						)
					)
				),
				dd.div({className: 'modal-backdrop fade in', onClick: !_.isFunction(onClose) ? null : onClose})
			);
		}
	});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)(module), (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var dateformat = __webpack_require__(41);
	var AuthedUserSession = __webpack_require__(4);
	
	var TIMEZONE_DATA = __webpack_require__(421);
	
	var EVENT_STATUSES = {
	  //TODO keep in sync with class.Event.php
	  held: 0,
	  confirmed: 1,
	  canceled: 9,
	  lead: 10,
	  zimbra: 11,
	  postponed: 12,
	  closed: 13
	};
	
	var CONTACT_PRIMARY = 1;
	var CONTACT_CSP = 2;
	var CONTACT_HOLDS = 4;
	var CONTACT_ONLINEOFFICEACCESS = 8;
	
	var EVENTTYPE_PD = 3;
	
	var ST_USERTYPE_SUPER_ADMIN = 3; //see class.genericUser.php const USER_TYPE_SUPER_ADMIN
	var ST_USERTYPE_STAFF = 1;
	var ST_USERTYPE_SPEAKER = 2;
	
	var file_type_icon_map = {
	  pdf: "fa-file-pdf-o",
	  ps: "fa-file-pdf-o",
	
	  txt: "fa-file-text-o",
	
	  doc: "fa-file-word-o",
	  docx: "fa-file-word-o",
	  odt: "fa-file-word-o",
	  rtf: "fa-file-word-o",
	  eml: "fa-envelope-o",
	
	  ppt: "fa-file-powerpoint-o",
	  pptx: "fa-file-powerpoint-o",
	  odp: "fa-file-powerpoint-o",
	
	  xls: "fa-file-excel-o",
	  xlsx: "fa-file-excel-o",
	  ods: "fa-file-excel-o",
	
	  mp3: "fa-file-audio-o",
	  wma: "fa-file-audio-o",
	  wav: "fa-file-audio-o",
	
	  png: "fa-file-image-o",
	  gif: "fa-file-image-o",
	  jpg: "fa-file-image-o",
	  bmp: "fa-file-image-o",
	
	  mp4: "fa-file-video-o",
	  mpg: "fa-file-video-o",
	  mpeg: "fa-file-video-o",
	  wmv: "fa-file-video-o",
	  mov: "fa-file-video-o",
	  avi: "fa-file-video-o",
	  vob: "fa-file-video-o",
	
	  zip: "fa-file-archive-o",
	  tgz: "fa-file-archive-o",
	  tar: "fa-file-archive-o",
	  rar: "fa-file-archive-o",
	  "7z": "fa-file-archive-o"
	};
	
	var getFileTypeIcon = function getFileTypeIcon(file_name) {
	  var parts = /\.[0-9a-z]+$/i.exec(file_name);
	  var extension = (parts && parts[0] || "").replace(/\./, "").toLowerCase();
	  return file_type_icon_map[extension] || "fa-file-o";
	};
	
	var buildMailToURLForEvent = function buildMailToURLForEvent(event, email, Displaylists) {
	  if (!_.isString(email)) {
	    return null;
	  }
	  var my_speaker_names_by_sid = _.object(_.map(Displaylists.perspeaker, function (speaker) {
	    return [speaker.sid, speaker.name_full];
	  }));
	
	  var speaker_names = _.map(event.sids, function (sid) {
	    return my_speaker_names_by_sid[sid];
	  }).join(", ");
	
	  var stagetime = _.first(event.Stagetime) || {};
	  var venue = _.find(event.Venue, function (v) {
	    return v.id == stagetime.venueid;
	  }) || {};
	
	  var subject = _.reject([speaker_names, event.organization, _.isDate(stagetime.starttime) ? dateformat(stagetime.starttime, "mmm d, yyyy") : null, _.reject([venue.city, venue.st], esUtils.isBlank).join(", ")], esUtils.isBlank).join(" - ");
	
	  return "mailto:" + encodeURIComponent(email) + "?subject=" + encodeURIComponent(subject);
	};
	
	module.exports = {
	  EVENT_STATUSES: EVENT_STATUSES,
	  TIMEZONE_DATA: TIMEZONE_DATA,
	  EVENT_STATUSES_by_num: _.object(_.map(_.pairs(EVENT_STATUSES), function (pair) {
	    return pair.reverse();
	  })),
	  DELIVERY_METHOD_INTEGERS: {
	    ONSITE: 1,
	    VIRTUAL: 2
	  },
	
	  EVENT_STATUS_PRIORITY: {
	    canceled: 0,
	    closed: 1,
	    postponed: 2,
	    lead: 3,
	    held: 4,
	    confirmed: 5
	  },
	
	  GRAB_SERVICES: {
	    MAC_CONTACTS: "Mac Contacts",
	    EP: "Other Events",
	    HL: "HighLevel",
	    SALESFORCE: "SalesForce",
	    GOOGLEAPI: "Google Contacts",
	    INFUSION: "Keap",
	    INSIGHTLY: "Insightly",
	    KARMACRM: "karmaCRM",
	    HUBSPOT: "Hubspot",
	    ZOHOCRM: "ZohoCRM"
	  }, //    OUTLOOK: 'Outlook',    ZIMBRA: 'Zimbra',
	
	  GRAB_SERVICES_WITH_DEEP_INTEGRATION: {
	    KARMACRM: {
	      browser_window_name: "KarmaCRMWindow"
	    },
	    HUBSPOT: {
	      browser_window_name: "HubspotWindow"
	    },
	    ZOHOCRM: {
	      browser_window_name: "ZohoCRMWindow"
	    },
	    HL: {
	      browser_window_name: "HighLevelWindow"
	    }
	  }, //these crms show up on the navbar, and also link contacts directly
	
	  GRAB_SERVICES_not_yet_supported: ["OUTLOOK"],
	
	  HOLD_PRIORITY: {
	    1: "weak",
	    5: "normal",
	    9: "strong"
	  },
	
	  QTYCUSTOMS: 10,
	  QTYLONGCUSTOMS: 8,
	
	  CC_INIT_VALUES: {
	    //Comes from Event::$CC_INIT_VALUES
	    1: "we call them",
	    2: "they call us",
	    3: "in person"
	  },
	
	  EVENTTYPE_PD: EVENTTYPE_PD,
	  CONTACT_PRIMARY: CONTACT_PRIMARY,
	  CONTACT_CSP: CONTACT_CSP,
	  CONTACT_HOLDS: CONTACT_HOLDS,
	  CONTACT_ONLINEOFFICEACCESS: CONTACT_ONLINEOFFICEACCESS,
	  ST_USERTYPE_SPEAKER: ST_USERTYPE_SPEAKER,
	  ST_USERTYPE_STAFF: ST_USERTYPE_STAFF,
	  ST_USERTYPE_SUPER_ADMIN: ST_USERTYPE_SUPER_ADMIN,
	  CONTACT_FLAGS: function () {
	    var map = {};
	    map[CONTACT_PRIMARY] = "Primary contact for this event";
	    map[CONTACT_CSP] = "CSP® evaluation contact";
	    map[CONTACT_HOLDS] = "Contact about hold status";
	    map[CONTACT_ONLINEOFFICEACCESS] = "Can access this event via Online Assistant";
	    return map;
	  }(),
	  ONLINE_ASSISTANT_OPTIONS: {
	    INVITE_QUESTIONNAIRE: "complete questionnaire",
	    INVITE_CONFIRM: "please release or confirm",
	    MAIL_RESENDKEY: "send office key"
	  },
	  MAINTENANCE_IMPACT_LABELS: {
	    1: "No Interruption expected",
	    2: "No Downtime, but logins locked",
	    3: "Brief Interruption expected",
	    4: "Long Interruption expected",
	    5: "Unexpected Maintenance"
	  },
	
	  PRESENTATION_CATEGORY_FLAGS: {
	    ARCHIVED: 1
	  },
	  file_type_icon_map: file_type_icon_map,
	  getFileTypeIcon: getFileTypeIcon,
	  FileStore_UPLOAD_FILE_NAME: "store_this_file", //FileStore::UPLOAD_FILE_NAME
	
	  buildMailToURLForEvent: buildMailToURLForEvent,
	  /**
	   * Used to build the href for notemail links on the notes area and the contacts tab.
	   *
	   * @param event
	   * @param contact
	   * @param Displaylists
	   * @returns {string}
	   */
	  generateNotemailHREF: function generateNotemailHREF(event, contact, Displaylists) {
	    if (AuthedUserSession.is_privatelabel) {
	      return null; //don't use notemail on privatelabels yet
	    }
	
	    var recipient = contact !== null && contact.hasOwnProperty("email") ? contact.email : "";
	
	    return buildMailToURLForEvent(event, recipient, Displaylists) + "&cc=" + encodeURIComponent(event.notemail_address); // + '&body=' + encodeURIComponent('\n\n(Please REPLY ALL so that our eSpeakers software will pick up your response.)');
	  },
	
	
	  /**
	   * Generate the mailto: url for the Client Portal link
	   * @param event
	   * @param email
	   * @param Displaylists
	   * @returns {string}
	   */
	  generateClientPortalMailtoForEvent: function generateClientPortalMailtoForEvent(event, email, Displaylists) {
	    var my_speaker_names_by_sid = _.object(_.map(Displaylists.perspeaker, function (speaker) {
	      return [speaker.sid, speaker.name_full];
	    }));
	
	    var speaker_names = _.map(event.sids, function (sid) {
	      return my_speaker_names_by_sid[sid];
	    }).join(", ");
	
	    var stagetime = _.first(event.Stagetime) || {};
	    var venue = _.find(event.Venue, function (v) {
	      return v.id == stagetime.venueid;
	    }) || {};
	
	    var subject = _.reject(["Client Portal access for your event", speaker_names, event.organization, _.isDate(stagetime.starttime) ? dateformat(stagetime.starttime, "mmm d, yyyy") : null, _.reject([venue.city, venue.st], esUtils.isBlank).join(", ")], esUtils.isBlank).join(" - ");
	
	    return "mailto:" + encodeURIComponent(email) + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent("Enjoy realtime access to your critical event data at " + event.online_assistant_url + "\r\n\r\nYour email address is your access key.");
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(445);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	var InputTypes = __webpack_require__(190);
	
	var FormMixin = {
		getInitialState: function(){
			return {
				initial_values_source_version: _.isFunction(this.getInitialValuesSourceVersion) ? this.getInitialValuesSourceVersion(this.props) : null,
				data: this.____getInitialValues(this.props),
				errors: {},
				submit_attempts: 0
			};
		},
		componentWillReceiveProps: function(new_props){
			if(_.isFunction(this.getInitialValuesSourceVersion)){
				var initial_values_source_version = this.getInitialValuesSourceVersion(new_props);
				if(this.state.initial_values_source_version !== initial_values_source_version){
					this.setState({initial_values_source_version: initial_values_source_version, data: this.____getInitialValues(new_props), errors: {}, submit_attempts: 0});
				}
			}
		},
		_form_validate: function(callback){
			var fields = this.buildFields();
			var data = this.state.data;
			this.setState({errors: validateFields(fields, data)}, function(){
					if(_.isFunction(callback)){
						callback();
					}
				}
			);
		},
		_form_onSubmit: esUtils.wrapPreventDefault(function(){
			var self = this;
			var fields = this.buildFields();
			var data = this.state.data;
	
			this.setState({
					submit_attempts: this.state.submit_attempts + 1,
					errors: validateFields(fields, data)
				},
				function(){
					var has_error = _.filter(_.values(self.state.errors)).length > 0;
					if(has_error){
						if(_.isFunction(self.props.onSubmitFail)){
							self.props.onSubmitFail(self.state.errors);
						}
					}else{
						if(_.isFunction(self.props.onSubmit)){
							self.props.onSubmit(self.state.data);
						}
					}
				}
			);
		}),
		_form_onChange: function(field_path, new_value){
			var self = this;
			var fields = this.buildFields();
			var should_validate = this.state.submit_attempts > 0;
			var data = this.state.data;
	
			data[field_path] = new_value;
	
			this.setState({
				data: data,
				errors: should_validate ? validateFields(fields, data) : null
			}, function(){
				if(_.isFunction(self.onFormChanged)){
					self.onFormChanged(field_path, new_value);
				}
			});
		},
		_form_buildInput: function(field, field_path){
			var input = InputTypes.getInputByType(field.type);
			return input.component({
				field: field,
				value: this.state.data[field_path],
				onChange: this._form_onChange,
				field_path: field_path
			});
		},
		_form_reset: function(){
			this.setState({data: this.____getInitialValues(this.props), errors: {}, submit_attempts: 0});
		},
		_form_areChangesMade: function(props){
			return !_.isEqual(this.state.data, this.____getInitialValues(_.isUndefined(props) ? this.props : props));
		},
		____getInitialValues: function(props){
			if(_.isFunction(this.getInitialValues)){
				return _.cloneDeep(this.getInitialValues(props)) || {};
			}
			return {};
		}
		//child needs to implement
		//buildFields: function() - returns the fields schema
		//getInitialValues: function(props) - returns the values for the fields
		//getInitialValuesSourceVersion: function(props) - returns some sort of version identifier to determine if the initial values source has changed.
		//onFormChanged: function(field_path, new_value) - simply called after _form_onChange is called
	};
	
	var default_validation_fn = function(value, field){
		var valid = false;
		if(_.isBoolean(value)){
			valid = value === true;
		}else if(_.isNumber(value)){
			valid = value !== 0;
		}else if(_.isDate(value)){
			valid = true;
		}else{
			valid = !_.isEmpty(value);
		}
		return valid || field.label + ' is required';
	};
	
	var validateFields = function(fields, data){
		return _.mapValues(fields, function(field, field_path){
			var validation_fn = default_validation_fn;
			if(_.isFunction(field.validate)){
				validation_fn = field.validate;
			}else{
				var input = InputTypes.getInputByType(field.type);
				if(_.isFunction(input.validate)){
					validation_fn = input.validate;
				}
			}
			var resp = validation_fn(data[field_path], field);
			if(resp === true){
				return false;
			}
			return _.isString(resp) ? resp : 'Please check your input.';
		});
	};
	
	module.exports = FormMixin;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(444);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(98);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(37);
	var _ = __webpack_require__(12);
	var Ajax = __webpack_require__(83);
	var JSONP = __webpack_require__(389);
	
	var balboa_prefix = '/balboa3';
	var extend_with_params = {};
	var init = function(config){
		if(_.isObject(config)){
			if(_.isObject(config.extend_with_params)){
				extend_with_params = _.cloneDeep(config.extend_with_params);
			}
			if(_.isString(config.balboa_prefix)){
				balboa_prefix = config.balboa_prefix;
			}
		}
	};
	
	var extend_with_balboa_params = function(params_orig){
		var params = _.cloneDeep(_.isObject(params_orig) ? params_orig : {});
		params = _.extend(params, extend_with_params);
		return params;
	};
	
	var api = function(uri, params, callback, errorCallback, onProgress){
		if(!uri){
			return null;
		}
		callback = _.isFunction(callback) ? callback : _.noop;
		errorCallback = _.isFunction(errorCallback) ? errorCallback : _.noop;
	
		params = extend_with_balboa_params(params);
	
		return Ajax.post(balboa_prefix + uri, params, function(err, data, status_code, xhr){
			if(!err){
				try{
					data = JSON.parse(data);
				}catch(e){
				}
				if(data.success === true){
					callback(data, err, status_code, xhr);
					return;
				}
			}
			if(data && data.authenticationerror){
				radio('Balboa_authenticationerror').broadcast(data);
			}
			errorCallback(data, err, status_code, xhr);
		}, onProgress);
	};
	
	
	module.exports.init = init;
	module.exports.api = api;
	module.exports.jsonp = function(url, params, onSuccess, onFailure){
		JSONP({
			url: balboa_prefix + url,
			data: extend_with_balboa_params(params),
			success: function(data){
				if(data && data.success){
					onSuccess(data);
				}else{
					if(data && data.authenticationerror){
						radio('Balboa_authenticationerror').broadcast(data);
					}
					onFailure(data);
				}
			},
			error: onFailure
		});
	};
	module.exports.extend_with_balboa_params = extend_with_balboa_params;
	module.exports.get_balboa_upload_url = function(url){
		return 'https://www.espeakers.com/balboa3' + url;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(37);
	var _ = __webpack_require__(12);
	
	var RadioMixin = {
		componentDidMount: function(){
			_.each(this.radio, function(callback, key){
				radio(key).subscribe(callback);
			});
		},
		componentWillUnmount: function(){
			_.each(this.radio, function(callback, key){
				radio(key).unsubscribe(callback);
			});
		}
	};
	
	module.exports = RadioMixin;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(29);
	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	
	var HelpTooltip = __webpack_require__(118);
	
	module.exports = dd.createClass({
		propTypes: {
			fields: React.PropTypes.object.isRequired,
			errors: React.PropTypes.object.isRequired,
			buildInput: React.PropTypes.func.isRequired,
	
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
			label_size: React.PropTypes.number,
			input_size: React.PropTypes.number
		},
		render: function(){
			var fields = this.props.fields;
			var errors = this.props.errors;
			var buildInput = this.props.buildInput;
	
			var scale = this.props.scale || 'sm';
			var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
			var input_size = this.props.input_size || (12 - label_size);
	
			var layout = _.isArray(this.props.layout) ? this.props.layout : _.map(_.keys(fields), function(name){
				return [name];
			});
	
			return dd.div({className: 'HorizontalFields'},
				_.map(layout, function(row, i){
					return dd.div({key: i, className: 'form-group'},
						_.map(row, function(name, j){
							return HorizontalField({
								key: j,
								field_name: name,
								fields: fields,
								errors: errors,
								buildInput: buildInput,
	
								scale: scale,
								label_size: label_size,
								input_size: row.length > 1 ? (input_size - label_size) / 2 : input_size
							});
						})
					);
				})
			);
		}
	});
	
	var HorizontalField = dd.createClass({
		propTypes: {
			//field_name: String or Component //basically required, if not a field name it'll stick it in a div at the proper col-width
			fields: React.PropTypes.object.isRequired,
			errors: React.PropTypes.object.isRequired,
			buildInput: React.PropTypes.func.isRequired,
	
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
			label_size: React.PropTypes.number,
			input_size: React.PropTypes.number
		},
		render: function(){
			var name = this.props.field_name;
			var field = this.props.fields[name];
			var error = this.props.errors[name];
			var buildInput = this.props.buildInput;
	
			var scale = this.props.scale || 'sm';
			var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
			var input_size = this.props.input_size || (12 - label_size);
	
			if(!field){
				return dd.div({className: 'col-' + scale + '-' + (label_size + input_size)}, name);//render a placeholder with whatever name is (i.e. can pass in a component)
			}
	
			var field_label = field.label || name;
			var tooltip = field.tooltip ? HelpTooltip({title: field_label, content: field.tooltip}) : null;
	
			return dd.div({className: 'HorizontalField ' + (error ? ' has-error' : '')},
				dd.label({className: 'control-label col-' + scale + '-' + label_size},
					field.type == 'checkbox' ? null : field_label + ' ',
					field.type !== 'checkbox' ? tooltip : null
				),
				dd.div({className: ' col-' + scale + '-' + input_size},
					buildInput(field, name),
					field.type == 'checkbox' ? ' ' : null,
					field.type == 'checkbox' ? tooltip : null,
					error ? dd.span({className: 'help-block'}, error) : null,
					field.help_text ? dd.span({className: 'help-block'}, field.help_text) : null
				)
			);
		}
	});
	
	var ButtonArea = dd.createClass({
		propTypes: {
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
			label_size: React.PropTypes.number,
			input_size: React.PropTypes.number,
	
			right_align_buttons: React.PropTypes.bool
		},
		render: function(){
			var scale = this.props.scale || 'sm';
			var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
			var input_size = this.props.input_size || (12 - label_size);
	
			return dd.div({className: 'HorizontalFields'},//hack to fix layout
				dd.div({className: 'form-group ButtonArea'},
					dd.label({className: 'control-label col-' + scale + '-' + label_size}, ' '),
					dd.div({className: 'col-' + scale + '-' + input_size + ' ' + (this.props.right_align_buttons ? 'text-right' : '')},
						this.props.children
					)
				)
			);
		}
	});
	
	module.exports.FormButtons = dd.createClass({
		propTypes: {
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
			label_size: React.PropTypes.number,
			input_size: React.PropTypes.number,
	
			onCancel: React.PropTypes.func,
			onDelete: React.PropTypes.func,
			onDiscard: React.PropTypes.func,
			submit_btn_text: React.PropTypes.string,
	
			right_align_buttons: React.PropTypes.bool
		},
		render: function(){
			var scale = this.props.scale || 'sm';
			var onCancel = this.props.onCancel;
			var onDelete = this.props.onDelete;
			var onDiscard = this.props.onDiscard;
			var submit_btn_text = this.props.submit_btn_text;
	
	
			var buttons = [];
			buttons.push(dd.button({type: 'submit', className: 'btn btn-primary btn-' + scale}, submit_btn_text || 'Save'));
			if(onCancel){
				buttons.push(dd.button({className: 'btn btn-default btn-' + scale, onClick: onCancel}, 'Cancel'));
			}
			if(onDiscard){
				buttons.push(dd.button({className: 'btn btn-default btn-' + scale, onClick: onDiscard}, 'Undo Changes'));
			}
			if(onDelete){
				buttons.push(dd.button({className: 'btn btn-danger btn-' + scale, onClick: onDelete}, 'Delete'));
			}
			if(this.props.right_align_buttons){
				buttons.reverse();
			}
			return ButtonArea({
					scale: scale,
					label_size: this.props.label_size,
					input_size: this.props.input_size,
					right_align_buttons: !!this.props.right_align_buttons
				},
				_.map(buttons, function(button, i){
					return dd.span({key: i}, button, ' ');
				})
			);
		}
	});


/***/ }),
/* 24 */
5,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var HorizontalFields = __webpack_require__(441);
	
	module.exports = function(form, layout, scale, label_size){
	  return HorizontalFields({
	    fields: form.Form_buildSchema(),
	    errors: form.state.errors || {},
	    buildInput: form.Form_buildInput,
	    layout: layout,
	    scale: scale,
	    label_size: label_size
	  });
	};


/***/ }),
/* 26 */
12,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	
	module.exports = dd.createClass({
		render: function render() {
			var open = !!this.props.open;
			var max_height = _.has(this.props, 'max_height') && this.props.max_height > 0 ? this.props.max_height : 100;
			var speed = _.has(this.props, 'speed') ? this.props.speed : '.15s';
	
			return dd.div({ style: {
					maxHeight: open ? max_height : 0,
					overflow: 'hidden',
					transition: 'max-height ' + speed + ' ease-in-out'
				} }, this.props.children);
		}
	});

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(457);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var React = __webpack_require__(15);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormButtons = __webpack_require__(36);
	var ConfirmModal = __webpack_require__(129);
	var SlideOpenDown = __webpack_require__(27);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	
	var DaForm = dd.createClass({
		mixins: [FormMixin, EventFormUnsavedChangeMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return esUtils.getEventVersionIdentifier(props.event);
		},
		getInitialValues: function getInitialValues(props) {
			var event = props.event;
			if (!event) {
				return null;
			}
			return this.props.eventToInitialValues(event);
		},
		buildSchema: function buildSchema() {
			var data = this.state.data || {};
			var schema = this.props.buildSchema.call(null, this.props, data);
	
			if (this.props.read_only) {
				return _.mapValues(schema, function (field) {
					return _.assign(field, { read_only: true });
				});
			}
			return schema;
		},
		__onFormChanged: function __onFormChanged(field_path, field_value) {
			var data = this.state.data || {};
			if (_.isFunction(this.props.onFormChanged)) {
				this.props.onFormChanged(field_path, field_value, data, this.Form_onChange);
			}
		},
		render: function render() {
			var has_fields = !_.isEmpty(this.Form_buildSchema());
			var changes_made = this.Form_areChangesMade();
			var _props = this.props,
			    form_section_name = _props.form_section_name,
			    renderFields = _props.renderFields,
			    renderButtons = _props.renderButtons;
	
	
			return dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, has_fields && !esUtils.isBlank(form_section_name) ? dd.h4({ className: "section-head" }, form_section_name) : null, renderFields ? renderFields.apply(this) : ezHorizontalFields(this), renderButtons ? renderButtons.apply(this) : SlideOpenDown({ open: changes_made }, HorizontalFieldSpot(null, FormButtons({ onDiscard: this.__discardChanges }))), this.props.children //potentially the ConfirmModal will be rendered here
			);
		}
	});
	
	module.exports = function (config) {
		_.each(["buildSchema", "eventToInitialValues", "writeInputDataToEvent"], function (fn_name) {
			if (!_.isFunction(config[fn_name])) {
				throw new Error("cannot createStandardEventForm, missing: " + fn_name);
			}
		});
		var renderFields = _.isFunction(config.renderFields) ? config.renderFields : undefined;
		var renderButtons = _.isFunction(config.renderButtons) ? config.renderButtons : undefined;
		var onFormChanged = _.isFunction(config.onFormChanged) ? config.onFormChanged : undefined;
		var confirmMessageBeforeSave = _.isFunction(config.confirmMessageBeforeSave) ? config.confirmMessageBeforeSave : undefined;
		return dd.createClass({
			propTypes: {
				event: React.PropTypes.object.isRequired
			},
			getInitialState: function getInitialState() {
				return { confirm_data: null };
			},
			__onSubmit: function __onSubmit(data) {
				var old_event = this.props.event;
				if (!old_event) {
					return;
				}
				var new_event = _.cloneDeep(old_event);
				config.writeInputDataToEvent(data, new_event); //this mutates new_event
	
				var confirm_msg = confirmMessageBeforeSave ? confirmMessageBeforeSave(old_event, new_event) : undefined;
				if (confirm_msg) {
					this.setState({ confirm_data: { message: confirm_msg, saveIt: function saveIt() {
								radio("save_Event").broadcast(new_event);
							}
						} });
				} else {
					radio("save_Event").broadcast(new_event);
				}
			},
	
			__confirmYes: esUtils.wrapPreventDefault(function () {
				var confirm_data = this.state.confirm_data;
	
				confirm_data.saveIt();
				this.setState({ confirm_data: null });
			}),
			__closeConfirm: esUtils.wrapPreventDefault(function () {
				this.setState({ confirm_data: null });
			}),
			render: function render() {
				var confirm_data = this.state.confirm_data;
	
				return DaForm(_.assign({}, this.props, {
					renderFields: renderFields,
					renderButtons: renderButtons,
					onFormChanged: onFormChanged,
					onSubmit: this.__onSubmit,
					buildSchema: config.buildSchema,
					eventToInitialValues: config.eventToInitialValues
				}), confirm_data ? ConfirmModal({ message: confirm_data.message, onYes: this.__confirmYes, onClose: this.__closeConfirm }) : null);
			}
		});
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactDOMFeatureFlags = __webpack_require__(155);
	var ReactElement = __webpack_require__(35);
	var ReactEmptyComponentRegistry = __webpack_require__(162);
	var ReactInstanceHandles = __webpack_require__(57);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactMarkupChecksum = __webpack_require__(165);
	var ReactPerf = __webpack_require__(39);
	var ReactReconciler = __webpack_require__(52);
	var ReactUpdateQueue = __webpack_require__(105);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(59);
	var containsNode = __webpack_require__(134);
	var instantiateReactComponent = __webpack_require__(112);
	var invariant = __webpack_require__(11);
	var setInnerHTML = __webpack_require__(81);
	var shouldUpdateReactComponent = __webpack_require__(115);
	var validateDOMNesting = __webpack_require__(117);
	var warning = __webpack_require__(16);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(147);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var radio = __webpack_require__(37);
	var RadioMixin = __webpack_require__(22);
	
	var SafeRadioBroadcast = _.memoize(function(name){
		return function(){
			var r = radio(name);
			r.broadcast.apply(r.channel(name), arguments);
		};
	});
	
	module.exports = {
		RadioAjax: function(name, callback, singletonKeyFn){
			radio(name).subscribe((function(){
				var ajax_waiting = {};
				return function(){
					var onSuccess = SafeRadioBroadcast(name + '_succeeded');
					var onFail = SafeRadioBroadcast(name + '_failed');
	
					var finishFunctions = [onSuccess, onFail];
	
					if(_.isFunction(singletonKeyFn)){
						var key = singletonKeyFn.apply(null, arguments);
	
						radio(name + '_waiting_on_server').broadcast(key);
						if(_.has(ajax_waiting, key) && ajax_waiting[key] === true){
							return;
						}
						ajax_waiting[key] = true;
	
						finishFunctions = [
							function(){
								onSuccess.apply(null, [key].concat(_.toArray(arguments)));
								ajax_waiting[key] = false;
							},
							function(){
								onFail.apply(null, [key].concat(_.toArray(arguments)));
								ajax_waiting[key] = false;
							}
						];
					}
					callback.apply(null, _.toArray(arguments).concat(finishFunctions));
				};
			}()));
			radio(name + '_failed').subscribe(function(){
				console.error(name, arguments);
			});
		},
		reloadDisplaylists: function(){
			radio('invalidate_Displaylists_cache').broadcast();
			radio('Displaylists_get').broadcast();
		},
		RadioAjaxMixin: function(){
			var actions = _.flattenDeep(_.toArray(arguments));
	
			return {
				mixins: [RadioMixin],
					getInitialState: function(){
						//must gen a new fromPairs for each instance, otherwise you have shared mutable state
						return _.object(_.map(actions, function(a){
							return [a , {waiting: false, data: null, error_message: null}];
						}));
					},
					__RadioAjax_setActionState: function(action, o, cb){
						var s = {};
						s[action] = _.extend({}, this.state[action], o);
						this.setState(s, cb);
					},
					componentWillMount: function(){
						var self = this;
						var childFunction = function(a, fn_name){
							if(_.isFunction(self["__RadioAjax_" + fn_name + "_" + a])){
								return self["__RadioAjax_" + fn_name + "_" + a];
							}
							return _.noop;
						};
						var isMyKey = function(a, key){
							return key === childFunction(a, "key")();
						};
						self.radio = _.object(_.flatten(_.map(actions, function(a){
							return [
								[a + "_waiting_on_server", function(key){
									if(isMyKey(a, key)){
										self.__RadioAjax_setActionState(a, {waiting: true, data: null, error_message: null});
										childFunction(a, "onWait")();
									}
								}],
								[a + "_succeeded", function(key, data){
									if(isMyKey(a, key)){
										self.__RadioAjax_setActionState(a, {waiting: false, data: data, error_message: null});
										childFunction(a, "onSuccess")(data);
									}
								}],
								[a + "_failed", function(key, message){
									if(isMyKey(a, key)){
										self.__RadioAjax_setActionState(a, {waiting: false, error_message: message});
										childFunction(a, "onFail")(message);
									}
								}]
							];
						})));
					}
			};
		}
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	var hasPro = function hasPro(sids) {
	    if (AuthedUserSession.is_privatelabel) {
	        return true; //privatelabels get everything
	    }
	    sids = esUtils.cleanup_ids(sids); //let sids = esUtils.cleanup_ids(_.flattenDeep(_.rest(_.toArray(arguments))));
	    var pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");
	
	    if (_.size(sids) > 0) {
	        pro_sids = _.intersection(pro_sids, sids);
	    }
	    return _.size(pro_sids) > 0;
	};
	
	module.exports = dd.createClass({
	    __unlock: esUtils.wrapPreventDefault(function () {
	        window.open("/account-menu/upgrade-to-pro-from-starter/");
	    }),
	    render: function render() {
	        var custom_message = this.props.custom_message;
	
	        if (hasPro(_.get(this.props, 'sids', []))) {
	            return dd.div({ className: "ProOnly has-pro" }, this.props.children);
	        }
	
	        // NOTE
	        // NOTE there are many places where this css is overridden so use caution when renaming/changing structure of the markup
	        // NOTE
	        return dd.div({ className: "ProOnly relative clickable", onClick: this.__unlock }, dd.div({ className: "glass" }), dd.div({ className: "pro-message" }, dd.div({ className: "title" }, dd.i({ className: "fa fa-unlock-alt" }), " ", dd.a({ href: "#", onClick: this.__unlock }, "Unlock PRO")), custom_message ? dd.div({ className: "custom_message" }, custom_message, dd.a({ href: "#", onClick: this.__unlock }, " Learn more... ")) : null), this.props.children);
	    }
	});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(44);
	
	var assign = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(79);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var ucfirst = __webpack_require__(503);
	
	var buttons = [
	  ['submit', 'primary', 'Save'],
	  ['discard', 'default', 'Undo Changes'],
	  ['cancel', 'default', 'Cancel'],
	  ['delete', 'danger', 'Delete']
	];
	
	var propTypes = {
	  scale: React.PropTypes.oneOf(['sm', 'md', 'lg'])
	};
	_.each(buttons, function(b){
	  propTypes['on' + ucfirst(b[0])] = React.PropTypes.func;
	  propTypes[b[0] + '_btn_text'] = React.PropTypes.string;
	});
	
	module.exports = dd.createClass({
	  propTypes: propTypes,
	  render: function(){
	    var scale = this.props.scale || 'sm';
	
	    var btns = _.map(buttons, function(b){
	      var onclick = this.props['on' + ucfirst(b[0])];
	      if(b[0] !== 'submit' && !_.isFunction(onclick)){
	        return null;
	      }
	      return dd.span({key: b[0]},
	        dd.button({
	            type: b[0] === 'submit' ? 'submit' : undefined,
	            className: 'btn btn-' + b[1] + ' btn-' + scale,
	            onClick: onclick
	          },
	          this.props[b[0] + '_btn_text'] || b[2]
	        ),
	        " "
	      );
	    }, this);
	
	    if(this.props.right_align){
	      btns.reverse();
	    }
	
	    return dd.div(this.props.right_align ? {style: {textAlign: "right"}} : null,
	      btns
	    );
	  }
	});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(72);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	
	module.exports = {
		_input_newValue: function(new_value){
			var onChange = this.props.onChange;
			if(_.isFunction(onChange)){
				onChange(this.props.field_path, new_value);
			}
		}
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(99);
	var PooledClass = __webpack_require__(48);
	var ReactPerf = __webpack_require__(39);
	var ReactReconciler = __webpack_require__(52);
	var Transaction = __webpack_require__(78);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(70);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(71);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	
	module.exports = {
		getInitialState: function getInitialState() {
			return { form_uid: _.uniqueId() };
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			this.__checkForChangesMade();
			if (_.isFunction(this.__onFormChanged)) {
				return this.__onFormChanged(field_path, new_value);
			}
		},
		__checkForChangesMade: _.debounce(function () {
			this.updateUnsavedState(this.Form_areChangesMade ? this.Form_areChangesMade() //react-loose-forms
			: this._form_areChangesMade() //old forms
			);
		}, 500),
		__discardChanges: esUtils.wrapPreventDefault(function () {
			if (this.Form_reset) {
				this.Form_reset(); //react-loose-forms
			} else {
				this._form_reset(); //old forms
			}
			this.updateUnsavedState(false);
		}),
		__doTheFormSave: function __doTheFormSave(onSaveStarted) {
			var save_fn = this.Form_onSubmit || this._form_onSubmit; //react-loose-forms || old forms
			save_fn();
			var self = this;
			setTimeout(function () {
				var has_error = _.filter(_.values(self.state.errors)).length > 0;
				onSaveStarted(has_error ? 'Check your input' : undefined);
			}, 500);
		},
		updateUnsavedState: function updateUnsavedState(is_dirty) {
			var event = this.props.event;
			radio('eventFormUnsavedState').broadcast(event && event.eid, this.state.form_uid, is_dirty ? this.__doTheFormSave : undefined);
		}
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	
	module.exports = dd.createClass({
	  propTypes: {
	    scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
	    label_size: React.PropTypes.number,
	    input_size: React.PropTypes.number
	  },
	  render: function(){
	    var scale = this.props.scale || 'sm';
	    var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
	    var input_size = this.props.input_size || (12 - label_size);
	
	    return dd.div({className: 'HorizontalFields'},//hack to fix layout
	      dd.div({className: 'form-group'},
	        dd.label({className: 'control-label col-' + scale + '-' + label_size}, ' '),
	        dd.div({className: 'col-' + scale + '-' + input_size},
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	
	module.exports = {
		getInitialState: function(){
			this.__HoverMixin_fast_state = {
				hover: false,
				last_time: _.now(),
				interval: 100,
				timeout_handle: null,
				on_user_left_waitfor: 500,
				on_user_left_debounce_handler: null
			};
			return {hover: false, hoverable_top: 0, hoverable_left: 0};
		},
		___fastStateChangeHover: function(){
			var diff = _.now() - this.__HoverMixin_fast_state.last_time;
			if(diff >= this.__HoverMixin_fast_state.interval){
				var self = this;
	
				this.setState({hover: this.__HoverMixin_fast_state.hover}, function(){
					if(_.isFunction(self.hoverable_onUserLeftHoverable) && !self.__HoverMixin_fast_state.hover){
						clearTimeout(self.__HoverMixin_fast_state.on_user_left_debounce_handler);
						self.__HoverMixin_fast_state.on_user_left_debounce_handler = setTimeout(function(){
							if(!self.state.hover){//only if still not hovering after the time has passed
								self.hoverable_onUserLeftHoverable();
							}
						}, self.__HoverMixin_fast_state.on_user_left_waitfor);
					}
				});
				this.__HoverMixin_fast_state.last_time = _.now();
			}else{
				clearTimeout(this.__HoverMixin_fast_state.timeout_handle);
				this.__HoverMixin_fast_state.timeout_handle = setTimeout(this.___fastStateChangeHover, diff);
			}
		},
		hoverable_onMouseEnter: function(){
			this.__HoverMixin_fast_state.hover = true;
			this.___fastStateChangeHover();
		},
		hoverable_onMouseLeave: function(){
			this.__HoverMixin_fast_state.hover = false;
			this.___fastStateChangeHover();
		},
		componentDidUpdate: function(){
			var dom_node = this.refs.hoverable;
			if(!dom_node || !this.state.hover){
				return;
			}
			var parentNode = dom_node.parentNode;
			var rect = parentNode.getBoundingClientRect();
			var parent_width = Math.max(0, parentNode.offsetWidth);
			if(this.not_relative_to_parent_bounding_rect){
				rect = {top: 0, left: 0};
			}
			var top = esUtils.toInt(rect.top - Math.max(0, dom_node.offsetHeight));
			var left = esUtils.toInt(rect.left - (dom_node.offsetWidth / 2) + (parent_width / 2));
	
			var new_state = {};
			if(Math.abs(top - this.state.hoverable_top) > 5){//only make changes when needed so we don't get into a loop (some loops are over a few pixels difference)
				new_state.hoverable_top = top;
			}
			if(Math.abs(left - this.state.hoverable_left) > 5){//only make changes when needed so we don't get into a loop (some loops are over a few pixels difference)
				new_state.hoverable_left = left;
			}
			if(!_.isEmpty(new_state)){
				this.setState(new_state);
			}
		}
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	
	module.exports = function (Displaylists /*, sids... */) {
		var sids = esUtils.cleanup_ids(_.flattenDeep(_.tail(_.toArray(arguments))));
		return _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
			return _.includes(sids, spkr.sid);
		});
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(82)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(476);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(48);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(16);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	  this.target = nativeEventTarget;
	  this.currentTarget = nativeEventTarget;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var DeliveryMethodIcon = __webpack_require__(362);
	
	module.exports = dd.createClass({
		render: function render() {
			var _props = this.props,
			    size = _props.size,
			    status = _props.status,
			    closed = _props.closed,
			    delivery_method = _props.delivery_method,
			    has_parent = _props.has_parent,
			    has_children = _props.has_children;
	
	
			size = esUtils.toInt(size);
			size = size > 0 ? size : 40;
	
			var icon_size = size / 2;
			var sub_icon_size = .4 * size;
	
			//fixing a font size that doesn't look as good for the on-site icon
			icon_size = icon_size === 20 ? 21 : icon_size;
	
			//fixing a font size that doesn't look as good for the family icon
			sub_icon_size = sub_icon_size === 8 ? 10 : sub_icon_size;
	
			return dd.div({ className: "esStatusImage " + (_.has(Constants.EVENT_STATUSES, status) ? status : "") + (closed ? " closed" : ""), style: {
					position: "relative",
					width: size + "px",
					height: size + "px",
					margin: 0,
					padding: 0,
					fontSize: icon_size + "px",
					textAlign: "center",
					lineHeight: size + "px",
					borderRadius: size / 2 + "px"
				} }, DeliveryMethodIcon({ delivery_method: delivery_method }), dd.div({ style: {
					position: "absolute",
					top: "auto",
					right: 0,
					bottom: 0,
					left: "auto",
					textAlign: "right",
					fontSize: sub_icon_size + "px",
					lineHeight: sub_icon_size + "px",
					borderRadius: sub_icon_size / 2 + "px",
					color: "#000000",
					backgroundColor: "#FFFFFF"
				} }, has_parent ? dd.i({ className: "fa fa-arrow-circle-up" }) : null, has_children ? dd.i({ className: "fa fa-arrow-circle-down" }) : null));
		}
	});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = function (event) {
		return event && event.accountinglocked && !AuthedUserSession.doIHaveAccess.admin.any(event.sids);
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(170);
	
	var invariant = __webpack_require__(11);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	module.exports = function (username) {
		var s = _.isString(username) ? username.replace(/\s+/g, "").toUpperCase() : "";
		return s.length > 0 ? s : null;
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	(function(global) {
	  'use strict';
	
	  var dateFormat = (function() {
	      var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
	      var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
	      var timezoneClip = /[^-+\dA-Z]/g;
	  
	      // Regexes and supporting functions are cached through closure
	      return function (date, mask, utc, gmt) {
	  
	        // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
	        if (arguments.length === 1 && kindOf(date) === 'string' && !/\d/.test(date)) {
	          mask = date;
	          date = undefined;
	        }
	  
	        date = date || new Date;
	  
	        if(!(date instanceof Date)) {
	          date = new Date(date);
	        }
	  
	        if (isNaN(date)) {
	          throw TypeError('Invalid date');
	        }
	  
	        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks['default']);
	  
	        // Allow setting the utc/gmt argument via the mask
	        var maskSlice = mask.slice(0, 4);
	        if (maskSlice === 'UTC:' || maskSlice === 'GMT:') {
	          mask = mask.slice(4);
	          utc = true;
	          if (maskSlice === 'GMT:') {
	            gmt = true;
	          }
	        }
	  
	        var _ = utc ? 'getUTC' : 'get';
	        var d = date[_ + 'Date']();
	        var D = date[_ + 'Day']();
	        var m = date[_ + 'Month']();
	        var y = date[_ + 'FullYear']();
	        var H = date[_ + 'Hours']();
	        var M = date[_ + 'Minutes']();
	        var s = date[_ + 'Seconds']();
	        var L = date[_ + 'Milliseconds']();
	        var o = utc ? 0 : date.getTimezoneOffset();
	        var W = getWeek(date);
	        var N = getDayOfWeek(date);
	        var flags = {
	          d:    d,
	          dd:   pad(d),
	          ddd:  dateFormat.i18n.dayNames[D],
	          dddd: dateFormat.i18n.dayNames[D + 7],
	          m:    m + 1,
	          mm:   pad(m + 1),
	          mmm:  dateFormat.i18n.monthNames[m],
	          mmmm: dateFormat.i18n.monthNames[m + 12],
	          yy:   String(y).slice(2),
	          yyyy: y,
	          h:    H % 12 || 12,
	          hh:   pad(H % 12 || 12),
	          H:    H,
	          HH:   pad(H),
	          M:    M,
	          MM:   pad(M),
	          s:    s,
	          ss:   pad(s),
	          l:    pad(L, 3),
	          L:    pad(Math.round(L / 10)),
	          t:    H < 12 ? 'a'  : 'p',
	          tt:   H < 12 ? 'am' : 'pm',
	          T:    H < 12 ? 'A'  : 'P',
	          TT:   H < 12 ? 'AM' : 'PM',
	          Z:    gmt ? 'GMT' : utc ? 'UTC' : (String(date).match(timezone) || ['']).pop().replace(timezoneClip, ''),
	          o:    (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
	          S:    ['th', 'st', 'nd', 'rd'][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
	          W:    W,
	          N:    N
	        };
	  
	        return mask.replace(token, function (match) {
	          if (match in flags) {
	            return flags[match];
	          }
	          return match.slice(1, match.length - 1);
	        });
	      };
	    })();
	
	  dateFormat.masks = {
	    'default':               'ddd mmm dd yyyy HH:MM:ss',
	    'shortDate':             'm/d/yy',
	    'mediumDate':            'mmm d, yyyy',
	    'longDate':              'mmmm d, yyyy',
	    'fullDate':              'dddd, mmmm d, yyyy',
	    'shortTime':             'h:MM TT',
	    'mediumTime':            'h:MM:ss TT',
	    'longTime':              'h:MM:ss TT Z',
	    'isoDate':               'yyyy-mm-dd',
	    'isoTime':               'HH:MM:ss',
	    'isoDateTime':           'yyyy-mm-dd\'T\'HH:MM:sso',
	    'isoUtcDateTime':        'UTC:yyyy-mm-dd\'T\'HH:MM:ss\'Z\'',
	    'expiresHeaderFormat':   'ddd, dd mmm yyyy HH:MM:ss Z'
	  };
	
	  // Internationalization strings
	  dateFormat.i18n = {
	    dayNames: [
	      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
	      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	    ],
	    monthNames: [
	      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
	      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	    ]
	  };
	
	function pad(val, len) {
	  val = String(val);
	  len = len || 2;
	  while (val.length < len) {
	    val = '0' + val;
	  }
	  return val;
	}
	
	/**
	 * Get the ISO 8601 week number
	 * Based on comments from
	 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	 *
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getWeek(date) {
	  // Remove time components of date
	  var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	  // Change date to Thursday same week
	  targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	  // Take January 4th as it is always in week 1 (see ISO 8601)
	  var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	  // Change date to Thursday same week
	  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	  // Check if daylight-saving-time-switch occured and correct for it
	  var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	  targetThursday.setHours(targetThursday.getHours() - ds);
	
	  // Number of weeks between target Thursday and first Thursday
	  var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	  return 1 + Math.floor(weekDiff);
	}
	
	/**
	 * Get ISO-8601 numeric representation of the day of the week
	 * 1 (for Monday) through 7 (for Sunday)
	 * 
	 * @param  {Object} `date`
	 * @return {Number}
	 */
	function getDayOfWeek(date) {
	  var dow = date.getDay();
	  if(dow === 0) {
	    dow = 7;
	  }
	  return dow;
	}
	
	/**
	 * kind-of shortcut
	 * @param  {*} val
	 * @return {String}
	 */
	function kindOf(val) {
	  if (val === null) {
	    return 'null';
	  }
	
	  if (val === undefined) {
	    return 'undefined';
	  }
	
	  if (typeof val !== 'object') {
	    return typeof val;
	  }
	
	  if (Array.isArray(val)) {
	    return 'array';
	  }
	
	  return {}.toString.call(val)
	    .slice(8, -1).toLowerCase();
	};
	
	
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return dateFormat;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = dateFormat;
	  } else {
	    global.dateFormat = dateFormat;
	  }
	})(this);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(150);
	var EventPluginUtils = __webpack_require__(454);
	var ReactErrorUtils = __webpack_require__(163);
	
	var accumulateInto = __webpack_require__(172);
	var forEachAccumulated = __webpack_require__(173);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPluginHub = __webpack_require__(61);
	
	var warning = __webpack_require__(16);
	
	var accumulateInto = __webpack_require__(172);
	var forEachAccumulated = __webpack_require__(173);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(110);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var dateformat = __webpack_require__(41);
	
	module.exports = dd.createClass({
		render: function(){
			var style = this.props.style || {};
	
			var str = buildDateRangeString(this.props.start, this.props.stop, this.props.start_format, this.props.stop_format, this.props.show_times);
			return dd.span(esUtils.isBlank(str) ? null : {className: 'DateRange', style: style}, str);
		}
	});
	
	var buildDateRangeString = function(start, stop, start_format, stop_format, show_times){
		start_format = start_format || 'ddd, mmm d, yyyy';
		stop_format = stop_format || 'mmm d';
		show_times = !!show_times;
		var str_parts = [];
		if(_.isDate(start)){
			str_parts.push(dateformat(start, start_format));
		}
		if(show_times){
			str_parts.push(timeOrBlakIfMidnight(start));
		}
		if(_.isDate(start) && _.isDate(stop)){
			var show_end_date = parseInt(start.getTime() / (1000 * 60 * 60 * 24)) !== parseInt(stop.getTime() / (1000 * 60 * 60 * 24));
			var show_end_time = show_times && (show_end_date || timeOrBlakIfMidnight(start) != timeOrBlakIfMidnight(stop));
	
			if(show_end_date || show_end_time){
				str_parts.push("to");
			}
			if(show_end_date){
				str_parts.push(dateformat(stop, stop_format));
			}
			if(show_end_time){
				str_parts.push(timeOrBlakIfMidnight(stop));
			}
		}
		return str_parts.join(" ");
	};
	
	var timeOrBlakIfMidnight = function(d){
		var time = dateformat(d, 'h:MM TT');
		return time === '12:00 AM' ? '' : time;
	};
	
	module.exports.__for_testing__ = {
		buildDateRangeString: buildDateRangeString
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	module.exports = dd.createClass({
		render: function(){
			return dd.div({
					style: {overflowY: 'auto', height: '100%', maxHeight: '100%', minHeight: '100%'},
					onScroll: this.props.onScroll || null
				},
				this.props.children
			);
		}
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var FullLayout = __webpack_require__(84);
	var HeadNavbar = __webpack_require__(243);
	
	module.exports = dd.createClass({
		render: function render() {
			var Displaylists = this.props.Displaylists;
	
			return FullLayout({ vertical: true }, [{
				height: 52,
				body: HeadNavbar({ Displaylists: Displaylists })
			}, {
				body: this.props.children
			}]);
		}
	});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { left_tabs_height: 100 };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(new_props) {
	    var n_tabs_before = _.keys(this.props.tabs).length;
	    var n_tabs_after = _.keys(new_props.tabs).length;
	    if (n_tabs_after !== n_tabs_before) {
	      this.setState({}, this.__handleResize); //call __handleResize after it renders the new_props
	    }
	  },
	  __handleResize: function __handleResize(e) {
	    if (this.refs && this.refs.tab_areas) {
	      this.setState({ left_tabs_height: this.refs.tab_areas.offsetHeight });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    this.__handleResize(); //trigger first one
	  },
	  render: function render() {
	    var tabs = this.props.tabs;
	    var render_props = this.props.render_props;
	    var tab_body = this.props.tab_body; //if you want to explicitly render the body
	    var selected_tab = this.props.selected_tab;
	    var lefty = !!this.props.lefty;
	    var tabs_width = null;
	    if (lefty) {
	      tabs_width = this.props.tabs_width || 100;
	    }
	    if (_.isEmpty(tabs)) {
	      return dd.div({ className: 'TabSet' });
	    }
	    var first_tab = _.first(_.keys(tabs));
	    if (!tabs[selected_tab]) {
	      selected_tab = first_tab;
	    }
	    return dd.div({ className: 'TabSet' + (lefty ? ' tabs-left' : '') }, dd.ul({ className: 'nav nav-tabs', style: { width: tabs_width }, ref: 'tab_areas' }, _.map(tabs, function (tab, id) {
	      return dd.li({ key: id, className: selected_tab === id ? 'active' : null }, tab.url || tab.onClick ? dd.a({ href: tab.url || '#', onClick: tab.onClick || null }, tab.name) : tab.name);
	    })), lefty ? dd.div({ className: 'tab-content', style: { marginLeft: tabs_width, minHeight: this.state.left_tabs_height } }, dd.div({ className: 'tab-pane active' }, dd.div({ style: { float: 'left', width: '100%' } }, //hack to fix the layout
	    _.isFunction(tabs[selected_tab].render) ? tabs[selected_tab].render(render_props) : tab_body), dd.div({ className: 'clearfix' }))) : null, lefty ? null : dd.div({ className: 'panel panel-default', style: { borderTopLeftRadius: selected_tab === first_tab ? 0 : null } }, dd.div({ className: 'panel-body' }, _.isFunction(tabs[selected_tab].render) ? tabs[selected_tab].render(render_props) : tab_body)), dd.div({ className: 'clearfix' }));
	  }
	});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var radio = __webpack_require__(5);
	
	module.exports = function () {
		radio('invalidate_Displaylists_cache').broadcast();
		radio('Displaylists_get').broadcast({ clear_cache: true });
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Date Format 1.2.3
	 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
	 * MIT license
	 *
	 * Includes enhancements by Scott Trenda <scott.trenda.net>
	 * and Kris Kowal <cixar.com/~kris.kowal/>
	 *
	 * Accepts a date, a mask, or a date and a mask.
	 * Returns a formatted version of the given date.
	 * The date defaults to the current date/time.
	 * The mask defaults to dateFormat.masks.default.
	 */
	
	var dateFormat = function () {
		var	token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g,
			timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
			timezoneClip = /[^-+\dA-Z]/g,
			pad = function (val, len) {
				val = String(val);
				len = len || 2;
				while (val.length < len) val = "0" + val;
				return val;
			},
	    /**
	     * Get the ISO 8601 week number
	     * Based on comments from
	     * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
	     */
	    getWeek = function (date) {
	      // Remove time components of date
	      var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	
	      // Change date to Thursday same week
	      targetThursday.setDate(targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3);
	
	      // Take January 4th as it is always in week 1 (see ISO 8601)
	      var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
	
	      // Change date to Thursday same week
	      firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
	
	      // Check if daylight-saving-time-switch occured and correct for it
	      var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
	      targetThursday.setHours(targetThursday.getHours() - ds);
	
	      // Number of weeks between target Thursday and first Thursday
	      var weekDiff = (targetThursday - firstThursday) / (86400000*7);
	      return 1 + Math.floor(weekDiff);
	    },
	
	    /**
	     * Get ISO-8601 numeric representation of the day of the week
	     * 1 (for Monday) through 7 (for Sunday)
	     */
	
	    getDayOfWeek = function(date){
	    	var dow = date.getDay();
	    	if(dow === 0) dow = 7;
	    	return dow;
	    };
	
		// Regexes and supporting functions are cached through closure
		return function (date, mask, utc, gmt) {
			var dF = dateFormat;
	
			// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
			if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
				mask = date;
				date = undefined;
			}
	
			date = date || new Date;
	
	    if(!(date instanceof Date)) {
	      date = new Date(date);
	    }
	
	    if (isNaN(date)) {
	      throw TypeError("Invalid date");
	    }
	
			mask = String(dF.masks[mask] || mask || dF.masks["default"]);
	
			// Allow setting the utc/gmt argument via the mask
			var maskSlice = mask.slice(0, 4);
			if (maskSlice == "UTC:" || maskSlice == "GMT:") {
				mask = mask.slice(4);
				utc = true;
				if (maskSlice == "GMT:") {
					gmt = true;
				}
			}
	
			var	_ = utc ? "getUTC" : "get",
				d = date[_ + "Date"](),
				D = date[_ + "Day"](),
				m = date[_ + "Month"](),
				y = date[_ + "FullYear"](),
				H = date[_ + "Hours"](),
				M = date[_ + "Minutes"](),
				s = date[_ + "Seconds"](),
				L = date[_ + "Milliseconds"](),
				o = utc ? 0 : date.getTimezoneOffset(),
				W = getWeek(date),
				N = getDayOfWeek(date),
				flags = {
					d:    d,
					dd:   pad(d),
					ddd:  dF.i18n.dayNames[D],
					dddd: dF.i18n.dayNames[D + 7],
					m:    m + 1,
					mm:   pad(m + 1),
					mmm:  dF.i18n.monthNames[m],
					mmmm: dF.i18n.monthNames[m + 12],
					yy:   String(y).slice(2),
					yyyy: y,
					h:    H % 12 || 12,
					hh:   pad(H % 12 || 12),
					H:    H,
					HH:   pad(H),
					M:    M,
					MM:   pad(M),
					s:    s,
					ss:   pad(s),
					l:    pad(L, 3),
					L:    pad(Math.round(L / 10)),
					t:    H < 12 ? "a"  : "p",
					tt:   H < 12 ? "am" : "pm",
					T:    H < 12 ? "A"  : "P",
					TT:   H < 12 ? "AM" : "PM",
					Z:    gmt ? "GMT" : utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
					o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
					S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
					W:    W,
					N:    N
				};
	
			return mask.replace(token, function ($0) {
				return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
			});
		};
	}();
	
	// Some common format strings
	dateFormat.masks = {
		"default":      "ddd mmm dd yyyy HH:MM:ss",
		shortDate:      "m/d/yy",
		mediumDate:     "mmm d, yyyy",
		longDate:       "mmmm d, yyyy",
		fullDate:       "dddd, mmmm d, yyyy",
		shortTime:      "h:MM TT",
		mediumTime:     "h:MM:ss TT",
		longTime:       "h:MM:ss TT Z",
		isoDate:        "yyyy-mm-dd",
		isoTime:        "HH:MM:ss",
		isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
		isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
		expiresHeaderFormat: "ddd, dd mmm yyyy HH:MM:ss Z"
	};
	
	// Internationalization strings
	dateFormat.i18n = {
		dayNames: [
			"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
			"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
		],
		monthNames: [
			"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
			"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
		]
	};
	
	/*
	// For convenience...
	Date.prototype.format = function (mask, utc) {
		return dateFormat(this, mask, utc);
	};
	*/
	
	if (true) {
	  module.exports = dateFormat;
	}


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 Radio.js - Chainable, Dependency Free Publish/Subscribe for Javascript
	 http://radio.uxder.com
	 Author: Scott Murphy 2011
	 twitter: @hellocreation, github: uxder
	 
	 Permission is hereby granted, free of charge, to any person
	 obtaining a copy of this software and associated documentation
	 files (the "Software"), to deal in the Software without
	 restriction, including without limitation the rights to use,
	 copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the
	 Software is furnished to do so, subject to the following
	 conditions:
	 
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	 
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 OTHER DEALINGS IN THE SOFTWARE.
	 */
	(function (name, global, definition) {
		if (true) module.exports = definition(name, global);
		else if (typeof define === 'function' && typeof define.amd  === 'object') define(definition);
		else global[name] = definition(name, global);
	})('radio', this, function (name, global) {
	
		"use strict";
	
		/**
		 * Main Wrapper for radio.$ and create a function radio to accept the channelName
		 * @param {String} channelName topic of event
		 */
		function radio(channelName) {
			radio.$.channel(channelName);
			return radio.$;
		}
	
		radio.$ = {
			version: '0.2',
			channelName: "",
			channels: [],
			/**
			 * Broadcast (publish)
			 * Iterate through all listeners (callbacks) in current channel and pass arguments to subscribers
			 * @param arguments data to be sent to listeners
			 * @example
			 *    //basic usage
			 *    radio('channel1').broadcast('my message'); 
			 *    //send an unlimited number of parameters
			 *    radio('channel2').broadcast(param1, param2, param3 ... );
			 */
			broadcast: function() {
				var i, c = this.channels[this.channelName],
					l = c.length,
					subscriber, callback, context;
				//iterate through current channel and run each subscriber
				for (i = 0; i < l; i++) {
					subscriber = c[i];
					//if subscriber was an array, set the callback and context.
					if ((typeof(subscriber) === 'object') && (subscriber.length)) {
						callback = subscriber[0];
						//if user set the context, set it to the context otherwise, it is a globally scoped function
						context = subscriber[1] || global;
					}
					callback.apply(context, arguments);
				}
				return this;
			},
	
			/**
			 * Create the channel if it doesn't exist and set the current channel/event name
			 * @param {String} name the name of the channel
			 * @example
			 *    radio('channel1');
			 */
			channel: function(name) {
				var c = this.channels;
				//create a new channel if it doesn't exists
				if (!c[name]) c[name] = [];
				this.channelName = name;
				return this;
			},
	
			/**
			 * Add Subscriber to channel
			 * Take the arguments and add it to the this.channels array.
			 * @param {Function|Array} arguments list of callbacks or arrays[callback, context] separated by commas
			 * @example
			 *      //basic usage
			 *      var callback = function() {};
			 *      radio('channel1').subscribe(callback); 
			 *
			 *      //subscribe an endless amount of callbacks
			 *      radio('channel1').subscribe(callback, callback2, callback3 ...);
			 *
			 *      //adding callbacks with context
			 *      radio('channel1').subscribe([callback, context],[callback1, context], callback3);
			 *     
			 *      //subscribe by chaining
			 *      radio('channel1').subscribe(callback).radio('channel2').subscribe(callback).subscribe(callback2);
			 */
			subscribe: function() {
				var a = arguments,
					c = this.channels[this.channelName],
					i, l = a.length,
					p, ai = [];
	
				//run through each arguments and subscribe it to the channel
				for (i = 0; i < l; i++) {
					ai = a[i];
					//if the user sent just a function, wrap the fucntion in an array [function]
					p = (typeof(ai) === "function") ? [ai] : ai;
					if ((typeof(p) === 'object') && (p.length)) c.push(p);
				}
				return this;
			},
	
			/**
			 * Remove subscriber from channel
			 * Take arguments with functions and unsubscribe it if there is a match against existing subscribers.
			 * @param {Function} arguments callbacks separated by commas
			 * @example
			 *      //basic usage
			 *      radio('channel1').unsubscribe(callback); 
			 *      //you can unsubscribe as many callbacks as you want
			 *      radio('channel1').unsubscribe(callback, callback2, callback3 ...);
			 *       //removing callbacks with context is the same
			 *      radio('channel1').subscribe([callback, context]).unsubscribe(callback);
			 */
			unsubscribe: function() {
				var a = arguments,
					i, j, c = this.channels[this.channelName],
					l = a.length,
					cl = c.length,
					offset = 0,
					jo;
				//loop through each argument
				for (i = 0; i < l; i++) {
					//need to reset vars that change as the channel array items are removed
					offset = 0;
					cl = c.length;
					//loop through the channel
					for (j = 0; j < cl; j++) {
						jo = j - offset;
						//if there is a match with the argument and the channel function, unsubscribe it from the channel array
						if (c[jo][0] === a[i]) {
							//unsubscribe matched item from the channel array
							c.splice(jo, 1);
							offset++;
						}
					}
				}
				return this;
			}
		};
	
		return radio;
	});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var VerticalFields = __webpack_require__(443);
	
	module.exports = function(form, layout, scale){
	  return VerticalFields({
	    fields: form.Form_buildSchema(),
	    errors: form.state.errors || {},
	    buildInput: form.Form_buildInput,
	    layout: layout,
	    scale: scale
	  });
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPluginHub = __webpack_require__(61);
	var EventPluginRegistry = __webpack_require__(150);
	var ReactEventEmitterMixin = __webpack_require__(469);
	var ReactPerf = __webpack_require__(39);
	var ViewportMetrics = __webpack_require__(171);
	
	var assign = __webpack_require__(17);
	var isEventSupported = __webpack_require__(113);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(71);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	var ViewportMetrics = __webpack_require__(171);
	
	var getEventModifierState = __webpack_require__(109);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	
	var doAjax = function(method, url, post_body, callback, onProgress, timeout){
		method = _.includes(['GET', 'POST'], method) ? method : 'GET';
		callback = _.isFunction(callback) ? callback : _.noop;
		timeout = _.isNumber(timeout) && timeout > 0 ? timeout : 3 * 60 * 1000;
	
		var xhr = (window.ActiveXObject) ? new ActiveXObject("Microsoft.XMLHTTP") : (XMLHttpRequest && new XMLHttpRequest()) || null;
		if(!xhr){
			callback('NO AJAX', null, -1, null);
			return null;
		}
		var requestTimeout = setTimeout(function(){
			xhr.abort();
			callback('ajax timed out', null, -1, xhr);
		}, timeout);
		xhr.onreadystatechange = function(){
			if(xhr.readyState == 4){
				clearTimeout(requestTimeout);
				callback(null, xhr.responseText, xhr.status, xhr);
			}
		};
		if(_.isFunction(onProgress) && _.has(xhr, 'upload')){
			xhr.upload.onprogress = function(e){
				if(e.lengthComputable){
					onProgress(e.loaded / e.total);
				}
			};
		}
		xhr.open(method, url, true);
		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
		if(method === 'POST'){
			if(typeof FormData !== 'undefined' && post_body instanceof FormData){
				//Don't set a Content-type, FormData will handle it
			}else{
				xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			}
			xhr.send(post_body);
		}else{
			xhr.send();
		}
		return xhr;
	};
	
	module.exports.get = function(url, callback, timeout){
		return doAjax('GET', url, null, callback, null, timeout);
	};
	
	module.exports.post = function(url, params, callback, onProgress, timeout){
		var body = null;
	
		if(_.isObject(params) && typeof File !== 'undefined' && _.find(_.values(params), function(param){
			return param instanceof File;
		})){
			body = new FormData();
			_.each(params, function(val, key){
				body.append(key, val);
			});
		}else if(!_.isString(params)){
			body = esUtils.phpCompatibleParams(params);
		}else{
			body = params;
		}
		return doAjax('POST', url, body, callback, onProgress, timeout);
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	
	module.exports = dd.createClass({
		render: function(){
			var horizontal = !!this.props.horizontal;
			var layout_shiz = make_layout_portions(_.map(this.props.children, function(elm, i){
				return num_or_null(horizontal ? elm.width : elm.height);
			}));
	
			return dd.div({style: {
					height: '100%'
				}},
				_.map(this.props.children, function(elm, i){
					var style = {
						position: 'absolute'
					};
	
					if(horizontal){
						style.top = 0;
						style.bottom = 0;
	
						if(layout_shiz[i].before !== null){
							style.left = layout_shiz[i].before;
						}
						if(layout_shiz[i].after !== null){
							style.right = layout_shiz[i].after;
						}
						if(layout_shiz[i].size !== null){
							style.width = layout_shiz[i].size;
						}
					}else{
						style.right = 0;
						style.left = 0;
	
						if(layout_shiz[i].before !== null){
							style.top = layout_shiz[i].before;
						}
						if(layout_shiz[i].after !== null){
							style.bottom = layout_shiz[i].after;
						}
						if(layout_shiz[i].size !== null){
							style.height = layout_shiz[i].size;
						}
					}
					return dd.div({key: i, style: style}, elm.body);
				})
			);
		}
	});
	
	var num_or_null = function(n){
		return _.isNumber(n) && !_.isNaN(n) && n >= 0 ? n : null;
	};
	
	var sum_until_null = function(arr){
		var null_mode = false;
		var sum = 0;
		return _.map(arr, function(size){
			var result = null_mode ? null : sum;
			if(size === null){
				null_mode = true;
			}else if(!null_mode){
				sum += size;
			}
			return result;
		});
	};
	
	var make_layout_portions = function(sizes){
		var befores = sum_until_null(sizes);
		var afters = sum_until_null(_.clone(sizes).reverse()).reverse();
		return _.map(sizes, function(size, i){
			return {
				size: size,
				before: befores[i],
				after: afters[i]
			};
		});
	};
	
	module.exports.__for_testing__ = {
		make_layout_portions: make_layout_portions,
		sum_until_null: sum_until_null
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	module.exports = dd.createClass({
		render: function(){
			return dd.img({src: '//d1wyxf4lkw4102.cloudfront.net/ui/loading.gif'});
		}
	});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(29);
	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var HelpTooltip = __webpack_require__(118);
	
	//read why vertical labels are the best layout
	//http://www.uxmatters.com/mt/archives/2006/07/label-placement-in-forms.php
	
	module.exports = dd.createClass({
		propTypes: {
			fields: React.PropTypes.object.isRequired,
			errors: React.PropTypes.object.isRequired,
			buildInput: React.PropTypes.func.isRequired,
	
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
			layout: React.PropTypes.array
		},
		render: function(){
			var fields = this.props.fields;
			var errors = this.props.errors;
			var buildInput = this.props.buildInput;
	
			var scale = this.props.scale || 'sm';
			var layout = this.props.layout;
			if(!layout || !_.isArray(layout)){
				layout = _.map(fields, function(f, name){
					return [name];
				});
			}
	
	
			return dd.div({className: 'VerticalFields'},
				_.map(layout, function(row, i){
					if(!_.isArray(row) || row.length === 0 || row.length > 12){
						return dd.div({key: i});
					}
					var col_size = Math.floor(12 / row.length);
	
					return dd.div({className: 'row', key: i},
						_.map(row, function(name, i){
							return dd.div({key: i, className: 'col-' + scale + '-' + col_size},
								VerticalField({
									field_name: name,
									fields: fields,
									errors: errors,
									buildInput: buildInput
								})
							);
						})
					);
				})
			);
		}
	});
	
	var VerticalField = dd.createClass({
		propTypes: {
			//field_name: String or Component //basically required, if not a field name it'll stick it in a div at the proper col-width
			fields: React.PropTypes.object.isRequired,
			errors: React.PropTypes.object.isRequired,
			buildInput: React.PropTypes.func.isRequired
		},
		render: function(){
			var name = this.props.field_name;
			var field = this.props.fields[name];
			var error = this.props.errors[name];
			var buildInput = this.props.buildInput;
	
			if(!field){
				return dd.div();//render a placeholder with whatever name is (i.e. can pass in a component)
			}
	
			var field_label = field.label || name;
			var tooltip = field.tooltip ? HelpTooltip({title: field_label, content: field.tooltip}) : null;
	
			return dd.div({className: 'VerticalField form-group ' + (error ? ' has-error' : '')},
				field.type !== 'checkbox' && !!(tooltip || field.label) ? dd.label({className: 'control-label'},
					field_label + ' ', tooltip
				) : null,
				buildInput(field, name),
				field.type == 'checkbox' ? ' ' : null,
				field.type == 'checkbox' ? tooltip : null,
				error ? dd.span({className: 'help-block'}, error) : null,
				field.help_text ? dd.span({className: 'help-block'}, field.help_text) : null
			);
		}
	});
	
	module.exports.FormButtons = dd.createClass({
		propTypes: {
			scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
	
			onCancel: React.PropTypes.func,
			onDelete: React.PropTypes.func,
			onDiscard: React.PropTypes.func,
			submit_btn_text: React.PropTypes.string
		},
		render: function(){
			var scale = this.props.scale || 'sm';
			var onCancel = this.props.onCancel;
			var onDelete = this.props.onDelete;
			var onDiscard = this.props.onDiscard;
			var submit_btn_text = this.props.submit_btn_text;
	
			return dd.div(null,
				dd.button({type: 'submit', className: 'btn btn-primary btn-' + scale}, submit_btn_text || 'Save'),
				' ',
				onDiscard ? dd.button({className: 'btn btn-default btn-' + scale, onClick: onDiscard}, 'Undo Changes') : null,
				' ',
				onCancel ? dd.button({className: 'btn btn-default btn-' + scale, onClick: onCancel}, 'Cancel') : null,
				' ',
				onDelete ? dd.button({className: 'btn btn-danger btn-' + scale, onClick: onDelete}, 'Delete') : null
			);
		}
	});


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var FormMixin = __webpack_require__(19);
	
	module.exports = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return props.sid;
		},
		getInitialValues: function getInitialValues(props) {
			return { speaker: props.sid };
		},
		buildSchema: function buildSchema() {
			var _props = this.props,
			    Displaylists = _props.Displaylists,
			    sids_to_choose = _props.sids_to_choose;
	
			var options = FormUtils.getSpeakerNamesBySid(Displaylists, false);
	
			if (_.isArray(sids_to_choose)) {
				var new_opts = {};
				_.each(sids_to_choose, function (sid) {
					new_opts[sid] = _.has(options, sid) ? options[sid] : "speaker:" + sid; //this is very unlikely
				});
				options = new_opts;
			}
			return {
				speaker: {
					type: "select",
					options: options,
					validate: function validate(v) {
						var sid = esUtils.toInt(v);
						return _.has(options, sid) ? true : "Please select a speaker";
					}
				}
			};
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			if (field_path === "speaker") {
				var sid = esUtils.toInt(new_value);
				if (sid > 0) {
					this.props.onSidChanged(sid);
				}
			}
		},
		__startValidation: function __startValidation() {
			if (this.state.submit_attempts == 0) {
				this.Form_onSubmit(); //so that validation will kick in
			}
		},
		componentDidUpdate: function componentDidUpdate() {
			this.__startValidation();
		},
		componentDidMount: function componentDidMount() {
			this.__startValidation();
		},
		render: function render() {
			var fields = this.Form_buildSchema();
			var errors = this.state.errors || {};
	
			return dd.form({ onSubmit: this.Form_onSubmit, role: "form" }, dd.div({ className: "form-group" }, dd.label({ className: "control-label col-sm-2 text-right" }, "For Speaker "), dd.div({ className: "col-sm-10", style: { display: "inline-block", width: 260, margin: "0 0 20px 10px" } }, this.Form_buildInput(fields.speaker), errors["speaker"] ? dd.span({ className: "help-block" }, errors["speaker"]) : null)));
		}
	});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	module.exports = function (speaker) {
	    var to_save = {};
	    _.each(speaker.todolists, function (list) {
	        to_save[list.id] = {
	            name: list.listname,
	            items: {}
	        };
	        _.each(list.masters, function (item, id) {
	            to_save[list.id].items[id] = {
	                activateonstatus: item.activateonstatus,
	                assignedto: item.assignedto,
	                description: item.description,
	                duebasedon: item.duebasedon,
	                duedelta: item.duedelta,
	                vieworder: item.vieworder
	            };
	        });
	    });
	    return to_save;
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var VerticalScroll = __webpack_require__(66);
	var HorizontalFields = __webpack_require__(23);
	var Constants = __webpack_require__(13);
	
	var service_name_map = {
	  infusionsoft: "Keap Opportunities",
	  zoho: "Zoho CRM Opportunities",
	  hl: "HighLevel CRM Opportunities"
	};
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { loading: false, error_msg: null };
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var link_to_event = _.get(this.props, "link_to_event", null);
	    var service = _.has(service_name_map, this.props.service_to_import_from) ? this.props.service_to_import_from : _.first(_.keys(service_name_map));
	    var service_name = service_name_map[service];
	    var grabber = null;
	    switch (service) {
	      case "infusionsoft":
	        grabber = InfusionsoftGrabber({ Displaylists: Displaylists, link_to_event: link_to_event });
	        break;
	      case "zoho":
	        grabber = ZohoGrabber({
	          Displaylists: Displaylists,
	          link_to_event: link_to_event,
	          get_opportunities: "Thirdpartyconnection_Zoho_get_opportunities"
	        });
	        break;
	      case "hl":
	        grabber = HighlevelGrabber({
	          Displaylists: Displaylists,
	          link_to_event: link_to_event,
	          get_opportunities: "Thirdpartyconnection_Hl_get_opportunities"
	        });
	        break;
	      default:
	    }
	
	    return VerticalScroll(null, dd.div({ className: "ImportEvent panel panel-default", style: { margin: 10 } }, dd.div({ className: "panel-body" }, ErrorAlert({ message: this.state.error_msg }), LoadingWrap({ is_loading: this.state.loading || _.isEmpty(Displaylists) }, _.isEmpty(link_to_event) ? dd.h3(null, "Import ", service_name) : null, dd.div({ className: "alert alert-info" }, _.isEmpty(link_to_event) ? dd.div(null, "eSpeakers and ", service_name, " work together like Sonny and Cher.") : "Link an existing Opportunity to this event.", _.isEmpty(link_to_event) ? "This screen helps you locate one of your " + service_name + " to bring into eSpeakers as an event." : null), grabber))));
	  }
	});
	
	var ZohoGrabber = dd.createClass({
	  mixins: [FormMixin, RadioMixin],
	  getInitialState: function getInitialState() {
	    return { stagetimes: null, loading: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {},
	  buildFields: function buildFields() {
	    var Displaylists = this.props.Displaylists;
	    var schema = {
	      speaker: {
	        label: "speaker",
	        type: "select",
	        placeholder: "-- select a speaker --",
	        options: _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
	          return [spkr.sid, spkr.name_full];
	        }))
	      },
	      searchfor: {
	        label: "find opportunity",
	        type: "text",
	        placeholder: "[search keyword]"
	      }
	    };
	
	    return schema;
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    switch (field_path) {
	      case "speaker":
	        //this._form_onChange('searchfor', null);//clear it when speaker changes
	        break;
	      case "searchfor":
	        //radio(self.props.get_opportunities).broadcast(this.state.data.speaker, new_value);
	        break;
	      default:
	    }
	  },
	
	
	  onSubmitSearch: esUtils.wrapPreventDefault(function () {
	    if (!_.isEmpty(this.state.data.speaker) && !_.isEmpty(this.state.data.searchfor)) {
	      radio(this.props.get_opportunities).broadcast(this.state.data.speaker, this.state.data.searchfor);
	    }
	  }),
	
	  render: function render() {
	    var data = this.state.data || {};
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var Displaylists = this.props.Displaylists;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, dd.form({ className: "form-horizontal", onSubmit: this.onSubmitSearch }, ErrorAlert({ message: this.state.error_msg }), HorizontalFields({
	      fields: fields,
	      errors: errors,
	      buildInput: this._form_buildInput,
	      FormButtons: { submit_btn_text: "search" }
	    }), _.isEmpty(_.get(this.state, "data.speaker")) || _.isEmpty(_.get(this.state, "data.searchfor")) ? null : HorizontalFields.FormButtons({ submit_btn_text: "Search" }), LoadingWrap({ is_loading: this.state.loading })), ZohoOpportunitiesList({
	      radio_get_opportunities: "Thirdpartyconnection_Zoho_get_opportunities",
	      radio_opportunities: "Thirdpartyconnection_Zoho_opportunities",
	      radio_get_opportunities_failed: "Thirdpartyconnection_Zoho_get_opportunities_failed",
	      service: "zoho",
	      link_to_event: link_to_event,
	      Displaylists: Displaylists,
	      speaker_id: data.speaker,
	      searchfor: data.searchfor
	    }));
	  }
	});
	
	var HighlevelGrabber = dd.createClass({
	  mixins: [FormMixin, RadioMixin],
	  getInitialState: function getInitialState() {
	    return { stagetimes: null, loading: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {},
	  buildFields: function buildFields() {
	    var Displaylists = this.props.Displaylists;
	    var schema = {
	      speaker: {
	        label: "event speaker",
	        type: "select",
	        placeholder: "-- select a speaker --",
	        options: _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
	          return [spkr.sid, spkr.name_full];
	        }))
	      },
	      searchfor: {
	        label: "find opportunity",
	        type: "text",
	        placeholder: "[search keyword]"
	      }
	    };
	
	    return schema;
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    switch (field_path) {
	      case "speaker":
	        //this._form_onChange('searchfor', null);//clear it when speaker changes
	        break;
	      case "searchfor":
	        //radio(self.props.get_opportunities).broadcast(this.state.data.speaker, new_value);
	        break;
	      default:
	    }
	  },
	
	
	  onSubmitSearch: esUtils.wrapPreventDefault(function () {
	    if (!_.isEmpty(this.state.data.speaker) && !_.isEmpty(this.state.data.searchfor)) {
	      radio(this.props.get_opportunities).broadcast(this.state.data.speaker, this.state.data.searchfor);
	    }
	  }),
	
	  render: function render() {
	    var data = this.state.data || {};
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var Displaylists = this.props.Displaylists;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, dd.form({ className: "form-horizontal", onSubmit: this.onSubmitSearch }, ErrorAlert({ message: this.state.error_msg }), HorizontalFields({
	      fields: fields,
	      errors: errors,
	      buildInput: this._form_buildInput,
	      FormButtons: { submit_btn_text: "search" }
	    }), _.isEmpty(_.get(this.state, "data.speaker")) || _.isEmpty(_.get(this.state, "data.searchfor")) ? null : HorizontalFields.FormButtons({ submit_btn_text: "Search" }), LoadingWrap({ is_loading: this.state.loading })), HighlevelOpportunitiesList({
	      radio_get_opportunities: "Thirdpartyconnection_Hl_get_opportunities",
	      radio_opportunities: "Thirdpartyconnection_Hl_opportunities",
	      radio_get_opportunities_failed: "Thirdpartyconnection_Hl_get_opportunities_failed",
	      service: "hl",
	      link_to_event: link_to_event,
	      Displaylists: Displaylists,
	      speaker_id: data.speaker,
	      searchfor: data.searchfor
	    }));
	  }
	});
	
	var InfusionsoftGrabber = dd.createClass({
	  mixins: [FormMixin, RadioMixin],
	  getInitialState: function getInitialState() {
	    return { stagetimes: null, loading: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      Thirdpartyconnection_Infusionsoft_get_stagetimes: function Thirdpartyconnection_Infusionsoft_get_stagetimes(sid) {
	        if (sid === self.state.data.speaker) {
	          self.setState({ stagetimes: null, loading: true, error_msg: null });
	        }
	      },
	      Thirdpartyconnection_Infusionsoft_stagetimes: function Thirdpartyconnection_Infusionsoft_stagetimes(sid, stagetimes) {
	        if (sid === self.state.data.speaker) {
	          self.setState({
	            stagetimes: stagetimes,
	            loading: false,
	            error_msg: null
	          });
	        }
	      },
	      Thirdpartyconnection_Infusionsoft_get_stagetimes_failed: function Thirdpartyconnection_Infusionsoft_get_stagetimes_failed(sid, message) {
	        if (sid === self.state.data.speaker) {
	          self.setState({
	            stagetimes: null,
	            loading: false,
	            error_msg: "Failed to grab stagetimes: " + message
	          });
	        }
	      }
	    };
	  },
	  buildFields: function buildFields() {
	    var Displaylists = this.props.Displaylists;
	    var schema = {
	      speaker: {
	        label: "speaker",
	        type: "select",
	        placeholder: "-- select a speaker --",
	        options: _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
	          return [spkr.sid, spkr.name_full];
	        }))
	      }
	    };
	    if (!_.isEmpty(this.state.stagetimes)) {
	      schema.stagetime = {
	        label: "opportunities in",
	        type: "select",
	        placeholder: "-- select stage --",
	        options: _.object(_.map(this.state.stagetimes, function (s) {
	          return [s.Id, s.StageName];
	        }))
	      };
	    }
	    return schema;
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    if (field_path === "speaker") {
	      if (new_value !== null && new_value > 0) {
	        radio("Thirdpartyconnection_Infusionsoft_get_stagetimes").broadcast(new_value);
	      }
	      this._form_onChange("stagetime", null); //clear it when speaker changes
	    } else {
	      if (new_value !== null && new_value > 0) {
	        radio("Thirdpartyconnection_Infusionsoft_get_opportunities").broadcast(this.state.data.speaker, new_value);
	      }
	    }
	  },
	  render: function render() {
	    var data = this.state.data || {};
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var Displaylists = this.props.Displaylists;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, dd.form({ className: "form-horizontal", onSubmit: this._form_onSubmit }, ErrorAlert({ message: this.state.error_msg }), HorizontalFields({
	      fields: fields,
	      errors: errors,
	      buildInput: this._form_buildInput
	    }), LoadingWrap({ is_loading: this.state.loading })), OpportunitiesList({
	      Displaylists: Displaylists,
	      speaker_id: data.speaker,
	      stagetime_id: data.stagetime,
	      link_to_event: link_to_event,
	      stagetime_name: fields.stagetime && fields.stagetime.options[data.stagetime] || null
	    }));
	  }
	});
	
	var ZohoOpportunitiesList = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      opp_key: this.__opportunityKey(this.props),
	      opportunities: null,
	      loading: false,
	      error_msg: null,
	      selected_opportunity: null
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.state.opp_key !== this.__opportunityKey(props)) {
	      this.setState({ opportunities: null, loading: null, error_msg: null });
	    }
	  },
	  __opportunityKey: function __opportunityKey(props) {
	    return props.speaker_id + "_" + props.searchfor;
	  },
	  componentWillMount: function componentWillMount() {
	    var _self$radio;
	
	    var self = this;
	    self.radio = (_self$radio = {}, _defineProperty(_self$radio, self.props.radio_get_opportunities, function (sid, searchfor) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: null,
	          loading: true,
	          error_msg: null
	        });
	      }
	    }), _defineProperty(_self$radio, self.props.radio_opportunities, function (sid, searchfor, opportunities) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: opportunities,
	          loading: false,
	          error_msg: null
	        });
	      }
	    }), _defineProperty(_self$radio, self.props.radio_get_opportunities_failed, function (sid, searchfor, message) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: null,
	          loading: false,
	          error_msg: "Failed to grab opportunities: " + message
	        });
	      }
	    }), _self$radio);
	  },
	  __setSelectedOpportunity: function __setSelectedOpportunity(opp) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ selected_opportunity: opp });
	    });
	  },
	  render: function render() {
	    var speaker_id = this.props.speaker_id;
	    var Displaylists = this.props.Displaylists;
	    var opportunities = this.state.opportunities;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, ErrorAlert({ message: this.state.error_msg }), LoadingWrap({ is_loading: this.state.loading }, _.isArray(opportunities) && opportunities.length > 0 ? dd.p({ style: { marginTop: "1rem" } }, "Select an Opportunity from the list") : null, _.isArray(opportunities) ? opportunities.length > 0 ? dd.table({ className: "table table-hover" }, dd.thead(null, dd.tr(null, dd.th(null, "close date"), dd.th(null, "client"), dd.th(null, "description"))), dd.tbody(null, _.map(opportunities, function (opportunity, i) {
	      return dd.tr({
	        key: i,
	        className: "clickable",
	        onClick: this.__setSelectedOpportunity(opportunity)
	      }, dd.td(null, _.get(opportunity, "date", "[missing name]"), dd.td(null, _.get(opportunity, "ProspectName", "[missing name]")), dd.td(null, '"', _.get(opportunity, "OpportunityTitle", "[missing name]"), '"')));
	    }, this))) : dd.div({ className: "text-center" }, dd.b(null, "no opportunities "), " matching ", _.get(this.props, "searchfor")) : null), this.state.selected_opportunity === null ? null : OpportunityGrabber({
	      Displaylists: Displaylists,
	      opportunity: this.state.selected_opportunity,
	      speaker_id: speaker_id,
	      onClose: this.__setSelectedOpportunity(null),
	      service: "zoho",
	      link_to_event: link_to_event,
	      radio_import_opportunities: _.isEmpty(link_to_event) ? "Thirdpartyconnection_Zoho_import_opportunities" : "Thirdpartyconnection_Zoho_link_opportunities",
	      radio_import_opportunities_failed: "Thirdpartyconnection_Zoho_import_opportunities_failed",
	      radio_import_opportunities_succeeded: "Thirdpartyconnection_Zoho_import_opportunities_succeeded"
	    }), dd.br(), dd.br());
	  }
	});
	
	var HighlevelOpportunitiesList = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      opp_key: this.__opportunityKey(this.props),
	      opportunities: null,
	      loading: false,
	      error_msg: null,
	      selected_opportunity: null
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.state.opp_key !== this.__opportunityKey(props)) {
	      this.setState({ opportunities: null, loading: null, error_msg: null });
	    }
	  },
	  __opportunityKey: function __opportunityKey(props) {
	    return props.speaker_id + "_" + props.searchfor;
	  },
	  componentWillMount: function componentWillMount() {
	    var _self$radio2;
	
	    var self = this;
	    self.radio = (_self$radio2 = {}, _defineProperty(_self$radio2, self.props.radio_get_opportunities, function (sid, searchfor) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: null,
	          loading: true,
	          error_msg: null
	        });
	      }
	    }), _defineProperty(_self$radio2, self.props.radio_opportunities, function (sid, searchfor, opportunities) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: opportunities,
	          loading: false,
	          error_msg: null
	        });
	      }
	    }), _defineProperty(_self$radio2, self.props.radio_get_opportunities_failed, function (sid, searchfor, message) {
	      if (sid === self.props.speaker_id && searchfor === self.props.searchfor) {
	        self.setState({
	          opportunities: null,
	          loading: false,
	          error_msg: "Failed to grab opportunities: " + message
	        });
	      }
	    }), _self$radio2);
	  },
	  __setSelectedOpportunity: function __setSelectedOpportunity(opp) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ selected_opportunity: opp });
	    });
	  },
	  render: function render() {
	    var speaker_id = this.props.speaker_id;
	    var Displaylists = this.props.Displaylists;
	    var opportunities = this.state.opportunities;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, ErrorAlert({ message: this.state.error_msg }), LoadingWrap({ is_loading: this.state.loading }, _.isArray(opportunities) && opportunities.length > 0 ? dd.p({ style: { marginTop: "1rem" } }, "Select an Opportunity from the list") : null, _.isArray(opportunities) ? opportunities.length > 0 ? dd.table({ className: "table table-hover" }, dd.thead(null, dd.tr(null, dd.th(null, "start date"), dd.th(null, "contact"), dd.th(null, "opportunity name"))), dd.tbody(null, _.map(opportunities, function (opportunity, i) {
	      return dd.tr({
	        key: i,
	        className: "clickable",
	        onClick: this.__setSelectedOpportunity(opportunity)
	      }, dd.td(null, opportunity.date), dd.td(null, opportunity.ProspectName), dd.td(null, '"', opportunity.OpportunityTitle, '"'));
	    }, this))) : dd.div({ className: "text-center" }, dd.b(null, "no opportunities "), " matching ", _.get(this.props, "searchfor")) : null), this.state.selected_opportunity === null ? null : OpportunityGrabber({
	      Displaylists: Displaylists,
	      opportunity: this.state.selected_opportunity,
	      speaker_id: speaker_id,
	      onClose: this.__setSelectedOpportunity(null),
	      service: "hl",
	      link_to_event: link_to_event,
	      radio_import_opportunities: _.isEmpty(link_to_event) ? "Thirdpartyconnection_Hl_import_opportunities" : "Thirdpartyconnection_Hl_link_opportunities",
	      radio_import_opportunities_failed: "Thirdpartyconnection_Hl_import_opportunities_failed",
	      radio_import_opportunities_succeeded: "Thirdpartyconnection_Hl_import_opportunities_succeeded"
	    }), dd.br(), dd.br());
	  }
	});
	
	var OpportunitiesList = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      opp_key: this.__opportunityKey(this.props),
	      opportunities: null,
	      loading: false,
	      error_msg: null,
	      selected_opportunity: null
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.state.opp_key !== this.__opportunityKey(props)) {
	      this.setState({ opportunities: null, loading: null, error_msg: null });
	    }
	  },
	  __opportunityKey: function __opportunityKey(props) {
	    return props.speaker_id + "_" + props.stagetime_id;
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      Thirdpartyconnection_Infusionsoft_get_opportunities: function Thirdpartyconnection_Infusionsoft_get_opportunities(sid, stagetime_id) {
	        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
	          self.setState({
	            opportunities: null,
	            loading: true,
	            error_msg: null
	          });
	        }
	      },
	      Thirdpartyconnection_Infusionsoft_opportunities: function Thirdpartyconnection_Infusionsoft_opportunities(sid, stagetime_id, opportunities) {
	        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
	          self.setState({
	            opportunities: opportunities,
	            loading: false,
	            error_msg: null
	          });
	        }
	      },
	      Thirdpartyconnection_Infusionsoft_get_opportunities_failed: function Thirdpartyconnection_Infusionsoft_get_opportunities_failed(sid, stagetime_id, message) {
	        if (sid === self.props.speaker_id && stagetime_id === self.props.stagetime_id) {
	          self.setState({
	            opportunities: null,
	            loading: false,
	            error_msg: "Failed to grab stagetimes: " + message
	          });
	        }
	      }
	    };
	  },
	  __setSelectedOpportunity: function __setSelectedOpportunity(opp) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ selected_opportunity: opp });
	    });
	  },
	  render: function render() {
	    var speaker_id = this.props.speaker_id;
	    var Displaylists = this.props.Displaylists;
	    var opportunities = this.state.opportunities;
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    return dd.div(null, ErrorAlert({ message: this.state.error_msg }), LoadingWrap({ is_loading: this.state.loading }, _.isArray(opportunities) ? opportunities.length > 0 ? dd.table({ className: "table table-hover" }, dd.thead(null, dd.tr(null, dd.th(null, "close date"), dd.th(null, "client"), dd.th(null, "description"))), dd.tbody(null, _.map(opportunities, function (opportunity, i) {
	      return dd.tr({
	        key: i,
	        className: "clickable",
	        onClick: this.__setSelectedOpportunity(opportunity)
	      }, dd.td(null, opportunity.date), dd.td(null, opportunity.ProspectName), dd.td(null, '"', opportunity.OpportunityTitle, '"'));
	    }, this))) : dd.div({ className: "text-center" }, dd.b(null, "no opportunities "), " in ", this.props.stagetime_name) : null), this.state.selected_opportunity === null ? null : OpportunityGrabber({
	      Displaylists: Displaylists,
	      opportunity: this.state.selected_opportunity,
	      speaker_id: speaker_id,
	      onClose: this.__setSelectedOpportunity(null),
	      service: "infusionsoft",
	      link_to_event: link_to_event,
	      radio_import_opportunities: _.isEmpty(link_to_event) ? "Thirdpartyconnection_Infusionsoft_import_opportunities" : "Thirdpartyconnection_Infusionsoft_import_opportunities",
	      radio_import_opportunities_failed: "Thirdpartyconnection_Infusionsoft_import_opportunities_failed",
	      radio_import_opportunities_succeeded: "Thirdpartyconnection_Infusionsoft_import_opportunities_succeeded"
	    }), dd.br(), dd.br());
	  }
	});
	
	var OpportunityGrabber = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { event_status: 0, importing: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {
	    var _self$radio3;
	
	    var self = this;
	    self.radio = (_self$radio3 = {}, _defineProperty(_self$radio3, self.props.radio_import_opportunities, function (sid, opportunity_id, status, event_id) {
	      self.setState({ importing: true, error_msg: null });
	    }), _defineProperty(_self$radio3, self.props.radio_import_opportunities_succeeded, function (sid, opportunity_id, status, event_id) {
	      if (window.location.href.includes(event_id)) {
	        //we linked to existing event
	        window.location.reload();
	      } else {
	        //we created a new event
	        radio("Hashbang_set").broadcast("/events/" + event_id);
	      }
	    }), _defineProperty(_self$radio3, self.props.radio_import_opportunities_failed, function (sid, opportunity_id, status, message) {
	      self.setState({
	        importing: false,
	        error_msg: "Failed to import from " + self.props.service + ": " + message
	      });
	    }), _defineProperty(_self$radio3, "Thirdpartyconnection_Zoho_link_opportunities_succeeded", function Thirdpartyconnection_Zoho_link_opportunities_succeeded(sid, opportunity_id, status, event_id) {
	      radio("Hashbang_set").broadcast("/events/" + event_id);
	    }), _defineProperty(_self$radio3, "Thirdpartyconnection_Zoho_link_opportunities_failed", function Thirdpartyconnection_Zoho_link_opportunities_failed(sid, opportunity_id, status, message) {
	      self.setState({
	        importing: false,
	        error_msg: "Failed to import from " + self.props.service + ": " + message
	      });
	    }), _self$radio3);
	  },
	  __onChange: function __onChange(e) {
	    this.setState({ event_status: _.parseInt(e.target.value) });
	  },
	  __import: esUtils.wrapPreventDefault(function () {
	    radio(this.props.radio_import_opportunities).broadcast(this.props.speaker_id, this.props.opportunity.Id, this.state.event_status, _.get(this.props, "link_to_event.eid", null));
	  }),
	  render: function render() {
	    var onClose = this.props.onClose;
	    var opportunity = this.props.opportunity;
	    var Displaylists = this.props.Displaylists;
	    var event_status = this.state.event_status;
	    var service_name = _.get(Constants.GRAB_SERVICES, _.get(this.props, "service", "CRM").toUpperCase(), _.get(this.props, "service", "CRM"));
	    var link_to_event = _.get(this.props, "link_to_event");
	
	    var verb = _.isEmpty(link_to_event) ? "Import" : "Link";
	    service_name = service_name[0].toUpperCase() + service_name.slice(1);
	
	    if (this.state.importing) {
	      return Modal({ title: verb + " from " + service_name + "...", buttons: [] }, LoadingWrap({ text: verb + "ing...", is_loading: true }));
	    }
	
	    return Modal({
	      title: verb + " " + service_name + " opportunity",
	      buttons: [],
	      onClose: onClose
	    }, ErrorAlert({ message: this.state.error_msg }), dd.div(null, _.isEmpty(link_to_event) ? dd.p(null, "You are about to import the " + service_name + ' opportunity "' + _.get(opportunity, "OpportunityTitle", "title") + '" into your eSpeakers calendar as a ', dd.select({ value: event_status, onChange: this.__onChange }, _.map(Displaylists && Displaylists.universal && Displaylists.universal.eventstatuses, function (a) {
	      return dd.option({ key: a.id, value: a.id }, a.description);
	    })), " event.") : dd.p(null, "You are about to link the " + service_name + ' opportunity "' + _.get(opportunity, "OpportunityTitle", "title") + '" to this event.'), dd.p(null, "Proceed?")), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: this.__import }, verb), " ", dd.button({ className: "btn btn-default", onClick: onClose }, "Cancel")));
	  }
	});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var normalizeUsername = __webpack_require__(58);
	
	// let getSpeakersOnEvent = function (event, Displaylists) {
	//   return _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
	//     return _.includes(event && event.sids, spkr.sid);
	//   });
	// };
	
	module.exports = function (event) {
	  var usernames = [];
	  // We now return only active users
	  _.forEach(_.get(event, "CoWorkers", []), function (a, speaker_id) {
	    _.merge(usernames, _.pluck(_.filter(a, function (b) {
	      return _.get(b, ["active"], false);
	    }), "id"));
	  });
	
	  if (_.has(event, "eventrep_login")) {
	    usernames.push(event.eventrep_login);
	  }
	  usernames = _.uniq(_.filter(_.map(usernames, normalizeUsername), _.isString));
	  usernames = _.sortBy(usernames);
	  var r = _.object(_.map(usernames, function (username) {
	    return [username, username];
	  }));
	
	  return r;
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localStorage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var SearchForm = __webpack_require__(280);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ComingSoonModal = __webpack_require__(278);
	// let DeprecatedModal = require("./DeprecatedModal");
	var MacContactsModal = __webpack_require__(279);
	var RadioServiceMixin = __webpack_require__(14);
	
	var ContactToGrab = dd.createClass({
	  __onClick: esUtils.wrapPreventDefault(function () {
	    this.props.onSelected(this.props.contact.id);
	  }),
	  render: function render() {
	    var contact = this.props.contact;
	
	
	    return dd.div({ className: "ContactToGrab row", style: { marginTop: "0.5rem" } }, dd.div({ className: "col-sm-1" }, dd.a({
	      style: { paddingTop: "0", paddingLeft: "0", marginLeft: "0" },
	      href: "#",
	      className: "btn btn-link btn-sm ",
	      onClick: this.__onClick
	    }, "GRAB")), dd.div({ className: "col-sm-11" }, contact.name));
	  }
	});
	
	var ContactList = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        contacts = _props.contacts,
	        onSelected = _props.onSelected;
	
	
	    return dd.div({
	      className: "panel panel-default ContactList",
	      style: { marginTop: 30 }
	    }, dd.div({ className: "panel-body" }, _.map(contacts, function (contact, i) {
	      return ContactToGrab({
	        key: i,
	        contact: contact,
	        onSelected: onSelected
	      });
	    }), _.size(contacts) === 0 ? dd.div({ className: "text-center" }, "-- no results --") : null));
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	  getInitialState: function getInitialState() {
	    var defaultGrabservice = _.get(this, "props.service");
	    if (_.isEmpty(defaultGrabservice)) {
	      defaultGrabservice = localStorage.getItem("default_grab_service");
	    }
	    defaultGrabservice = _.isEmpty(defaultGrabservice) ? "EP" : defaultGrabservice;
	    return { has_searched_yet: false, service: defaultGrabservice };
	  },
	  RadioService_setup: function RadioService_setup() {
	    return {
	      ContactGrabber_search: {
	        key: function key() {
	          return 1;
	        }
	      },
	      ContactGrabber_grab: {
	        key: function key() {
	          return 1;
	        },
	
	        on: {
	          succeeded: function succeeded(data, key) {
	            this.props.onClose(data, key);
	          }
	        }
	      }
	    };
	  },
	
	  __onServiceChange: function __onServiceChange(e) {
	    this.setState({ service: e.target.value, has_searched_yet: false });
	  },
	  __onSubmit: function __onSubmit(data) {
	    var event = this.props.event;
	
	    var service = this.state.service;
	    localStorage.setItem("default_grab_service", service);
	    radio("ContactGrabber_search").broadcast({
	      grabservice: service,
	      searchtext: data.search,
	      sids: event.sids
	    });
	    this.setState({ has_searched_yet: true });
	  },
	  __onSelected: function __onSelected(contact_id) {
	    var event = this.props.event;
	
	    var service = this.state.service;
	    radio("ContactGrabber_grab").broadcast({
	      grabservice: service,
	      contactid: contact_id,
	      sids: event.sids
	    });
	  },
	  render: function render() {
	    var onClose = this.props.onClose;
	
	    var service = this.state.service;
	    var ajax_grab = this.state.ContactGrabber_grab;
	    var ajax_search = this.state.ContactGrabber_search;
	
	    if (_.includes(Constants.GRAB_SERVICES_not_yet_supported, service)) {
	      return ComingSoonModal({ service: service, onClose: onClose });
	    }
	    if (service === "MAC_CONTACTS") {
	      return MacContactsModal({ service: service, onClose: onClose });
	    }
	    // if(service === "GOOGLEAPI"){
	    // 	return DeprecatedModal({service: service, onClose: onClose});
	    // }
	
	    return Modal({
	      title: "Grab a " + Constants.GRAB_SERVICES[service] + (/contact/i.test(Constants.GRAB_SERVICES[service]) ? "" : " contact"),
	      buttons: [],
	      onClose: onClose
	    }, LoadingWrap({
	      is_loading: ajax_search.waiting || ajax_grab.waiting,
	      text: ajax_grab.waiting ? "Copying Contact to Event..." : "Searching..."
	    }, ErrorAlert({ message: ajax_grab.error }), ErrorAlert({ message: ajax_search.error }), dd.div({ className: "form-inline" }, dd.div({ className: "form-group" }, dd.label({ style: { marginRight: 10 } }, "Grab from CRM"), dd.select({
	      className: "form-control",
	      value: service,
	      onChange: this.__onServiceChange
	    }, _.map(Constants.GRAB_SERVICES, function (label, key) {
	      return dd.option({ key: key, value: key }, label);
	    })))), SearchForm({ onSubmit: this.__onSubmit }), this.state.has_searched_yet ? ContactList({
	      contacts: ajax_search.data,
	      onSelected: this.__onSelected
	    }) : null));
	  }
	});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This version of the ModalWrap does not animate, which makes it more tolerant of bad HTML
	 * elsewhere on the page (as when messages are showing, which may contain wild HTML tags).
	 *
	 */
	exports.default = _react2.default.createClass({
	  displayName: "ModalWrap",
	
	  propTypes: {
	    body: _react2.default.PropTypes.node
	  },
	
	  componentWillMount: function componentWillMount() {},
	
	  render: function render(props) {
	    var body = this.props.body;
	
	    var animate_classes = "fade in";
	    var display = "block";
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "modal " + animate_classes,
	          tabIndex: -1,
	          role: "dialog",
	          style: { display: display }
	        },
	        body
	      ),
	      _react2.default.createElement("div", {
	        className: "modal-backdrop " + animate_classes,
	        style: { display: display }
	      })
	    );
	  }
	});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var AuthedUserSession = __webpack_require__(4);
	var is_pl = _.get(AuthedUserSession, ["is_privatelabel"], false);
	var private_label_code = _.get(AuthedUserSession, ["privatelabel_code"]);
	var pl_logo = _.get(AuthedUserSession, ["activeCompany", "LOGO"], is_pl ? "logo-" + private_label_code + ".png" : "logo-main.png");
	var is_beta = AuthedUserSession.is_beta;
	
	module.exports = {
	  logo: is_pl ? "/myevents/img/" + pl_logo : "/myevents/img/logo-" + (is_beta ? "beta" : "main") + ".png",
	  mp_logo: "/myevents/img/mp_logo.png",
	  event_placeholder: is_pl ? "/myevents/img/event_placeholder_no_mp.png" : "/myevents/img/event_placeholder.png?v3"
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = function (Displaylists, sids) {
	  var company_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var common_actionlist_sid = _.get(Displaylists, "universal.USE_COMMON_ACTIONLISTS_SID");
	  var my_speakers = getSpeakersFromDisplaylists(Displaylists, sids, common_actionlist_sid);
	
	  if (AuthedUserSession.is_st_family) {
	    //TEAM-ADMIN privatelabels using only common actionlists
	    var r = _.get(Displaylists, ["universal", "todolists", company_id, "lists"], []);
	    r = _.map(r, function (todolist) {
	      return [todolist.id, todolist.listname];
	    });
	    r = _.object(r);
	    return r;
	  } else {
	    //normal, per-speaker actionlists combined with shared lists
	    var _r = _.flatten(_.map(my_speakers, function (spkr) {
	      return _.map(_.get(spkr, ["todolists"]), function (todolist) {
	        return [_.get(todolist, ["id"]), _.get(todolist, ["listname"]) + (_.get(spkr, ["sid"]) === common_actionlist_sid ? " (shared)" : "")];
	      });
	    }));
	    var shared = _.map(_.get(Displaylists, ["universal", "todolists", company_id, "lists"], []), function (todolist) {
	      return [_.get(todolist, ["id"]), _.get(todolist, ["listname"]) + " (shared)"];
	    });
	    _r = _.object(_.union(_r, shared));
	    return _r;
	  }
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	var OFFER_STATII = [null, "unread message", "waiting client", "waiting you", "offer accepted", "deposit paid", "paid in full", "event completed", "reviewed"]; //order of priority is important; the names are magic (if you change them you'll need to search & replace)
	
	
	/**
	 * For data formatted as a "job"
	 *
	 * @param job
	 * @param returnNumeric
	 * @returns {number}
	 */
	var status = function status(job) {
	    var returnNumeric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	    var n_unread = _.get(job, "my_info.n_unread", 0);
	    var status = 0;
	
	    if (n_unread > 0) status = 1; //"unread message";
	
	    if (_.get(job, "my_info.mp_agreement", null)) {
	        var signed_b = _.get(job, "my_info.mp_agreement.buyer_signed", false);
	        var signed_s = _.get(job, "my_info.mp_agreement.speaker_signed", false);
	        var is_accepted = _.get(job, "my_info.mp_agreement.is_accepted", false);
	
	        if (is_accepted) {
	            status = _.max([status, 4]); //"offer accepted";
	            if (_.get(job, "my_info.mp_agreement.is_deposit_paid", false)) status = _.max([status, 5]);
	            if (_.get(job, "my_info.mp_agreement.is_balance_paid", false)) status = _.max([status, 6]);
	        } else if (signed_b && !signed_s) {
	            status = _.max([status, 3]); //"waiting you"
	        } else if (!signed_b && signed_s) {
	            status = _.max([status, 2]); //"waiting client"
	        }
	    }
	
	    return returnNumeric ? status : this.OFFER_STATII[status];
	};
	
	/**
	 * For data formatted as an "event"
	 *
	 * @param event
	 * @param sid
	 * @param returnNumeric
	 * @returns {number}
	 */
	var statusForEvent = function statusForEvent(event, sid) {
	    var returnNumeric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	
	    var status = 0;
	
	    if (_.get(event, ["MPAgreement", sid], false)) {
	        if ((_.get(event, ["MPAgreement", sid, "flags"], 0) & 1) > 0) {
	            //flag "1" means "speaker initiated offer"
	            status = 2;
	        } else {
	            status = 3;
	        }
	        if (_.get(event, ["MPAgreement", sid, "is_accepted"], false)) {
	            status = 4;
	
	            if (_.get(event, ["MPPaymentStatus", sid, "deposit"], false)) status = _.max([5, status]);
	            if (_.get(event, ["MPPaymentStatus", sid, "balance"], false)) status = _.max([6, status]);
	        }
	
	        if (status >= 5) {
	            var tomorrow = new Date();
	            tomorrow.setDate(tomorrow.getDate() + 1);
	
	            if (_.get(event, "startdate", 0) >= tomorrow) status = 7; //completed
	        }
	    }
	    return returnNumeric ? status : this.OFFER_STATII[status];
	};
	module.exports = {
	    OFFER_STATII: OFFER_STATII,
	    status: status,
	    statusForEvent: statusForEvent
	};
	
	/**
	 'IS_ROYALTY'        => array(1, 'is a royalty payment'),
	 'MP_LINEITEM'       => array(2, 'is a marketplace line item'),
	 'BILL_LATER'        => array(4, 'is a bill later/actual price (i.e. travel expense)'), //used to be called FEE_TO_BE_DECIDED_LATER
	 'FREE'              => array(8, 'is billed as a free item'),
	 'IS_DEPOSIT'        => array(16, 'billed up front'),
	 'IS_COMMISSIONABLE' => array(32, 'Is a commissionable fee'),
	 'TRAVEL'            => array(64, 'This is a travel fee'),
	 'MATERIALS'         => array(128, 'This is a materials fee'),
	 'BALANCE'           => array(256, 'This is the balance due after any deposits'),
	 'PAYMENT'           => array(512, 'This is a payment against the total amount'), //? DEPRECATED
	 'SPEAKING_FEE'      => array(1024, 'This is the main speaking fee. Use in conjuction with IS_DEPOSIT or BALANCE')
	 **/

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = function(fn){
	  return function(e){
	    if(e && e.preventDefault){
	      e.preventDefault();
	    }
	    if(e && e.stopPropagation){
	      e.stopPropagation();
	    }
	    fn.call(this, e);
	  };
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	
	var placeholder_value = '__some$random$uuid__';
	
	var component = dd.createClass({
	  __onChange: function(e){
	    var field = this.props.field;
	    var new_value = e.target.value;
	    this.props.onChange(_.has(field.options, new_value) ? new_value : null);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = _.has(field.options, this.props.value) ? this.props.value : (field.placeholder ? placeholder_value : '');
	
	    if(field.read_only){
	      return dd.p({className: 'form-control-static'},
	        _.has(field.options, value) ? field.options[value] : (value === placeholder_value ? null : value)
	      );
	    }
	
	    var options = _.pairs(field.options);
	    if(!field.dont_sort_options){
	      options = _.sortBy(options, function(option){
	        return _.isString(option[1]) ? option[1].toUpperCase() : 0;
	      });
	    }
	
	    return dd.select({
	        name: field.name,
	        value: value,
	        onChange: this.__onChange,
	        disabled: field.disabled ? 'disabled' : null,
	        className: 'form-control' + (field.disabled ? ' disabled' : '')
	      },
	      dd.option({value: placeholder_value}, field.placeholder ? field.placeholder : ''),
	      _.map(options, function(option){
	        return dd.option({value: option[0], key: option[0]}, option[1]);
	      })
	    );
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function(value, field){
	    if(!_.has(field.options, value)){
	      return 'Please make a selection';
	    }
	    return true;
	  }
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(72);
	
	module.exports = {
	  componentDidMount: function(){
	    if(!this.Radio_setup){
	      console.warn("RadioMixin expects you to define a method called Radio_setup");
	      return;
	    }
	    this.__Radio_unsubscribe_fns = [];
	    var s = this.Radio_setup();
	    var self = this;
	    Object.keys(s).forEach(function(chanel){
	      var fn = function(){
	        s[chanel].apply(self, arguments);
	      };
	      radio(chanel).subscribe(fn);
	      self.__Radio_unsubscribe_fns.push(function(){
	        radio(chanel).unsubscribe(fn);
	      });
	    });
	  },
	  componentWillUnmount: function(){
	    this.__Radio_unsubscribe_fns.forEach(function(fn){
	      fn();
	    });
	  }
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(48);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var ReactPerf = __webpack_require__(39);
	
	var quoteAttributeValueForBrowser = __webpack_require__(499);
	var warning = __webpack_require__(16);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(169);
	var ReactPropTypeLocations = __webpack_require__(76);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(104);
	var ReactMount = __webpack_require__(31);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(149);
	var DOMPropertyOperations = __webpack_require__(100);
	var ReactMount = __webpack_require__(31);
	var ReactPerf = __webpack_require__(39);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.3';

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactMount = __webpack_require__(31);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(460);
	var ReactEmptyComponent = __webpack_require__(161);
	var ReactNativeComponent = __webpack_require__(167);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	var escapeTextContentForBrowser = __webpack_require__(80);
	var setInnerHTML = __webpack_require__(81);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceHandles = __webpack_require__(57);
	
	var getIteratorFn = __webpack_require__(111);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	var warning = __webpack_require__(16);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var esUtils = __webpack_require__(2);
	var HoverMixin = __webpack_require__(49);
	
	module.exports = dd.createClass({
		mixins: [HoverMixin],
		not_relative_to_parent_bounding_rect: true,
		__onClick: esUtils.wrapPreventDefault(function(){}),
		render: function(){
			return dd.a({
					className: 'HelpTooltip',
					href: '#',
					style: {position: 'relative'},
					onMouseEnter: this.hoverable_onMouseEnter,
					onMouseLeave: this.hoverable_onMouseLeave,
					onClick: this.__onClick
				},
				dd.i({className: 'fa fa-question-circle'}),
				dd.div({className: 'popover top', ref: 'hoverable', style: {
						display: this.state.hover ? 'block' : 'none',//hide show so that we can keep access to the dom node's width height in componentDidUpdate
						width: this.props.content ? Math.max(70, this.props.content.length * 14) + 'px' : 'auto',//aprox the width for the content, note that .popover class sets a max-width, so no worries
						top: this.state.hoverable_top + 'px',
						left: this.state.hoverable_left + 'px',
	
						//normalizing styles (so parent font styling doesn't mess with this)
						fontSize: '14px',
						color: 'black',
						textAlign: 'left',
						fontWeight: 'normal'
					}},
					dd.div({className: 'arrow'}),
					this.props.title ? dd.h3({className: 'popover-title'}, this.props.title) : '',
					this.props.content ? dd.div({className: 'popover-content'}, this.props.content) : ''
				)
			);
		}
	});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	
	var getEventClass = function getEventClass(day_event) {
	  return !day_event ? '' : day_event.type == 'event' ? day_event.sta : day_event.type;
	};
	
	var getEventIcon = function getEventIcon(day_event) {
	  if (day_event.type == 'flight') {
	    return dd.i({ className: 'fa fa-plane' });
	  } else if (day_event.type == 'ground') {
	    return dd.i({ className: 'fa fa-car' });
	  } else if (day_event.type == 'daily') {
	    return dd.i({ className: 'fa fa-calendar-o' });
	  } else if (day_event.type == 'call') {
	    return dd.i({ className: 'fa fa-phone' });
	  } else if (day_event.type == 'coaching') {
	    return dd.i({ className: 'fa fa-video-camera' });
	  } else if (day_event.type == 'event') {
	    return dd.i({ className: 'fa fa-circle' });
	  }
	  return null;
	};
	
	var getEventURL = function getEventURL(event) {
	  var url = event.eid > 0 ? '#/events/' + event.eid : null;
	  if (url) {
	    if (event.type === 'call') {
	      url += '/contacts';
	    } else if (event.type === 'coaching') {
	      url += '/coaching';
	    } else if (event.type === 'flight') {
	      url += '/travel';
	    } else if (event.type === 'ground') {
	      url += '/travel';
	    }
	  }
	  return url;
	};
	
	var getEventText = function getEventText(event) {
	  var venue_parts = [];
	  if (event.vcty) {
	    venue_parts.push(event.vcty);
	  }
	  if (event.vst) {
	    venue_parts.push(event.vst);
	  }
	  if (event.vcnt) {
	    venue_parts.push(event.vcnt);
	  }
	  var text = esUtils.isBlank(event.desc) ? "" : event.desc;
	  if (venue_parts.length > 0) {
	    text += " - " + venue_parts.join(', ');
	  }
	  return text;
	};
	
	module.exports = {
	  getEventClass: getEventClass,
	  getEventIcon: getEventIcon,
	  getEventURL: getEventURL,
	  getEventText: getEventText,
	  getEventHash: function getEventHash(event) {
	    //This is just to help you decide if the event items are talking about the same thing
	    return [event.type, getEventURL(event), getEventText(event)].join("-");
	  }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	var last_char = "\xFF"; //when sorting stings, this is the last one
	
	var groupBySids = function groupBySids(items) {
	  var by_sid = {};
	  _.each(items, function (item) {
	    var sids = _.size(item.sids) > 0 ? item.sids : ["-no-sids-"];
	    _.each(sids, function (sid) {
	      if (!_.has(by_sid, sid)) {
	        by_sid[sid] = [];
	      }
	      by_sid[sid].push(item);
	    });
	  });
	  return by_sid;
	};
	
	var MenuItem = dd.createClass({
	  __clickItem: function __clickItem(fn) {
	    return !_.isFunction(fn) ? null : esUtils.wrapPreventDefault(fn);
	  },
	  render: function render() {
	    var _props = this.props,
	        item = _props.item,
	        speaker_name = _props.speaker_name;
	
	
	    return dd.li({ role: "presentation" }, dd[item.onClick ? "a" : "span"]({
	      role: "menuitem",
	      tabIndex: "-1",
	      className: (item.className || "") + (speaker_name ? " has-speaker-name" : ""),
	      href: item.onClick ? "#" : null,
	      onClick: item.onClick ? this.__clickItem(item.onClick) : null
	    }, speaker_name ? dd.b({
	      className: "speaker-name"
	    }, speaker_name) : null, item.icon ? item.icon : null, dd.span({ className: "item-name" }, item.name)));
	  }
	});
	
	var speakerAbbreviatedName = function speakerAbbreviatedName(spkr) {
	  if (AuthedUserSession.is_st_family) {
	    if (!_.isEmpty(_.get(spkr, "name_first")) && !_.isEmpty(_.get(spkr, "name_last"))) {
	      return _.get(spkr, "name_last") + ", " + _.get(spkr, "name_first").substring(0, 1);
	    }
	    return _.get(spkr, "name_full");
	  } else {
	    if (!_.isEmpty(_.get(spkr, "name_first")) && !_.isEmpty(_.get(spkr, "name_last"))) {
	      return _.get(spkr, "name_first") + " " + _.get(spkr, "name_last");
	    }
	    return _.get(spkr, "name_full");
	  }
	};
	
	var getAbbreviatedNamesBySid = function getAbbreviatedNamesBySid(Displaylists) {
	  return _.object(_.compact(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
	    var name = speakerAbbreviatedName(spkr);
	    return _.isEmpty(name) ? null : [spkr.sid, name];
	  })));
	};
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { popover_top: 0, popover_left: 0 };
	  },
	  componentDidMount: function componentDidMount() {
	    this.__setup_position();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.__setup_position();
	  },
	  __setup_position: function __setup_position() {
	    var dom_node = this.refs.popover;
	    if (!dom_node) {
	      return;
	    }
	    var width_factor = _.isNumber(this.props.width_factor) ? this.props.width_factor : 0.75;
	    var height_factor = _.isNumber(this.props.height_factor) ? this.props.height_factor : 0.5;
	
	    var parentNode = dom_node.parentNode;
	    var rect = parentNode.getBoundingClientRect();
	    var parent_width = Math.max(0, parentNode.offsetWidth);
	    var parent_height = Math.max(0, parentNode.offsetHeight);
	    var h = Math.max(0, dom_node.offsetHeight);
	    var top = rect.top - h / 2 + parent_height * height_factor + "px";
	    var left = rect.left + parent_width * width_factor + "px";
	    if (top !== this.state.popover_top || left !== this.state.popover_left) {
	      this.setState({ popover_top: top, popover_left: left }); //only make changes when needed so we don't get into a loop
	    }
	  },
	
	  __onScroll: esUtils.wrapPreventDefault(function (e) {
	    e.stopPropagation();
	  }),
	  render: function render() {
	    var _props2 = this.props,
	        items = _props2.items,
	        Displaylists = _props2.Displaylists,
	        is_multi_sid_mode = _props2.is_multi_sid_mode,
	        empire_mode = _props2.empire_mode;
	
	    var items_by_sid = groupBySids(items);
	    var spkrname_by_sid = getAbbreviatedNamesBySid(Displaylists);
	
	    var menu_items = _.flatten(_.map(items_by_sid, function (items, sid) {
	      var speaker_name = is_multi_sid_mode || empire_mode ? spkrname_by_sid[sid] : null;
	      return _.map(items, function (item, i) {
	        return {
	          elm: MenuItem({
	            key: sid + "-" + i,
	            item: item,
	            speaker_name: speaker_name,
	            empire_mode: empire_mode
	          }),
	          sort_key: sid === "-no-sids-" ? last_char + last_char + last_char : (speaker_name || last_char) + item.name
	        };
	      }, this);
	    }, this));
	
	    return dd.div({
	      className: "DayPopover popover right",
	      ref: "popover",
	      style: {
	        position: "fixed",
	        display: "block",
	        top: this.state.popover_top,
	        left: this.state.popover_left,
	        bottom: "auto",
	        right: "auto",
	        maxWidth: "none",
	
	        //normalizing styles (so parent font styling doesn't mess with this)
	        fontSize: 14,
	        color: "black",
	        textAlign: "left",
	        fontWeight: "normal"
	      }
	    }, dd.div({ className: "arrow" }), dd.ul({ className: "dropdown-menu", role: "menu", onScroll: this.__onScroll }, _.map(_.sortBy(menu_items, function (_ref) {
	      var sort_key = _ref.sort_key;
	
	      return sort_key.trim().toLowerCase();
	    }), "elm")));
	  }
	});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var AuthedUserSession = __webpack_require__(4);
	
	var Form = dd.createClass({
	  mixins: [FormMixin, RadioMixin],
	  getInitialState: function getInitialState() {
	    return { advanced_expanded: false };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      'EventSearchAside_open': function EventSearchAside_open(action) {
	        if (action === 'show_advanced') {
	          self.setState({ advanced_expanded: true });
	        }
	      }
	    };
	  },
	  getInitialValues: function getInitialValues(props) {
	    var query = props.query;
	    if (!query) {
	      return null;
	    }
	    return {
	      searchterm: query.searchterm || null,
	      deepsearch: !!query.deepsearch,
	      includecanceled: _.isArray(query.exclude_event_types) && !_.includes(query.exclude_event_types, Constants.EVENT_STATUSES.canceled),
	      cross_companies: !!query.cross_companies,
	      datelessonly: !!query.datelessonly,
	      futureonly: !!query.futureonly,
	      marketplaceonly: !!query.marketplaceonly,
	      speaker_select: _.isArray(query.sids) && query.sids.length > 0 ? _.first(query.sids) : -1,
	      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"])
	    };
	  },
	  buildFields: function buildFields() {
	    var my_speaker_names_by_sid = this.props.my_speaker_names_by_sid;
	
	    var fields = {
	      searchterm: {
	        type: 'text',
	        placeholder: 'Search',
	        validate: function validate() {
	          return true; //accepts searches w/o a query
	        }
	      },
	      deepsearch: {
	        label: 'deep search',
	        type: 'checkbox'
	      },
	      includecanceled: {
	        label: 'include canceled',
	        type: 'checkbox'
	      },
	      datelessonly: {
	        label: 'only dateless events',
	        type: 'checkbox'
	      },
	      futureonly: {
	        label: 'only future events',
	        type: 'checkbox'
	      }
	      // cross_companies: {
	      //   label: 'other companies',
	      //   type: 'checkbox'
	      // }
	    };
	    if (!AuthedUserSession.is_privatelabel) {
	      fields.marketplaceonly = {
	        label: 'marketplace only',
	        type: 'checkbox'
	      };
	    }
	    if (AuthedUserSession.is_privatelabel) {
	      fields.cross_company = {
	        label: 'other companies',
	        type: 'checkbox'
	      };
	    }
	
	    if (_.keys(my_speaker_names_by_sid).length > 1) {
	      fields.speaker_select = {
	        type: 'select',
	        placeholder: '-- all speakers --',
	        options: my_speaker_names_by_sid,
	        validate: function validate() {
	          return true; //optional
	        }
	      };
	    }
	    return fields;
	  },
	
	  __toggleAdvanced: esUtils.wrapPreventDefault(function () {
	    this.setState({ advanced_expanded: !this.state.advanced_expanded });
	  }),
	  __open_n_show_advanced: esUtils.wrapPreventDefault(function () {
	    radio('EventSearchAside_open').broadcast('show_advanced');
	    setTimeout(function () {
	      radio('EventSearchAside_open').broadcast('show_advanced');
	    }, 100); //need to broadcast again after it's visible so that it'll be listening this time
	  }),
	  __changeTriggersSearch: _.debounce(function () {
	    this._form_onSubmit({ preventDefault: _.noop });
	  }, 1000),
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    if (field_path !== 'searchterm') {
	      this.__changeTriggersSearch();
	    }
	  },
	  render: function render() {
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var advanced_expanded = this.state.advanced_expanded;
	    var mini_form = this.props.mini_form;
	    var status_text = this.props.status_text;
	
	    return dd.form({ role: 'search', onSubmit: this._form_onSubmit }, dd.div({ className: 'form-group' + (errors['searchterm'] ? ' has-error' : ''), style: { marginBottom: 0 } }, dd.div({ className: 'input-group' }, this._form_buildInput(fields.searchterm, 'searchterm'), dd.span({ className: 'input-group-btn' }, dd.button({ type: 'submit', className: 'btn btn-default' }, dd.i({ className: 'fa fa-search' })), mini_form ? dd.button({
	      className: 'btn btn-default',
	      onClick: this.__open_n_show_advanced
	    }, dd.i({ className: 'fa fa-gear' })) : null))), mini_form ? null : dd.div({ style: { marginTop: 5 } }, dd.span({ className: 'pull-right' }, status_text), dd.a({ href: '#', onClick: this.__toggleAdvanced }, 'advanced ', dd.i({ className: 'fa fa-caret-' + (advanced_expanded ? 'up' : 'down') })), advanced_expanded ? dd.div(null, dd.div(null, _.map(_.filter(_.keys(fields), function (name) {
	      return fields[name].type === 'checkbox';
	    }), function (name) {
	      return dd.div({ className: 'checkbox', key: name }, this._form_buildInput(fields[name], name));
	    }, this), dd.div({ className: 'clearfix' })), fields.speaker_select ? this._form_buildInput(fields.speaker_select, 'speaker_select') : null) : null));
	  }
	});
	
	module.exports = dd.createClass({
	  __onSubmit: function __onSubmit(data) {
	    var q = {
	      searchterm: data.searchterm,
	      deepsearch: !!data.deepsearch,
	      marketplaceonly: !!data.marketplaceonly,
	      datelessonly: !!data.datelessonly,
	      cross_companies: !!data.cross_companies,
	      company_ids: data.company_ids,
	      futureonly: !!data.futureonly,
	      exclude_event_types: [Constants.EVENT_STATUSES.zimbra]
	    };
	    if (data.speaker_select > 0) {
	      q.sids = [data.speaker_select];
	    } else if (this.props.mini_form && this.props.default_filter_to_sid > 0) {
	      q.sids = [this.props.default_filter_to_sid];
	    }
	    if (!data.includecanceled) {
	      q.exclude_event_types.push(Constants.EVENT_STATUSES.canceled);
	    }
	    radio('EventSearchAside_search').broadcast(q);
	  },
	  render: function render() {
	    var _props = this.props,
	        results = _props.results,
	        loading = _props.loading,
	        error_msg = _props.error_msg;
	
	
	    var status_text = null;
	    if (error_msg) {
	      status_text = 'error';
	    } else if (loading) {
	      status_text = 'searching...';
	    } else if (_.isArray(results)) {
	      if (_.size(results) === 1) {
	        status_text = "1 result";
	      } else if (_.size(results) > 1) {
	        status_text = _.size(results) + " results";
	      } else {
	        status_text = 'no results';
	      }
	    }
	
	    return Form({
	      query: this.props.query,
	      status_text: status_text,
	      onSubmit: this.__onSubmit,
	      mini_form: this.props.mini_form,
	      my_speaker_names_by_sid: this.props.my_speaker_names_by_sid
	    });
	  }
	});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	var removeTime = function removeTime(d_orig) {
		var d = new Date();
		d.setTime(0);
		// We have to set the date in this order (Year -> Date -> Month) to account for
		// leap years because in most years setting the date to February 29th results
		// in it being March 1st
		d.setFullYear(d_orig.getFullYear());
		d.setDate(d_orig.getDate());
		d.setMonth(d_orig.getMonth());
		return d;
	};
	
	var getDate = function getDate(o, key) {
		if (_.isDate(o && o[key]) && !_.isNaN(o[key].getTime())) {
			return removeTime(o[key]);
		}
		return undefined;
	};
	
	module.exports = function (result) {
		var start = getDate(result, 'stagetime_starttime');
		var stop = getDate(result, 'stagetime_stoptime');
	
		if (!start && !stop) {
			return [];
		} else if (start && !stop) {
			return [start];
		} else if (!start && stop) {
			return [stop];
		} else if (start > stop) {
			var tmp = start;
			start = stop;
			stop = tmp;
		}
	
		var r = [];
		while (start < stop) {
			r.push(new Date(start));
			start.setDate(start.getDate() + 1);
		}
		r.push(new Date(stop));
	
		return r;
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	
	module.exports = dd.createClass({
		render: function render() {
			var event = this.props.event;
	
			if (!event || !event.accountinglocked) {
				return dd.span();
			}
			return dd.div({ className: "alert alert-warning" }, dd.i({ className: "fa fa-lock" }), " Be advised this event is accounting-locked.");
		}
	});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var React = __webpack_require__(15);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	/**
	 * THIS LOGIC IS DUPLICATED IN include/class.Event.php,
	 * so if you make changes here, you need to make the same changes there.
	 *
	 * For a particular todomaster item, create a todoevent item set correctly for this event.
	 *
	 * @param event
	 * @param master_list
	 * @returns {{eid, from_list_id: *, vieworder, id: number}}
	 */
	var masterlistToEventTodo = function masterlistToEventTodo(event, master_list) {
	  var new_todo = {
	    id: 0,
	    eid: event.eid,
	    from_list_id: master_list.id > 1 ? master_list.id : master_list._list_id,
	    vieworder: master_list.vieworder,
	    action_type: master_list.action_type,
	    todomaster_id: master_list._todo_id,
	    email_recipient_group: _.isString(master_list.email_recipient_group) ? master_list.email_recipient_group : "",
	    action_foreign_id: master_list.action_foreign_id
	  };
	  new_todo.description = master_list.description;
	  if (master_list.duebasedon === "STRT") {
	    //STRT - event start date
	    new_todo.statusdate = _.isDate(event.starttime) ? new Date(event.starttime.getTime()) : new Date();
	  } else if (master_list.duebasedon === "STAT") {
	    //STAT - event status change date (which is now)
	    new_todo.statusdate = new Date();
	  } else {
	    new_todo.statusdate = null;
	  }
	  if (_.isDate(new_todo.statusdate) && _.isNumber(master_list.duedelta) && !_.isNaN(master_list.duedelta)) {
	    new_todo.statusdate.setDate(new_todo.statusdate.getDate() + master_list.duedelta);
	  }
	  new_todo.assignedto = _.isString(master_list.assignedto) ? master_list.assignedto : "";
	  new_todo.assignedto = new_todo.assignedto.replace(/\[ME\]/i, AuthedUserSession.balboa && AuthedUserSession.balboa.username && AuthedUserSession.balboa.username.toUpperCase() || "me");
	  return new_todo;
	};
	
	module.exports = dd.createClass({
	  propTypes: {
	    event: React.PropTypes.object.isRequired,
	    Displaylists: React.PropTypes.object.isRequired,
	    onClose: React.PropTypes.func.isRequired,
	    list_id: React.PropTypes.number.isRequired,
	    custom_clear_message: React.PropTypes.string //optional
	  },
	  getInitialState: function getInitialState() {
	    return { should_apply_lists: null, should_clear_lists: null };
	  },
	  __hasBeenAskedToApplyLists: function __hasBeenAskedToApplyLists() {
	    var applicable_items = this.__getApplicable_items();
	    //either they clicked yes OR there are no items, thus only asked if they want to clear it
	    return null !== this.state.should_apply_lists || applicable_items.length === 0;
	  },
	  __hasBeenAskedToClearLists: function __hasBeenAskedToClearLists() {
	    var event = this.props.event;
	    //either they clicked yes OR the current list is already empty
	
	    return null !== this.state.should_clear_lists || event && _.isEmpty(event.EventTodo);
	  },
	  __getApplicable_items: function __getApplicable_items() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists,
	        list_id = _props.list_id;
	
	    var common_actionlists_sid = _.get(Displaylists, "universal.USE_COMMON_ACTIONLISTS_SID", -1);
	    var todoIds = [];
	    var master_lists = void 0;
	    if (AuthedUserSession.is_st_family) {
	      //TEAM-ADMIN privatelabels that use only shared actionlists
	
	      var event_company_id = _.get(event, "companyID", 2);
	      var todolists = _.get(Displaylists, ["universal", "todolists", event_company_id, "lists"], []);
	      todolists = _.filter(todolists, function (todolist) {
	        return _.get(todolist, ["id"]) == list_id;
	      });
	      master_lists = _.map(todolists, function (todolist) {
	        return _.map(_.get(todolist, ["masters"]), function (master_list, id) {
	          master_list._todo_id = id;
	          master_list._sid = common_actionlists_sid;
	          master_list._list_id = _.get(todolist, ["id"]);
	          return master_list;
	        });
	      });
	      master_lists = _.flatten(master_lists);
	    } else if (AuthedUserSession.is_cs) {
	      // CS uses universal and speaker action lists
	      // get the universal lists
	      var _event_company_id = _.get(event, "companyID", 2);
	      var common_todolists = _.map(_.filter(_.get(Displaylists, ["universal", "todolists", _event_company_id, "lists"], []), function (todolist) {
	        return _.get(todolist, ["id"]) == list_id;
	      }), function (todolist) {
	        return _.map(_.get(todolist, ["masters"]), function (master_list, id) {
	          master_list._todo_id = id;
	          master_list._sid = common_actionlists_sid;
	          master_list._list_id = _.get(todolist, ["id"]);
	          return master_list;
	        });
	      });
	      // get the lists for a speaker
	      var speaker_todolists = _.map(_.filter(_.get(Displaylists, "perspeaker"), function (spkr) {
	        return _.includes(event.sids, spkr.sid) || spkr.sid == common_actionlists_sid;
	      }), function (spkr) {
	        return _.map(_.filter(spkr.todolists, function (todolist) {
	          return _.get(todolist, ["id"]) == list_id;
	        }), function (todolist) {
	          return _.map(_.get(todolist, ["masters"]), function (master_list, id) {
	            master_list._todo_id = id;
	            master_list._sid = spkr.sid;
	            master_list._list_id = _.get(todolist, ["id"]);
	            return master_list;
	          });
	        });
	      });
	
	      master_lists = _.flattenDeep([].concat(common_todolists, speaker_todolists));
	    } else {
	      // trunk get the lists for a speaker
	      var _speaker_todolists = _.map(_.filter(_.get(Displaylists, "perspeaker"), function (spkr) {
	        return _.includes(event.sids, spkr.sid) || spkr.sid == common_actionlists_sid;
	      }), function (spkr) {
	        return _.map(_.filter(spkr.todolists, function (todolist) {
	          return _.get(todolist, ["id"]) == list_id;
	        }), function (todolist) {
	          return _.map(_.get(todolist, ["masters"]), function (master_list, id) {
	            master_list._todo_id = id;
	            master_list._sid = spkr.sid;
	            master_list._list_id = _.get(todolist, ["id"]);
	            return master_list;
	          });
	        });
	      });
	
	      master_lists = _.flattenDeep([].concat(_speaker_todolists));
	    }
	
	    var applied_ids = [];
	    var master_lists_cleaned = [];
	    _.each(master_lists, function (each) {
	      if (!_.includes(applied_ids, each._todo_id)) {
	        master_lists_cleaned.push(each);
	        applied_ids.push(each._todo_id);
	      }
	    });
	
	    var status_map = _.object(_.map(Displaylists && Displaylists.universal && Displaylists.universal.eventstatuses, function (status) {
	      return [status.id, status.description];
	    }));
	    return _.filter(master_lists_cleaned, function (master) {
	      if (master.activateonstatus == -1) {
	        return true;
	      }
	      return event.status == status_map[master.activateonstatus];
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    //once all the choices are made, apply them
	    if (this.__hasBeenAskedToApplyLists() && this.__hasBeenAskedToClearLists()) {
	      this.__applyList();
	    }
	  },
	
	  /**
	   * Apply the selected actionlist to this event, setting each item appropriately
	   * based on this event's date, etc.
	   *
	   * @private
	   */
	  __applyList: function __applyList() {
	    var event = _.cloneDeep(this.props.event);
	    var list_id = this.props.list_id; //Displaylists
	
	    var applicable_items = this.state.should_apply_lists ? this.__getApplicable_items() : [];
	    var originalTodolistids = event.todolistids;
	    var needsSave = false;
	
	    if (this.state.should_clear_lists || !_.isArray(event.EventTodo)) {
	      event.EventTodo = [];
	      needsSave = true;
	    }
	    //iterate over each item in the new list and create a todoevent item for this event
	    _.each(applicable_items, function (master_list) {
	      event.EventTodo.push(masterlistToEventTodo(event, master_list));
	      needsSave = true;
	    });
	
	    //allow multiple actionlists per event
	    /*
	         if (!_.isArray(event.todolistids)) {
	         event.todolistids = [];
	         }
	         let my_sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, 'sid'));
	         _.each(_.intersection(event.sids, my_sids), function (sid) {
	         let alreadyInList = false;
	         _.each(event.todolistids, function (list) {
	         if ((list.sid == sid) && (list.listid == list_id)) {
	         alreadyInList = true;
	         }
	         });
	         if (!alreadyInList) {
	         event.todolistids.push({sid: parseInt(list_sid, 10), listid: parseInt(list_id, 10)});
	         }
	         });
	         */
	
	    //single Actionlist per event
	    event.todolistids = [_.parseInt(list_id)]; //must be integers
	
	    needsSave = needsSave || !_.isEqual(originalTodolistids, event.todolistids);
	    if (needsSave) {
	      radio("save_Event").broadcast(event);
	    }
	    this.props.onClose(); //close it b/c the event details area will handle applying these changes
	  },
	
	  __onYesApply: esUtils.wrapPreventDefault(function () {
	    //componentDidUpdate() takes care of applying once all the choices are made
	    this.setState({ should_apply_lists: true });
	  }),
	  __onNoApply: esUtils.wrapPreventDefault(function () {
	    this.setState({ should_apply_lists: false });
	  }),
	  __onYesClear: esUtils.wrapPreventDefault(function () {
	    this.setState({ should_clear_lists: true });
	  }),
	  __onNoClear: esUtils.wrapPreventDefault(function () {
	    this.setState({ should_clear_lists: false });
	  }),
	
	  render: function render() {
	    var _props2 = this.props,
	        event = _props2.event,
	        onClose = _props2.onClose,
	        custom_clear_message = _props2.custom_clear_message;
	
	    // This line keeps action item lists from updating if both are blank
	    // if (this.__hasBeenAskedToApplyLists() && this.__hasBeenAskedToClearLists()) return null;
	
	    var whichModal = this.__hasBeenAskedToApplyLists() ? "askclear" : "askapply";
	    var applicable_items = this.__getApplicable_items();
	
	    return Modal({
	      title: "Add action items?",
	      onClose: onClose,
	      buttons: []
	    }, dd.div({ className: "row" }, dd.div({ className: "col-sm-2" }, dd.i({
	      className: "fa fa-warning text-muted",
	      style: { fontSize: 64 }
	    })), dd.div({ className: "col-sm-10" }, whichModal == "askclear" ? dd.div(null, dd.p(null, custom_clear_message || "You are changing the action lists for this event."), dd.p(null, "Do you want to CLEAR THE CURRENT list?")) : dd.div(null, dd.p(null, "Add " + applicable_items.length + ' applicable Action Items for the status "' + event.status + '"?')))), dd.div({ className: "text-center" }, dd.button({
	      className: "btn btn-primary",
	      onClick: whichModal === "askclear" ? this.__onYesClear : this.__onYesApply
	    }, "Yes"), " ", dd.button({
	      className: "btn btn-default",
	      onClick: whichModal === "askclear" ? this.__onNoClear : this.__onNoApply
	    }, "No")));
	  }
	});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	/*global FileList */
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var RadioMixin = __webpack_require__(22);
	var ProgressBar = __webpack_require__(187);
	var HorizontalFields = __webpack_require__(23);
	var UPLOAD_FILE_NAME_ARRAY = Constants.FileStore_UPLOAD_FILE_NAME + '[]';
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { uploading: false, upload_progress: -1, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      StoredFile_save: function StoredFile_save(eid, fileid) {
	        if (self.__isThisMe(eid, fileid)) {
	          self.setState({ uploading: true, upload_progress: -1, error_msg: null });
	        }
	      },
	      StoredFile_save_progress: function StoredFile_save_progress(eid, fileid, percent) {
	        if (self.__isThisMe(eid, fileid)) {
	          self.setState({ upload_progress: percent });
	        }
	      },
	      StoredFile_save_succeeded: function StoredFile_save_succeeded(eid, fileid, storedfiles) {
	        if (self.__isThisMe(eid, fileid)) {
	          self.setState({ uploading: false, upload_progress: -1, error_msg: null });
	          self.props.onClose();
	        }
	      },
	      StoredFile_save_failed: function StoredFile_save_failed(eid, fileid, message) {
	        if (self.__isThisMe(eid, fileid)) {
	          self.setState({ uploading: false, upload_progress: -1, error_msg: 'Failed to upload file: ' + message });
	        }
	      }
	    };
	  },
	  __isThisMe: function __isThisMe(eid, fileid) {
	    return eid === (this.props.event ? this.props.event.eid : -1) && fileid === (this.props.file_id > 0 ? this.props.file_id : -1); //don't reference __getFileFromProps b/c that file will be nuked on updates
	  },
	  __getFileFromProps: function __getFileFromProps() {
	    var _props = this.props,
	        event = _props.event,
	        file_id = _props.file_id,
	        Displaylists = _props.Displaylists;
	
	    if (event) {
	      return _.find(event.storedfiles, function (storedfile) {
	        return storedfile.id === file_id;
	      });
	    }
	    return esUtils.getIn(Displaylists, ["speaker_shared", "templatefiles", file_id]);
	  },
	
	  __onSubmit: function __onSubmit(data) {
	    var file = this.__getFileFromProps();
	    var event = this.props.event;
	    var sids_to_apply_to = this.props.sids_to_apply_to;
	    radio('StoredFile_save').broadcast(event ? event.eid : -1, file ? file.id : -1, data.description, data[UPLOAD_FILE_NAME_ARRAY] ? data[UPLOAD_FILE_NAME_ARRAY] : null, sids_to_apply_to);
	  },
	  render: function render() {
	    if (this.state.uploading) {
	      return Modal({
	        title: 'Uploading...',
	        buttons: [],
	        onClose: null
	      }, ProgressBar({ percent: this.state.upload_progress }));
	    }
	    var event = this.props.event;
	    var file = this.__getFileFromProps();
	    return Modal({
	      title: event ? file ? 'Edit Attached File' : 'Attach file to event' : file ? 'Edit Template File' : 'Upload new Template',
	      buttons: [],
	      onClose: this.props.onClose
	    }, ErrorAlert({ message: this.state.error_msg }), DaForm({
	      file: file,
	      event: event,
	      file_id: this.props.file_id,
	      onClose: this.props.onClose,
	      onSubmit: this.__onSubmit,
	      Displaylists: this.props.Displaylists
	    }));
	  }
	});
	
	var DaForm = dd.createClass({
	  mixins: [FormMixin],
	  getInitialState: function getInitialState() {
	    return { clicked_edit_file: false };
	  },
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	    return (props.event ? esUtils.getEventVersionIdentifier(props.event) : -1) + '_' + props.file_id;
	  },
	  getInitialValues: function getInitialValues(props) {
	    var file = props.file;
	    if (!file) {
	      return null;
	    }
	    return {
	      description: file.description,
	      filename: file.originalfilename,
	      uploaded: file.uploadedby + ' - ' + esUtils.format_date(file.postdate, 'mm/dd/yyyy')
	    };
	  },
	  buildFields: function buildFields() {
	    var clicked_edit_file = !!this.state.clicked_edit_file;
	    var file = this.props.file;
	    var schema = {
	      description: {
	        label: 'Description',
	        type: 'text',
	        validate: function validate(v) {
	          return true;
	        }
	      }
	    };
	    if (file && !clicked_edit_file) {
	      schema.filename = {
	        label: 'File',
	        type: 'static'
	      };
	      schema.uploaded = {
	        label: 'Uploaded by',
	        type: 'static'
	      };
	    } else {
	      schema[UPLOAD_FILE_NAME_ARRAY] = {
	        label: 'File',
	        type: 'file',
	        multiple: true
	      };
	    }
	    return schema;
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    if (field_path === UPLOAD_FILE_NAME_ARRAY && new_value instanceof FileList) {
	      if (new_value.length > 1) {
	        this._form_onChange('description', '');
	      } else {
	        var file = new_value[0];
	        var data = this.state.data || {};
	        if (_.isEmpty(data.description)) {
	          var parts = /^(.*)\.[0-9a-z]+$/i.exec(file.name);
	          this._form_onChange('description', (parts && parts[1] || file.name).replace(/_/g, ' '));
	        }
	      }
	    }
	  },
	  __clickViewAndEdit: function __clickViewAndEdit(e) {
	    //NOTE we DO want it do do the default aka follow the link
	    this.setState({ clicked_edit_file: true });
	  },
	  render: function render() {
	    var file = this.props.file;
	    var data = this.state.data || {};
	    var event = this.props.event;
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var onClose = this.props.onClose;
	    var clicked_edit_file = !!this.state.clicked_edit_file;
	
	    var self = this;
	    return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
	      fields: fields,
	      errors: errors,
	      buildInput: function buildInput(field, name) {
	        if (name === 'filename') {
	          return dd.div({ className: 'form-control-static' }, data.filename, ' ', dd.a({ href: file.url, target: '_blank', onClick: self.__clickViewAndEdit }, 'Edit file'));
	        } else if (name === UPLOAD_FILE_NAME_ARRAY && clicked_edit_file) {
	          return dd.div({ style: { marginTop: 6 } }, 'After saving changes, click CHOOSE FILE below, select the changed file ("' + _.first(_.last(file.url.split('/')).split('?')) + '"), and click SAVE.', self._form_buildInput(field, name));
	        }
	        return self._form_buildInput(field, name);
	      },
	      label_size: 2
	    }), dd.div({ className: 'form-group' }, dd.div({ className: 'col-sm-10 col-sm-offset-2', style: { paddingLeft: '25px' } }, dd.small({ className: 'text-muted' }, 'To select multiple files, hold down the CTRL or SHIFT key while selecting.', dd.br(), 'If you select multiple files, the description field will be ignored.'))), HorizontalFields.FormButtons({ label_size: 2, scale: 'md', submit_btn_text: file ? 'Save' : event ? 'Attach' : 'Upload', onCancel: onClose, right_align_buttons: true }));
	  }
	});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	var sids_I_can_manage = esUtils.cleanup_ids(_.flattenDeep([AuthedUserSession.doIHaveAccess.spkr.getSIDs(), AuthedUserSession.doIHaveAccess.admin.getSIDs()]));
	
	module.exports = function (Displaylists) {
		return _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
			return _.includes(sids_I_can_manage, spkr.sid);
		});
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (props) {
	    var _getLedgerData = (0, _getLedgerData3.default)(props),
	        fees = _getLedgerData.fees,
	        grand_total = _getLedgerData.grand_total,
	        fee_speaking = _getLedgerData.fee_speaking,
	        fee_travel = _getLedgerData.fee_travel,
	        fee_materials = _getLedgerData.fee_materials;
	
	    var display_payments = _lodash2.default.get(props, 'display_payments', false);
	    var payments = pluckPayments(props.event);
	    var payment_body = null;
	
	    if (display_payments) {
	        if (_lodash2.default.isEmpty(payments)) {
	            payment_body = _react2.default.createElement(
	                "p",
	                { className: "text-muted" },
	                "- the client has not made a payment yet -"
	            );
	        } else {
	            payment_body = _lodash2.default.map(payments, function (payment, payment_id) {
	                return PaymentLine(payment);
	            });
	        }
	        payment_body = _react2.default.createElement(
	            "div",
	            { style: { color: "green", marginBottom: "1em" } },
	            _react2.default.createElement(
	                "b",
	                null,
	                "payments made by client"
	            ),
	            payment_body
	        );
	    }
	
	    var payout_body = _lodash2.default.map(_lodash2.default.groupBy(fees, "due"), function (fees, group) {
	        var total = _lodash2.default.reduce(fees, function (sum, f) {
	            return sum + f.fee;
	        }, 0);
	        return _react2.default.createElement(
	            "div",
	            { key: group, style: { marginBottom: "1em" } },
	            _react2.default.createElement(
	                "b",
	                null,
	                group
	            ),
	            _lodash2.default.map(fees, function (f, i) {
	                return _react2.default.createElement(FeeLine, { key: i, fee: f.fee, description: f.description });
	            }),
	            _react2.default.createElement("hr", { style: { margin: 0, borderColor: "#ccc" } }),
	            _react2.default.createElement(
	                "div",
	                { className: "text-muted" },
	                _react2.default.createElement(FeeLine, { fee: total, description: "to you *" })
	            )
	        );
	    });
	
	    var contractedamounts_body = _react2.default.createElement(
	        "div",
	        { style: { marginBottom: "1em" } },
	        _react2.default.createElement(
	            "b",
	            null,
	            "contracted fees"
	        ),
	        _react2.default.createElement(FeeLine, { key: "contractspeaking", fee: fee_speaking, description: "speaking fee" }),
	        _react2.default.createElement(FeeLine, { key: "contracttravel", fee: fee_travel, description: "travel" }),
	        _react2.default.createElement(FeeLine, { key: "contractmaterials", fee: fee_materials, description: "materials / other" })
	    );
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { style: {
	                    borderRadius: ".5em",
	                    background: "#eee",
	                    border: "1px solid #aaa",
	                    padding: "1em"
	                } },
	            contractedamounts_body,
	            payment_body,
	            payout_body,
	            _react2.default.createElement("hr", { style: { margin: 0, borderColor: "black" } }),
	            _react2.default.createElement(FeeLine, { fee: grand_total, description: "TOTAL to you *" }),
	            _react2.default.createElement(
	                "div",
	                { className: "text-muted", style: { marginTop: "1em" } },
	                "* less card processing costs up to 3%."
	            )
	        )
	    );
	};
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	var _getLedgerData2 = __webpack_require__(128);
	
	var _getLedgerData3 = _interopRequireDefault(_getLedgerData2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FeeLine = function FeeLine(props) {
	    var fee = props.fee,
	        description = props.description;
	
	    var amt = "$" + _lodash2.default.padLeft(_esUtils2.default.format_number(fee, 2), 11, " ");
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { style: { whiteSpace: "pre-wrap", fontFamily: "monospace", float: "left" } },
	            amt + " "
	        ),
	        _react2.default.createElement(
	            "div",
	            { style: { overflow: "hidden" } },
	            description
	        )
	    );
	};
	
	var PaymentLine = function PaymentLine(payment) {
	    var amt = "$" + _lodash2.default.padLeft(_esUtils2.default.format_number(_lodash2.default.get(payment, "amount", 0.00), 2), 11, " ");
	    return _react2.default.createElement(
	        "div",
	        { key: _lodash2.default.get(payment, "payment_id") },
	        _react2.default.createElement(
	            "div",
	            { style: { whiteSpace: "pre-wrap", fontFamily: "monospace", float: "left" } },
	            amt + " "
	        ),
	        _react2.default.createElement(
	            "div",
	            { style: { overflow: "hidden" } },
	            _lodash2.default.get(payment, "method_text") + " payment on " + _esUtils2.default.format_date(_esUtils2.default.convertFromISO8601(_lodash2.default.get(payment, "created_iso8601", null)), "mmm dd, yyyy"),
	            _lodash2.default.map(payment.flags_array, function (flag) {
	                flag = flag.replace("status_", "");
	                return _react2.default.createElement(
	                    "span",
	                    { key: _lodash2.default.get(payment, "payment_id") + flag, style: { backgroundColor: "green", color: "white", fontSize: "0.8em", padding: "1px 2px 2px 2px", marginLeft: "1em", borderRadius: "3px" } },
	                    flag
	                );
	            })
	        )
	    );
	};
	
	var pluckPayments = function pluckPayments(event) {
	    var payments = {};
	    _lodash2.default.each(_lodash2.default.get(event, "MPPaymentsUnmapped", {}), function (payment) {
	        payments[payment.id] = payment;
	    });
	
	    return payments;
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (opts) {
	    var event = opts.event,
	        Displaylists = opts.Displaylists,
	        mp_agreement = opts.mp_agreement,
	        fee_main = opts.fee_main,
	        fee_travel = opts.fee_travel,
	        fee_materials = opts.fee_materials;
	
	
	    var close_date = "payout on event date";
	    var acceptance_date = "payout on acceptance";
	
	    var commission = (0, _getMPCommissionForEvent2.default)(Displaylists, event);
	
	    var commission_desc = commission + "%";
	    var bname = _lodash2.default.get(Displaylists, ["universal", "whitelabels", event.bureauID, "bname"]);
	    if (bname) {
	        commission_desc += " " + bname;
	    }
	    commission_desc += " finder's fee";
	
	    if (mp_agreement) {
	        fee_main = 0;
	        fee_travel = 0;
	        fee_materials = 0;
	        _lodash2.default.each(mp_agreement.fees, function (f) {
	            if (f.flags_as_map.speaking_fee.is_set) {
	                fee_main += f.fee;
	            } else if (f.flags_as_map.travel.is_set) {
	                fee_travel += f.fee;
	            } else {
	                fee_materials += f.fee;
	            }
	        });
	    }
	
	    var fees = [{
	        due: acceptance_date,
	        fee: fee_main * .5,
	        description: "client pays deposit"
	    }, {
	        due: acceptance_date,
	        fee: -fee_main * (commission / 100),
	        description: commission_desc
	    }, {
	        due: close_date,
	        fee: fee_main * .5,
	        description: "client pays balance"
	    }];
	    if (fee_travel > 0) {
	        fees.push({
	            due: close_date,
	            fee: fee_travel,
	            description: "client pays travel"
	        });
	    }
	    if (fee_materials > 0) {
	        fees.push({
	            due: close_date,
	            fee: fee_materials,
	            description: "client pays materials"
	        });
	    }
	
	    var grand_total = _lodash2.default.reduce(fees, function (sum, f) {
	        return sum + f.fee;
	    }, 0);
	
	    return {
	        fees: fees,
	        grand_total: grand_total,
	        fee_speaking: fee_main, //amount the buyer pays for speaking only (not travel or material)
	        fee_materials: fee_materials,
	        fee_travel: fee_travel
	
	    };
	};
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _getMPCommissionForEvent = __webpack_require__(386);
	
	var _getMPCommissionForEvent2 = _interopRequireDefault(_getMPCommissionForEvent);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	
	module.exports = dd.createClass({
		render: function render() {
			var _props = this.props,
			    message = _props.message,
			    onYes = _props.onYes,
			    onClose = _props.onClose;
	
			return Modal({
				title: "Are you sure?",
				buttons: [{
					name: "No, never mind",
					onClick: onClose,
					className: "btn btn-default"
				}, {
					name: "Yes, I am sure",
					onClick: onYes,
					className: "btn btn-primary"
				}],
				onClose: onClose
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({
				className: "fa fa-warning text-muted",
				style: { fontSize: 100 }
			})), dd.div({ className: "col-sm-9" }, dd.p({ className: "preserve-whitespace" }, message))));
		}
	});

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    var buttons_vdom = _lodash2.default.map(props.buttons, function (btn, i) {
	        return _react2.default.createElement(
	            "button",
	            {
	                key: i,
	                type: "button",
	                className: btn.className,
	                onClick: btn.onClick
	            },
	            btn.name
	        );
	    });
	    if (_lodash2.default.isEmpty(buttons_vdom)) {
	        return _react2.default.createElement("div", null);
	    }
	    return _react2.default.createElement(
	        "div",
	        { className: "modal-footer" },
	        buttons_vdom
	    );
	};
	
	exports.default = _react2.default.createClass({
	    displayName: "ModalDialog",
	
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        onClose: _react2.default.PropTypes.func,
	        is_large: _react2.default.PropTypes.bool,
	        buttons: _react2.default.PropTypes.array
	    },
	    render: function render() {
	        var title = this.props.title;
	        var body = this.props.children;
	        var onClose = _lodash2.default.isFunction(this.props.onClose) ? this.props.onClose : undefined;
	        var is_large = !!this.props.is_large;
	
	        var buttons;
	        if (_lodash2.default.isArray(this.props.buttons)) {
	            buttons = this.props.buttons;
	            //empty array means they don't want a button footer at all
	        } else {
	            buttons = [];
	            if (onClose) {
	                buttons.push({
	                    className: "btn btn-default",
	                    name: "Close",
	                    onClick: onClose
	                });
	            }
	        }
	
	        return _react2.default.createElement(
	            "div",
	            {
	                className: "modal-dialog" + (is_large ? " modal-lg" : ""),
	                role: "document"
	            },
	            _react2.default.createElement(
	                "div",
	                { className: "modal-content" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "modal-header" },
	                    onClose ? _react2.default.createElement(
	                        "button",
	                        { type: "button", className: "close", onClick: onClose },
	                        "x"
	                    ) : null,
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "modal-title" },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "modal-body" },
	                    body
	                ),
	                _react2.default.createElement(Footer, { buttons: buttons })
	            )
	        );
	    }
	});

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var _ = __webpack_require__(1);
	var FormUtils = __webpack_require__(9);
	
	var horizontal_fields_layout = [['building'], ['address'], ['city', 'st'], ['zip', 'country'], ['phone', 'timezone'], ['fax', null]];
	
	var buildInitialValues = function buildInitialValues(event, venue_id) {
		var venue = _.first(_.filter(event && event.Venue, function (venue) {
			return venue.id == venue_id;
		})) || {};
		return {
			address: venue.address || '',
			building: venue.building || '',
			city: venue.city || '',
			country: venue.country || 'US',
			fax: venue.fax || '',
			phone: venue.phone || '',
			st: venue.st || '',
			timezone: venue.timezone || '',
			zip: venue.zip || ''
		};
	};
	
	var buildFields = function buildFields(Displaylists, data) {
		var u_lists = Displaylists && Displaylists.universal || {};
	
		return _.assign(FormUtils.buildAddressFields(Displaylists, data), {
			building: {
				label: 'Name',
				type: 'text',
				placeholder: 'Name...',
				validate: FormUtils.optional
			},
			timezone: {
				label: 'Timezone',
				type: 'select',
				placeholder: '-- local time --',
				options: _.object(_.map(u_lists.timezones, function (timezone, k) {
					return [k, _.get(timezone, ["label"], k)];
				})),
				dont_sort_options: true,
				validate: FormUtils.optional
			},
			phone: {
				label: 'Phone',
				type: 'text',
				placeholder: 'Phone...',
				validate: FormUtils.optional
			},
			fax: {
				label: 'Fax',
				type: 'text',
				placeholder: 'Fax...',
				validate: FormUtils.optional
			}
		});
	};
	
	module.exports = {
		buildFields: buildFields,
		buildInitialValues: buildInitialValues,
		horizontal_fields_layout: horizontal_fields_layout
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		var buyer_names = _.map(event && event.Buyers, function (Buyer) {
			return Buyer.firstname;
		});
		if (_.isEmpty(buyer_names)) {
			buyer_names = ['The client'];
		}
		return buyer_names.join(', ');
	};
	
	var _ = __webpack_require__(1);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(411);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(424);
	var parse = __webpack_require__(423);
	var formats = __webpack_require__(139);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	exports.arrayToObject = function (source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function (target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (Object.prototype.hasOwnProperty.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function (str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        /* eslint operator-linebreak: [2, "before"] */
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function (obj, references) {
	    if (typeof obj !== 'object' || obj === null) {
	        return obj;
	    }
	
	    var refs = references || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0; i < obj.length; ++i) {
	            if (obj[i] && typeof obj[i] === 'object') {
	                compacted.push(exports.compact(obj[i], refs));
	            } else if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    keys.forEach(function (key) {
	        obj[key] = exports.compact(obj[key], refs);
	    });
	
	    return obj;
	};
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function (obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(154);


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var isDom = __webpack_require__(417);
	var now = Date.now || function(){
	  return new Date().getTime();
	};
	
	module.exports = {
	  getInitialState: function(){
	    this.__HoverMixin_fast_state = {
	      hover: false,
	      last_time: now(),
	      interval: 100,
	      timeout_handle: null,
	      on_user_left_waitfor: 500,
	      on_user_left_debounce_handler: null
	    };
	    return {hover: false, hoverable_top: 0, hoverable_left: 0};
	  },
	  ___fastStateChangeHover: function(){
	    var diff = now() - this.__HoverMixin_fast_state.last_time;
	    if(diff >= this.__HoverMixin_fast_state.interval){
	      var self = this;
	
	      this.setState({hover: this.__HoverMixin_fast_state.hover}, function(){
	        if(self.hoverable_onUserLeftHoverable && !self.__HoverMixin_fast_state.hover){
	          clearTimeout(self.__HoverMixin_fast_state.on_user_left_debounce_handler);
	          self.__HoverMixin_fast_state.on_user_left_debounce_handler = setTimeout(function(){
	            if(!self.state.hover){//only if still not hovering after the time has passed
	              self.hoverable_onUserLeftHoverable();
	            }
	          }, self.__HoverMixin_fast_state.on_user_left_waitfor);
	        }
	      });
	      this.__HoverMixin_fast_state.last_time = now();
	    }else{
	      clearTimeout(this.__HoverMixin_fast_state.timeout_handle);
	      this.__HoverMixin_fast_state.timeout_handle = setTimeout(this.___fastStateChangeHover, diff);
	    }
	  },
	  hoverable_onMouseEnter: function(){
	    this.__HoverMixin_fast_state.hover = true;
	    this.___fastStateChangeHover();
	  },
	  hoverable_onMouseLeave: function(){
	    this.__HoverMixin_fast_state.hover = false;
	    this.___fastStateChangeHover();
	  },
	  componentDidUpdate: function(){
	    var dom_node = this.refs.hoverable;//react 0.14.+
	    if(!isDom(dom_node)){//try the pre 0.14 method
	      dom_node = this.refs.hoverable && this.refs.hoverable.getDOMNode && this.refs.hoverable.getDOMNode();
	    }
	    if(!dom_node || !this.state.hover){
	      return;
	    }
	    var parentNode = dom_node.parentNode;
	    var rect = parentNode.getBoundingClientRect();
	    var parent_width = Math.max(0, parentNode.offsetWidth);
	    if(this.hoverable_not_relative_to_parent_bounding_rect){
	      rect = {top: 0, left: 0};
	    }
	    var top = parseInt(rect.top - Math.max(0, dom_node.offsetHeight), 10) || 0;
	    var left = parseInt(rect.left - (dom_node.offsetWidth / 2) + (parent_width / 2), 10) || 0;
	
	    var new_state = {};
	    if(Math.abs(top - this.state.hoverable_top) > 5){
	      new_state.hoverable_top = top;
	    }
	    if(Math.abs(left - this.state.hoverable_left) > 5){
	      new_state.hoverable_left = left;
	    }
	    if(Object.keys(new_state).length > 0){
	      //only make changes when needed so we don't get into a loop (some loops are over a few pixels difference)
	      this.setState(new_state);
	    }
	  }
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	
	var component = dd.createClass({
	  __onChange: function(e){
	    this.props.onChange(e.target.value);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    if(field.read_only){
	      return dd.p({className: 'form-control-static'},
	        value
	      );
	    }
	
	    var p = {
	      name: field.name,
	      disabled: field.disabled ? "disabled" : null,
	      type: field.type || 'text',
	      value: value || '',
	      placeholder: field.placeholder || null,
	      className: 'form-control',
	      autoFocus: field.autofocus || false,
	      onChange: this.__onChange
	    };
	    if(p.type === "number"){
	      _.each(["min", "max", "step"], function(key){
	        if(_.has(field, key) && _.isNumber(field[key])){
	          p[key] = field[key];
	        }
	      });
	    }
	    return dd.input(p);
	  }
	});
	
	module.exports = {
	  component: component
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * There is a single GlobalTooltip that is mounted once on the page in the body
	 * The purpose is to avoid hairy CSS situations where the tooltip is inside a
	 * container that is stomping over it.
	 *
	 * What doesn't work:
	 * 1) Position relative the tooltip doesn't work when inside a container that is 
	 *    using overflow: hidden. It will clip the tooltip regardlis of z-index
	 *
	 * 2) Position fixed directly inside the component almost works, except for inside
	 *    a parent element that is using css tranform, i.e. bootstrap modals
	 */
	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var ReactDOM = __webpack_require__(142);
	var e = React.createElement;
	
	__webpack_require__(439);
	
	
	//ToolTips keeps track of all the tooltips that can be rendered
	//It also notifies the GlobalTooltip when something changes
	var ToolTips = (function(){
	  var tips = {};
	  var listener = function(){};
	  return {
	    setListener: function(fn){
	      listener = fn;
	    },
	    getTip: function(){
	      return _.find(tips, function(t){
	        return t.show === true && _.isNumber(t.x) && _.isNumber(t.y);
	      });
	    },
	    update: function(id, o){
	      if(!_.has(tips, id)){
	        tips[id] = {};
	      }
	      _.assign(tips[id], o, {id: id});
	      listener();
	    },
	    remove: function(id){
	      if(_.has(tips, id)){
	        delete tips[id];
	        listener();
	      }
	    }
	  };
	}());
	
	
	var GlobalTooltip = React.createClass({
	  getInitialState: function(){
	    //just position it off screen so the height/width stays intact
	    return {
	      x: -100000,
	      y: -100000,
	      top: -100000,
	      left: -100000,
	      title: null,
	      content: null
	    };
	  },
	  onRef: function(popover_node){
	    this.popover_node = popover_node;
	  },
	  __hideIt: function(){
	    var to_show = ToolTips.getTip();
	    if(to_show){
	      return;//never mind, there is something to show
	    }
	    //just position it off screen so the height/width stays intact
	    this.setState({
	      x: -100000,
	      y: -100000,
	      top: -100000,
	      left: -100000
	    });
	  },
	  componentWillMount: function(){
	    ToolTips.setListener(this.__onTooltips);
	    this.__hideIt_direct = this.__hideIt;
	    this.__hideIt = _.debounce(this.__hideIt_direct, 500);
	  },
	  __onTooltips: function(){
	    var to_show = ToolTips.getTip();
	    if(!to_show){
	      this.__hideIt();
	      return;
	    }
	    var top = to_show.y;
	    var left = to_show.x;
	    if(this.popover_node){
	      top -= this.popover_node.offsetHeight;
	      left -= this.popover_node.offsetWidth/2;
	    }
	    this.setState({
	      x: to_show.x,
	      y: to_show.y,
	      top: top,
	      left: left,
	      title: to_show.title,
	      content: to_show.content
	    });
	  },
	  componentDidUpdate: function(){
	    if(!this.popover_node || (this.state.y < -1000)){
	      return;
	    }
	    var top = this.state.y - this.popover_node.offsetHeight;
	    var left = this.state.x - this.popover_node.offsetWidth/2;
	    if((top !== this.state.top)
	        || (left !== this.state.left)){
	      this.setState({top: top, left: left});
	    }
	  },
	  render: function(){
	    var top = this.state.top;
	    var left = this.state.left;
	    var title = this.state.title;
	    var content = this.state.content;
	
	    return (
	      e("div", {className: 'popover top', ref: this.onRef, style: {
	          display: 'block',//always show so that onMouseEnter we have the height/width of this popover
	          width: content ? Math.max(70, content.length * 14) + 'px' : 'auto',//aprox the width for the content, note that .popover class sets a max-width, so no worries
	          position: 'fixed',//this way a parent container can't overflow:hidden this
	          top: top + 'px',
	          left: left + 'px',
	
	          //normalizing styles (so parent font styling doesn't mess with this)
	          fontSize: '14px',
	          color: 'black',
	          textAlign: 'left',
	          fontWeight: 'normal'
	        }},
	        e("div", {className: 'arrow'}),
	        title ? e("h3", {className: 'popover-title'}, title) : '',
	        content ? e("div", {className: 'popover-content'}, content) : ''
	      )
	    );
	  }
	});
	
	// in case we are testing, document is undefined, so skip this section
	if (typeof document !== 'undefined') {
		var div = document.createElement("DIV")
		div.setAttribute("id", "loose-forms-GlobalTooltip");//ability to style it
		ReactDOM.render(e(GlobalTooltip), div);
		document.body.appendChild(div);
	}
	
	module.exports = dd.createClass({
	  getInitialState: function(){
	    return {id: _.uniqueId()};
	  },
	  onClick: function(e){
	    e.preventDefault();
	    e.stopPropagation();
	    this.__updateTip({show: true, x: e.clientX, y: e.clientY});
	  },
	  onMouseEnter: function(e){
	    this.__updateTip({show: true, x: e.clientX, y: e.clientY});
	  },
	  onMouseLeave: function(){
	    this.__updateTip({show: false});
	  },
	  componentWillMount: function(){
	    this.__updateTip({title: this.props.title, content: this.props.content});
	  },
	  componentWillReceiveProps: function(next_props){
	    this.__updateTip({title: next_props.title, content: next_props.content});
	  },
	  componentWillUnmount: function(){
	    ToolTips.remove(this.state.id);
	  },
	  __updateTip: function(o){
	    ToolTips.update(this.state.id, o);
	  },
	  render: function(){
	    return dd.a({
	        className: 'HelpTooltip',
	        href: '#',
	        style: {position: 'relative'},
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      },
	      dd.i({className: "react-bootstrap3-tooltip-icon react-bootstrap3-tooltip-icon-help-circled"})
	    );
	  }
	});


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	var input_types = {};
	
	module.exports = {
		getInputByType: function(type){
			if(!input_types.hasOwnProperty(type)){
				type = 'text';
			}
			return input_types[type];
		},
		setInputType: function(type, input){
			input_types[type] = input;
			return input_types[type];
		}
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(72);
	
	var defaultKeyFn = function(data){
	  return JSON.stringify(data);
	};
	
	module.exports = function(name, callback, keyFn){
	  keyFn = keyFn || defaultKeyFn;
	
	  radio(name).subscribe((function(){
	    var ajax_waiting = {};
	
	    return function(data){
	      var key = keyFn(data);
	
	      radio(name + '_waiting').broadcast(key);
	      if(ajax_waiting[key] === true){
	        return;
	      }
	      ajax_waiting[key] = true;
	
	      callback(data, function(err, resp){
	        if(err){
	          radio(name + '_failed').broadcast(key, err);
	        }else{
	          radio(name + '_succeeded').broadcast(key, resp);
	        }
	        ajax_waiting[key] = false;
	      });
	    };
	  }()));
	};


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(451);
	var ReactMultiChildUpdateTypes = __webpack_require__(166);
	var ReactPerf = __webpack_require__(39);
	
	var setInnerHTML = __webpack_require__(81);
	var setTextContent = __webpack_require__(114);
	var invariant = __webpack_require__(11);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(48);
	var ReactElement = __webpack_require__(35);
	
	var emptyFunction = __webpack_require__(42);
	var traverseAllChildren = __webpack_require__(116);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(153);
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactNoopUpdateQueue = __webpack_require__(168);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(11);
	var keyMirror = __webpack_require__(71);
	var keyOf = __webpack_require__(46);
	var warning = __webpack_require__(16);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(168);
	
	var canDefineProperty = __webpack_require__(79);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactDOMTextComponent = __webpack_require__(157);
	var ReactDefaultInjection = __webpack_require__(159);
	var ReactInstanceHandles = __webpack_require__(57);
	var ReactMount = __webpack_require__(31);
	var ReactPerf = __webpack_require__(39);
	var ReactReconciler = __webpack_require__(52);
	var ReactUpdates = __webpack_require__(40);
	var ReactVersion = __webpack_require__(106);
	
	var findDOMNode = __webpack_require__(107);
	var renderSubtreeIntoContainer = __webpack_require__(500);
	var warning = __webpack_require__(16);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(101);
	var ReactMount = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, props, value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(149);
	var DOMPropertyOperations = __webpack_require__(100);
	var ReactComponentBrowserEnvironment = __webpack_require__(102);
	var ReactMount = __webpack_require__(31);
	
	var assign = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(80);
	var setTextContent = __webpack_require__(114);
	var validateDOMNesting = __webpack_require__(117);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(40);
	var Transaction = __webpack_require__(78);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(447);
	var ChangeEventPlugin = __webpack_require__(449);
	var ClientReactRootIndex = __webpack_require__(450);
	var DefaultEventPluginOrder = __webpack_require__(452);
	var EnterLeaveEventPlugin = __webpack_require__(453);
	var ExecutionEnvironment = __webpack_require__(28);
	var HTMLDOMPropertyConfig = __webpack_require__(456);
	var ReactBrowserComponentMixin = __webpack_require__(458);
	var ReactComponentBrowserEnvironment = __webpack_require__(102);
	var ReactDefaultBatchingStrategy = __webpack_require__(158);
	var ReactDOMComponent = __webpack_require__(462);
	var ReactDOMTextComponent = __webpack_require__(157);
	var ReactEventListener = __webpack_require__(470);
	var ReactInjection = __webpack_require__(471);
	var ReactInstanceHandles = __webpack_require__(57);
	var ReactMount = __webpack_require__(31);
	var ReactReconcileTransaction = __webpack_require__(475);
	var SelectEventPlugin = __webpack_require__(481);
	var ServerReactRootIndex = __webpack_require__(482);
	var SimpleEventPlugin = __webpack_require__(483);
	var SVGDOMPropertyConfig = __webpack_require__(480);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(44);
	
	var canDefineProperty = __webpack_require__(79);
	var getIteratorFn = __webpack_require__(111);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactEmptyComponentRegistry = __webpack_require__(162);
	var ReactReconciler = __webpack_require__(52);
	
	var assign = __webpack_require__(17);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(466);
	
	var containsNode = __webpack_require__(134);
	var focusNode = __webpack_require__(135);
	var getActiveElement = __webpack_require__(136);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(492);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(71);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(16);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	
	var emptyFunction = __webpack_require__(42);
	var getIteratorFn = __webpack_require__(111);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isDate = __webpack_require__(422);
	var timeago = __webpack_require__(501);
	
	module.exports = function(since, until){
	  if((since && !isDate(since)) || (until && !isDate(until))){
	    return "???";
	  }
	  return timeago(since || null, until || null);
	};


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var Select = __webpack_require__(97).component;
	
	var getCountryList = function(Displaylists){
		var u_lists = (Displaylists && Displaylists.universal) || {};
		return u_lists.countrylist || {};
	};
	
	module.exports = {
		component: dd.createClass({
			render: function(){
				var field = _.cloneDeep(_.omit(this.props.field, "Displaylists"));
	
				field.options = _.object(_.map(getCountryList(this.props.field.Displaylists), function(country){
					return [country.sc, country.lc];
				}));
				field.dont_sort_options = true;//It should come pre-sorted from the server
				if(!_.isString(field.placeholder)){
					field.placeholder = "-- select country --";
				}
	
				return Select(_.assign({}, this.props, {
					field: field
				}));
			}
		}),
		validate: function(value){
			return !!value || "Please select a country";
		}
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var Text = __webpack_require__(144).component;
	var Select = __webpack_require__(97).component;
	
	var getStatesForCountry = function(Displaylists, short_country){
		var u_lists = (Displaylists && Displaylists.universal) || {};
		return _.filter(u_lists.statelist, function(state){
			return state.sc == short_country;
		});
	};
	
	module.exports = {
		component: dd.createClass({
			__getOptions: function(){
				var field = this.props.field || {};
				return _.object(_.map(getStatesForCountry(field.Displaylists, field.country), function(state){
					return [state.ss, state.ls];
				}));
			},
			render: function(){
				var field = _.cloneDeep(_.omit(this.props.field, "Displaylists"));
				var options = this.__getOptions();
	
				if(_.isEmpty(options)){
					if(!_.isString(field.placeholder)){
						field.placeholder = "State/Province";
					}
					return Text(_.assign({}, this.props, {
						field: field
					}));
				}
				field.options = options;
				field.dont_sort_options = true;//It should come pre-sorted from the server
				if(!_.isString(field.placeholder)){
					field.placeholder = "-- select state/province --";
				}
				return Select(_.assign({}, this.props, {
					field: field
				}));
			}
		}),
		validate: function(value){
			return !!value || "Please select a state/province";
		}
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var Ajax = __webpack_require__(83);
	var radio = __webpack_require__(37);
	var esUtils = __webpack_require__(2);
	
	var write = function(data){
		Ajax.get("/js-bug-hunter?" + esUtils.phpCompatibleParams(data));
		console.log("WRITE TO SERVER LOG", data);
	};
	
	if((typeof window !== "undefined") && (("production") === "production")){
		var session_data = typeof AUTHED_USER_SESSION !== "undefined" ? AUTHED_USER_SESSION : {};
		var username = (session_data.balboa && session_data.balboa.username) || "unknown";
		window.onerror = function(message, file_url, line, col, errorObj){
			try{
				write({
					message: message,
					file_url: file_url,
					username: username,
					js_file_url: errorObj && errorObj.fileName,
					stack: errorObj && errorObj.stack,
					line: line,
					col: col,
					url: window.location.href
				});
			}catch(e){
			}
			return true;
		};
	}
	
	module.exports.init = function(){
		radio("BugHunter_logit").subscribe(write);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(37);
	var _ = __webpack_require__(12);
	
	var hashChange = (function(){
		if(typeof window === 'undefined'){
			return _.noop;
		}
		var oldHref = null;//start with nothing so the first page load gets broadcasted
		return function(e){
			var newHref = (!!e && e.newURL) || window.location.href;
			oldHref = (!!e && e.oldURL) || oldHref;
	
			if(oldHref !== newHref){
				radio('Hashbang_changed').broadcast(parse_url(newHref), newHref, oldHref);
				oldHref = newHref;
			}
		};
	}());
	
	radio('Hashbang_set').subscribe(function(new_url){
		if(_.isString(new_url)){
			window.location.hash = new_url;
			hashChange();
		}
	});
	
	module.exports.init = function(){
		if(typeof window === 'undefined'){
			return;
		}
		if(!('onhashchange' in window)){
			setInterval(hashChange, 100);
		}else if(window.addEventListener){
			window.addEventListener('hashchange', hashChange, false);
		}else if(window.attachEvent){
			window.attachEvent('onhashchange', hashChange);
		}
		hashChange();//trigger the initial broadcast
	};
	
	var parse_url = (function(){
		var parse_url_regex = /^(?:([A-Za-z]+):)?(?:\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;//thanks for the good parts Douglas Crockford
		var names = ['url', 'scheme', 'host', 'port', 'path', 'query', 'hash'];
	
		return function(url){
			var result = parse_url_regex.exec(url);
			return _.object(_.filter(_.zip(names, result), function(keyvalpair){
				return !!keyvalpair[1];//remove any empty values
			}));
		};
	}());


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(37);
	var _ = __webpack_require__(12);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	
	//key: eid , value: messages array
	var messages_by_eid_cache = {};
	
	var wating_on_ajax_eid = {};
	
	var broadcast_all = function(){
		radio('MPMessages_response').broadcast(messages_by_eid_cache);
	};
	
	module.exports.init = function(){
		radio('MPMessages_get_for_event').subscribe(_.debounce(function(event_id){
			if((event_id > 0) === false){
				return;
			}
			if(messages_by_eid_cache[event_id]){
				broadcast_all();
				return;
			}
			radio('MPMessages_waiting_on_balboa').broadcast(event_id);
			if(wating_on_ajax_eid[event_id]){
				return;
			}
			wating_on_ajax_eid[event_id] = true;
			Balboa.api('/mpmessage/read', {
				event_id: event_id
			}, function(data){
				messages_by_eid_cache[event_id] = _.map(data.messages, formatMessageFromServer);
				broadcast_all();
				wating_on_ajax_eid[event_id] = false;
			}, function(data){
				console.error(data);
				radio('MPMessages_failed').broadcast(event_id, (data && data.message) || 'unknown cause');
				wating_on_ajax_eid[event_id] = false;
			});
		}, 50));//must debounce b/c race conditions can happen if it's too fast (aka syncronis when expected to be async)
	
		radio('MPMessages_decache').subscribe(_.debounce(function(event_id){
			delete messages_by_eid_cache[event_id];
		}, 50));
	
		radio('MPMessages_send_message').subscribe(function(params){
			Balboa.api('/mpmessage/save', params, function(data){
				var message = formatMessageFromServer(data.message);
				if(params.event_id > 0){
					if(!messages_by_eid_cache[params.event_id]){
						messages_by_eid_cache[params.event_id] = [];
					}
					messages_by_eid_cache[params.event_id].unshift(message);
				}
				radio('MPMessages_send_success').broadcast(message);
				broadcast_all();
			}, function(data){
				console.error(data);
				radio('MPMessages_send_failed').broadcast(params, (data && data.message) || 'unknown cause');
			});
		});
	};
	
	var formatMessageFromServer = function(message){
		message.created = esUtils.convertFromISO8601(message.created_ISO8601);
		return message;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(37);
	var _ = __webpack_require__(12);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	
	var cached_response = null;
	
	var ask_balboa = (function(){
		var currently_talking_to_balboa = false;
		return function(){
			if(currently_talking_to_balboa){
				return;
			}
			currently_talking_to_balboa = true;
			Balboa.api('/mpmessage/numunread', {
				get_by_eid_then_sid: true
			}, function(data){
				cached_response = data.data;
				radio('unread_messages_by_eid_and_sid').broadcast(cached_response);
				currently_talking_to_balboa = false;
			}, function(data){
				console.error(data);
				currently_talking_to_balboa = false;
			});
		};
	}());
	
	
	var markAsRead = (function(){
		var message_ids_marked_as_read = [];
		return function(message_ids){
			message_ids = esUtils.cleanup_ids(message_ids);
			message_ids = _.difference(message_ids, message_ids_marked_as_read);
			if(message_ids.length === 0){
				return;
			}
			Balboa.api('/mpmessage/ireadit', {
				ids: message_ids
			}, function(data){
				message_ids_marked_as_read.concat(message_ids);
				radio('messages_marked_as_read').broadcast(message_ids);
				ask_balboa();//re-broadcast it
			}, function(data){
				console.error(data);
			});
		};
	}());
	
	module.exports.init = function(){
		radio('please_broadcast_number_of_unread_messages').subscribe(_.debounce(function(){
			if(cached_response){
				radio('unread_messages_by_eid_and_sid').broadcast(cached_response);
			}else{
				ask_balboa();
			}
		}, 100));
		setTimeout(ask_balboa, 10 * 60 * 1000);//check every 10 min
	
		var message_ids_to_mark_read = [];
		radio('mark_messages_as_read').subscribe(function(mp_message_ids){
			message_ids_to_mark_read = message_ids_to_mark_read.concat(esUtils.cleanup_ids(mp_message_ids));
			_.debounce(function(){
				markAsRead(message_ids_to_mark_read);
			}, 100)();
		});
	
	};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	
	__webpack_require__(185);
	
	var VerticalScroll = __webpack_require__(66);
	
	module.exports = dd.createClass({
		__onClose: esUtils.wrapPreventDefault(function(){
			if(_.isFunction(this.props.__onClose)){
				this.props.__onClose();
			}
		}),
		render: function(){
	
			return dd.div({className: 'Aside ' + (this.props.className ? this.props.className : '')},
				dd.div({className: 'aside ' + (this.props.right ? 'right' : 'left'), tabIndex: -1, role: 'dialog'},
					dd.div({className: 'aside-dialog'},
						dd.div({className: 'aside-content'},
							dd.table({style: {width: '100%', height: '100%', border: 0, margin: 0, padding: 0}},
								dd.tbody(null,
									dd.tr({style: {width: '100%', border: 0, margin: 0, padding: 0}},
										dd.td({style: {width: '100%', height: '1px', border: 0, margin: 0, padding: 0}},
											dd.div({className: 'aside-header'},
												dd.a({className: 'close', href: '#', onClick: this.__onClose}, 'CLOSE'),
												this.props.header
											)
										)
									),
									dd.tr({style: {width: '100%', border: 0, margin: 0, padding: 0}},
										dd.td({style: {width: '100%', height: '100%', verticalAlign: 'top', border: 0, margin: 0, padding: 0}},
											VerticalScroll(null,
												dd.div({className: 'aside-body'},
													this.props.children
												)
											)
										)
									)
								)
							)
						)
					)
				),
				dd.div({className: 'aside-backdrop in', onClick: this.__onClose})
			);
		}
	});


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})(".aside{z-index:1040;background:#FFF;position:fixed;overflow:auto;min-width:320px;top:0;bottom:0}.aside:focus{outline:0}.aside.left{left:0;right:auto}.aside.right{left:auto;right:0}.aside .aside-dialog .aside-header{border-bottom:1px solid #E5E5E5;min-height:15px;padding:10px;background:#428BCA;color:#FFF}.aside .aside-dialog .aside-header a{color:#FFF}.aside .aside-dialog .aside-header .close{color:#FFF;font-size:.75em;opacity:.8;text-shadow:none;font-weight:400}.aside .aside-dialog .aside-body{position:relative;padding:20px}.aside .aside-dialog .aside-footer{margin-top:15px;padding:19px 20px 20px;text-align:right;border-top:1px solid #e5e5e5}.aside .aside-dialog .aside-footer:after,.aside .aside-dialog .aside-footer:before{content:\" \";display:table}.aside .aside-dialog .aside-footer:after{clear:both}.aside .aside-dialog .aside-footer .btn+.btn{margin-left:5px;margin-bottom:0}.aside .aside-dialog .aside-footer .btn-group .btn+.btn{margin-left:-1px}.aside .aside-dialog .aside-footer .btn-block+.btn-block{margin-left:0}.aside-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1030;background-color:#000}.relative>.Aside>.aside,.relative>.Aside>.aside-backdrop{position:absolute}.aside-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.aside-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.aside-backdrop.animation-fade{background:rgba(0,0,0,.5);opacity:1}.relative>.Aside>.aside .aside-dialog,.relative>.Aside>.aside .aside-dialog .aside-content{width:100%;height:100%}.relative>.Aside>.aside .aside-dialog .aside-content .aside-footer{margin-top:0}");

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})(".waitGlass{position:absolute;z-index:100;width:100%;height:100%;background-color:#333;opacity:.5;filter:alpha(opacity=50)}.waitGlass .circleG{width:150px;height:32px;margin:32px 0 0 32px}.waitGlass .circleG .circleG{background-color:#333;float:left;width:32px;margin:0 17px 0 0;-moz-animation-name:bounce_circleG;-moz-animation-duration:1.9500000000000002s;-moz-animation-iteration-count:infinite;-moz-animation-direction:linear;-moz-border-radius:21px;-webkit-animation-name:bounce_circleG;-webkit-animation-duration:1.9500000000000002s;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:linear;-webkit-border-radius:21px;-ms-animation-name:bounce_circleG;-ms-animation-duration:1.9500000000000002s;-ms-animation-iteration-count:infinite;-ms-animation-direction:linear;-ms-border-radius:21px;-o-animation-name:bounce_circleG;-o-animation-duration:1.9500000000000002s;-o-animation-iteration-count:infinite;-o-animation-direction:linear;-o-border-radius:21px;animation-name:bounce_circleG;animation-duration:1.9500000000000002s;animation-iteration-count:infinite;animation-direction:linear;border-radius:21px}.waitGlass .circleG .circleG.circleG_1{-moz-animation-delay:.39s;-webkit-animation-delay:.39s;-ms-animation-delay:.39s;-o-animation-delay:.39s;animation-delay:.39s}.waitGlass .circleG .circleG.circleG_2{-moz-animation-delay:.9099999999999999s;-webkit-animation-delay:.9099999999999999s;-ms-animation-delay:.9099999999999999s;-o-animation-delay:.9099999999999999s;animation-delay:.9099999999999999s}.waitGlass .circleG .circleG.circleG_3{-moz-animation-delay:1.1700000000000002s;-webkit-animation-delay:1.1700000000000002s;-ms-animation-delay:1.1700000000000002s;-o-animation-delay:1.1700000000000002s;animation-delay:1.1700000000000002s}@-moz-keyframes bounce_circleG{50%{background-color:#428aca}}@-webkit-keyframes bounce_circleG{50%{background-color:#428aca}}@-ms-keyframes bounce_circleG{50%{background-color:#428aca}}@-o-keyframes bounce_circleG{50%{background-color:#428aca}}@keyframes bounce_circleG{50%{background-color:#428aca}}");

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	
	module.exports = dd.createClass({
		render: function(){
			var percent = this.props.percent;
			var custom_text = this.props.custom_text;
			var text_color = this.props.text_color || (percent > 0.5 ? 'white' : 'black');
	
			if(percent < 0 || percent > 1){
				//indeterminate progress if out of range
				return dd.div({className: 'progress progress-striped active'},
					dd.div({className: 'progress-bar', role: 'progressbar', style: {width: '100%'}})
				);
			}
			return dd.div({className: 'progress relative'},
				dd.div({className: 'text-center', style: {position: 'absolute', width: '100%', fontWeight: 'bold', color: text_color}},
					custom_text || (esUtils.format_number(percent * 100, 1) + '%')
				),
				dd.div({className: 'progress-bar', role: 'progressbar', style: {width: esUtils.format_number(percent * 100, 2) + '%'}})
			);
		}
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var esUtils = __webpack_require__(2);
	
	__webpack_require__(189);
	
	module.exports = dd.createClass({
		getInitialState: function(){
			return {sort_col: 0, sort_ascending: true, default_sort: {sort_col: 0, sort_ascending: true}};
		},
		componentWillReceiveProps: function(props){
			this.__updateDefaultSort(props);
		},
		componentDidMount: function(){
			this.__updateDefaultSort(this.props);
		},
		__updateDefaultSort: function(props){
			if(!props.default_sort){
				return;
			}
			var default_sort = this.state.default_sort;
			var changed = false;
			_.each(["sort_col", "sort_ascending"], function(f){
				if(default_sort[f] !== props.default_sort[f]){
					default_sort[f] = props.default_sort[f];
					changed = true;
				}
			});
			if(changed){
				this.setState({
					sort_col: default_sort.sort_col,
					sort_ascending: default_sort.sort_ascending,
					default_sort: default_sort
				});
			}
		},
		__clickCol: function(col_i){
			var self = this;
			return esUtils.wrapPreventDefault(function(){
				if(self.state.sort_col === col_i){
					self.setState({sort_ascending: !self.state.sort_ascending});
				}else{
					self.setState({sort_col: col_i, sort_ascending: true});
				}
			});
		},
		__determineHeaderOnClick: function(header, i) {
			if(_.isFunction(header.onClick)) {
				return header.onClick;
			}
	
			return header.sortable ? this.__clickCol(i) : null;
		},
		render: function(){
			var table = this.props.table;
			var sort_col = this.state.sort_col;
			var sort_ascending = this.state.sort_ascending;
	
			var rows = _.sortBy(table.rows, function(row){
				var col = row.cols[sort_col] || {};
				if(col.sortkey){
					return col.sortkey;
				}
				return col.body;
			});
			if(!sort_ascending){
				rows = rows.reverse();
			}
	
			return dd.table({className: 'SortableTable table table-condensed table-hover'},
				dd.thead(null,
					dd.tr(null,
						_.map(table.header, function(header, i){
							var classes = ['clickable'];
	
							// make sortable true by default
							if(!header.hasOwnProperty('sortable')) {
								header.sortable = true;
							}
	
							if(header.className){
								classes.push(header.className);
							}
							return dd.th({key: i, className: classes.join(' '), onClick: this.__determineHeaderOnClick(header, i)},
								_.isFunction(header.render) ? header.render() : header.body,
								' ',
								(header.sortable && sort_col === i) ? dd.i({className: 'fa fa-caret-' + (sort_ascending ? 'down' : 'up')}) : null
							);
						}, this)
					)
				),
				dd.tbody(null,
					rows.length === 0 ? dd.tr({className: 'emptytable'}, dd.td({colSpan: table.header.length, className: 'text-muted'}, 'nothing to report')) : _.map(rows, function(row, i){
						var tr_props = _.isPlainObject(row.props) ? row.props : {};
						tr_props.key = i;
	
						return dd.tr(tr_props,
							_.map(row.cols, function(col, i){
								var td_props = _.isPlainObject(col.props) ? col.props : {};
								td_props.key = i;
	
								return dd.td(td_props,
									dd.div({className: 'oneline-ellipsis'},
										_.isFunction(col.render) ? col.render() : col.body
									)
								);
							})
						);
					})
				)
			);
		}
	});


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})("table.SortableTable.table{table-layout:fixed}table.SortableTable.table>thead>tr>th{white-space:nowrap;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}table.SortableTable.table>thead>tr>th.date{min-width:7em;width:7em}table.SortableTable.table>thead>tr>th.organization{min-width:8em}table.SortableTable.table>tbody>tr{cursor:pointer;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}table.SortableTable.table>tbody>tr.emptytable{cursor:default}table.SortableTable.table>tbody>tr>td{line-height:1.2em}table.SortableTable.table>tbody>tr>td .initials{padding-right:.5em;color:grey}table.SortableTable.table>tbody>tr>td>div.oneline-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}");

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	
	var input_types = {
		captcha: __webpack_require__(191),
		checkbox: __webpack_require__(192),
		combo: __webpack_require__(193),
		date: __webpack_require__(198),
		esBudgetRange: __webpack_require__(204),
		esCountry: __webpack_require__(205),
		esState: __webpack_require__(206),
		file: __webpack_require__(199),
		select: __webpack_require__(200),
		static: __webpack_require__(201),
		text: __webpack_require__(202),
		textarea: __webpack_require__(203)
	};
	
	var getInputByType = function(type){
		if(!_.has(input_types, type)){
			type = 'text';
		}
		return input_types[type];
	};
	
	var setInputType = function(type, input){
		input_types[type] = input;
	};
	
	module.exports = {
		getInputByType: getInputByType,
		setInputType: setInputType
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(37);
	var esUtils = __webpack_require__(2);
	var ErrorAlert = __webpack_require__(6);
	var LoadingBar = __webpack_require__(85);
	var FormInputMixin = __webpack_require__(38);
	var RadioAjaxMixin = __webpack_require__(33).RadioAjaxMixin;
	
	module.exports = {
		component: dd.createClass({
			mixins: [FormInputMixin, RadioAjaxMixin('getCaptchaURL')],
			__onChange: function(e){
				var ajax = this.state.getCaptchaURL;
				var data = ajax.data || {};
	
				this._input_newValue({
					key: data.key,
					input: e.target.value
				});
			},
			__RadioAjax_key_getCaptchaURL: function(){
				return 1;
			},
			componentDidMount: function(){
				radio('getCaptchaURL').broadcast();
			},
			__refresh: esUtils.wrapPreventDefault(function(){
				radio('getCaptchaURL').broadcast();
			}),
			render: function(){
				var ajax = this.state.getCaptchaURL;
				var field = this.props.field;
				var value = (this.props.value && this.props.value.input) || '';
				var field_path = this.props.field_path;
	
				if(ajax.error_message){
					return ErrorAlert({message: ajax.error_message});
				}
				if(ajax.waiting){
					return dd.div({className: ajax.waiting},
						LoadingBar()
					);
				}
				var data = ajax.data || {};
	
				return dd.div({style: {width: '200px'}},
					dd.img({src: data.url, style: {padding: '0 10px 5px 0'}}),
					dd.a({href: '#', onClick: this.__refresh}, dd.i({className: 'fa fa-refresh'})),
					dd.input({
						type: 'text',
						name: field_path,
						value: value,
						onChange: this.__onChange,
						className: 'form-control',
						placeholder: field.placeholder || null
					})
				);
			}
		}),
		validate: function(v){
			return _.isString(v && v.input) && v.input.length > 0 ? true : 'Please enter the text above';
		}
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var dd = dd;
	var FormInputMixin = __webpack_require__(38);
	
	var component = dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			this._input_newValue(!!e.target.checked);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
	
			return dd.label({className: "forms-checkbox", style: {fontWeight: 'normal'}},
				dd.input({type: 'checkbox', checked: !!value, name: this.props.field_path, onChange: this.__onChange, disabled: field.read_only ? 'disabled' : null}),
				' ',
				field.label
			);
		}
	});
	
	module.exports = {
		component: component,
		validate: function(){
			return true;//can't go wrong with a checkbox
		}
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	var HoverMixin = __webpack_require__(49);
	var FormInputMixin = __webpack_require__(38);
	
	var component = dd.createClass({
		mixins: [FormInputMixin, HoverMixin],
		__onChange: function(e){
			this._input_newValue(e.target.value);
		},
		getInitialState: function(){
			return {dd_open: false};
		},
		__toggleDropDown: esUtils.wrapPreventDefault(function(){
			this.setState({dd_open: !this.state.dd_open});
		}),
		hoverable_onUserLeftHoverable: function(){
			if(this.state.dd_open){//only setState if needed
				this.setState({dd_open: false});
			}
		},
		__itemSelected: function(value){
			var self = this;
			return esUtils.wrapPreventDefault(function(){
				if(_.isFunction(self.props.__onSelectTransform)){
					value = self.props.__onSelectTransform(value);
				}
				self.setState({dd_open: false});
				self._input_newValue(value);
			});
		},
		render: function(){
			var self = this;
			var field = this.props.field;
			var value = this.props.value;
	
			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					_.has(field.options, value) ? field.options[value] : value
				);
			}
	
			var type_in = dd.input({
				type: 'text',
				placeholder: field.placeholder || null,
				className: 'form-control',
				value: value || '',
				name: this.props.field_path,
				onChange: this.__onChange
			});
			if(_.isEmpty(field.options)){
				return type_in;
			}
			return dd.div({className: 'input-group'},
				type_in,
				dd.span({
						className: 'input-group-btn' + (this.state.dd_open ? ' open' : ''),
						onMouseEnter: this.hoverable_onMouseEnter,
						onMouseLeave: this.hoverable_onMouseLeave
					},
					dd.button({className: 'btn btn-default', onClick: this.__toggleDropDown},
						dd.span({className: 'caret'})
					),
					dd.ul({className: 'dropdown-menu pull-right', style: {overflowY: 'auto', maxHeight: 150}},
						_.map(field.options, function(name, val){
							return dd.li({key: val}, dd.a({href: '#', onClick: self.__itemSelected(val)}, name));
						})
					)
				)
			);
		}
	});
	
	module.exports = {
		component: component
	};


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})(".Date .DatePickerCalendar{display:block;background-color:#FFF;padding:2px}.Date .DatePickerCalendar table th{padding:3px 7.5px}.Date .DatePickerCalendar table th.month{font-size:12px;line-height:20px;text-align:center}.Date .DatePickerCalendar table th.month .btn{padding:0 10px}.Date .DatePickerCalendar table th.dow{font-size:11px;padding:3px 1px;text-align:center}.Date .DatePickerCalendar table td{padding:1px;text-align:center;position:relative}.Date .DatePickerCalendar table td span{border-radius:2px;-moz-border-radius:2px;-webkit-border-radius:2px;display:block;font-size:10px;padding:2px 5.5px}.Date .DatePickerCalendar table td span.out{color:#9e97a6}.Date .DatePickerCalendar table td span.clickable:hover{background-color:#EEE}.Date .DatePickerCalendar table td span.selected{background-color:#A4D5FF}.Date .TimePicker{padding:0 5px}.Date .TimePicker table{width:100%}.Date .TimePicker table tbody>tr>td .btn{width:100%;padding-top:2px;padding-bottom:2px}.Date .TimePicker table tbody>tr>td .form-control{margin:0!important;width:100%!important;text-align:center}");

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	
	var esUtils = __webpack_require__(2);
	
	module.exports = dd.createClass({
		getInitialState: function(){
			var today = new Date();
			if(_.isDate(this.props.value)){
				today = this.props.value;
			}else{
				var field = this.props.field;
				var start = _.isDate(field.valid_range && field.valid_range.start) ? field.valid_range.start : null;
				var stop = _.isDate(field.valid_range && field.valid_range.stop) ? field.valid_range.stop : null;
				if(start && ((start.getFullYear() > today.getFullYear()) || (start.getMonth() > today.getMonth()))){
					today = start;
				}else if(stop && ((stop.getFullYear() < today.getFullYear()) || (stop.getMonth() < today.getMonth()))){
					today = stop;
				}
			}
			return {
				year: today.getFullYear(),
				month: today.getMonth() + 1
			};
		},
		__incMonth: function(inc){
			var year = this.state.year;
			var month = this.state.month;
			var d = new Date(year, month - 1, 1);
			d.setMonth(d.getMonth() + inc);
			this.setState({year: d.getFullYear(), month: d.getMonth() + 1});
		},
		__nextMonth: esUtils.wrapPreventDefault(function(){
			this.__incMonth(1);
		}),
		__prevMonth: esUtils.wrapPreventDefault(function(){
			this.__incMonth(-1);
		}),
		__onDayClick: function(day){
			var self = this;
			return esUtils.wrapPreventDefault(function(){
				var year = self.state.year;
				var month = self.state.month;
				self.props.onDatePicked(year, month, day);
			});
		},
		render: function(){
			var self = this;
			var field = self.props.field;
			var year = self.state.year;
			var month = self.state.month;
			var selected_day = getDayIfMatches(self.props.value, month, year);
	
			var start_day = getDayIfMatches(field.valid_range && field.valid_range.start, month, year);
			var stop_day = getDayIfMatches(field.valid_range && field.valid_range.stop, month, year);
	
			var weeks = esUtils.build_calendar_weeks(year, month, true);
			return dd.div({className: 'DatePickerCalendar'},
				dd.table(null,
					dd.thead(null,
						dd.tr(null,
							dd.th({colSpan: 7, className: 'month'},
								start_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-left', onClick: this.__prevMonth},
									dd.i({className: 'fa fa-angle-left'})
								),
								esUtils.get_month_name(month) + ' ' + year,
								stop_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-right', onClick: this.__nextMonth},
									dd.i({className: 'fa fa-angle-right'})
								)
							)
						),
						dd.tr(null,
							_.map([1, 2, 3, 4, 5, 6, 7], function(d){
								return dd.th({key: d, className: 'dow'}, esUtils.get_day_of_week(d, true));
							})
						)
					),
					dd.tbody(null,
						_.map(weeks, function(week, i){
							return dd.tr({key: i},
								_.map(week, function(day, i){
									var classes = [];
									var onClick = null;
									if(day.out_of_month || day.date < start_day || (stop_day > 0 && day.date > stop_day)){
										classes.push('out');
									}else{
										classes.push('clickable');
										onClick = self.__onDayClick(day.date);
										if(day.date == selected_day){
											classes.push('selected');
										}
									}
									return dd.td({key: i},
										dd.span({className: classes.join(' '), onClick: onClick}, day.date)
									);
								})
							);
						})
					)
				)
			);
		}
	});
	
	
	var getDayIfMatches = function(date, month, year){
		if(_.isDate(date)){
			if(date.getFullYear() === year && date.getMonth() + 1 === month){
				return date.getDate();
			}
		}
		return -1;
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(70);
	
	var time_placeholder = 'hh:mm am/pm';
	
	var isDateValid = function(d){
		return _.isDate(d) && !_.isNaN(d.getTime());
	};
	
	var hashDate = function(d){
		return isDateValid(d) ? d.toISOString() : null;
	};
	
	var formatDate = function(value, pick_date, pick_time){
		var format_parts = [];
		if(pick_date){
			format_parts.push('mm/dd/yyyy');
		}
		var extra_append = '';
		if(pick_time){
			if(isDateValid(value) && value.getHours() === 0 && value.getMinutes() === 0){
				if(pick_date){
					//provide hint that there is a place to enter the time
					extra_append += ' - ' + time_placeholder;
				}else{
					//let the placeholder take over
				}
			}else{
				format_parts.push('- h:MM TT');
			}
		}
		return isDateValid(value) ? dateFormat(value, format_parts.join(' ')) + extra_append : '';
	};
	
	module.exports = dd.createClass({
		getInitialState: function(){
			return {
				text_value: formatDate(this.props.value, this.props.pick_date, this.props.pick_time),
				is_text_invalid: false,
				last_prop_value: hashDate(this.props.value)
			};
		},
		componentWillReceiveProps: function(props){
			var value = props.value;
			var pick_date = props.pick_date;
			var pick_time = props.pick_time;
	
			if(this.state.last_prop_value !== hashDate(value)){
				this.setState({
					text_value: formatDate(value, pick_date, pick_time),
					is_text_invalid: !!(this.state.is_text_invalid && _.isNull(value)),//set it false if it's a real value now
					last_prop_value: hashDate(value)
				});
			}
		},
		__onChange: function(e){
			var input = e.target.value;
			this.setState({text_value: input});
			this.__debouncedChange();
		},
		__debouncedChange: _.debounce(function(){
			this.__parseInputToDate();
		}, 3 * 1000),
		__onBlur: function(e){
			this.__parseInputToDate();
		},
		componentWillMount: function(){
			var self = this;
	
			self.__parseInputToDate = (function(){
				var last_input_checked = null;
	
				return function(){
					var text_value = self.state.text_value;
					if(last_input_checked === text_value){
						return;//already checked this
					}
					last_input_checked = text_value;
					var d = new Date(text_value);
	
					//try different formats
					if(!isDateValid(d)){
						d = new Date(text_value.replace(/\-/g, " "));
					}
					if(!isDateValid(d)){
						d = new Date(text_value.replace(/am\/pm/i, " ").replace(/\-/g, " ").replace(/m|h/g, "0"));
					}
	
					//final verdict if it's valid or not
					if(isDateValid(d)){
						self.props.onDateSet(d);
					}else{
						self.props.onDateSet(null);
						self.setState({is_text_invalid: true, text_value: ''});
	
						//auto hide the message
						setTimeout(function(){
							if(self.state.is_text_invalid){
								self.setState({is_text_invalid: false});
							}
						}, 3 * 1000);
					}
				};
			}());
		},
		render: function(){
			var pick_date = this.props.pick_date;
			var pick_time = this.props.pick_time;
			var placeholder = this.props.placeholder;
	
			var text_value = this.state.text_value;
			var is_text_invalid = this.state.is_text_invalid;
	
			var placeholder_parts = [];
			if(pick_date){
				placeholder_parts.push('mm/dd/yyyy');
			}
			if(pick_time){
				placeholder_parts.push(time_placeholder);
			}
			return dd.span({className: is_text_invalid ? 'has-error' : null},
				dd.input({
					type: 'text',
					className: 'form-control',
					placeholder: placeholder || placeholder_parts.join(' - '),
					value: text_value,
					onChange: this.__onChange,
					onBlur: this.__onBlur
				}),
				is_text_invalid ? dd.div({className: 'popover bottom', ref: 'popover', style: {
						display: 'block',
						top: 28,
	
						//normalizing styles (so parent font styling doesn't mess with this)
						fontSize: 14,
						color: 'black',
						textAlign: 'left',
						fontWeight: 'normal'
					}},
					dd.div({className: 'arrow'}),
					dd.div({className: 'popover-content'},
						'Try again using the suggested format, or use the buttons to the right'
					)
				) : null
			);
		}
	});


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(70);
	var esUtils = __webpack_require__(2);
	
	var icon_classes = {
		angle_up: 'fa fa-angle-up',
		angle_down: 'fa fa-angle-down'
	};
	
	var TypeIn = dd.createClass({
		getInitialState: function(){
			return {text_value: this.props.value};
		},
		componentWillReceiveProps: function(next_props){
			if(this.props.value !== next_props.value){
				this.setState({text_value: next_props.value});
			}
		},
		__onChange: function(e){
			this.setState({text_value: e.target.value});
		},
		__onBlur: function(){
			this.props.onValue(this.state.text_value);
		},
		__onKeyUp: function(e){
			if(e.keyCode == 13){//enter key
				e.preventDefault();
				this.props.onValue(this.state.text_value);
			}
		},
		render: function(){
			return dd.input({
				type: 'text',
				className: 'form-control input-sm',
				placeholder: this.props.placeholder,
				maxLength: 2,
				value: this.state.text_value,
				onBlur: this.__onBlur,
				onKeyUp: this.__onKeyUp,
				onChange: this.__onChange
			});
		}
	});
	
	module.exports = dd.createClass({
		__changeTime: function(doChange){
			var onTimeChanged = this.props.onTimeChanged;
			var d = _.isDate(this.props.value) ? _.cloneDeep(this.props.value) : new Date(0, -1, 0, 0, 0, 0, 0);
	
			//save these so we ensure adding a bunch of hours doesn't change the day
			var year = d.getFullYear();
			var month = d.getMonth();
			var day = d.getDate();
	
			var changes = doChange(d.getHours(), d.getMinutes());
			if(_.isNumber(changes.hour) && !_.isNaN(changes.hour)){
				d.setHours(changes.hour);
			}
			if(_.isNumber(changes.minute) && !_.isNaN(changes.minute)){
				d.setMinutes(changes.minute);
			}
			d.setFullYear(year);
			d.setMonth(month);
			d.setDate(day);
	
			onTimeChanged(d.getHours(), d.getMinutes());
		},
		__increment: function(field, inc){
			var self = this;
			return esUtils.wrapPreventDefault(function(){
				self.__changeTime(function(hour, minute){
					if(field === 'hour'){
						return {hour: hour + inc};
					}else if(field === 'min'){
						return {minute: minute + inc};
					}
				});
			});
		},
		__onTypeHour: function(str){
			var new_hour = _.parseInt(str.replace(/[^[0-9]]/g, ""), 10) || 0;
			this.__changeTime(function(){
				return {hour: new_hour};
			});
		},
		__onTypeMinutes: function(str){
			var new_minute = _.parseInt(str.replace(/[^[0-9]]/g, ""), 10) || 0;
			this.__changeTime(function(){
				return {minute: new_minute};
			});
		},
		__onTypeAMPM: function(ampm){
			this.__changeTime(function(hour){
				var inc = 0;
				if(/am/i.test(ampm)){
					inc += hour < 12 ? 0 : 12;
				}else if(/pm/i.test(ampm)){
					inc += hour < 12 ? 12 : 0;
				}
				return {hour: hour + inc};
			});
		},
		render: function(){
			var self = this;
			var value = _.isDate(this.props.value) ? this.props.value : null;
	
			var hours = value ? dateFormat(value, 'h') : '';
			var minutes = value ? dateFormat(value, 'MM') : '';
			var ampm = value ? dateFormat(value, 'TT') : '';
	
			var incBtn = function(field, inc){
				var onClick = self.__increment(field, inc);
				return dd.button({className: 'btn btn-default', onClick: onClick},
					dd.i({
						className: inc > 0 ? icon_classes.angle_up : icon_classes.angle_down
					})
				);
			};
	
			return dd.div({className: 'TimePicker'},
				dd.table(null,
					dd.tbody(null,
						dd.tr(null,
							dd.td(null, incBtn('hour', 1)),
							dd.td(),
							dd.td(null, incBtn('min', 5)),
							dd.td(),
							dd.td(null, incBtn('hour', 12))
						),
						dd.tr(null,
							dd.td(null, TypeIn({
								placeholder: 'HH',
								value: hours,
								onValue: this.__onTypeHour
							})),
							dd.td(null, ' : '),
							dd.td(null, TypeIn({
								placeholder: 'MM',
								value: minutes,
								onValue: this.__onTypeMinutes
							})),
							dd.td(null, ' : '),
							dd.td(null, TypeIn({
								placeholder: 'AM/PM',
								value: ampm,
								onValue: this.__onTypeAMPM
							}))
						),
						dd.tr(null,
							dd.td(null, incBtn('hour', -1)),
							dd.td(),
							dd.td(null, incBtn('min', -5)),
							dd.td(),
							dd.td(null, incBtn('hour', -12))
						)
					)
				)
			);
		}
	});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	var HoverMixin = __webpack_require__(49);
	
	var esUtils = __webpack_require__(2);
	var FormInputMixin = __webpack_require__(38);
	
	__webpack_require__(194);
	var DatePickerCalendar = __webpack_require__(195);
	var DateTypeIn = __webpack_require__(196);
	var TimePicker = __webpack_require__(197);
	
	var component = dd.createClass({
		mixins: [FormInputMixin, HoverMixin],
		__onChange: function(date){
			this._input_newValue(_.isDate(date) ? date : null);
		},
	
		////////////////////////////////////////////////////////////////////////
		getInitialState: function(){
			return {show_calendar: false, show_timepicker: false};
		},
		__toggleCalendar: esUtils.wrapPreventDefault(function(){
			this.setState({show_calendar: !this.state.show_calendar, show_timepicker: false});
		}),
		__toggleTimepicker: esUtils.wrapPreventDefault(function(){
			this.setState({show_calendar: false, show_timepicker: !this.state.show_timepicker});
		}),
		__onDatePicked: function(year, month, day){
			var d = _.isDate(this.props.value) ? _.cloneDeep(this.props.value) : new Date(0, -1, 0, 0, 0, 0, 0);
			d.setFullYear(year);
			d.setMonth(month - 1, day);//You must set the date in setMonth b/c otherwise they will mess with each other in surprising ways (what the heck javascript!)
			this.__onChange(d);
			this.setState({show_calendar: false});
		},
		__onTimeChanged: function(hours, minute){
			var d = _.isDate(this.props.value) ? _.cloneDeep(this.props.value) : new Date();
			d.setHours(hours);
			d.setMinutes(minute);
			this.__onChange(d);
		},
		__onDateSet: function(new_date){
			this.__onChange(_.cloneDeep(new_date));
		},
		hoverable_onUserLeftHoverable: function(){
			if(this.state.show_calendar || this.state.show_timepicker){//only setState if needed
				this.setState({show_calendar: false, show_timepicker: false});
			}
		},
		__stopClick: esUtils.wrapPreventDefault(_.noop),
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
	
			var pick_date = _.has(field, 'pick_date') ? !!field.pick_date : true;//by default be a date picker
			var pick_time = !!field.pick_time;//by default don't pick time
	
			if(field.read_only){
				var format_parts = [];
				if(pick_date){
					format_parts.push('mm/dd/yyyy');
				}
				if(pick_time){
					if(_.isDate(value) && value.getHours() === 0 && value.getMinutes() === 0){
					}else{
						format_parts.push(' "-" h:MM TT');
					}
				}
				return dd.p({className: 'form-control-static'},
					_.isDate(value) ? esUtils.format_date(value, format_parts.join(' ')) : ''
				);
			}
	
			return dd.div({
					className: 'Date input-group',
					onClick: this.__toggleCalendar,
					onMouseEnter: this.hoverable_onMouseEnter,
					onMouseLeave: this.hoverable_onMouseLeave
				},
				DateTypeIn({pick_date: pick_date, pick_time: pick_time, value: value, onDateSet: this.__onDateSet, placeholder: field.placeholder}),
				dd.span({className: 'input-group-btn' + (this.state.show_calendar || this.state.show_timepicker ? ' open' : ''), style: {verticalAlign: 'top'}},
					!pick_date ? null : dd.button({type: 'button', className: 'btn btn-default', onClick: this.__toggleCalendar},
						dd.i({className: 'fa fa-calendar'})
					),
					!pick_time ? null : dd.button({type: 'button', className: 'btn btn-default', onClick: this.__toggleTimepicker},
						dd.i({className: 'fa fa-clock-o'})
					),
					!(this.state.show_calendar || this.state.show_timepicker) ? null : dd.div({
							className: 'dropdown-menu pull-right',
							onClick: this.__stopClick
						},
						!this.state.show_calendar ? null : DatePickerCalendar({field: field, value: value, onDatePicked: this.__onDatePicked}),
						!this.state.show_timepicker ? null : TimePicker({field: field, value: value, onTimeChanged: this.__onTimeChanged})
					)
				)
			);
		}
	});
	
	module.exports = {
		component: component,
		validate: function(value){
			if(!_.isDate(value)){
				return 'Please enter your date';
			}
			return true;
		}
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var FormInputMixin = __webpack_require__(38);
	
	var component = dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			this._input_newValue(e.target.files);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
	
			if(typeof FileList === 'undefined'){
				return dd.p({className: 'form-control-static text-danger'},
					'Your browser is outdated and will not work with this file upload.'
				);
			}
			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					value
				);
			}
			return dd.input({
				type: 'file',
				name: this.props.field_path,
				className: 'form-control',
				style: {border: 0, boxShadow: 'none', paddingLeft: 0, paddingRight: 0},
				onChange: this.__onChange,
				multiple: field.multiple === true ? true : false
			});
		}
	});
	
	module.exports = {
		component: component,
		validate: function(value){
			return ((value instanceof FileList) && value.length > 0) || 'You must select a file to upload';
		}
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var FormInputMixin = __webpack_require__(38);
	
	var placeholder_value = '__some$random$uuid__';
	
	var component = dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			var field = this.props.field;
			var new_value = e.target.value;
			this._input_newValue(_.has(field.options, new_value) ? new_value : null);
		},
		render: function(){
			var field = this.props.field;
			var value = _.has(field.options, this.props.value) ? this.props.value : (field.placeholder ? placeholder_value : '');
	
			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					_.has(field.options, value) ? field.options[value] : value
				);
			}
	
			var options = _.pairs(field.options);
			if(!field.dont_sort_options){
				options = _.sortBy(options, function(option){
					return _.isString(option[1]) ? option[1].toUpperCase() : 0;
				});
			}
	
			return dd.select({className: 'form-control' + (field.disabled ? ' disabled' : ''), value: value, name: this.props.field_path, onChange: this.__onChange, disabled: field.disabled ? 'disabled' : null},
				dd.option({value: placeholder_value}, field.placeholder ? field.placeholder : ''),
				_.map(options, function(option){
					return dd.option({value: option[0], key: option[0]}, option[1]);
				})
			);
		}
	});
	
	module.exports = {
		component: component,
		validate: function(value, field){
			if(!_.has(field.options, value)){
				return 'Please make a selection';
			}
			return true;
		}
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	
	module.exports = {
		component: dd.createClass({
			render: function(){
				var field = this.props.field;
				var value = this.props.value;
				return dd.p({className: 'form-control-static'},
					field.options && _.has(field.options, value) ? field.options[value] : value
				);
			}
		}),
		validate: function(){
			return true;
		}
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(12);
	var dd = __webpack_require__(7);
	var FormInputMixin = __webpack_require__(38);
	
	var component = dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			this._input_newValue(e.target.value);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
	
			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					value
				);
			}
	
			var p = {
				type: field.type || 'text',
				placeholder: field.placeholder || null,
				className: 'form-control',
				value: value || '',
				name: this.props.field_path,
				onChange: this.__onChange
			};
			if(p.type === "number"){
				_.each(["min", "max", "step"], function(key){
					if(_.has(field, key) && _.isNumber(field[key])){
						p[key] = field[key];
					}
				});
			}
			return dd.input(p);
		}
	});
	
	module.exports = {
		component: component
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var FormInputMixin = __webpack_require__(38);
	
	var component = dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			this._input_newValue(e.target.value);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
	
			if(field.read_only){
				return dd.p({className: 'form-control-static', style: {whiteSpace: 'pre-wrap'}},
					value
				);
			}
	
			return dd.textarea({
				rows: field.rows > 0 ? field.rows : 3,
				placeholder: field.placeholder || null,
				className: 'form-control',
				value: value || '',
				name: this.props.field_path,
				onChange: this.__onChange
			});
		}
	});
	
	module.exports = {
		component: component
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var esUtils = __webpack_require__(2);
	var FormInputMixin = __webpack_require__(38);
	
	var ranges = [
		[0, 0],
		[0, 1000],
		[1000, 2500],
		[2500, 5000],
		[5000, 7500],
		[7500, 10000],
		[10000, 15000],
		[15000, 20000],
		[20000, Infinity]
	];
	var ranges_options = _.map(ranges, function(range){
		if(_.isArray(range)){
			range = esUtils.format_budget_range(range);
		}
		return range;
	});
	
	var placeholder_value = '__some$random$uuid__';
	var getSelectedOption = function(value){
		if(_.isArray(value)){
			var i;
			for(i = 0; i < ranges.length; i++){
				if(_.isEqual(ranges[i], value)){
					return i;
				}
			}
		}
		return placeholder_value;
	};
	
	
	module.exports = {
		component: dd.createClass({
			mixins: [FormInputMixin],
			__onChange: function(e){
				var new_value = ranges[e.target.value];
				this._input_newValue(_.isArray(new_value) ? new_value : null);
			},
			render: function(){
				var field = this.props.field;
				var value = getSelectedOption(this.props.value);
	
				if(field.read_only){
					return dd.p({className: 'form-control-static'},
						_.has(ranges_options, value) ? ranges_options[value] : null
					);
				}
	
				return dd.select({
						className: 'form-control' + (field.disabled ? ' disabled' : ''),
						value: value,
						name: this.props.field_path,
						onChange: this.__onChange,
						disabled: field.disabled ? 'disabled' : null
					},
					dd.option({value: placeholder_value}, field.placeholder || '-- select price range --'),
					_.map(ranges_options, function(text, i){
						return dd.option({key: i, value: i}, text);
					})
				);
			}
		}),
		validate: function(value){
			return _.isArray(value) || 'Please select a price range';
		}
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var FormInputMixin = __webpack_require__(38);
	
	var placeholder_value = '__some$random$uuid__';
	
	module.exports = {
		component: dd.createClass({
			mixins: [FormInputMixin],
			__onChange: function(e){
				var new_value = e.target.value;
				this._input_newValue(this.__isOption(new_value) ? new_value : null);
			},
			__getCountryList: function(){
				var field = this.props.field;
				var Displaylists = field.Displaylists;
				var u_lists = (Displaylists && Displaylists.universal) || {};
				return u_lists.countrylist || {};//It should come pre-sorted from the server
			},
			__isOption: function(value){
				return _.includes(_.map(this.__getCountryList(), 'sc'), value);
			},
			render: function(){
				var field = this.props.field;
				var value = this.props.value;
	
				if(field.read_only){
					return dd.p({className: 'form-control-static'},
						this.__isOption(value) ? _.find(this.__getCountryList(),function(country){
							return country.sc === value;
						}).lc : value
					);
				}
	
				value = this.__isOption(value) ? value : placeholder_value;
	
				return dd.select({
						className: 'form-control' + (field.disabled ? ' disabled' : ''),
						value: value,
						name: this.props.field_path,
						onChange: this.__onChange,
						disabled: field.disabled ? 'disabled' : null
					},
					dd.option({value: placeholder_value}, field.placeholder || '-- select country --'),
					_.map(this.__getCountryList(), function(country, i){
						return dd.option({key: i, value: country.sc}, country.lc);
					})
				);
			}
		}),
		validate: function(value){
			return !!value || 'Please select a country';
		}
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var _ = __webpack_require__(12);
	var FormInputMixin = __webpack_require__(38);
	
	var placeholder_value = '__some$random$uuid__';
	
	module.exports = {
		component: dd.createClass({
			mixins: [FormInputMixin],
			__onChange: function(e){
				var new_value = e.target.value;
				this._input_newValue(this.__isOption(new_value) ? new_value : null);
			},
			__onTextChange: function(e){
				this._input_newValue(e.target.value);
			},
			__getStateList: function(){
				var field = this.props.field;
				var Displaylists = field.Displaylists;
				var country = field.country;
	
				var u_lists = (Displaylists && Displaylists.universal) || {};
				return _.filter(u_lists.statelist, function(state){
					return state.sc == country;
				});//It should come pre-sorted from the server
			},
			__isOption: function(value){
				var countrylist = this.__getStateList();
				return _.includes(_.map(countrylist, 'ss'), value);
			},
			render: function(){
				var field = this.props.field;
				var value = this.props.value;
				var states = this.__getStateList();
	
				if(field.read_only){
					return dd.p({className: 'form-control-static'},
						this.__isOption(value) ? _.find(states,function(state){
							return state.ss === value;
						}).ls : value
					);
				}
	
				if(_.isEmpty(states)){
					return dd.input({
						type: 'text',
						placeholder: field.placeholder || 'State/Prov',
						className: 'form-control',
						value: value || '',
						name: this.props.field_path,
						onChange: this.__onTextChange
					});
				}
	
				value = this.__isOption(value) ? value : placeholder_value;
	
				return dd.select({
						className: 'form-control' + (field.disabled ? ' disabled' : ''),
						value: value,
						name: this.props.field_path,
						onChange: this.__onChange,
						disabled: field.disabled ? 'disabled' : null
					},
					dd.option({value: placeholder_value}, field.placeholder || '-- select state/province --'),
					_.map(states, function(state, i){
						return dd.option({key: i, value: state.ss}, state.ls);
					})
				);
			}
		}),
		validate: function(value){
			return !!value || 'Please select a state/province';
		}
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _InputTypes = __webpack_require__(146);
	
	var _InputTypes2 = _interopRequireDefault(_InputTypes);
	
	var _RadioInput = __webpack_require__(242);
	
	var _RadioInput2 = _interopRequireDefault(_RadioInput);
	
	var _DropFileInput = __webpack_require__(237);
	
	var _DropFileInput2 = _interopRequireDefault(_DropFileInput);
	
	var _InitialsInput = __webpack_require__(239);
	
	var _InitialsInput2 = _interopRequireDefault(_InitialsInput);
	
	var _EvaluationInput = __webpack_require__(238);
	
	var _EvaluationInput2 = _interopRequireDefault(_EvaluationInput);
	
	var _NewSelectInput = __webpack_require__(240);
	
	var _NewSelectInput2 = _interopRequireDefault(_NewSelectInput);
	
	var _crm = __webpack_require__(236);
	
	var _crm2 = _interopRequireDefault(_crm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*eslint no-unused-vars:0 no-alert:0 */
	/*global localStorage localforage alert */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var ReactDOM = __webpack_require__(142);
	var RadioMixin = __webpack_require__(20);
	var AuthedUserSession = __webpack_require__(4);
	var Constants = __webpack_require__(13);
	__webpack_require__(177);
	
	var Balboa = __webpack_require__(21);
	Balboa.init({
	  extend_with_params: AuthedUserSession.balboa
	});
	
	//setting up inputs for react-loose-forms
	
	
	__webpack_require__(425).install(_InputTypes2.default);
	_InputTypes2.default.setInputType("esState", __webpack_require__(179));
	_InputTypes2.default.setInputType("esCountry", __webpack_require__(178));
	_InputTypes2.default.setInputType("groupCodeSelect", __webpack_require__(283));
	
	
	_InputTypes2.default.setInputType("radio", _RadioInput2.default);
	_InputTypes2.default.setInputType("drop-file-input", _DropFileInput2.default);
	_InputTypes2.default.setInputType("initials", _InitialsInput2.default);
	_InputTypes2.default.setInputType("evaluation", _EvaluationInput2.default);
	_InputTypes2.default.setInputType("newselect", _NewSelectInput2.default);
	
	//services
	var Event = __webpack_require__(372);
	var AwardWallet = __webpack_require__(366);
	var TripIt = __webpack_require__(381);
	var Calendar = __webpack_require__(367);
	var Hashbang = __webpack_require__(181);
	var Dashboard = __webpack_require__(370);
	var BugHunter = __webpack_require__(180);
	var MPMessages = __webpack_require__(182);
	var EventSearch = __webpack_require__(373);
	var Marketplace = __webpack_require__(375);
	var Authenticate = __webpack_require__(365);
	var Displaylists = __webpack_require__(371);
	var SpeakerLists = __webpack_require__(379);
	var EventServices = __webpack_require__(374);
	var UnreadMessages = __webpack_require__(183);
	var ContactGrabber = __webpack_require__(369);
	var UserPreferences = __webpack_require__(382);
	var NewAppVersionChecker = __webpack_require__(376);
	var Thirdpartyconnection = __webpack_require__(380);
	var ClientPortalConfig = __webpack_require__(368);
	var QuickBooks = __webpack_require__(377);
	var Sitelists = __webpack_require__(378);
	
	//pages
	var MainPage = __webpack_require__(333);
	var SigninPage = __webpack_require__(361);
	var MarketplacePage = __webpack_require__(244);
	
	
	var AccountSettings = __webpack_require__(234);
	
	var app = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      hash_parts: [],
	      hash_history: [],
	      Displaylists: {},
	      Sitelists: {}
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      Hashbang_changed: function Hashbang_changed(url_parts) {
	        var hash_parts = [];
	        var hash = url_parts && url_parts.hash;
	        if (/^\//.test(hash)) {
	          //make sure it's a string and it starts with "/"
	          hash_parts = _.reject(_.map(hash.split("/"), function (part) {
	            return part.trim();
	          }), _.isEmpty);
	        }
	
	        var old_url = "/" + this.state.hash_parts.join("/");
	        if (old_url === "/" + hash_parts.join("/")) {
	          return; //no change
	        }
	
	        if (_.head(hash_parts) === "jobs") {
	          radio("Hashbang_set").broadcast("/marketplace");
	        }
	
	        var self = this;
	        var saveState = function saveState() {
	          self.setState({
	            hash_parts: hash_parts,
	            hash_history: [old_url].concat(self.state.hash_history)
	          });
	        };
	        if (/^\/events\/[1-9][0-9]*/i.test(old_url)) {
	          //if the last url was an event being edited, let's checkUnsavedEventChangesBeforeContinuing
	          radio("checkUnsavedEventChangesBeforeContinuing").broadcast(esUtils.toInt(this.state.hash_parts[1]), saveState, function () {
	            radio("Hashbang_set").broadcast(old_url);
	          });
	        } else {
	          saveState();
	        }
	      },
	      Displaylists_get_succeeded: function Displaylists_get_succeeded(key, Displaylists) {
	        var self = this;
	        var signature = localStorage.getItem("Displaylists_signature") !== null ? localStorage.getItem("Displaylists_signature") : "";
	
	        if (Displaylists.signature !== undefined && Displaylists.signature != signature) {
	          localStorage.removeItem("Displaylists_signature");
	          localforage.setItem("Displaylists", Displaylists, function (err, value) {
	            if (err === null && value !== null && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	              localStorage.setItem("Displaylists_signature", Displaylists.signature);
	            }
	          });
	        }
	        if (Displaylists.signature === undefined) {
	          var Displaylists_local = "";
	          localforage.getItem("Displaylists", function (err, value) {
	            if (value !== null) {
	              Displaylists = value;
	              self.setState({ Displaylists: Displaylists });
	            } else {
	              alert("An error occurred loading display lists. Please reload the page.");
	            }
	          });
	        } else {
	          self.setState({ Displaylists: Displaylists });
	        }
	      },
	      invalidate_Displaylists_cache: function invalidate_Displaylists_cache() {
	        this.setState({ Displaylists: {} });
	      },
	      Sitelists_get_succeeded: function Sitelists_get_succeeded(key, Sitelists) {
	        var self = this;
	        var company_id = _.get(Sitelists, ["sitelists", "company", "id"]);
	        var signature = localStorage.getItem("Sitelists_signature_" + company_id) !== null ? localStorage.getItem("Sitelists_signature_" + company_id) : "";
	
	        if (Sitelists.signature !== undefined && Sitelists.signature != signature) {
	          localStorage.removeItem("Sitelists_signature_" + company_id);
	          localforage.setItem("Sitelists_" + company_id, Sitelists, function (err, value) {
	            if (err === null && value !== null && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	              localStorage.setItem("Sitelists_signature_" + company_id, Sitelists.signature);
	            }
	          });
	        }
	        if (Sitelists.signature === undefined) {
	          var Sitelists_local = "";
	          localforage.getItem("Sitelists_" + company_id, function (err, value) {
	            if (value !== null) {
	              Sitelists = value;
	              self.setState({ Sitelists: Sitelists });
	            } else {
	              alert("An error occurred loading site lists. Please reload the page.");
	            }
	          });
	        } else {
	          self.setState({ Sitelists: Sitelists });
	        }
	      }
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    Event.init();
	    AwardWallet.init();
	    TripIt.init();
	    Calendar.init();
	    Dashboard.init();
	    BugHunter.init();
	    MPMessages.init();
	    EventSearch.init();
	    Marketplace.init();
	    Authenticate.init();
	    Displaylists.init();
	    SpeakerLists.init();
	    EventServices.init();
	    UnreadMessages.init();
	    ContactGrabber.init();
	    UserPreferences.init();
	    NewAppVersionChecker.init();
	    Thirdpartyconnection.init();
	    ClientPortalConfig.init();
	    QuickBooks.init();
	    Sitelists.init();
	  },
	  componentDidMount: function componentDidMount() {
	    Hashbang.init();
	    radio("Displaylists_get").broadcast();
	    radio("Sitelists_get").broadcast({
	      id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
	    });
	  },
	  render: function render() {
	    var _state = this.state,
	        hash_history = _state.hash_history,
	        Displaylists = _state.Displaylists,
	        Sitelists = _state.Sitelists;
	
	    var display_lists = _.merge(Displaylists, {
	      sitelists: _.get(Sitelists, ["sitelists"])
	    });
	    var url_args = this.state.hash_parts;
	    var page = _.first(url_args);
	    var props = {
	      url_args: url_args,
	      hash_history: hash_history,
	      Displaylists: display_lists
	    };
	    //console.log(AuthedUserSession);
	    if (!AuthedUserSession.is_logged_in) {
	      return SigninPage(_.assign({}, props, {
	        login_locked: _.get(Sitelists, ["login_locked"], false),
	        maintenance_notices: _.get(Sitelists, ["maintenance_notices"], [])
	      }));
	    } else if ("marketplace" === page) {
	      return MarketplacePage(props);
	    } else if ("account_settings" === page) {
	      return AccountSettings(props);
	    } else if ("crm" === page) {
	      return (0, _crm2.default)(props);
	    } else {
	      return MainPage(props);
	    }
	  }
	});
	
	module.exports = app;
	
	if (typeof window !== "undefined") {
	  window.LOAD_EVENT = function (event_id) {
	    radio("Hashbang_set").broadcast("/events/" + event_id);
	  };
	
	  var div = document.getElementById("react-root-mount");
	  ReactDOM.render(app(), div);
	  document.body.appendChild(div);
	}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var dateformat = __webpack_require__(41);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var RadioServiceMixin = __webpack_require__(14);
	
	var getPastNMonths = function getPastNMonths(n_months) {
		var date = new Date();
		date.setDate(1);
		date.setHours(0);
		return _.map(_.range(0, n_months), function () {
			var m = {
				name: dateformat(date, "mmmm yyyy"),
				year: esUtils.toInt(dateformat(date, "yyyy")),
				month: esUtils.toInt(dateformat(date, "m"))
			};
			date.setMonth(date.getMonth() - 1);
			return m;
		});
	};
	
	var MonthToggle = dd.createClass({
		__onClick: esUtils.wrapPreventDefault(function () {
			var _props = this.props,
			    year = _props.year,
			    month = _props.month,
			    toggleMonth = _props.toggleMonth;
	
			toggleMonth(year, month);
		}),
		render: function render() {
			var _props2 = this.props,
			    name = _props2.name,
			    is_locked = _props2.is_locked,
			    is_loading = _props2.is_loading;
	
			var classes = ["fa"];
			if (is_loading) {
				classes.push("fa-spinner");
				classes.push("fa-spin");
			} else if (is_locked) {
				classes.push("fa-unlock");
				classes.push("text-warning");
			} else {
				classes.push("fa-lock");
				classes.push("text-success");
			}
			return dd.a({ href: "#", className: "list-group-item", onClick: this.__onClick }, dd.span({ style: { display: "inline-block", width: "1.5em", fontSize: "1.5em" } }, dd.i({ className: classes.join(" ") })), " " + name);
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		getInitialState: function getInitialState() {
			return { last_month_clicked: null, month_data: null };
		},
		RadioService_setup: function RadioService_setup() {
			return {
				AccountingLock_read: { key: "callService", on: {
						succeeded: function succeeded(data) {
							this.setState({ month_data: data });
						}
					} },
				AccountingLock_toggle: { key: "callService", on: {
						succeeded: function succeeded(data) {
							this.setState({ month_data: data });
						}
					} }
			};
		},
		componentDidMount: function componentDidMount() {
			this.RadioService_callService("AccountingLock_read");
		},
		__toggleMonth: function __toggleMonth(year, month) {
			this.setState({ last_month_clicked: year + "-" + month });
			this.RadioService_callService("AccountingLock_toggle", { year: year, month: month });
		},
		render: function render() {
			var Displaylists = this.props.Displaylists;
	
			var ajax_read = this.state.AccountingLock_read;
			var ajax_toggle = this.state.AccountingLock_toggle;
			var _state = this.state,
			    last_month_clicked = _state.last_month_clicked,
			    month_data = _state.month_data;
	
	
			return LoadingWrap({ is_loading: _.isEmpty(Displaylists) || ajax_read.waiting || ajax_toggle.waiting, glass: true }, ErrorAlert({ message: ajax_read.error }), ErrorAlert({ message: ajax_toggle.error }), dd.h2({ style: { marginTop: 0 } }, "Click the lock icon next to a month to change accounting lock status."), dd.div({ className: "row" }, dd.div({ className: "col-sm-1" }), dd.div({ className: "col-sm-4" }, dd.div({ className: "list-group" }, _.map(getPastNMonths(60), function (_ref) {
				var year = _ref.year,
				    month = _ref.month,
				    name = _ref.name;
	
				return MonthToggle({
					key: name,
					name: name, year: year, month: month,
					is_locked: _.isEmpty(esUtils.getIn(month_data, [year, month])),
					is_loading: (ajax_read.waiting || ajax_toggle.waiting) && (last_month_clicked === null || last_month_clicked === year + "-" + month),
					toggleMonth: this.__toggleMonth
				});
			}, this)))), dd.div({ className: "clearfix" }));
		}
	});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	
	
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var ErrorAlert = __webpack_require__(6);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var ServicesUtils = __webpack_require__(33);
	
	var DisplayfieldsForm = dd.createClass({
	    mixins: [FormMixin],
	
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props;
	    },
	
	    getInitialValues: function getInitialValues(props) {
	        return _.get(props, "initvals", []);
	    },
	
	    buildFields: function buildFields() {
	        var key = void 0;
	        var fields = {};
	        var data = _.get(this.state, "data", {});
	        var tabs = _.get(this.props, 'config.displayfields.tabs', []);
	
	        _.each(tabs, function (tab) {
	
	            if (!tab.hasOwnProperty('tabtype') || !tab.hasOwnProperty('label')) return; //got some bad data to skip
	
	            //the tab itself
	            key = ["tab", tab.tabtype, "hidden"].join("|");
	            fields[key] = {
	                label: "Entire " + tab.label.toUpperCase() + " tab",
	                type: "select",
	                options: {
	                    SHOW: "show",
	                    HIDE: "hide"
	                },
	                help_text: "Do you want clients to be able to see this tab?",
	                validate: FormUtils.v.required
	            };
	
	            if ("contacts" !== tab.tabtype && Object.keys(_.get(tab, "fieldlist", {})).length < 2) return; //if there's only one field (ie, "othernote") then hiding/showing the tab itself is sufficient
	            if ("HIDE" === _.get(data, [key], "SHOW")) return; //individual fields only if the tab as a whole isn't hidden
	
	            //fields within the tab
	            _.each(_.get(tab, "fieldlist", {}), function (fielddata, fieldname) {
	                key = ["tab", tab.tabtype, "field", fieldname, "hidden"].join("|");
	                fields[key] = {
	                    label: fielddata.label,
	                    type: "select",
	                    options: {
	                        SHOW: "show",
	                        HIDE: "hide"
	                    },
	                    validate: FormUtils.v.required
	                };
	
	                //if ("HIDE" === _.get(data, [key])) return;//editable control only if the field is not hidden
	                key = ["tab", tab.tabtype, "field", fieldname, "editable"].join("|");
	                fields[key] = {
	                    label: "client can update",
	                    type: "select",
	                    options: {
	                        "ALWAYS": "client can change",
	                        "NEVER": "client cannot change",
	                        "WHENPENDING": "when offer pending is ON"
	                    },
	                    validate: FormUtils.v.required
	                };
	            });
	        });
	        return fields;
	    },
	    __discardChanges: esUtils.wrapPreventDefault(function () {
	        this._form_reset();
	    }),
	
	    render: function render() {
	        var fields = this.buildFields();
	        var changes_made = this._form_areChangesMade();
	        var error_msg = _.get(this.props, "error_msg");
	        var success_msg = _.get(this.props, "success_msg");
	        var parts = void 0,
	            key2 = void 0,
	            tabtype = void 0;
	        var self = this;
	        var errors = this.state.errors || {};
	        var tablabel = void 0;
	        var layoutfields = {};
	
	        if (_.isEmpty(fields)) return null;
	
	        //layout the tabs and fields
	        _.each(fields, function (field, key) {
	            parts = key.split('|');
	            tabtype = parts[parts.indexOf('tab') + 1];
	            _.set(layoutfields, [tabtype, "fields", key], field);
	            if (-1 === parts.indexOf('field')) {
	                _.set(layoutfields, [tabtype, "layout"], _.get(layoutfields, [tabtype, "layout"], []).concat([[key, null]]));
	            } else {
	                if ("editable" == parts[parts.length - 1]) {
	                    parts[parts.length - 1] = "hidden";
	                    key2 = parts.join("|");
	                    _.set(layoutfields, [tabtype, "layout"], _.get(layoutfields, [tabtype, "layout"], []).concat([[key2, key]]));
	                }
	            }
	        });
	
	        _.each(layoutfields, function (v, tabtype) {
	            tablabel = _.result(_.find(_.get(self.props, ["config", "displayfields", "tabs"]), { "tabtype": tabtype }), "label");
	            layoutfields[tabtype]["render"] = _react2.default.createElement(
	                "div",
	                { className: "portaltab", style: { marginTop: "2em" }, key: tabtype },
	                _react2.default.createElement(
	                    "h4",
	                    { style: { marginLeft: "2em" } },
	                    tablabel,
	                    " tab"
	                ),
	                HorizontalFields({
	                    fields: _.get(layoutfields, [tabtype, "fields"], []),
	                    errors: errors,
	                    buildInput: self._form_buildInput,
	                    layout: _.get(layoutfields, [tabtype, "layout"], [])
	                })
	            );
	        });
	
	        return _react2.default.createElement(
	            "form",
	            { className: "form-horizontal", onSubmit: this._form_onSubmit },
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Choose which fields the client can see / change"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://espeakers.com/wiki/Client_Portal#How_do_I_choose_which_fields_my_customers_can_see_or_change.3F", target: "_blank" },
	                    "Learn more about the Client Portal  ",
	                    _react2.default.createElement("i", { style: { marginLeft: "0.5em", fontSize: "1.0em" }, className: "fa fa-external-link" })
	                )
	            ),
	            _.map(layoutfields, function (v) {
	                return v["render"];
	            }),
	            SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })),
	            success_msg && !changes_made && _react2.default.createElement(
	                "div",
	                { className: "alert alert-success" },
	                "Saved."
	            ),
	            ErrorAlert({
	                message: error_msg
	            })
	        );
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_displayfields")],
	
	    getInitialState: function getInitialState(props) {
	        return {
	            sid: -1,
	            data: {},
	            is_saving: false,
	            error_msg: null,
	            success_msg: null
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        this.setState({ sid: props.config.sid, config: props.config, data: this.__convertDisplayfieldsToFormData(props.config.displayfields), success_msg: null, error_msg: null });
	    },
	
	
	    //translate the displayfield data from xhr into the initvalues the form needs. This gets reversed in ClientportalController->convertFormDataToDisplayFields()
	    __convertDisplayfieldsToFormData: function __convertDisplayfieldsToFormData(displayfields) {
	        var initvals = { sid: _.get(this.state, "sid", '') };
	        var key = void 0;
	
	        var tabs = _.get(displayfields, "tabs", []);
	        _.each(tabs, function (tab) {
	            key = ["tab", tab.tabtype, "hidden"].join("|");
	            initvals[key] = _.get(tab, "hidden", true) ? "HIDE" : "SHOW";
	
	            _.each(_.get(tab, "fieldlist", []), function (fielddata, fieldname) {
	                key = ["tab", tab.tabtype, "field", fieldname, "editable"].join("|");
	                initvals[key] = _.get(fielddata, "editable", "never").toUpperCase();
	                key = ["tab", tab.tabtype, "field", fieldname, "hidden"].join("|");
	                initvals[key] = _.get(fielddata, "hidden", true) ? "HIDE" : "SHOW";
	            });
	        });
	
	        return initvals;
	    },
	
	    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into DisplayfieldsForm() as a parameter
	    __onSubmit: function __onSubmit(data) {
	        var self = this;
	
	        radio('save_ClientPortal_displayfields').broadcast(data.sid, data, function (sid, data) {
	
	            //setting state.config results in new initvals being passed to DisplayfieldsForm
	            if (_.get(self, "state.sid") == sid) {
	                self.setState({
	                    sid: sid,
	                    config: data,
	                    is_saving: false,
	                    error_msg: null,
	                    success_msg: "Saved."
	                });
	            }
	        }, function (sid, message) {
	            self.setState({ error_msg: message, success_msg: null });
	        });
	    },
	    __selectTextInput: function __selectTextInput(e) {
	        e.target.setSelectionRange(0, e.target.value.length);
	    },
	    render: function render() {
	        var _props = this.props,
	            speaker = _props.speaker,
	            Displaylists = _props.Displaylists;
	
	
	        return dd.div({}, DisplayfieldsForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            initvals: this.__convertDisplayfieldsToFormData(_.get(this.state, "config.displayfields")),
	            config: _.get(this.state, "config"),
	            onSubmit: this.__onSubmit,
	            error_msg: _.get(this.state, "error_msg"),
	            success_msg: _.get(this.state, "success_msg")
	        }));
	    }
	});

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	
	
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var ServicesUtils = __webpack_require__(33);
	var ErrorAlert = __webpack_require__(6);
	
	var SettingsForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props;
	    },
	    getInitialValues: function getInitialValues(props) {
	
	        return _.get(props, "initvals", {});
	    },
	    buildFields: function buildFields() {
	        return {
	            contact_url: {
	                label: 'contact us URL',
	                type: 'text',
	                placeholder: 'https://mywebsite.com/contact',
	                validate: FormUtils.v.optional
	                // },
	                // sales_url: {
	                //     label: 'product sales URL',
	                //     type: 'text',
	                //     placeholder: 'https://mywebsite.com/salesinfo',
	                //     validate: FormUtils.v.optional
	                // },
	                // recording_url: {
	                //     label: 'recording permission sales URL',
	                //     type: 'text',
	                //     placeholder: 'https://mywebsite.com/recordinginfo',
	                //     validate: FormUtils.v.optional
	                // }
	            }
	        };
	    },
	    __discardChanges: esUtils.wrapPreventDefault(function () {
	        this._form_reset();
	    }),
	
	    render: function render() {
	        var fields = this.buildFields();
	        var errors = this.state.errors || {};
	        var changes_made = this._form_areChangesMade();
	        var error_msg = _.get(this.props, "error_msg");
	        var success_msg = _.get(this.props, "success_msg");
	
	        return _react2.default.createElement(
	            "form",
	            { className: "form-horizontal", onSubmit: this._form_onSubmit },
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Links"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Enter links back to your website that are used on the Client Portal."
	            ),
	            HorizontalFields({
	                fields: fields,
	                errors: errors,
	                buildInput: this._form_buildInput
	            }),
	            SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })),
	            success_msg && !changes_made && _react2.default.createElement(
	                "div",
	                { className: "alert alert-success" },
	                "Saved."
	            ),
	            ErrorAlert({
	                message: error_msg
	            })
	        );
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_links")],
	
	    getInitialState: function getInitialState() {
	        return {
	            sid: -1,
	            data: {},
	            is_saving: false,
	            error_msg: null,
	            changes_made: false,
	            success_msg: null
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        _.set(props, "config.urls.sid", _.get(props, "config.sid"));
	        this.setState({ sid: props.config.sid, config: props.config, data: props.config.urls, success_msg: null, error_msg: null });
	    },
	
	    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into SettingsForm() as a parameter
	    __onSubmit: function __onSubmit(data) {
	        var self = this;
	
	        radio('save_ClientPortal_links').broadcast(data.sid, data, function (sid, data) {
	            if (_.get(self, "state.data.sid") == sid) {
	                self.setState({
	                    sid: sid,
	                    config: data,
	                    data: data.urls,
	                    is_saving: false,
	                    error_msg: null,
	                    changes_made: false,
	                    success_msg: "Saved."
	                });
	            }
	        }, function (sid, message) {
	            self.setState({ error_msg: message, success_msg: null });
	        });
	    },
	    __selectTextInput: function __selectTextInput(e) {
	        e.target.setSelectionRange(0, e.target.value.length);
	    },
	    render: function render() {
	        var _props = this.props,
	            speaker = _props.speaker,
	            Displaylists = _props.Displaylists;
	
	
	        return dd.div({}, SettingsForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            config: _.get(this, "state.config"),
	            initvals: this.state.data,
	            onSubmit: this.__onSubmit,
	            error_msg: _.get(this.state, "error_msg"),
	            success_msg: _.get(this.state, "success_msg")
	        }));
	    }
	});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	
	
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var ErrorAlert = __webpack_require__(6);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var ServicesUtils = __webpack_require__(33);
	var AuthedUserSession = __webpack_require__(4);
	
	var QuestionnaireForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props;
	    },
	    getInitialValues: function getInitialValues(props) {
	        return _.get(props, "initvals", {});
	    },
	    getInitialState: function getInitialState() {
	        // Default to HL mode if there are surveys available and no HL error
	        var ghlSurveys = _.get(this.props, "config.ghl_surveys", []);
	        var hl_error = _.get(this.props, "config.hl_error");
	        var hasHLError = _.isString(hl_error) && !_.isEmpty(hl_error);
	        var hasAvailableSurveys = _.isArray(ghlSurveys) && ghlSurveys.length > 0;
	        return {
	            surveyMode: hasAvailableSurveys && !hasHLError ? "hl" : "custom"
	        };
	    },
	    __onModeChange: function __onModeChange(mode) {
	        this.setState({ surveyMode: mode });
	    },
	    buildFields: function buildFields() {
	        var speaker = _.get(this, "props.speaker", null);
	        var surveyMode = _.get(this, "state.surveyMode", "custom");
	
	        // Build survey options from ghl_surveys array
	        var ghlSurveys = _.get(this, "props.config.ghl_surveys", []);
	        var surveyOptions = { "": "-- Select a High Level Survey --" };
	        _.each(ghlSurveys, function (survey) {
	            var surveyUrl = "https://hlapi.espeakers.com/widget/survey/" + survey.id;
	            surveyOptions[surveyUrl] = survey.name;
	        });
	
	        var standardKey = "CLIENTPORTAL_QSNTR_ACTIONLIST_ID_0";
	        var standardField = {};
	        if (surveyMode === "hl") {
	            standardField[standardKey] = {
	                label: "Standard",
	                type: "select",
	                options: surveyOptions,
	                validate: FormUtils.v.optional
	            };
	        } else {
	            standardField[standardKey] = {
	                label: "Standard",
	                type: "text",
	                placeholder: "https://goo.gl/forms/PMK0lzlS6Z8DRE152",
	                validate: FormUtils.v.optional
	            };
	        }
	
	        var fields = {};
	
	        _.each(_.get(speaker, "todolists", []), function (list) {
	            var selectKey = "clientportal_qsntr_actionlist_id_" + list.id;
	            var textKey = "clientportal_qsntr_actionlist_id_" + list.id; //magic value; must match key in ClientportalController->questionnaireAction()
	
	            if (surveyMode === "hl") {
	                // Dropdown for selecting a HL survey
	                fields[selectKey] = {
	                    label: list.listname,
	                    type: "select",
	                    options: surveyOptions,
	                    validate: FormUtils.v.optional
	                };
	            } else {
	                // Text field for custom URL
	                fields[textKey] = {
	                    label: list.listname,
	                    type: "text",
	                    placeholder: "https://goo.gl/forms/PMK0lzlS6Z8DRE152",
	                    validate: FormUtils.v.optional
	                };
	            }
	        });
	
	        return _.assign({}, standardField, fields);
	    },
	    __discardChanges: esUtils.wrapPreventDefault(function () {
	        this._form_reset();
	    }),
	
	    render: function render() {
	        var self = this;
	        var allFields = this.buildFields();
	        var standardKey = "CLIENTPORTAL_QSNTR_ACTIONLIST_ID_0";
	        var standardField = _.pick(allFields, [standardKey]);
	        var fields = _.omit(allFields, [standardKey]);
	        var errors = this.state.errors || {};
	        var changes_made = this._form_areChangesMade();
	        var error_msg = _.get(this.props, "error_msg");
	        var success_msg = _.get(this.props, "success_msg");
	        var surveyMode = _.get(this.state, "surveyMode", "custom");
	        var hl_error = _.get(this.props, "config.hl_error");
	        var hasHLError = _.isString(hl_error) && !_.isEmpty(hl_error);
	        var needsUpgrade = hl_error === "Your HighLevel CRM connection does not support surveys" || _.isString(hl_error) && hl_error.indexOf("To use integrated features") === 0;
	
	        return _react2.default.createElement(
	            "form",
	            { className: "form-horizontal", onSubmit: this._form_onSubmit },
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Pre-event Questionnaire"
	            ),
	            needsUpgrade && _react2.default.createElement(
	                "div",
	                { className: "alert alert-info" },
	                _react2.default.createElement(
	                    "h4",
	                    null,
	                    _react2.default.createElement("i", { className: "fa fa-info-circle" }),
	                    " HighLevel CRM Surveys Now Available"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "You can now use HighLevel CRM Surveys for your pre-event questionnaire instead of Google Forms."
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { target: '_blank', href: '/dashboard/token-callback?token=' + _.get(AuthedUserSession, ['balboa', 'estoken'], '') + '&redir=/high-level', className: "btn btn-primary" },
	                        "Update Now ",
	                        _react2.default.createElement("i", { className: "fa fa-external-link" })
	                    )
	                )
	            ),
	            hasHLError && !needsUpgrade && _react2.default.createElement(
	                "div",
	                { className: "alert alert-warning" },
	                _react2.default.createElement("i", { className: "fa fa-exclamation-triangle" }),
	                " We were unable to find your HighLevel CRM surveys: ",
	                hl_error
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Select a High Level Survey, or enter the URL to the Google Form for your pre-event questionnaire. You can assign a specific Form to events using specific Action Lists. The STANDARD form will be used if there is not a specific one assigned to an event."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://espeakers.com/wiki/Pre-event_Questionnaire_in_the_Client_Portal", target: "_blank" },
	                    "Learn more about pre-event questionnaires ",
	                    _react2.default.createElement("i", { style: { marginLeft: "0.5em", fontSize: "1.0em" }, className: "fa fa-external-link" })
	                )
	            ),
	            !hasHLError && _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement(
	                    "label",
	                    { className: "col-sm-3 control-label" },
	                    "Questionnaire Type"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-9" },
	                    _react2.default.createElement(
	                        "label",
	                        { className: "radio-inline" },
	                        _react2.default.createElement("input", {
	                            type: "radio",
	                            name: "surveyMode",
	                            value: "hl",
	                            checked: surveyMode === "hl",
	                            onChange: function onChange() {
	                                self.__onModeChange("hl");
	                            }
	                        }),
	                        "High Level Surveys"
	                    ),
	                    _react2.default.createElement(
	                        "label",
	                        { className: "radio-inline" },
	                        _react2.default.createElement("input", {
	                            type: "radio",
	                            name: "surveyMode",
	                            value: "custom",
	                            checked: surveyMode === "custom",
	                            onChange: function onChange() {
	                                self.__onModeChange("custom");
	                            }
	                        }),
	                        "Custom Link"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { style: { marginBottom: "1.5em", paddingBottom: "0.5em", borderBottom: "1px solid #ddd" } },
	                HorizontalFields({
	                    fields: standardField,
	                    errors: errors,
	                    buildInput: this._form_buildInput
	                })
	            ),
	            HorizontalFields({
	                fields: fields,
	                errors: errors,
	                buildInput: this._form_buildInput
	            }),
	            SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })),
	            success_msg && !changes_made && _react2.default.createElement(
	                "div",
	                { className: "alert alert-success" },
	                "Saved."
	            ),
	            ErrorAlert({
	                message: error_msg
	            })
	        );
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [ServicesUtils.RadioAjaxMixin("save_ClientPortal_questionnaire")],
	
	    getInitialState: function getInitialState() {
	        return {
	            sid: -1,
	            data: {},
	            is_saving: false,
	            error_msg: null,
	            success_msg: null
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        _.set(props, "config.questionnaire.sid", _.get(props, "config.sid"));
	        this.setState({ sid: props.config.sid, config: props.config, data: props.config.questionnaire, success_msg: null, error_msg: null });
	    },
	
	    //dd.form calls this._form_onSubmit, which in turn calls this because it was passed into QuestionnaireForm() as a parameter
	    __onSubmit: function __onSubmit(data) {
	        var self = this;
	        radio('save_ClientPortal_questionnaire').broadcast(data.sid, data, function (sid, data) {
	            if (_.get(self, "state.data.sid") == sid) {
	                self.setState({
	                    sid: sid,
	                    config: data,
	                    data: _.get(data, "questionnaire"),
	                    is_saving: false,
	                    error_msg: null,
	                    success_msg: "Saved."
	                });
	            }
	        }, function (sid, message) {
	            self.setState({ error_msg: message, success_msg: null });
	        });
	    },
	    __selectTextInput: function __selectTextInput(e) {
	        e.target.setSelectionRange(0, e.target.value.length);
	    },
	    render: function render() {
	        var _props = this.props,
	            speaker = _props.speaker,
	            Displaylists = _props.Displaylists;
	
	
	        return dd.div({}, QuestionnaireForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            config: _.get(this, "state.config"),
	            initvals: this.state.data,
	            onSubmit: this.__onSubmit,
	            error_msg: _.get(this.state, "error_msg"),
	            success_msg: _.get(this.state, "success_msg")
	        }));
	    }
	});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var SpeakerForm = __webpack_require__(87);
	var LinksForm = __webpack_require__(210);
	var QuestionnaireForm = __webpack_require__(211);
	var DisplayfieldsForm = __webpack_require__(209);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	var ProOnly = __webpack_require__(34);
	
	var sids_I_can_manage = _.intersection(AuthedUserSession.getSIDsAtPackageLevel('PRO'), AuthedUserSession.doIHaveAccess.admin.getSIDs());
	
	var getMySIDs = function getMySIDs(Displaylists) {
	    var dl_sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	    return _.uniq(_.intersection(dl_sids, sids_I_can_manage));
	};
	
	module.exports = dd.createClass({
	    getInitialState: function getInitialState() {
	        return { selected_sid: -1 };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        this.__handleDefaultSIDfromProps(props);
	    },
	    componentDidMount: function componentDidMount() {
	        this.__handleDefaultSIDfromProps(this.props);
	    },
	
	    __loadForSid: function __loadForSid(sid) {
	        if (sid !== this.state.selected_sid) {
	            this.setState({ selected_sid: sid }, function () {
	                var self = this;
	                radio('read_ClientPortal_config').broadcast(sid, function (sid, data) {
	                    if (self.state.selected_sid == sid) {
	                        self.setState({ selected_sid: sid, data: data, error_msg: null, success_msg: null });
	                    }
	                }, function (sid, message) {
	                    if (self.state.selected_sid == sid) {
	                        self.setState({ error_msg: message, success_msg: null });
	                    }
	                });
	            });
	        }
	    },
	    __handleDefaultSIDfromProps: function __handleDefaultSIDfromProps(props) {
	        var sid = props.sid,
	            Displaylists = props.Displaylists;
	
	        var my_sids = getMySIDs(Displaylists);
	        var cur_sid = this.state.selected_sid;
	
	        if (_.isEmpty(my_sids)) {
	            return;
	        }
	        if (_.includes(my_sids, cur_sid)) {
	            return; //no change needed
	        }
	        if (_.includes(my_sids, sid)) {
	            this.__onSidChanged(sid);
	            return;
	        }
	        sid = AuthedUserSession.getLastSelectedSID();
	        sid = sid === 0 ? 1 : sid; //fix for Solution Tree to select master list
	        if (_.includes(my_sids, sid)) {
	            this.__onSidChanged(sid);
	            return;
	        }
	        this.__onSidChanged(_.first(my_sids));
	    },
	    __onSidChanged: function __onSidChanged(sid) {
	        this.__loadForSid(_.parseInt(sid));
	    },
	
	    __onCancel: esUtils.wrapPreventDefault(function () {
	        if (this.props.redir) {
	            radio('Hashbang_set').broadcast(this.props.redir);
	        }
	    }),
	    render: function render() {
	        var _props = this.props,
	            redir = _props.redir,
	            Displaylists = _props.Displaylists;
	        var selected_sid = this.state.selected_sid;
	
	
	        var onCancel = redir ? this.__onCancel : null;
	
	        var my_sids = getMySIDs(Displaylists);
	
	        var speaker = void 0;
	        if (_.includes(my_sids, selected_sid)) {
	            speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
	                return spkr.sid === selected_sid;
	            }));
	        }
	        var data = _.get(this.state, "data", {});
	
	        return LoadingWrap({ is_loading: _.isEmpty(Displaylists), glass: true }, dd.div({ className: 'ClientPortalSettings' }, dd.h2({ style: { marginTop: 0 } }, 'Client Portal settings'), dd.p({ style: { marginBottom: 40 } }, 'Makes changes to the client portal settings for the selected speaker.', " ", dd.a({ href: "https://www.espeakers.com/wiki/Client_Portal", target: "_blank" }, 'More information', dd.i({ style: { marginLeft: "0.5em", fontSize: "1.0em" }, className: "fa fa-external-link" }))), ProOnly({
	            sids: AuthedUserSession.doIHaveAccess.admin.getSIDs(),
	            custom_message: 'Upgrade to PRO to use the amazing Client Portal to give your customers real-time access to some critical data about their event.'
	        }, _.size(my_sids) > 1 ? SpeakerForm({
	            sid: selected_sid,
	            Displaylists: Displaylists,
	            sids_to_choose: my_sids,
	            onSidChanged: this.__onSidChanged
	        }) : null, dd.div({ className: "clearfix" }), speaker ? dd.div({}, LinksForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            config: data
	        }), QuestionnaireForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            config: data
	        }), DisplayfieldsForm({
	            speaker: speaker,
	            Displaylists: Displaylists,
	            config: data
	        })) : null), onCancel ? dd.button({
	            className: 'btn btn-default btn-md',
	            onClick: onCancel
	        }, 'Cancel') : null), dd.div({ className: "clearfix" }));
	    }
	});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var Constants = __webpack_require__(13);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var RadioServiceMixin = __webpack_require__(14);
	var AuthedUserSession = __webpack_require__(4);
	var DisplaylistSpeaker_to_actionlistSaveData = __webpack_require__(88);
	
	var isPlaceholderValue = function isPlaceholderValue(v) {
	    return v === null || v === undefined;
	};
	
	var ActionItemForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValues: function getInitialValues(props) {
	        var item = props.item;
	
	        if (!item) {
	            return null;
	        }
	        var data = {
	            description: item.description,
	            activateonstatus: item.activateonstatus == -1 ? null : item.activateonstatus,
	            duedelta: esUtils.toInt(item.duedelta),
	            duebasedon: item.duebasedon,
	            vieworder: item.vieworder, //even though they don't edit this we want it to be sent to the server
	            assignedto: item.assignedto
	        };
	
	        data.duebasedon = data.duedelta < 0 ? "before" : "after";
	        data.duebasedon += "_";
	        data.duebasedon += /STRT/i.test(item.duebasedon) ? "STRT" : "STAT";
	
	        data.duedelta = Math.abs(data.duedelta);
	
	        return data;
	    },
	    buildSchema: function buildSchema() {
	        var data = this.state.data || {};
	        var speaker = this.props.speaker;
	
	
	        var schema = {
	            description: {
	                label: "Item Description",
	                type: "text",
	                validate: FormUtils.v.required,
	                help_text: "ex: 'send invoice', 'book travel', etc"
	            },
	            activateonstatus: {
	                label: "When does this item apply?",
	                type: "select",
	                validate: FormUtils.v.optional,
	                placeholder: "manually applied",
	                options: {
	                    0: "When the event is held",
	                    1: "When the event is confirmed",
	                    9: "When the event is canceled",
	                    10: "When the event is lead"
	                },
	                help_text: "ex: for 'book travel', then choose 'when event is confirmed. For 'confirm hold status', choose 'when the event is held'."
	            },
	            duedelta: {
	                label: "# of days",
	                type: "number",
	                validate: FormUtils.v.integer, //positive or negative
	                min: 0
	            },
	            duebasedon: {
	                label: "When is this item normally due?",
	                type: "select",
	                dont_sort_options: true,
	                options: function () {
	                    var st = _.has(Constants.EVENT_STATUSES_by_num, data.activateonstatus) ? Constants.EVENT_STATUSES_by_num[data.activateonstatus] : "created";
	                    return {
	                        before_STRT: "days BEFORE the event starts",
	                        after_STRT: "days AFTER the event starts",
	
	                        after_STAT: "days AFTER the event is " + st
	                    };
	                }(),
	                help_text: "ex: if you book travel 4 weeks prior to the event, then choose 'days BEFORE the event starts'. and enter 28 in the box."
	            },
	            assignedto: {
	                label: "Who is usually responsible for this?",
	                type: "select",
	                placeholder: "not assigned",
	                validate: FormUtils.v.optional,
	                options: _.assign({
	                    "[ME]": "* the person who enters the event", //see class.Event.php::TODO_ASSIGNEDTO_ME
	                    "[SPEAKER]": "* the speaker" //class.Event.php::TODO_ASSIGNEDTO_SPEAKER
	                }, _.object(_.map(speaker.coworkers, function (coworker) {
	                    return [coworker.id, coworker.name];
	                })))
	            }
	        };
	        if (AuthedUserSession.is_st_family) {
	            schema.assignedto.options["[EVENTREP]"] = "* event representative"; //class.Event.php::TODO_ASSIGNEDTO_REP
	        }
	        if (isPlaceholderValue(data.activateonstatus)) {
	            delete schema.duedelta;
	            delete schema.duebasedon;
	        }
	        return schema;
	    },
	    render: function render() {
	        var fields = this.Form_buildSchema();
	        var errors = this.state.errors || {};
	        var buildInput = this.Form_buildInput;
	
	        var onClose = this.props.onClose;
	
	
	        var renderInput = function renderInput(name, no_wrap) {
	            var body = dd.div({ className: errors[name] ? "has-error" : null }, buildInput(fields[name], name), errors[name] ? dd.span({ className: "help-block" }, errors[name]) : null);
	            return no_wrap ? body : dd.div({ className: "row" }, dd.div({ className: "col-sm-1" }), dd.div({ className: "col-sm-11" }, body));
	        };
	        var renderLabel = function renderLabel(name) {
	            var field = fields[name];
	            return dd.label(null, field.label);
	        };
	        var renderHelpText = function renderHelpText(name) {
	            var field = fields[name];
	            return dd.div({ className: "row" }, dd.div({ className: "col-sm-1" }), dd.div({ className: "col-sm-11" }, dd.span({ className: "help-block" }, field.help_text)));
	        };
	
	        return dd.form({ onSubmit: this.Form_onSubmit }, renderLabel("description"), renderInput("description"), renderHelpText("description"), renderLabel("activateonstatus"), renderInput("activateonstatus"), renderHelpText("activateonstatus"), _.has(fields, "duebasedon") ? dd.div(null, renderLabel("duebasedon"), dd.div({ className: "row" }, dd.div({ className: "col-sm-1" }), dd.div({ className: "col-sm-4" }, renderInput("duedelta", true)), dd.div({ className: "col-sm-7" }, renderInput("duebasedon", true))), renderHelpText("duebasedon")) : null, renderLabel("assignedto"), renderInput("assignedto"), dd.div({ style: { margin: "20px 0", textAlign: "right" } }, dd.button({ className: "btn btn-primary", type: "submit" }, "Save"), " ", dd.button({ className: "btn btn-default", onClick: onClose }, "Close")));
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [RadioServiceMixin],
	    RadioService_setup: function RadioService_setup() {
	        return {
	            Actionlists_save: {
	                key: function key() {
	                    return 1;
	                },
	
	                on: {
	                    succeeded: function succeeded() {
	                        this.props.onClose();
	                    }
	                }
	            }
	        };
	    },
	    __onSubmit: function __onSubmit(data) {
	        var item = _.cloneDeep(data);
	        item.duedelta = esUtils.toInt(item.duedelta);
	        item.assignedto = isPlaceholderValue(item.assignedto) ? null : item.assignedto;
	        item.activateonstatus = isPlaceholderValue(item.activateonstatus) ? -1 : esUtils.toInt(item.activateonstatus);
	
	        if (/before/.test(item.duebasedon)) {
	            item.duedelta = -item.duedelta;
	        }
	        if (/_STRT/.test(item.duebasedon)) {
	            item.duebasedon = "STRT"; //start date
	        } else {
	            item.duebasedon = "STAT"; //status change
	        }
	
	        var list_id = this.props.list_id;
	        var item_id = this.props.item.id;
	        var speaker = this.props.speaker;
	        var to_save = {};
	        to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
	        //update the changed item
	        to_save[speaker.sid][list_id].items[item_id] = item;
	        radio("Actionlists_save").broadcast(to_save);
	    },
	    render: function render() {
	        var ajax = this.state.Actionlists_save;
	        var _props = this.props,
	            onClose = _props.onClose,
	            item = _props.item,
	            speaker = _props.speaker;
	
	
	        return Modal({
	            title: "Action Item",
	            buttons: [],
	            onClose: ajax.waiting ? null : onClose
	        }, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: "Saving..." }, dd.p(null, "Make changes to the master to-do list, which affects all events for the speaker. Changes made here will not affect todo-items already created."), ActionItemForm({
	            speaker: speaker,
	            item: item,
	            onClose: onClose,
	            onSubmit: this.__onSubmit
	        })));
	    }
	});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localforage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var radio = __webpack_require__(24);
	var FormMixin = __webpack_require__(19);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var FormButtons = __webpack_require__(36);
	var ConfirmModal = __webpack_require__(129);
	var FormUtils = __webpack_require__(9);
	var SlideOpenDown = __webpack_require__(27);
	var RadioServiceMixin = __webpack_require__(14);
	var ActionListItemEditor = __webpack_require__(213);
	var DisplaylistSpeaker_to_actionlistSaveData = __webpack_require__(88);
	
	var DRAG_THRESHOLD = 3;
	
	var ListItem = dd.createClass({
	  getInitialState: function getInitialState() {
	    return {
	      mouseDown: false,
	      dragging: false,
	      left: 0,
	      right: 0,
	      originX: 0,
	      originY: 0,
	      elementX: 0,
	      elementY: 0
	    };
	  },
	  onMouseDown: function onMouseDown(event) {
	    var pageOffset = void 0;
	    if (event.button === 0 && this.refs && this.refs.main) {
	      //left button
	      event.stopPropagation();
	      this.addEvents();
	      pageOffset = this.refs.main.getBoundingClientRect();
	      this.setState({
	        mouseDown: true,
	        originX: event.pageX,
	        originY: event.pageY,
	        elementX: pageOffset.left,
	        elementY: pageOffset.top - 52 //TODO better get this offset
	      });
	    }
	  },
	  onMouseMove: function onMouseMove(event) {
	    var deltaX = void 0,
	        deltaY = void 0,
	        distance = void 0;
	    deltaX = event.pageX - this.state.originX;
	    deltaY = event.pageY - this.state.originY;
	    distance = Math.abs(deltaX) + Math.abs(deltaY);
	    if (!this.state.dragging && distance > DRAG_THRESHOLD) {
	      this.setState({
	        dragging: true
	      });
	      this.onDragStart();
	    }
	    if (this.state.dragging) {
	      this.setState({
	        left: this.state.elementX + deltaX + document.body.scrollLeft,
	        top: this.state.elementY + deltaY + document.body.scrollTop
	      });
	    }
	  },
	  onMouseUp: function onMouseUp() {
	    this.removeEvents();
	    if (this.state.dragging) {
	      this.onDragStop();
	      this.setState({
	        dragging: false
	      });
	    }
	  },
	  addEvents: function addEvents() {
	    document.addEventListener("mousemove", this.onMouseMove);
	    document.addEventListener("mouseup", this.onMouseUp);
	  },
	  removeEvents: function removeEvents() {
	    document.removeEventListener("mousemove", this.onMouseMove);
	    document.removeEventListener("mouseup", this.onMouseUp);
	  },
	  __onDeleteClicked: esUtils.wrapPreventDefault(function () {
	    this.props.deleteItem(this.props.item);
	  }),
	  __onClick: esUtils.wrapPreventDefault(function () {
	    this.props.setEditingItem(this.props.item);
	  }),
	  onDragStart: function onDragStart() {
	    this.props.onItemDragStart(this.props.item);
	  },
	  onDragStop: function onDragStop() {
	    this.props.onItemDragStop(this.props.item);
	  },
	  onMouseEnter: function onMouseEnter() {
	    this.props.setItemIDHoveredOver(this.props.item.id);
	  },
	  onMouseLeave: function onMouseLeave() {
	    this.props.setItemIDHoveredOver(null); //no longer being hovered over
	  },
	  render: function render() {
	    var item = this.props.item;
	    var is_drag_over_me = this.props.is_drag_over_me;
	
	    return dd.tbody({
	      onMouseEnter: this.onMouseEnter,
	      onMouseLeave: this.onMouseLeave
	    }, is_drag_over_me ? dd.tr(null, dd.td({ colSpan: 3 }, dd.br())) : null, dd.tr({
	      ref: "main",
	      style: this.state.dragging ? {
	        position: "absolute",
	        left: this.state.left,
	        top: this.state.top
	      } : {},
	      className: "MasterListItem " + (this.state.dragging ? "dragging" : "")
	    }, dd.td({ className: "text-muted draggable", onMouseDown: this.onMouseDown }, dd.i({ className: "fa fa-bars" })), dd.td({ className: "clickable", onClick: this.__onClick }, item.description), dd.td(null, dd.a({ href: "#", onClick: this.__onDeleteClicked }, dd.i({ className: "fa fa-times" })))));
	  }
	});
	
	var DaForm = dd.createClass({
	  mixins: [FormMixin],
	  getInitialState: function getInitialState() {
	    return {
	      item_dragging: null,
	      item_id_being_hovered: null
	    };
	  },
	  getInitialValues: function getInitialValues(props) {
	    var list = props.list;
	    return {
	      name: list.listname,
	      item_ids_in_order: _.map(_.sortBy(_.map(list.masters, function (item, id) {
	        return _.assign({}, item, { id: id });
	      }), "vieworder"), "id")
	    };
	  },
	  buildSchema: function buildSchema() {
	    return {
	      name: {
	        label: "List Name",
	        type: "text",
	        validate: FormUtils.v.required
	      }
	    };
	  },
	  __deleteList: esUtils.wrapPreventDefault(function () {
	    this.props.deleteList();
	  }),
	  __newItem: esUtils.wrapPreventDefault(function () {
	    this.props.setEditingItem({ id: -1 });
	  }),
	  __discardChanges: esUtils.wrapPreventDefault(function () {
	    this.Form_reset(); //react-loose-forms
	  }),
	  __deleteItem: function __deleteItem(item) {
	    //remove the item from the list
	    this.Form_onChange("item_ids_in_order", _.filter(this.state.data.item_ids_in_order, function (id) {
	      return id !== item.id;
	    }));
	  },
	  __setItemIDHoveredOver: function __setItemIDHoveredOver(item_id) {
	    if (!this.state.item_dragging) {
	      //not dragging anything
	      if (item_id === null && this.state.item_id_being_hovered !== item_id) {
	        //reset to null
	        this.setState({ item_id_being_hovered: null });
	      }
	      return;
	    }
	    this.setState({ item_id_being_hovered: item_id });
	  },
	  __onItemDragStart: function __onItemDragStart(item) {
	    this.setState({ item_dragging: item });
	  },
	  __onItemDragStop: function __onItemDragStop(item) {
	    var h_id = this.state.item_id_being_hovered;
	    var old_order = this.state.data.item_ids_in_order;
	
	    var injected_new = false;
	    var new_order = [];
	    _.each(old_order, function (id) {
	      if (item.id === id) {
	        //we're going to put it somewhere new
	        return;
	      }
	      if (h_id === id) {
	        new_order.push(item.id);
	        injected_new = true;
	      }
	      new_order.push(id);
	    });
	    if (!injected_new) {
	      new_order.push(item.id);
	    }
	    this.Form_onChange("item_ids_in_order", new_order);
	    this.setState({ item_dragging: null, item_id_being_hovered: null });
	  },
	  render: function render() {
	    var data = this.state.data || {};
	    var fields = this.Form_buildSchema();
	    var errors = this.state.errors || {};
	    var buildInput = this.Form_buildInput;
	    var changes_made = this.Form_areChangesMade();
	
	    var list = this.props.list;
	    var setEditingItem = this.props.setEditingItem;
	
	    var list_name = void 0;
	    if (list.id === 0) {
	      list_name = dd.h4(null, data.name);
	    } else {
	      list_name = dd.div({}, dd.button({
	        className: "btn btn-danger btn-sm pull-right",
	        onClick: this.__deleteList
	      }, "Delete"), dd.div({ className: errors.name ? "has-error" : null, style: { maxWidth: "70%" } }, buildInput(fields.name), errors.name ? dd.span({ className: "help-block" }, errors.name) : null));
	    }
	
	    var items = _.map(_.map(data.item_ids_in_order, function (id) {
	      return _.assign({}, list.masters[id], { id: id });
	    }), _.bind(function (item) {
	      return ListItem({
	        key: item.id,
	        item: item,
	        deleteItem: this.__deleteItem,
	        setEditingItem: setEditingItem,
	        is_drag_over_me: this.state.item_id_being_hovered === item.id,
	        setItemIDHoveredOver: this.__setItemIDHoveredOver,
	        onItemDragStart: this.__onItemDragStart,
	        onItemDragStop: this.__onItemDragStop
	      });
	    }, this));
	
	    return dd.form({ onSubmit: this.Form_onSubmit }, list_name, dd.table({ className: "table table-condensed table-hover" }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }), dd.th(null, "Action Items"), dd.th({ style: { width: 1 } }))), items), _.isEmpty(items) ? dd.div({ className: "text-center" }, dd.h3({ className: "text-muted" }, "-- empty list --"), dd.button({ className: "btn btn-default", onClick: this.__newItem }, "Create Item")) : dd.div({ style: { marginBottom: 15, float: "right" } }, dd.button({ className: "btn btn-default btn-sm", onClick: this.__newItem }, "New Item")), SlideOpenDown({ open: changes_made }, FormButtons({ onDiscard: this.__discardChanges })));
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      Actionlists_save: {
	        key: function key() {
	          return 1;
	        }
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return { editing_item: null, show_delete_list_confirm: false };
	  },
	  __onSubmit: function __onSubmit(data) {
	    var speaker = this.props.speaker;
	    var list_id = this.props.list_id;
	
	    var to_save = {};
	    to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
	
	    to_save[speaker.sid][list_id].name = data.name;
	
	    var old_items = to_save[speaker.sid][list_id].items;
	    var new_items = {}; //only add ones that are in item_ids_in_order
	
	    //set vieworder based on position
	    _.map(data.item_ids_in_order, function (id, i) {
	      new_items[id] = old_items[id];
	      new_items[id].vieworder = i;
	    });
	    to_save[speaker.sid][list_id].items = new_items;
	
	    radio("Actionlists_save").broadcast(to_save);
	  },
	  __setEditingItem: function __setEditingItem(item) {
	    this.setState({ editing_item: item });
	  },
	  __closeEditingItem: esUtils.wrapPreventDefault(function () {
	    this.setState({ editing_item: null });
	  }),
	  __toggleDeleteConfirm: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_delete_list_confirm: !this.state.show_delete_list_confirm });
	  }),
	  __deleteList: esUtils.wrapPreventDefault(function () {
	    var speaker = this.props.speaker;
	    var list_id = this.props.list_id;
	
	    var to_save = {};
	    to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
	    delete to_save[speaker.sid][list_id];
	
	    radio("Actionlists_save").broadcast(to_save);
	
	    this.setState({ show_delete_list_confirm: false });
	  }),
	  render: function render() {
	    var list_id = this.props.list_id;
	    var speaker = this.props.speaker;
	    var ajax = this.state.Actionlists_save;
	
	    var editing_item = this.state.editing_item;
	
	    var list = _.find(speaker.todolists, function (list) {
	      return list.id === list_id;
	    });
	
	    if (!list) {
	      //may have tried to restore another speaker's list, so let's default to 0
	      list_id = 0;
	      localforage.setItem('actionlist_edit_id', 0); //reset to 'standard'
	      list = _.find(speaker.todolists, { 'id': 0 });
	    }
	    if (!list) {
	      //still can't find the list
	      return ErrorAlert({ message: "List not found." });
	    }
	
	    return dd.div({ className: "EditMasterList" }, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: "Saving..." }, DaForm({
	      list: list,
	      speaker: speaker,
	      onSubmit: this.__onSubmit,
	      deleteList: this.__toggleDeleteConfirm,
	      setEditingItem: this.__setEditingItem
	    })), editing_item ? ActionListItemEditor({
	      item: editing_item,
	      list_id: list_id,
	      speaker: speaker,
	      onClose: this.__closeEditingItem
	    }) : null, this.state.show_delete_list_confirm ? ConfirmModal({
	      message: "Are you sure you want to delete this list?",
	      onYes: this.__deleteList,
	      onClose: this.__toggleDeleteConfirm
	    }) : null);
	  }
	});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localforage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var TabSet = __webpack_require__(68);
	var esUtils = __webpack_require__(2);
	var EditMasterList = __webpack_require__(214);
	var NewActionListModal = __webpack_require__(216);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { list_editing: 0, show_new_list_modal: false };
	  },
	  __clickListTab: function __clickListTab(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      localforage.setItem('actionlist_edit_id', id); //will restore to this list after reload
	      self.setState({ list_editing: id });
	    });
	  },
	  componentDidMount: function componentDidMount(props) {
	    //with the data fully available now, try to restore the last-used action list
	    var self = this;
	    localforage.getItem('actionlist_edit_id', function (err, value) {
	      if (_.isNull(err) && !_.isNull(value)) {
	        self.setState({ list_editing: value });
	      }
	    });
	  },
	
	  __toggleNewListModal: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_new_list_modal: !this.state.show_new_list_modal });
	  }),
	  render: function render() {
	    var speaker = this.props.speaker;
	    var _state = this.state,
	        list_editing = _state.list_editing,
	        show_new_list_modal = _state.show_new_list_modal;
	
	
	    var tabs = {};
	    var clickListTab = this.__clickListTab;
	    _.each(speaker.todolists, function (list) {
	      tabs[list.id] = {
	        onClick: clickListTab(list.id),
	        name: list.listname
	      };
	    });
	    tabs['static'] = {
	      name: dd.div(null, dd.div({ className: 'text-muted' }, 'Use different lists for different types of events (ie, "Keynote", "Full-day Workshop", etc.)'), dd.button({ className: 'btn btn-default', onClick: this.__toggleNewListModal }, 'New List'))
	    };
	
	    return dd.div({}, TabSet({
	      tabs: tabs,
	      selected_tab: list_editing + '', //hack to fix it not === b/c it's comparing string and num
	      lefty: true,
	      tabs_width: 350,
	      tab_body: EditMasterList({
	        list_id: list_editing,
	        speaker: speaker
	      })
	    }), show_new_list_modal ? NewActionListModal({
	      speaker: speaker,
	      onClose: this.__toggleNewListModal
	    }) : null);
	  }
	});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var FormMixin = __webpack_require__(19);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ezVerticalFields = __webpack_require__(73);
	var RadioServiceMixin = __webpack_require__(14);
	var FormUtils = __webpack_require__(9);
	var DisplaylistSpeaker_to_actionlistSaveData = __webpack_require__(88);
	
	var NewActionListForm = dd.createClass({
	    mixins: [FormMixin],
	    buildSchema: function buildSchema() {
	        return {
	            name: {
	                label: "List Name",
	                type: "text",
	                validate: FormUtils.v.required
	            }
	        };
	    },
	    render: function render() {
	        var onClose = this.props.onClose;
	        return dd.form({ onSubmit: this.Form_onSubmit }, ezVerticalFields(this), dd.div({}, dd.button({ className: "btn btn-primary", type: "submit" }, "Add"), " ", dd.button({
	            className: "btn btn-default",
	            onClick: onClose
	        }, "Cancel")));
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [RadioServiceMixin],
	    RadioService_setup: function RadioService_setup() {
	        return {
	            Actionlists_save: {
	                key: function key() {
	                    return 1;
	                },
	
	                on: {
	                    succeeded: function succeeded() {
	                        this.props.onClose();
	                    }
	                }
	            }
	        };
	    },
	
	    __onSubmit: function __onSubmit(data) {
	        var speaker = this.props.speaker;
	
	        var to_save = {};
	        to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
	
	        //Add the new list
	        to_save[speaker.sid][-1] = {
	            name: data.name,
	            items: {}
	        };
	
	        radio("Actionlists_save").broadcast(to_save);
	    },
	    render: function render() {
	        var ajax = this.state.Actionlists_save;
	        var onClose = this.props.onClose;
	        return Modal({
	            title: "New Action Action List",
	            buttons: [],
	            onClose: ajax.waiting ? null : onClose
	        }, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: "Saving..." }, NewActionListForm({
	            onClose: onClose,
	            onSubmit: this.__onSubmit
	        })));
	    }
	});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localforage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var SpeakerForm = __webpack_require__(87);
	
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	var ProOnly = __webpack_require__(34);
	
	var MasterActionLists = __webpack_require__(215);
	
	var sids_I_can_manage = _.intersection(AuthedUserSession.getSIDsAtPackageLevel("PRO"), AuthedUserSession.doIHaveAccess.admin.getSIDs());
	
	var getMySIDs = function getMySIDs(Displaylists) {
	  var dl_sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	  return _.uniq(_.intersection(dl_sids, sids_I_can_manage));
	};
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { selected_sid: -1 };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__handleDefaultSIDfromProps(props);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__handleDefaultSIDfromProps(this.props);
	  },
	  __handleDefaultSIDfromProps: function __handleDefaultSIDfromProps(props) {
	    var sid = props.sid,
	        Displaylists = props.Displaylists;
	
	    var my_sids = getMySIDs(Displaylists);
	    var cur_sid = this.state.selected_sid;
	
	    if (_.isEmpty(my_sids)) {
	      return;
	    }
	    if (_.includes(my_sids, cur_sid)) {
	      return; //no change needed
	    }
	    if (_.includes(my_sids, sid)) {
	      this.__onSidChanged(sid);
	      return;
	    }
	    sid = AuthedUserSession.getLastSelectedSID();
	    sid = sid === 0 ? 1 : sid; //fix for Solution Tree to select master list
	    if (_.includes(my_sids, sid)) {
	      this.__onSidChanged(sid);
	      return;
	    }
	    this.__onSidChanged(_.first(my_sids));
	  },
	  __onSidChanged: function __onSidChanged(sid) {
	    var self = this;
	    localforage.setItem("actionlist_edit_id", null).then(function () {
	      self.setState({ selected_sid: _.parseInt(sid) });
	    }); //reset selected list for new speaker
	  },
	
	  __onCancel: esUtils.wrapPreventDefault(function () {
	    if (this.props.redir) {
	      radio("Hashbang_set").broadcast(this.props.redir);
	    }
	  }),
	  render: function render() {
	    var _props = this.props,
	        redir = _props.redir,
	        Displaylists = _props.Displaylists;
	    var selected_sid = this.state.selected_sid;
	
	
	    var onCancel = redir ? this.__onCancel : null;
	
	    var my_sids = getMySIDs(Displaylists);
	
	    var speaker = void 0;
	    if (_.includes(my_sids, selected_sid)) {
	      speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
	        return spkr.sid === selected_sid;
	      }));
	    }
	
	    if (AuthedUserSession.privatelabel_code === "cs") {
	      return LoadingWrap({ is_loading: _.isEmpty(Displaylists), glass: true }, dd.div({ className: 'ActionLists' }, dd.h2({ style: { marginTop: 0 } }, 'Master Action Lists'), dd.p({ style: { marginBottom: 40 } }, 'This screen makes changes to the master to-do list, which affects all applications of the list to events going forward. Changes made here will not affect todo-items already created.'), ProOnly({
	        sids: AuthedUserSession.doIHaveAccess.admin.getSIDs(),
	        custom_message: 'With a PRO account you can manage the master to-do lists for all your events.'
	      }, _.size(my_sids) > 1 ? SpeakerForm({
	        sid: selected_sid,
	        Displaylists: Displaylists,
	        sids_to_choose: my_sids,
	        onSidChanged: this.__onSidChanged
	      }) : null, dd.div({ className: "clearfix" }), speaker ? MasterActionLists({
	        speaker: speaker,
	        Displaylists: Displaylists
	      }) : null), onCancel ? dd.button({
	        className: 'btn btn-default btn-lg',
	        onClick: onCancel
	      }, 'Cancel') : null));
	    }
	
	    return LoadingWrap({ is_loading: _.isEmpty(Displaylists), glass: true }, dd.div({ className: "ActionLists" }, dd.h2({ style: { marginTop: 0 } }, "Action Lists Have MOVED"), dd.p({ style: { marginBottom: 40 } }, "The Master Action List screen has been moved to the main dashboard."), dd.a({
	      href: "/dashboard/token-callback?token=" + _.get(AuthedUserSession, ["balboa", "estoken"], "") + "&redir=" + this.state.selected_sid + "/actionlist-settings",
	      target: "_blank"
	    }, dd.button({
	      className: "btn btn-primary btn-lg",
	      style: { margin: "auto" }
	    }, "Master Action List Editor"))
	
	    //     ProOnly({
	    //         sids: AuthedUserSession.doIHaveAccess.admin.getSIDs(),
	    //         custom_message: 'With a PRO account you can manage the master to-do lists for all your events.'
	    //       },
	    //
	    //       _.size(my_sids) > 1 ? SpeakerForm({
	    //         sid: selected_sid,
	    //         Displaylists,
	    //         sids_to_choose: my_sids,
	    //         onSidChanged: this.__onSidChanged
	    //       }) : null,
	    //
	    //       dd.div({className: "clearfix"}),
	    //
	    //       speaker
	    //         ? MasterActionLists({
	    //           speaker: speaker,
	    //           Displaylists: Displaylists,
	    //         })
	    //         : null
	    //     ),
	    //     onCancel ? dd.button({
	    //       className: 'btn btn-default btn-lg',
	    //       onClick: onCancel
	    //     }, 'Cancel') : null
	    ), dd.div({ className: "clearfix" }));
	  }
	});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	// var radio = require('ES/lib/radio');
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var VerticalFields = __webpack_require__(86);
	var AuthedUserSession = __webpack_require__(4);
	var reloadDisplaylists = __webpack_require__(69);
	var reloadSitelists = __webpack_require__(387);
	
	module.exports = dd.createClass({
	    mixins: [RadioMixin],
	    getInitialState: function getInitialState() {
	        return { saving: false, error_msg: null, sitelists_reloaded: false, displaylists_reloaded: false };
	    },
	    componentWillMount: function componentWillMount() {
	        var self = this;
	        self.radio = {
	            Displaylists_get: function Displaylists_get() {
	                self.setState({ saving: true, error_msg: null, displaylists_reloaded: false });
	            },
	            Displaylists_get_succeeded: function Displaylists_get_succeeded() {
	                self.setState({ saving: false, displaylists_reloaded: true });
	            },
	            Displaylists_get_failed: function Displaylists_get_failed(message) {
	                self.setState({ saving: false, error_msg: 'Failed to clear the cache: ' + message, displaylists_reloaded: false });
	            },
	            Sitelists_get: function Sitelists_get() {
	                self.setState({ saving: true, error_msg: null, sitelists_reloaded: false });
	            },
	            Sitelists_get_succeeded: function Sitelists_get_succeeded() {
	                self.setState({ saving: false, sitelists_reloaded: true });
	            },
	            Sitelists_get_failed: function Sitelists_get_failed(message) {
	                self.setState({ saving: false, error_msg: 'Failed to clear the cache: ' + message, sitelists_reloaded: false });
	            }
	        };
	    },
	    __onSubmit: function __onSubmit(data) {
	        reloadDisplaylists();
	        reloadSitelists();
	    },
	    render: function render() {
	        var Displaylists = this.props.Displaylists;
	
	        return LoadingWrap({ is_loading: _.isEmpty(Displaylists) || this.state.saving, glass: true }, dd.div({ className: 'Preferences' }, dd.h2({ style: { marginTop: 0 } }, 'Advanced Settings'), ErrorAlert({ message: this.state.error_msg }), this.state.sitelists_reloaded && this.state.displaylists_reloaded ? dd.div({ className: 'alert alert-success' }, "Cache has been cleared successfully. You will need to sign in again. RELOAD the page to complete the process.") : null, DaForm({ Displaylists: Displaylists, onSubmit: this.__onSubmit })));
	    }
	});
	
	var DaForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        var Displaylists = props.Displaylists;
	        return AuthedUserSession.MY_USERNAME + JSON.stringify(Displaylists && Displaylists.user && Displaylists.user.myevents_preferences);
	    },
	    getInitialValues: function getInitialValues(props) {
	        return {};
	    },
	    buildFields: function buildFields() {
	        return {};
	    },
	    render: function render() {
	        return dd.form({ className: '', onSubmit: this._form_onSubmit }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-12' }, dd.p({}, "You can clear the saved cache below.  You will download updated settings, action lists, templates, and other company data on your next refresh."))), dd.div({ className: 'row' }, dd.div({ className: 'col-sm-12' }, VerticalFields.FormButtons({ scale: 'md', submit_btn_text: "Clear Cache" }))));
	    }
	});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ServicesUtils = __webpack_require__(33);
	
	module.exports = dd.createClass({
	    mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_APIkey_config", "save_Thirdpartyconnection_APIkey_config")],
	
	    getInitialState: function getInitialState() {
	        return {
	            sid: -1,
	            save_error_msg: null,
	            read_error_msg: null,
	            saving: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        this.__loadForSid(props.selected_sid);
	    },
	    componentDidMount: function componentDidMount() {
	        this.__loadForSid(this.props.selected_sid);
	    },
	    componentWillMount: function componentWillMount() {
	        var self = this;
	        self.radio = {
	            save_Thirdpartyconnection_APIkey_config_failed: function save_Thirdpartyconnection_APIkey_config_failed(sid, message) {
	                if (self.state.sid == sid) {
	                    self.setState({ config: null, saving: false, save_error_msg: 'Problem changing your API key: ' + message });
	                }
	            },
	            save_Thirdpartyconnection_APIkey_config_succeeded: function save_Thirdpartyconnection_APIkey_config_succeeded(sid, data) {
	                if (self.state.sid == sid) {
	                    self.setState({ config: data, save_error_message: null });
	                }
	            }
	        };
	    },
	    __loadForSid: function __loadForSid(sid) {
	        if (sid !== this.state.sid) {
	            this.setState({ sid: sid }, function () {
	                var self = this;
	                radio('read_Thirdpartyconnection_APIkey_config').broadcast(sid, function (sid, data) {
	                    if (self.state.sid == sid) {
	                        self.setState({ config: data, read_error_msg: null });
	                    }
	                }, function (sid, message) {
	                    if (self.state.sid == sid) {
	                        self.setState({ read_error_msg: message });
	                    }
	                });
	            });
	        }
	    },
	    __onSubmit: function __onSubmit() {
	        radio('save_Thirdpartyconnection_APIkey_config').broadcast(this.state.sid, function (sid, data) {
	            //see componentWillMount()
	        });
	    },
	    render: function render() {
	        var Displaylists = this.props.Displaylists;
	        var speaker = _.find(_.get(Displaylists, "perspeaker"), { 'sid': this.state.sid });
	        var espeakers_apikey = _.get(this.state, "config.espeakers_apikey", null);
	
	        return dd.div(null, LoadingWrap({
	            is_loading: this.state.saving,
	            glass: true
	        }, dd.h3(null, 'eSpeakers API key for ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), ErrorAlert({ message: this.state.save_error_msg }), ErrorAlert({ message: this.state.read_error_msg }), dd.p({ className: 'text-muted' }, 'This is the API key for ', speaker ? speaker.name_full : '', '. Use it to give third-party software access to your eSpeakers data.'), dd.p({ className: 'text-muted' }, 'TREAT THIS LIKE A PASSWORD. Any service that knows this key can access and change your eSpeakers data.'), espeakers_apikey ? dd.div({
	            className: 'well',
	            style: { fontSize: '0.85em', fontFamily: 'monospace', wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal' }
	        }, espeakers_apikey) : null, dd.div({ className: 'pull-right' }, dd.div({}, 'Change your API Key to invalidate any services using the current one and generate a new key.'), dd.button({ className: 'pull-right btn btn-sm', onClick: this.__onSubmit }, 'Change API Key'))));
	    }
	});
	
	//// NEWER STYLE (almost complete)
	
	//
	// import _ from "ES/lib/lodash";
	// import React from "ES/lib/react";
	// import radio from "ES/lib/react-pubsub-via-radio.js/radio";
	// import ErrorAlert from "ES/widgets/ErrorAlert";
	// import LoadingWrap from "ES/widgets/LoadingWrap";
	// import CopyToClipboard from 'react-copy-to-clipboard';
	// import ServicesUtils from 'ES/utils/ServicesUtils';
	//
	//
	// //export default React.createClass({
	// //export default React.createFactory(React.createClass({
	// class APIkey extends React.Component {
	//
	//     //mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_APIkey_config", "save_Thirdpartyconnection_APIkey_config")],
	//
	//     getInitialState() {
	//         return {
	//             sid: -1,
	//             save_error_msg: null,
	//             read_error_msg: null,
	//             saving: false,
	//             copied: false
	//         };
	//     }
	//
	//     componentWillReceiveProps(props) {
	//         this.__loadForSid(props.selected_sid);
	//     }
	//
	//     componentDidMount() {
	//         this.__loadForSid(this.props.selected_sid);
	//     }
	//
	//     componentWillMount() {
	//         var self = this;
	//         self.radio = {
	//             save_Thirdpartyconnection_APIkey_config_failed: function (sid, message) {
	//                 if (self.state.sid == sid) {
	//                     self.setState({config: null, saving: false, save_error_msg: 'Problem changing your API key: ' + message});
	//                 }
	//             },
	//             save_Thirdpartyconnection_APIkey_config_succeeded: function (sid, data) {
	//                 if (self.state.sid == sid) {
	//                     self.setState({config: data, save_error_message: null});
	//                 }
	//             }
	//         };
	//     }
	//
	//     __loadForSid(sid) {
	//         if (sid !== this.state.sid) {
	//             this.setState({sid: sid}, function () {
	//                 var self = this;
	//                 radio('read_Thirdpartyconnection_APIkey_config').broadcast(sid,
	//                     function (sid, data) {
	//                         if (self.state.sid == sid) {
	//                             self.setState({config: data, read_error_msg: null});
	//                         }
	//                     },
	//                     function (sid, message) {
	//                         if (self.state.sid == sid) {
	//                             self.setState({read_error_msg: message});
	//                         }
	//                     });
	//             });
	//         }
	//     }
	//
	//     __onSubmit() {
	//         radio('save_Thirdpartyconnection_APIkey_config').broadcast(this.state.sid,
	//             function (sid, data) {
	//                 //see componentWillMount()
	//             }
	//         );
	//     }
	//
	//     render() {
	//         let Displaylists = this.props.Displaylists;
	//         let speaker = _.find(_.get(Displaylists, "perspeaker"), {'sid': this.state.sid});
	//         let espeakers_apikey = _.get(this.state, "config.espeakers_apikey", null);
	//         //const {copied} = this.state;
	//
	//         return <div>
	//             <LoadingWrap is_loading={this.state.saving} glass={true}>
	//                 <h3>
	//                     eSpeakers API key for <span className="nametag">{_.get(speaker, "name", "")}</span>
	//                 </h3>
	//                 <ErrorAlert message={this.state.save_error_msg}/>
	//                 <ErrorAlert message={this.state.read_error_msg}/>
	//                 <p className="text-muted">
	//                     This is the API key for {_.get(speaker, "name", "")}. Use this to give third-party software access to your eSpeakers data.
	//                 </p>
	//                 {espeakers_apikey && <div className="well" style={{fontSize: "0.85em", fontFamily: "monospace", wordWrap: "break-word", wordBreak: "break-all", whiteSpace: "normal"}}>
	//                     {espeakers_apikey}
	//                     <CopyToClipboard text={espeakers_apikey} onCopy={() => this.setState({copied: true})}>
	//                         <a style={{marginLeft: "0.5em"}}><span className="glyphicon glyphicon-paste"></span></a>
	//                     </CopyToClipboard>
	//                 </div>
	//                 }
	//                 <div className="pull-right">
	//                     <div>Change your API Key to break the connection from any services using the current one, and generate a new key.</div>
	//                     <button className="pull-right btn btn-sm" onClick={this.__onSubmit}>Change API Key</button>
	//                 </div>
	//             </LoadingWrap>
	//         </div>;
	//     }
	// };

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { sid: -1, has_award_wallet_connected: null, is_reading: false, read_error_msg: null };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__loadForSid(props.selected_sid);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__loadForSid(this.props.selected_sid);
	  },
	  __loadForSid: function __loadForSid(sid) {
	    if (sid != this.state.sid) {
	      this.setState({ sid: sid, has_award_wallet_connected: null, is_reading: false, read_error_msg: null }, function () {
	        radio('read_Thirdpartyconnection_AwardWallet_config').broadcast(sid);
	      });
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      read_Thirdpartyconnection_AwardWallet_config: function read_Thirdpartyconnection_AwardWallet_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({ has_award_wallet_connected: null, is_reading: true, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_AwardWallet_config_succeeded: function read_Thirdpartyconnection_AwardWallet_config_succeeded(sid, has_it) {
	        if (self.state.sid == sid) {
	          self.setState({ has_award_wallet_connected: !!has_it, is_reading: false, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_AwardWallet_config_failed: function read_Thirdpartyconnection_AwardWallet_config_failed(sid, message) {
	        if (self.state.sid == sid) {
	          self.setState({ has_award_wallet_connected: null, is_reading: false, read_error_msg: 'Failed to read your Award Wallet connector settings: ' + message });
	        }
	      }
	    };
	  },
	  __removeAwardWalletConfig: function __removeAwardWalletConfig(sid) {
	    var self = this;
	    if (sid == this.state.sid) {
	      radio("remove_Thirdpartyconnection_AwardWallet_config").broadcast(sid, function (sid, data) {
	        self.setState({
	          has_award_wallet_connected: false,
	          is_reading: false,
	          read_error_msg: null
	        });
	      }, function (sid, data) {
	        self.setState({
	          has_award_wallet_connected: true,
	          is_reading: false,
	          read_error_msg: _.get(data, "message", "Unknown error.")
	        });
	      });
	    }
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return spkr.sid == this.state.sid;
	    }, this);
	
	    var connect_url = "/balboa3/thirdpartyconnection/configawardwallet/" + this.state.sid + "/start_oauth?" + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	
	    return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, 'AwardWallet connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ', 'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'), ErrorAlert({ message: this.state.read_error_msg }), this.state.has_award_wallet_connected === true ? dd.div(null, dd.div({ className: "alert alert-success" }, "You are connected to AwardWallet!"), dd.p({}, dd.a({ href: connect_url }, "Click here to CHANGE the AwardWallet account to which you are connected.")), dd.p({}, dd.a({
	      href: '#',
	      onClick: this.__removeAwardWalletConfig.bind(this, this.state.sid)
	    }, "Click here to DISCONNECT your AwardWallet account."))) : dd.div(null, dd.p(null, "The link below will take you to AwardWallet's site, where you can sign in with your AwardWallet credentials."), dd.p(null, "AwardWallet will ask if it's OK for eSpeakers to access your contacts, and you should ", dd.b(null, "choose ALLOW ACCESS.")), dd.a({ href: connect_url, className: "btn btn-primary" }, "Connect to your AwardWallet account"), dd.br(), dd.br())));
	  }
	});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      sid: -1,
	      has_google_connected: null,
	      is_reading: false,
	      read_error_msg: null
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__loadForSid(props.selected_sid);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__loadForSid(this.props.selected_sid);
	  },
	  __loadForSid: function __loadForSid(sid) {
	    if (sid != this.state.sid) {
	      this.setState({
	        sid: sid,
	        has_google_connected: null,
	        is_reading: false,
	        read_error_msg: null
	      }, function () {
	        radio("read_Thirdpartyconnection_Google_config").broadcast(sid);
	      });
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      read_Thirdpartyconnection_Google_config: function read_Thirdpartyconnection_Google_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_google_connected: null,
	            is_reading: true,
	            read_error_msg: null
	          });
	        }
	      },
	      read_Thirdpartyconnection_Google_config_succeeded: function read_Thirdpartyconnection_Google_config_succeeded(sid, has_it) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_google_connected: !!has_it,
	            is_reading: false,
	            read_error_msg: null
	          });
	        }
	      },
	      read_Thirdpartyconnection_Google_config_failed: function read_Thirdpartyconnection_Google_config_failed(sid, message) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_google_connected: null,
	            is_reading: false,
	            read_error_msg: "Failed to read your Google connector settings: " + message
	          });
	        }
	      }
	    };
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return spkr.sid == this.state.sid;
	    }, this);
	
	    var connect_url = "/balboa3/thirdpartyconnection/configgoogle/" + this.state.sid + "/start_oauth?" + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	
	    return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, "Google Contacts connector for ", dd.span({ className: "nametag" }, AuthedUserSession.MY_USERNAME), " + ", dd.span({ className: "nametag" }, speaker ? speaker.name_full : "")), dd.p({ className: "text-muted" }, "NOTE: The settings for this connector is for your eSpeakers account for this speaker specifically.  ", "Other users for this speaker account will need to configure this individually with their own Google login."), ErrorAlert({ message: this.state.read_error_msg }), this.state.has_google_connected === true ? dd.div(null, dd.div({ className: "alert alert-success" }, "You are connected to Google!"), dd.a({ href: connect_url }, "Click here to change the Google account to which you are connected."), dd.p({ className: "small", style: { marginTop: "1rem" } }, "EventCX's use and transfer to any other app of information received from Google APIs will adhere to Google API Services User Data Policy, including the ", dd.a({
	      href: "https://developers.google.com/terms/api-services-user-data-policy"
	    }, "Limited Use requirements"), dd.span(null, "."))) : dd.div(null, dd.p(null, "The link below will take you to Google's site, where you can sign in to Google and choose which of your Google accounts you want to link to ", "(if you have more than one Google account)."), dd.p(null, "Google will ask if it's OK for eSpeakers to access your contacts, and you should ", dd.b(null, "choose ALLOW ACCESS.")), dd.a({ href: connect_url, className: "btn btn-default" }, dd.img({
	      src: "img/google_contacts_icon_2022.png",
	      height: 24,
	      width: 24
	    }), " Connect your Google Contacts"), dd.p({ className: "small", style: { marginTop: "1rem" } }, "EventCX's use and transfer to any other app of information received from Google APIs will adhere to Google API Services User Data Policy, including the ", dd.a({
	      href: "https://developers.google.com/terms/api-services-user-data-policy"
	    }, "Limited Use requirements"), dd.span(null, ".")))));
	  }
	});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var ErrorAlert = __webpack_require__(6);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { read_error_msg: null };
	  },
	  render: function render() {
	    return dd.div(null, dd.h3(null, "HighLevel CRM connection"), dd.p({}, "The connection settings for the HighLevel CRM are on ", dd.a({ href: "/dashboard/high-level" }, "your main dashboard ->")), ErrorAlert({ message: this.state.read_error_msg }));
	  }
	});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { sid: -1, has_hubspot_connected: null, is_reading: false, read_error_msg: null };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__loadForSid(props.selected_sid);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__loadForSid(this.props.selected_sid);
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      read_Thirdpartyconnection_Hubspot_config: function read_Thirdpartyconnection_Hubspot_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({ has_hubspot_connected: null, is_reading: true, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_Hubspot_config_succeeded: function read_Thirdpartyconnection_Hubspot_config_succeeded(sid, data) {
	        if (self.state.sid == sid) {
	          self.setState({ has_hubspot_connected: !_.isEmpty(data), is_reading: false, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_Hubspot_config_failed: function read_Thirdpartyconnection_Hubspot_config_failed(sid, message) {
	        if (self.state.sid == sid) {
	          self.setState({ has_hubspot_connected: null, is_reading: false, read_error_msg: 'Failed to read your Hubspot connector settings: ' + message });
	        }
	      },
	      remove_Thirdpartyconnection_Hubspot_config: function remove_Thirdpartyconnection_Hubspot_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({ has_hubspot_connected: null, is_reading: true, read_error_msg: null });
	        }
	      }
	
	    };
	  },
	  __loadForSid: function __loadForSid(sid) {
	    if (sid != this.state.sid) {
	      this.setState({ sid: sid, has_hubspot_connected: null, is_reading: false, read_error_msg: null }, function () {
	        radio('read_Thirdpartyconnection_Hubspot_config').broadcast(sid);
	      });
	    }
	  },
	  __removeHubspotConfig: function __removeHubspotConfig(sid) {
	
	    var self = this;
	    if (sid == this.state.sid) {
	      radio('remove_Thirdpartyconnection_Hubspot_config').broadcast(sid, function (sid, data) {
	        self.setState({ has_hubspot_connected: false, is_reading: false, read_error_msg: null });
	      }, function (sid, data) {
	        self.setState({ has_hubspot_connected: true, is_reading: false, read_error_msg: _.get(data, 'message', 'Unknown error.') });
	      });
	    }
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return spkr.sid == this.state.sid;
	    }, this);
	
	    var connect_url = '/balboa3/thirdpartyconnection/confighubspot/' + this.state.sid + '/start_oauth?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	
	    return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, 'HubSpot connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is for your eSpeakers account for this speaker specifically. ', 'Other users for this speaker account will need to configure this individually with their own HubSpot login.'), ErrorAlert({ message: this.state.read_error_msg }), this.state.has_hubspot_connected === true ? dd.div(null, dd.div({ className: 'alert alert-success' }, 'You are connected to HubSpot!'), dd.p({}, dd.a({ href: connect_url }, 'Click here to CHANGE the HubSpot account to which you are connected.')), dd.p({}, dd.a({ onClick: this.__removeHubspotConfig.bind(this, this.state.sid) }, 'Click here to DISCONNECT your HubSpot account.'))) : dd.div(null, dd.p(null, 'The link below will take you to Hubspot\'s site, where you can sign in with your HubSpot credentials.'), dd.p(null, 'HubSpot will ask if it\'s OK for eSpeakers to access your contacts, and you should ', dd.b(null, 'choose ALLOW ACCESS.')), dd.a({ href: connect_url, className: 'btn btn-primary' }, 'Connect to your HubSpot account'), dd.br(), dd.br())));
	  }
	});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ServicesUtils = __webpack_require__(33);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
		mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_Infusionsoft_config", "save_Thirdpartyconnection_Infusionsoft_config")],
		__RadioAjax_key_read_Thirdpartyconnection_Infusionsoft_config: function __RadioAjax_key_read_Thirdpartyconnection_Infusionsoft_config() {
			return this.state.sid;
		},
		__RadioAjax_key_save_Thirdpartyconnection_Infusionsoft_config: function __RadioAjax_key_save_Thirdpartyconnection_Infusionsoft_config() {
			return this.state.sid;
		},
		getInitialState: function getInitialState() {
			return { sid: -1 };
		},
		componentWillReceiveProps: function componentWillReceiveProps(props) {
			this.__loadForSid(props.selected_sid);
		},
		componentDidMount: function componentDidMount() {
			this.__loadForSid(this.props.selected_sid);
		},
		__loadForSid: function __loadForSid(sid) {
			if (sid !== this.state.sid) {
				this.setState({ sid: sid }, function () {
					radio('read_Thirdpartyconnection_Infusionsoft_config').broadcast(sid);
				});
			}
		},
		__onSubmit: function __onSubmit(data) {
			radio('save_Thirdpartyconnection_Infusionsoft_config').broadcast(this.state.sid, data);
		},
		render: function render() {
			var Displaylists = this.props.Displaylists;
	
			var sid = this.state.sid;
			var ajax_read = this.state.read_Thirdpartyconnection_Infusionsoft_config;
			var ajax_save = this.state.save_Thirdpartyconnection_Infusionsoft_config;
	
			var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
				return spkr.sid == sid;
			}, this);
	
			return dd.div(null, LoadingWrap({
				is_loading: ajax_read.waiting || ajax_save.waiting,
				glass: true
			}, dd.h3(null, 'Keap connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is PER-USER. Each user on the account must individually use this configuration page.'), ErrorAlert({ message: ajax_read.error_message }), ErrorAlert({ message: ajax_save.error_message }), DaForm({
				sid: sid,
				config: ajax_read.data,
				onSubmit: this.__onSubmit
			})));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return props.sid + JSON.stringify(this.getInitialValues(props));
		},
		getInitialValues: function getInitialValues(props) {
			var config = props.config || {};
			return {
				app_name: config.app_name || '',
				app_key: config.app_key || '',
				infusionsoft_username: config.infusionsoft_username || '',
				infusionsoft_password: config.infusionsoft_password || ''
			};
		},
		buildFields: function buildFields() {
			return {
				app_name: {
					label: 'Keap ACCOUNT CODE',
					type: 'text',
					help_text: 'example: bc423',
					tooltip: 'This is the account code for your Keap account. You can find it by looking at the first part of your Keap URL (just before .infusionsoft.com)'
				},
				app_key: {
					label: 'Keap APP KEY',
					type: 'text',
					help_text: 'example: 08491f242aaa21e013fa56b26c1a9c72',
					tooltip: 'Input the Keap App Key. You can find this in Keap in ADMIN -> SETTINGS -> APPLICATION -> API -> ENCRYPTED KEY.'
				},
				infusionsoft_username: {
					label: 'Keap EMAIL ADDRESS',
					type: 'text',
					help_text: 'example: jsmith@example.com',
					tooltip: 'This is your individual email address that you use when logging in to Keap.'
				},
				infusionsoft_password: {
					label: 'Keap PASSWORD',
					type: 'text',
					help_text: '(cASE sENSITIVE)',
					tooltip: 'Enter the password you use to access your Keap account. This is CASE SENSITIVE.'
				}
			};
		},
		__discardChanges: esUtils.wrapPreventDefault(function () {
			this._form_reset();
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var changes_made = this._form_areChangesMade();
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })));
		}
	});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ServicesUtils = __webpack_require__(33);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	
	module.exports = dd.createClass({
		mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_Insightly_config", "save_Thirdpartyconnection_Insightly_config")],
		getInitialState: function getInitialState() {
			return { sid: -1, successMessage: null, failureMessage: null };
		},
		__RadioAjax_key_read_Thirdpartyconnection_Insightly_config: function __RadioAjax_key_read_Thirdpartyconnection_Insightly_config() {
			return this.state.sid;
		},
		__RadioAjax_key_save_Thirdpartyconnection_Insightly_config: function __RadioAjax_key_save_Thirdpartyconnection_Insightly_config() {
			return this.state.sid;
		},
		__RadioAjax_read_Thirdpartyconnection_Insightly_config_success: function __RadioAjax_read_Thirdpartyconnection_Insightly_config_success() {
			this.setState({ successMessage: 'API Key saved. You can now grab contacts from Insightly.', failureMessage: null });
		},
		__RadioAjax_read_Thirdpartyconnection_Insightly_config_failure: function __RadioAjax_read_Thirdpartyconnection_Insightly_config_failure(sid, data) {
			this.setState({ successMessage: null, failureMessage: data });
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(props) {
			this.__loadForSid(props.selected_sid);
		},
		componentDidMount: function componentDidMount() {
			this.__loadForSid(this.props.selected_sid);
		},
		__loadForSid: function __loadForSid(sid) {
			if (sid !== this.state.sid) {
				this.setState({ sid: sid }, function () {
					radio('read_Thirdpartyconnection_Insightly_config').broadcast(sid);
				});
			}
		},
		__onSubmit: function __onSubmit(data) {
			radio('save_Thirdpartyconnection_Insightly_config').broadcast(this.state.sid, data, this.__RadioAjax_read_Thirdpartyconnection_Insightly_config_success, this.__RadioAjax_read_Thirdpartyconnection_Insightly_config_failure);
		},
		render: function render() {
			var Displaylists = this.props.Displaylists;
	
			var sid = this.state.sid;
			var ajax_read = this.state.read_Thirdpartyconnection_Insightly_config; //this doesn't appear to be hooked up
			var ajax_save = this.state.save_Thirdpartyconnection_Insightly_config; //this doesn't appear to be hooked up
			var successMessage = this.state.successMessage;
			var failureMessage = this.state.failureMessage;
	
			var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
				return spkr.sid == sid;
			}, this);
	
			return dd.div(null, LoadingWrap({
				is_loading: ajax_read.waiting || ajax_save.waiting,
				glass: true
			}, dd.h3(null, 'Insightly connector for ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is PER-SPEAKER. This change will apply to all users on the account.'), ErrorAlert({ message: ajax_read.error_message }), ErrorAlert({ message: ajax_save.error_message }), ErrorAlert({ message: failureMessage }), _.isEmpty(successMessage) ? null : dd.div({ className: 'alert alert-success' }, successMessage), DaForm({
				sid: sid,
				config: ajax_read.data,
				onSubmit: this.__onSubmit
			})));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return props.sid + JSON.stringify(this.getInitialValues(props));
		},
		getInitialValues: function getInitialValues(props) {
			var config = props.config || {};
			return {
				insightly_api_token: config.insightly_api_token || ''
			};
		},
		buildFields: function buildFields() {
			return {
				insightly_api_token: {
					label: 'Insightly API KEY',
					type: 'text',
					help_text: 'example: 08491f242aaa21e013fa56b26c1a9c72',
					tooltip: 'Input the your Insightly API Key. You can find this in Insightly in USER SETTINGS -> API KEY.'
				}
			};
		},
		__discardChanges: esUtils.wrapPreventDefault(function () {
			this._form_reset();
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var changes_made = this._form_areChangesMade();
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })));
		}
	});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ServicesUtils = __webpack_require__(33);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var AuthedUserSession = __webpack_require__(4);
	var FormUtils = __webpack_require__(9);
	
	var DaForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props.sid + JSON.stringify(this.getInitialValues(props));
	    },
	    getInitialValues: function getInitialValues(props) {
	        var config = props.config || {};
	        return {
	            karmacrm_api_token: config.karmacrm_api_token || ''
	        };
	    },
	    buildFields: function buildFields() {
	        return {
	            karmacrm_api_token: {
	                label: 'karmaCRM API token',
	                type: 'text',
	                help_text: 'example: NDzJcvqdNUoqZ2oXQvqq',
	                tooltip: 'Enter your karmaCRM API token.',
	                validate: FormUtils.optional
	            }
	        };
	    },
	    __discardChanges: esUtils.wrapPreventDefault(function () {
	        this._form_reset();
	    }),
	    render: function render() {
	        var fields = this.buildFields();
	        var errors = this.state.errors || {};
	        var changes_made = this._form_areChangesMade();
	
	        return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
	            fields: fields,
	            errors: errors,
	            buildInput: this._form_buildInput
	        }), SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })));
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_KarmaCRM_config", "save_Thirdpartyconnection_KarmaCRM_config")],
	    getInitialState: function getInitialState() {
	        return { sid: -1, successMessage: null, failureMessage: null };
	    },
	    __RadioAjax_key_read_Thirdpartyconnection_KarmaCRM_config: function __RadioAjax_key_read_Thirdpartyconnection_KarmaCRM_config() {
	        return this.state.sid;
	    },
	    __RadioAjax_key_save_Thirdpartyconnection_KarmaCRM_config: function __RadioAjax_key_save_Thirdpartyconnection_KarmaCRM_config() {
	        return this.state.sid;
	    },
	    __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_success: function __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_success() {
	        this.setState({ successMessage: 'API Key saved.', failureMessage: null });
	    },
	    __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_failure: function __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_failure(sid, data) {
	        this.setState({ successMessage: null, failureMessage: data });
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        this.__loadForSid(props.selected_sid);
	    },
	    componentDidMount: function componentDidMount() {
	        this.__loadForSid(this.props.selected_sid);
	    },
	    __loadForSid: function __loadForSid(sid) {
	        if (sid !== this.state.sid) {
	            this.setState({ sid: sid, failureMessage: "", successMessage: "" }, function () {
	                radio('read_Thirdpartyconnection_KarmaCRM_config').broadcast(sid);
	            });
	        }
	    },
	    __onSubmit: function __onSubmit(data) {
	        radio('save_Thirdpartyconnection_KarmaCRM_config').broadcast(this.state.sid, data, this.__RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_success, this.__RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_failure);
	    },
	    render: function render() {
	        var Displaylists = this.props.Displaylists;
	
	        var sid = this.state.sid;
	        var ajax_read = this.state.read_Thirdpartyconnection_KarmaCRM_config; //this doesn't appear to be hooked up
	        var ajax_save = this.state.save_Thirdpartyconnection_KarmaCRM_config; //this doesn't appear to be hooked up
	        var successMessage = this.state.successMessage;
	        var failureMessage = this.state.failureMessage;
	
	        var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	            return spkr.sid == sid;
	        }, this);
	        return dd.div(null, LoadingWrap({
	            is_loading: ajax_read.waiting || ajax_save.waiting,
	            glass: true
	        }, dd.h3(null, 'karmaCRM connector for ', dd.span({ className: 'nametag' }, _.get(AuthedUserSession, "MY_USERNAME")), ' + ', dd.span({ className: 'nametag' }, _.get(speaker, "name_full"))), dd.p({ className: 'text-muted' }, 'NOTE: The setting for this connector is unique to the user-speaker combination. Each user on a speaker\'s account will need to connect this individually.'),
	        // ErrorAlert({message: ajax_read.error_message}),
	        // ErrorAlert({message: ajax_save.error_message}),
	        ErrorAlert({ message: failureMessage }), _.isEmpty(successMessage) ? null : dd.div({ className: 'alert alert-success' }, successMessage), DaForm({
	            sid: sid,
	            config: ajax_read.data,
	            onSubmit: this.__onSubmit
	        }), dd.div({ className: "row", style: { marginTop: "4em" } }, dd.div({ className: "col-sm-12 text-left" }, dd.p({ className: "text-muted" }, "Need help ", dd.a({ href: "http://support.karmacrm.com/users/settings/account-settings-profile-details", target: "_blank" }, "finding your karmaCRM API key?"))), dd.div({ className: "col-sm-12 text-left" }, dd.p({ className: "text-muted" }, "To disconnect from karmaCRM, clear out your API token above and click SAVE.")))));
	    }
	});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	/*global screen localStorage*/
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var radio = __webpack_require__(24);
	var RadioServiceMixin = __webpack_require__(14);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Quickbooks_readAuth: {
					key: function key() {
						return 1;
					}
				},
				Quickbooks_disconnectAuth: {
					key: function key() {
						return 1;
					}
				}
			};
		},
		getInitialState: function getInitialState() {
			return { sid: -1 };
		},
		componentWillReceiveProps: function componentWillReceiveProps(props) {
			this.__loadForSid(props.selected_sid);
		},
		componentDidMount: function componentDidMount() {
			this.__loadForSid(this.props.selected_sid);
		},
		__loadForSid: function __loadForSid(sid) {
			if (sid != this.state.sid) {
				this.setState({ sid: sid }, function () {
					radio('Quickbooks_readAuth').broadcast({ sid: sid });
				});
			}
		},
		_openConnectPopup: function _openConnectPopup() {
			var connect_url = '/balboa3/quickbooks/connectauth/?sid=' + this.state.sid + '&' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
			var wind = { height: 640, width: 800 };
			var parameters = 'location=1';
			parameters += ',width=' + wind.width + ',height=' + wind.height;
			parameters += ',left=' + (screen.width - wind.width) / 2 + ',top=' + (screen.height - wind.height) / 2;
			window.open(connect_url, 'Intuit QuickBooks Authorize Popup', parameters);
		},
		_disconnectAccount: esUtils.wrapPreventDefault(function (e) {
			localStorage.removeItem('connection_type');
			radio('Quickbooks_disconnectAuth').broadcast({ sid: this.state.sid });
		}),
		render: function render() {
	
			var ajax = this.state.Quickbooks_readAuth;
			var ajax2 = this.state.Quickbooks_disconnectAuth;
			var isConnected = ajax.data && ajax.data.data.is_connected;
			if (ajax2.data && ajax2.data.data && ajax2.data.data.is_connected === false) {
				isConnected = false;
			}
			var Displaylists = this.props.Displaylists;
			var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
				return spkr.sid == this.state.sid;
			}, this);
			var originEid = localStorage.getItem('origin_eid') ? localStorage.getItem('origin_eid') : null;
			if (isConnected) {
				localStorage.removeItem('origin_eid');
			}
			return dd.div(null, LoadingWrap({ is_loading: ajax.waiting || ajax2.waiting, glass: true }, dd.h3(null, 'QuickBooks connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ', 'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'), ErrorAlert({ message: ajax.error }), ErrorAlert({ message: ajax2.error }), isConnected ? dd.div(null, dd.div({ className: 'alert alert-success' }, 'You are connected to QuickBooks!'), dd.a({ href: '#', onClick: this._disconnectAccount }, 'Click here to disconnect your QuickBooks account.'), originEid ? dd.div({ style: { marginTop: '20px' } }, dd.a({ href: '#/events/' + originEid + '/services', className: 'btn btn-default' }, dd.i({ className: 'fa fa-arrow-left' }), ' Back to last viewed event')) : '') : dd.div(null, originEid ? dd.div({ className: 'alert alert-info' }, dd.strong(null, 'Heads Up!'), ' In order to use the QuickBooks Online invoice feature, you\'ll first need to connect your QuickBooks account.') : '', dd.p(null, 'The link below will open a popup to Intuit\'s site, where you can sign in.'), dd.p(null, 'Intuit will ask permission to securely share your data with eSpeakers, and you should ', dd.b(null, 'choose AUTHORIZE.')), dd.a({ onClick: this._openConnectPopup, className: 'btn btn-primary' }, 'Connect to your QuickBooks account'), dd.br(), dd.br())));
		}
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ServicesUtils = __webpack_require__(33);
	var HorizontalFields = __webpack_require__(23);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
		mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_SalesForce_config", "save_Thirdpartyconnection_SalesForce_config")],
		__RadioAjax_key_read_Thirdpartyconnection_SalesForce_config: function __RadioAjax_key_read_Thirdpartyconnection_SalesForce_config() {
			return this.state.sid;
		},
		__RadioAjax_key_save_Thirdpartyconnection_SalesForce_config: function __RadioAjax_key_save_Thirdpartyconnection_SalesForce_config() {
			this.setState({ has_connected: true });
			return this.state.sid;
		},
		getInitialState: function getInitialState() {
			return { sid: -1, has_connected: null, is_reading: false, read_error_msg: null, show_disconnect: false };
		},
		componentWillMount: function componentWillMount() {
			var self = this;
			self.radio = {
				save_Thirdpartyconnection_SalesForce_config: function save_Thirdpartyconnection_SalesForce_config(sid) {
					if (self.state.sid === sid) {
						self.setState({ has_connected: null, is_reading: true, read_error_msg: null });
					}
				},
				save_Thirdpartyconnection_SalesForce_config_succeeded: function save_Thirdpartyconnection_SalesForce_config_succeeded(sid, has_it) {
					if (self.state.sid === sid) {
						self.setState({ has_connected: !!has_it, is_reading: false, read_error_msg: null });
					}
				},
				save_Thirdpartyconnection_SalesForce_config_failed: function save_Thirdpartyconnection_SalesForce_config_failed(sid, message) {
					if (self.state.sid === sid) {
						self.setState({ has_connected: null, is_reading: false, read_error_msg: 'Failed to read your Salesforce connector settings: ' + message });
					}
				}
			};
		},
		componentWillReceiveProps: function componentWillReceiveProps(props) {
			this.__loadForSid(props.selected_sid);
		},
		componentDidMount: function componentDidMount() {
			this.__loadForSid(this.props.selected_sid);
		},
		__loadForSid: function __loadForSid(sid) {
			if (sid !== this.state.sid) {
				this.setState({ sid: sid }, function () {
					radio('read_Thirdpartyconnection_SalesForce_config').broadcast(sid);
				});
			}
		},
		__onSubmit: function __onSubmit(data) {
			radio('save_Thirdpartyconnection_SalesForce_config').broadcast(this.state.sid, data);
		},
		render: function render() {
			var Displaylists = this.props.Displaylists;
	
			var sid = this.state.sid;
			var has_connected = this.state.has_connected;
			var ajax_read = this.state.read_Thirdpartyconnection_SalesForce_config;
			var ajax_save = this.state.save_Thirdpartyconnection_SalesForce_config;
	
			var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
				return spkr.sid == sid;
			}, this);
	
			return dd.div(null, LoadingWrap({
				is_loading: ajax_read.waiting || ajax_save.waiting,
				glass: true
			}, dd.h3(null, 'SalesForce connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is PER-USER. Each user on the account must individually use this configuration page.'), ErrorAlert({ message: ajax_read.error_message }), ErrorAlert({ message: ajax_save.error_message }), DaForm({
				sid: sid,
				config: ajax_read.data,
				onSubmit: this.__onSubmit
			}), has_connected ? dd.div({ className: 'alert alert-success' }, 'You are connected to Salesforce!') : null));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return props.sid + JSON.stringify(this.getInitialValues(props));
		},
		getInitialValues: function getInitialValues(props) {
			var config = props.config || {};
			return {
				salesforce_username: config.salesforce_username || '',
				salesforce_password: config.salesforce_password || '',
				salesforce_api_token: config.salesforce_api_token || ''
			};
		},
		buildFields: function buildFields() {
			return {
				salesforce_username: {
					label: 'SalesForce username',
					type: 'text',
					help_text: 'example: you@domain.com',
					tooltip: 'This is the username for your SalesForce account.'
				},
				salesforce_password: {
					label: 'SalesForce password',
					type: 'text',
					help_text: '(cASE sENSITIVE)',
					tooltip: 'Enter the password you use to access your SalesForce account. This is CASE SENSITIVE.'
				},
				salesforce_api_token: {
					label: 'API Token',
					type: 'text',
					help_text: 'example: 023eb09d953408',
					tooltip: 'Input the SalesForce API token. You can find this in SalesForce in SETTINGS -> SECURITY TOKEN.'
				}
			};
		},
		__discardChanges: esUtils.wrapPreventDefault(function () {
			this._form_reset();
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), HorizontalFields.FormButtons({ onDiscard: this.__discardChanges }));
		}
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ModalWrap = __webpack_require__(92);
	
	var _ModalWrap2 = _interopRequireDefault(_ModalWrap);
	
	var _DisconnectStripeModal = __webpack_require__(337);
	
	var _DisconnectStripeModal2 = _interopRequireDefault(_DisconnectStripeModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	var React = __webpack_require__(15);
	
	
	module.exports = dd.createClass({
	    mixins: [RadioMixin],
	    getInitialState: function getInitialState() {
	        return { sid: -1, has_stripe_connected: null, is_reading: false, read_error_msg: null, show_disconnect: false };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(props) {
	        this.__loadForSid(props.selected_sid);
	    },
	    componentDidMount: function componentDidMount() {
	        this.__loadForSid(this.props.selected_sid);
	    },
	    __loadForSid: function __loadForSid(sid) {
	        if (sid != this.state.sid) {
	            this.setState({ sid: sid, has_stripe_connected: null, is_reading: false, read_error_msg: null }, function () {
	                radio('read_Thirdpartyconnection_Stripe_config').broadcast(sid);
	            });
	        }
	    },
	    __reloadData: esUtils.wrapPreventDefault(function () {
	        this.setState({ sid: this.props.selected_sid, has_stripe_connected: null, is_reading: false, read_error_msg: null }, function () {
	            radio('read_Thirdpartyconnection_Stripe_config').broadcast(this.props.selected_sid);
	        });
	    }),
	    __toggleDisconnectModal: esUtils.wrapPreventDefault(function () {
	        this.setState({ show_disconnect: !this.state.show_disconnect });
	    }),
	    componentWillMount: function componentWillMount() {
	        var self = this;
	        self.radio = {
	            read_Thirdpartyconnection_Stripe_config: function read_Thirdpartyconnection_Stripe_config(sid) {
	                if (self.state.sid == sid) {
	                    self.setState({ has_stripe_connected: null, is_reading: true, read_error_msg: null });
	                }
	            },
	            read_Thirdpartyconnection_Stripe_config_succeeded: function read_Thirdpartyconnection_Stripe_config_succeeded(sid, has_it) {
	                if (self.state.sid == sid) {
	                    self.setState({ has_stripe_connected: !!has_it, is_reading: false, read_error_msg: null });
	                }
	            },
	            read_Thirdpartyconnection_Stripe_config_failed: function read_Thirdpartyconnection_Stripe_config_failed(sid, message) {
	                if (self.state.sid == sid) {
	                    self.setState({ has_stripe_connected: null, is_reading: false, read_error_msg: 'Failed to read your Stripe connector settings: ' + message });
	                }
	            }
	        };
	    },
	    render: function render() {
	        var Displaylists = this.props.Displaylists;
	        var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	            return spkr.sid == this.state.sid;
	        }, this);
	
	        var connect_url = '/balboa3/stripe/connectspeaker/' + this.state.sid + '?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	        // var disconnect_url = '/balboa3/stripe/disconnectspeaker/' + this.state.sid + '?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	        var modal = null;
	
	        if (this.state.show_disconnect) {
	            modal = React.createElement(_DisconnectStripeModal2.default, {
	                sid: this.state.sid,
	                reloadData: this.__reloadData,
	                onClose: this.__toggleDisconnectModal
	            });
	        }
	
	        return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, 'Stripe Payment Processing for ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ', 'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'), ErrorAlert({ message: this.state.read_error_msg }), this.state.has_stripe_connected === true ? dd.div(null, dd.div({ className: 'alert alert-success' }, 'You are connected to Stripe!'), dd.a({ onClick: this.__toggleDisconnectModal, className: 'btn btn-primary' }, 'Disconnect your Stripe account.')) : dd.div(null, dd.p({ style: { marginTop: '2em' } }, 'The button below will take you to Stripe\'s site, where you can create a FREE Stripe account (or choose an existing one) to link to your eSpeakers account. ', 'When buyers pay you through the Marketplace platform, the payments will land in your Stripe account and from there to your bank account.'), dd.p(null, 'When Stripe asks if it\'s OK for eSpeakers to access your account, and you should ', dd.b(null, 'choose ALLOW ACCESS'), '.'), dd.a({ href: connect_url, className: 'btn btn-primary' }, 'Connect to Stripe'), dd.br(), dd.br())), modal && React.createElement(_ModalWrap2.default, { body: modal }));
	    }
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	// var esUtils = require('ES/utils/esUtils');
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { sid: -1, has_tripit_connected: null, is_reading: false, read_error_msg: null };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__loadForSid(props.selected_sid);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__loadForSid(this.props.selected_sid);
	  },
	  __loadForSid: function __loadForSid(sid) {
	    if (sid != this.state.sid) {
	      this.setState({ sid: sid, has_tripit_connected: null, is_reading: false, read_error_msg: null }, function () {
	        radio('read_Thirdpartyconnection_TripIt_config').broadcast(sid);
	      });
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      read_Thirdpartyconnection_TripIt_config: function read_Thirdpartyconnection_TripIt_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({ has_tripit_connected: null, is_reading: true, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_TripIt_config_succeeded: function read_Thirdpartyconnection_TripIt_config_succeeded(sid, has_it) {
	        if (self.state.sid == sid) {
	          self.setState({ has_tripit_connected: !!has_it, is_reading: false, read_error_msg: null });
	        }
	      },
	      read_Thirdpartyconnection_TripIt_config_failed: function read_Thirdpartyconnection_TripIt_config_failed(sid, message) {
	        if (self.state.sid == sid) {
	          self.setState({ has_tripit_connected: null, is_reading: false, read_error_msg: 'Failed to read your TripIt connector settings: ' + message });
	        }
	      }
	    };
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return spkr.sid == this.state.sid;
	    }, this);
	
	    // var connect_url = '/balboa3/thirdpartyconnection/configtripit/' + this.state.sid + '/start_oauth?' + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	
	    return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, 'TripIt connector for ', dd.span({ className: 'nametag' }, AuthedUserSession.MY_USERNAME), ' + ', dd.span({ className: 'nametag' }, speaker ? speaker.name_full : '')), dd.p({ className: 'text-muted' }, 'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ', 'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'), ErrorAlert({ message: this.state.read_error_msg }), dd.div({ className: 'alert alert-warning' }, 'TripIt has officially discontinued support for their API and do not allow third parties (like us) to pull your trip data.  We are sorry you can no longer sync your trips and we are exploring new options that can bring you the same great experience you have had.')
	    // this.state.has_tripit_connected === true ? dd.div(null,
	    //   dd.div({className: 'alert alert-danger'},
	    //     'You are connected to TripIt but will lose access in the coming days.'
	    //   )
	    // ) : dd.div(null,
	    //   dd.p(null,
	    //     'The link below will take you to TripIt\'s site, where you can log in to TripIt, and choose which of your TripIt accounts you want to link to ',
	    //     '(if you have more than one TripIt account).'
	    //   ),
	    //   dd.p(null,
	    //     'TripIt will ask if it\'s OK for eSpeakers to access your trips, and you should ', dd.b(null, 'choose ALLOW ACCESS')
	    //   ),
	    //   dd.br(),
	    //   dd.br()
	    // )
	    ));
	  }
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      sid: -1,
	      has_zohocrm_connected: null,
	      is_reading: false,
	      read_error_msg: null
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__loadForSid(props.selected_sid);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__loadForSid(this.props.selected_sid);
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      read_Thirdpartyconnection_ZohoCRM_config: function read_Thirdpartyconnection_ZohoCRM_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_zohocrm_connected: null,
	            is_reading: true,
	            read_error_msg: null
	          });
	        }
	      },
	      read_Thirdpartyconnection_ZohoCRM_config_succeeded: function read_Thirdpartyconnection_ZohoCRM_config_succeeded(sid, data) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_zohocrm_connected: !_.isEmpty(data),
	            is_reading: false,
	            read_error_msg: null
	          });
	        }
	      },
	      read_Thirdpartyconnection_ZohoCRM_config_failed: function read_Thirdpartyconnection_ZohoCRM_config_failed(sid, message) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_zohocrm_connected: null,
	            is_reading: false,
	            read_error_msg: "Failed to read your ZohoCRM connector settings: " + message
	          });
	        }
	      },
	      remove_Thirdpartyconnection_ZohoCRM_config: function remove_Thirdpartyconnection_ZohoCRM_config(sid) {
	        if (self.state.sid == sid) {
	          self.setState({
	            has_zohocrm_connected: null,
	            is_reading: true,
	            read_error_msg: null
	          });
	        }
	      }
	    };
	  },
	  __loadForSid: function __loadForSid(sid) {
	    if (sid != this.state.sid) {
	      this.setState({
	        sid: sid,
	        has_zohocrm_connected: null,
	        is_reading: false,
	        read_error_msg: null
	      }, function () {
	        radio("read_Thirdpartyconnection_ZohoCRM_config").broadcast(sid);
	      });
	    }
	  },
	  __removeZohoCRMConfig: function __removeZohoCRMConfig(sid) {
	    var self = this;
	    if (sid == this.state.sid) {
	      radio("remove_Thirdpartyconnection_ZohoCRM_config").broadcast(sid, function (sid, data) {
	        self.setState({
	          has_zohocrm_connected: false,
	          is_reading: false,
	          read_error_msg: null
	        });
	      }, function (sid, data) {
	        self.setState({
	          has_zohocrm_connected: true,
	          is_reading: false,
	          read_error_msg: _.get(data, "message", "Unknown error.")
	        });
	      });
	    }
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return spkr.sid == this.state.sid;
	    }, this);
	
	    var connect_url = "/balboa3/thirdpartyconnection/configzohocrm/" + this.state.sid + "/start_oauth?" + esUtils.phpCompatibleParams(AuthedUserSession.balboa);
	
	    return dd.div(null, LoadingWrap({ is_loading: this.state.is_reading, glass: true }, dd.h3(null, "ZohoCRM connector for ", dd.span({ className: "nametag" }, speaker ? speaker.name_full : "...")), dd.p({ className: "text-muted" }, "NOTE: The Zoho CRM account you set here is SHARED with every user on this speaker account. Other EventCX users will have access to the Zoho CRM contacts. ", "You are changing it for all the users on this eSpeakers account."), ErrorAlert({ message: this.state.read_error_msg }), this.state.has_zohocrm_connected === true ? dd.div(null, dd.div({ className: "alert alert-success" }, "You are connected to ZohoCRM!"), dd.p({}, dd.a({ href: connect_url }, "Click here to CHANGE the ZohoCRM account to which you are connected.")), dd.p({}, dd.a({
	      onClick: this.__removeZohoCRMConfig.bind(this, this.state.sid)
	    }, "Click here to DISCONNECT your ZohoCRM account."))) : dd.div(null, dd.p(null, "The link below will take you to Zoho's site, where you can sign in with your ZohoCRM credentials."), dd.p(null, "Zoho will ask if it's OK for eSpeakers to access your contacts, and you should ", dd.b(null, "choose ALLOW ACCESS.")), dd.a({ href: connect_url, className: "btn btn-primary" }, "Connect to your ZohoCRM account"), dd.br(), dd.br())));
	  }
	});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFields = __webpack_require__(23);
	var AuthedUserSession = __webpack_require__(4);
	
	var SubscribeForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props.ical_feed ? props.ical_feed.calid : -1;
	    },
	    getInitialValues: function getInitialValues(props) {
	        return {
	            url: props.ical_feed ? props.ical_feed.url : '',
	            tzoffset: (props.ical_feed ? props.ical_feed.tzoffset : 0) + '_THIS_MAY_LOOK_LIKE_A_NUMBER_BUT_ITs_NOT' //look at the way this fields options are made
	        };
	    },
	    buildFields: function buildFields() {
	        return {
	            url: {
	                label: 'iCalendar URL',
	                type: 'text',
	                validate: FormUtils.v.optional
	            },
	            tzoffset: {
	                label: 'Adjust time',
	                type: 'select',
	                dont_sort_options: true,
	                options: _.object(_.map(_.range(-12, 12), function (hours) {
	                    return [hours + '_THIS_MAY_LOOK_LIKE_A_NUMBER_BUT_ITs_NOT', //hack so _.fromPairs doesn't sort the keys
	                    hours === 0 ? 'no change' : (hours > 0 ? '+' : '') + hours + ' hours'];
	                }))
	            }
	        };
	    },
	    __discardChanges: esUtils.wrapPreventDefault(function () {
	        this._form_reset();
	    }),
	    render: function render() {
	        var fields = this.buildFields();
	        var errors = this.state.errors || {};
	        var changes_made = this._form_areChangesMade();
	
	        return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
	            fields: fields,
	            errors: errors,
	            buildInput: this._form_buildInput
	        }), SlideOpenDown({ open: changes_made }, HorizontalFields.FormButtons({ onDiscard: this.__discardChanges })));
	    }
	});
	
	var PublishForm = dd.createClass({
	    mixins: [FormMixin],
	    getInitialValues: function getInitialValues(props) {
	        return {
	            confirmed: true
	        };
	    },
	    buildFields: function buildFields() {
	        var Displaylists = this.props.Displaylists;
	
	        var schema = {
	            confirmed: { label: 'include confirmed events', read_only: true },
	            holds: { label: 'include holds' },
	            leads: { label: 'include leads' },
	            conference: { label: 'include conference calls' },
	            travel: { label: 'include flight & ground travel' },
	            personal: { label: 'include personal dates' },
	            timezone: {
	                label: 'Your Time Zone',
	                type: 'select',
	                placeholder: '-- select home time zone --',
	                options: _.object(_.map(Displaylists && Displaylists.universal && Displaylists.universal.timezones, function (timezone, k) {
	                    return [k, _.get(timezone, ["label"], k)];
	                })),
	                validate: FormUtils.optional
	            },
	            travel_filter: {
	                label: 'Travel Filter',
	                type: 'text',
	                help_text: 'Only flight and ground items that include this text in the description will be exported.',
	                validate: FormUtils.optional
	            }
	        };
	        return _.mapValues(schema, function (field) {
	            if (!field.type) {
	                field.type = 'checkbox';
	            }
	            return field;
	        });
	    },
	    render: function render() {
	        var fields = this.buildFields();
	        var errors = this.state.errors || {};
	
	        return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
	            fields: fields,
	            errors: errors,
	            buildInput: this._form_buildInput
	        }), HorizontalFields.FormButtons({ submit_btn_text: 'Show my URL' }));
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [RadioMixin],
	    getInitialState: function getInitialState() {
	        return {
	            ical_published_url: null,
	            subscribe_saving: false,
	            subscribe_error_msg: null,
	            generate_error_msg: null,
	            generate_saving: false
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        var self = this;
	        self.radio = {
	            save_iCalFeed: function save_iCalFeed(sid, ical_feed) {
	                if (self.props.selected_sid === sid) {
	                    self.setState({ subscribe_saving: true, subscribe_error_msg: null });
	                }
	            },
	            save_iCalFeed_succeeded: function save_iCalFeed_succeeded(sid) {
	                if (self.props.selected_sid === sid) {
	                    self.setState({ subscribe_saving: false, subscribe_error_msg: null });
	                }
	            },
	            save_iCalFeed_failed: function save_iCalFeed_failed(sid, message) {
	                if (self.props.selected_sid === sid) {
	                    self.setState({ subscribe_saving: false, subscribe_error_msg: 'Failed to save: ' + message });
	                }
	            },
	            read_iCalExportURL_succeeded: function read_iCalExportURL_succeeded(sid, export_url) {
	                if (self.props.selected_sid === sid) {
	                    self.setState({ generate_saving: false, generate_error_msg: null, ical_published_url: export_url });
	                }
	            },
	            read_iCalExportURL_failed: function read_iCalExportURL_failed(sid, message) {
	                if (self.props.selected_sid === sid) {
	                    self.setState({ generate_saving: false, generate_error_msg: message ? message : 'Failed to generate export URL.' });
	                }
	            }
	        };
	    },
	
	    __onSubscribeSubmit: function __onSubscribeSubmit(data) {
	        var selected_sid = this.props.selected_sid;
	        var ical_feed = this.__getSelectedSIDsiCal();
	        if (!ical_feed) {
	            ical_feed = { calid: -1 };
	        }
	        ical_feed.url = data.url;
	        ical_feed.tzoffset = _.parseInt(data.tzoffset); //yep needs to be parsed int - look at the way this fields options are made
	        radio('save_iCalFeed').broadcast(selected_sid, ical_feed);
	    },
	    __onPublishSubmit: function __onPublishSubmit(data) {
	        var selected_sid = this.props.selected_sid;
	
	
	        var params = {
	            sid: selected_sid,
	            loginid: _.get(AuthedUserSession, "MY_USERNAME"),
	            holds: !!data.holds,
	            leads: !!data.leads,
	            calls: !!data.conference,
	            flights: !!data.travel,
	            personal: !!data.personal,
	            tz: data.timezone,
	            travel_filter: data.travel_filter
	        };
	
	        radio('read_iCalExportURL').broadcast(selected_sid, params);
	    },
	
	    __getSelectedSIDsiCal: function __getSelectedSIDsiCal() {
	        var selected_sid = this.props.selected_sid;
	        var Displaylists = this.props.Displaylists;
	        var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
	            return spkr.sid == selected_sid;
	        });
	        return speaker && speaker.ical_feed;
	    },
	
	    __selectTextInput: function __selectTextInput(e) {
	        e.target.setSelectionRange(0, e.target.value.length);
	    },
	
	    __resetGenerateForm: function __resetGenerateForm() {
	        this.setState({ ical_published_url: null });
	    },
	
	    render: function render() {
	        var Displaylists = this.props.Displaylists;
	        var ical_feed = this.__getSelectedSIDsiCal();
	        var ical_published_url = _.get(this.state, 'ical_published_url');
	        var generate_error_msg = _.get(this.state, 'generate_error_msg');
	
	        return dd.div({ className: 'row' }, dd.div({ className: 'col-sm-5' }, dd.h3(null, 'Export speaking calendar'), dd.p({ className: 'text-muted' }, 'Send your speaking calendar from here to all of your other calendars with an iCalendar feed.'), ical_published_url ? dd.div(null, dd.p({ style: { marginTop: "2em" } }, 'Copy this url and paste it into your application:'), dd.textarea({ style: { fontFamily: 'monospace', height: "10em" }, type: 'text', value: ical_published_url, className: 'form-control', onFocus: this.__selectTextInput, readOnly: 'readonly' }), dd.a({ style: { cursor: "pointer" }, className: "pull-right", onClick: this.__resetGenerateForm }, "(change settings)")) : dd.div(null, generate_error_msg ? dd.div({ className: "alert alert-danger" }, generate_error_msg) : null, PublishForm({ onSubmit: this.__onPublishSubmit, Displaylists: Displaylists })), dd.a({ href: "https://espeakers.com/wiki/Export_your_events_to_other_calendar_programs", target: "_blank", style: { marginTop: "2em", display: "block" } }, dd.i({ className: "fa fa-question-circle", style: { marginTop: "2em", marginRight: "0.5em" } }), "How do I use this iCalendar URL?")), dd.div({ className: 'col-sm-5 col-sm-offset-2' }, LoadingWrap({ is_loading: this.state.subscribe_saving, glass: true }, dd.h3(null, 'Import daily calendar'), dd.p({ className: 'text-muted' }, 'Display an iCalendar feed as "Daily" items on your eSpeakers calendar.'), dd.p({ className: 'text-muted' }, dd.i({ className: "fa fa-info-circle", style: { marginRight: "0.5em" } }), "Prepare for longer EventCX start times when loading a large calendar."), dd.p({ className: 'text-muted' }, dd.i({ className: "fa fa-info-circle", style: { marginRight: "0.5em" } }), "Daily calendars are refreshed at most every 24 hours."), ErrorAlert({ message: this.state.subscribe_error_msg }), SubscribeForm({ ical_feed: ical_feed, onSubmit: this.__onSubscribeSubmit })), dd.a({ href: "https://espeakers.com/wiki/Import_Google_Calendar_into_EventCX", target: "_blank", style: { marginTop: "2em", display: "block" } }, dd.i({ className: "fa fa-question-circle", style: { marginRight: "0.5em" } }), "How do I import daily items from a Google calendar?")));
	    }
	});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var TabSet = __webpack_require__(68);
	var esUtils = __webpack_require__(2);
	var LoadingWrap = __webpack_require__(8);
	var SpeakerForm = __webpack_require__(87);
	var AuthedUserSession = __webpack_require__(4);
	
	var tabs = {
	  ical: {
	    name: "iCal Feed",
	    render: __webpack_require__(232)
	  },
	  hl: {
	    name: "HighLevel",
	    render: __webpack_require__(222)
	  },
	  awardwallet: {
	    name: "AwardWallet",
	    render: __webpack_require__(220)
	  },
	  tripit: {
	    name: "TripIt (defunct)",
	    render: __webpack_require__(230)
	  },
	  google_contacts: {
	    name: "Google Contacts",
	    render: __webpack_require__(221)
	  },
	  // google_tasks: {
	  //   name: "Google Tasks",
	  //   render: require("./GoogleTasks.js"),
	  // },
	  salesforce: {
	    name: "SalesForce",
	    render: __webpack_require__(228)
	  },
	  infusionsoft: {
	    name: "Keap",
	    render: __webpack_require__(224)
	  },
	  insightly: {
	    name: "Insightly",
	    render: __webpack_require__(225)
	  },
	  karmacrm: {
	    name: "karmaCRM",
	    render: __webpack_require__(226)
	  },
	  hubspot: {
	    name: "HubSpot",
	    render: __webpack_require__(223)
	  },
	  zohocrm: {
	    name: "SpeakerFlow (Zoho)",
	    render: __webpack_require__(231)
	  }
	};
	
	if (!AuthedUserSession.is_privatelabel) {
	  tabs.quickbooks = {
	    name: "QuickBooks",
	    render: __webpack_require__(227)
	  };
	  tabs.apikey = {
	    name: "API key",
	    render: __webpack_require__(219)
	  };
	  tabs.stripe = {
	    name: "Stripe",
	    render: __webpack_require__(229)
	  };
	}
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    var url_args = this.props.url_args;
	    // console.log("url_args", url_args);
	    return {
	      selected_sid: -1,
	      selected_tab: url_args.length > 4 ? url_args[4] : ""
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__handleDefaultSIDfromProps(props);
	  },
	  componentDidMount: function componentDidMount() {
	    this.__handleDefaultSIDfromProps(this.props);
	  },
	  __handleDefaultSIDfromProps: function __handleDefaultSIDfromProps(props) {
	    var sid = props.sid,
	        Displaylists = props.Displaylists;
	
	    var my_sids = _.uniq(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	    var cur_sid = this.state.selected_sid;
	    if (cur_sid < 0 && my_sids.length > 0) {
	      sid = AuthedUserSession.getLastSelectedSID();
	      this.__onSidChanged(sid > 0 ? sid : _.first(my_sids));
	    }
	  },
	  __onSidChanged: function __onSidChanged(sid) {
	    this.setState({ selected_sid: _.parseInt(sid) });
	  },
	  __setTab: function __setTab(tab) {
	    return _.bind(esUtils.wrapPreventDefault(function () {
	      this.setState({ selected_tab: tab });
	    }), this);
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var _state = this.state,
	        selected_sid = _state.selected_sid,
	        selected_tab = _state.selected_tab;
	
	    var my_sids = _.uniq(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	
	    return LoadingWrap({ is_loading: _.isEmpty(Displaylists), glass: true }, dd.div({ className: "Connect" }, dd.h2({ style: { marginTop: 0 } }, "Connect eSpeakers to your other cloud services"), my_sids.length > 1 ? SpeakerForm({
	      sid: selected_sid,
	      Displaylists: Displaylists,
	      onSidChanged: this.__onSidChanged
	    }) : null, dd.div({ className: "clearfix" }), TabSet({
	      tabs: _.mapValues(tabs, function (tab, name) {
	        tab.onClick = this.__setTab(name);
	        return tab;
	      }, this),
	      selected_tab: selected_tab,
	      render_props: {
	        selected_sid: selected_sid,
	        Displaylists: Displaylists
	      },
	      lefty: true,
	      tabs_width: 160
	    })));
	  }
	});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var TabSet = __webpack_require__(68);
	var esUtils = __webpack_require__(2);
	var Connect = __webpack_require__(233);
	var AuthedUserSession = __webpack_require__(4);
	var AdvancedSettings = __webpack_require__(218);
	var Preferences = __webpack_require__(235);
	var ActionLists = __webpack_require__(217);
	var AccountingLock = AuthedUserSession.is_st_family ? __webpack_require__(208) : null;
	var ClientPortal = __webpack_require__(212);
	var StandardLayout = __webpack_require__(67);
	var Constants = __webpack_require__(13);
	
	if (_.size(AuthedUserSession.doIHaveAccess.admin.getSIDs()) === 0 && AuthedUserSession.st_usertype !== Constants.ST_USERTYPE_SUPER_ADMIN) {
	    AccountingLock = null; //only show this tab if they have admin
	}
	
	if (!_.isEmpty(AuthedUserSession.doIHaveAccess.limited_speaker.getSIDs()) || _.isEmpty(AuthedUserSession.doIHaveAccess.admin.getSIDs())) {
	    ActionLists = null;
	}
	
	//NOTE
	//NOTE these keys on this are use in urls so don't casually RENAME them
	//NOTE
	var tabs = {
	    preferences: {
	        name: "Preferences",
	        render: Preferences
	    },
	    action_list: {
	        name: "Action Lists",
	        render: ActionLists
	    },
	    connect: {
	        name: "Connect",
	        render: Connect
	    },
	    accounting_lock: {
	        name: "Accounting Lock",
	        render: AccountingLock
	    },
	    client_portal: {
	        name: "Client Portal",
	        render: ClientPortal
	    },
	    advanced: {
	        name: "Advanced",
	        render: AdvancedSettings
	    }
	};
	
	if (AuthedUserSession.is_st) {
	    delete tabs.action_list;
	    delete tabs.client_portal;
	}
	
	_.each(tabs, function (tab, id) {
	    if (!tab.render) {
	        delete tabs[id];
	    }
	});
	
	module.exports = dd.createClass({
	    render: function render() {
	        var _props = this.props,
	            url_args = _props.url_args,
	            Displaylists = _props.Displaylists; //url format: #/account_settings/:tab/:redir/:sid
	
	        var url_tab = null;
	        var url_redir = null;
	        var url_sid = -1;
	
	        if (url_args[0] === "account_settings" && _.has(tabs, url_args[1])) {
	            url_tab = url_args[1];
	
	            url_redir = _.isString(url_args[2]) ? esUtils.decode_redir(url_args[2]) || null : null;
	
	            url_sid = _.parseInt(url_args[3]);
	            url_sid = _.isNaN(url_sid) || url_sid < 1 ? -1 : url_sid;
	        }
	
	        var back_url = _.first(_.reject(this.props.hash_history, function (hash) {
	            return (/^\/account_settings/.test(hash)
	            );
	        })) || "/";
	
	        return StandardLayout({ Displaylists: Displaylists }, dd.div({ className: "container AccountSettings" }, dd.div({ className: "pull-right", style: { marginTop: 22 } }, dd.a({ href: "#" + back_url, className: "btn btn-default" }, dd.i({ className: "fa fa-arrow-left" }), " Back to events")), dd.h1(null, "Account Settings"), TabSet({
	            tabs: _.mapValues(tabs, function (tab, id) {
	                tab.url = "#/account_settings/" + id;
	                if (url_redir) {
	                    tab.url += "/" + url_args[2]; //append the un-encoded one
	                    if (url_sid > 0) {
	                        tab.url += "/" + url_sid;
	                    }
	                }
	                return tab;
	            }),
	            render_props: {
	                redir: url_redir,
	                sid: url_sid,
	                url_args: url_args,
	                Displaylists: Displaylists
	            },
	            selected_tab: url_tab
	        })));
	    }
	});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var SlideOpenDown = __webpack_require__(27);
	var VerticalFields = __webpack_require__(86);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { saving: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      save_UserPreferences: function save_UserPreferences() {
	        self.setState({ saving: true, error_msg: null });
	      },
	      save_UserPreferences_succeeded: function save_UserPreferences_succeeded() {
	        self.setState({ saving: false, error_msg: null });
	      },
	      save_UserPreferences_failed: function save_UserPreferences_failed(message) {
	        self.setState({ saving: false, error_msg: 'Failed to save your preferences: ' + message });
	      }
	    };
	  },
	  __onSubmit: function __onSubmit(data) {
	    radio('save_UserPreferences').broadcast(data);
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    return LoadingWrap({ is_loading: _.isEmpty(Displaylists) || this.state.saving, glass: true }, dd.div({ className: 'Preferences' }, dd.h2({ style: { marginTop: 0 } }, 'Preferences'), dd.p({ style: { marginBottom: 40 } }, 'These preferences only affect your login: ' + AuthedUserSession.MY_USERNAME), ErrorAlert({ message: this.state.error_msg }), DaForm({ Displaylists: Displaylists, onSubmit: this.__onSubmit })));
	  }
	});
	
	var DaForm = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	    return AuthedUserSession.MY_USERNAME + JSON.stringify(_.get(props, "Displaylists.user.myevents_preferences"));
	  },
	  getInitialValues: function getInitialValues(props) {
	    return _.get(props, "Displaylists.user.myevents_preferences");
	  },
	  buildFields: function buildFields() {
	    //NOTE
	    //NOTE don't willy-nilly change these keys or option keys. These are what are saved in the db and used to reference their preferences.
	    //NOTE
	    //NOTE adding a new pref here: also add to AuthenticateController::$DEFAULT_MYEVENTS_USER_PREFERENCES
	    //NOTE
	    var r = {
	      notify_coworkers_on_schedule_changes: {
	        label: 'Notify co-workers on schedule changes',
	        type: 'checkbox'
	      },
	      ask_for_reason_when_canceling_or_releasing: {
	        label: 'Ask for a reason when canceling/releasing',
	        type: 'checkbox'
	      },
	      hide_personal_days_on_dashboard_lists: {
	        label: 'Hide personal/blackout days on dashboard lists',
	        type: 'checkbox'
	      },
	      open_crm_in_same_window: {
	        label: 'Open CRM in same window instead of opening a new one',
	        type: 'checkbox'
	      },
	      show_other_companies_by_default: {
	        label: 'Check the "show other companies" checkbox on startup',
	        type: 'checkbox'
	      },
	      show_parent_child_ui: {
	        label: 'ADVANCED: enable parent-child event relationships',
	        type: 'checkbox'
	      },
	      hide_closed_events_in_results: {
	        label: 'Default to hiding Closed events in search results',
	        type: 'checkbox'
	      },
	      sort_results: {
	        label: 'Order dashboard lists and search results',
	        type: 'select',
	        options: {
	          earliest_at_bottom: 'Earliest date at bottom',
	          earliest_at_top: 'Earliest date at top'
	        }
	      },
	      library_placeholder_codes_if_field_is_empty: {
	        label: 'Document Library placeholder codes -- If the replacement field is empty',
	        type: 'select', //'radio',
	        options: {
	          leave_placeholder: 'leave the placeholder in the result document',
	          leave_empty: 'leave the empty space'
	        }
	      }
	    };
	
	    if (AuthedUserSession.is_privatelabel) {
	      delete r["show_parent_child_ui"];
	    } else {
	      delete r["show_other_companies_by_default"];
	      delete r["hide_closed_events_in_results"];
	    }
	
	    return r;
	  },
	  __discardChanges: esUtils.wrapPreventDefault(function () {
	    this._form_reset();
	  }),
	  render: function render() {
	    var fields = this.buildFields();
	    var errors = this.state.errors || {};
	    var changes_made = this._form_areChangesMade();
	
	    return dd.form({ className: '', onSubmit: this._form_onSubmit }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-2' }), dd.div({ className: 'col-sm-8' }, VerticalFields({
	      fields: fields,
	      errors: errors,
	      buildInput: this._form_buildInput
	    }), SlideOpenDown({ open: changes_made }, VerticalFields.FormButtons({ onDiscard: this.__discardChanges }))), dd.div({ className: 'col-sm-2' })));
	  }
	});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StandardLayout = __webpack_require__(67);
	
	var _StandardLayout2 = _interopRequireDefault(_StandardLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(393);
	
	exports.default = _react2.default.createFactory(_react2.default.createClass({
	    iframe: function iframe(sid, Displaylists) {
	
	        if (_lodash2.default.isEmpty(sid)) return null;
	
	        var crm_sso_link = _lodash2.default.find(_lodash2.default.get(Displaylists, "perspeaker"), function (spkr) {
	            return spkr.sid == sid;
	        });
	        crm_sso_link = _lodash2.default.get(_lodash2.default.first(_lodash2.default.get(crm_sso_link, "crm_sso", [])), "sso_url");
	
	        if (_lodash2.default.isEmpty(crm_sso_link)) return null;
	
	        return {
	            __html: "<iframe src=\"" + crm_sso_link + "\" width=\"100%\" height=\"100%\" data-sid=\"" + sid + "\"></iframe>"
	        };
	    },
	
	    render: function render() {
	        var _props = this.props,
	            Displaylists = _props.Displaylists,
	            url_args = _props.url_args;
	
	        var sid = _lodash2.default.last(url_args);
	
	        return (0, _StandardLayout2.default)({ Displaylists: Displaylists }, _react2.default.createElement(
	            "div",
	            { style: { height: "100%", width: "100%" } },
	            _react2.default.createElement(
	                "div",
	                { style: { height: "3em" } },
	                _react2.default.createElement(
	                    "a",
	                    { style: { paddingLeft: "1em", paddingTop: "1em", display: "block" }, href: "#/events" },
	                    "\xAB back to events"
	                )
	            ),
	            _react2.default.createElement("div", { dangerouslySetInnerHTML: this.iframe(sid, Displaylists), style: { height: "100%", width: "100%", border: "none" } })
	        ));
	    }
	}));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(394); /*global FileList, File */
	
	
	var component = _react2.default.createFactory(_react2.default.createClass({
	    displayName: "component",
	
	    __onChange: function __onChange(e) {
	        var files = e.target.files;
	        if (files.length !== 1) {
	            this.props.onChange(void 0);
	            return;
	        }
	        var file = files[0];
	
	        this.props.onChange(file);
	    },
	    render: function render() {
	        var field = this.props.field;
	        var value = this.props.value;
	
	        if (typeof FileList === "undefined") {
	            return _react2.default.createElement(
	                "p",
	                { className: "form-control-static text-danger" },
	                "Your browser is outdated and will not work with this file upload."
	            );
	        }
	
	        var filename = value && value.name ? value.name : "";
	
	        if (field.read_only) {
	            return _react2.default.createElement(
	                "p",
	                { className: "form-control-static" },
	                filename
	            );
	        }
	
	        return _react2.default.createElement(
	            "div",
	            { className: "DropFileInput" },
	            _react2.default.createElement(
	                "div",
	                { className: "DropFileInput-wrap" },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement("i", {
	                        className: "fa fa-cloud-upload text-muted",
	                        style: { fontSize: "2em" }
	                    }),
	                    " ",
	                    filename
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        null,
	                        "Browse"
	                    ),
	                    " or drag and drop a PDF here to upload."
	                )
	            ),
	            _react2.default.createElement("input", {
	                type: "file",
	                className: "DropFileInput-file-input",
	                name: field.name,
	                onChange: this.__onChange
	            })
	        );
	    }
	}));
	
	exports.default = {
	    component: component,
	    validate: function validate(value) {
	        return value instanceof File ? true : "You must select a file to upload";
	    }
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(51);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _dd = __webpack_require__(3);
	
	var _dd2 = _interopRequireDefault(_dd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(395);
	
	var component = _dd2.default.createClass({
	  __onChange: function __onChange(e) {
	    this.props.onChange(e.target.value);
	  },
	  render: function render() {
	    var field = this.props.field;
	    var value = this.props.value || "";
	
	    var score_icon = "fa-circle-thin";
	    var score_bg = "#F2C411";
	    if (parseFloat(value) >= 4.2) {
	      score_icon = "fa-circle-thin";
	      score_bg = "#57BD8B";
	    } else if (parseFloat(value) > 0 && parseFloat(value) < 3.8) {
	      score_icon = "fa-circle-thin";
	      score_bg = "#FF7878";
	    } else if (parseFloat(value) === 0 || _lodash2.default.isNaN(parseFloat(value))) {
	      score_bg = "#E8E8E8";
	    }
	
	    return _dd2.default.div({ className: "input-group evaluation-input" }, _dd2.default.input({
	      type: "text",
	      name: field.name,
	      value: value || "",
	      disabled: field.disabled ? "disabled" : null,
	      className: "form-control",
	      onChange: this.__onChange,
	      onBlur: this.__onChange
	    }), _dd2.default.div({ className: "input-group-addon", style: { backgroundColor: score_bg } }, _dd2.default.i({ className: "fa " + score_icon }, "")));
	  }
	});
	
	exports.default = {
	  component: component,
	  validate: function validate(v) {
	    return true;
	  }
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _dd = __webpack_require__(3);
	
	var _dd2 = _interopRequireDefault(_dd);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(396);
	
	var component = _dd2.default.createClass({
		__onChange: function __onChange(e) {
			this.props.onChange(e.target.value);
		},
		render: function render() {
			var field = this.props.field;
			var value = this.props.value;
	
			return _dd2.default.div({ className: "InitialsInput" }, _dd2.default.div({ className: "InitialsInput-group" }, _dd2.default.div({ className: "input", style: { minWidth: 200 } }, field.name_full), "Name"), _dd2.default.div({ className: "InitialsInput-group" }, _dd2.default.div(null, _dd2.default.input({
				type: "text",
				name: "initials",
				value: value || "",
				disabled: field.disabled ? "disabled" : null,
				className: "form-control",
				onChange: this.__onChange
			})), _dd2.default.span({ className: "help-block" }, "Initials")), _dd2.default.div({ className: "InitialsInput-group" }, _dd2.default.div({ className: "input" }, _esUtils2.default.format_date(new Date(), "m/d/yyyy")), "Date"), _dd2.default.div({ className: "clearfix" }));
		}
	});
	
	exports.default = {
		component: component,
		validate: function validate(v) {
			return _esUtils2.default.isBlank(v) ? "Please enter your initials to sign this agreement" : true;
		}
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(51);
	var dd = __webpack_require__(7);
	
	var placeholder_value = '__some$random$uuid__';
	
	var component = dd.createClass({
	  __onChange: function __onChange(e) {
	    var field = this.props.field;
	    var new_value = e.target.value;
	    this.props.onChange(_.has(_.keyBy(field.options, "value"), new_value) ? new_value : null);
	  },
	  render: function render() {
	    var field = this.props.field;
	    var options = _.keyBy(field.options, "value");
	    var value = _.has(options, this.props.value) ? this.props.value : field.placeholder ? placeholder_value : '';
	
	    if (field.read_only) {
	      return dd.p({ className: 'form-control-static' }, _.has(options, value) ? _.get(options, [value, "label"]) : value === placeholder_value ? null : value);
	    }
	
	    return dd.select({
	      name: field.name,
	      value: value,
	      onChange: this.__onChange,
	      disabled: field.disabled ? 'disabled' : null,
	      className: 'form-control' + (field.disabled ? ' disabled' : '')
	    }, _.has(field, ["placeholder"]) && dd.option({ value: placeholder_value }, field.placeholder ? field.placeholder : ''), _.map(field.optgroups, function (optgroup, i) {
	      return dd.optgroup({ key: i, label: optgroup }, _.map(_.filter(field.options, function (option) {
	        return _.get(option, ["optgroup"]) === optgroup;
	      }), function (option) {
	        return dd.option({ value: _.get(option, ["value"]), key: _.get(option, ["value"]) }, _.get(option, ["label"]));
	      }));
	    }), _.map(_.filter(field.options, function (option) {
	      return !_.has(option, ["optgroup"]);
	    }), function (option) {
	      return dd.option({ value: _.get(option, ["value"]), key: _.get(option, ["value"]) }, _.get(option, ["label"]));
	    }));
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function validate(value, field) {
	    if (!_.has(field.options, value)) {
	      return 'Please make a selection';
	    }
	    return true;
	  }
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (props) {
		var name = props.name;
		var value = props.value;
		var checked = props.checked;
		var onChange = props.onChange;
		return React.createElement(
			"div",
			{ className: "radio" },
			React.createElement(
				"label",
				null,
				React.createElement("input", { type: "radio", name: name, value: value, checked: checked, onChange: onChange }),
				props.children
			)
		);
	};
	
	var React = __webpack_require__(15);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Radio = __webpack_require__(241);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var React = __webpack_require__(15);
	
	var component = React.createFactory(React.createClass({
		displayName: "component",
	
		__onChange: function __onChange(e) {
			var field = this.props.field;
			var new_value = e.target.value;
			this.props.onChange(_.has(field.options, new_value) ? new_value : null);
		},
		render: function render() {
			var field = this.props.field;
			var value = this.props.value;
	
			if (field.read_only) {
				return React.createElement(
					"p",
					{ className: "form-control-static" },
					_.has(field.options, value) ? field.options[value] : value
				);
			}
	
			var radios = _.map(field.options, _.bind(function (label, v) {
				return React.createElement(
					_Radio2.default,
					{
						key: v,
						name: field.name,
						value: v,
						checked: value === v,
						onChange: this.__onChange
					},
					label
				);
			}, this));
	
			return React.createElement(
				"div",
				null,
				radios
			);
		}
	}));
	
	exports.default = {
		component: component
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Electron = __webpack_require__(383);
	var ImageURLs = __webpack_require__(93);
	var HoverMixin = __webpack_require__(49);
	var RadioMixin = __webpack_require__(20);
	var RadioServiceMixin = __webpack_require__(14);
	var AuthedUserSession = __webpack_require__(4);
	var Constants = __webpack_require__(13);
	
	var DropDownMenuItem = dd.createClass({
	  mixins: [HoverMixin],
	  getInitialState: function getInitialState() {
	    return { show_dd: false };
	  },
	
	  __toggleDropDown: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_dd: !this.state.show_dd });
	    //TODO: hide any other open dropdown when a new one is opened
	  }),
	  hoverable_onUserLeftHoverable: function hoverable_onUserLeftHoverable() {
	    if (this.state.show_dd) {
	      //only setState if needed
	      this.setState({ show_dd: false });
	    }
	  },
	  __itemClick: function __itemClick(action) {
	    var self = this;
	    return function (e) {
	      self.setState({ show_dd: !self.state.show_dd });
	      if (_.isFunction(action)) {
	        action(e);
	      }
	    };
	  },
	
	  __disableClick: esUtils.wrapPreventDefault(_.noop),
	  render: function render() {
	    return dd.li({
	      className: "dropdown" + (this.state.show_dd ? " open" : ""),
	      onMouseEnter: this.hoverable_onMouseEnter,
	      onMouseLeave: this.hoverable_onMouseLeave
	    }, dd.a({
	      href: "#",
	      className: "dropdown-toggle",
	      onClick: this.__toggleDropDown
	    }, this.props.name, " ", dd.b({ className: "caret" })), dd.ul({ className: "dropdown-menu", role: "menu" }, _.map(_.filter(this.props.items), function (item, i) {
	      if (item.divider) {
	        return dd.li({ key: i, className: "divider" });
	      }
	      return dd.li({
	        key: i,
	        role: "presentation",
	        className: item.no_click ? "disabled" : null
	      }, dd.a({
	        role: "menuitem",
	        href: item.href || "#",
	        onClick: item.no_click ? this.__disableClick : this.__itemClick(item.onClick)
	      }, item.name));
	    }, this)));
	  }
	});
	
	var Menu = dd.createClass({
	  mixins: [RadioServiceMixin],
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  __showEventSearch: esUtils.wrapPreventDefault(function () {
	    this.__toMainViewThenDoThis(function () {
	      radio("EventSearchAside_open").broadcast();
	    });
	  }),
	  __genCSPReport: function __genCSPReport(sid) {
	    return esUtils.wrapPreventDefault(function () {
	      window.open("/csp_application?speaker_id=" + sid + "&" + esUtils.phpCompatibleParams(AuthedUserSession.balboa), "CSPApplication", "height=600,width=1024").focus();
	    });
	  },
	
	  __showEmpireCalendar: esUtils.wrapPreventDefault(function () {
	    window.open("/admin/token-callback/" + esUtils.phpCompatibleParams(AuthedUserSession.balboa) + "?redir=/empire-calendar", "esAdmin", "height=600,width=1024").focus();
	  }),
	  __showReports: esUtils.wrapPreventDefault(function () {
	    window.open("/reports/menu.phtml?" + esUtils.phpCompatibleParams(AuthedUserSession.balboa), "esReportWindow", "height=600,width=1024").focus();
	  }),
	  __showCRM: function __showCRM(sid, url, crmkind) {
	    var self = this;
	    var CRMWindowName = _.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind.toUpperCase(), "browser_window_name"], "genericcrm");
	
	    return esUtils.wrapPreventDefault(function () {
	      if (_.get(self.props, "Displaylists.user.myevents_preferences.open_crm_in_same_window", false)) {
	        radio("Hashbang_set").broadcast("/crm/" + sid);
	      } else {
	        window.open(url, CRMWindowName, "height=700,width=1200").focus();
	      }
	    });
	  },
	
	  __showMonthCalendar: esUtils.wrapPreventDefault(function () {
	    this.__toMainViewThenDoThis(function () {
	      radio("Show_Calendar").broadcast("month");
	    });
	  }),
	  __showYearCalendar: esUtils.wrapPreventDefault(function () {
	    this.__toMainViewThenDoThis(function () {
	      radio("Show_Calendar").broadcast("year");
	    });
	  }),
	  __showDashboard: esUtils.wrapPreventDefault(function () {
	    this.__toMainViewThenDoThis(function () {
	      radio("Show_Calendar").broadcast("Dashboard");
	    });
	  }),
	  __toMainViewThenDoThis: function __toMainViewThenDoThis(do_this) {
	    radio("Hashbang_set").broadcast("/");
	    setTimeout(do_this, 250);
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    var pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");
	    var trav_or_read_only = AuthedUserSession.doIHaveAccess.read_or_travel.all(AuthedUserSession.all_sids_i_have_permissions_for);
	    var dont_marketplace = trav_or_read_only || AuthedUserSession.is_privatelabel;
	    var csp_links = [];
	    var crm_sso_links = [];
	    var canOnlyCreatePersonalEvent = AuthedUserSession.is_st_family && !AuthedUserSession.doIHaveAccess.full.any(AuthedUserSession.all_sids_i_have_permissions_for); //as for speaker users on a privatelabel who can only create blackout events
	
	    if (!AuthedUserSession.is_privatelabel) {
	      //CSP application
	      csp_links = _.map(_.sortBy(Displaylists && Displaylists.perspeaker, function (spkr) {
	        return _.get(spkr, "name_full", "(name unknown)").toUpperCase().trim();
	      }), function (spkr) {
	        if (!_.includes(pro_sids, spkr.sid)) {
	          return {
	            no_click: true,
	            name: "CSP Progress report for " + _.get(spkr, "name_full", "(name unknown)") + " (Pro only)"
	          };
	        }
	        return {
	          onClick: this.__genCSPReport(spkr.sid),
	          name: "CSP Progress Report for " + _.get(spkr, "name_full", "(name unknown)")
	        };
	      }, this);
	    }
	
	    //CRM single sign-on
	    crm_sso_links = _.map(_.get(Displaylists, "perspeaker", []), function (spkr) {
	      return _.map(_.get(spkr, "crm_sso", []), function (crm_sso) {
	        return {
	          onClick: this.__showCRM(_.get(spkr, "sid", 0), _.get(crm_sso, "sso_url", "#"), _.get(crm_sso, "kind")),
	          name: _.get(spkr, "name_full", "(name unknown)").trim() + " " + _.get(Constants, ["GRAB_SERVICES", _.get(crm_sso, "kind", "unknown")], _.get(crm_sso, "kind", "unknown"))
	        };
	      }, this);
	    }, this);
	    crm_sso_links = crm_sso_links.filter(function (el) {
	      return !_.isEmpty(el);
	    });
	    crm_sso_links = _.flatten(crm_sso_links);
	
	    var logout_uri = AuthedUserSession.is_st_family ? "https://us-east-1neqazvzhh.auth.us-east-1.amazoncognito.com/logout?client_id=63i9p9d7v7g41go9b3btmov09f&redirect_uri=" + encodeURIComponent("/balboa3/oauth2/invalidatetoken?redir=/myevents/signin?cognito") + "&logout_uri=" + encodeURIComponent("https://balboa-st.espeakers.com/speaker/connect/cognito/logout") : "/balboa3/oauth2/invalidatetoken?redir=/dashboard/login";
	
	    if (AuthedUserSession.is_staging && AuthedUserSession.is_st_family) {
	      logout_uri = "https://us-east-1al1ir26l3.auth.us-east-1.amazoncognito.com/logout?client_id=52kr75ahdvkdb8vq3ojoanvq0c&redirect_uri=" + encodeURIComponent("/balboa3/oauth2/invalidatetoken?redir=/myevents/signin?cognito") + "&logout_uri=" + encodeURIComponent("https://balboa-st-staging.espeakers.com/speaker/connect/cognito/logout");
	    }
	
	    return dd.div({ className: "collapse navbar-collapse" }, dd.ul({ className: "nav navbar-nav navbar-right" },
	
	    //events
	    trav_or_read_only ? null : DropDownMenuItem({
	      name: "My Events",
	      items: [{ onClick: this.__showMonthCalendar, name: "Show Events" }, { href: "#/events/new", name: "New Event" }, { onClick: this.__showDashboard, name: "Dashboard" }, { onClick: this.__showEventSearch, name: "Search Events" }, { onClick: this.__showMonthCalendar, name: "Month Calendar" }, { onClick: this.__showYearCalendar, name: "Year Calendar" }, !AuthedUserSession.is_privatelabel ? {
	        href: "#/events/import/hl",
	        name: "Import HighLevel Opportunity"
	      } : null, !AuthedUserSession.is_privatelabel ? {
	        href: "#/events/import/infusionsoft",
	        name: "Import Keap Opportunity"
	      } : null, !AuthedUserSession.is_privatelabel ? {
	        href: "#/events/import/zoho",
	        name: "Import SpeakerFlow/Zoho Opportunity"
	      } : null, _.size(csp_links) > 0 ? { divider: true } : null].concat(csp_links)
	    }),
	
	    //reports
	    trav_or_read_only || canOnlyCreatePersonalEvent ? null : dd.li({}, dd.a({ href: "#", onClick: this.__showReports }, "Reports")),
	
	    //marketplace
	    dont_marketplace ? null : dd.li({}, dd.a({ href: "#/marketplace" }, "Marketplace")),
	
	    //single speaker, with crm
	    1 === crm_sso_links.length && 1 === _.get(Displaylists, "perspeaker", []).length ? dd.li({}, dd.a({
	      href: "#",
	      onClick: _.get(crm_sso_links[0], "onClick")
	    }, "CRM")) : null,
	
	    //multiple speakers, with crm
	    _.get(Displaylists, "perspeaker", []).length > 1 && !_.isEmpty(crm_sso_links) ? DropDownMenuItem({
	      name: "CRM",
	      items: crm_sso_links
	    }) : null,
	
	    //help
	    dd.li({}, dd.a({ href: AuthedUserSession.helpurl, target: "_blank" }, "Help")),
	
	    //account
	    DropDownMenuItem({
	      name: dd.span(null, dd.i({ className: "fa fa-user" }), " ", AuthedUserSession.MY_USERNAME.toLowerCase().substring(0, 25)),
	      items: [{
	        href: AuthedUserSession.is_st_family ? "/" // ST family users (both admin and speaker)
	        : "/dashboard/token-callback?token=" + _.get(AuthedUserSession, ["balboa", "estoken"], "") + "&redir=/" + AuthedUserSession.getLastSelectedSID(), // All other users
	        name: "Account menu"
	      }, trav_or_read_only ? null : { href: "#/account_settings", name: "Settings" }, { divider: true }, Electron.is_on ? { href: Electron.logout_url, name: "Sign out" } : {
	        href: logout_uri,
	        name: "Sign out"
	      }, Electron.is_on ? {
	        onClick: esUtils.wrapPreventDefault(Electron.quit),
	        name: "Quit"
	      } : null]
	    })));
	  }
	});
	
	var UpdateAlert = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { update_available: false };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      NewAppVersionChecker_new_version_available: function NewAppVersionChecker_new_version_available() {
	        this.setState({ update_available: true });
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    radio("NewAppVersionChecker_get_status").broadcast();
	  },
	
	  __reload: esUtils.wrapPreventDefault(function () {
	    window.location.reload();
	  }),
	  render: function render() {
	    if (this.state.update_available) {
	      return dd.div({
	        className: "alert alert-info pull-left",
	        style: { margin: "6px 0 0 0", padding: "3px 10px" }
	      }, "New update available! ", dd.button({ className: "btn btn-default btn-sm", onClick: this.__reload }, "reload"));
	    }
	    return dd.div();
	  }
	});
	
	module.exports = dd.createClass({
	  __changeActiveCompany: function __changeActiveCompany() {
	    radio("change_active_company").broadcast();
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    var is_beta = AuthedUserSession.is_beta;
	    var is_st_family = AuthedUserSession.is_st_family;
	    var thestyle = { padding: "11px 11px 11px " + (is_beta ? "40px" : "11px") };
	    if (AuthedUserSession.is_privatelabel) {
	      thestyle.cursor = "pointer";
	    }
	    return dd.nav({
	      className: "HeadNavbar navbar navbar-default",
	      style: { marginBottom: 0 }
	    }, dd.span({
	      onClick: AuthedUserSession.is_privatelabel && this.__changeActiveCompany,
	      className: "navbar-brand",
	      style: thestyle
	    }, is_beta ? dd.span({ className: "beta-ribbon" }, "BETA") : null, dd.img({
	      key: _.uniqueId(),
	      src: ImageURLs.logo,
	      style: { height: 28 }
	    }), is_st_family ? dd.span({
	      className: "btn btn-link",
	      style: {
	        fontSize: "0.75rem",
	        paddingTop: "0",
	        marginTop: "-1rem"
	      }
	    }, "change") : null), UpdateAlert(), Menu({ Displaylists: Displaylists }));
	  }
	});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _dd = __webpack_require__(3);
	
	var _dd2 = _interopRequireDefault(_dd);
	
	var _StandardLayout = __webpack_require__(67);
	
	var _StandardLayout2 = _interopRequireDefault(_StandardLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	
	
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = _dd2.default.createClass({
	  render: function render() {
	    return (0, _StandardLayout2.default)({}, _dd2.default.div({ className: "container" }, _dd2.default.div({}, _dd2.default.h1({}, "eSpeakers Lead Board"), _dd2.default.div({ className: "panel panel-default" }, _dd2.default.div({ className: "panel-body" }, _dd2.default.h4({}, "The eSpeakers Marketplace Lead Board has been upgraded and is easier to get to directly from the main dashboard."), _dd2.default.hr(), _dd2.default.p({}, "The improved Lead Board now combines jobs from eSpeakers Marketplace, bureaus and associations, and sources across the web."), _dd2.default.ul({}, _dd2.default.li({}, _dd2.default.span({}, "Some jobs in the Lead Board include a finders fee that varies from lead to lead. ")), _dd2.default.li({}, _dd2.default.span({}, "Any finders fee is always displayed clearly so that you will know your responsibility if you close the deal."))), _dd2.default.p({}, "There are several new features that make it easier for you to find new jobs:"), _dd2.default.ul({}, _dd2.default.li({}, "Filter jobs based on your chosen topics to find the best matched jobs"), _dd2.default.li({}, "Sort jobs based on name, location, and budget"), _dd2.default.li({}, "Work with curated and public jobs all from a single page"), _dd2.default.li({}, "Show or hide jobs from outside sites or internal directories"), _dd2.default.li({}, "Find jobs by date range to more easily plan your schedule"), _dd2.default.li({}, "Instantly communicate with the Bureau Agent to quickly get more information about a job to send a better proposal")), _dd2.default.p({}, "We are excited to offer these new tools to help you grow your speaking business."), _dd2.default.div({ className: "text-center" }, _dd2.default.a({
	      href: "/dashboard/token-callback?token=" + _.get(AuthedUserSession, ["balboa", "estoken"], "") + "&redir=/" + AuthedUserSession.getLastSelectedSID() + "/lead-board/shortlists"
	    }, _dd2.default.button({ className: "btn btn-primary" }, "Access The New Lead Board"))))))));
	  }
	});
	//
	// export default function LeadBoard() {
	//
	//   return (
	//     <div className={"container-fluid"}>
	//       <h2>Important information the new eSpeakers Lead Board</h2>
	//       <p>
	//         We have moved the marketplace jobs and all other leads to your eSpeakers Dashboard.
	//       </p>
	//       <p>
	//         You can search hundreds of jobs and apply to the ones that best match your speaking strengths.  Jobs that are available on a bureau will still require
	//         a finder's fee; while Call for Speaker jobs are free to apply.
	//       </p>
	//       <p>
	//         You can start your search today by going to the <a href={"/dashboard/lead-board"}>Lead Board</a>.
	//       </p>
	//     </div>
	//   );
	// }

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
		render: function render() {
			var mobile_app_url = AuthedUserSession.is_privatelabel ? null //privatelabels currently don't have a mobile app
			: "https://www.espeakers.com/wiki/Download_eSpeakers_App";
	
			return dd.div({ className: "your-browser-window-is-too-small text-center hidden-lg hidden-md" }, dd.div({ className: "relative" }, dd.div({ className: "glass" }), dd.div({ className: "body" }, dd.div({ className: "panel panel-default" }, dd.div({ className: "panel-body" }, dd.h2(null, "Squeezed! Your window is too narrow for this."), mobile_app_url ? dd.div(null, dd.h3(null, dd.i({ className: "fa fa-mobile" }), " If you are on a mobile device:"), dd.a({ href: mobile_app_url }, "Click here"), " to get our free mobile app.", dd.h3(null, dd.i({ className: "fa fa-desktop" }), " If you are on a desktop:")) : null, "Stretch this window wider.")))));
		}
	});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  render: function render() {
	
	    var decorators = [['travel', 'travel'], ['daily', 'daily'], ['call', 'call']];
	
	    if (AuthedUserSession.is_st_family) {
	      decorators.push(['coaching', 'coaching']);
	    }
	
	    return dd.div({ className: 'CalendarLegend text-center no-select', style: { padding: "1em 2em" } }, dd.div({ style: { paddingBottom: ".5em" } }, dd.div({ className: 'legend-item confirmedevent' }, 'confirmed'), dd.div({ className: 'legend-item heldevent' }, 'held'), dd.div({ className: 'legend-item leadevent' }, 'lead'), dd.div({ className: 'legend-item postponedevent' }, 'postponed'), dd.div({ className: 'legend-item closedevent' }, 'closed'), !AuthedUserSession.is_st_family && dd.div({}, dd.div({ className: "legend-item dayshape" }), dd.div({ className: "legend-item dayshape-label" }, "on-site"), dd.div({ className: "legend-item dayshape", style: { borderRadius: "4px" } }), dd.div({ className: "legend-item dayshape-label" }, "remote"))), _.map(decorators, function (_ref, i) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          label = _ref2[0],
	          css_class = _ref2[1];
	
	      return dd.div({ key: i, className: 'legend-item decorator' }, label, dd.span({ className: css_class + ' decoration' }));
	    }));
	  }
	});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var SortableTable = __webpack_require__(188);
	var AuthedUserSession = __webpack_require__(4);
	
	var DashArea = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        title = _props.title,
	        children = _props.children,
	        iconClassName = _props.iconClassName,
	        className = _props.className;
	
	    return dd.div({ className: "panel panel-default " + (className ? ' ' + className : '') }, dd.div({ className: "panel-heading" }, dd.i({ className: "fa fa-fw" + (iconClassName ? ' ' + iconClassName : '') }), ' ' + title), dd.div({ className: "panel-body" }, children));
	  }
	});
	
	var PipelineNumber = dd.createClass({
	  __searchFor: function __searchFor(searchterm, filter_to_sid) {
	    //the detail link has been clicked
	    return esUtils.wrapPreventDefault(function () {
	      var q = {
	        searchterm: searchterm,
	        exclude_event_types: [Constants.EVENT_STATUSES.zimbra, Constants.EVENT_STATUSES.canceled]
	      };
	      if (filter_to_sid > 0) {
	        q.sids = [filter_to_sid];
	      }
	      radio('EventSearchAside_search').broadcast(q);
	    });
	  },
	  render: function render() {
	    var filter_to_sid = this.props.filter_to_sid;
	
	    var can_view_fees = AuthedUserSession.doIHaveAccess.view_fees.any(filter_to_sid > 0 ? filter_to_sid : AuthedUserSession.all_sids_i_have_permissions_for);
	    return dd.div({ className: "panel panel-" + (this.props.className || '') }, dd.div({ className: "panel-heading" }, dd.div({ className: "row" }, dd.div({ className: "col-xs-3 visible-lg " }, dd.i({ className: "fa fa-circle-o fa-4x" })), dd.div({ className: "col-xs-9 text-right" }, dd.div({ className: "huge" }, esUtils.format_number(this.props.qty, 0)), dd.div(null, this.props.label)))), dd.a({ href: "#", onClick: this.__searchFor(this.props.searchfor, filter_to_sid) }, dd.div({ className: "panel-footer" }, can_view_fees ? dd.span({ className: "pull-left detaillink" }, esUtils.format_currency(this.props.value, 0) + '') : null, dd.span({ className: "pull-right" }, dd.i({ className: "fa fa-arrow-circle-right" })), dd.div({ className: "clearfix" }))));
	  }
	});
	
	module.exports = dd.createClass({
	  __eventClicked: function __eventClicked(eid, tab) {
	    return esUtils.wrapPreventDefault(function () {
	      radio('Hashbang_set').broadcast('/events/' + eid + (tab ? '/' + tab : ''));
	    });
	  },
	  render: function render() {
	    var self = this;
	    var _props2 = this.props,
	        filter_to_sid = _props2.filter_to_sid,
	        Displaylists = _props2.Displaylists;
	
	    var dashboardData = this.props.Dashboarddata || {};
	    var pipeline = _.isPlainObject(dashboardData.pipeline) ? dashboardData.pipeline['sid' + (filter_to_sid > 0 ? filter_to_sid : 0)] : null;
	
	    var preferences = Displaylists && Displaylists.user && Displaylists.user.myevents_preferences || {};
	    var today = new Date();
	    var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(AuthedUserSession.all_sids_i_have_permissions_for);
	
	    var isRowForSelectedSID = function isRowForSelectedSID(row) {
	      if (!row.hasOwnProperty('sids')) {
	        return false;
	      }
	      if (preferences.hide_personal_days_on_dashboard_lists && row.hasOwnProperty('psnl') && row.psnl) {
	        return false; //filter out personal items
	      }
	      return filter_to_sid < 1 || _.includes(row.sids, filter_to_sid);
	    };
	
	    var tip = Displaylists && Displaylists.tip || {};
	
	    return dd.div({ className: 'Dashboard container-fluid' }, pipeline ? DashArea({ title: 'Events Pipeline', iconClassName: 'fa-usd' }, dd.div({ className: "panel-body" }, dd.div({ className: "row" }, dd.div({ className: 'col-xs-4' }, PipelineNumber({ className: 'confirmed', qty: pipeline.s1.qty, label: 'confirmed', value: pipeline.s1.val, searchfor: 'pipeline:confirmed', filter_to_sid: filter_to_sid })), dd.div({ className: 'col-xs-4' }, PipelineNumber({ className: 'held', qty: pipeline.s0.qty, label: 'held', value: pipeline.s0.val, searchfor: 'pipeline:held', filter_to_sid: filter_to_sid })), dd.div({ className: 'col-xs-4' }, PipelineNumber({ className: 'lead', qty: pipeline.s10.qty, label: 'leads', value: pipeline.s10.val, searchfor: 'pipeline:lead', filter_to_sid: filter_to_sid }))))) : null, !AuthedUserSession.is_st_family && tip && _.isString(tip.tiptext) ? DashArea({ title: 'Tip of the day', iconClassName: 'fa-lightbulb-o' }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-3 text-center text-muted' }, dd.i({
	      className: tip.priority >= 8 ? 'fa fa-warning text-danger' : 'fa fa-lightbulb-o',
	      style: { fontSize: 100 }
	    })), dd.div({ className: 'col-sm-9' }, dd.p({ className: "preserve-whitespace" }, tip.tiptext.trim()), tip.link ? dd.p(null, dd.a({ href: tip.link, target: '_blank' }, tip.linktext || tip.link)) : null))) : null, !is_limited_speaker ? DashArea({ title: 'Action List', iconClassName: 'fa-check-circle-o' }, SortableTable({
	      default_sort: {
	        sort_col: 0,
	        sort_ascending: true
	      }, table: {
	        header: [{ body: 'due', className: 'date' }, { body: 'action' }, { body: 'organization', className: 'organization' }],
	        rows: _.map(_.filter(dashboardData.actionlist, isRowForSelectedSID), function (row) {
	          var date = esUtils.convertFromISO8601(row.date);
	          return {
	            props: { 'className': today.getTime() >= date.getTime() ? 'danger' : '', onClick: self.__eventClicked(row.eid, 'action_list'), 'data-eid': row.eid },
	            cols: [{ body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date }, { body: row.dsc }, {
	              sortkey: row.org, render: function render() {
	                var intitials = filter_to_sid < 1 ? dd.span({ className: 'initials' }, row.intls) : null;
	                return dd.span(null, intitials, row.org);
	              }
	            }]
	          };
	        })
	      }
	    })) : null, DashArea({ title: 'Recent Activity', iconClassName: 'fa-bars', className: 'recentactivity' }, SortableTable({
	      default_sort: {
	        sort_col: 0,
	        sort_ascending: preferences.sort_results !== 'earliest_at_bottom'
	      }, table: {
	        header: [{ body: 'changed', className: 'date' }, { body: 'status', className: 'status' }, { body: 'organization', className: 'organization' }],
	        rows: _.map(_.filter(dashboardData.activity, isRowForSelectedSID), function (row) {
	          var date = esUtils.convertFromISO8601(row.date);
	          return {
	            props: { onClick: self.__eventClicked(row.eid, 'details'), 'data-eid': row.eid },
	            cols: [{ body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date }, { body: row.st }, {
	              sortkey: row.dsc, render: function render() {
	                var intitials = filter_to_sid < 1 ? dd.span({ className: 'initials' }, row.intls) : null;
	                return dd.span(null, intitials, row.dsc);
	              }
	            }]
	          };
	        })
	      }
	    })), DashArea({ title: 'Upcoming confirmed', iconClassName: 'fa-calendar' }, SortableTable({
	      default_sort: {
	        sort_col: 0,
	        sort_ascending: preferences.sort_results !== 'earliest_at_bottom'
	      }, table: {
	        header: [{ body: 'date', className: 'date' }, { body: 'organization', className: 'organization' }, { body: 'venue' }],
	        rows: _.map(_.filter(dashboardData.upcoming, isRowForSelectedSID), function (row) {
	          var date = esUtils.convertFromISO8601(row.date);
	          return {
	            props: { onClick: self.__eventClicked(row.eid, 'details'), 'data-eid': row.eid },
	            cols: [{ body: esUtils.format_date(date, esUtils.format_date.masks.mediumDate), sortkey: date }, {
	              sortkey: row.dsc, render: function render() {
	                var intitials = filter_to_sid < 1 ? dd.span({ className: 'initials' }, row.intls) : null;
	                return dd.span(null, intitials, row.dsc);
	              }
	            }, { body: row.vnu }]
	          };
	        })
	      }
	    })));
	  }
	});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var Aside = __webpack_require__(184);
	var ErrorAlert = __webpack_require__(6);
	var RadioMixin = __webpack_require__(20);
	var SearchForm = __webpack_require__(121);
	var LoadingWrap = __webpack_require__(8);
	var SearchResult = __webpack_require__(251);
	var RadioServiceMixin = __webpack_require__(14);
	var FormUtils = __webpack_require__(9);
	
	var SearchResults = dd.createClass({
		render: function render() {
			var _props = this.props,
			    my_speaker_names_by_sid = _props.my_speaker_names_by_sid,
			    results = _props.results;
	
	
			if (_.size(results) === 0) {
				return dd.h4({ className: 'text-center emptylist', style: { margin: '30px 0' } }, 'No matches. Try a different search.');
			}
	
			return dd.div({ style: { margin: '10px 0' } }, _.map(results, function (result, i) {
				return SearchResult({ key: result.eid + ',' + i, result: result, my_speaker_names_by_sid: my_speaker_names_by_sid });
			}));
		}
	});
	
	var DaAside = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				EventSearch_search: {
					key: function key() {
						return JSON.stringify(this.props.query);
					}
				}
			};
		},
		render: function render() {
			var ajax = this.state.EventSearch_search;
			var _props2 = this.props,
			    query = _props2.query,
			    onClose = _props2.onClose,
			    Displaylists = _props2.Displaylists;
	
	
			var my_speaker_names_by_sid = FormUtils.getSpeakerNamesBySid(Displaylists, true);
			var preferences = Displaylists && Displaylists.user && Displaylists.user.myevents_preferences || {};
			var results = _.isArray(ajax.data) ? ajax.data : [];
	
			if (preferences.sort_results === 'earliest_at_top' && !(query && query.parenteid > 0)) {
				//don't reverse it on family searches
				//DON't use results.reverse() b/c that will reverse on every render, mutating the underlying ajax data every time
				results = _.sortBy(results, function (val, i) {
					//sortBy doesn't mutate the original array
					return -i; //reverse
				});
			}
	
			return Aside({
				header: [dd.h4({ key: 1 }, 'Search EventCX'), SearchForm({
					key: 2,
					mini_form: false,
					query: query,
					results: results,
					loading: ajax.waiting,
					error_msg: ajax.error,
					my_speaker_names_by_sid: my_speaker_names_by_sid
				})],
				right: true,
				__onClose: onClose
			}, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: 'Searching...' }, !ajax.error && !_.isArray(ajax.data) ? dd.h4({ className: 'text-center', style: { margin: '30px 0' } }, "What would you like to search?") : SearchResults({ results: results, my_speaker_names_by_sid: my_speaker_names_by_sid })));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { show: false, query: null };
		},
		Radio_setup: function Radio_setup() {
			return {
				EventSearchAside_search: function EventSearchAside_search(query) {
					this.setState({ show: true, query: query }, function () {
						radio("EventSearch_search").broadcast(query);
					});
				},
				EventSearchAside_open: function EventSearchAside_open() {
					if (!this.state.show) {
						this.setState({ show: true, query: null });
					}
				}
			};
		},
		__onClose: function __onClose() {
			this.setState({ show: false });
		},
		render: function render() {
			if (!this.state.show) {
				return dd.div();
			}
	
			return DaAside({
				query: this.state.query,
				onClose: this.__onClose,
				Displaylists: this.props.Displaylists
			});
		}
	});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioMixin = __webpack_require__(20);
	var DayPopover = __webpack_require__(120);
	var CalendarTools = __webpack_require__(119);
	var AuthedUserSession = __webpack_require__(4);
	
	var MonthTitle = dd.createClass({
	  __monthClicked: esUtils.wrapPreventDefault(function () {
	    var _props = this.props,
	        year = _props.year,
	        month = _props.month;
	
	    radio("Show_Calendar").broadcast("month", new Date(year, month - 1, 1));
	  }),
	  render: function render() {
	    var _props2 = this.props,
	        year = _props2.year,
	        month = _props2.month;
	
	    return dd.a({ href: "#", onClick: this.__monthClicked }, esUtils.get_month_name(month), dd.span(null, year));
	  }
	});
	
	var Day = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { show_popover: false };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      MiniCalendar_day_clicked: function MiniCalendar_day_clicked(in_year, in_month, in_day) {
	        var _props3 = this.props,
	            year = _props3.year,
	            month = _props3.month,
	            day = _props3.day;
	
	        if (in_year === year && in_month === month && in_day === _.get(day, "date")) {} else {
	          this.setState({ show_popover: false }); //hide all others
	        }
	      },
	      MiniCalendar_close_all_popovers: function MiniCalendar_close_all_popovers() {
	        if (this.state.show_popover) {
	          this.setState({ show_popover: false });
	        }
	      }
	    };
	  },
	
	  __click_newEvent: esUtils.wrapPreventDefault(function () {
	    var _props4 = this.props,
	        year = _props4.year,
	        month = _props4.month,
	        day = _props4.day;
	
	    radio("Hashbang_set").broadcast("/events/new" + (!day ? "" : "/" + year + "-" + month + "-" + day.date));
	    this.setState({ show_popover: false });
	  }),
	  __click_toggle_popover: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_popover: !this.state.show_popover });
	  }),
	  __click_url: function __click_url(url) {
	    return _.bind(esUtils.wrapPreventDefault(function () {
	      radio("Hashbang_set").broadcast(url);
	      this.setState({ show_popover: false });
	    }), this);
	  },
	  __dayClicked: function __dayClicked(e) {
	    var _props5 = this.props,
	        year = _props5.year,
	        month = _props5.month,
	        day = _props5.day;
	
	    radio("MiniCalendar_day_clicked").broadcast(year, month, day.date);
	
	    if (day.out_of_month) {
	      return;
	    }
	    this.__click_toggle_popover(e);
	  },
	  render: function render() {
	    var _props6 = this.props,
	        day = _props6.day,
	        cal_data = _props6.cal_data,
	        cal_details = _props6.cal_details,
	        Displaylists = _props6.Displaylists,
	        is_multi_sid_mode = _props6.is_multi_sid_mode,
	        include_other_companies = _props6.include_other_companies,
	        empire_mode = _props6.empire_mode;
	
	    var day_data = _.has(cal_data, day.date) ? cal_data[day.date] : {};
	
	    var details = _.uniq(_.reject(_.map(day_data.detail_ids, function (detail_id) {
	      return cal_details && cal_details[detail_id];
	    }), _.isEmpty), function (detail) {
	      if (detail.eid && detail.eid > 0) {
	        return detail.eid;
	      }
	      return [detail.desc, detail.type].join("$");
	    });
	
	    var classes = ["day", "relative"];
	    var decorators_classes = day_data.decorators; //TODO don't use day_data.decorators - why? b/c it doesn't filter by sid thus lots of stuff gets stomped over
	    decorators_classes = _.without(decorators_classes, "personal"); //don't use day_data.decorators why? b/c it doesn't filter by sid
	    if (day.out_of_month) {
	      classes.push("old");
	    } else {
	      classes.push("clickable");
	      if (_.some(details, function (detail) {
	        //if there are any personal days...
	        return _.get(detail, "psnl", false);
	      }) && !_.some(details, function (detail) {
	        //...and there are no non-personal days
	        return !_.get(detail, "psnl", false);
	      })) {
	        //add personal...
	        classes.push("personal");
	        decorators_classes.push("personal");
	      }
	      if (!AuthedUserSession.is_st_family) {
	        if (_.some(details, function (detail) {
	          return _.get(detail, "vrtl", false);
	        })) {
	          classes.push("virtual");
	          decorators_classes.push("virtual");
	        }
	      }
	
	      //setting the day's status here includes status of every speaker, and we probably just want status for one
	      var daystatus = -1;
	      var has_other_company = false;
	      _.each(details, function (detail) {
	        if (detail.type === "event" && (daystatus < 0 || Constants.EVENT_STATUS_PRIORITY[detail.sta] > Constants.EVENT_STATUS_PRIORITY[Constants.EVENT_STATUSES_by_num[daystatus]]) && (!AuthedUserSession.is_st_family || !_.get(detail, "psnl", false) || _.includes(classes, "personal"))) {
	          daystatus = Constants.EVENT_STATUSES[detail.sta];
	        }
	        has_other_company = (has_other_company || !_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(detail.cmpid))) && !empire_mode; //in empire mode, there's not an 'other' company
	      });
	      if (daystatus > -1) {
	        classes.push("cal-event");
	        classes.push(Constants.EVENT_STATUSES_by_num[daystatus]);
	      }
	      if (has_other_company) {
	        classes.push('othercompany');
	      }
	    }
	
	    //ITEMS THAT WILL APPEAR IN THE POPUP MENU FOR THE DAY
	    var popover_items = _.map(details, function (detail) {
	      var url = CalendarTools.getEventURL(detail);
	      var description = detail.desc;
	      var personal = detail.psnl ? "[PSNL] " : "";
	      var name = (personal + description).trim();
	
	      //EMPIRE MODE
	      if (empire_mode) {
	        var company = _.get(Displaylists, "universal.company", []).find(function (obj) {
	          return obj.id == _.parseInt(detail.cmpid);
	        });
	        company = "[" + _.get(company, "abbr", "COMPANY " + detail.cmpid) + "] ";
	        name = (company + personal + description).trim();
	        url = CalendarTools.getEventURL(detail) + "/load"; //pecial EventTab state that will load the correct company
	      } else {
	
	        //EVENT COMPANY IS NOT THE ACTIVE COMPANY
	        if (!_.include([_.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])], detail.cmpid)) {
	          var _company = _.get(Displaylists, "universal.company", []).find(function (obj) {
	            return _.parseInt(obj.id) === _.parseInt(detail.cmpid);
	          });
	          _company = "[" + _.get(_company, "abbr", "COMPANY " + detail.cmpid) + "] ";
	          var location = (_.get(detail, "vcty", "") + " " + _.get(detail, "vst", "")).trim();
	          if (location === '') {
	            // if location is blank (i.e. no city or state), then use the country instead
	            location = _.get(detail, "vcnt", "").trim();
	          }
	          if (location === '' || location === 'US') {
	            // if the location is still blank, then just use the description
	            location = 'TBD';
	          }
	          name = (_company + personal + location).trim();
	          if (!_.include(_.get(AuthedUserSession, ["companyIdsICanRead"]), _.parseInt(detail.cmpid))) {
	            url = null; // Only remove the url if we can't read the event (or switch to a company and read the event)
	          }
	        }
	      }
	
	      return {
	        sids: detail.sids,
	        name: name,
	        icon: CalendarTools.getEventIcon(detail),
	        cmpid: detail.cmpid,
	        className: CalendarTools.getEventClass(detail) + (detail.psnl ? ' personal' : ''),
	        onClick: url ? this.__click_url(url) : null
	      };
	    }, this);
	    popover_items.push({
	      name: "Create new",
	      onClick: this.__click_newEvent,
	      className: _.isEmpty(popover_items) ? null : "popoverSeparator"
	    });
	
	    return dd.td({ className: classes.join(" "), onClick: this.__dayClicked }, dd.span(null, day.date), day.out_of_month ? null : _.map(decorators_classes, function (decorator, i) {
	      return dd.div({ key: i, className: "decorator " + decorator });
	    }), !this.state.show_popover || popover_items.length === 0 ? null : DayPopover({ items: popover_items, Displaylists: Displaylists, is_multi_sid_mode: is_multi_sid_mode, include_other_companies: include_other_companies, empire_mode: empire_mode }));
	  }
	});
	
	var weeksHaveMoreThanOneSID = function weeksHaveMoreThanOneSID(cal_details, cal_data, weeks) {
	  var da_one_sid = undefined;
	  return _.some(weeks, function (week) {
	    return _.some(week, function (day) {
	      var day_data = _.has(cal_data, day.date) ? cal_data[day.date] : {};
	      return _.some(day_data.detail_ids, function (detail_id) {
	        var e = cal_details && cal_details[detail_id];
	        return _.some(e && e.sids, function (sid) {
	          var id = _.parseInt(sid, 10);
	          if (da_one_sid === undefined) {
	            da_one_sid = id;
	          } else if (id > 0 && da_one_sid !== id) {
	            //we found more than one sid
	            return true;
	          }
	          return false;
	        });
	      });
	    });
	  });
	};
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props7 = this.props,
	        year = _props7.year,
	        month = _props7.month,
	        cal_details = _props7.cal_details,
	        cal_data = _props7.cal_data,
	        Displaylists = _props7.Displaylists,
	        include_other_companies = _props7.include_other_companies,
	        empire_mode = _props7.empire_mode;
	
	    var weeks = esUtils.build_calendar_weeks(year, month, true);
	    var is_multi_sid_mode = weeksHaveMoreThanOneSID(cal_details, cal_data, weeks);
	
	    return dd.div({ className: "MiniCalendar" }, dd.table(null, dd.thead(null, dd.tr(null, dd.th({ colSpan: 7, className: "month" }, MonthTitle({ month: month, year: year }))), dd.tr(null, _.map([1, 2, 3, 4, 5, 6, 7], function (d) {
	      return dd.th({ key: d, className: "dow" }, esUtils.get_day_of_week(d, true));
	    }))), dd.tbody(null, _.map(weeks, function (week, i) {
	      return dd.tr({ key: i }, _.map(week, function (day, i) {
	        return Day({
	          key: i,
	          year: year,
	          month: month,
	          day: day,
	          cal_data: cal_data,
	          cal_details: cal_details,
	          Displaylists: Displaylists,
	          is_multi_sid_mode: is_multi_sid_mode,
	          include_other_companies: include_other_companies,
	          empire_mode: empire_mode
	        });
	      }));
	    }))));
	  }
	});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(22);
	var DayPopover = __webpack_require__(120);
	var CalendarTools = __webpack_require__(119);
	var HoverMixin = __webpack_require__(49);
	var AuthedUserSession = __webpack_require__(4);
	
	var build_month_calendar = function build_month_calendar(year, month, calendar_data) {
	  var days_data = {};
	  if (calendar_data && calendar_data.calendar && calendar_data.calendar[year.toString()] && calendar_data.calendar[year.toString()][month.toString()]) {
	    days_data = calendar_data.calendar[year.toString()][month.toString()];
	  }
	  return _.map(esUtils.build_calendar_weeks(year, month), function (week) {
	    return _.map(week, function (day) {
	      if (day.out_of_month) {
	        return day;
	      }
	      day.events = [];
	      if (days_data[day.date]) {
	        var detail_ids = days_data[day.date].detail_ids;
	        if (detail_ids && calendar_data.details) {
	          _.each(detail_ids, function (id) {
	            if (calendar_data.details[id]) {
	              day.events.push(calendar_data.details[id]);
	            }
	          });
	        }
	      }
	      return day;
	    });
	  });
	};
	
	module.exports = dd.createClass({
	  __incMonth: function __incMonth(inc) {
	    var d = new Date(this.props.year, this.props.month - 1, 1);
	    d.setMonth(d.getMonth() + inc);
	    radio('Show_Calendar').broadcast('month', d);
	  },
	  __prevMonth: esUtils.wrapPreventDefault(function () {
	    this.__incMonth(-1);
	  }),
	  __nextMonth: esUtils.wrapPreventDefault(function () {
	    this.__incMonth(1);
	  }),
	  __today: esUtils.wrapPreventDefault(function () {
	    var d1 = new Date(this.props.year, this.props.month - 1, 1);
	    var d2 = new Date();
	    this.__incMonth(d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear()));
	  }),
	  __yearView: esUtils.wrapPreventDefault(function () {
	    radio('Show_Calendar').broadcast('year');
	  }),
	  render: function render() {
	    var month = this.props.month;
	    var year = this.props.year;
	    var Displaylists = this.props.Displaylists;
	
	    var month_weeks = build_month_calendar(year, month, this.props.Calendars[year]);
	    return dd.table({ className: 'MonthCalendar' }, dd.thead(null, dd.tr(null, dd.th({ colSpan: 7, className: 'month-and-year forward-backward-picker' }, dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginLeft: "0" }, onClick: this.__nextMonth }, dd.i({ className: 'fa fa-angle-right' })), dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginLeft: "0", marginRight: "0" }, onClick: this.__today }, "today"), dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginRight: "0" }, onClick: this.__prevMonth }, dd.i({ className: 'fa fa-angle-left' })), dd.span({ className: 'title' }, esUtils.get_month_name(month) + ' ', dd.a({ href: '#', onClick: this.__yearView }, year)), dd.div({ className: 'clearfix' }))), dd.tr(null, _.map([1, 2, 3, 4, 5, 6, 7], function (d) {
	      return dd.th({ key: d }, esUtils.get_day_of_week(d));
	    }))), dd.tbody(null, _.map(month_weeks, function (week, i) {
	      return dd.tr({ key: i }, _.map(week, function (day, i) {
	        return CalendarDay({ key: i, year: year, month: month, day: day, Displaylists: Displaylists });
	      }));
	    })));
	  }
	});
	
	var CalendarDay = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { show_popover: false };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      MiniCalendar_day_clicked: function MiniCalendar_day_clicked(year, month, day) {
	        var s_year = self.props.year;
	        var s_month = self.props.month;
	        var s_day = self.props.day && self.props.day.date;
	        var s_out_of_month = self.props.day && self.props.day.out_of_month;
	        var show = year === s_year && month === s_month && day === s_day && !s_out_of_month;
	
	        if (show !== self.state.show_popover) {
	          //only do this if there is a change
	          setTimeout(function () {
	            //need to run them outside of each others update phase
	            self.setState({ show_popover: show });
	          }, 1);
	        }
	      },
	      MiniCalendar_close_all_popovers: function MiniCalendar_close_all_popovers() {
	        if (self.state.show_popover) {
	          self.setState({ show_popover: false });
	        }
	      }
	    };
	  },
	  __clickDay: esUtils.wrapPreventDefault(function () {
	    var day = this.props.day;
	    radio('MiniCalendar_day_clicked').broadcast(this.props.year, this.props.month, day.date);
	  }),
	  __click_newEvent: esUtils.wrapPreventDefault(function () {
	    var day = this.props.day;
	    var month = this.props.month;
	    var year = this.props.year;
	    this.setState({ show_popover: false }, function () {
	      radio('Hashbang_set').broadcast('/events/new' + (!day ? '' : '/' + year + '-' + month + '-' + day.date));
	    });
	  }),
	  render: function render() {
	    var day = this.props.day;
	    var Displaylists = this.props.Displaylists;
	
	    var events = _.uniq(day.events, CalendarTools.getEventHash);
	    return dd.td({ className: day.out_of_month ? 'out-of-month' : null }, dd.div({
	      className: 'date clickable text-right ' + (day.eventstatus || ''), onClick: this.__clickDay, style: {
	        position: "relative"
	      }
	    }, day.date, this.state.show_popover ? DayPopover({
	      items: [{ name: 'Create new', onClick: this.__click_newEvent }],
	      width_factor: 1
	    }) : null), _.map(_.sortBy(events, CalendarTools.getEventClass).reverse(), function (event, i) {
	      return CalendarEvent({ key: i, event: event, Displaylists: Displaylists });
	    }));
	  }
	});
	
	var CalendarEvent = dd.createClass({
	  mixins: [HoverMixin],
	  render: function render() {
	    var event = this.props.event;
	    var Displaylists = this.props.Displaylists;
	    var has_other_company = false;
	
	    var url = CalendarTools.getEventURL(event);
	    var text = CalendarTools.getEventText(event);
	
	    //events belonging to other companies get special treatment
	    if (!_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(event.cmpid))) {
	      text = _.get(Displaylists, "universal.company", []).find(function (obj) {
	        return obj.id === event.cmpid;
	      });
	
	      text = "[" + _.get(text, "abbr", "COMPANY " + event.cmpid) + "] ";
	
	      var location = (_.get(event, "vcty", "") + " " + _.get(event, "vst", "")).trim();
	      if (location === '') {
	        // if location is blank (i.e. no city or state), then use the country instead
	        location = _.get(event, "vcnt", "").trim();
	      }
	      if (location === '' || location === 'US') {
	        // if the location is still blank, then just use the description
	        location = 'TBD';
	      }
	      //name = (company + personal + location).trim();
	      text = (text + location).trim();
	
	      url = null;
	      has_other_company = true;
	    }
	
	    //add speakername
	    var speakernames = _.map(event.sids, function (sid) {
	      var r = _.findWhere(_.get(Displaylists, "perspeaker", []), { 'sid': _.parseInt(sid, 10) });
	      r = _.get(r, 'name_last', '');
	      return r;
	    });
	    text += " (" + speakernames.join(",") + ")";
	
	    return dd.div({
	      style: { position: 'relative' }
	    }, dd[url ? 'a' : 'span']({
	      href: url,
	      className: 'event ' + CalendarTools.getEventClass(event) + (has_other_company ? ' othercompany' : ''),
	      onMouseEnter: this.hoverable_onMouseEnter,
	      onMouseLeave: this.hoverable_onMouseLeave
	    }, CalendarTools.getEventIcon(event), ' ', text), this.state.hover ? dd.div({
	      ref: "hoverable",
	      className: "tooltip top",
	      role: "tooltip",
	      style: {
	        position: "fixed",
	        opacity: 1,
	        top: this.state.hoverable_top + 'px',
	        left: this.state.hoverable_left + 'px'
	      }
	    }, dd.div({ className: "tooltip-arrow" }), dd.div({ className: "tooltip-inner" }, text)) : null);
	  }
	});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var DateRange = __webpack_require__(65);
	var esStatusImage = __webpack_require__(54);
	
	module.exports = dd.createClass({
		__onClick: esUtils.wrapPreventDefault(function () {
			var result = this.props.result || {};
			radio("Hashbang_set").broadcast("/events/" + result.eid);
		}),
		render: function render() {
			var _props = this.props,
			    my_speaker_names_by_sid = _props.my_speaker_names_by_sid,
			    result = _props.result;
	
			result = result || {};
	
			var loc = (result.venue_city ? result.venue_city + ", " : "") + (result.venue_st ? result.venue_st + " " : "") + (result.venue_country || "");
	
			return dd.div({ className: "SearchResult clickable", onClick: this.__onClick }, dd.div({ className: "pull-left", style: { marginRight: 10, marginBottom: "1em" } }, esStatusImage({
				"status": result["status"],
				delivery_method: result.deliverymethod,
				has_parent: result.parentID > 0,
				has_children: result.n_child_events > 0
			})), dd.div({ style: { float: "right", marginLeft: 10, textAlign: "right" } }, result.mp_payment_total > 0 ? esUtils.format_currency(result.mp_payment_total, 0) : null, " ", result.mp_unread_messages > 0 ? dd.span(null, dd.i({ className: "fa fa-envelope-o" }), " " + result.mp_unread_messages) : null), dd.h4(null, result.organization, dd.span({ className: "text-muted", style: { marginLeft: ".5em" } }, result.meetingname)), dd.div({ className: "stagetime" }, DateRange({ start: result.stagetime_starttime, stop: result.stagetime_stoptime }), esUtils.isBlank(loc) ? null : dd.span({ className: "location text-muted" }, dd.i({ className: "fa fa-map-marker" }), " " + loc)), dd.div({ className: "clearfix" }), _.size(my_speaker_names_by_sid) > 0 ? dd.div({ className: "text-muted text-right" }, _.map(result.sids, function (sid) {
				return my_speaker_names_by_sid[sid];
			}).join(", ")) : null);
		}
	});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var Constants = __webpack_require__(13);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValues: function getInitialValues(_ref) {
	    var query = _ref.query;
	
	    return !query ? {
	      hide_closed_events: _.get(this.props, "Displaylists.user.myevents_preferences.hide_closed_events_in_results", false)
	    } : {
	      searchterm: query.searchterm || null,
	      deepsearch: !!query.deepsearch,
	      includecanceled: _.isArray(query.exclude_event_types) && !_.includes(query.exclude_event_types, Constants.EVENT_STATUSES.canceled),
	      cross_companies: !!query.cross_companies,
	      datelessonly: !!query.datelessonly,
	      marketplaceonly: !!query.marketplaceonly,
	      speaker_select: _.isArray(query.sids) && query.sids.length > 0 ? _.first(query.sids) : -1,
	      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"]),
	      hide_closed_events: !!query.hide_closed_events
	    };
	  },
	  buildSchema: function buildSchema() {
	    var speakers = this.props.speakers;
	    return {
	      searchterm: {
	        type: "text",
	        placeholder: "Search",
	        validate: FormUtils.v.optional //accepts searches w/o a query
	      },
	      speaker: {
	        type: "select",
	        placeholder: "-- select speaker --",
	        options: speakers,
	        validate: FormUtils.v.optional //accepts searches w/o a speaker
	      },
	      deepsearch: {
	        label: "deep search",
	        type: "checkbox"
	      },
	      includecanceled: {
	        label: "include canceled",
	        type: "checkbox"
	      },
	      datelessonly: {
	        label: "only dateless events",
	        type: "checkbox"
	      },
	      cross_companies: {
	        label: 'other companies',
	        type: 'checkbox'
	      },
	      hide_closed_events: {
	        label: 'hide closed events',
	        type: 'checkbox'
	      }
	    };
	  },
	  render: function render() {
	    var fields = this.Form_buildSchema();
	    var errors = this.state.errors || {};
	
	    return dd.form({ onSubmit: this.Form_onSubmit }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-6' }, dd.div({ className: "form-group" + (errors["searchterm"] ? " has-error" : ""), style: { marginBottom: "10px" } }, dd.div({ className: "input-group" }, this.Form_buildInput(fields.searchterm), dd.span({ className: "input-group-btn" }, dd.button({ type: "submit", className: "btn btn-default" }, dd.i({ className: "fa fa-search" }), " Search"))))), dd.div({ className: 'col-sm-6' }, dd.div({ className: "form-group" + (errors["speaker"] ? " has-error" : ""), style: { marginBottom: "10px" } }, dd.div({ className: "input-group" }, this.Form_buildInput(fields.speaker))))), _.map(["deepsearch", "includecanceled", "datelessonly", "cross_companies", "hide_closed_events"], function (name) {
	      return dd.div({ key: name, style: { display: "inline-block", marginRight: "1em" } }, this.Form_buildInput(fields[name]));
	    }, this), dd.div({ className: "clearfix" }));
	  }
	});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var dateformat = __webpack_require__(41);
	var esStatusImage = __webpack_require__(54);
	var getResultDates = __webpack_require__(122);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  __onClick: esUtils.wrapPreventDefault(function () {
	    var result = this.props.result;
	
	    radio("Hashbang_set").broadcast("/events/" + result.eid);
	  }),
	  render: function render() {
	    var _props = this.props,
	        indent = _props.indent,
	        result = _props.result,
	        Displaylists = _props.Displaylists;
	
	
	    var d = result.this_result_date;
	
	    var n_child_days = 0;
	    if (_.size(getResultDates(result)) <= 1) {
	      //only show child days if we only have on result
	      n_child_days = esUtils.toInt(result.n_child_days);
	    }
	
	    //tack on the company name if it's not the active company or it's child
	    var event_company_id = _.parseInt(_.get(result, ["companyID"]));
	    var companylabel = "";
	    if (event_company_id !== _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])) {
	      var company = _.find(_.get(Displaylists, ["universal", "company"]), { 'id': event_company_id });
	      if (_.parseInt(_.get(company, "prnt", 0)) !== _.parseInt(_.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) {
	        companylabel = " [" + _.get(company, "abbr", event_company_id) + "]";
	      }
	    }
	
	    return dd.div({ className: "clickable", onClick: this.__onClick }, dd.div({ style: { marginLeft: indent, padding: "3px 0" } }, dd.div({ className: "pull-left" }, esStatusImage({
	      size: 20,
	      status: _.get(result, "status"),
	      closed: (_.get(result, "flags", 0) & 4) > 0,
	      delivery_method: _.get(result, "deliverymethod"),
	      has_parent: _.get(result, "parentID", 0) > 0,
	      has_children: _.get(result, "n_child_events", 0) > 0
	    })), dd.div({ style: { marginLeft: 30 } }, _.isDate(d) ? dateformat(d, "d") + ": " : "", _.get(result, "organization", null), " ", _.get(result, "meetingname", null), n_child_days > 1 ? " (" + n_child_days + " Days)" : null, companylabel), dd.div({ className: "clearfix" })));
	  }
	});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Form = __webpack_require__(252);
	var Result = __webpack_require__(253);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var ErrorAlert = __webpack_require__(6);
	var LoadingBar = __webpack_require__(85);
	var RadioServiceMixin = __webpack_require__(14);
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var searchResultsToTree = __webpack_require__(255);
	
	var TreeBlock = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { expanded: true };
	  },
	
	  __toggle: esUtils.wrapPreventDefault(function () {
	    this.setState({ expanded: !this.state.expanded });
	  }),
	  render: function render() {
	    var _props = this.props,
	        title = _props.title,
	        children = _props.children,
	        indent = _props.indent;
	    var expanded = this.state.expanded;
	
	
	    return dd.div({ className: "TreeBlock" }, dd.div({ onClick: this.__toggle, className: "clickable" }, dd.div({ style: { marginLeft: indent } }, dd.i({
	      className: "fa fa-caret-" + (expanded ? "down" : "right"), style: {
	        width: "2em",
	        textAlign: "center"
	      }
	    }), title)), dd.div({ className: "tree-block-body" + (expanded ? "" : " tree-block-closed") }, children));
	  }
	});
	
	var SearchStatus = dd.createClass({
	  render: function render() {
	    var ajax = this.props.ajax;
	
	    var n_results = _.isArray(ajax.data) ? _.size(ajax.data) : -1;
	
	    if (ajax.error) {
	      return ErrorAlert({ message: ajax.error });
	    } else if (ajax.waiting) {
	      return dd.div(null, dd.h4(null, "Searching..."), LoadingBar());
	    } else if (n_results < 0) {
	      return dd.h4(null, "What would you like to search?");
	    } else if (n_results === 0) {
	      return dd.h4(null, "No results");
	    } else if (n_results === 1) {
	      return dd.h4(null, n_results + " result");
	    } else {
	      return dd.h4(null, n_results + " results");
	    }
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      EventSearch_search: { key: "callService" }
	    };
	  },
	  RadioService_Radio_setup: function RadioService_Radio_setup() {
	    return {
	      EventSearchAside_search: function EventSearchAside_search(query) {
	        this.RadioService_callService("EventSearch_search", query);
	      }
	    };
	  },
	  __onSubmit: function __onSubmit(data) {
	    var filter_to_sid = data.speaker ? data.speaker : 0;
	    var q = {
	      searchterm: data.searchterm,
	      deepsearch: !!data.deepsearch,
	      marketplaceonly: !!data.marketplaceonly,
	      datelessonly: !!data.datelessonly,
	      cross_companies: !!data.cross_companies,
	      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"]),
	      exclude_event_types: [Constants.EVENT_STATUSES.zimbra],
	      hide_closed_events: !!data.hide_closed_events
	    };
	    if (filter_to_sid > 0) {
	      q.sids = [filter_to_sid];
	    }
	    if (!data.includecanceled) {
	      q.exclude_event_types.push(Constants.EVENT_STATUSES.canceled);
	    }
	    this.RadioService_callService("EventSearch_search", q);
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    var my_speaker_names_by_sid = _.object(_.map(Displaylists && Displaylists.perspeaker, function (speaker) {
	      return [speaker.sid, speaker.name_full];
	    }));
	    var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, true);
	
	    var ajax = this.state.EventSearch_search;
	    var results_tree = searchResultsToTree(ajax.data);
	
	    return dd.div({ className: "container-fluid" }, dd.div({ className: "panel panel-default" }, dd.div({
	      className: "panel-heading", style: {
	        background: "#428BCA",
	        color: "#FFFFFF"
	      }
	    }, dd.h4(null, "Search EventCX"), Form({ onSubmit: this.__onSubmit, speakers: my_speakers, Displaylists: Displaylists })), dd.div({ className: "panel-body", style: { minHeight: "20em" } }, SearchStatus({ ajax: ajax }), _.map(results_tree, function (results_by_sid, group_name) {
	      return TreeBlock({ key: group_name, title: group_name, indent: 0 }, _.map(results_by_sid, function (results, sid) {
	        var name = _.has(my_speaker_names_by_sid, sid) ? my_speaker_names_by_sid[sid] : "-- no speaker --";
	        return TreeBlock({ key: sid, title: name, indent: "3em" }, _.map(_.sortBy(results, function (result) {
	          var d = result.this_result_date;
	          return _.isDate(d) ? d.getDate() : -1;
	        }), function (result, i) {
	          return Result({ key: i, indent: "7em", result: result, Displaylists: Displaylists });
	        }));
	      }));
	    }))));
	  }
	});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dateformat = __webpack_require__(41);
	var getResultDates = __webpack_require__(122);
	
	module.exports = function (results) {
	  var results_w_date = _.flattenDeep(_.map(results, function (result) {
	    var dates = getResultDates(result);
	    if (_.isEmpty(dates)) {
	      return result;
	    }
	    return _.map(dates, function (date) {
	      return _.assign({}, result, {
	        this_result_date: date
	      });
	    });
	  }));
	
	  var results_by_date = _.groupBy(results_w_date, function (result) {
	    var d = result.this_result_date;
	    return _.isDate(d) ? dateformat(d, 'mmmm yyyy') : 'Dateless Events';
	  });
	
	  return _.mapValues(results_by_date, function (results, group_name) {
	    var results_by_sid = {};
	    var push = function push(sid, result) {
	      if (!_.has(results_by_sid, sid)) {
	        results_by_sid[sid] = [];
	      }
	      results_by_sid[sid].push(result);
	    };
	    _.each(results, function (result) {
	      if (_.size(result && result.sids) > 0) {
	        _.each(result && result.sids, function (sid) {
	          push(sid, result);
	        });
	      } else {
	        push('no-sids', result);
	      }
	    });
	    return results_by_sid;
	  });
	};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var MiniCalendar = __webpack_require__(249);
	var CalendarLegend = __webpack_require__(246);
	
	module.exports = dd.createClass({
	  __incYear: function __incYear(inc) {
	    var d = new Date(this.props.year, this.props.month - 1, 1);
	    d.setFullYear(d.getFullYear() + inc);
	    radio('Show_Calendar').broadcast('year', d);
	  },
	
	  __prevYear: esUtils.wrapPreventDefault(function () {
	    this.__incYear(-1);
	  }),
	  __nextYear: esUtils.wrapPreventDefault(function () {
	    this.__incYear(1);
	  }),
	  __today: esUtils.wrapPreventDefault(function () {
	    var d1 = new Date(this.props.year, this.props.month - 1, 1);
	    var d2 = new Date();
	    this.__incYear(d2.getFullYear() - d1.getFullYear());
	  }),
	  render: function render() {
	    var _props = this.props,
	        year = _props.year,
	        Calendars = _props.Calendars,
	        Displaylists = _props.Displaylists,
	        include_other_companies = _props.include_other_companies,
	        empire_mode = _props.empire_mode;
	
	    var year_cal = esUtils.getIn(Calendars, [year, "calendar", year]) || {};
	    var cal_details = esUtils.getIn(Calendars, [year, "details"]) || {};
	
	    return dd.div({ className: 'text-center' }, dd.div({ className: 'forward-backward-picker' }, dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginLeft: "0" }, onClick: this.__nextYear }, dd.i({ className: 'fa fa-angle-right' })), dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginRight: "0", marginLeft: "0" }, onClick: this.__today }, "today"), dd.button({ className: 'pull-right btn btn-default btn-sm', style: { marginRight: "0" }, onClick: this.__prevYear }, dd.i({ className: 'fa fa-angle-left' })), dd.span({ className: 'title' }, year), dd.div({ className: 'clearfix' })), dd.div(null, _.map(_.range(1, 13), function (month) {
	      return dd.div({
	        key: year + '-' + month,
	        style: { display: "inline-block", margin: 5, verticalAlign: "top" }
	      }, MiniCalendar({
	        year: year,
	        month: month,
	        cal_data: year_cal[month],
	        cal_details: cal_details,
	        Displaylists: Displaylists,
	        include_other_companies: include_other_companies,
	        empire_mode: empire_mode
	      }));
	    })), CalendarLegend());
	  }
	});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	/*global localStorage localforage alert */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var RadioMixin = __webpack_require__(20);
	var FullLayout = __webpack_require__(84);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var VerticalScroll = __webpack_require__(66);
	var AuthedUserSession = __webpack_require__(4);
	var RadioServiceMixin = __webpack_require__(14);
	var Constants = __webpack_require__(13);
	
	//NOTE the keys here refer to view_mode
	var calendar_area_views = {
	  year: {
	    cmpt: __webpack_require__(256),
	    name: "Year"
	  },
	  month: {
	    cmpt: __webpack_require__(250),
	    name: "Month"
	  },
	  Dashboard: {
	    cmpt: __webpack_require__(247),
	    name: "Dashboard"
	  }
	};
	
	var SearchForm = __webpack_require__(121);
	var EventSearchAside = void 0;
	//TreeSearch or EventSearchAside???
	if (AuthedUserSession.is_st_family) {
	  calendar_area_views.TreeSearch = {
	    cmpt: __webpack_require__(254),
	    name: "Search"
	  };
	} else {
	  EventSearchAside = __webpack_require__(248);
	}
	
	var filterCalendarToDetailIDs = function filterCalendarToDetailIDs(calendar, detail_ids) {
	  var new_calendar = {};
	  _.each(calendar, function (months, year) {
	    _.each(months, function (days, month) {
	      _.each(days, function (day, date) {
	        var matching_ids = _.intersection(detail_ids, day.detail_ids);
	        if (matching_ids.length > 0) {
	          if (!_.has(new_calendar, year)) {
	            new_calendar[year] = {};
	          }
	          if (!_.has(new_calendar[year], month)) {
	            new_calendar[year][month] = {};
	          }
	          var day_clone = _.cloneDeep(day); //don't mess with the Calendars cache
	          day_clone.detail_ids = matching_ids;
	          new_calendar[year][month][date] = day_clone;
	        }
	      });
	    });
	  });
	  return new_calendar;
	};
	
	/**
	 * Remove Calendar data not belonging to the active company ids.
	 * Filter to a specific speaker should be done _before_ this.
	 *
	 * @param Calendars
	 * @param include_other_companies
	 * @param empire_mode
	 * @returns {{}}
	 */
	var filterCalendarsToCompanies = function filterCalendarsToCompanies(Calendars) {
	  var include_other_companies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var empire_mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  //REMOVE detail rows that are not non [held,conf] belonging to other companies
	  Calendars = _.mapValues(Calendars, function (Calendar, year) {
	    var valid_detail_ids = esUtils.cleanup_ids(_.map(_.filter(_.map(Calendar.details, function (detail, id) {
	      return { id: id, cmpid: detail.cmpid, sta: detail.sta };
	    }), function (pair) {
	      //include events for the active company
	      if (_.includes(_.get(AuthedUserSession, ["activeCompanyIds"]), _.get(pair, ["cmpid"]))) {
	        //in empire_mode, we want only CONF, HELD
	        if (empire_mode) {
	          return _.includes(["confirmed", "held"], pair.sta);
	        }
	        return true;
	      }
	
	      //it didn't belong to the active company, and we're not including other companies or in empire_mode
	      if (!include_other_companies && !empire_mode) {
	        return false;
	      }
	
	      //for other company events, we only want CONF, HELD
	      return _.includes(["confirmed", "held"], pair.sta);
	    }), "id"));
	
	    return {
	      calendar: filterCalendarToDetailIDs(Calendar.calendar, valid_detail_ids),
	      details: _.pick(Calendar.details, valid_detail_ids)
	    };
	  });
	
	  //filtering the data is all we have to do here. The display logic in MiniCalendar.js will color things for us and figure out new day status.
	
	  // Calendars = _.mapValues(Calendars, function (Calendar, year) {
	  //   let calendar = _.mapValues(Calendar.calendar, function (months) {
	  //     return _.mapValues(months, function(days) {
	  //       return _.mapValues(days, function(day) {
	  //         let newday = _.cloneDeep(day);
	  //         let new_decorators = day.decorators;
	  //         let new_eventstatus = day.eventstatus;
	  //
	  //         //figure out if any of the day's events belong to an "other company"
	  //         let has_othercompany = false;
	  //         _.each(day.detail_ids, function(detail_id) {
	  //           has_othercompany = has_othercompany ||  (!_.includes(AuthedUserSession.companyIdsICanRead, _.get(Calendar, ["details", detail_id, "cmpid"])));
	  //         });
	  //
	  //         newday.decorators = new_decorators;
	  //         newday.eventstatus = new_eventstatus;
	  //         return newday;
	  //       });
	  //     });
	  //   });
	  //
	  //   return {
	  //     calendar: calendar,
	  //     details: Calendar.details
	  //   };
	  // });
	  return Calendars;
	};
	
	var filterCalendarsToSID = function filterCalendarsToSID(Calendars, sid) {
	  return _.mapValues(Calendars, function (Calendar, year) {
	    var valid_detail_ids = esUtils.cleanup_ids(_.map(_.filter(_.map(Calendar.details, function (detail, id) {
	      return { id: id, sids: esUtils.cleanup_ids(detail.sids) };
	    }), function (pair) {
	      return _.includes(pair.sids, sid);
	    }), "id"));
	
	    return {
	      calendar: filterCalendarToDetailIDs(Calendar.calendar, valid_detail_ids),
	      details: _.pick(Calendar.details, valid_detail_ids) //altho we could just pass them all back, they are not used b/c filterCalendarToDetailIDs filtered out references to them
	    };
	  });
	};
	
	var filterCalendarDecoratorsToSID = function filterCalendarDecoratorsToSID(Calendars, sid) {
	  return _.mapValues(Calendars, function (Calendar, year) {
	    var new_calendar = {};
	    _.each(Calendar.calendar, function (months, year) {
	      _.each(months, function (days, month) {
	        _.each(days, function (day, date) {
	          if (!_.has(new_calendar, year)) {
	            new_calendar[year] = {};
	          }
	          if (!_.has(new_calendar[year], month)) {
	            new_calendar[year][month] = {};
	          }
	          var day_clone = _.cloneDeep(day); //don't mess with the Calendars cache
	          if (sid > 0) {
	            var new_decorators = [];
	            _.each(day_clone.decorators, function (sids, type) {
	              if (_.indexOf(sids, sid.toString()) > -1) {
	                new_decorators.push(type);
	              }
	            });
	            day_clone.decorators = _.uniq(new_decorators);
	          } else {
	            day_clone.decorators = _.keys(day_clone.decorators);
	          }
	          new_calendar[year][month][date] = day_clone;
	        });
	      });
	    });
	    return {
	      calendar: new_calendar,
	      details: Calendar.details
	    };
	  });
	};
	
	var MonthYearToggle = dd.createClass({
	  __setViewOnClick: function __setViewOnClick(view_mode) {
	    return esUtils.wrapPreventDefault(function () {
	      radio("Show_Calendar").broadcast(view_mode);
	    });
	  },
	
	  __openSearch: esUtils.wrapPreventDefault(function () {
	    radio("EventSearchAside_open").broadcast();
	  }),
	  render: function render() {
	    var view_mode = this.props.view_mode;
	
	    return dd.ul({ className: "nav nav-pills small", style: { display: "inline-block" } }, _.map(calendar_area_views, function (_ref, mode) {
	      var name = _ref.name;
	
	      return dd.li({ key: mode, className: mode === view_mode ? "active" : null }, dd.a({ href: "#", onClick: this.__setViewOnClick(mode) }, name));
	    }, this), this.props.show_search_btn ? dd.li(null,
	    //dd.a({href: "#", onClick: this.__openSearch}, dd.i({className: "fa fa-search"}))
	    dd.button({
	      type: "submit",
	      className: "btn btn-default",
	      onClick: this.__openSearch
	    }, dd.i({ className: "fa fa-search" }))) : null);
	  }
	});
	
	var excludeOtherCompaniesForm = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        include_other_companies = _props.include_other_companies,
	        waiting_for_displaylists = _props.waiting_for_displaylists,
	        empire_mode = _props.empire_mode;
	
	    if (AuthedUserSession.is_st_family && !waiting_for_displaylists && _.includes(["year", "month"], this.props.view_mode)) {
	      return dd.div({ style: { display: "block", marginLeft: "1rem", fontSize: "100%" } }, Constants.ST_USERTYPE_SUPER_ADMIN !== _.get(AuthedUserSession, "st_usertype") ? null : dd.div({
	        className: "pull-left",
	        style: { marginRight: "1rem" }
	      }, dd.input({
	        id: "empire_mode_checkbox",
	        type: "checkbox",
	        checked: empire_mode,
	        onChange: this.props.toggleEmpireMode,
	        style: {}
	      }), dd.label({
	        htmlFor: "empire_mode_checkbox",
	        style: { paddingLeft: "5px" }
	      }, " empire")), _.get(this.props, "empire_mode", false) ? null : dd.div({}, dd.input({
	        id: "show_other_companies_checkbox",
	        type: "checkbox",
	        checked: include_other_companies,
	        onChange: this.props.toggleIncludeOtherCompanies
	      }), dd.label({
	        htmlFor: "show_other_companies_checkbox",
	        style: { paddingLeft: "5px" }
	      }, " other companies")));
	    } else {
	      return null;
	    }
	  }
	});
	
	var SelectSpeakerForm = dd.createClass({
	  __onChange: function __onChange(e) {
	    var value = _.parseInt(e.target.value);
	    this.props.setSIDFilter(value > 0 ? value : 0);
	  },
	  render: function render() {
	    var _props2 = this.props,
	        Displaylists = _props2.Displaylists,
	        filter_to_sid = _props2.filter_to_sid;
	
	    var my_speakers = _.get(this.props, "empire_mode", false) ? FormUtils.getSpeakerNamesBySidForEveryCompany(Displaylists) : FormUtils.getSpeakerNamesBySid(Displaylists, false);
	    if (_.size(my_speakers) === 0) {
	      return dd.span();
	    } else if (_.size(my_speakers) === 1) {
	      return dd.b({ style: { lineHeight: "30px" } }, _.first(my_speakers));
	    }
	    my_speakers = _.sortBy(_.pairs(my_speakers), function (o) {
	      return o[1];
	    });
	    return dd.select({
	      className: "form-control",
	      value: filter_to_sid,
	      onChange: this.__onChange,
	      style: { width: "14rem" }
	    }, dd.option({ value: 0 }, "--- all speakers --"), _.map(my_speakers, function (a) {
	      return dd.option({ key: a[0], value: a[0] }, a[1]);
	    }));
	  }
	});
	
	var CalendarHeader = dd.createClass({
	  render: function render() {
	    var _props3 = this.props,
	        Displaylists = _props3.Displaylists,
	        filter_to_sid = _props3.filter_to_sid,
	        view_mode = _props3.view_mode,
	        setSIDFilter = _props3.setSIDFilter,
	        toggleIncludeOtherCompanies = _props3.toggleIncludeOtherCompanies,
	        toggleEmpireMode = _props3.toggleEmpireMode,
	        include_other_companies = _props3.include_other_companies,
	        empire_mode = _props3.empire_mode,
	        waiting_for_displaylists = _props3.waiting_for_displaylists;
	
	    if (calendar_area_views.TreeSearch) {
	      return dd.div({ className: "CalendarHeader" }, dd.div({ className: "row" }, dd.div({ className: "col-xs-5" }, AuthedUserSession.is_st_family && view_mode === "TreeSearch" ? null : SelectSpeakerForm({
	        Displaylists: Displaylists,
	        filter_to_sid: filter_to_sid,
	        setSIDFilter: setSIDFilter,
	        empire_mode: empire_mode
	      }), AuthedUserSession.is_st_family && view_mode === "TreeSearch" ? null : excludeOtherCompaniesForm({
	        Displaylists: Displaylists,
	        view_mode: view_mode,
	        toggleIncludeOtherCompanies: toggleIncludeOtherCompanies,
	        include_other_companies: include_other_companies,
	        empire_mode: empire_mode,
	        toggleEmpireMode: toggleEmpireMode,
	        waiting_for_displaylists: waiting_for_displaylists
	      })), dd.div({ className: "col-xs-7 text-right" }, MonthYearToggle({ view_mode: view_mode }))));
	    }
	    return dd.div({ className: "CalendarHeader" }, dd.div({ className: "larger-screen" }, FullLayout({ horizontal: true }, [{
	      width: 300,
	      body: dd.div({ style: { padding: "10px 0 10px 10px" } }, SelectSpeakerForm({
	        Displaylists: Displaylists,
	        filter_to_sid: filter_to_sid,
	        setSIDFilter: setSIDFilter,
	        empire_mode: empire_mode
	      }), excludeOtherCompaniesForm({
	        Displaylists: Displaylists,
	        view_mode: view_mode,
	        toggleIncludeOtherCompanies: toggleIncludeOtherCompanies,
	        include_other_companies: include_other_companies,
	        toggleEmpireMode: toggleEmpireMode,
	        empire_mode: empire_mode
	      }))
	    }, {
	      body: dd.div({ className: "text-center", style: { padding: "10px 0 0 0" } }, MonthYearToggle({ view_mode: view_mode }))
	    }, {
	      width: AuthedUserSession.is_st_family ? 10 : 200,
	      body: dd.div({ style: { padding: "10px 10px 10px 0" } }, SearchForm({
	        mini_form: true,
	        default_filter_to_sid: filter_to_sid
	      }))
	    }])), dd.div({ className: "smaller-screen row", style: { marginTop: 7 } }, dd.div({ className: "col-xs-6" }, SelectSpeakerForm({
	      Displaylists: Displaylists,
	      filter_to_sid: filter_to_sid,
	      setSIDFilter: setSIDFilter,
	      empire_mode: empire_mode
	    }), excludeOtherCompaniesForm({
	      Displaylists: Displaylists,
	      toggleIncludeOtherCompanies: toggleIncludeOtherCompanies,
	      include_other_companies: include_other_companies,
	      toggleEmpireMode: toggleEmpireMode,
	      empire_mode: empire_mode
	    })), dd.div({ className: "col-xs-6" }, MonthYearToggle({ view_mode: view_mode, show_search_btn: true }))));
	  }
	});
	
	var Main = dd.createClass({
	  mixins: [RadioServiceMixin],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      Dashboard_get: {
	        key: function key() {
	          return 1;
	        }
	      },
	      Calendar_get: {
	        key: function key() {
	          return this.props.year;
	        }
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    radio("Calendar_get").broadcast({
	      year: _.get(this.props, "year"),
	      include_other_companies: _.get(this.props, "include_other_companies", false),
	      empire_mode: _.get(this.props, "empire_mode", false)
	    });
	    radio("Dashboard_get").broadcast();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(next_props) {
	    if (this.props.year !== next_props.year) {
	      radio("Calendar_get").broadcast({ year: next_props.year });
	    }
	  },
	  __onScroll: function __onScroll() {
	    radio("MiniCalendar_close_all_popovers").broadcast();
	  },
	  __clearCalendarData: function __clearCalendarData() {
	    this.setState({
	      Calendar_get: { data: {}, waiting: true }
	    });
	  },
	  render: function render() {
	    var _props4 = this.props,
	        year = _props4.year,
	        month = _props4.month,
	        view_mode = _props4.view_mode,
	        Displaylists = _props4.Displaylists,
	        filter_to_sid = _props4.filter_to_sid,
	        setSIDFilter = _props4.setSIDFilter,
	        toggleIncludeOtherCompanies = _props4.toggleIncludeOtherCompanies,
	        include_other_companies = _props4.include_other_companies,
	        toggleEmpireMode = _props4.toggleEmpireMode,
	        empire_mode = _props4.empire_mode,
	        waiting_for_displaylists = _props4.waiting_for_displaylists;
	    var _state = this.state,
	        Dashboard_get = _state.Dashboard_get,
	        Calendar_get = _state.Calendar_get;
	
	
	    var Calendars = _.get(Calendar_get, "data", {});
	    if (filter_to_sid > 0) {
	      Calendars = filterCalendarsToSID(Calendars, filter_to_sid);
	    }
	    if (AuthedUserSession.is_st_family) {
	      //TEAM ADMIN
	      Calendars = filterCalendarsToCompanies(Calendars, include_other_companies, empire_mode);
	    }
	    Calendars = filterCalendarDecoratorsToSID(Calendars, filter_to_sid);
	
	    var is_loading = false;
	    // Load all the views and hide the inactive ones.  this way we don't mount/unmount the views and lose our data
	    var body = dd.div({}, _.map(calendar_area_views, function (view, key) {
	      return dd.div({
	        key: key,
	        id: key,
	        style: { display: key === view_mode ? "block" : "none" }
	      }, view.cmpt({
	        Displaylists: Displaylists,
	        filter_to_sid: filter_to_sid,
	        year: year,
	        month: month,
	        Calendars: Calendars,
	        Dashboarddata: Dashboard_get.data,
	        include_other_companies: include_other_companies,
	        empire_mode: empire_mode
	      }));
	    }));
	    if (view_mode === "year" || view_mode === "month") {
	      is_loading = false;
	    } else if (view_mode === "Dashboard") {
	      is_loading = !!Dashboard_get.waiting;
	    }
	    return dd.div({ id: "calendar_area", className: "relative" }, FullLayout({ vertical: true }, [{
	      height: 75,
	      body: CalendarHeader({
	        Displaylists: Displaylists,
	        view_mode: view_mode,
	        filter_to_sid: filter_to_sid,
	        setSIDFilter: setSIDFilter,
	        include_other_companies: include_other_companies,
	        empire_mode: empire_mode,
	        toggleIncludeOtherCompanies: toggleIncludeOtherCompanies,
	        toggleEmpireMode: toggleEmpireMode,
	        waiting_for_displaylists: waiting_for_displaylists
	      })
	    }, {
	      body: LoadingWrap({ is_loading: _.isEmpty(Displaylists) || is_loading, glass: true }, VerticalScroll({ onScroll: this.__onScroll }, ErrorAlert({ message: Calendar_get.error }), ErrorAlert({ message: Dashboard_get.error }), body, dd.div({ className: "clearfix" })))
	    }]), EventSearchAside ? EventSearchAside({ Displaylists: Displaylists }) : null);
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    var today = new Date();
	
	    var empire_mode_initially = false;
	    var view_mode = "Dashboard";
	
	    if (AuthedUserSession.is_st_family && Constants.ST_USERTYPE_SUPER_ADMIN === AuthedUserSession.st_usertype) {
	      if (window.location.hash.includes("empire_mode")) {
	        empire_mode_initially = true;
	        view_mode = "year";
	      }
	    }
	
	    return {
	      year: today.getFullYear(),
	      month: today.getMonth() + 1,
	      view_mode: view_mode,
	      filter_to_sid: AuthedUserSession.getLastSelectedSID(),
	      include_other_companies: false,
	      empire_mode: empire_mode_initially,
	      waiting_for_displaylists: true
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      Show_Calendar: function Show_Calendar(type_shown, d) {
	        if (!_.isEmpty(type_shown)) {
	          this.setState({ view_mode: type_shown });
	        }
	        if (_.isDate(d)) {
	          this.setState({ month: d.getMonth() + 1, year: d.getFullYear() });
	        }
	      },
	      Calendar_setSID: function Calendar_setSID(sid) {
	        if (sid > 0) {
	          this.__setSIDFilter(sid);
	        }
	      },
	      Displaylists_get_succeeded: function Displaylists_get_succeeded(key, Displaylists) {
	        var sids = esUtils.cleanup_ids(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	        if (_.size(sids) === 1) {
	          this.__setSIDFilter(_.first(sids));
	        }
	        var preferences = _.get(Displaylists, "user.myevents_preferences", {});
	        this.setState({
	          include_other_companies: _.get(preferences, "show_other_companies_by_default", false),
	          waiting_for_displaylists: false
	        });
	        // if (_.get(preferences, "show_other_companies_by_default", false)) {
	        //   this.__toggleIncludeOtherCompanies();
	        // }
	      },
	      EventSearchAside_search: function EventSearchAside_search(query) {
	        if (calendar_area_views.TreeSearch && "TreeSearch" !== this.state.view_mode) {
	          this.setState({ view_mode: "TreeSearch" }, function () {
	            //re-broadcast once the view is mounted
	            radio("EventSearchAside_search").broadcast(query);
	          });
	        }
	      },
	      EventSearchAside_open: function EventSearchAside_open() {
	        if (calendar_area_views.TreeSearch && "TreeSearch" !== this.state.view_mode) {
	          this.setState({ view_mode: "TreeSearch" });
	        }
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    radio("Displaylists_get").broadcast();
	  },
	  __setSIDFilter: function __setSIDFilter(sid) {
	    sid = _.isNumber(sid) && !_.isNaN(sid) && sid > 0 ? sid : 0;
	    this.setState({ filter_to_sid: sid });
	    AuthedUserSession.setLastSelectedSID(sid);
	  },
	  __toggleIncludeOtherCompanies: function __toggleIncludeOtherCompanies() {
	    this.setState({
	      include_other_companies: !_.get(this.state, "include_other_companies", false),
	      empire_mode: false
	    });
	    radio("Show_Calendar").broadcast();
	  },
	  __toggleEmpireMode: function __toggleEmpireMode() {
	    this.setState({
	      empire_mode: !_.get(this.state, "empire_mode", false),
	      include_other_companies: false
	    });
	    radio("Show_Calendar").broadcast();
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	    var _state2 = this.state,
	        year = _state2.year,
	        month = _state2.month,
	        view_mode = _state2.view_mode,
	        filter_to_sid = _state2.filter_to_sid,
	        include_other_companies = _state2.include_other_companies,
	        empire_mode = _state2.empire_mode,
	        waiting_for_displaylists = _state2.waiting_for_displaylists;
	
	    return Main({
	      year: year,
	      month: month,
	      view_mode: view_mode,
	      Displaylists: Displaylists,
	      filter_to_sid: filter_to_sid,
	      include_other_companies: include_other_companies,
	      empire_mode: empire_mode,
	      waiting_for_displaylists: waiting_for_displaylists,
	      setSIDFilter: this.__setSIDFilter,
	      toggleIncludeOtherCompanies: this.__toggleIncludeOtherCompanies,
	      toggleEmpireMode: this.__toggleEmpireMode
	    });
	  }
	});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var DateRange = __webpack_require__(65);
	var esStatusImage = __webpack_require__(54);
	var AuthedUserSession = __webpack_require__(4);
	var Constants = __webpack_require__(13);
	var esUtils = __webpack_require__(2);
	
	/**
	 * Open an external window
	 * @param opentocontact_url
	 * @param crmkind
	 * @returns {*}
	 * @private
	 */
	var __onClickExternalCRM = function __onClickExternalCRM(opento_url, crmkind) {
	  return esUtils.wrapPreventDefault(function () {
	    var CRMWindowName = _.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind.toUpperCase(), "browser_window_name"], "genericcrm");
	    window.open(opento_url, CRMWindowName); //, CRMWindowName, "height=700,width=1024").focus();
	  });
	};
	
	/**
	 * Given an external CRM id (like "KARMACRM:12345"), figure out if we should
	 * offer a link to that lead in the external app.
	 *
	 * This depends on /authenticate/getdisplaylists sending over data in the perspeaker.xxx.crm_sso key
	 * with a value for lead_url that looks like "https://app.hubspot.com/contacts/6224665/contact/{id}/"
	 * where {id} will be replaced with the lead ID.
	 *
	 * @param event
	 * @param crm_sso
	 * @returns {{crmkind: null, opento_url: null}}
	 * @private
	 */
	var __computeExternalCRMLink = function __computeExternalCRMLink(event, crm_sso) {
	  //possibly link to external CRM (contact.externalid = "KARMACRM:12345", for example)
	  var opento_url = null;
	  var crmkind = null;
	
	  var externalid = _.get(event, "foreignKey", "");
	  externalid = "string" === typeof externalid ? externalid.split(":") : [];
	  if (2 === externalid.length) {
	    //we have an id for an external in the form of KARMACRM:123456
	    crmkind = externalid[0];
	    if (!_.isEmpty(_.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind]))) {
	      opento_url = _.get(_.find(crm_sso, { kind: crmkind }), "lead_url");
	      if (!_.isEmpty(opento_url)) {
	        opento_url = opento_url.replace("{id}", externalid[1]);
	      }
	    }
	  }
	  return { opento_url: opento_url, crmkind: crmkind };
	};
	
	module.exports = dd.createClass({
	  __changeActiveCompany: function __changeActiveCompany(company_id) {
	    AuthedUserSession.setLastSelectedCompany(company_id);
	    window.location.reload();
	  },
	  __onCopy: esUtils.wrapPreventDefault(function (e) {
	    var textArea = document.createElement("textarea");
	    textArea.value = this.props.event.eid;
	    document.body.appendChild(textArea);
	    textArea.select();
	    document.execCommand("Copy");
	    textArea.remove();
	
	    this.setState({ copySuccess: true });
	  }),
	  render: function render() {
	    var _this = this;
	
	    var event = this.props.event,
	        Displaylists = this.props.Displaylists,
	        custom_status_text = this.props.custom_status_text,
	        my_speaker_names_by_sid = void 0,
	        speaker_names = void 0,
	        event_time = null,
	        event_venue = null;
	
	    if (!event || event.eid < 1) {
	      return dd.div();
	    }
	
	    my_speaker_names_by_sid = _.object(_.map(Displaylists.perspeaker, function (speaker) {
	      return [speaker.sid, speaker.name_full];
	    }));
	    speaker_names = _.map(event.sids, function (sid) {
	      return my_speaker_names_by_sid[sid];
	    }).join(", ");
	
	    if (event.starttime || event.stoptime) {
	      event_time = DateRange({
	        start: event.starttime,
	        start_format: "dddd, mmmm d, yyyy",
	        stop: event.stoptime
	      });
	    } else {
	      event_time = dd.div({}, dd.span({ className: "DateRange fa-calendar fa" }), " (no stagetimes)");
	    }
	    if (event.deliveryMethod === Constants.DELIVERY_METHOD_INTEGERS.ONSITE) {
	      event_venue = dd.div({}, dd.span({ className: "fa fa-map-marker venue" }), _.uniq(_.map(event.Stagetime, function (v) {
	        return _.get(_.find(event.Venue, { id: v.venueid.toString() }), "st", "...");
	      })).join(", "));
	    } else if (event.deliveryMethod === Constants.DELIVERY_METHOD_INTEGERS.VIRTUAL) {
	      event_venue = dd.div({}, dd.span({ className: "fa fa-video-camera venue" }), dd.a({ href: event.zoomUrl }, "Launch Video Conference"));
	    } else {
	      event_venue = dd.div({}, dd.span({ className: "fa fa-map-marker venue" }), _.map(_.filter(_.get(Displaylists, "universal.deliverymethods", {}), function (dm) {
	        return _.get(dm, "id") == _.get(event, "deliveryMethod");
	      }), "description").join(", "));
	    }
	
	    var status_text = _.isString(custom_status_text) ? custom_status_text : event.status;
	
	    var isOtherCompany = !_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(_.get(event, ["companyID"])));
	
	    var crmlink = _.get(Displaylists, ["perspeaker"]);
	    crmlink = _.find(crmlink, { sid: event.sids[0] });
	    crmlink = _.get(crmlink, "crm_sso", []);
	
	    var _computeExternalCRML = __computeExternalCRMLink(event, crmlink),
	        opento_url = _computeExternalCRML.opento_url,
	        crmkind = _computeExternalCRML.crmkind; //trouble if multiple speakers on event, but that's rare
	
	    var status_eval_icon = "img/light-null.png";
	    if (_.get(event, ["Evaluation", "not_evaluated"], true)) {
	      status_eval_icon = "img/light-not.png";
	    } else {
	      if (parseFloat(_.get(event, ["Evaluation", "score"])) >= 4.2) {
	        status_eval_icon = "img/light-green.png";
	      } else if (parseFloat(_.get(event, ["Evaluation", "score"])) >= 3.8) {
	        status_eval_icon = "img/light-yellow.png";
	      } else if (parseFloat(_.get(event, ["Evaluation", "score"])) > 0) {
	        status_eval_icon = "img/light-red.png";
	      }
	    }
	
	    return dd.div({
	      className: event.status + " EventHeader well well-sm" + (_.isEmpty(event.sids) ? " job" : "")
	    }, dd.div({ className: "pull-left", style: { marginRight: 10 } }, esStatusImage({
	      status: event.status,
	      delivery_method: event.deliveryMethod,
	      has_parent: event.parentID > 0,
	      has_children: !_.isEmpty(event.childevents),
	      closed: (_.get(event, "flags", 0) & 4) > 0
	    })), dd.div(null, dd.h4({ className: "status" }, status_text, dd.img({
	      className: "pull-right",
	      src: status_eval_icon,
	      style: { marginLeft: "0.5rem", width: "18px", height: "18px" }
	    })), isOtherCompany ? dd.h4(null, "[" + _.get(_.indexBy(_.get(Displaylists, ["universal", "company"]), "id"), [_.get(event, ["companyID"]), "abbr"], "other company").toUpperCase() + "] event") : dd.h4(null, event.organization), dd.div({ className: "event-details" }, dd.span({ className: "pull-right" }, speaker_names, _.isEmpty(speaker_names) ? null : " ", dd.a({
	      onClick: this.__onCopy,
	      style: {
	        marginRight: "0.5rem",
	        marginLeft: "0.5rem",
	        color: _.get(this.state, "copySuccess", false) ? "green" : "#428BCA"
	      }
	    }, dd.i({ className: "fa fa-clipboard" })), event.eid, _.get(event, "accountinglocked") ? dd.div({ className: "text-right" }, dd.i({ className: "fa fa-lock" }), " Accounting locked") : null, opento_url ? dd.div({ className: "text-right" }, dd.a({
	      href: opento_url,
	      onClick: __onClickExternalCRM(opento_url, crmkind)
	    }, "CRM ", dd.i({
	      className: "fa fa-external-link",
	      style: { marginLeft: "0.25rem" }
	    }))) : null, _.isEmpty(opento_url) && !_.isEmpty(_.get(event, "foreignKey")) ? dd.div({ className: "text-right" }, dd.i({ className: "fa fa-link" }), " CRM") : null), event_time, " ", event_venue), isOtherCompany ? dd.div({
	      className: "text-danger text-center",
	      style: { marginTop: 10 }
	    }, "To view this event, ", dd.span({
	      className: "text-primary",
	      onClick: function onClick() {
	        return _this.__changeActiveCompany(_.get(event, ["companyID"]));
	      },
	      style: { cursor: "pointer", textDecoration: "underline" }
	    }, " change your active company  to " + _.get(_.indexBy(_.get(Displaylists, ["universal", "company"]), "id"), [_.get(event, ["companyID"]), "name"], "match this event").toUpperCase() + ".")) : null, AuthedUserSession.doIHaveAccess.read.all(event.sids) ? dd.div({
	      className: "text-danger text-center",
	      style: { marginTop: 10 }
	    }, "You are in READ ONLY mode and cannot save changes.") : null));
	  }
	});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var TabSet = __webpack_require__(68);
	var esUtils = __webpack_require__(2);
	var AuthedUserSession = __webpack_require__(4);
	
	//NOTE
	//NOTE these keys on this are used in urls so don't casually RENAME them
	//NOTE
	var tabs = {};
	tabs.marketplace = {
	  name: "Job",
	  render: __webpack_require__(311)
	};
	tabs.details = {
	  name: "Details",
	  render: __webpack_require__(304)
	};
	tabs.contacts = {
	  name: "Contacts",
	  render: __webpack_require__(284)
	};
	tabs.services = {
	  name: "Services",
	  render: __webpack_require__(325)
	};
	if (AuthedUserSession.is_st_family) {
	  tabs.evals = {
	    name: "Feedback",
	    render: __webpack_require__(306)
	  };
	}
	tabs.action_list = {
	  name: "Action List",
	  render: __webpack_require__(269)
	};
	tabs.custom = {
	  name: "Custom",
	  render: __webpack_require__(286)
	};
	tabs.library = {
	  name: "Library",
	  render: __webpack_require__(310)
	};
	tabs.misc = {
	  name: "Misc",
	  render: __webpack_require__(316)
	};
	
	if (!AuthedUserSession.is_st_family) {
	  tabs.travel = {
	    name: "Travel",
	    render: __webpack_require__(332)
	  };
	}
	
	if (AuthedUserSession.is_st_family) {
	  tabs.coaching = {
	    name: "Coaching",
	    render: __webpack_require__(275)
	  };
	}
	
	/**
	 * Based on the build and the user access level for the event, choose which tabs to display.
	 * @param event
	 * @returns {*}
	 */
	var determineTabNamesToDisplay = function determineTabNamesToDisplay(event) {
	  //console.log("determineTabNamesToDisplay", AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.is_cs, AuthedUserSession.is_privatelabel, AuthedUserSession.privatelabel_code, event.sids);
	  if (AuthedUserSession.doIHaveAccess.travel.all(event.sids)) {
	    return ["details", "travel"];
	  }
	
	  var tab_names = _.keys(tabs);
	
	  if (!event.is_mp_event) {
	    tab_names = _.without(tab_names, "marketplace");
	  }
	
	  if (!AuthedUserSession.doIHaveAccess.full.any(event.sids) && !AuthedUserSession.doIHaveAccess.read.any(event.sids) && !AuthedUserSession.doIHaveAccess.admin.any(event.sids)) {
	    //console.log("determineTabNamesToDisplay", "restricting [services, library]", event.sids, AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.doIHaveAccess.read.any(event.sids), AuthedUserSession.doIHaveAccess.admin.any(event.sids));
	    tab_names = _.without(tab_names, "services", "library", "evals");
	  }
	
	  if (AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids)
	  // && !AuthedUserSession.is_cs
	  ) {
	      //console.log("determineTabNamesToDisplay", "restricting [action_list, custom]", event.sids, AuthedUserSession.doIHaveAccess.full.any(event.sids), AuthedUserSession.doIHaveAccess.read.any(event.sids), AuthedUserSession.doIHaveAccess.admin.any(event.sids));
	      tab_names = _.without(tab_names, "action_list");
	    }
	
	  if (AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids) && AuthedUserSession.is_cs) {
	    tab_names = _.without(tab_names, "misc");
	  }
	
	  if (!esUtils.getIn(event, ["flags_as_map", "coaching", "is_set"])) {
	    tab_names = _.without(tab_names, "coaching");
	  }
	  if (!_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(_.get(event, ["companyID"])))) {
	    return [];
	  }
	  return tab_names;
	};
	
	module.exports = dd.createClass({
	  render: function render() {
	    var event = this.props.event;
	
	    if (!event || event.eid < 1) {
	      return dd.div();
	    }
	
	    return dd.div({ className: "EventTabs" }, TabSet({
	      tabs: _.object(_.map(determineTabNamesToDisplay(event), function (name) {
	        return [name, _.assign({
	          url: "#/events/" + event.eid + "/" + name
	        }, tabs[name])];
	      })),
	      render_props: this.props,
	      selected_tab: this.props.selected_tab
	    }), AuthedUserSession.is_privatelabel ? dd.p({ className: "text-center text-muted" }, "powered by eSpeakers") : null);
	  }
	});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	/*global sessionStorage */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var VenueForm = __webpack_require__(131);
	var FormUtils = __webpack_require__(9);
	var dateformat = __webpack_require__(41);
	var LoadingWrap = __webpack_require__(8);
	var esStatusImage = __webpack_require__(54);
	var RadioServiceMixin = __webpack_require__(14);
	var ezHorizontalFields = __webpack_require__(25);
	var AuthedUserSession = __webpack_require__(4);
	var getActionListDropDownOptions = __webpack_require__(94);
	
	var buildGeneralDetailsFields = function buildGeneralDetailsFields(Displaylists, data, canOnlyCreatePersonalEvent) {
	  var fields = {};
	  var has_pro = _.includes(AuthedUserSession.getSIDsAtPackageLevel("PRO"), esUtils.toInt(data.speaker));
	
	  if (_.isEmpty(Displaylists)) {
	    return {};
	  }
	  var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
	  if (_.size(my_speakers) > 1) {
	    fields.speaker = {
	      label: "Speaker",
	      type: "select",
	      options: my_speakers
	    };
	  }
	
	  var actionlist_options = getActionListDropDownOptions(Displaylists, data.speaker, _.get(AuthedUserSession, "activeCompany.COMPANY_ID", 2));
	  if (actionlist_options) {
	    fields.todolists = {
	      label: "Action List",
	      type: "select",
	      placeholder: "-- select actionlist --",
	      options: actionlist_options,
	      dont_sort_options: false,
	      validate: AuthedUserSession.is_privatelabel && !canOnlyCreatePersonalEvent ? FormUtils.v.required : FormUtils.v.optional
	    };
	  }
	
	  fields.organization = {
	    label: "Presenting to",
	    placeholder: "Presenting to",
	    validate: FormUtils.v.required,
	    type: "text"
	  };
	
	  fields.status = {
	    label: "Status",
	    type: "select",
	    options: _.object(_.map(_.get(Displaylists, ["universal", "eventstatuses"]), function (status) {
	      return [status.description, status.description];
	    })),
	    dont_sort_options: true,
	    read_only: AuthedUserSession.is_privatelabel && canOnlyCreatePersonalEvent,
	    validate: function validate(s) {
	      if (!AuthedUserSession.is_st_family && s == "lead" && !has_pro) {
	        return "Only PRO users can have '" + s + "' events";
	      }
	      return true;
	    }
	  };
	  fields.personal = {
	    label: "Personal/Blackout",
	    type: "checkbox",
	    read_only: canOnlyCreatePersonalEvent
	  };
	
	  if (AuthedUserSession.is_st_family) {
	    fields.pd_rep = {
	      label: "PD Rep",
	      type: "select",
	      placeholder: "none -- direct",
	      validate: FormUtils.v.optional,
	      options: _.object(_.map(_.get(Displaylists, ["sitelists", "pd_reps"]), function (user) {
	        return [user.id, user.fullname];
	      }))
	    };
	    fields.sales_rep = {
	      label: "Sales Rep",
	      type: "select",
	      placeholder: "none -- direct",
	      validate: FormUtils.v.optional,
	      options: _.object(_.map(_.get(Displaylists, ["sitelists", "sales_reps"]), function (user) {
	        return [user.id, user.fullname];
	      }))
	    };
	    fields.project_manager = {
	      label: "Project Manager",
	      type: "select",
	      placeholder: "none -- direct",
	      validate: FormUtils.v.optional,
	      options: _.object(_.map(_.get(Displaylists, ["sitelists", "project_managers"]), function (user) {
	        return [user.id, user.fullname];
	      }))
	    };
	  } else {
	    fields.bureauID = {
	      label: "Bureau",
	      type: "select",
	      placeholder: "none -- direct",
	      validate: FormUtils.v.optional,
	      options: _.object(_.map(_.get(Displaylists, ["universal", "bureaus"]), function (bureau) {
	        return [bureau.bid, bureau.bname];
	      }))
	    };
	    fields.bureauNotes = {
	      label: "Bureau Notes",
	      type: "text",
	      placeholder: "Bureau Notes"
	    };
	  }
	  fields.has_date = {
	    label: "(unselect for DATELESS events)",
	    type: "checkbox"
	  };
	  return fields;
	};
	
	var buildStagetimeFields = function buildStagetimeFields(Displaylists, data) {
	  return {
	    description: {
	      label: "Description",
	      type: "text",
	      placeholder: "Description",
	      validate: FormUtils.v.optional
	    },
	    starttime: {
	      label: "Start",
	      type: "date",
	      placeholder: "Start date and time",
	      validate: FormUtils.v.required,
	      pick_time: true
	    },
	    stoptime: {
	      label: "End",
	      type: "date",
	      placeholder: "End date and time",
	      validate: FormUtils.v.required,
	      pick_time: true,
	      valid_range: {
	        start: data.starttime
	      }
	    },
	    avchecktime: {
	      label: "A/V check",
	      type: "date",
	      placeholder: "A/V check date and time",
	      pick_time: true,
	      valid_range: {
	        stop: data.starttime
	      },
	      validate: FormUtils.v.optional
	    },
	    room: {
	      label: "Room",
	      type: "text",
	      placeholder: "Room",
	      validate: FormUtils.v.optional
	    }
	  };
	};
	
	var NewForm = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	    var url_date = props.url_date;
	    return _.isDate(url_date) ? esUtils.format_date(url_date, "yyyy-dd-mm") : null;
	  },
	  getInitialValues: function getInitialValues(props) {
	    var Displaylists = props.Displaylists;
	    var lastSelectedSID = AuthedUserSession.getLastSelectedSID();
	    var sid = lastSelectedSID || _.first(_.map(_.get(Displaylists, "perspeaker"), "sid"));
	    var canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(sid); //as for speaker users on a privatelabel who can only create blackout events
	
	    var data = {
	      speaker: sid + "",
	      has_date: true,
	      todolists: sid + "|0",
	      status: AuthedUserSession.is_st ? canOnlyCreatePersonalEvent ? "confirmed" : "lead" : "held", //CS SPKR-users create as HELD, ST SPKR-users create as CONFIRMED
	      country: "US",
	      personal: canOnlyCreatePersonalEvent
	    };
	    if (_.isDate(props.url_date)) {
	      data.starttime = props.url_date;
	      data.stoptime = props.url_date;
	    }
	
	    if (AuthedUserSession.is_privatelabel) {
	      //TEAM-ADMIN privatelabels using only common actionlists
	      data.todolists = null;
	    }
	
	    // set default values if we have them available from the mother event
	    if (this.props.has_parent && sessionStorage.getItem("parent_organization")) {
	      data.organization = sessionStorage.getItem("parent_organization");
	      data.status = sessionStorage.getItem("parent_status");
	      data.pd_rep = sessionStorage.getItem("parent_pd_rep_id");
	      data.sales_rep = sessionStorage.getItem("parent_sales_rep_id");
	      data.project_manager = sessionStorage.getItem("parent_project_manager_id");
	      data.bureauID = sessionStorage.getItem("parent_bureauID");
	      data.bureauNotes = sessionStorage.getItem("parent_bureauNotes");
	      var parent_sid = JSON.parse(sessionStorage.getItem("parent_sids"))[0];
	      if (parent_sid > 0) {
	        data.speaker = parent_sid;
	      }
	      var venue = JSON.parse(sessionStorage.getItem("parent_Venue"))[0];
	      _.each(venue, function (value, key) {
	        data[key] = value;
	      });
	    }
	
	    return data;
	  },
	  buildSchema: function buildSchema(props) {
	    var Displaylists = (props || this.props).Displaylists;
	    var data = _.get(this, "state.data", {});
	    var canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(data.speaker); //as for speaker users on a privatelabel who can only create blackout events
	    var detail_fields = buildGeneralDetailsFields(Displaylists, data, canOnlyCreatePersonalEvent);
	    var stagetime_fields = !data.has_date ? null : buildStagetimeFields(Displaylists, data);
	    var venue_fields = VenueForm.buildFields(Displaylists, data);
	    return _.assign(detail_fields, stagetime_fields, venue_fields);
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    var self = this;
	    var data = this.state && this.state.data || {};
	    if (field_path === "starttime" && _.isDate(new_value)) {
	      this.setState({ data: data }, function () {
	        if (!_.isDate(data.stoptime) || data.stoptime.getTime() < new_value.getTime()) {
	          self.Form_onChange("stoptime", _.cloneDeep(new_value));
	        }
	      });
	    }
	  },
	  render: function render() {
	    var self = this;
	    var fields = this.Form_buildSchema();
	    var data = this.state.data || {};
	    var onCancel = this.props.onCancel;
	
	
	    var canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(data.speaker); //as for speaker users on a privatelabel who can only create blackout events
	    // let errorMessage = _.reduce(_.get(this.state, "errors", {}), function (result, v, k) {
	    //   (result || (result = [])).push(v + " on " + k.toUpperCase()+".");
	    //   return result;
	    // }, []);
	    // errorMessage = errorMessage.join(" ");
	    var errorMessage = !_.isEmpty(_.get(this.state, "errors")) ? "Fix errors above to continue." : null;
	    var renderFieldLayout = function renderFieldLayout(layout) {
	      return ezHorizontalFields(self, _.filter(layout, function (row) {
	        return _.size(row) === 1 ? _.has(fields, row[0]) : true;
	      }), "sm", 2);
	    };
	
	    var middlesection = AuthedUserSession.is_st_family ? renderFieldLayout([["pd_rep"], ["sales_rep"], ["project_manager"]]) : renderFieldLayout([["bureauID"], ["bureauNotes"]]);
	    if (AuthedUserSession.is_privatelabel && canOnlyCreatePersonalEvent) {
	      middlesection = null;
	    }
	
	    return dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, dd.h4({ className: "section-head" }, "Event Details"), renderFieldLayout([["speaker"], !AuthedUserSession.is_privatelabel || !canOnlyCreatePersonalEvent ? ["todolists"] : null, ["organization"], ["status", "personal"]]), middlesection, renderFieldLayout([["has_date"]]), !data.has_date ? null : dd.h4({ className: "section-head" }, "Stagetime"), !data.has_date ? null : renderFieldLayout([["description"], ["starttime"], ["stoptime"], ["avchecktime"], ["room"]]), dd.h4({ className: "section-head" }, "Venue"), renderFieldLayout(VenueForm.horizontal_fields_layout), dd.div({ className: "form-group text-center", style: { marginTop: 30 } }, !_.isEmpty(errorMessage) && dd.div({
	      className: "has-error",
	      style: { marginRight: "2rem", marginLeft: "2rem" }
	    }, dd.p({ className: "help-block" }, errorMessage)), dd.button({ type: "submit", className: "btn btn-primary btn-lg" }, "Create Event"), " ", dd.button({ className: "btn btn-default btn-lg", onClick: onCancel }, "Cancel")));
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      Event_my_events_on_date: {
	        key: "callService",
	        on: {
	          succeeded: function succeeded(data) {
	            if (_.size(data) === 0) {
	              this.__saveTheEvent();
	            }
	          },
	          failed: function failed(error) {
	            //ignore this error b/c it's not a big deal
	            this.__saveTheEvent();
	          }
	        }
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { event_to_save: null, date_to_check_first: null };
	  },
	
	  __saveTheEvent: esUtils.wrapPreventDefault(function () {
	    radio("save_Event").broadcast(this.state.event_to_save);
	    this.setState({
	      event_to_save: null,
	      date_to_check_first: null,
	      Event_my_events_on_date: {}
	    });
	  }),
	  __dontSaveTheEvent: esUtils.wrapPreventDefault(function () {
	    this.setState({
	      event_to_save: null,
	      date_to_check_first: null,
	      Event_my_events_on_date: {}
	    });
	  }),
	  __onSubmit: function __onSubmit(data) {
	    var event = {
	      eid: 0,
	      sids: [esUtils.toInt(data.speaker)],
	      parentID: Math.max(0, esUtils.toInt(this.__parseUrlParams().parent_id)),
	      organization: data.organization,
	      status: data.status,
	      isPersonal: !!data.personal,
	      pd_rep_id: esUtils.toInt(_.get(data, ["pd_rep"], 0)),
	      sales_rep_id: esUtils.toInt(_.get(data, ["sales_rep"], 0)),
	      project_manager_id: esUtils.toInt(_.get(data, ["project_manager"], 0)),
	      bureauID: esUtils.toInt(_.get(data, ["bureauID"], 0)),
	      bureauNotes: _.get(data, ["bureauNotes"], 0),
	      companyID: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]),
	      todolistids: []
	    };
	    if (!esUtils.isBlank(data.todolists)) {
	      event.todolistids = [_.parseInt(data.todolists)]; //must be integers
	    }
	    if (event.sids[0] > 0) {
	      AuthedUserSession.setLastSelectedSID(event.sids[0]);
	    }
	
	    if (data.has_date) {
	      event.Stagetime = [{
	        id: 0,
	        description: data.description,
	        starttime: data.starttime,
	        stoptime: data.stoptime,
	        avchecktime: data.avchecktime,
	        room: data.room
	      }];
	    }
	    event.Venue = [{
	      id: 0,
	      address: data.address,
	      building: data.building,
	      city: data.city,
	      country: data.country,
	      fax: data.fax,
	      phone: data.phone,
	      st: data.st,
	      timezone: data.timezone,
	      zip: data.zip
	    }];
	    var self = this;
	    this.setState({
	      event_to_save: event,
	      date_to_check_first: data.has_date && _.isDate(data.starttime) ? data.starttime : null
	    }, function () {
	      if (_.isDate(self.state.date_to_check_first)) {
	        this.RadioService_callService("Event_my_events_on_date", {
	          "yyyy-mm-dd": dateformat(self.state.date_to_check_first, "yyyy-mm-dd"),
	          speaker_ids: self.state.event_to_save.sids
	        });
	      } else {
	        this.__saveTheEvent();
	      }
	    });
	  },
	  __openEvent: function __openEvent(event_id) {
	    return esUtils.wrapPreventDefault(function () {
	      radio("Hashbang_set").broadcast("/events/" + event_id);
	    });
	  },
	
	  __cancel: esUtils.wrapPreventDefault(function () {
	    radio("Hashbang_set").broadcast("");
	  }),
	  __parseUrlParams: function __parseUrlParams() {
	    var url_params = this.props.url_params;
	
	    var r = {
	      date: null,
	      parent_id: 0
	    };
	    if (/^\s*[0-9]+\-[0-9]+\-[0-9]+\s*$/.test(url_params[0])) {
	      var _url_params$0$split = url_params[0].split("-"),
	          _url_params$0$split2 = _slicedToArray(_url_params$0$split, 3),
	          y = _url_params$0$split2[0],
	          m = _url_params$0$split2[1],
	          d = _url_params$0$split2[2];
	
	      r.date = new Date(esUtils.toInt(y), esUtils.toInt(m) - 1, esUtils.toInt(d));
	    } else if (url_params[0] === "child") {
	      r.parent_id = esUtils.toInt(url_params[1]);
	    }
	    return r;
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    var ajax = this.state.Event_my_events_on_date;
	    var events = ajax.data;
	
	    return dd.div({ className: "NewEventForm panel panel-default", style: { margin: 10 } }, dd.div({ className: "panel-body" }, LoadingWrap({ is_loading: ajax.waiting, glass: true }, dd.h2({ style: { margin: "0 0 15px 0", textAlign: "center" } }, "Creating New Event"), NewForm({
	      Displaylists: Displaylists,
	      url_date: this.__parseUrlParams().date,
	      onSubmit: this.__onSubmit,
	      onCancel: this.__cancel,
	      has_parent: this.__parseUrlParams().parent_id > 0 ? true : false
	    }))), _.size(events) > 0 ? Modal({
	      title: "Are you sure?",
	      onClose: this.__dontSaveTheEvent,
	      buttons: [{
	        name: "Yes",
	        onClick: this.__saveTheEvent,
	        className: "btn btn-default"
	      }, {
	        name: "No",
	        onClick: this.__dontSaveTheEvent,
	        className: "btn btn-default"
	      }]
	    }, dd.p(null, _.size(events) === 1 ? dd.span(null, "There is one event on ") : dd.span(null, "There are ", _.size(events), " events on "), dateformat(this.state.date_to_check_first, "dddd, mmmm d, yyyy"), "."), dd.div({ style: { margin: "1em 0 1em 1em" } }, _.map(events, function (event) {
	      return dd.div({
	        key: event.eid,
	        style: { marginBottom: 10, lineHeight: "28px" },
	        className: "clickable",
	        onClick: this.__openEvent(event.eid)
	      }, dd.div({ className: "pull-left", style: { marginRight: 10 } }, esStatusImage({
	        status: event.eventconfirmed,
	        delivery_method: event.deliverymethod,
	        has_parent: event.parentid > 0,
	        has_children: event.n_children > 0,
	        size: 30
	      })), dd.div(null, event.organization, " ", event.meetingname, " ", event.ispersonal ? "(personal)" : ""), dd.div({ className: "clearfix" }));
	    }, this)), dd.div(null, "Do you still want to create your event on this date?")) : null);
	  }
	});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*global sessionStorage */
	/*global localStorage  */
	/* eslint-disable no-unused-vars */
	
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchAContactService = __webpack_require__(91);
	
	var _SearchAContactService2 = _interopRequireDefault(_SearchAContactService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var dateformat = __webpack_require__(41);
	var LoadingWrap = __webpack_require__(8);
	var esStatusImage = __webpack_require__(54);
	var RadioServiceMixin = __webpack_require__(14);
	var ezHorizontalFields = __webpack_require__(25);
	var AuthedUserSession = __webpack_require__(4);
	var getActionListDropDownOptions = __webpack_require__(94);
	
	
	var buildFields = function buildFields(Displaylists, data, canOnlyCreatePersonalEvent) {
	  var fields = {};
	  var has_pro = _.includes(AuthedUserSession.getSIDsAtPackageLevel("PRO"), esUtils.toInt(data.speaker));
	
	  if (_.isEmpty(Displaylists)) {
	    return {};
	  }
	  var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
	  if (_.size(my_speakers) > 1) {
	    fields.speaker = {
	      label: "Speaker",
	      type: "select",
	      options: my_speakers
	    };
	  }
	
	  fields.organization = {
	    label: "Presenting to",
	    placeholder: "Presenting to",
	    validate: FormUtils.v.required,
	    type: "text"
	  };
	
	  fields.status = {
	    label: "Status",
	    type: "select",
	    options: _.object(_.map(_.get(Displaylists, ["universal", "eventstatuses"], []), function (status) {
	      return [status.description, status.description];
	    })),
	    dont_sort_options: true,
	    read_only: AuthedUserSession.is_st_family && canOnlyCreatePersonalEvent,
	    validate: function validate(s) {
	      if (s == "lead" && !has_pro) {
	        return "Only PRO users can have '" + s + "' events";
	      }
	      return true;
	    }
	  };
	
	  fields.personal = {
	    label: "personal / blackout",
	    type: "checkbox",
	    read_only: canOnlyCreatePersonalEvent
	  };
	
	  fields.deliveryMethod = {
	    type: "select",
	    label: "Event Type",
	    placeholder: "-- select an event type --",
	    options: _.object(_.map(_.get(Displaylists, ["universal", "deliverymethods"], []), function (d) {
	      return [d.id, d.description];
	    }))
	  };
	
	  fields.bureauID = {
	    label: AuthedUserSession.is_st_family ? "PD Rep" : "Bureau",
	    type: "select",
	    placeholder: "none -- direct",
	    validate: FormUtils.v.optional,
	    options: _.object(_.map(_.slice(_.get(Displaylists, ["universal", "bureaus"], []), 0, 1000), function (bureau) {
	      return [bureau.bid, bureau.bname];
	    }))
	  };
	  fields.bureauNotes = {
	    label: AuthedUserSession.is_st_family ? "Sales Rep" : "Bureau Notes",
	    type: "text",
	    placeholder: AuthedUserSession.is_st_family ? "Sally Salesrep" : "..."
	  };
	  fields.no_date = {
	    label: "no date yet (add a stagetime later)",
	    type: "checkbox"
	  };
	
	  fields.contact_name = {
	    label: "Name",
	    placeholder: "Harry Hiredme",
	    validate: FormUtils.v.optional,
	    type: "text"
	  };
	
	  fields.contact_phone = {
	    label: "Phone",
	    placeholder: "(801) 555-1212",
	    validate: FormUtils.v.optional,
	    type: "phone"
	  };
	
	  fields.contact_email = {
	    label: "Email",
	    placeholder: "name@client.com",
	    validate: FormUtils.v.optional,
	    type: "email"
	  };
	
	  fields.contact_remote_id = {
	    type: "hidden"
	  };
	
	  //for personal events, Balboa forces the actionlist=Standard
	  if (!data.personal) {
	    var actionlist_options = getActionListDropDownOptions(Displaylists, data.speaker, _.get(AuthedUserSession, "activeCompany.COMPANY_ID", 0));
	    if (actionlist_options) {
	      fields.todolists = {
	        label: "Action List",
	        type: "select",
	        placeholder: "-- select actionlist --",
	        options: actionlist_options,
	        dont_sort_options: false,
	        validate: FormUtils.v.optional
	      };
	    }
	  }
	
	  if (!data.no_date) {
	    fields.starttime = {
	      label: "Start",
	      type: "date",
	      placeholder: "Start date",
	      validate: FormUtils.v.required,
	      pick_time: false
	    };
	
	    fields.stoptime = {
	      label: "End",
	      type: "date",
	      placeholder: "End date",
	      validate: FormUtils.v.required,
	      pick_time: false,
	      valid_range: {
	        start: data.starttime
	      }
	    };
	
	    fields.add_flights = {
	      label: "add temp flights day before and after (update later)",
	      type: "checkbox",
	      validate: FormUtils.v.optional
	    };
	  }
	
	  return fields;
	};
	
	var NewForm = dd.createClass({
	  mixins: [FormMixin, RadioServiceMixin],
	  has_remote_contact: false,
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	    var url_date = props.url_date;
	    return _.isDate(url_date) ? esUtils.format_date(url_date, "yyyy-dd-mm") : null;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    //If we grabbed a contact, we passed it into the form in the props. Test for that and update the fields if appropriate.
	    var new_contact = nextProps.contact_from_grab;
	    var prev_contact = this.props.contact_from_grab;
	    if (new_contact && new_contact !== prev_contact) {
	      var name = new_contact.name || new_contact.cname || "";
	      var phone = new_contact.phone || new_contact.phone1 || new_contact.mobile || "";
	      var email = new_contact.email || new_contact.email1 || "";
	      var remote_id = _.get(new_contact, "externalid");
	      var updatedData = _.cloneDeep(this.state.data);
	      var hasChanges = false;
	      if (!_.isEmpty(name)) {
	        updatedData.contact_name = name;
	        hasChanges = true;
	      }
	      if (!_.isEmpty(phone)) {
	        updatedData.contact_phone = phone;
	        hasChanges = true;
	      }
	      if (!_.isEmpty(email)) {
	        updatedData.contact_email = email;
	        hasChanges = true;
	      }
	      if (!_.isEmpty(remote_id)) {
	        updatedData.contact_remote_id = remote_id;
	        hasChanges = true;
	      }
	
	      if (hasChanges) {
	        this.setState({ data: updatedData });
	      }
	    }
	  },
	  getInitialValues: function getInitialValues(props) {
	    this.has_remote_contact = _.get(props, "has_remote_contact", false);
	    var Displaylists = props.Displaylists;
	    var lastSelectedSID = AuthedUserSession.getLastSelectedSID();
	    var sid = lastSelectedSID || _.first(_.map(Displaylists && Displaylists.perspeaker, "sid"));
	    var canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(sid); //as for speaker users on a privatelabel who can only create blackout events
	
	    var data = {
	      speaker: sid + "",
	      no_date: false,
	      todolists: sid + "|0",
	      status: AuthedUserSession.is_st_family ? canOnlyCreatePersonalEvent ? "confirmed" : "lead" : "held",
	      country: "US",
	      personal: canOnlyCreatePersonalEvent,
	      add_flights: false,
	      deliveryMethod: 1 //on-site
	    };
	    if (_.isDate(props.url_date)) {
	      data.starttime = props.url_date;
	      data.stoptime = props.url_date;
	    }
	
	    // set default values if we have them available from the mother event
	    if (this.props.has_parent && sessionStorage.getItem("parent_organization")) {
	      data.organization = sessionStorage.getItem("parent_organization");
	      data.status = sessionStorage.getItem("parent_status");
	      data.bureauID = sessionStorage.getItem("parent_bureauID");
	      data.bureauNotes = sessionStorage.getItem("parent_bureauNotes");
	      var parent_sid = JSON.parse(sessionStorage.getItem("parent_sids"))[0];
	      if (parent_sid > 0) {
	        data.speaker = parent_sid;
	      }
	      var venue = JSON.parse(sessionStorage.getItem("parent_Venue"))[0];
	      _.each(venue, function (value, key) {
	        data[key] = value;
	      });
	    }
	
	    return data;
	  },
	  buildSchema: function buildSchema(props) {
	    var Displaylists = (props || this.props).Displaylists;
	    var data = this.state && this.state.data || {};
	    var canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(data.speaker); //as for speaker users on a privatelabel who can only create blackout events
	    var detail_fields = buildFields(Displaylists, data, canOnlyCreatePersonalEvent);
	    return _.assign(detail_fields, FormUtils.buildAddressFields(Displaylists, data)); //add venue fields
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    var self = this;
	    var data = _.get(this, "state.data", {});
	
	    //make sure the stoptime > starttime
	    if ("starttime" === field_path && _.isDate(new_value)) {
	      this.setState({ data: data }, function () {
	        if (!_.isDate(data.stoptime) || data.stoptime.getTime() < new_value.getTime()) {
	          self.Form_onChange("stoptime", _.cloneDeep(new_value));
	        }
	      });
	    }
	
	    if ("stoptime" === field_path && _.isDate(new_value)) {
	      this.setState({ data: data }, function () {
	        if (!_.isDate(new_value) || new_value.getTime() < data.starttime.getTime()) {
	          self.Form_onChange("stoptime", _.cloneDeep(data.starttime));
	        }
	      });
	    }
	  },
	  render: function render() {
	    var self = this;
	    var fields = this.Form_buildSchema();
	    var data = this.state.data || {};
	    var _props = this.props,
	        onCancel = _props.onCancel,
	        has_remote_contact = _props.has_remote_contact,
	        __openGrabModal = _props.__openGrabModal;
	    //let { Displaylists } = this.props;
	
	    var speaker_id = _.get(data, "speaker", null);
	    var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any([speaker_id]);
	
	    var has_pro = _.includes(AuthedUserSession.getSIDsAtPackageLevel("PRO"), esUtils.toInt(data.speaker));
	
	    var renderFieldLayout = function renderFieldLayout(layout) {
	      return ezHorizontalFields(self, _.filter(layout, function (row) {
	        return _.size(row) === 1 ? _.has(fields, row[0]) : true;
	      }), "sm", 2);
	    };
	
	    return _react2.default.createElement(
	      "form",
	      { className: "form-horizontal", onSubmit: this.Form_onSubmit },
	      _react2.default.createElement(
	        "h4",
	        { className: "section-head" },
	        "New Event"
	      ),
	      renderFieldLayout([["speaker", "deliveryMethod"], ["organization"], ["status", "personal"]]),
	      _react2.default.createElement(
	        "h4",
	        { className: "section-head" },
	        "When & Where"
	      ),
	      renderFieldLayout([["no_date"]]),
	      !data.no_date && renderFieldLayout([["starttime", "stoptime"]]
	      //                ["add_flights"],
	      ),
	      _.includes([NaN, 0, 1], _.parseInt(data.deliveryMethod)) && _react2.default.createElement(
	        "div",
	        { style: { marginTop: "1em" } },
	        renderFieldLayout([["city"], ["st", "country"]])
	      ),
	      !has_remote_contact && _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h4",
	          { className: "section-head" },
	          "Primary Contact"
	        ),
	        !is_limited_speaker && has_pro && _react2.default.createElement(
	          "div",
	          { className: "row", style: { marginBottom: "0.5rem" } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-offset-1 col-sm-10" },
	            dd.a({
	              href: "#",
	              onClick: __openGrabModal.bind(null, speaker_id)
	            }, "GRAB a crm contact")
	          )
	        ),
	        renderFieldLayout([["contact_name"], ["contact_phone", "contact_email"]])
	      ),
	      _react2.default.createElement(
	        "h4",
	        { className: "section-head" },
	        "Other"
	      ),
	      renderFieldLayout([!data.personal ? ["todolists"] : null, ["bureauID"], ["bureauNotes"]]),
	      _react2.default.createElement(
	        "div",
	        { className: "form-group text-center", style: { marginTop: "30px" } },
	        _react2.default.createElement(
	          "button",
	          { type: "submit", className: "btn btn-primary" },
	          "Create Event"
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            className: "btn btn-default",
	            onClick: onCancel,
	            style: { marginLeft: "1em" }
	          },
	          "Cancel"
	        )
	      )
	    );
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	
	  RadioService_setup: function RadioService_setup() {
	    var _this = this;
	
	    return {
	      Event_my_events_on_date: {
	        key: "callService",
	        on: {
	          succeeded: function succeeded(data) {
	            if (_.size(data) === 0) {
	              _this.__saveTheEvent();
	            }
	          },
	          failed: function failed(error) {
	            //ignore this error b/c it's not a big deal
	            _this.__saveTheEvent();
	          }
	        }
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      event_to_save: null,
	      date_to_check_first: null,
	      contact_from_grab: null,
	      show_grab_modal: false,
	      grab_speaker_id: null
	    };
	  },
	
	  __saveTheEvent: esUtils.wrapPreventDefault(function () {
	    radio("save_Event").broadcast(this.state.event_to_save);
	    this.setState({
	      event_to_save: null,
	      date_to_check_first: null,
	      Event_my_events_on_date: {}
	    });
	  }),
	  __dontSaveTheEvent: esUtils.wrapPreventDefault(function () {
	    this.setState({
	      event_to_save: null,
	      date_to_check_first: null,
	      Event_my_events_on_date: {}
	    });
	  }),
	  __onSubmit: function __onSubmit(data) {
	    var event = {
	      eid: 0,
	      sids: [esUtils.toInt(data.speaker)],
	      parentID: Math.max(0, esUtils.toInt(this.__parseUrlParams().parent_id)),
	      remotecontactID: this.__parseUrlParams().remotecontact_id,
	      organization: data.organization,
	      status: data.status,
	      isPersonal: !!data.personal,
	      bureauID: esUtils.toInt(data.bureauID),
	      bureauNotes: data.bureauNotes,
	      todolistids: [],
	      companyID: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]),
	      deliveryMethod: esUtils.toInt(data.deliveryMethod)
	    };
	    if (!esUtils.isBlank(data.todolists)) {
	      event.todolistids = [esUtils.toInt(data.todolists)];
	    }
	    if (event.sids[0] > 0) {
	      AuthedUserSession.setLastSelectedSID(event.sids[0]);
	    }
	
	    if (!data.no_date) {
	      event.Stagetime = [{
	        id: 0,
	        description: "presentation",
	        starttime: data.starttime,
	        stoptime: data.stoptime
	      }];
	    }
	
	    event.Venue = [{
	      id: 0,
	      city: data.city,
	      country: data.country,
	      st: data.st
	    }];
	
	    if (!_.isEmpty(data.contact_name) || !_.isEmpty(data.contact_phone) || !_.isEmpty(data.contact_email)) {
	      event.EventContact = [{
	        id: 0,
	        cname: data.contact_name,
	        email: data.contact_email,
	        phone: data.contact_phone,
	        groupcodes: ["PRIM"],
	        flags: 1, //primary contact
	        externalid: data.contact_remote_id
	      }];
	    }
	
	    event.add_temp_flights = !data.no_date && data.add_flights;
	
	    var self = this;
	    this.setState({
	      event_to_save: event,
	      date_to_check_first: !data.no_date && _.isDate(data.starttime) ? data.starttime : null
	    }, function () {
	      if (_.isDate(self.state.date_to_check_first)) {
	        this.RadioService_callService("Event_my_events_on_date", {
	          "yyyy-mm-dd": dateformat(self.state.date_to_check_first, "yyyy-mm-dd"),
	          speaker_ids: self.state.event_to_save.sids
	        });
	      } else {
	        this.__saveTheEvent();
	      }
	    });
	  },
	
	  __openGrabModal: function __openGrabModal(speaker_id, e) {
	    if (e && e.preventDefault) {
	      e.preventDefault();
	    }
	    if (e && e.stopPropagation) {
	      e.stopPropagation();
	    }
	    this.setState({ show_grab_modal: true, grab_speaker_id: speaker_id });
	  },
	  __onCloseGrabModal: esUtils.wrapPreventDefault(function (data) {
	    this.setState({ show_grab_modal: false, contact_from_grab: data });
	  }),
	  __openEvent: function __openEvent(event_id) {
	    return esUtils.wrapPreventDefault(function () {
	      radio("Hashbang_set").broadcast("/events/" + event_id);
	    });
	  },
	
	  __cancel: esUtils.wrapPreventDefault(function () {
	    radio("Hashbang_set").broadcast("");
	  }),
	  __parseUrlParams: function __parseUrlParams() {
	    var url_params = this.props.url_params;
	
	    var r = {
	      date: null,
	      parent_id: 0,
	      remotecontact_id: null
	    };
	    if (/^\s*[0-9]+\-[0-9]+\-[0-9]+\s*$/.test(url_params[0])) {
	      var _url_params$0$split = url_params[0].split("-"),
	          _url_params$0$split2 = _slicedToArray(_url_params$0$split, 3),
	          y = _url_params$0$split2[0],
	          m = _url_params$0$split2[1],
	          d = _url_params$0$split2[2];
	
	      r.date = new Date(esUtils.toInt(y), esUtils.toInt(m) - 1, esUtils.toInt(d));
	    } else if (url_params[0] === "child") {
	      r.parent_id = esUtils.toInt(url_params[1]);
	    } else if (url_params[0] === "remotecontact") {
	      r.remotecontact_id = url_params[1];
	    }
	    return r;
	  },
	  render: function render() {
	    var Displaylists = this.props.Displaylists;
	
	    var ajax = this.state.Event_my_events_on_date;
	    var events = ajax.data;
	    var defaultGrabservice = localStorage.getItem("default_grab_service");
	    defaultGrabservice = _.isEmpty(defaultGrabservice) ? "EP" : defaultGrabservice;
	    var contact_from_grab = this.state.contact_from_grab;
	    return dd.div({ className: "NewEventForm panel panel-default", style: { margin: 10 } }, dd.div({ className: "panel-body" }, LoadingWrap({ is_loading: ajax.waiting, glass: true }, NewForm({
	      Displaylists: Displaylists,
	      url_date: this.__parseUrlParams().date,
	      onSubmit: this.__onSubmit,
	      onCancel: this.__cancel,
	      has_parent: this.__parseUrlParams().parent_id > 0,
	      has_remote_contact: !_.isEmpty(this.__parseUrlParams().remotecontact_id),
	      contact_from_grab: contact_from_grab,
	      __openGrabModal: this.__openGrabModal
	    }))), this.state.show_grab_modal ? (0, _SearchAContactService2.default)({
	      service: defaultGrabservice,
	      event: { sids: [this.state.grab_speaker_id] },
	      onClose: this.__onCloseGrabModal
	    }) : null, _.size(events) > 0 ? Modal({
	      title: "Are you sure?",
	      onClose: this.__dontSaveTheEvent,
	      buttons: [{
	        name: "Yes",
	        onClick: this.__saveTheEvent,
	        className: "btn btn-default"
	      }, {
	        name: "No",
	        onClick: this.__dontSaveTheEvent,
	        className: "btn btn-default"
	      }]
	    }, dd.p(null, _.size(events) === 1 ? dd.span(null, "There is one event on ") : dd.span(null, "There are ", _.size(events), " events on "), dateformat(this.state.date_to_check_first, "dddd, mmmm d, yyyy"), ":"), dd.div({ style: { margin: "1em 0 1em 1em" } }, _.map(events, function (event) {
	      return dd.div({
	        key: event.eid,
	        style: { marginBottom: 10, lineHeight: "28px" },
	        className: "clickable",
	        onClick: this.__openEvent(event.eid)
	      }, dd.div({ className: "pull-left", style: { marginRight: 10 } }, esStatusImage({
	        status: event.eventconfirmed,
	        delivery_method: event.deliverymethod,
	        has_parent: event.parentid > 0,
	        has_children: event.n_children > 0,
	        size: 30
	      })), dd.div(null, event.organization, " ", event.meetingname, " ", event.ispersonal ? "(personal)" : ""), dd.div({ className: "clearfix" }));
	    }, this)), dd.div(null, "Do you still want to create your event on this date?")) : null);
	  }
	});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var ImageURLs = __webpack_require__(93);
	var RadioMixin = __webpack_require__(20);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var VerticalScroll = __webpack_require__(66);
	var needsToSignMPAgreementFirst = __webpack_require__(264);
	var isLoading = __webpack_require__(263);
	
	var EventTabs = __webpack_require__(259);
	var EventHeader = __webpack_require__(258);
	var ImportEvent = __webpack_require__(89);
	var AuthedUserSession = __webpack_require__(4);
	var NewEventForm = !AuthedUserSession.is_privatelabel ? __webpack_require__(261) : __webpack_require__(260);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      last_URL_event_id: null, //to detect when to load an event from the server
	      event: {},
	      saving: false,
	      change_company: false,
	      error_msg: null,
	      info_msg: null,
	      last_used_tab: "" //remember what tab the user was looking at and keep it when switching events
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    var self = this;
	    var isMe = function isMe(event_id, is_new) {
	      return self.__getURL_event_id() == event_id || is_new && "new" == self.props.url_args[1];
	    };
	    return {
	      load_Event_waiting_on_server: function load_Event_waiting_on_server(event_id) {
	        if (isMe(event_id)) {
	          this.setState({
	            event: {},
	            error_msg: null,
	            info_msg: null,
	            saving: false
	          });
	        }
	      },
	      Event: function Event(event) {
	        if (isMe(event.eid)) {
	          this.setState({ event: event, error_msg: null, saving: false });
	        }
	        if (_.get(event, ["companyID"]) !== _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]) && this.state.change_company) {
	          AuthedUserSession.setLastSelectedCompany(_.get(event, ["companyID"]));
	          window.location.reload();
	        }
	
	        //when linking from other apps (like SalesRelay) open direct to calendar if the URL looks like
	        //   /myevents/#/events/818709/view_year
	        if (window.location.hash.includes("view_year")) {
	          radio("Show_Calendar").broadcast("year", _.get(event, "starttime"));
	          radio("Calendar_setSID").broadcast(_.first(_.get(event, "sids", [])));
	        }
	      },
	      load_Event_failed: function load_Event_failed(event_id, message) {
	        if (isMe(event_id)) {
	          this.setState({
	            error_msg: "Failed to load event: " + message,
	            saving: false,
	            info_msg: null
	          });
	        }
	      },
	      Event_destroyed: function Event_destroyed(event_id, message) {
	        if (isMe(event_id)) {
	          var self = this;
	          this.setState({
	            info_msg: null,
	            error_msg: "Deleted: " + message,
	            event: {},
	            saving: false
	          }, function () {
	            setTimeout(function () {
	              self.setState({ error_msg: null });
	              radio("Hashbang_set").broadcast("");
	            }, 3000);
	          });
	        }
	      },
	      save_Event: function save_Event(event) {
	        if (isMe(event.eid)) {
	          radio("stop_EventPoller").broadcast();
	          this.setState({ saving: true, error_msg: null, info_msg: null });
	        }
	      },
	      save_Event_succeeded: function save_Event_succeeded(event, is_new, displaymessage) {
	        if (isMe(event.eid, is_new)) {
	          radio("start_EventPoller").broadcast(event.eid);
	          this.setState({
	            saving: false,
	            error_msg: null,
	            info_msg: displaymessage
	          });
	          if (is_new) {
	            radio("Hashbang_set").broadcast("/events/" + event.eid);
	            radio("event_schedule_change").broadcast(event);
	            var _self = this;
	            if (!_.isEmpty(displaymessage)) setTimeout(function () {
	              _self.setState({ info_msg: displaymessage });
	            }, 1500); //sloppy, but the Hashbang_set resets our state, losing displaymessage
	          }
	        }
	      },
	      save_Event_failed: function save_Event_failed(event, message, is_new) {
	        if (isMe(event.eid, is_new)) {
	          this.setState({
	            saving: false,
	            error_msg: "Failed to save changes: " + message
	          });
	          radio("start_EventPoller").broadcast(event.eid);
	        }
	      }
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.__watchURLchange(this.props);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    this.__watchURLchange(props);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    radio("stop_EventPoller").broadcast();
	  },
	  __watchURLchange: function __watchURLchange(props) {
	    var eid = this.__getURL_event_id(props);
	    var selected_tab = this.props.url_args[2];
	    if (selected_tab === "load") {
	      // if we are loading the event, then change companies, load the event, and default to the details tab
	      this.setState({ change_company: true });
	      window.location.href = "#/events/" + eid + "/details";
	    }
	
	    if (eid > 0) {
	      if (eid !== this.state.last_URL_event_id) {
	        this.setState({
	          last_URL_event_id: eid,
	          last_used_tab: selected_tab || this.state.last_used_tab
	        }, function () {
	          setTimeout(function () {
	            radio("reload_Event").broadcast(eid); //reload b/c we want to load in the fresh changes rather than being fast by just loading from cache
	            radio("start_EventPoller").broadcast(eid);
	          }, 16); //wait til after it's all setup before we broadcast
	        });
	      }
	    } else if (this.state.last_URL_event_id > 0 || !_.isEmpty(this.state.event)) {
	      this.setState({ last_URL_event_id: null, event: {} });
	    }
	  },
	  __getURL_event_id: function __getURL_event_id(props) {
	    props = props || this.props;
	    var url_args = props.url_args;
	    return esUtils.toInt(url_args[1]);
	  },
	  render: function render() {
	    var event = this.state.event;
	    var saving = this.state.saving;
	    var error_msg = this.state.error_msg;
	    var Displaylists = this.props.Displaylists;
	
	    var url_args = this.props.url_args;
	    var route = _.first(url_args);
	    var selected_tab = url_args[2] || this.state.last_used_tab; //if we didn't get a tab on the url, show the last-used tab
	
	    if (route == "events" && url_args[1] === "import") {
	      return ImportEvent({
	        Displaylists: Displaylists,
	        service_to_import_from: url_args[2]
	      });
	    }
	    if (needsToSignMPAgreementFirst(event, Displaylists)) {
	      setTimeout(function () {
	        //must run this after the render has finished or it will mess up React's rendering step and cause an error
	        radio("Hashbang_set").broadcast("/marketplace/" + _.first(event.sids));
	      }, 1);
	      return dd.div();
	    }
	
	    var show_new_event_form = route == "events" && url_args[1] === "new";
	    if (!show_new_event_form && this.__getURL_event_id() < 1) {
	      return dd.div({ key: _.uniqueId(), style: { height: "100%" } }, //both these keys fix the multiple reactids issues
	      VerticalScroll(null, dd.img({ key: _.uniqueId(), src: ImageURLs.event_placeholder })));
	    }
	
	    var InfoAlert = show_new_event_form || _.isEmpty(this.state.info_msg) ? null : _react2.default.createElement(
	      "div",
	      { className: "alert alert-warning" },
	      this.state.info_msg
	    );
	
	    return VerticalScroll(null, ErrorAlert({ message: error_msg }), InfoAlert, LoadingWrap({
	      is_loading: isLoading(event, Displaylists, show_new_event_form, error_msg, saving),
	      glass: !_.isEmpty(Displaylists) && (show_new_event_form || !_.isEmpty(event))
	    }, show_new_event_form ? NewEventForm({
	      Displaylists: Displaylists,
	      url_params: _.drop(url_args, 2)
	    }) : _.isEmpty(event) ? null //only render this if we have the stuff, otherwise it'll throw up and _.isEmpty(event.sids) will be true and try and show the error message
	    : dd.div(null, EventHeader({ event: event, Displaylists: Displaylists }), _.isEmpty(event.sids) ? ErrorAlert({ message: "no sids attached to this event" }) : EventTabs({
	      event: event,
	      Displaylists: Displaylists,
	      selected_tab: selected_tab,
	      url_args: url_args
	    }))));
	  }
	});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	module.exports = function (event, Displaylists, show_new_event_form, error_msg, saving) {
		return (saving || _.isEmpty(_.get(Displaylists, ["sitelists"])) || _.isEmpty(_.get(Displaylists, ["universal"])) || !show_new_event_form && _.isEmpty(event)) && !error_msg;
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	
	module.exports = function (event, Displaylists) {
		if (event && event.is_mp_event && Displaylists && Displaylists.perspeaker) {
			//make sure Displaylists are loaded before we check, otherwise it will always result in needing to sign
			var num_signed = _.filter(Displaylists.perspeaker, function (speaker) {
				return speaker.flags.accepted_mp_agreement;
			}).length;
			if (num_signed === 0) {
				return true; //needs to sign
			}
		}
		return false;
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var SlideOpenDown = __webpack_require__(27);
	var VerticalFields = __webpack_require__(86);
	var rangeSelectIDs = __webpack_require__(270);
	var normalizeUsername = __webpack_require__(58);
	var AuthedUserSession = __webpack_require__(4);
	var MultiItemEditModal = __webpack_require__(267);
	var EmailTemplatePreviewModal = __webpack_require__(266);
	var getUsernameOptions = __webpack_require__(90);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	
	module.exports = dd.createClass({
	  mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, "onFormChanged")],
	  getInitialState: function getInitialState() {
	    return {
	      id_delete_confirm: -1,
	      field_editing: null,
	      selected_item_ids: [],
	      show_MultiItemEditModal: false,
	      show_EmailTemplatePreviewModal: false,
	      selectedEmailTemplate: null,
	      column_sorting_by: "statusdate",
	      column_sorting_ascending: true
	    };
	  },
	
	
	  /**
	   * use this method to ensure it's in sync with the availble EventTodo ids
	   */
	  __getSelectedItemsID: function __getSelectedItemsID() {
	    var event = this.props.event;
	    var selected_item_ids = this.state.selected_item_ids;
	
	
	    return _.intersection(selected_item_ids, _.map(_.map(event && event.EventTodo, "id"), esUtils.toInt));
	  },
	  getInitialValues: function getInitialValues(props) {
	    var event = props.event;
	
	    return _.object(_.flatten(_.map(event && event.EventTodo, function (todo) {
	      return [[todo.id + "_status", !!(todo.status > 0)], [todo.id + "_description", todo.description + ""],
	      // somewhere in the code "null" values are being set to a literal string 'null', this check is a temporary fix
	      [todo.id + "_email_recipient_group", todo.email_recipient_group === "null" ? null : todo.email_recipient_group + ""], [todo.id + "_actionforeignid", todo.action_foreign_id === "null" ? null : todo.action_foreign_id + ""], [todo.id + "_actiontype", todo.action_type + ""], [todo.id + "_statusdate", _.isDate(todo.statusdate) ? todo.statusdate : null], [todo.id + "_assignedto", normalizeUsername(todo.assignedto)], [todo.id + "_vieworder", todo.vieworder]];
	    } //invisible field that's used for the default table sorting
	    )));
	  },
	  buildSchema: function buildSchema() {
	    var _props = this.props,
	        event = _props.event,
	        read_only = _props.read_only,
	        Displaylists = _props.Displaylists;
	
	    var username_options = getUsernameOptions(event);
	    var speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
	    var eventContacts = event.EventContact;
	    var speakerContactCodes = _.object(_.map(speaker && speaker.contactcodes, function (code) {
	      return code;
	    }));
	    var sorted_options = [];
	    _.each(eventContacts, function (contact) {
	      if (!_.isEmpty(contact.groupcodes)) {
	        _.each(contact.groupcodes, function (groupcode) {
	          sorted_options.push({
	            key: groupcode,
	            value: "[" + groupcode + "] " + contact.cname
	          });
	        });
	      }
	    });
	    _.each(speakerContactCodes, function (value, key) {
	      var filtered_options = _.filter(sorted_options, function (option) {
	        return option.key === key;
	      });
	      if (_.size(filtered_options) === 0) {
	        sorted_options.push({ key: key, value: "[" + key + "]" });
	      }
	    });
	
	    sorted_options = _.object(_.map(sorted_options, function (item) {
	      return [item.key, item.value];
	    }));
	
	    return _.object(_.flatten(_.map(event && event.EventTodo, function (todo) {
	      return [[todo.id + "_status", {
	        type: "checkbox",
	        read_only: read_only,
	        actionlist: todo
	      }], [todo.id + "_description", {
	        label: "Item description", //For the validation function
	        type: "text"
	      }], [todo.id + "_statusdate", {
	        type: "date"
	      }], [todo.id + "_assignedto", {
	        type: "select",
	        // We only show active users in the drop down, so if the selected option is inactive, also add it to the dropdown
	        options: _.contains(username_options, _.get(todo, ["assignedto"])) ? username_options : _.assign({}, username_options, _.object([[_.get(todo, ["assignedto"]), _.get(todo, ["assignedto"])]])),
	        placeholder: "--",
	        validate: FormUtils.v.optional
	      }], [todo.id + "_email_recipient_group", {
	        type: "select",
	        options: sorted_options,
	        placeholder: "--",
	        validate: FormUtils.v.optional
	      }]];
	    })));
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    if (/_status$/.test(field_path) && !!new_value) {
	      var todo_id = field_path.split("_")[0];
	      var data = this.state.data || {};
	      data[todo_id + "_statusdate"] = new Date();
	      data[todo_id + "_assignedto"] = normalizeUsername(AuthedUserSession.MY_USERNAME);
	      this.setState({ data: data });
	    }
	    //from EventFormUnsavedChangeMixin
	    this.__checkForChangesMade();
	  },
	
	  __resetForm: esUtils.wrapPreventDefault(function () {
	    this.setState({ id_delete_confirm: -1, field_editing: null });
	    this.__discardChanges(); //from EventFormUnsavedChangeMixin
	  }),
	  __setDeleteConfirmID: function __setDeleteConfirmID(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ id_delete_confirm: id });
	    });
	  },
	  __delete: function __delete(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.props.deleteItem(id);
	    });
	  },
	  __setEditField: function __setEditField(name) {
	    return _.bind(esUtils.wrapPreventDefault(function (e) {
	      var action_id = esUtils.toInt(/^([0-9]+)_/.exec(name)[1]);
	      var is_multi_select = !!e.shiftKey;
	      var is_single_select = !!(e.ctrlKey || e.metaKey || e.altKey);
	
	      if (is_multi_select) {
	        this.setState({
	          field_editing: null,
	          selected_item_ids: rangeSelectIDs(this.__getTodoIDsInOrder(), this.__getSelectedItemsID(), action_id)
	        });
	      } else if (is_single_select) {
	        var selected_item_ids = this.__getSelectedItemsID();
	        this.setState({
	          field_editing: null,
	          selected_item_ids: _.includes(selected_item_ids, action_id) ? _.without(selected_item_ids, action_id) : _.uniq([action_id].concat(selected_item_ids))
	        });
	      } else {
	        this.setState({
	          field_editing: this.props.read_only ? null : name,
	          selected_item_ids: []
	        });
	      }
	    }), this);
	  },
	
	  __toggleMultiItemEditModal: esUtils.wrapPreventDefault(function () {
	    if (_.size(this.state.selected_item_ids) > 1) {
	      this.setState({
	        show_MultiItemEditModal: !this.state.show_MultiItemEditModal
	      });
	    }
	  }),
	  __toggleEmailTemplatePreviewModal: function __toggleEmailTemplatePreviewModal(email_template) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function (e) {
	      // debugger;
	      e.stopPropagation();
	      self.setState({
	        show_EmailTemplatePreviewModal: !self.state.show_EmailTemplatePreviewModal,
	        selectedEmailTemplate: email_template
	      });
	    });
	  },
	
	  __clearMultiItem: esUtils.wrapPreventDefault(function () {
	    this.setState({
	      show_MultiItemEditModal: false,
	      field_editing: null,
	      selected_item_ids: []
	    });
	  }),
	  __sortByColumn: function __sortByColumn(column) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      if (self.state.column_sorting_by === column) {
	        self.setState({
	          column_sorting_ascending: !self.state.column_sorting_ascending
	        });
	      } else {
	        self.setState({
	          column_sorting_by: column,
	          column_sorting_ascending: true
	        });
	      }
	    });
	  },
	  __findEmailTemplateById: function __findEmailTemplateById(id) {
	    var _props2 = this.props,
	        event = _props2.event,
	        Displaylists = _props2.Displaylists;
	
	    var speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
	    var email_templates = _.get(speaker, ["speaker_email_templates"]);
	    return _.first(_.filter(email_templates, function (template) {
	      return parseInt(template.id, 10) === parseInt(id, 10);
	    }));
	  },
	  __getTodoIDsInOrder: function __getTodoIDsInOrder() {
	    var fields = this.Form_buildSchema();
	    var initial_values = this.getInitialValues(this.props) || {};
	    var _state = this.state,
	        column_sorting_by = _state.column_sorting_by,
	        column_sorting_ascending = _state.column_sorting_ascending;
	
	
	    var todo_ids = _.uniq(_.map(_.keys(fields), function (fieldname) {
	      return esUtils.toInt(fieldname.split("_")[0]);
	    }));
	    todo_ids = _.sortBy(todo_ids, function (id) {
	      var val = initial_values[id + "_" + column_sorting_by];
	      return _.isString(val) ? val.toLowerCase() : val;
	    });
	    if (!column_sorting_ascending) {
	      todo_ids = todo_ids.reverse();
	    }
	    return todo_ids;
	  },
	  render: function render() {
	    var self = this;
	    var data = this.state.data || {};
	    var errors = this.state.errors || {};
	    var fields = this.Form_buildSchema();
	    var changes_made = this.Form_areChangesMade();
	    var selected_item_ids = this.__getSelectedItemsID();
	    var _props3 = this.props,
	        event = _props3.event,
	        Displaylists = _props3.Displaylists;
	    var _state2 = this.state,
	        show_MultiItemEditModal = _state2.show_MultiItemEditModal,
	        show_EmailTemplatePreviewModal = _state2.show_EmailTemplatePreviewModal;
	
	    var used_contact_codes = [];
	    _.each(event.EventContact, function (contact) {
	      if (!_.isEmpty(contact.groupcodes)) {
	        _.each(contact.groupcodes, function (groupcode) {
	          used_contact_codes.push(groupcode);
	        });
	      }
	    });
	
	    var renderFieldCell = function renderFieldCell(field_name, children) {
	      var field = fields[field_name];
	      var error = errors[field_name];
	
	      var body = null;
	      var width = null;
	      var onClick = null;
	      var classes = [];
	
	      if (self.state.field_editing === field_name || field.type === "checkbox") {
	        body = self.Form_buildInput(field);
	        if (field.type === "date") {
	          width = "11em";
	        } else if (field.type === "select") {
	          width = "9em";
	        }
	      } else {
	        body = _.isDate(data[field_name]) ? esUtils.format_date(data[field_name], "mm/dd/yyyy") : data[field_name] || "--";
	        onClick = self.__setEditField(field_name);
	      }
	      if (field.type === "checkbox") {
	        classes.push("text-center");
	      }
	      if (error) {
	        classes.push("has-error");
	      }
	      return dd.td({
	        className: classes.join(" "),
	        style: { width: width },
	        onClick: onClick,
	        onContextMenu: self.__toggleMultiItemEditModal
	      }, body, children, error ? dd.span({ className: "help-block" }, error) : null);
	    };
	
	    var today = new Date();
	
	    return dd.div(null,
	    //this modal needs to be rendered outside the form or else the modals submit button will submit the parent form
	    show_MultiItemEditModal ? MultiItemEditModal({
	      event: event,
	      Displaylists: Displaylists,
	      selected_item_ids: selected_item_ids,
	      onClose: this.__toggleMultiItemEditModal,
	      onClearMultiItem: this.__clearMultiItem
	    }) : null, show_EmailTemplatePreviewModal ? EmailTemplatePreviewModal({
	      onClose: this.__toggleEmailTemplatePreviewModal,
	      email_template: this.state.selectedEmailTemplate
	    }) : null, dd.form({ className: "ActionListTable", onSubmit: this.Form_onSubmit }, dd.table({ className: "table table-condensed table-hover" }, dd.thead(null, dd.tr(null, _.map([{ sort_field: "status", width: 1 }, { sort_field: "description", label: "Item" }, { sort_field: "statusdate", label: "Date" }, { sort_field: "assignedto", label: "By" }], function (col, i) {
	      return dd.th({
	        key: i,
	        className: "clickable no-select",
	        style: { width: col.width || null },
	        onClick: self.__sortByColumn(col.sort_field)
	      }, col.label || null, " ", self.state.column_sorting_by === col.sort_field ? dd.i({
	        className: "fa fa-caret-" + (self.state.column_sorting_ascending ? "down" : "up")
	      }) : null);
	    }), this.props.read_only ? null : dd.th(null, ""))), dd.tbody(null, _.map(this.__getTodoIDsInOrder(), function (todo_id) {
	      var confirm_delete = todo_id == this.state.id_delete_confirm;
	      var classes = ["no-select"];
	      if (data[todo_id + "_status"]) {
	        classes.push("success");
	      } else if (_.isDate(data[todo_id + "_statusdate"]) && today.getTime() >= data[todo_id + "_statusdate"].getTime()) {
	        classes.push("danger"); //overdue
	      }
	      if (confirm_delete) {
	        classes.push("danger");
	      }
	      if (_.includes(selected_item_ids, esUtils.toInt(todo_id))) {
	        classes.push("selected");
	      }
	      if (parseInt(data[todo_id + "_actiontype"], 10) === 1) {
	        var warn_contact_code = false;
	        if (!_.includes(used_contact_codes, data[todo_id + "_email_recipient_group"])) {
	          warn_contact_code = true;
	        }
	        return dd.tr({ key: todo_id, className: classes.join(" ") }, renderFieldCell(todo_id + "_status"), renderFieldCell(todo_id + "_description", this.state.field_editing === todo_id + "_description" ? dd.div(null, dd.p({
	          className: "text-muted",
	          onClick: this.__toggleEmailTemplatePreviewModal(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]))
	        }, _.get(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]), ["name"]) + " ", dd.a({ href: "#" }, dd.i({ className: "fa fa-eye text-link" })))) : dd.span(null, dd.i({
	          className: "fa fa-envelope text-muted",
	          style: { marginLeft: "3px" }
	        }), dd.div(null, dd.p({
	          className: "text-muted",
	          onClick: this.__toggleEmailTemplatePreviewModal(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]))
	        }, _.get(this.__findEmailTemplateById(data[todo_id + "_actionforeignid"]), ["name"]) + " ", dd.a({ href: "#" }, dd.i({ className: "fa fa-eye text-link" })))))), confirm_delete ? null : renderFieldCell(todo_id + "_statusdate"), confirm_delete ? null : renderFieldCell(todo_id + "_email_recipient_group", warn_contact_code && dd.i({
	          className: "fa fa-warning text-warning",
	          style: { marginLeft: "3px" }
	        })), confirm_delete || this.props.read_only ? null : dd.td(null, dd.a({
	          href: "#",
	          onClick: this.__setDeleteConfirmID(todo_id)
	        }, dd.i({ className: "fa fa-times" }))), confirm_delete ? dd.td({
	          colSpan: 3,
	          style: { width: "auto", textAlign: "right" }
	        }, dd.button({
	          className: "btn btn-sm btn-danger",
	          onClick: this.__delete(todo_id)
	        }, "Delete"), " ", dd.button({
	          className: "btn btn-sm btn-default",
	          onClick: this.__setDeleteConfirmID(-1)
	        }, "Cancel")) : null);
	      }
	      return dd.tr({ key: todo_id, className: classes.join(" ") }, renderFieldCell(todo_id + "_status"), renderFieldCell(todo_id + "_description", this.state.field_editing === todo_id + "_description" || AuthedUserSession.is_privatelabel ? null : dd.span(null, dd.i({
	        className: "fa fa-bell text-muted",
	        style: { marginLeft: "3px" }
	      }))), confirm_delete ? null : renderFieldCell(todo_id + "_statusdate"), confirm_delete ? null : renderFieldCell(todo_id + "_assignedto"), confirm_delete || this.props.read_only ? null : dd.td(null, dd.a({
	        href: "#",
	        onClick: this.__setDeleteConfirmID(todo_id)
	      }, dd.i({ className: "fa fa-times" }))), confirm_delete ? dd.td({
	        colSpan: 3,
	        style: { width: "auto", textAlign: "right" }
	      }, dd.button({
	        className: "btn btn-sm btn-danger",
	        onClick: this.__delete(todo_id)
	      }, "Delete"), " ", dd.button({
	        className: "btn btn-sm btn-default",
	        onClick: this.__setDeleteConfirmID(-1)
	      }, "Cancel")) : null);
	    }, this))), _.size(selected_item_ids) > 1 ? dd.button({
	      className: "btn btn-default btn-sm pull-right",
	      onClick: this.__toggleMultiItemEditModal
	    }, dd.i({ className: "fa fa-edit" }), " Change ", _.size(selected_item_ids), " items") : null, SlideOpenDown({ open: changes_made }, VerticalFields.FormButtons({ onDiscard: this.__resetForm }))));
	  }
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        email_template = _props.email_template,
	        onClose = _props.onClose;
	
	
	    return Modal({
	      title: "Previewing email: " + _.get(email_template, ['name']),
	      onClose: onClose(null),
	      buttons: []
	    }, dd.div({ className: "clearfix" }), dd.div({ style: { padding: '5px 0px' } }, "Subject:"), dd.div({ style: { padding: '8px', border: '1px solid #ccc', width: '100%' } }, email_template.subject), dd.div({ style: { padding: '5px 0px' } }, "Body:"), dd.div({ dangerouslySetInnerHTML: { __html: email_template.body, html: email_template.body }, style: { padding: '8px', border: '1px solid #ccc' } }), dd.div({ className: "clearfix" }));
	  }
	});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var FormButtons = __webpack_require__(36);
	var normalizeUsername = __webpack_require__(58);
	var getUsernameOptions = __webpack_require__(90);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		buildSchema: function buildSchema() {
			var event = this.props.event;
	
			return {
				"status": {
					type: "select",
					label: "Completed",
					placeholder: "no change",
					options: {
						"complete": "set complete",
						"incomplete": "set incomplete"
					},
					validate: FormUtils.v.optional
				},
				statusdate: {
					type: "date",
					label: "Due Date",
					validate: FormUtils.v.optional
				},
				assignedto: {
					type: "select",
					options: getUsernameOptions(event),
					placeholder: "--",
					validate: FormUtils.v.optional
				}
			};
		},
		render: function render() {
			var _props = this.props,
			    onClose = _props.onClose,
			    onDeleteItems = _props.onDeleteItems;
	
			return dd.form({ onSubmit: this.Form_onSubmit }, ezHorizontalFields(this), dd.div({ className: "clearfix" }), dd.div({ style: { marginTop: "1em" } }, HorizontalFieldSpot(null, FormButtons({
				right_align: true,
				delete_btn_text: "Delete",
				onDelete: onDeleteItems,
				cancel_btn_text: "Cancel",
				onCancel: onClose,
				submit_btn_text: "Ok"
			}))), dd.div({ className: "clearfix" }));
		}
	});
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var _props2 = this.props,
			    selected_item_ids = _props2.selected_item_ids,
			    onClearMultiItem = _props2.onClearMultiItem;
	
			var event = _.cloneDeep(this.props.event);
	
			_.each(event.EventTodo, function (todo) {
				if (!_.includes(selected_item_ids, todo.id)) {
					return;
				}
				if (data["status"] === "complete") {
					todo.status = 1;
				} else if (data["status"] === "incomplete") {
					todo.status = 0;
				}
				if (_.isDate(data.statusdate)) {
					todo.statusdate = data.statusdate;
				}
				var assignedto = normalizeUsername(data.assignedto);
				if (assignedto) {
					todo.assignedto = assignedto;
				}
			});
	
			radio("save_Event").broadcast(event);
			onClearMultiItem();
		},
	
		__deleteItems: esUtils.wrapPreventDefault(function () {
			var _props3 = this.props,
			    selected_item_ids = _props3.selected_item_ids,
			    onClearMultiItem = _props3.onClearMultiItem;
	
			var event = _.cloneDeep(this.props.event);
	
			event.EventTodo = _.reject(event.EventTodo, function (todo) {
				return _.includes(selected_item_ids, todo.id);
			});
	
			radio("save_Event").broadcast(event);
			onClearMultiItem();
		}),
		render: function render() {
			var _props4 = this.props,
			    event = _props4.event,
			    Displaylists = _props4.Displaylists,
			    selected_item_ids = _props4.selected_item_ids,
			    onClose = _props4.onClose;
	
	
			return Modal({
				title: "Changing " + _.size(selected_item_ids) + " Action Items",
				onClose: onClose,
				buttons: []
			}, dd.p(null, "Set new values to apply to all selected items."), dd.p(null, "Empty fields will not change selected items."), DaForm({ event: event, Displaylists: Displaylists, onClose: onClose, onSubmit: this.__onSubmit, onDeleteItems: this.__deleteItems }));
		}
	});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var getUsernameOptions = __webpack_require__(90);
	
	var getMasterTodoListsForEvent = function getMasterTodoListsForEvent(event, Displaylists) {
	
	  var todolists = void 0;
	  if (AuthedUserSession.is_st_family) {
	    //TEAM-ADMIN privatelabels that use only shared actionlists
	    todolists = _.get(Displaylists, ["universal", "todolists", _.get(event, "company_id"), "lists"], []);
	  } else {
	    //NORMAL per-speaker actionlists
	    todolists = _.flattenDeep(_.map(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return _.includes(event && _.get(event, ["sids"]), _.get(spkr, ["sid"]));
	    }), "todolists"));
	  }
	
	  var event_todolist_ids = _.map(event && event.todolistids, "listid");
	  var todolist = _.flattenDeep(_.filter(todolists, function (todolist) {
	    return _.includes(event_todolist_ids, _.get(todolist, ["id"]));
	  }));
	  if (!todolist) {
	    todolist = _.flattenDeep(_.filter(todolists, function (todolist) {
	      return 0 === _.get(todolist, ["id"]);
	    }));
	  }
	  return _.object(_.flatten(_.map(todolist, function (list) {
	    return _.map(list.masters, function (master, id) {
	      return [id, master];
	    });
	  })));
	};
	
	module.exports = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	    return esUtils.getEventVersionIdentifier(props.event);
	  },
	  buildSchema: function buildSchema() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    return {
	      description: {
	        label: "Item description", //For the validation method
	        type: "combo",
	        options: _.mapValues(getMasterTodoListsForEvent(event, Displaylists), "description"),
	        validate: FormUtils.v.required
	      },
	      statusdate: {
	        type: "date",
	        dropup: true
	      },
	      assignedto: {
	        type: "select",
	        options: getUsernameOptions(event),
	        placeholder: "--",
	        validate: FormUtils.v.optional
	      }
	    };
	  },
	  onFormChanged: function onFormChanged(field_path, new_value) {
	    if (field_path === "description") {
	      var _props2 = this.props,
	          event = _props2.event,
	          Displaylists = _props2.Displaylists;
	
	      var master_lists = getMasterTodoListsForEvent(event, Displaylists);
	      var master_list = master_lists[new_value];
	      if (event && master_list) {
	        var data = this.state.data || {};
	        data.description = master_list.description;
	        if (master_list.duebasedon === "STRT") {
	          //STRT - event start date
	          data.statusdate = _.isDate(event.starttime) ? new Date(event.starttime.getTime()) : new Date();
	        } else if (master_list.duebasedon === "STAT") {
	          //STAT - event create date
	          data.statusdate = _.isDate(event.created) ? new Date(event.created.getTime()) : new Date();
	        } else {
	          data.statusdate = null;
	        }
	        if (_.isDate(data.statusdate) && _.isNumber(master_list.duedelta) && !_.isNaN(master_list.duedelta)) {
	          data.statusdate.setDate(data.statusdate.getDate() + master_list.duedelta);
	        }
	        data.assignedto = _.isString(master_list.assignedto) ? master_list.assignedto : "";
	        data.assignedto = data.assignedto.replace(/\[ME\]/i, AuthedUserSession.MY_USERNAME);
	        this.setState({ data: data });
	      }
	    }
	  },
	  render: function render() {
	    var fields = this.Form_buildSchema();
	    var errors = this.state.errors || {};
	    var buildInput = this.Form_buildInput;
	
	    var buildField = function buildField(name) {
	      return dd.div({ className: errors[name] ? "has-error" : null }, buildInput(fields[name]), errors[name] ? dd.span({ className: "help-block" }, errors[name]) : null);
	    };
	
	    return dd.form({ className: "NewActionItemForm", onSubmit: this.Form_onSubmit }, dd.table({ style: { width: "100%" } }, dd.thead(null, dd.tr(null, dd.th({ style: { fontWeight: "normal" } }, "Add New Action"), dd.th({ style: { fontWeight: "normal", width: "10em" } }, "Due On"), dd.th({ style: { fontWeight: "normal", width: "7em" } }, "Assigned To"), dd.th({ style: { fontWeight: "normal", width: 1 } }))), dd.tbody(null, dd.tr(null, dd.td(null, buildField("description")), dd.td(null, buildField("statusdate")), dd.td(null, buildField("assignedto")), dd.td(null, dd.button({ type: "submit", className: "btn btn-default" }, dd.i({ className: "fa fa-plus" }), " Add"))))));
	  }
	});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var ProOnly = __webpack_require__(34);
	var FormMixin = __webpack_require__(19);
	var ApplyListModal = __webpack_require__(124);
	var ActionListTable = __webpack_require__(265);
	var AuthedUserSession = __webpack_require__(4);
	var NewActionItemForm = __webpack_require__(268);
	var normalizeUsername = __webpack_require__(58);
	var getActionListDropDownOptions = __webpack_require__(94);
	
	var ActionListSelector = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValues: function getInitialValues(props) {
	    var event = props.event;
	
	    var todolist = _.first(event.todolistids) || null; //this should degrade nicely if there are no todolistids
	    return { todolist: todolist };
	  },
	  buildSchema: function buildSchema() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    return {
	      todolist: {
	        type: "select",
	        placeholder: "-- select actionlist --",
	        dont_sort_options: false,
	        options: getActionListDropDownOptions(Displaylists, _.get(event, "sids", []), _.get(event, "companyID", 0))
	      }
	    };
	  },
	
	  __onClose: esUtils.wrapPreventDefault(function () {
	    this.Form_reset();
	  }),
	  render: function render() {
	    var _props2 = this.props,
	        event = _props2.event,
	        Displaylists = _props2.Displaylists;
	
	    var data = this.state.data || {};
	    var fields = this.Form_buildSchema();
	    var changes_made = this.Form_areChangesMade();
	
	    var error = esUtils.isBlank(data.todolist) && changes_made ? "Please select a an actionlist" : null;
	
	    return dd.div({ style: { margin: "15px 0" } }, dd.div({ className: "row" }, dd.div({ className: "col-sm-8" }, this.Form_buildInput(fields["todolist"]), error ? dd.span({ className: "text-danger" }, error) : null)), changes_made && !error ? ApplyListModal({
	      event: event,
	      Displaylists: Displaylists,
	      list_id: data.todolist,
	      onClose: this.__onClose
	    }) : null);
	  }
	});
	
	module.exports = dd.createClass({
	  __addItem: function __addItem(data) {
	    var event = _.cloneDeep(this.props.event);
	    if (!_.isArray(event.EventTodo)) {
	      event.EventTodo = [];
	    }
	    event.EventTodo.push({
	      id: 0,
	      eid: event.eid,
	      description: data.description,
	      statusdate: data.statusdate,
	      statusdate_ISO8601: _.isDate(data.statusdate) ? data.statusdate.toISOString() : null,
	      assignedto: normalizeUsername(data.assignedto)
	    });
	    radio("save_Event").broadcast(event);
	  },
	  __saveActionLists: function __saveActionLists(data) {
	    var event = _.cloneDeep(this.props.event);
	    event.EventTodo = _.map(event.EventTodo, function (todo) {
	      var id = todo.id;
	      todo.status = data[id + "_status"] ? 1 : 0;
	      todo.description = data[id + "_description"] + "";
	      todo.email_recipient_group = data[id + "_email_recipient_group"] + "";
	      todo.statusdate = _.isDate(data[id + "_statusdate"]) ? data[id + "_statusdate"] : null;
	      todo.statusdate_ISO8601 = _.isDate(data[id + "_statusdate"]) ? data[id + "_statusdate"].toISOString() : null;
	      todo.assignedto = normalizeUsername(data[id + "_assignedto"]);
	      return todo;
	    });
	    radio("save_Event").broadcast(event);
	  },
	  __deleteItem: function __deleteItem(item_id) {
	    var event = _.cloneDeep(this.props.event);
	    event.EventTodo = _.filter(event.EventTodo, function (todo) {
	      return item_id != todo.id;
	    });
	    radio("save_Event").broadcast(event);
	  },
	  render: function render() {
	    var _props3 = this.props,
	        event = _props3.event,
	        Displaylists = _props3.Displaylists;
	
	    var can_I_manage = AuthedUserSession.doIHaveAccess.admin.any(event.sids) && !AuthedUserSession.is_st; //hidden for ST
	
	    var read_only = !(AuthedUserSession.doIHaveAccess.full.any(event.sids) || AuthedUserSession.doIHaveAccess.admin.any(event.sids));
	
	    return dd.div({ className: "ActionList" }, dd.div(null, dd.span({ className: "pull-right", style: { marginTop: -3 } }, can_I_manage ? dd.a({
	      href: AuthedUserSession.privatelabel_code === "cs" ? "/myevents/#/account_settings/action_list" : "/dashboard/token-callback?token=" + _.get(AuthedUserSession, ["balboa", "estoken"], "") + "&redir=" + _.first(event.sids) + "/actionlist-settings",
	      target: "_blank",
	      className: "printlink"
	    }, dd.i({ className: "fa fa-gear" }), " customize master list") : null), dd.h2({ style: { marginBottom: read_only ? null : 0 } }, "Action List")), read_only ? null : dd.div(null, //wrapping ProOnly in a div to hack around the funky padding issue
	    ProOnly({ sids: event.sids }, ActionListSelector({ event: event, Displaylists: Displaylists }))), dd.div({ className: "panel panel-default" }, dd.div({ className: "panel-body" }, ActionListTable({
	      event: event,
	      Displaylists: Displaylists,
	      read_only: read_only,
	      onSubmit: this.__saveActionLists,
	      deleteItem: this.__deleteItem
	    }))), read_only ? null : dd.div(null, //wrapping ProOnly in a div to hack around the funky padding issue
	    ProOnly({ sids: event.sids }, dd.div({ style: { marginBottom: 30 } }, NewActionItemForm({
	      event: event,
	      Displaylists: Displaylists,
	      onSubmit: this.__addItem
	    })))));
	  }
	});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	
	module.exports = function (ids_in_order, curr_selection, end_id) {
		if (_.size(curr_selection) === 0 && _.includes(ids_in_order, end_id)) {
			return [end_id];
		}
		var start_id = _.first(curr_selection);
		if (!_.includes(ids_in_order, start_id)) {
			return [];
		}
		if (!_.includes(ids_in_order, end_id)) {
			return curr_selection;
		}
	
		var start_i = ids_in_order.indexOf(start_id);
		var end_i = ids_in_order.indexOf(end_id);
	
		return start_i > end_i ? ids_in_order.slice(end_i, start_i + 1).reverse() //We wan to reverse b/c next selection will preserve the starting id, thus making it feel more natural to the user
		: ids_in_order.slice(start_i, end_i + 1);
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var createStandardEventForm = __webpack_require__(30);
	var buildNDiffVideoCoaching = __webpack_require__(274);
	
	module.exports = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				participants: esUtils.getIn(event, ["key_values", "PARTICIPANTS"]),
				individual_sessions: esUtils.getIn(event, ["key_values", "INDIVIDUAL_SESSIONS"]),
				team_sessions: esUtils.getIn(event, ["key_values", "TEAM_SESSIONS"])
			};
		},
		buildSchema: function buildSchema() {
			return {
				participants: {
					type: "text",
					label: "participants",
					validate: FormUtils.v.positive_integer
				},
				individual_sessions: {
					type: "text",
					label: "individual sessions",
					validate: FormUtils.v.positive_integer
				},
				team_sessions: {
					type: "text",
					label: "team sessions",
					validate: FormUtils.v.positive_integer
				}
			};
		},
		confirmMessageBeforeSave: function confirmMessageBeforeSave(old_event, new_event) {
			//check if the new_event will cause data to be lost
			var has_data_loss = buildNDiffVideoCoaching(_.object(_.map(["PARTICIPANTS", "INDIVIDUAL_SESSIONS", "TEAM_SESSIONS"], function (key) {
				return [key, esUtils.toInt(new_event.key_values && new_event.key_values[key])];
			})), old_event.VideoCoaching).has_data_loss;
	
			if (!has_data_loss) {
				return; //no data will be lost with this change, so nothing to report
			}
	
			//Ask the user if they are sure
			return "This change will cause some coaching sessions to be DELETED. Continue?";
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			if (!_.isPlainObject(event.key_values)) {
				event.key_values = {};
			}
			event.key_values.PARTICIPANTS = esUtils.toInt(data.participants);
			event.key_values.INDIVIDUAL_SESSIONS = esUtils.toInt(data.individual_sessions);
			event.key_values.TEAM_SESSIONS = esUtils.toInt(data.team_sessions);
	
			event.VideoCoaching = buildNDiffVideoCoaching({
				PARTICIPANTS: event.key_values.PARTICIPANTS,
				INDIVIDUAL_SESSIONS: event.key_values.INDIVIDUAL_SESSIONS,
				TEAM_SESSIONS: event.key_values.TEAM_SESSIONS
			}, event.VideoCoaching).VideoCoaching;
		}
	});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var dateformat = __webpack_require__(41);
	var FormButtons = __webpack_require__(36);
	var StatusBoxes = __webpack_require__(273);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	
	var ParticipantBlock = dd.createClass({
	    mixins: [FormMixin, EventFormUnsavedChangeMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(_ref) {
	        var event = _ref.event;
	
	        return esUtils.getEventVersionIdentifier(event);
	    },
	    getInitialValues: function getInitialValues(_ref2) {
	        var participant = _ref2.participant;
	
	        var values = {
	            id: participant.id, //hidden (so __onSubmit knows which id it is)
	            name: participant.name
	        };
	        _.each(participant.sessions, function (s) {
	            values["startdate_" + s.id] = s.startdate;
	            values["complete_" + s.id] = !!esUtils.getIn(s, ["flags_as_map", "complete", "is_set"]);
	        });
	        return values;
	    },
	    buildSchema: function buildSchema() {
	        var participant = this.props.participant;
	
	        var schema = {
	            name: {
	                type: "text",
	                validate: FormUtils.v.optional
	            }
	        };
	        _.each(participant.sessions, function (s) {
	            schema["startdate_" + s.id] = {
	                type: "date",
	                validate: FormUtils.v.optional
	            };
	            schema["complete_" + s.id] = {
	                type: "checkbox",
	                validate: FormUtils.v.optional
	            };
	        });
	        return schema;
	    },
	    getInitialState: function getInitialState() {
	        return { is_open: false, edit_mode: false };
	    },
	
	    __toggleOpen: esUtils.wrapPreventDefault(function () {
	        this.setState({
	            is_open: !this.state.is_open,
	            edit_mode: false
	        });
	    }),
	    __toggleEditMode: esUtils.wrapPreventDefault(function () {
	        var read_only = this.props.read_only;
	
	        if (read_only) {
	            if (this.state.edit_mode) {
	                this.setState({ edit_mode: false, is_open: true });
	            }
	            return;
	        }
	        this.setState({
	            is_open: true,
	            edit_mode: !this.state.edit_mode
	        });
	    }),
	    __cancelEdits: esUtils.wrapPreventDefault(function () {
	        this.__discardChanges();
	        this.setState({ is_open: true, edit_mode: false });
	    }),
	    render: function render() {
	        var fields = this.Form_buildSchema();
	        var errors = this.state.errors || {};
	        var _props = this.props,
	            participant = _props.participant,
	            read_only = _props.read_only;
	        var _state = this.state,
	            is_open = _state.is_open,
	            edit_mode = _state.edit_mode;
	
	
	        var buildField = _.bind(function (field_name) {
	            var error = errors[field_name];
	            return dd.div({ className: error ? "has-error" : null }, this.Form_buildInput(fields[field_name]), error ? dd.span({ className: "help-block" }, error) : null);
	        }, this);
	
	        return dd.div({ className: "panel panel-" + (participant.id === 0 ? "primary" : "default"), style: { marginBottom: 0 } }, dd.div({ className: "panel-heading" }, read_only ? null : dd.div({ className: "pull-right", style: { marginLeft: "1em" } }, dd.a({
	            href: "#",
	            onClick: this.__toggleEditMode,
	            style: participant.id === 0 ? { color: "white" } : {}
	        }, dd.i({ className: "fa fa-edit" }))), dd.div({ className: "pull-right" }, StatusBoxes({ sessions: participant.sessions })), dd.h4({ className: "panel-title" }, dd.a({
	            href: "#",
	            onClick: this.__toggleOpen
	        }, dd.i({ className: "fa fa-caret-" + (is_open ? "down" : "right") }), " ", participant.id === 0 ? "Team Sessions" : participant.name))), is_open ? dd.div({ className: "panel-body" }, dd.form({ onSubmit: this.Form_onSubmit }, participant.id !== 0 && edit_mode ? buildField("name") : null, dd.table({ className: "table", onClick: edit_mode ? null : this.__toggleEditMode }, dd.thead(null, dd.tr(null, dd.th(null, "Session Date"), dd.th({ style: { width: "1px" } }, "Complete"))), dd.tbody(null, _.map(participant.sessions, function (s) {
	            var is_checked = !!esUtils.getIn(s, ["flags_as_map", "complete", "is_set"]);
	
	            return dd.tr({ key: s.id }, dd.td(null, edit_mode ? buildField("startdate_" + s.id) : _.isDate(s.startdate) ? dateformat(s.startdate, dateformat.masks.mediumDate) : "- -"), dd.td({ className: "text-center" }, edit_mode ? buildField("complete_" + s.id) : dd.i({ className: "fa fa-" + (is_checked ? "check-" : "") + "square-o" })));
	        }, this))), edit_mode ? FormButtons({ onCancel: this.__cancelEdits, right_align: true }) : null)) : null);
	    }
	});
	
	module.exports = dd.createClass({
	    __onSubmit: function __onSubmit(data) {
	        var event = _.cloneDeep(this.props.event);
	        ///////////////////////////////////////////
	
	        _.each(event.VideoCoaching, function (p) {
	            if (p.id === data.id) {
	                p.name = data.name;
	                _.each(p.sessions, function (s) {
	                    if (_.has(data, "complete_" + s.id)) {
	                        s.flags_as_map.complete.is_set = !!data["complete_" + s.id];
	                    }
	                    if (_.has(data, "startdate_" + s.id)) {
	                        s.startdate = data["startdate_" + s.id];
	                    }
	                });
	            }
	        });
	
	        ///////////////////////////////////////////
	        radio("save_Event").broadcast(event);
	    },
	    render: function render() {
	        var _props2 = this.props,
	            event = _props2.event,
	            read_only = _props2.read_only;
	        /*
	         participants:        esUtils.getIn(event, ["key_values", "PARTICIPANTS"]),
	         individual_sessions: esUtils.getIn(event, ["key_values", "INDIVIDUAL_SESSIONS"]),
	         team_sessions:       esUtils.getIn(event, ["key_values", "TEAM_SESSIONS"])
	         */
	
	        return dd.div(null, _.map(_.sortBy(event.VideoCoaching, function (p) {
	            return (p.id === 0 ? "z" : "a") + p.id;
	        }), function (p) {
	            return ParticipantBlock({
	                key: p.id,
	                event: event,
	                read_only: read_only,
	                participant: p,
	                onSubmit: this.__onSubmit
	            });
	        }, this));
	    }
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	
	module.exports = dd.createClass({
		render: function render() {
			var sessions = this.props.sessions;
	
			return dd.div(null, _.map(sessions, function (s) {
	
				var bg_color = null;
				if (_.isDate(s.startdate)) {
					bg_color = "yellow";
				}
				if (esUtils.getIn(s, ["flags_as_map", "complete", "is_set"])) {
					bg_color = "green";
				}
				return dd.div({ key: s.id, style: {
						display: "inline-block",
						border: "1px solid black",
						width: ".5em",
						height: "1em",
						marginLeft: ".25em",
						background: bg_color
					} });
			}));
		}
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	
	var buildSessions = function buildSessions(n_sess, old_sessions) {
		var new_sessions = _.values(old_sessions); //ensuring it's an array
	
		var has_data_loss = false;
	
		var n_sess_diff = n_sess - _.size(new_sessions);
	
		if (n_sess_diff === 0) {//no change
			//nothing to do
		} else if (n_sess_diff > 0) {
			//add some more
			_.each(_.range(0, n_sess_diff), function (s) {
				new_sessions.push({ id: -1 }); //-1 means create a new one
			});
		} else {
			//TODO cherry pick the blank ones (not checked or blank date)
			//TODO indicate that data was lost
			has_data_loss = true;
			new_sessions = _.take(new_sessions, n_sess);
		}
		return { new_sessions: new_sessions, has_data_loss: has_data_loss };
	};
	
	var isTeamPart = function isTeamPart(part) {
		return esUtils.toInt(part.id) === 0;
	};
	
	module.exports = function (numbers, old_VideoCoaching) {
		var PARTICIPANTS = numbers.PARTICIPANTS,
		    INDIVIDUAL_SESSIONS = numbers.INDIVIDUAL_SESSIONS,
		    TEAM_SESSIONS = numbers.TEAM_SESSIONS;
	
	
		var has_data_loss = false;
	
		//put the old participants at the top
		var new_VideoCoaching = _.reject(old_VideoCoaching, isTeamPart);
	
		var n_part_diff = PARTICIPANTS - _.size(new_VideoCoaching);
		if (n_part_diff === 0) {
			//nothing to do
		} else if (n_part_diff > 0) {
			//add some more
			_.each(_.range(0, n_part_diff), function () {
				new_VideoCoaching.push({ id: -1 }); //-1 means create a new one (0 means team)
			});
		} else {
			//TODO cherry pick the blank ones (not checked or blank date)
			has_data_loss = true;
			new_VideoCoaching = _.take(new_VideoCoaching, PARTICIPANTS);
		}
	
		//Add the team sessions at the end
		var old_team = _.find(old_VideoCoaching, isTeamPart);
		if (old_team) {
			new_VideoCoaching.push(old_team);
		} else {
			new_VideoCoaching.push({ id: 0 }); //0 for team session
		}
	
		//Adjust the number of sessions for all these parts
		new_VideoCoaching = _.map(new_VideoCoaching, function (part) {
			var n_sess = isTeamPart(part) ? TEAM_SESSIONS : INDIVIDUAL_SESSIONS;
	
			var d = buildSessions(n_sess, part.sessions);
			has_data_loss = has_data_loss || d.has_data_loss;
			return _.assign({}, part, {
				sessions: d.new_sessions
			});
		});
	
		return {
			has_data_loss: has_data_loss,
			VideoCoaching: new_VideoCoaching
		};
	};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var CoachingFields = __webpack_require__(271);
	var CoachingScheduler = __webpack_require__(272);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    var can_edit_numbers = AuthedUserSession.doIHaveAccess.full.any(event.sids);
	    var can_edit_schedules = AuthedUserSession.doIHaveAccess.full.any(event.sids) || AuthedUserSession.doIHaveAccess.spkr.any(event.sids);
	
	    return dd.div(null, dd.h2(null, "Coaching"), CoachingFields({ event: event, Displaylists: Displaylists, read_only: !can_edit_numbers }), dd.br(), dd.br(), CoachingScheduler({ event: event, Displaylists: Displaylists, read_only: !can_edit_schedules }));
	  }
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var FormUtils = __webpack_require__(9);
	var createStandardEventForm = __webpack_require__(30);
	var ezHorizontalFields = __webpack_require__(25);
	var dd = __webpack_require__(3);
	
	module.exports = createStandardEventForm({
	    eventToInitialValues: function eventToInitialValues(event) {
	        return {
	            ccNotes: event.ccNotes,
	            ccDateTime: event.ccDateTime,
	            ccTimezone: event.ccTimezone,
	            ccInitiator: esUtils.toInt(event.ccInitiator) || null
	        };
	    },
	    buildSchema: function buildSchema(_ref) {
	        var Displaylists = _ref.Displaylists;
	
	        return {
	            ccDateTime: {
	                label: "When",
	                type: "date",
	                pick_time: true,
	                validate: FormUtils.v.optional
	            },
	            ccTimezone: {
	                label: "Time Zone",
	                type: "select",
	                placeholder: "-- local time --",
	                options: _.object(_.map(Displaylists && Displaylists.universal && Displaylists.universal.timezones, function (timezone, k) {
	                    return [k, _.get(timezone, ["label"], k)];
	                })),
	                dont_sort_options: true,
	                validate: FormUtils.v.optional
	            },
	            ccInitiator: {
	                label: "Call Initiated By",
	                type: "select",
	                options: _.object(_.map(Constants.CC_INIT_VALUES, function (name, id) {
	                    return [id, name];
	                })),
	                validate: FormUtils.v.optional
	            },
	            ccNotes: {
	                label: "Notes",
	                type: "textarea"
	            }
	        };
	    },
	    renderFields: function renderFields() {
	        var self = this;
	        return dd.div(null, ezHorizontalFields(this, [["ccDateTime"], ["ccTimezone"], ["ccInitiator"], ["ccNotes"]]), dd.div({ className: "pull-right", style: { marginRight: "1em" } }, dd.a({
	            onClick: function onClick() {
	                self.setState({
	                    data: {
	                        ccTimezone: null,
	                        ccDateTime: null,
	                        ccInitiator: null,
	                        ccNotes: null
	                    }
	                });
	            }
	        }, 'clear')));
	    },
	    writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	        event.ccNotes = data.ccNotes;
	        event.ccDateTime = _.isDate(data.ccDateTime) ? data.ccDateTime : null;
	        event.ccTimezone = data.ccTimezone;
	        event.ccInitiator = esUtils.toInt(data.ccInitiator);
	    }
	});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var _ = __webpack_require__(1);
	var Constants = __webpack_require__(13);
	var AuthedUserSession = __webpack_require__(4);
	var ProOnly = __webpack_require__(34);
	
	module.exports = dd.createClass({
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists;
	
	        var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
	        var can_I_manage = AuthedUserSession.doIHaveAccess.admin.any(event.sids);
	
	        if (AuthedUserSession.is_st_family) {
	            return null;
	        }
	
	        return is_limited_speaker || event.is_mp_event ? null : ProOnly({
	            sids: event.sids,
	            custom_message: "Give your customers a red-carpet experience with the Client Portal."
	        }, dd.div({ className: "clientportal", style: { marginTop: "3em" } }, dd.h4({ className: "section-head" }, 'Client Portal page', dd.div({ className: "pull-right" }, can_I_manage ? dd.a({
	            href: "#/account_settings/client_portal/" + esUtils.encode_redir("/events/" + event.eid + "/contacts") + "/" + _.first(event.sids),
	            className: "printlink"
	        }, dd.i({ className: "fa fa-gear" }), " master settings") : null)), dd.div({ style: { marginLeft: '2em' } }, dd.div({ className: 'alert alert-info' }, dd.p({ style: { fontWeight: 'bold', fontFamily: 'monospace', fontSize: '0.8em', padding: "0.2em" } }, event.online_assistant_url, dd.a({ href: Constants.generateClientPortalMailtoForEvent(event, '', Displaylists), style: { marginLeft: "2em" } }, dd.i({ style: { fontSize: "1.25em" }, className: "fa fa-envelope-o" }))), dd.p({}, 'Give the client this web address to let them see and update parts of this event.')), dd.div({ className: "instruction" }, dd.p({}, 'Only customers who enter an ', dd.span({ style: { fontWeight: 'bold' } }, 'email address belonging to one of this event\'s contacts'), ' will have access.'), dd.p({ className: "text-muted", style: { marginTop: "1em" } }, dd.a({ href: "https://espeakers.com/wiki/Client_Portal", target: "_blank" }, 'Learn more about the Client Portal', dd.i({ style: { marginLeft: "0.5em", fontSize: "1.0em" }, className: "fa fa-external-link" })))))));
	    }
	});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var Constants = __webpack_require__(13);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
		componentWillMount: function componentWillMount() {
			var service = this.props.service;
	
			radio("BugHunter_logit").broadcast({ not_built_yet: true, feature: service + " contact grabber", username: AuthedUserSession.MY_USERNAME });
		},
		render: function render() {
			var _props = this.props,
			    service = _props.service,
			    onClose = _props.onClose;
	
	
			return Modal({
				title: 'Coming soon: ' + Constants.GRAB_SERVICES[service],
				buttons: [],
				onClose: onClose
			}, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-3 text-center text-muted' }, dd.i({
				className: 'fa fa-wrench',
				style: { fontSize: 100 }
			})), dd.div({ className: 'col-sm-9' }, dd.p({ style: { fontSize: 18 } }, "Coming soon!"), dd.p({ style: { fontSize: 14 } }, Constants.GRAB_SERVICES[service], " has not yet been integrated for myevents."))), dd.div({ className: 'text-center' }, dd.button({ className: "btn btn-primary", onClick: onClose }, "Ok")));
		}
	});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var Constants = __webpack_require__(13);
	
	module.exports = dd.createClass({
		render: function render() {
			var _props = this.props,
			    service = _props.service,
			    onClose = _props.onClose;
	
			var wiki_url = "https://www.espeakers.com/wiki/Mac_address_book";
	
			return Modal({
				title: Constants.GRAB_SERVICES[service],
				onClose: onClose
			}, dd.p(null, 'You can copy contacts from your local Mac Contacts (used to be "Address Book") onto an event without re-typing. ', 'However, to do it you must connect your Mac Contacts with Google Contacts. ', 'This article will explain step by step how to do this: '), dd.a({ href: wiki_url, target: "_blank" }, wiki_url));
		}
	});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var FormMixin = __webpack_require__(18);
	
	module.exports = dd.createClass({
		mixins: [FormMixin],
		buildFields: function buildFields() {
			return {
				search: {
					label: 'Name to search for',
					type: 'text'
				}
			};
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var error = errors['search'];
	
			return dd.form({ onSubmit: this._form_onSubmit }, dd.div({ className: error ? ' has-error' : null }, dd.label(null, fields.search.label), dd.div({ className: 'input-group' }, this._form_buildInput(fields.search, 'search'), dd.span({ className: 'input-group-btn' }, dd.button({ className: 'btn btn-default pull-left', type: 'submit' }, dd.i({ className: 'fa fa-search' })))), error ? dd.span({ className: 'help-block' }, error) : null));
		}
	});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localStorage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var ProOnly = __webpack_require__(34);
	var SearchAContactService = __webpack_require__(91);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { show_modal: false };
	  },
	  __openModal: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_modal: true });
	  }),
	  __onClose: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_modal: false });
	  }),
	  render: function render() {
	    var event = this.props.event;
	    var defaultGrabservice = localStorage.getItem("default_grab_service");
	    defaultGrabservice = _.isEmpty(defaultGrabservice) ? "EP" : defaultGrabservice;
	
	    return dd.div({ className: "ContactGrabber" }, ProOnly({ sids: _.get(event, "sids", []) }, dd.a({ href: "#", onClick: this.__openModal }, "GRAB a crm contact")), this.state.show_modal ? SearchAContactService({
	      service: defaultGrabservice,
	      event: event,
	      onClose: this.__onClose
	    }) : null);
	  }
	});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var ProOnly = __webpack_require__(34);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var Constants = __webpack_require__(13);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var FormButtons = __webpack_require__(36);
	var RadioServiceMixin = __webpack_require__(14);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	var AuthedUserSession = __webpack_require__(4);
	
	var IS_ST = !!AuthedUserSession.is_st_family;
	
	var ContactForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(props) {
			var contact = props.contact;
			if (!contact) {
				//there can be contacts with an id less than 1 if it's from grab
				return null;
			}
			var data = {
				cname: contact.cname,
				company: contact.company,
				title: contact.title,
				phone: contact.phone,
				mobile: contact.mobile,
				fax: contact.fax,
				email: contact.email,
				address: contact.address,
				city: contact.city,
				st: contact.st,
				country: contact.country,
				zip: contact.zip,
				contnotes: contact.contnotes,
				groupcodes: IS_ST ? contact.groupcodes : _.first(contact.groupcodes),
				externalid: contact.externalid
			};
			var flags = _.parseInt(contact.flags);
			_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
				/*eslint no-bitwise:0 */
				data["flags_" + flag] = (flags & _.parseInt(flag)) > 0;
			});
			return data;
		},
		buildSchema: function buildSchema() {
			var data = this.state.data || {};
			var _props = this.props,
			    event = _props.event,
			    Displaylists = _props.Displaylists;
	
			var speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
	
			var schema = {
				cname: {
					label: "Name",
					type: "text",
					validate: FormUtils.v.required
				},
				company: {
					label: "Company",
					type: "text"
				},
				title: {
					label: "Title",
					type: "text"
				},
				phone: {
					label: "Phone",
					type: "text"
				},
				mobile: {
					label: "Mobile",
					type: "text"
				},
				fax: {
					label: "Fax",
					type: "text"
				},
				email: {
					label: "Email",
					type: "text"
				},
				contnotes: {
					label: "Notes",
					type: "textarea"
				},
				groupcodes: {
					label: "Group Code",
					type: IS_ST ? "groupCodeSelect" : "combo",
					options: _.object(_.map(speaker && speaker.contactcodes, function (code, id) {
						return [code, code];
					}))
				},
				online_assistant: {
					type: "select",
					placeholder: "-- select invitation --",
					options: Constants.ONLINE_ASSISTANT_OPTIONS,
					disabled: !data["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS],
					validate: FormUtils.v.optional
				}
			};
			schema = _.assign(FormUtils.buildAddressFields(Displaylists, data), schema);
	
			_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
				schema["flags_" + flag] = {
					label: desc,
					type: "checkbox"
				};
			});
	
			if (AuthedUserSession.is_privatelabel) {
				delete schema["flags_" + Constants.CONTACT_CSP];
				delete schema["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS];
				delete schema["online_assistant"];
			}
			return schema;
		},
	
		__sendOnlineAssistantEmail: esUtils.wrapPreventDefault(function () {
			var event = this.props.event;
	
			var errors = this.state.errors || {};
			var data = this.state.data || {};
			if (data["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS] && event && event.eid > 0) {
				var recipientemail = data.email;
				var recipientname = data.cname;
				if (!_.isString(recipientemail) || recipientemail.trim().length === 0 || !esUtils.is_valid_email(recipientemail)) {
					errors.email = "Please enter their email";
				}
				if (!_.isString(recipientname) || recipientname.trim().length === 0) {
					errors.cname = "Please enter their name";
				}
				if (!_.has(Constants.ONLINE_ASSISTANT_OPTIONS, data.online_assistant)) {
					errors.online_assistant = "Please select an invitation";
				}
				if (errors.email || errors.cname || errors.online_assistant) {
					if (errors.email || errors.cname) {
						errors.online_assistant = "You must set the contacts name and email first";
					}
					this.setState({ errors: errors });
				} else {
					this.props.sendOnlineAssistantEmail(event.eid, recipientemail, recipientname, data.online_assistant);
				}
			}
		}),
		render: function render() {
			var fields = this.Form_buildSchema();
			var errors = this.state.errors || {};
			var _props2 = this.props,
			    onCancel = _props2.onCancel,
			    onDelete = _props2.onDelete,
			    contact = _props2.contact,
			    event = _props2.event;
	
			var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
			var layout, layout1, layout2;
	
			if (this.props.from_parent) {
				is_limited_speaker = true;
			}
	
			if (IS_ST) {
				layout1 = [["cname", "title"], ["company", "mobile"], ["phone", "groupcodes"], ["fax", null]];
				layout2 = [["email"], ["address"], ["city", "st"], ["zip", "country"], ["contnotes"]];
			} else {
				layout = [["cname", "groupcodes"], ["company", "title"], ["phone", "mobile"], ["fax", null], ["email"], ["address"], ["city", "st"], ["zip", "country"], ["contnotes"]];
			}
			_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
				if (!_.includes([Constants.CONTACT_CSP, Constants.CONTACT_ONLINEOFFICEACCESS], _.parseInt(flag))) {
					if (IS_ST) {
						layout2.push(["flags_" + flag]);
					} else {
						layout.push(["flags_" + flag]);
					}
				}
			});
	
			return dd.form({ className: "form-horizontal new-contact-form", onSubmit: this.Form_onSubmit }, IS_ST ? dd.div(null, ezHorizontalFields(this, layout1), dd.div({ style: { marginTop: '5px' } }, null), ezHorizontalFields(this, layout2)) : dd.div(null, ezHorizontalFields(this, layout)), !AuthedUserSession.is_privatelabel ? ProOnly({ sids: event.sids }, ezHorizontalFields(this, [["flags_" + Constants.CONTACT_CSP], ["flags_" + Constants.CONTACT_ONLINEOFFICEACCESS]]), dd.div({ className: "form-group" + (errors["online_assistant"] ? " has-error" : "") }, dd.label({ className: "control-label col-sm-3" }, " "), dd.div({ className: "col-sm-6" }, this.Form_buildInput(fields.online_assistant), errors["online_assistant"] ? dd.span({ className: "help-block" }, errors["online_assistant"]) : null), dd.div({ className: "col-sm-3" }, dd.button({
				className: "btn btn-default btn-sm " + (fields.online_assistant.disabled ? "disabled" : ""),
				disabled: fields.online_assistant.disabled ? "disabled" : null,
				onClick: this.__sendOnlineAssistantEmail
			}, "Send email")))) : null, HorizontalFieldSpot(null, is_limited_speaker ? FormButtons({
				submit_btn_text: 'cancel',
				onSubmit: onCancel,
				onCancel: null,
				onDelete: null,
				right_align: true,
				scale: 'md'
			}) : FormButtons({
				submit_btn_text: contact && contact.id > 0 ? "Save" : "Add New Contact",
				onCancel: onCancel,
				onDelete: contact && contact.id > 0 ? onDelete : null,
				right_align: true,
				scale: 'md'
			})));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Event_notify_contact: { key: "callService" }
			};
		},
		__sendOnlineAssistantEmail: function __sendOnlineAssistantEmail(event_id, recipientemail, recipientname, messagetype) {
			this.RadioService_callService("Event_notify_contact", { event_id: event_id, recipientemail: recipientemail, recipientname: recipientname, messagetype: messagetype });
		},
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var editing_id = this.props.editing_id > 0 ? this.props.editing_id : 0;
	
			if (editing_id < 1) {
				if (!_.isArray(event.EventContact)) {
					event.EventContact = [];
				}
				event.EventContact.push({ id: editing_id, eid: event.eid });
			}
			_.each(event.EventContact, function (contact) {
				if (contact.id == editing_id) {
					contact.cname = data.cname;
					contact.company = data.company;
					contact.title = data.title;
					contact.phone = data.phone;
					contact.mobile = data.mobile;
					contact.fax = data.fax;
					contact.email = data.email;
					contact.address = data.address;
					contact.city = data.city;
					contact.st = data.st;
					contact.zip = data.zip;
					contact.country = data.country;
					contact.contnotes = data.contnotes;
					contact.groupcodes = data.groupcodes;
					contact.externalid = data.externalid;
					contact.flags = 0;
					_.each(Constants.CONTACT_FLAGS, function (desc, flag) {
						if (data["flags_" + flag]) {
							contact.flags += _.parseInt(flag);
						}
					});
				}
			});
			radio("save_Event").broadcast(event);
			this.props.onClose();
		},
	
		__onDelete: esUtils.wrapPreventDefault(function () {
			var editing_id = this.props.editing_id > 0 ? this.props.editing_id : 0;
			if (editing_id === 0) {
				return;
			}
			var event = _.cloneDeep(this.props.event);
			event.EventContact = _.reject(event.EventContact, function (contact) {
				return contact.id == editing_id;
			});
			radio("save_Event").broadcast(event);
			this.props.onClose();
		}),
		render: function render() {
			var _props3 = this.props,
			    event = _props3.event,
			    Displaylists = _props3.Displaylists,
			    editing_id = _props3.editing_id,
			    contact = _props3.contact,
			    onClose = _props3.onClose;
	
			var ajax = this.state.Event_notify_contact;
			var from_parent = false;
	
			_.each(event.EventContact, function (elm) {
				if (elm.id == editing_id) {
					contact = elm;
				}
			});
			_.each(event.EventContact_from_parent, function (elm) {
				if (elm.id == editing_id) {
					contact = elm;
					from_parent = true;
				}
			});
	
			return dd.div(null, editing_id < 0 ? null : Modal({
				title: editing_id > 0 ? "Edit Contact" : "New Contact",
				onClose: onClose,
				buttons: []
			}, LoadingWrap({ is_loading: !!ajax.waiting, text: "Sending..." }, ErrorAlert({ message: ajax.error }), !ajax.data ? null : dd.div({ className: "alert alert-success" }, ajax.data), ContactForm({
				contact: contact,
				event: event,
				Displaylists: Displaylists,
				onClose: onClose,
				onSubmit: this.__onSubmit,
				onCancel: onClose,
				onDelete: this.__onDelete,
				sendOnlineAssistantEmail: this.__sendOnlineAssistantEmail,
				from_parent: from_parent
			}))));
		}
	});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	
	module.exports = {
		component: dd.createClass({
			getInitialState: function getInitialState() {
				return { generated_options_list: null, show_text_field: false };
			},
			__onMultiChange: function __onMultiChange(e) {
				var options = e.target.options;
				var new_value = [];
				for (var i = 0, l = options.length; i < l; i = i + 1) {
					if (options[i].selected) {
						new_value.push(options[i].value);
					}
				}
				this.props.onChange(new_value);
			},
			__onTextChange: function __onTextChange(e) {
				this.props.onChange(e.target.value);
			},
			__showTextField: esUtils.wrapPreventDefault(function () {
				this.setState({ show_text_field: true });
			}),
			__hideTextField: esUtils.wrapPreventDefault(function () {
				this.setState({ show_text_field: false });
			}),
			render: function render() {
	
				var field = this.props.field;
				var selected = _.isArray(this.props.value) ? this.props.value : this.props.value !== undefined && this.props.value !== '' ? [this.props.value] : [];
				var options = _.pairs(field.options);
	
				var sorted_options = [];
				if (this.state.generated_options_list !== null) {
					sorted_options = this.state.generated_options_list;
				} else {
					_.each(selected, function (option_value) {
						sorted_options.push(option_value);
					});
					_.each(options, function (option) {
						if (_.indexOf(sorted_options, option[0]) < 0) {
							sorted_options.push(option[0]);
						}
					});
					this.setState({ generated_options_list: sorted_options });
				}
	
				return dd.div(null, this.state.show_text_field ? dd.div(null, dd.input({ type: 'text', name: field.name, className: 'form-control', onChange: this.__onTextChange }), dd.a({ href: '#', className: 'group-codes-cancel', onClick: this.__hideTextField }, 'Cancel')) : dd.div(null, dd.span({ className: 'text-muted group-codes-ctrl-text' }, 'Ctrl for multiple'), dd.a({ href: '#', className: 'group-codes-add-new', onClick: this.__showTextField }, '+ Create Code'), dd.select({
					name: field.name,
					value: selected,
					onChange: this.__onMultiChange,
					className: 'form-control group-codes-select',
					multiple: true
				}, _.map(sorted_options, function (option_value) {
					return dd.option({ value: option_value, key: option_value }, option_value);
				}))));
			}
		})
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localStorage  */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioMixin = __webpack_require__(20);
	var ClientCall = __webpack_require__(276);
	var ContactGrabber = __webpack_require__(281);
	var EditContactModal = __webpack_require__(282);
	var AuthedUserSession = __webpack_require__(4);
	var ClientPortal = __webpack_require__(277);
	var SearchAContactService = __webpack_require__(91);
	
	var Contact = dd.createClass({
	  __onClick: esUtils.wrapPreventDefault(function () {
	    var _props = this.props,
	        setEditingId = _props.setEditingId,
	        contact = _props.contact;
	
	    setEditingId(contact.id);
	  }),
	
	  /**
	   * Open an external window
	   * @param opento_url
	   * @param crmkind
	   * @returns {*}
	   * @private
	   */
	  __onClickExternalCRM: function __onClickExternalCRM(opento_url, crmkind) {
	    return esUtils.wrapPreventDefault(function () {
	      var CRMWindowName = _.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind.toUpperCase(), "browser_window_name"], "genericcrm");
	      window.open(opento_url, CRMWindowName);
	    });
	  },
	
	
	  /**
	   * Given an external CRM id (like "KARMACRM:12345"), figure out if we should
	   * offer a link to that contact in the external app.
	   *
	   * This depends on /authenticate/getdisplaylists sending over data in the perspeaker.xxx.crm_sso key
	   * with a value for contact_url that looks like "https://app.hubspot.com/contacts/6224665/contact/{id}/"
	   * where {id} will be replaced with the contact ID.
	   *
	   * @param contact
	   * @param crm_sso
	   * @returns {{opentocontact_url: *, crmkind: *}}
	   * @private
	   */
	  __computeExternalCRMLink: function __computeExternalCRMLink(contact, crm_sso) {
	    //possibly link to external CRM (contact.externalid = "KARMACRM:12345", for example)
	    var opentocontact_url = null;
	    var crmkind = null;
	
	    var externalid = _.get(contact, "externalid", "");
	    externalid = "string" === typeof externalid ? externalid.split(":") : [];
	    if (2 === externalid.length) {
	      //we have an id for an external in the form of KARMACRM:123456
	      crmkind = externalid[0];
	      if (!_.isEmpty(_.get(Constants, ["GRAB_SERVICES_WITH_DEEP_INTEGRATION", crmkind]))) {
	        opentocontact_url = _.get(_.find(crm_sso, { kind: crmkind }), "contact_url");
	        if (!_.isEmpty(opentocontact_url)) {
	          opentocontact_url = opentocontact_url.replace("{id}", externalid[1]);
	        }
	      }
	    }
	    return { opentocontact_url: opentocontact_url, crmkind: crmkind };
	  },
	
	  render: function render() {
	    var _props2 = this.props,
	        contact = _props2.contact,
	        event = _props2.event,
	        Displaylists = _props2.Displaylists,
	        from_parent = _props2.from_parent;
	
	    var mail_to_url = Constants.generateNotemailHREF(event, contact, Displaylists);
	    if (!mail_to_url) {
	      mail_to_url = Constants.buildMailToURLForEvent(event, contact.email, Displaylists);
	    }
	    var crmlink = _.get(Displaylists, ["perspeaker"]);
	    crmlink = _.find(crmlink, { sid: event.sids[0] });
	    crmlink = _.get(crmlink, "crm_sso", []);
	
	    var _computeExternalCRML = this.__computeExternalCRMLink(contact, crmlink),
	        opentocontact_url = _computeExternalCRML.opentocontact_url,
	        crmkind = _computeExternalCRML.crmkind; //trouble if multiple speakers on event, but that's rare
	
	    //each contact row
	
	
	    return dd.tr({ className: "clickable" }, dd.td({ onClick: this.__onClick }, from_parent ? dd.i({ className: "fa fa-arrow-circle-up", title: "From Parent" }) : null, _.isArray(contact.groupcodes) ? dd.div(null, contact.groupcodes.join(", ")) : null), dd.td({ onClick: this.__onClick }, dd.div(null, dd.strong(null, contact.cname)), contact.company ? dd.div(null, dd.strong(null, contact.company)) : null, contact.title ? dd.div(null, dd.strong(null, contact.title)) : null, opentocontact_url ? dd.a({
	      href: opentocontact_url,
	      onClick: this.__onClickExternalCRM(opentocontact_url, crmkind)
	    }, _.get(Constants.GRAB_SERVICES, crmkind, "CRM"), " ", dd.i({
	      className: "fa fa-external-link",
	      style: { marginLeft: "0.25rem" }
	    })) : null), dd.td({ onClick: this.__onClick }, contact.phone ? dd.div(null, contact.phone, dd.span({ className: "text-muted" }, " (phone)")) : null, contact.mobile ? dd.div(null, contact.mobile, dd.span({ className: "text-muted" }, " (mobile)")) : null, contact.fax ? dd.div(null, contact.fax, dd.span({ className: "text-muted" }, " (fax)")) : null), dd.td(contact.email && mail_to_url ? null : { onClick: this.__onClick }, contact.email ? dd.div(null, mail_to_url ? dd.a({ href: mail_to_url }, contact.email) : contact.email) : null));
	  }
	});
	
	var Contacts = dd.createClass({
	  render: function render() {
	    var _props3 = this.props,
	        Displaylists = _props3.Displaylists,
	        event = _props3.event,
	        setEditingId = _props3.setEditingId;
	
	    var contacts = event.EventContact;
	    if (!_.get(event, ["flags_as_map", "marketplace", "is_set"], false)) {
	      contacts = _.flattenDeep([_.map(event.EventContact_from_parent, function (c) {
	        return _.assign({ from_parent: true }, c);
	      }), contacts]);
	    }
	
	    if (_.size(contacts) === 0) {
	      return dd.p({
	        className: "emptylist",
	        style: {
	          marginTop: "3rem",
	          paddingBottom: "2em",
	          paddingLeft: "1em"
	        }
	      }, "Click ADD CONTACT or GRAB to add the first contact to this event.");
	    }
	
	    return dd.table({ className: "table table-hover" }, dd.tbody(null, _.map(contacts, function (contact) {
	      return Contact({
	        key: contact.id,
	        contact: contact,
	        setEditingId: setEditingId,
	        event: event,
	        Displaylists: Displaylists,
	        from_parent: contact.from_parent
	      });
	    })));
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      editing_contact_id: -1,
	      contact_from_grab: null,
	      show_grab_modal: false
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      ContactGrabber_grab_succeeded: function ContactGrabber_grab_succeeded(key, contact) {
	        // eslint-disable-next-line no-debugger
	        //debugger;
	        this.setState({ editing_contact_id: 0, contact_from_grab: contact });
	      }
	    };
	  },
	  __setEditingId: function __setEditingId(id) {
	    this.setState({ editing_contact_id: id, contact_from_grab: null });
	  },
	
	  __newContact: esUtils.wrapPreventDefault(function () {
	    this.__setEditingId(0);
	  }),
	  __closeEditor: esUtils.wrapPreventDefault(function () {
	    this.__setEditingId(-1);
	  }),
	  __openGrabModal: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_grab_modal: true });
	  }),
	  __onCloseGrabModal: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_grab_modal: false });
	  }),
	
	  render: function render() {
	    var _props4 = this.props,
	        event = _props4.event,
	        Displaylists = _props4.Displaylists;
	
	    var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
	    var defaultGrabservice = localStorage.getItem("default_grab_service");
	    defaultGrabservice = _.isEmpty(defaultGrabservice) ? "EP" : defaultGrabservice;
	
	    return dd.div({ className: "Contacts" }, dd.div(null, is_limited_speaker ? null : dd.span({}, dd.h2({ className: "pull-left" }, "Contacts"), dd.button({
	      className: "btn btn-sm btn-default pull-right",
	      onClick: this.__newContact,
	      style: { marginLeft: "1rem" }
	    }, dd.i({ className: "fa fa-plus" }), " Add Contact"), dd.button({
	      className: "btn btn-sm btn-default pull-right",
	      onClick: this.__openGrabModal
	    }, dd.i({ className: "fa fa-plus" }), " Grab from CRM"))), dd.br({}), Contacts({
	      event: event,
	      Displaylists: Displaylists,
	      setEditingId: this.__setEditingId,
	      newContact: this.__newContact
	    }), is_limited_speaker ? null : ContactGrabber({ event: event, Displaylists: Displaylists }), ClientCall({ event: event, Displaylists: Displaylists, form_section_name: "Client Call" }), EditContactModal({
	      event: event,
	      Displaylists: Displaylists,
	      editing_id: this.state.editing_contact_id,
	      onClose: this.__closeEditor,
	      contact: this.state.contact_from_grab
	    }), ClientPortal({ event: event, form_section_name: "Client Portal", Displaylists: Displaylists }), this.state.show_grab_modal ? SearchAContactService({
	      service: defaultGrabservice,
	      event: event,
	      onClose: this.__onCloseGrabModal
	    }) : null);
	  }
	});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var React = __webpack_require__(15);
	var radio = __webpack_require__(5);
	var RadioMixin = __webpack_require__(22);
	
	var FormMixin = __webpack_require__(18);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var HorizontalFields = __webpack_require__(23);
	var Modal = __webpack_require__(10);
	
	var AuthedUserSession = __webpack_require__(4);
	var Constants = __webpack_require__(13);
	
	module.exports = dd.createClass({
		propTypes: {
			event: React.PropTypes.object.isRequired,
			Displaylists: React.PropTypes.object.isRequired,
			onClose: React.PropTypes.func.isRequired
		},
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { saving_custom_labels_for_sid: -1, error_msg: null };
		},
		componentWillMount: function componentWillMount() {
			var self = this;
			self.radio = {
				save_CustomFieldsLabels_succeeded: function save_CustomFieldsLabels_succeeded(sid) {
					if (self.state.saving_custom_labels_for_sid === sid) {
						self.setState({ saving_custom_labels_for_sid: -1, error_msg: null });
						self.props.onClose();
					}
				},
				'save_CustomFieldsLabels_failed': function save_CustomFieldsLabels_failed(sid, message) {
					if (self.state.saving_custom_labels_for_sid === sid) {
						self.setState({ saving_custom_labels_for_sid: -1, error_msg: 'Failed to save custom field labels: ' + message });
					}
				}
			};
		},
		__onSubmit: function __onSubmit(data) {
			radio('save_CustomFieldsLabels').broadcast(data.speaker_id, data.company_id, data);
			this.setState({ saving_custom_labels_for_sid: data.speaker_id, error_msg: null });
		},
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
			var onClose = this.props.onClose;
			var is_saving = this.state.saving_custom_labels_for_sid > 0;
	
			return Modal({
				title: 'Custom Field Labels',
				onClose: is_saving ? null : onClose,
				buttons: []
			}, LoadingWrap({ is_loading: is_saving, text: 'Saving...' }, ErrorAlert({ message: this.state.error_msg }), CustomFieldLabelForm({
				Displaylists: Displaylists,
				initial_sid: _.first(event && event.sids),
	
				onSubmit: this.__onSubmit,
				onClose: onClose
			})));
		}
	});
	
	var CustomFieldLabelForm = dd.createClass({
		mixins: [FormMixin],
		onFormChanged: function onFormChanged(field_path, new_value) {
			if (field_path === 'speaker_id') {
				this._form_reset(); //rebuild for the now selected speaker
			}
		},
		getInitialValues: function getInitialValues(props) {
			var initial_sid = props.initial_sid;
			var Displaylists = props.Displaylists;
			var my_sids = AuthedUserSession.doIHaveAccess.admin.getSIDs();
	
			var sid = _.includes(my_sids, initial_sid) ? initial_sid : _.first(my_sids);
			if (this.state && this.state.data && this.state.data.speaker_id > 0) {
				sid = this.state.data.speaker_id;
			}
			var speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
				return sid == spkr.sid;
			}));
			var data = _.object(_.map(speaker && _.filter(speaker.customfieldlabels, function (elm) {
				// filter custom field labels by company id
				return _.parseInt(_.get(elm, ["coid"], _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
			}), function (elm) {
				return [elm.id, elm.lbl];
			}));
			data.speaker_id = sid;
			data.company_id = _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
			return data;
		},
		buildFields: function buildFields() {
			var Displaylists = this.props.Displaylists;
	
			var sids_I_can_manage = AuthedUserSession.doIHaveAccess.admin.getSIDs();
			var speakers_I_can_manage = _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
				return _.includes(sids_I_can_manage, spkr.sid) && _.includes(spkr.companies, _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]));
			});
	
			var schema = {
				speaker_id: {
					label: 'Speaker',
					type: 'select',
					options: _.object(_.map(speakers_I_can_manage, function (spkr) {
						return [spkr.sid, spkr.name_full];
					}))
				}
			};
			_.each(_.range(0, Constants.QTYCUSTOMS).concat(_.range(100, 100 + Constants.QTYLONGCUSTOMS)), function (id) {
				schema[id] = {
					label: (id >= 100 ? 'long' : 'short') + ' ' + (_.parseInt(id) + 1 + (id >= 100 ? -100 : 0)),
					type: 'text',
					validate: noopAlwaysTrue
				};
			});
			return schema;
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var onClose = this.props.onClose;
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, dd.div({ className: 'alert alert-info' }, dd.b(null, 'NOTE: '), 'Changes applied to these labels apply to ALL EVENTS and all OTHER USERS for this speaker.'), HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				scale: 'sm',
				label_size: 2,
				layout: [['speaker_id', null]]
			}), dd.hr({}), dd.div(null, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				label_size: 2,
				layout: _.map(_.range(0, Constants.QTYCUSTOMS).concat(_.range(100, 100 + Constants.QTYLONGCUSTOMS)), function (id) {
					return [id + '']; //must be a string
				})
			})), HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				onCancel: onClose,
	
				right_align_buttons: true
			}));
		}
	});
	
	var noopAlwaysTrue = function noopAlwaysTrue() {
		return true;
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var ProOnly = __webpack_require__(34);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var Constants = __webpack_require__(13);
	var LabelEditorModal = __webpack_require__(285);
	var AuthedUserSession = __webpack_require__(4);
	var ezHorizontalFields = __webpack_require__(25);
	var createStandardEventForm = __webpack_require__(30);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	
	var tabs = {
	  SHORT: {
	    name: "Short",
	    ids: _.range(0, Constants.QTYCUSTOMS)
	  },
	  LONG: {
	    name: "Long",
	    ids: _.range(100, 100 + Constants.QTYLONGCUSTOMS)
	  }
	};
	
	var DaForm = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	    var sid = _.first(event && event.sids); //TODO fix this
	    var contents = event && event.Customfields && event.Customfields.contents ? event.Customfields.contents : {};
	    var fields = contents[sid];
	    return _.object(_.map(fields, function (value, id) {
	      return [id, value];
	    }));
	  },
	  buildSchema: function buildSchema(_ref) {
	    var event = _ref.event,
	        Displaylists = _ref.Displaylists;
	
	    var speaker = _.first(getSpeakersFromDisplaylists(Displaylists, event.sids));
	    var custom_labels = _.object(_.map(speaker && _.filter(speaker.customfieldlabels, function (elm) {
	      // filter custom field labels by company id
	      return _.parseInt(_.get(elm, ["coid"], _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
	    }), function (elm) {
	      return [elm.id, elm.lbl];
	    }));
	    var schema = {};
	    _.each(_.range(0, Constants.QTYCUSTOMS), function (id) {
	      schema[id] = {
	        label: custom_labels[id] ? custom_labels[id] : "--",
	        type: "text",
	        validate: FormUtils.v.optional
	      };
	    });
	    _.each(_.range(100, 100 + Constants.QTYLONGCUSTOMS), function (id) {
	      schema[id] = {
	        label: custom_labels[id] ? custom_labels[id] : "--",
	        type: "textarea",
	        validate: FormUtils.v.optional
	      };
	    });
	    return schema;
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    if (!event.Customfields) {
	      event.Customfields = {
	        id: 0,
	        eid: event.eid
	      };
	    }
	    if (!_.isPlainObject(event.Customfields.contents)) {
	      event.Customfields.contents = {};
	    }
	    var sid = _.first(event.sids); //TODO fix this
	    event.Customfields.contents[sid] = data;
	  },
	  renderFields: function renderFields() {
	    var _props = this.props,
	        open_tab = _props.open_tab,
	        tabs_to_render = _props.tabs_to_render,
	        clickTab = _props.clickTab;
	
	
	    return dd.div(null, _.size(tabs_to_render) > 1 ? dd.ul({ className: "nav nav-tabs small", style: { marginBottom: 20 } }, _.map(tabs_to_render, function (tab, tab_name) {
	      return dd.li({
	        key: tab_name,
	        className: open_tab === tab_name ? "active" : null
	      }, dd.a({ href: "#", onClick: clickTab(tab_name) }, tab.name));
	    }, this)) : null, ezHorizontalFields(this, _.map(tabs_to_render[open_tab].ids, function (id) {
	      return [id + ""];
	    })));
	  }
	});
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { show_label_editor: false, open_tab: _.first(_.keys(tabs)) };
	  },
	  __clickTab: function __clickTab(tab_clicked) {
	    return _.bind(esUtils.wrapPreventDefault(function () {
	      this.setState({ open_tab: tab_clicked });
	    }), this);
	  },
	
	  __toggleLabelEditor: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_label_editor: !this.state.show_label_editor });
	  }),
	  render: function render() {
	    var _props2 = this.props,
	        event = _props2.event,
	        Displaylists = _props2.Displaylists;
	    var _state = this.state,
	        open_tab = _state.open_tab,
	        show_label_editor = _state.show_label_editor;
	
	    var can_I_edit_labels = void 0;
	    if (AuthedUserSession.privatelabel_code === "st") {
	      can_I_edit_labels = AuthedUserSession.doIHaveAccess.full.any(event.sids);
	    } else {
	      can_I_edit_labels = AuthedUserSession.doIHaveAccess.admin.any(event.sids);
	    }
	
	    var tabs_to_render = tabs;
	    if (AuthedUserSession.privatelabel_code === "cs" && !AuthedUserSession.doIHaveAccess.full.any(event.sids)) {
	      tabs_to_render = _.omit(tabs, "SHORT"); //it's important we don't actually mutate tabs
	    }
	    if (!_.has(tabs_to_render, open_tab)) {
	      open_tab = _.first(_.keys(tabs_to_render));
	    }
	
	    return dd.div({ className: "Custom" }, ProOnly({
	      sids: event.sids,
	      custom_message: "Your business is unique. PRO users celebrate that with 10 short and 4 long custom fields to store the things that make your business special."
	    }, dd.h2(null, "Custom Data", !can_I_edit_labels ? null : dd.a({
	      className: "printlink pull-right",
	      onClick: this.__toggleLabelEditor
	    }, dd.i({ className: "fa fa-gear" }), " customize labels")), dd.div({ className: "clearfix" }), DaForm({
	      event: event,
	      Displaylists: Displaylists,
	      open_tab: open_tab,
	      read_only: !AuthedUserSession.doIHaveAccess.full.any(event.sids),
	      tabs_to_render: tabs_to_render,
	      clickTab: this.__clickTab
	    }), !show_label_editor ? null : LabelEditorModal({
	      event: event,
	      Displaylists: Displaylists,
	      onClose: this.__toggleLabelEditor
	    })));
	  }
	});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var ProOnly = __webpack_require__(34);
	var FormUtils = __webpack_require__(9);
	var Constants = __webpack_require__(13);
	var AuthedUserSession = __webpack_require__(4);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	var HoldCompetitionModal = __webpack_require__(289);
	var createStandardEventForm = __webpack_require__(30);
	var isEventAccountingLockedForMe = __webpack_require__(55);
	
	var DaForm = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				organization: event.organization,
				meetingname: event.meetingname,
				status: event.status,
				holdPriority: event.holdPriority,
				isPersonal: !!event.isPersonal,
				deliveryMethod: event.deliveryMethod,
				zoomUrl: event.zoomUrl,
				coaching: !!esUtils.getIn(event, ["flags_as_map", "coaching", "is_set"]),
				saleClosed: !!esUtils.getIn(event, ["flags_as_map", "sale_closed", "is_set"]),
				eventClass: event.eventClass,
				arrivalNotes: event.arrivalNotes || '', // default to blank otherwise IE11 fires an onchange event which shows the EventFormUnsavedChangeMixin modal @see https://www.pivotaltracker.com/story/show/152897695
				companyID: event.companyID,
				evalLink: _.get(event, ["Evaluation", "eval_link"]) || '',
				evaluation_type: _.get(event, ["Evaluation", "evaluation_type"]) || 0
			};
		},
		buildSchema: function buildSchema(_ref, data) {
			var event = _ref.event,
			    read_only = _ref.read_only,
			    Displaylists = _ref.Displaylists;
	
			var has_pro = _.intersection(AuthedUserSession.getSIDsAtPackageLevel("PRO"), event && event.sids).length > 0;
			var ulists = Displaylists && Displaylists.universal || {};
			var schema = {
				organization: {
					type: "text",
					label: "Presenting to",
					placeholder: "Presenting to",
					validate: FormUtils.v.required
				},
				meetingname: {
					type: "text",
					label: "Event Reason",
					placeholder: "Event Reason"
				},
				"status": {
					type: "select",
					label: "Status",
					read_only: AuthedUserSession.privatelabel_code === "cs" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
					placeholder: "-- select a status --",
					options: _.object(_.map(ulists.eventstatuses, function (d) {
						return [d.description, d.description]; //yep the description is the key
					})),
					validate: function validate(s) {
						if (!AuthedUserSession.is_st_family && s == "lead" && !has_pro) {
							return "Only PRO users can have '" + s + "' events";
						}
						return true;
					}
				},
				isPersonal: {
					label: "Personal/Blackout",
					type: "checkbox"
				},
				deliveryMethod: {
					type: "select",
					label: "Event Type",
					placeholder: "-- select an event type --",
					options: _.object(_.map(ulists.deliverymethods, function (d) {
						return [d.id, d.description];
					}))
				},
				arrivalNotes: {
					type: "textarea",
					label: "Schedule Notes",
					placeholder: "Schedule Notes"
				}
			};
			if (esUtils.toInt(data.deliveryMethod) === 2) {
				schema.zoomUrl = {
					type: "textarea",
					label: "Meeting URL",
					rows: 2,
					placeholder: "Enter Meeting URL (Zoom, Webex, Hangouts, etc)"
				};
			}
			if (!read_only && data.status === "held") {
				schema.holdPriority = {
					label: "Hold Strength",
					type: "select",
					options: Constants.HOLD_PRIORITY,
					dont_sort_options: true,
					validate: function validate(s) {
						return true;
					}
				};
			}
			if (AuthedUserSession.is_st_family) {
				var evaluation_types = _.get(Displaylists, ["sitelists", "evaluation_types"], []);
	
				schema.deliveryMethod.label = "Delivery Method";
				schema.deliveryMethod.placeholder = "-- select a delivery method --";
				schema.eventClass = {
					type: "select",
					label: "Event Type",
					placeholder: "-- select an event type --",
					options: _.object(_.map(ulists.eventclass, function (_ref2) {
						var id = _ref2.id,
						    name = _ref2.name;
	
						return [id, name];
					})),
					read_only: isEventAccountingLockedForMe(event),
					validate: FormUtils.v.optional
				};
				schema.companyID = {
					label: "Company",
					type: "select",
					options: _.object(_.map(ulists.company, function (_ref3) {
						var id = _ref3.id,
						    name = _ref3.name;
	
						return [id, name];
					})),
					validate: FormUtils.v.optional,
					onChange: function onChange(e) {
						//console.log(e);
					}
				};
				schema.saleClosed = {
					label: "event closed",
					type: "checkbox"
				};
				schema.coaching = {
					label: "virtual coaching",
					type: "checkbox"
				};
				// Only show evaluation link if the evaluation is set as electronic
				if (_.get(_.find(evaluation_types, { "id": _.parseInt(data.evaluation_type) }), ["electronic"], 0) === 1) {
					schema.evalLink = {
						label: "Evaluation Link",
						type: 'text',
						validate: FormUtils.v.optional,
						read_only: true
					};
				}
			}
			return schema;
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			event.organization = data.organization;
			event.meetingname = data.meetingname;
			event.status = data.status;
			event.isPersonal = !!data.isPersonal;
			event.holdPriority = data.holdPriority;
			event.deliveryMethod = data.deliveryMethod;
			event.zoomUrl = data.zoomUrl;
			event.arrivalNotes = data.arrivalNotes;
			if (AuthedUserSession.is_st_family) {
				event.eventClass = esUtils.toInt(data.eventClass);
				event.companyID = esUtils.toInt(data.companyID);
				event.flags_as_map.coaching.is_set = !!data.coaching;
				event.flags_as_map.sale_closed.is_set = !!data.saleClosed;
			}
		},
		confirmMessageBeforeSave: function confirmMessageBeforeSave(old_event, new_event) {
			if (AuthedUserSession.is_st_family) {
				if (old_event.companyID !== new_event.companyID) {
					return dd.span({}, dd.span({}, "You have changed the event COMPANY.  This will affect the PD Rep, Sales Rep and Specific Content Area.  The old values will be saved as notes on this event."), dd.br(), dd.br(), dd.span({}, "Once you change the event COMPANY, you may lose access to this event if you are not authorized on the new company."));
				}
			}
		},
		renderFields: function renderFields() {
			var fields = this.Form_buildSchema();
			var event = this.props.event;
	
			return dd.div(null, ezHorizontalFields(this, [["organization"], ["meetingname"], ["status"], ["holdPriority"]]), _.has(fields, "holdPriority") && !_.isEmpty(event.Stagetime) //don't show this if there is no date
			? HorizontalFieldSpot(null, dd.a({ href: "#", onClick: this.props.toggleHoldCompetition }, "view hold competition")) : null, ProOnly({ sids: event.sids }, ezHorizontalFields(this, [["isPersonal"]])), ezHorizontalFields(this, [["deliveryMethod"], ["zoomUrl"], ["coaching"], ["saleClosed"], ["eventClass"], ["arrivalNotes"], ["companyID"], ["evalLink"]]));
		}
	});
	
	module.exports = dd.createClass({
		getInitialState: function getInitialState() {
			return { show_hold_competition: false };
		},
	
		__toggleHoldCompetition: esUtils.wrapPreventDefault(function () {
			this.setState({ show_hold_competition: !this.state.show_hold_competition });
		}),
		render: function render() {
			var _props = this.props,
			    event = _props.event,
			    Displaylists = _props.Displaylists,
			    read_only = _props.read_only;
	
	
			return dd.div(null, DaForm({ event: event, Displaylists: Displaylists, read_only: read_only, toggleHoldCompetition: this.__toggleHoldCompetition, toggleCompanyChange: this.__toggleCompanyChange }), this.state.show_hold_competition ? HoldCompetitionModal({ event: event, onClose: this.__toggleHoldCompetition }) : null);
		}
	});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	// let ProOnly = require("../../../../widgets/ProOnly");
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var ezHorizontalFields = __webpack_require__(25);
	var createStandardEventForm = __webpack_require__(30);
	
	module.exports = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	    return {
	      bureauID: event.bureauID > 0 ? event.bureauID : null,
	      bureauNotes: _.get(event, ["bureauNotes"], "")
	    };
	  },
	  buildSchema: function buildSchema(_ref, data) {
	    var Displaylists = _ref.Displaylists,
	        is_limited_speaker = _ref.is_limited_speaker,
	        event = _ref.event;
	
	
	    var schema = {
	      bureauID: {
	        label: AuthedUserSession.is_st_family ? "PD Rep" : "Bureau",
	        type: "select",
	        placeholder: "none -- direct",
	        validate: FormUtils.v.optional,
	        options: _.object(_.map(_.slice(_.get(Displaylists, "universal.bureaus"), 0, 1500), function (bureau) {
	          return [bureau.bid, bureau.bname];
	        }))
	      },
	      bureauNotes: {
	        type: "text",
	        label: AuthedUserSession.is_st_family ? "Sales Rep" : "Bureau Notes"
	      }
	    };
	
	    //TEAM ADMIN style
	    if (AuthedUserSession.is_st_family) {
	      var options = _.get(Displaylists, ["universal", "eusers", event.companyID]);
	      var pd_options = _.filter(options, function (o) {
	        return _.get(o, "flags", 0) & 1;
	      });
	      var sales_options = _.filter(options, function (o) {
	        return _.get(o, "flags", 0) & 2;
	      });
	      pd_options = _.map(_.sortBy(pd_options, 'name'), function (o) {
	        return [o.id, o.name];
	      });
	      sales_options = _.map(_.sortBy(sales_options, 'name'), function (o) {
	        return [o.id, o.name];
	      });
	
	      schema = {
	        bureauID: {
	          label: "PD Rep",
	          type: "select",
	          placeholder: "none -- direct",
	          validate: FormUtils.v.optional,
	          options: _.object(pd_options)
	        },
	        bureauNotes: {
	          label: "Sales Rep",
	          type: "select",
	          placeholder: "none -- direct",
	          validate: FormUtils.v.optional,
	          options: _.object(sales_options)
	        }
	      };
	    }
	
	    return schema;
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    event.bureauID = esUtils.toInt(data.bureauID);
	    event.bureauNotes = data.bureauNotes;
	  },
	  renderFields: function renderFields() {
	    // let {event} = this.props;
	    // return ProOnly({sids: event.sids}, ezHorizontalFields(this));
	    // allow everyone to edit the bureau 01/19/18 - redheadedstep
	    return ezHorizontalFields(this);
	  }
	});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioMixin = __webpack_require__(20);
	var esStatusImage = __webpack_require__(54);
	
	var CalendarsToCompetitionByDay = function CalendarsToCompetitionByDay(Calendars, event, dates) {
		var competition_by_day = [];
		_.each(dates, function (d) {
			var year = d.getFullYear();
			var month = d.getMonth() + 1;
			var date = d.getDate();
	
			var detail_ids = _.toArray(esUtils.getIn(Calendars, [year, "calendar", year, month, date, "detail_ids"]));
	
			var items = [];
			_.each(detail_ids, function (detail_id) {
				var detail = esUtils.getIn(Calendars, [year, "details", detail_id]);
				if (detail.type === "event" && detail.eid != event.eid) {
					var detail_sids = esUtils.cleanup_ids(detail.sids);
					if (_.intersection(detail_sids, event.sids).length > 0) {
						items.push(detail);
					}
				}
			});
			competition_by_day.push({ date: d, items: items });
		});
		return competition_by_day;
	};
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { competition_by_day: null };
		},
		Radio_setup: function Radio_setup() {
			return {
				Calendar_get_succeeded: function Calendar_get_succeeded(radio_service_key, Calendars) {
					var event = this.props.event;
	
					var dates = this.__getDates();
	
					this.setState({
						competition_by_day: CalendarsToCompetitionByDay(Calendars, event, dates)
					});
				}
			};
		},
		componentDidMount: function componentDidMount() {
			var years = _.uniq(_.map(this.__getDates(), function (d) {
				return d.getFullYear();
			}));
			_.each(years, function (year) {
				radio("Calendar_get").broadcast({ year: year });
			});
		},
		__getDates: function __getDates() {
			var event = this.props.event;
	
	
			if (!_.isDate(event.starttime) || !_.isDate(event.stoptime)) {
				return [];
			}
			var dates = [new Date(event.starttime.getFullYear(), event.starttime.getMonth(), event.starttime.getDate())];
	
			var i = 0; //safety belt so there"s no infinite looping
			while (i < 50 && _.last(dates) < event.stoptime) {
				dates.push(new Date(_.last(dates).getFullYear(), _.last(dates).getMonth(), _.last(dates).getDate() + 1));
				i += 1;
			}
			return dates;
		},
		__openEvent: function __openEvent(event_id) {
			var onClose = this.props.onClose;
	
			return esUtils.wrapPreventDefault(function () {
				onClose();
				radio("Hashbang_set").broadcast("/events/" + event_id);
			});
		},
		render: function render() {
			var onClose = this.props.onClose;
			var competition_by_day = this.state.competition_by_day;
	
	
			return Modal({
				title: "Hold Competition",
				onClose: onClose
			}, competition_by_day === null ? dd.h4({ className: "text-center" }, "Loading...") : _.isEmpty(competition_by_day) ? "No date range" : _.map(competition_by_day, function (day, i) {
				return dd.div({ key: i, style: { marginBottom: competition_by_day.length - 1 === i ? 0 : 20 } }, dd.h3(null, esUtils.format_date(day.date, "dddd, mmmm d, yyyy")), _.isEmpty(day.items) ? "(no competition)" : _.map(day.items, function (item, i) {
					var priority = _.has(Constants.HOLD_PRIORITY, item.holdPriority) ? Constants.HOLD_PRIORITY[item.holdPriority] : "";
					return dd.div({ key: i, style: { marginBottom: 10, lineHeight: "28px" }, className: "clickable", onClick: this.__openEvent(item.eid) }, dd.div({ className: "pull-left", style: { marginRight: 10 } }, esStatusImage({
						status: item.sta,
						delivery_method: item.dm,
						has_parent: item.pntid > 0,
						has_children: item.chd > 0,
						size: 30
					})), dd.div(null, item.desc, priority ? " - hold strength " + _.toString(priority).toUpperCase() : null), dd.div({ className: "clearfix" }));
				}, this));
			}, this));
		}
	});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var AuthedUserSession = __webpack_require__(4);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	var SlideOpenDown = __webpack_require__(27);
	var Constants = __webpack_require__(13);
	
	/**
	 *
	 * @param dates
	 * @returns {string}
	 */
	var formattedDate = function formattedDate(note) {
	    var date = new Date(Date.parse(_.get(note, "datetime_ISO8601")));
	    return date ? esUtils.format_date(date, 'ddd, mmm d, yyyy') : "";
	};
	
	/**
	 *
	 * @param note
	 * @returns {boolean}
	 */
	var isSystemNote = function isSystemNote(note) {
	    return (/^\*/.test(note.enteredby) || /^Event created as a/.test(note.content)
	    );
	};
	
	/**
	 *
	 * @param note
	 * @returns {boolean}
	 */
	var isExternalNote = function isExternalNote(note) {
	    return !_.isEmpty(_.get(note, "foreign_service"));
	};
	
	/**
	 *
	 * @param note
	 * @returns {*}
	 */
	var enteredByToFullName = function enteredByToFullName(note) {
	    if (isExternalNote(note)) {
	        var r = "from ";
	        var enteredby_parts = _.get(note, "enteredby", "").split('|'); //comes in like "KARMACRM|12345|Dave Tebow"
	        r += enteredby_parts.length > 2 ? "contact " + _.last(enteredby_parts) : _.get(note, "foreign_service", "").toUpperCase();
	
	        return r;
	    }
	
	    return _.get(note, "enteredby_name", _.get(note, "enteredby"));
	};
	
	module.exports = dd.createClass({
	    mixins: [RadioMixin],
	    getInitialState: function getInitialState() {
	        return {
	            hide_system_notes: true,
	            hide_external_notes: false,
	            show_new_note_form: false,
	            saving_new_note: false,
	            show_grab_instructions: false,
	            expanded_note_id: false //one note at a time can be expanded
	        };
	    },
	    __chkHideSysNotes: function __chkHideSysNotes(e) {
	        this.setState({ hide_system_notes: !!e.target.checked });
	    },
	    __chkHideExternalNotes: function __chkHideExternalNotes(e) {
	        this.setState({ hide_external_notes: !!e.target.checked });
	    },
	    __toggleNewForm: esUtils.wrapPreventDefault(function () {
	        this.setState({ show_new_note_form: !this.state.show_new_note_form });
	    }),
	    __toggleGrabInstructions: esUtils.wrapPreventDefault(function () {
	        this.setState({ show_grab_instructions: !this.state.show_grab_instructions });
	    }),
	    __expandNote: esUtils.wrapPreventDefault(function (note_id) {
	        this.setState({ expanded_note_id: this.state.expanded_note_id == note_id ? 0 : note_id });
	    }),
	    componentWillMount: function componentWillMount() {
	        var self = this;
	        var closeNoteAfterItSaves = function closeNoteAfterItSaves(event, success) {
	            var my_eid = self.props.event && self.props.event.eid;
	            var this_eid = event && event.eid;
	            if (self.state.saving_new_note && my_eid == this_eid) {
	                self.setState({ saving_new_note: false, show_new_note_form: !success && self.state.show_new_note_form });
	            }
	        };
	        self.radio = {
	            save_Event_succeeded: function save_Event_succeeded(event, is_new, displaymessage) {
	                closeNoteAfterItSaves(event, true);
	            },
	            save_Event_failed: function save_Event_failed(event) {
	                closeNoteAfterItSaves(event, false);
	            }
	        };
	    },
	    __onSubmit: function __onSubmit(data) {
	        var event = _.cloneDeep(this.props.event);
	        if (!_.isArray(event.Note)) {
	            event.Note = [];
	        }
	        event.Note.push({
	            id: 0,
	            eid: event.eid,
	            content: data.content,
	            datetime: new Date(),
	            enteredby: AuthedUserSession.MY_USERNAME
	        });
	        event.Note = _.sortBy(event.Note, 'datetime').reverse();
	        radio('save_Event').broadcast(event);
	        this.setState({ saving_new_note: true });
	    },
	    render: function render() {
	        var event = this.props.event;
	        var Displaylists = this.props.Displaylists;
	        var read_only = this.props.read_only;
	
	        var hide_system_notes = !!this.state.hide_system_notes;
	        var hide_external_notes = !!this.state.hide_external_notes;
	
	        var show_new_note_form = !!this.state.show_new_note_form;
	        var show_grab_instructions = !!this.state.show_grab_instructions;
	
	        var notes = _.get(event, "Note", []);
	
	        if (hide_system_notes) {
	            notes = _.reject(notes, isSystemNote);
	        }
	
	        if (!hide_external_notes) {
	            notes = notes.concat(_.get(event, "ExternalNote", []));
	        }
	
	        //sort all notes by descending date
	        notes.sort(function (a, b) {
	            return Date.parse(_.get(b, "datetime_ISO8601", 0)) - Date.parse(_.get(a, "datetime_ISO8601", 0));
	        });
	        var notemail_href = Constants.generateNotemailHREF(event, null, Displaylists);
	
	        return dd.div({ className: 'Notes' }, dd.span({ className: 'pull-right' }, notemail_href ? dd.a({ href: '#', style: { marginRight: '2em' }, onClick: this.__toggleGrabInstructions }, 'link email') : null, dd.label({ style: { fontWeight: 'normal', marginRight: '2em' } }, dd.input({
	            type: 'checkbox',
	            checked: hide_system_notes,
	            onChange: this.__chkHideSysNotes
	        }), ' hide system notes '), dd.label({ style: { fontWeight: 'normal', marginRight: '2em' } }, dd.input({
	            type: 'checkbox',
	            checked: hide_external_notes,
	            onChange: this.__chkHideExternalNotes
	        }), ' hide CRM notes '), show_new_note_form || read_only ? null : dd.button({ className: 'btn btn-default btn-sm', onClick: this.__toggleNewForm }, dd.i({ className: 'fa fa-plus' }), ' Add Note')), dd.h4({ className: 'section-head' }, 'Notes'), dd.div({ className: 'clearfix', style: { height: '1em' } }), !show_new_note_form ? null : NoteForm({
	            event: event,
	            onSubmit: this.__onSubmit,
	            onCancel: this.__toggleNewForm
	        }), notemail_href ? SlideOpenDown({ open: show_grab_instructions, max_height: 80 }, GrabInstructions({
	            notemail_href: notemail_href,
	            closeFunction: this.__toggleGrabInstructions,
	            notemail_address: event.notemail_address,
	            copySuccess: this.state.copySuccess
	        })) : null, dd.div({ className: 'panel-group' }, dd.div({ className: 'panel panel-default' }, dd.div({ className: 'panel-body' }, notes.length === 0 ? dd.a({ href: "#", className: 'text-left emptylist', onClick: this.__toggleNewForm }, 'Add your first note.') : _.map(notes, function (note) {
	            return Note({
	                key: note.id,
	                note: note,
	                event: event,
	                display_expanded: this.state.expanded_note_id == note.id,
	                onExpand: this.__expandNote
	            });
	        }, this)))));
	    }
	});
	
	var Note = dd.createClass({
	    getInitialState: function getInitialState() {
	        return { editing: false, expanded: false };
	    },
	    __toggleEdit: esUtils.wrapPreventDefault(function () {
	        this.setState({ editing: !this.state.editing });
	    }),
	
	    __onExpand: esUtils.wrapPreventDefault(function () {
	        this.props.onExpand(this.props.note.id);
	    }),
	
	    __onSubmit: function __onSubmit(data) {
	        var event = _.cloneDeep(this.props.event);
	        var note_id = this.props.note.id;
	        _.each(event.Note, function (note) {
	            if (note.id == note_id) {
	                note.content = data.content;
	            }
	        });
	        this.setState({ editing: false });
	        radio('save_Event').broadcast(event);
	    },
	    render: function render() {
	        var note = this.props.note;
	        var event = this.props.event;
	        var TRUNCATE_LENGTH = 300;
	
	        var is_editable = (AuthedUserSession.MY_USERNAME === _.get(note, "enteredby", "").trim().toUpperCase() || _.get(note, "enteredby", "").trim().toUpperCase() === 'EMAIL') && !isSystemNote(note) && !isExternalNote(note);
	        var editing = this.state.editing;
	
	        var showExpander = false;
	
	        var noteStyle = {
	            transition: 'max-height .5s ease-in-out'
	        };
	
	        var classname = "Note";
	        if (isExternalNote(note)) {
	            classname += " external";
	        }
	
	        if (note.content.length > TRUNCATE_LENGTH && !this.props.display_expanded) {
	            noteStyle.maxHeight = '220px';
	            noteStyle.overflow = 'hidden';
	            noteStyle.textOverflow = 'ellipsis';
	            showExpander = true;
	        } else if (this.props.display_expanded) {
	            noteStyle.maxHeight = '500px';
	            noteStyle.overflow = 'auto';
	        } else {
	            //neither expanded nor needs to be
	        }
	
	        return dd.div({ className: classname }, dd.div({ className: 'text-muted noteSeparator' }, enteredByToFullName(note), dd.span({ className: 'pull-right' }, formattedDate(note))), editing ? NoteForm({
	            note: note,
	            event: event,
	            onSubmit: this.__onSubmit,
	            onCancel: this.__toggleEdit
	        }) : dd.div({ className: "preserve-whitespace" }, dd.div({ style: noteStyle }, showExpander ? note.content.substr(0, TRUNCATE_LENGTH) : note.content, showExpander ? '...' : null), showExpander ? dd.a({ href: '#', onClick: this.__onExpand }, '... show more') : null), !is_editable || editing ? null : dd.div({ style: {} }, dd.a({ href: '#', onClick: this.__toggleEdit }, dd.i({ className: 'fa fa-edit' }), ' edit')));
	    }
	});
	
	var GrabInstructions = dd.createClass({
	
	    getInitialState: function getInitialState() {
	        return {
	            copySuccess: null
	        };
	    },
	
	    __onCopy: esUtils.wrapPreventDefault(function (e) {
	        var textArea = document.createElement("textarea");
	        textArea.value = this.props.notemail_address;
	        document.body.appendChild(textArea);
	        textArea.select();
	        document.execCommand("Copy");
	        textArea.remove();
	
	        this.setState({ copySuccess: 'Copied!' });
	    }),
	
	    render: function render() {
	        var _props = this.props,
	            notemail_address = _props.notemail_address,
	            notemail_href = _props.notemail_href,
	            closeFunction = _props.closeFunction;
	
	        var copySuccess = _.get(this.state, "copySuccess", "");
	
	        return dd.div(null, dd.div({ className: 'alert alert-info', role: 'alert' }, dd.span({ className: "close", onClick: closeFunction }, dd.i({ className: 'fa fa-times' })), 'To copy email into this event\'s notes, add this address to your email\'s cc: ', dd.p({ style: { fontWeight: 'bold', fontFamily: 'monospace', fontSize: '1.0em', padding: "0.2em", marginTop: "0.5em" } }, dd.span({ ref: "myCopy" }, notemail_address), dd.a({
	            onClick: this.__onCopy,
	            style: { marginLeft: '1em' }
	        }, dd.i({ className: 'fa fa-clipboard' })), dd.a({
	            href: notemail_href,
	            style: { marginLeft: '1em' }
	        }, dd.i({ className: 'fa fa-envelope' })), !_.isEmpty(copySuccess) && dd.span({ style: { fontWeight: "normal", marginLeft: "1em", color: "white", backgroundColor: "#348bbd66", padding: "3px 5px", fontSize: "0.75em", borderRadius: "5px", fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif" } }, copySuccess))));
	    }
	});
	
	var NoteForm = dd.createClass({
	    mixins: [FormMixin, EventFormUnsavedChangeMixin],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        var note = props.note;
	        return note && note.id > 0 ? note.id : -1;
	    },
	    getInitialValues: function getInitialValues(props) {
	        var note = props.note;
	        return note && note.id > 0 ? { content: note.content } : {};
	    },
	    buildFields: function buildFields() {
	        return {
	            content: {
	                type: 'textarea',
	                placeholder: 'Enter a note about this event',
	                validate: function validate(value) {
	                    return _.isString(value) && value.trim().length > 0 || 'Please enter a note about this event.';
	                }
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        //focus the content field
	        //dd.findDOMNode(this.refs.myref).focus();
	    },
	    render: function render() {
	        var note = this.props.note;
	        var fields = this.buildFields();
	        var errors = this.state.errors || {};
	
	        return dd.form({ className: 'NoteForm', onSubmit: this._form_onSubmit, style: { marginBottom: 15 } }, dd.div({ className: 'form-group' + (errors['content'] ? ' has-error' : ''), style: { marginBottom: '.5em' } }, dd.div(null, this._form_buildInput(fields['content'], 'content'), errors['content'] ? dd.span({ className: 'help-block' }, errors['content']) : null)), dd.div({ className: 'form-group' }, dd.div(null, dd.button({ type: 'submit', className: 'btn btn-primary btn-sm' }, note && note.id > 0 ? 'Save Note' : 'Save'), ' ', !this.props.onCancel ? null : dd.button({ className: 'btn btn-default btn-sm', onClick: this.props.onCancel }, 'Cancel'))));
	    }
	});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var ErrorAlert = __webpack_require__(6);
	var FormButtons = __webpack_require__(36);
	var LoadingWrap = __webpack_require__(8);
	var RadioServiceMixin = __webpack_require__(14);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	
	var EIDForm = dd.createClass({
		mixins: [FormMixin],
		buildSchema: function buildSchema() {
			return {
				eid: {
					label: "Event ID",
					type: "text",
					validate: function validate(v) {
						return esUtils.toInt(v) > 0 || "Please enter a valid event id.";
					}
				}
			};
		},
		render: function render() {
			return dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, ezHorizontalFields(this), dd.br(), HorizontalFieldSpot(null, FormButtons({
				right_align: true,
				submit_btn_text: "Attach",
				cancel_btn_text: "Cancel",
				onCancel: this.props.onClose
			})));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Event_change_parentID: {
					key: "callService",
					on: {
						succeeded: function succeeded() {
							radio("reload_Event").broadcast(this.props.event.eid);
							this.props.onClose();
						}
					}
				}
			};
		},
		__onSubmit: function __onSubmit(data) {
			this.RadioService_callService("Event_change_parentID", {
				eid: esUtils.toInt(data.eid),
				parentID: this.props.event.eid
			});
		},
		render: function render() {
			var ajax = this.state.Event_change_parentID;
			var onClose = this.props.onClose;
	
	
			if (ajax.waiting) {
				return Modal({ title: "Attaching...", buttons: [] }, LoadingWrap({ is_loading: true, text: "Attaching..." }));
			}
	
			return Modal({
				title: "Attach existing event as child...",
				buttons: [],
				onClose: onClose
			}, ErrorAlert({ message: ajax.error }), dd.p(null, "Enter the event ID you wish to attach as a child to this event."), EIDForm({ onSubmit: this.__onSubmit, onClose: onClose }));
		}
	});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	
	module.exports = dd.createClass({
		__detach: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			event.parentID = 0;
			radio("save_Event").broadcast(event);
			this.props.onClose();
		}),
		render: function render() {
			var onClose = this.props.onClose;
	
			return Modal({
				title: "Detach from parent event",
				buttons: [{
					name: "No, never mind",
					onClick: onClose,
					className: "btn btn-default"
				}, {
					name: "Yes, detach",
					onClick: this.__detach,
					className: "btn btn-primary"
				}],
				onClose: onClose
			}, dd.p(null, "Are you sure you want to detach this event from it's parent event?"));
		}
	});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	
	module.exports = dd.createClass({
		render: function render() {
			var _props = this.props,
			    message = _props.message,
			    onClose = _props.onClose;
	
			return Modal({
				title: "",
				onClose: onClose
			}, dd.p(null, message));
		}
	});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	/*global sessionStorage */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var HoverMixin = __webpack_require__(49);
	var AuthedUserSession = __webpack_require__(4);
	
	var modals = {
	    ParentChildMessageModal: __webpack_require__(293),
	    DetachFromParentModal: __webpack_require__(292),
	    AttachExistingChildModal: __webpack_require__(291)
	};
	
	module.exports = dd.createClass({
	    mixins: [HoverMixin],
	    getInitialState: function getInitialState() {
	        return { show_dd: null, show_modal: null };
	    },
	    __toggleDD: function __toggleDD(direction) {
	        return _.bind(esUtils.wrapPreventDefault(function () {
	            if (this.state.show_dd === direction) {
	                this.setState({ show_dd: null });
	            } else {
	                this.setState({ show_dd: direction });
	            }
	        }), this);
	    },
	    hoverable_onUserLeftHoverable: function hoverable_onUserLeftHoverable() {
	        if (this.state.show_dd) {
	            //only setState if needed
	            this.setState({ show_dd: null });
	        }
	    },
	    __itemClick: function __itemClick(action) {
	        if (!_.isFunction(action)) {
	            return null;
	        }
	        return _.bind(function (e) {
	            this.setState({ show_dd: null });
	            action(e);
	        }, this);
	    },
	
	    __disableClick: esUtils.wrapPreventDefault(_.noop),
	    __searchFamily: esUtils.wrapPreventDefault(function () {
	        var event = this.props.event;
	
	        radio("EventSearchAside_search").broadcast({
	            parenteid: event.parentID > 0 ? event.parentID : event.eid
	        });
	    }),
	    __toggleModal: function __toggleModal(modal_name) {
	        return _.bind(esUtils.wrapPreventDefault(function () {
	            if (this.state.show_modal === modal_name) {
	                this.setState({ show_modal: null });
	            } else {
	                this.setState({ show_modal: modal_name });
	            }
	        }), this);
	    },
	
	    __openNewChildForm: esUtils.wrapPreventDefault(function () {
	        var event = this.props.event;
	        // set parent event data in session storage
	
	        sessionStorage.setItem('parent_organization', event.organization);
	        sessionStorage.setItem('parent_status', event.status);
	        sessionStorage.setItem('parent_bureauID', event.bureauID);
	        sessionStorage.setItem('parent_pd_rep_id', event.pd_rep_id);
	        sessionStorage.setItem('parent_sales_rep_id', event.sales_rep_id);
	        sessionStorage.setItem('parent_project_manager_id', event.project_manager_id);
	        sessionStorage.setItem('parent_bureauNotes', event.bureauNotes);
	        sessionStorage.setItem('parent_sids', JSON.stringify(event.sids));
	        sessionStorage.setItem('parent_Venue', JSON.stringify(event.Venue));
	        // send to new event form now
	        window.location.hash = '#/events/new/child/' + event.eid;
	    }),
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists;
	        var _state = this.state,
	            show_dd = _state.show_dd,
	            show_modal = _state.show_modal;
	
	
	        if (!AuthedUserSession.is_st_family) {
	            var pro_sids = AuthedUserSession.getSIDsAtPackageLevel("PRO");
	            if (!_.any(event.sids, _.partial(_.includes, pro_sids))) {
	                return dd.span(); //hide
	            }
	        }
	
	        var has_parent = event.parentID > 0;
	        var has_children = !_.isEmpty(event.childevents);
	        var dd_items = [show_dd === "up" ? { name: "Open parent event", href: "#/events/" + event.parentID, no_click: !has_parent } : { name: "Create a new child event...", onClick: this.__openNewChildForm }, show_dd === "up" ? { name: "Detach from parent event", onClick: this.__toggleModal("DetachFromParentModal"), no_click: !has_parent } : { name: "Attach existing event as child...", onClick: this.__toggleModal("AttachExistingChildModal") }, { name: "Search the family", onClick: this.__searchFamily, no_click: !has_parent && !has_children }];
	        if (!_.isEmpty(event.childevents) && show_dd === "down") {
	            dd_items.push({ divider: true });
	            _.each(event.childevents, function (child) {
	                dd_items.push({ name: child.organization || "event #" + child.id, href: "#/events/" + child.id });
	            });
	        }
	
	        var renderToggleHandle = _.bind(function (direction, disabled) {
	            if (disabled) {
	                return dd.span({ className: "text-verymuted no-select" }, dd.i({ className: "fa fa-arrow-circle-" + direction }));
	            }
	            return dd.a({ href: "#", className: "dropdown-toggle", onClick: this.__toggleDD(direction) }, dd.i({ className: "fa fa-arrow-circle-" + direction }));
	        }, this);
	
	        var warning_msg = event.message_that_parent_child_services_dont_add_upon_resc_and_pd_values;
	        warning_msg = esUtils.isBlank(warning_msg) ? false : warning_msg;
	        warning_msg = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids) ? null : warning_msg;
	
	        return dd.div({
	            style: {
	                display: "inline-block"
	            },
	            className: "dropdown relative " + (show_dd ? "open" : ""),
	            onMouseEnter: this.hoverable_onMouseEnter,
	            onMouseLeave: this.hoverable_onMouseLeave
	        }, warning_msg ? dd.a({ href: "#", onClick: this.__toggleModal("ParentChildMessageModal") }, dd.i({ className: "fa fa-warning" })) : null, " ", renderToggleHandle("up", !has_parent), " ", renderToggleHandle("down", has_parent), dd.ul({ className: "dropdown-menu dropdown-menu-right", role: "menu", style: { marginRight: show_dd === "up" ? "1em" : "" } }, _.map(dd_items, function (item, i) {
	            if (item.divider) {
	                return dd.li({ key: i, className: "divider" });
	            }
	            return dd.li({ key: i, role: "presentation", className: item.no_click ? "disabled" : null }, dd.a({ role: "menuitem", href: item.href || "#", onClick: item.no_click ? this.__disableClick : this.__itemClick(item.onClick) }, item.name));
	        }, this)), _.map(modals, function (cmpt, name) {
	            return show_modal === name ? cmpt({ key: name, event: event, Displaylists: Displaylists, message: warning_msg, onClose: this.__toggleModal(name) }) : null;
	        }, this));
	    }
	});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	// let ProOnly = require("../../../../widgets/ProOnly");
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var ezHorizontalFields = __webpack_require__(25);
	var createStandardEventForm = __webpack_require__(30);
	
	module.exports = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				pd_rep_id: esUtils.toInt(event.pd_rep_id) > 0 ? event.pd_rep_id : null,
				sales_rep_id: esUtils.toInt(event.sales_rep_id) > 0 ? event.sales_rep_id : null,
				project_manager_id: esUtils.toInt(event.project_manager_id) > 0 ? event.project_manager_id : null
			};
		},
		buildSchema: function buildSchema(_ref, data) {
			var Displaylists = _ref.Displaylists,
			    is_limited_speaker = _ref.is_limited_speaker;
	
	
			var schema = {
				pd_rep_id: {
					label: "PD Rep",
					type: "select",
					placeholder: "none -- direct",
					validate: FormUtils.v.optional,
					options: _.object(_.map(_.get(Displaylists, ["sitelists", "pd_reps"]), function (user) {
						return [user.id, user.fullname];
					}))
				},
				sales_rep_id: {
					label: "Sales Rep",
					type: "select",
					placeholder: "none -- direct",
					validate: FormUtils.v.optional,
					options: _.object(_.map(_.get(Displaylists, ["sitelists", "sales_reps"]), function (user) {
						return [user.id, user.fullname];
					}))
				},
				project_manager_id: {
					label: "Project Manager",
					type: "select",
					placeholder: "none -- direct",
					validate: FormUtils.v.optional,
					options: _.object(_.map(_.get(Displaylists, ["sitelists", "project_managers"]), function (user) {
						return [user.id, user.fullname];
					}))
				}
			};
	
			// If the PD Rep was archived and wouldn't show up in the drop down, then add it as an additional option
			if (!_.isNull(_.get(data, ["pd_rep_id"])) && !_.contains(_.map(_.keys(_.get(schema, ["pd_rep_id", "options"])), _.parseInt), _.get(data, ["pd_rep_id"]))) {
				_.set(schema, ["pd_rep_id", "options", _.get(data, ["pd_rep_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data, ["pd_rep_id"]), "name"], _.get(data, ["pd_rep_id"])));
			}
			// If the Sales Rep was archived and wouldn't show up in the drop down, then add it as an additional option
			if (!_.isNull(_.get(data, ["sales_rep_id"])) && !_.contains(_.map(_.keys(_.get(schema, ["sales_rep_id", "options"])), _.parseInt), _.get(data, ["sales_rep_id"]))) {
				_.set(schema, ["sales_rep_id", "options", _.get(data, ["sales_rep_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data, ["sales_rep_id"]), "name"], _.get(data, ["sales_rep_id"])));
			}
			// If the Project Manager was archived and wouldn't show up in the drop down, then add it as an additional option
			if (!_.isNull(_.get(data, ["project_manager_id"])) && !_.contains(_.map(_.keys(_.get(schema, ["project_manager_id", "options"])), _.parseInt), _.get(data, ["project_manager_id"]))) {
				_.set(schema, ["project_manager_id", "options", _.get(data, ["project_manager_id"])], _.get(_.indexBy(_.get(Displaylists, ["universal", "eusers", _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])]), "id"), [_.get(data, ["project_manager_id"]), "name"], _.get(data, ["project_manager_id"])));
			}
	
			return schema;
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			event.pd_rep_id = esUtils.toInt(data.pd_rep_id);
			event.sales_rep_id = esUtils.toInt(data.sales_rep_id);
			event.project_manager_id = esUtils.toInt(data.project_manager_id);
		},
		renderFields: function renderFields() {
			// let {event} = this.props;
			// return ProOnly({sids: event.sids}, ezHorizontalFields(this));
			// allow everyone to edit the bureau 01/19/18 - redheadedstep
			return ezHorizontalFields(this);
		}
	});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var VenueForm = __webpack_require__(131);
	var HorizontalFields = __webpack_require__(23);
	var AccountingLockedWarning = __webpack_require__(123);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var venue_id = esUtils.toInt(data.venue);
			var stagetime_id = this.props.stagetime_id;
			if (stagetime_id < 1) {
				event.Stagetime = _.values(event.Stagetime); //ensure it's an array
				event.Stagetime.push({ id: stagetime_id });
			}
			_.each(event.Stagetime, function (stagetime) {
				if (stagetime.id == stagetime_id) {
					stagetime.description = data.description;
					stagetime.venueid = venue_id;
					stagetime.starttime = data.starttime;
					stagetime.stoptime = data.stoptime;
					stagetime.avchecktime = data.avchecktime;
					stagetime.room = data.room;
					stagetime.breakinfo = data.breakinfo;
				}
			});
			if (venue_id < 1) {
				event.Venue = _.values(event.Venue); //ensure it's an array
				event.Venue.push({ id: venue_id });
			}
			_.each(event.Venue, function (venue) {
				if (venue.id == venue_id) {
					venue.address = data.address;
					venue.building = data.building;
					venue.city = data.city;
					venue.country = data.country;
					venue.fax = data.fax;
					venue.phone = data.phone;
					venue.st = data.st;
					venue.timezone = data.timezone;
					venue.zip = data.zip;
				}
			});
			radio('event_schedule_change').broadcast(event);
			radio('save_Event').broadcast(event);
			this.props.onClose();
		},
		render: function render() {
			var event = this.props.event;
			var onClose = this.props.onClose;
			var Displaylists = this.props.Displaylists;
			var stagetime_id = this.props.stagetime_id;
			var stagetime = _.first(_.filter(event.Stagetime, function (s) {
				return s.id == stagetime_id;
			}));
	
			return Modal({
				title: stagetime_id > 0 ? 'Edit Stagetime' : 'New Stagetime',
				onClose: onClose,
				buttons: []
			}, StagetimeForm({
				event: event,
				stagetime: stagetime,
				Displaylists: Displaylists,
				onSubmit: this.__onSubmit,
				onCancel: onClose
			}));
		}
	});
	
	var StagetimeForm = dd.createClass({
		mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
		getInitialState: function getInitialState() {
			return { show_delete_confirm: false };
		},
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			var stagetime = props.stagetime;
			return stagetime && stagetime.id > 0 ? stagetime.id : -1;
		},
		getInitialValues: function getInitialValues(props) {
			var event = props.event;
			var stagetime = props.stagetime || {};
	
			var default_venue_id = _.first(_.map(_.map(event.Venue, "id"), esUtils.toInt)) || null;
			var venue_id = stagetime.venueid > 0 ? stagetime.venueid : default_venue_id;
	
			//new stagetime: default dates to previous stagetime
			if (_.isEmpty(_.get(stagetime, "id"))) {
				stagetime.starttime = undefined;
				_.each(event.Stagetime, function (event_stagetime) {
					if (undefined == stagetime.starttime || _.get(event_stagetime, 'starttime') > stagetime.starttime) {
						stagetime.starttime = _.get(event_stagetime, 'starttime');
					}
				});
				stagetime.starttime = undefined == stagetime.starttime ? new Date(new Date().toDateString()) : new Date(stagetime.starttime.toDateString()); //default to today + and trim time off
				stagetime.stoptime = stagetime.starttime;
			}
	
			return _.assign({
				description: stagetime.description,
				venue: venue_id,
				starttime: stagetime.starttime,
				stoptime: stagetime.stoptime,
				avchecktime: stagetime.avchecktime,
				room: stagetime.room,
				breakinfo: stagetime.breakinfo
			}, VenueForm.buildInitialValues(event, venue_id));
		},
		buildFields: function buildFields() {
			var data = this.state && this.state.data || {};
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
	
			return _.assign({
				description: {
					label: 'Description',
					type: 'text',
					placeholder: 'Description',
					validate: FormUtils.v.optional
				},
				starttime: {
					label: 'Start',
					type: 'date',
					placeholder: 'Start date and time',
					pick_time: true
				},
				stoptime: {
					label: 'End',
					type: 'date',
					placeholder: 'End date and time',
					pick_time: true,
					valid_range: {
						start: data.starttime
					}
				},
				avchecktime: {
					label: 'A/V check',
					type: 'date',
					placeholder: 'A/V Check date and time',
					pick_time: true,
					valid_range: {
						stop: data.starttime
					},
					validate: FormUtils.v.optional
				},
				room: {
					label: 'Room',
					type: 'text',
					placeholder: 'Room',
					validate: FormUtils.v.optional
				},
				venue: {
					label: 'Venue',
					type: 'select',
					options: _.object(_.map(event.Venue, function (venue) {
						return [venue.id, esUtils.venue_to_string(venue)];
					})),
					placeholder: '-- Add new Venue --',
					validate: FormUtils.v.optional //if nothing is selected, then it's in add a new venue mode
				}
			}, VenueForm.buildFields(Displaylists, data));
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			var self = this;
			var data = this.state && this.state.data || {};
			if (field_path === 'starttime' && _.isDate(new_value)) {
				this.setState({ data: data }, function () {
					if (!_.isDate(data.stoptime) || data.stoptime.getTime() < new_value.getTime()) {
						self._form_onChange('stoptime', _.cloneDeep(new_value));
					}
				});
			} else if (field_path === 'venue') {
				this.setState({ data: _.assign(data, VenueForm.buildInitialValues(this.props.event, new_value)) });
			}
			//from EventFormUnsavedChangeMixin
			this.__checkForChangesMade();
		},
		__toggleDeleteConfirm: esUtils.wrapPreventDefault(function () {
			this.setState({ show_delete_confirm: !this.state.show_delete_confirm });
		}),
		__onDelete: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var stagetime = this.props.stagetime;
			if (event && event.eid > 0 && stagetime && stagetime.id > 0) {
				event.Stagetime = _.reject(event.Stagetime, function (s) {
					return s.id == stagetime.id;
				});
				radio('save_Event').broadcast(event);
				this.props.onCancel();
			}
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var _props = this.props,
			    event = _props.event,
			    onCancel = _props.onCancel,
			    stagetime = _props.stagetime;
	
			var buildInput = this._form_buildInput;
			var show_delete_confirm = this.state.show_delete_confirm;
	
			var buildFields = function buildFields(layout) {
				return HorizontalFields({
					fields: fields,
					errors: errors,
					buildInput: buildInput,
					scale: 'sm',
					label_size: 2,
					layout: layout
				});
			};
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, buildFields([['description'], ['starttime'], ['stoptime'], ['avchecktime'], ['room']]), dd.hr(), buildFields([['venue']]), dd.br(), buildFields(VenueForm.horizontal_fields_layout), dd.p({ className: 'text-muted text-center', style: { fontStyle: "italic" } }, "Select venue's timezone, and set times for that timezone."), show_delete_confirm ? dd.div(null, dd.div({ className: 'alert alert-danger' }, dd.div(null, dd.strong(null, 'Are you sure'), ' you want to delete this stagetime?'), dd.button({ className: 'btn btn-danger', onClick: this.__onDelete }, 'Yes, delete'), ' ', dd.button({ className: 'btn btn-default', onClick: this.__toggleDeleteConfirm }, 'No, don\'t delete'))) : HorizontalFields.FormButtons({
				label_size: 3,
				submit_btn_text: stagetime && stagetime.id > 0 ? 'Save' : 'Add',
				onDiscard: stagetime && !_.isFunction(onCancel) ? this.__discardChanges : null,
				onCancel: onCancel,
				onDelete: stagetime && stagetime.id > 0 ? this.__toggleDeleteConfirm : null,
				right_align_buttons: true
			}), AccountingLockedWarning({ event: event }));
		}
	});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var DateRange = __webpack_require__(65);
	var StagetimeModal = __webpack_require__(296);
	var Constants = __webpack_require__(13);
	
	var timeOrBlakIfMidnight = function timeOrBlakIfMidnight(d) {
	  var time = esUtils.format_date(d, "h:MM TT");
	
	  return time === "12:00 AM" ? "" : time;
	};
	
	var timeZoneDisplay = function timeZoneDisplay(stagetime, venue) {
	  var r = "local time";
	
	  if (!_.isEmpty(_.get(venue, "timezone"))) {
	    var r2 = _.find(_.get(Constants, "TIMEZONE_DATA", []), { "timezone": _.get(venue, "timezone") });
	    r = _.get(r2, "abbreviation", _.get(venue, "timezone", ""));
	  }
	  return dd.span({ className: "text-muted", style: { "marginLeft": "1rem" } }, r.toUpperCase());
	};
	
	var Stagetime = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        venues = _props.venues,
	        stagetime = _props.stagetime,
	        clickEdit = _props.clickEdit;
	
	
	    var venue = null;
	    _.each(venues, function (v) {
	      if (v.id == stagetime.venueid) {
	        venue = v;
	      }
	    });
	
	    return dd.div({ className: "Stagetime" + (clickEdit ? " clickable" : ""), onClick: clickEdit || null }, clickEdit ? dd.span({ className: "pull-right" }, dd.a({ href: "#", onClick: clickEdit }, dd.i({ className: "fa fa-pencil" }), " Edit")) : null, stagetime.description ? dd.div(null, stagetime.description) : null, dd.div(null, dd.i({ className: "fa fa-calendar text-muted" }), " ", DateRange({ start: stagetime.starttime, start_format: "dddd, mmmm d, yyyy", stop: stagetime.stoptime, show_times: true }), timeZoneDisplay(stagetime, venue)), venue ? dd.div(null, dd.i({ className: "fa fa-map-marker text-muted" }), " " + esUtils.venue_to_string(venue)) : null, dd.div(null, stagetime.room ? dd.span(null, dd.b({ className: "text-muted" }, "Room"), " " + stagetime.room) : null, " ", _.isDate(stagetime.avchecktime) ? dd.span(null, dd.b({ className: "text-muted" }, "A/V check"), " " + esUtils.format_date(stagetime.avchecktime, "mm/d/yyyy"), " ", timeOrBlakIfMidnight(stagetime.avchecktime)) : null));
	  }
	});
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { editing_stagetime_id: null };
	  },
	  __setEditingStagetime: function __setEditingStagetime(id) {
	    return _.bind(esUtils.wrapPreventDefault(function () {
	      this.setState({ editing_stagetime_id: id });
	    }), this);
	  },
	  render: function render() {
	    var _props2 = this.props,
	        event = _props2.event,
	        Displaylists = _props2.Displaylists,
	        read_only = _props2.read_only;
	
	
	    return dd.div({ className: "Stagetimes" }, dd.h4({ className: "section-head" }, "Stagetimes", read_only ? null : dd.button({ className: "btn btn-default btn-sm pull-right", onClick: this.__setEditingStagetime(0) }, dd.i({ className: 'fa fa-plus' }), ' Add Stagetime')), dd.div({ className: "clearfix" }), _.isEmpty(event.Stagetime) ? dd.div({ className: "text-muted text-center" }, dd.h4(null, "No Stagetimes"), "Use the button above to add a stagetime") : dd.div(null, _.map(event.Stagetime, function (stagetime) {
	      return Stagetime({ key: stagetime.id, stagetime: stagetime, venues: event.Venue, clickEdit: read_only ? null : this.__setEditingStagetime(stagetime.id) });
	    }, this)), this.state.editing_stagetime_id !== null ? StagetimeModal({
	      event: event,
	      Displaylists: Displaylists,
	      stagetime_id: this.state.editing_stagetime_id,
	      onClose: this.__setEditingStagetime(null)
	    }) : null);
	  }
	});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var HorizontalFields = __webpack_require__(23);
	var FormUtils = __webpack_require__(9);
	
	module.exports = dd.createClass({
		getInitialState: function getInitialState() {
			return { show_form: false };
		},
		__toggleForm: esUtils.wrapPreventDefault(function () {
			this.setState({ show_form: !this.state.show_form });
		}),
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			event.sids = [_.parseInt(data.sid)];
			radio('save_Event').broadcast(event);
			this.setState({ show_form: false });
		},
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
	
			var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
			if (_.size(my_speakers) <= 1) {
				return dd.div();
			}
			if (!this.state.show_form) {
	
				return event.is_mp_event ? dd.div(null) : dd.p(null, dd.button({ className: 'btn btn-default', onClick: this.__toggleForm }, 'Change Speaker'));
			}
			return dd.div({ className: 'panel panel-default' }, dd.div({ className: 'panel-body' }, dd.h4({ className: 'section-head', style: { marginTop: 0 } }, 'Change Speaker'), DaForm({ event: event, my_speakers: my_speakers, onSubmit: this.__onSubmit, onCancel: this.__toggleForm })));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return esUtils.getEventVersionIdentifier(props.event);
		},
		getInitialValues: function getInitialValues(props) {
			return {
				sid: _.first(props.event.sids)
			};
		},
		buildFields: function buildFields() {
			var my_speakers = this.props.my_speakers;
			return {
				sid: {
					label: 'Speaker',
					type: 'select',
					options: my_speakers
				}
			};
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var onCancel = this.props.onCancel;
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), HorizontalFields.FormButtons({
				onCancel: onCancel
			}));
		}
	});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var HorizontalFields = __webpack_require__(23);
	var FormUtils = __webpack_require__(9);
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { show_form: false, loading: false, error_msg: null };
		},
		componentWillMount: function componentWillMount() {
			var self = this;
			self.radio = {
				copy_Event: function copy_Event(event_id, target_sid, copylists) {
					if (event_id === self.props.event.eid) {
						self.setState({ loading: true, error_msg: null });
					}
				},
				copy_Event_succeeded: function copy_Event_succeeded(event_id, new_event_id) {
					if (event_id === self.props.event.eid) {
						//clearing the event area, then opening the new copied event (otherwise the components wont un-mount)
						radio('Hashbang_set').broadcast('/');
						setTimeout(function () {
							radio('Hashbang_set').broadcast('/events/' + new_event_id);
						}, 100);
					}
				},
				copy_Event_failed: function copy_Event_failed(event_id, message) {
					if (event_id === self.props.event.eid) {
						self.setState({ loading: false, error_msg: 'Failed to copy event: ' + message });
					}
				}
			};
		},
		__onSubmit: function __onSubmit(data) {
			var event = this.props.event;
			radio('copy_Event').broadcast(event.eid, data.sid, data.copylists);
		},
		__toggleForm: esUtils.wrapPreventDefault(function () {
			this.setState({ show_form: !this.state.show_form });
		}),
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
			var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
			var thebutton = event.is_mp_event ? dd.div(null) : dd.p(null, dd.button({ className: 'btn btn-default', onClick: this.__toggleForm }, 'Copy event'));
	
			return this.state.show_form ? dd.div({ className: 'panel panel-default' }, dd.div({ className: 'panel-body' }, dd.h4({ className: 'section-head', style: { marginTop: 0 } }, 'Copy Event'), ErrorAlert({ message: this.state.error_msg }), LoadingWrap({ glass: true, is_loading: this.state.loading }, DaForm({ event: event, my_speakers: my_speakers, onSubmit: this.__onSubmit, onCancel: this.__toggleForm })))) : thebutton;
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return esUtils.getEventVersionIdentifier(props.event);
		},
		getInitialValues: function getInitialValues(props) {
			return {
				sid: _.first(props.event.sids),
				copylists: true
			};
		},
		buildFields: function buildFields() {
			var my_speakers = this.props.my_speakers;
			var schema = {};
			if (_.keys(my_speakers).length > 1) {
				schema.sid = {
					label: 'Copy to speaker',
					type: 'select',
					options: my_speakers
				};
			}
			schema.copylists = {
				label: 'Copy lists (services, contacts, actions etc...)',
				type: 'checkbox'
			};
			return schema;
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var onCancel = this.props.onCancel;
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), HorizontalFields.FormButtons({
				submit_btn_text: 'Copy',
				onCancel: onCancel
			}));
		}
	});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var RadioMixin = __webpack_require__(22);
	var esUtils = __webpack_require__(2);
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { confirmMode: false, deleting: false, error_msg: null };
		},
		componentWillMount: function componentWillMount() {
			var self = this;
			self.radio = {
				'Event_destroy_failed': function Event_destroy_failed(event_id, message) {
					if (self.props.event && self.props.event.eid == event_id) {
						self.setState({ deleting: false, error_msg: 'Failed to delete event: ' + message });
					}
				}
			};
		},
		__toggleConfirmMode: esUtils.wrapPreventDefault(function () {
			this.setState({ confirmMode: !this.state.confirmMode });
		}),
		__resetState: esUtils.wrapPreventDefault(function () {
			this.setState({ confirmMode: false, deleting: false, error_msg: null });
		}),
		__delete: esUtils.wrapPreventDefault(function () {
			var event_id = _.parseInt(this.props.event && this.props.event.eid);
			if (_.isNaN(event_id) || event_id < 1) {
				return;
			}
			radio('Event_destroy').broadcast(event_id);
			this.setState({ deleting: true });
		}),
		render: function render() {
			var event = this.props.event;
	
			if (event.is_mp_event) {
				return dd.div(null);
			}
			if (!this.state.confirmMode && !this.state.deleting) {
				return dd.button({ className: 'btn btn-default', onClick: this.__toggleConfirmMode }, 'Delete event');
			}
			var body = null;
			if (this.state.error_msg) {
				body = dd.div(null, dd.a({ href: '#', className: 'pull-right', onClick: this.__resetState }, 'close'), this.state.error_msg);
			} else if (this.state.deleting) {
				body = dd.div({ className: 'text-center' }, dd.b(null, 'Deleting...'));
			} else {
				body = dd.div({ className: '' }, dd.p(null, dd.b(null, 'Are you sure?'), ' DELETE is going to remove this event, "' + event.organization + '," ', dd.b(null, 'permanently. '), 'A better option is to change the status to Canceled/Released so that the data can be retrieved.'), dd.button({ className: 'btn btn-danger', onClick: this.__delete }, 'Yes, Delete'), ' ', dd.button({ className: 'btn btn-default', onClick: this.__toggleConfirmMode }, 'No, don\'t delete'));
			}
			return dd.div({ className: 'alert alert-danger', style: { marginBottom: 0 } }, body);
		}
	});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var ImportEvent = __webpack_require__(89);
	
	module.exports = dd.createClass({
	  mixins: [],
	  getInitialState: function getInitialState() {
	    return { show_form: false };
	  },
	
	  __toggleForm: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_form: !this.state.show_form });
	  }),
	  render: function render() {
	    var event = this.props.event;
	    var Displaylists = this.props.Displaylists;
	
	    return this.state.show_form ? dd.div({ className: "panel panel-default" }, dd.div({ className: "panel-body" }, dd.h4({ className: "section-head", style: { marginTop: 0 } }, "Link HighLevel Opportunity"), ImportEvent({
	      Displaylists: Displaylists,
	      service_to_import_from: "hl",
	      link_to_event: event
	    }))) : dd.p(null, dd.button({
	      disabled: !_.isEmpty(_.get(event, "foreignKey")),
	      className: "btn btn-default",
	      style: { marginTop: "1rem" },
	      onClick: this.__toggleForm
	    }, "Link HighLevel Opportunity"));
	  }
	});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	var ImportEvent = __webpack_require__(89);
	
	module.exports = dd.createClass({
	  mixins: [],
	  getInitialState: function getInitialState() {
	    return { show_form: false };
	  },
	
	  __toggleForm: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_form: !this.state.show_form });
	  }),
	  render: function render() {
	    var event = this.props.event;
	    var Displaylists = this.props.Displaylists;
	
	    return this.state.show_form ? dd.div({ className: "panel panel-default" }, dd.div({ className: "panel-body" }, dd.h4({ className: "section-head", style: { marginTop: 0 } }, "Link SpeakerFlow/Zoho Opportunity"), ImportEvent({
	      Displaylists: Displaylists,
	      service_to_import_from: "zoho",
	      link_to_event: event
	    }))) : dd.p(null, dd.button({
	      disabled: !_.isEmpty(_.get(event, "foreignKey")),
	      className: "btn btn-default",
	      style: { marginTop: "0.25rem" },
	      onClick: this.__toggleForm
	    }, "Link SpeakerFlow/Zoho Opportunity"));
	  }
	});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var CopyEvent = __webpack_require__(299);
	var DeleteEvent = __webpack_require__(300);
	var ChangeSpeaker = __webpack_require__(298);
	var LinkOpportunityZoho = __webpack_require__(302);
	var LinkOpportunityHighlevel = __webpack_require__(301);
	var isEventAccountingLockedForMe = __webpack_require__(55);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  __emailToCoWorkers: esUtils.wrapPreventDefault(function () {
	    radio("send_event_to_coworkers").broadcast(this.props.event);
	  }),
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	
	    return dd.div({ className: "well" }, dd.h3({ style: { margin: "0 0 20px 0" } }, "Event Actions"), dd.p(null, dd.button({ className: "btn btn-default", onClick: this.__emailToCoWorkers }, "Email to Co-workers")), CopyEvent({ event: event, Displaylists: Displaylists }), isEventAccountingLockedForMe(event) || !AuthedUserSession.doIHaveAccess.full.any(event.sids) ? null : ChangeSpeaker({ event: event, Displaylists: Displaylists }), isEventAccountingLockedForMe(event) || !AuthedUserSession.doIHaveAccess.full.any(event.sids) ? null : DeleteEvent({ event: event }), AuthedUserSession.is_privatelabel ? null : LinkOpportunityHighlevel({ Displaylists: Displaylists, event: event }), AuthedUserSession.is_privatelabel ? null : LinkOpportunityZoho({ Displaylists: Displaylists, event: event }));
	  }
	});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Notes = __webpack_require__(290);
	var Bureau = __webpack_require__(288);
	var SalesRep = __webpack_require__(295);
	var esUtils = __webpack_require__(2);
	var Stagetimes = __webpack_require__(297);
	var EventActions = __webpack_require__(303);
	var BasicDetails = __webpack_require__(287);
	var AuthedUserSession = __webpack_require__(4);
	var ParentChildControls = __webpack_require__(294);
	var isEventAccountingLockedForMe = __webpack_require__(55);
	var _ = __webpack_require__(1);
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { show_actions: false };
	  },
	
	  __toggleShowActions: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_actions: !this.state.show_actions });
	  }),
	  __reloadEvent: esUtils.wrapPreventDefault(function () {
	    if (this.props.event && this.props.event.eid > 0) {
	      radio("reload_Event").broadcast(this.props.event.eid);
	    }
	  }),
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    var is_read_or_travel = AuthedUserSession.doIHaveAccess.read_or_travel.all(event.sids);
	    var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
	    var preferences = _.get(Displaylists, "user.myevents_preferences", {});
	    var show_parentchild = !event.is_mp_event && (_.get(preferences, "show_parent_child_ui", false) || AuthedUserSession.is_st_family && !AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids));
	    var is_cs = AuthedUserSession.is_cs;
	
	    return dd.div({ className: "EventDetails" }, dd.h2(null, "Event Details", dd.span({ className: "pull-right" }, is_read_or_travel || is_limited_speaker ? null : dd.a({
	      href: "/reports/loader.php?report=eventdetails.php&eid=" + event.eid + "&output_format=html",
	      target: "_blank",
	      style: {
	        fontWeight: "normal",
	        fontSize: "14px",
	        marginRight: "5px"
	      }
	    }, dd.i({ className: "fa fa-print" }), " Print"), show_parentchild ? ParentChildControls({ event: event, Displaylists: Displaylists }) : null, " ", is_read_or_travel || is_limited_speaker ? null : dd.button({
	      className: "btn btn-sm btn-default" + (this.state.show_actions ? " active" : ""),
	      onClick: this.__toggleShowActions
	    }, "Event Actions"), " ", dd.button({
	      className: "btn btn-sm btn-default",
	      onClick: this.__reloadEvent
	    }, dd.i({ className: "fa fa-refresh" })))), !this.state.show_actions ? null : EventActions({ event: event, Displaylists: Displaylists }), BasicDetails({
	      event: event,
	      Displaylists: Displaylists,
	      read_only: is_read_or_travel || is_limited_speaker || event.is_mp_event
	    }), Stagetimes({
	      event: event,
	      Displaylists: Displaylists,
	      read_only: is_read_or_travel || is_limited_speaker || event.is_mp_event || isEventAccountingLockedForMe(event) || (AuthedUserSession.privatelabel_code === "cs" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false)
	    }), AuthedUserSession.is_st_family ? SalesRep({
	      form_section_name: "Internal Team",
	      event: event,
	      Displaylists: Displaylists,
	      read_only: is_read_or_travel || is_limited_speaker || event.is_mp_event,
	      is_limited_speaker: is_limited_speaker
	    }) : Bureau({
	      form_section_name: "Bureau",
	      event: event,
	      Displaylists: Displaylists,
	      read_only: is_read_or_travel || is_limited_speaker || event.is_mp_event,
	      is_limited_speaker: is_limited_speaker
	    }), !is_limited_speaker || is_cs ? Notes({
	      event: event,
	      Displaylists: Displaylists,
	      read_only: is_read_or_travel
	    }) : null);
	  }
	});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var ezHorizontalFields = __webpack_require__(25);
	var createStandardEventForm = __webpack_require__(30);
	var SlideOpenDown = __webpack_require__(27);
	var HorizontalFieldSpot = __webpack_require__(47);
	var FormButtons = __webpack_require__(36);
	
	module.exports = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	    return {
	      evaluation_type: _.get(event, ["Evaluation", "evaluation_type"]) || 0,
	      not_evaluated: _.get(event, ["Evaluation", "not_evaluated"], true),
	      score: parseFloat(_.get(event, ["Evaluation", "score"])).toFixed(2) || 0,
	      audience_size: _.get(event, ["audienceSize"]) || "",
	      eval_link: _.get(event, ["Evaluation", "eval_link"]) || '',
	      tracking_number: _.get(event, ["Evaluation", "tracking_number"]) || '',
	      return_tracking_number: _.get(event, ["Evaluation", "return_tracking_number"]) || '',
	      num_forms: _.get(event, ["Evaluation", "num_forms"]) || 0,
	      sent_date: !_.isEmpty(_.get(event, ["Evaluation", "sent_date"])) && _.get(event, ["Evaluation", "sent_date"], "12/31/1969") !== "12/31/1969" ? new Date(_.get(event, ["Evaluation", "sent_date"])) : "",
	      received_date: !_.isEmpty(_.get(event, ["Evaluation", "received_date"])) && _.get(event, ["Evaluation", "sent_date"], "12/31/1969") !== "12/31/1969" ? new Date(_.get(event, ["Evaluation", "received_date"])) : null,
	      comments: _.get(event, ["Evaluation", "comments"]) || '',
	      presenter_feedback: _.get(event, ["Evaluation", "presenter_feedback"]) || '',
	      customer_feedback: _.get(event, ["Evaluation", "customer_feedback"]) || '',
	      additional_feedback: _.get(event, ["Evaluation", "additional_feedback"]) || '',
	      service_recovery: _.get(event, ["Evaluation", "service_recovery"]) || 0,
	      service_recovery_amount: _.get(event, ["Evaluation", "service_recovery_amount"]) || 0,
	      service_recovery_notes: _.get(event, ["Evaluation", "service_recovery_notes"]) || ''
	    };
	  },
	  buildSchema: function buildSchema(_ref, data) {
	    var event = _ref.event,
	        Displaylists = _ref.Displaylists,
	        is_limited_speaker = _ref.is_limited_speaker;
	
	    var evaluation_types = _.get(Displaylists, ["sitelists", "evaluation_types"], []);
	
	    var schema = {
	      evaluation_type: {
	        label: "Form Type",
	        type: "newselect",
	        placeholder: "-- select an evaluation form --",
	        optgroups: ["Electronic Forms", "In Person Forms"],
	        options: _.map(evaluation_types, function (evaluation_type) {
	          return {
	            optgroup: _.get(evaluation_type, ["electronic"]) === 1 ? "Electronic Forms" : "In Person Forms",
	            value: _.get(evaluation_type, ["id"]),
	            label: _.get(evaluation_type, ["name"]) + " - " + _.get(evaluation_type, ["description"])
	          };
	        }),
	        validate: function validate(value) {
	          if (!data.not_evaluated && _.isNaN(_.parseInt(value))) {
	            return 'You must select an evaluation';
	          }
	          return true;
	        },
	        disabled: data.not_evaluated
	      },
	      not_evaluated: {
	        label: "Not Evaluated",
	        type: "checkbox"
	      },
	      score: {
	        label: "Cumulative Score",
	        type: "evaluation",
	        className: "form-control",
	        placeholder: "0.00",
	        validate: function validate(value) {
	          if (!data.not_evaluated && _.isNaN(parseFloat(value))) {
	            return 'You must enter a score';
	          }
	          return true;
	        },
	        disabled: data.not_evaluated
	      },
	      audience_size: {
	        label: "Audience Size",
	        type: "text",
	        placeholder: "0"
	      },
	      tracking_number: {
	        label: "Tracking #",
	        type: "text",
	        placeholder: "123456789",
	        disabled: data.not_evaluated
	      },
	      return_tracking_number: {
	        label: "Return Tracking #",
	        type: "text",
	        placeholder: "123456789",
	        disabled: data.not_evaluated
	      },
	      num_forms: {
	        label: "Number of Evaluation Forms",
	        type: "text",
	        placeholder: "0",
	        disabled: data.not_evaluated
	      },
	      sent_date: {
	        label: "Date Sent",
	        type: "date",
	        read_only: data.not_evaluated,
	        validate: function validate(value) {
	          return true;
	        }
	      },
	      received_date: {
	        label: "Date Received",
	        type: "date",
	        read_only: data.not_evaluated,
	        validate: function validate(value) {
	          return true;
	        }
	      },
	      comments: {
	        label: "Summary of Evaluation Comments",
	        type: "textarea",
	        rows: 5,
	        placeholder: "Enter summary of returned evaluation comments..."
	        // disabled: data.not_evaluated
	      },
	      presenter_feedback: {
	        label: "Presenter Feedback",
	        type: "textarea",
	        rows: 5,
	        placeholder: "Enter summary of presenter feedback..."
	        // disabled: data.not_evaluated
	      },
	      customer_feedback: {
	        label: "Customer Feedback",
	        type: "textarea",
	        rows: 5,
	        placeholder: "Enter summary of customer feedback..."
	        // disabled: data.not_evaluated
	      },
	      additional_feedback: {
	        label: "Additional Feedback & Next Steps",
	        type: "textarea",
	        rows: 5,
	        placeholder: "Enter any additional feedback received and next steps from host and presenter..."
	        // disabled: data.not_evaluated
	      },
	      service_recovery: {
	        label: "Service Recovery",
	        type: "newselect",
	        options: [{ value: 0, label: "Not needed" }, { value: 1, label: "Needed" }, { value: 2, label: "Complete" }]
	        // disabled: data.not_evaluated
	      },
	      service_recovery_amount: {
	        label: "Amount",
	        type: "text",
	        placeholder: "0.00",
	        // disabled: data.not_evaluated,
	        validate: function validate(value) {
	          // if (!data.not_evaluated && !_.contains([0], data.service_recovery) && _.isNaN(value)) {
	          //   return 'You must enter an amount > 0 when service recovery is set';
	          // }
	          return true;
	        }
	      },
	      service_recovery_notes: {
	        label: "Recovery Option Description",
	        type: "textarea",
	        rows: 5,
	        placeholder: "Enter notes regarding service recovery...",
	        // disabled: data.not_evaluated,
	        validate: function validate(value) {
	          // if (!data.not_evaluated && !_.contains([0], data.service_recovery) && _.isEmpty(value)) {
	          //   return 'You must enter comments when service recovery is set';
	          // }
	          return true;
	        }
	      }
	    };
	
	    if (_.get(_.find(evaluation_types, { "id": _.parseInt(data.evaluation_type) }), ["electronic"], 0) === 1) {
	      schema.eval_link = {
	        label: "Evaluation Form Link",
	        type: "text",
	        placeholder: "https://www.google.com",
	        disabled: data.not_evaluated
	      };
	    }
	
	    return schema;
	  },
	  onFormChanged: function onFormChanged(field_path, new_value, data, onChange) {
	    if (field_path === 'return_tracking_number') {
	      if (new_value !== null && !_.isDate(_.get(data, ["sent_date"], ""))) {
	        onChange("sent_date", new Date());
	      }
	    }
	    if (field_path === 'service_recovery_amount') {}
	    return data;
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    event.audienceSize = _.get(data, ["audience_size"]) || 0;
	    event.Evaluation = data;
	  },
	  renderFields: function renderFields() {
	    var changes_made = this.Form_areChangesMade();
	
	    return dd.div(null, dd.h2(null, "Evaluation"), ezHorizontalFields(this, [["evaluation_type"], ["not_evaluated"], ["score"], ["audience_size"], ["eval_link"], ["tracking_number"], ["return_tracking_number"], ["num_forms"], ["sent_date"], ["received_date"]]), SlideOpenDown({ open: changes_made }, HorizontalFieldSpot(null, FormButtons({ onDiscard: this.__discardChanges }))), dd.hr(), dd.h4({ className: "section-head" }, "Notes"), ezHorizontalFields(this, [["comments"], ["presenter_feedback"], ["customer_feedback"], ["additional_feedback"]]), dd.hr(), dd.h4({ className: "section-head" }, "Service Recovery"), ezHorizontalFields(this, [["service_recovery"], ["service_recovery_amount"], ["service_recovery_notes"]]));
	  }
	});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var EvalForm = __webpack_require__(305);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
	
	    return dd.div({ className: "Evals" }, EvalForm({
	      event: event,
	      Displaylists: Displaylists,
	      read_only: AuthedUserSession.privatelabel_code === "st" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
	      is_limited_speaker: is_limited_speaker
	    }));
	  }
	});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	
	var StoredFileModal = __webpack_require__(125);
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { file_id_editing: null, deleting: -1, file_id_confirming_delete: -1, error_msg: null };
		},
		componentWillMount: function componentWillMount() {
			var self = this;
			self.radio = {
				StoredFile_remove: function StoredFile_remove(eid, fileid) {
					if (eid === (self.props.event && self.props.event.eid)) {
						self.setState({ deleting: fileid, file_id_confirming_delete: -1, error_msg: null });
					}
				},
				StoredFile_remove_succeeded: function StoredFile_remove_succeeded(eid, fileid, storedfiles) {
					if (eid === (self.props.event && self.props.event.eid)) {
						self.setState({ deleting: -1, file_id_confirming_delete: -1, error_msg: null });
					}
				},
				StoredFile_remove_failed: function StoredFile_remove_failed(eid, fileid, message) {
					if (eid === (self.props.event && self.props.event.eid)) {
						self.setState({ deleting: -1, file_id_confirming_delete: -1, error_msg: 'Failed to delete: ' + message });
					}
				}
			};
		},
		__clickDelete: function __clickDelete(id) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				self.setState({ file_id_confirming_delete: id });
			});
		},
		__deleteFile: function __deleteFile(id) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				radio('StoredFile_remove').broadcast(self.props.event.eid, id);
			});
		},
		__downloadURL: function __downloadURL(url) {
			return esUtils.wrapPreventDefault(function () {
				window.open(url);
			});
		},
		__setEditingId: function __setEditingId(id) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				self.setState({ file_id_editing: id });
			});
		},
		render: function render() {
			var event = this.props.event;
			var deleting = this.state.deleting;
			var error_msg = this.state.error_msg;
			var file_id_confirming_delete = this.state.file_id_confirming_delete;
	
			return dd.div(null, dd.h4({ className: 'section-head' }, 'Attached Files'), ErrorAlert({ message: error_msg }), LoadingWrap({ is_loading: deleting > 0, glass: true }, dd.table({ className: 'table table-responsive table-condensed table-hover FilesList', style: { marginBottom: 10 } }, dd.thead(null, dd.tr(null, dd.th(null, 'File'), dd.th({ style: { width: 1 } }, 'Posted'), dd.th({ style: { width: '1.5em' } }), dd.th({ style: { width: '1.5em' } }))), dd.tbody(null, _.map(event.storedfiles, function (file, i) {
				var confirm_delete = file.id === file_id_confirming_delete;
				var is_deleting = file.id === deleting;
				return dd.tr({ key: i, className: 'file clickable' }, dd.td({ onClick: this.__downloadURL(file.url) }, dd.i({ className: 'file-icon fa ' + Constants.getFileTypeIcon(file.url) }), file.description), confirm_delete || is_deleting ? null : dd.td({ onClick: this.__downloadURL(file.url) }, esUtils.format_date(file.postdate, 'mm/dd/yyyy')), confirm_delete || is_deleting ? null : dd.td(null, dd.a({ href: '#', onClick: this.__setEditingId(file.id) }, dd.i({ className: 'fa fa-pencil' }))), confirm_delete || is_deleting ? null : dd.td(null, dd.a({ href: '#', onClick: this.__clickDelete(file.id) }, dd.i({ className: 'fa fa-times' }))), confirm_delete || is_deleting ? dd.td({ colSpan: 3 }, confirm_delete ? dd.div({ className: 'btn-group' }, dd.button({ className: 'btn btn-danger btn-sm', onClick: this.__deleteFile(file.id) }, 'Delete'), dd.button({ className: 'btn btn-default btn-sm', onClick: this.__clickDelete(-1) }, 'No')) : null, is_deleting ? 'Deleting....' : null) : null);
			}, this), !_.isArray(event.storedfiles) || event.storedfiles.length === 0 ? dd.tr(null, dd.td({ colSpan: 4 }, dd.div({ className: 'text-center emptylist' }, 'Attach files for this event (contract, spreadsheets, etc.) by clicking ATTACH FILE.'))) : null)), dd.div(null, dd.button({ className: 'btn btn-default btn-sm pull-right', onClick: this.__setEditingId(0) }, dd.i({ className: 'fa fa-paperclip' }), ' Attach File'), dd.div({ className: 'clearfix' }))), this.state.file_id_editing !== null ? StoredFileModal({
				event: event,
				file_id: this.state.file_id_editing,
				onClose: this.__setEditingId(null)
			}) : null);
		}
	});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	
	module.exports = dd.createClass({
		render: function render() {
			var event = this.props.event;
	
			return dd.div(null, dd.h4({ className: 'section-head' }, 'Relay Opportunity'), dd.div(null, dd.div({}, 'This event is linked to a relay opportunity (' + _.get(event, ["relay"]) + ').'), dd.a({ className: 'btn btn-default btn-sm pull-right', href: '/admin/pd-sales-relay/' + _.get(event, ["relay"]) + '/relay-full-detail' }, dd.i({ className: 'fa fa-external-link' }), ' View Opportunity'), dd.div({ className: 'clearfix' })));
		}
	});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioMixin = __webpack_require__(22);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var AuthedUserSession = __webpack_require__(4);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	
	var StoredFileModal = __webpack_require__(125);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return {
	      file_id_editing: null,
	      file_id_deleting: null,
	      file_id_merging: null,
	      show_placeholder_codes: false
	    };
	  },
	  __toggleShowPlaceholderCodes: esUtils.wrapPreventDefault(function () {
	    this.setState({
	      show_placeholder_codes: !this.state.show_placeholder_codes
	    });
	  }),
	  __clickDelete: function __clickDelete(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ file_id_deleting: id });
	    });
	  },
	  __setEditingId: function __setEditingId(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ file_id_editing: id });
	    });
	  },
	  __clickMerge: function __clickMerge(id) {
	    var self = this;
	    return esUtils.wrapPreventDefault(function () {
	      self.setState({ file_id_merging: id });
	    });
	  },
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	
	    var show_placeholder_codes = this.state.show_placeholder_codes;
	    var templates = [];
	    var template_ids_can_manage = [];
	
	    if (AuthedUserSession.is_st_family) {
	      template_ids_can_manage = []; //only managed through team admin
	      templates = _.get(Displaylists, ["sitelists", "templates"], []);
	      templates = _.sortBy(templates, ["description"]);
	    } else {
	      var my_template_ids = _.uniq(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, event.sids), "templatefile_ids")));
	      var all_templatefiles_by_id = esUtils.getIn(Displaylists, ["speaker_shared", "templatefiles"]) || {};
	      templates = _.sortBy(_.uniq(_.compact(_.map(my_template_ids, function (id) {
	        return all_templatefiles_by_id[id];
	      })), "id"), function (template) {
	        return template.description.trim().toLowerCase();
	      });
	
	      var sids_can_manage = _.intersection(event.sids, AuthedUserSession.doIHaveAccess.admin.getSIDs());
	      template_ids_can_manage = _.filter(_.uniq(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, sids_can_manage), "templatefile_ids"))), function (id) {
	        var template_sids = all_templatefiles_by_id[id] && all_templatefiles_by_id[id].sids;
	        return !_.isEmpty(_.intersection(template_sids, sids_can_manage));
	      });
	    }
	
	    var panelStyle = AuthedUserSession.is_st_family ? { maxHeight: "25em", overflowY: "auto" } : {};
	
	    return dd.div({ className: "Library" }, dd.a({
	      href: "#",
	      className: "pull-right printlink",
	      onClick: this.__toggleShowPlaceholderCodes
	    }, "view placeholder codes"), dd.h4({
	      className: "section-head",
	      style: { marginBottom: "1em", marginTop: 25 }
	    }, "Template Library"), dd.div({ style: panelStyle }, dd.table({
	      className: "table table-responsive table-condensed table-hover Templates",
	      style: { marginBottom: 10 }
	    }, dd.tbody(null, _.map(templates, function (template, i) {
	      var can_manage = _.includes(template_ids_can_manage, template.id);
	      return dd.tr({ key: i, className: "template" }, dd.td({
	        className: "clickable" + (!can_manage ? " common" : ""),
	        onClick: this.__clickMerge(template.id)
	      }, dd.i({
	        className: "file-icon fa " + Constants.getFileTypeIcon(template.url)
	      }), template.description), dd.td({ style: {} }, can_manage ? dd.a({
	        href: "#",
	        onClick: this.__setEditingId(template.id)
	      }, dd.i({ className: "fa fa-pencil" })) : null), dd.td({ style: {} }, can_manage ? dd.a({
	        href: "#",
	        onClick: this.__clickDelete(template.id)
	      }, dd.i({ className: "fa fa-times" })) : null), dd.td({ style: {} }, dd.button({
	        className: "btn btn-default btn-sm pull-right",
	        onClick: this.__clickMerge(template.id)
	      }, "merge")));
	    }, this), _.isEmpty(templates) === 0 ? dd.tr(null, dd.td({ colSpan: 4 }, dd.div({ className: "text-center" }, "-- no templates --"))) : null))), AuthedUserSession.doIHaveAccess.admin.any(event.sids) ? dd.div({ style: { marginTop: "1em" } }, dd.button({
	      className: "btn btn-default btn-sm pull-right",
	      onClick: this.__setEditingId(0)
	    }, dd.i({ className: "fa fa-file-o" }), " Add Template"), dd.div({ className: "clearfix" })) : null, dd.div({ className: "clearfix", style: { height: 20 } }),
	
	    //modals
	    show_placeholder_codes ? PlaceholderCodesModal({
	      onClose: this.__toggleShowPlaceholderCodes,
	      Displaylists: Displaylists
	    }) : null, this.state.file_id_editing !== null ? StoredFileModal({
	      //Don't pass event, b/c this is event-less (if you pass it it'll attach the file to the event, not as a template)
	      sids_to_apply_to: event.sids,
	      Displaylists: Displaylists,
	      file_id: this.state.file_id_editing,
	      onClose: this.__setEditingId(null)
	    }) : null, this.state.file_id_deleting > 0 ? DeleteTemplateModal({
	      sids_to_apply_to: event.sids,
	      file_id: this.state.file_id_deleting,
	      onClose: this.__clickDelete(null)
	    }) : null, this.state.file_id_merging > 0 ? MergeTemplateModal({
	      event_id: event && event.eid,
	      file_id: this.state.file_id_merging,
	      onClose: this.__clickMerge(null)
	    }) : null);
	  }
	});
	
	var PlaceholderCodesModal = dd.createClass({
	  __onCopy: esUtils.wrapPreventDefault(function (e) {
	    var textArea = document.createElement("textarea");
	    textArea.value = e.target.textContent;
	    document.body.appendChild(textArea);
	    textArea.select();
	    document.execCommand("Copy");
	    textArea.remove();
	
	    this.setState({ copySuccess: true, copyKey: e.target.textContent }); //the copyKey re-triggers animation
	  }),
	  render: function render() {
	    var placeholdercodes = esUtils.getIn(this.props, ["Displaylists", "universal", "placeholdercodes"]) || [];
	    placeholdercodes = _.map(placeholdercodes, function (k, v) {
	      return { code: v, description: k };
	    });
	    placeholdercodes = _.sortBy(placeholdercodes, "description");
	
	    var me = this;
	    return Modal({
	      title: "Placeholder Codes",
	      onClose: this.props.onClose
	    }, dd.div({ className: "alert" }, dd.p({}, "Create template documents using Word (.docx) and Excel (.xlsx)."), dd.p({}, 'Placeholder codes in template documents are replaced with data from the event during the merge. "xxxx" values in SERVICE and CONTACT placeholders match on those items\' group codes.'), dd.p({}, "More information about using placeholders in template documents is available ", dd.a({
	      href: "https://www.espeakers.com/wiki/Library_template_creation_instructions_(using_Placeholder_codes)",
	      target: "_blank"
	    }, "here"), ".")), dd.div({ style: { maxHeight: "20em", overflowY: "scroll" } }, dd.table({ className: "table table-responsive table-condensed" }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, "Code"), dd.th(null, "Description"))), dd.tbody(null, _.map(_.sortBy(placeholdercodes, "description"), function (o, i) {
	      return dd.tr({ key: i }, dd.td(null, dd.span({
	        className: "code",
	        onClick: me.__onCopy,
	        dataCode: _.get(o, "code")
	      }, "[[" + _.get(o, "code") + "]]")), dd.td(null, _.get(o, "description")));
	    })))), _.get(this.state, "copySuccess", false) ? dd.div({
	      key: _.get(this.state, "copyKey", ""),
	      style: {
	        color: "green",
	        marginLeft: "1rem",
	        marginTop: "0.5rem"
	      },
	      className: "fadein"
	    }, dd.i({
	      className: "fa fa-clipboard",
	      style: { marginRight: "0.5rem" }
	    }), "copied") : null);
	  }
	});
	
	var DeleteTemplateModal = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { deleting: false, error_msg: null };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      StoredFile_remove: function StoredFile_remove(eid, fileid) {
	        if (fileid === self.props.file_id) {
	          self.setState({ deleting: true, error_msg: null });
	        }
	      },
	      StoredFile_remove_succeeded: function StoredFile_remove_succeeded(eid, fileid, storedfiles) {
	        if (fileid === self.props.file_id) {
	          self.props.onClose();
	        }
	      },
	      StoredFile_remove_failed: function StoredFile_remove_failed(eid, fileid, message) {
	        if (fileid === self.props.file_id) {
	          self.setState({
	            deleting: false,
	            error_msg: "Failed to delete: " + message
	          });
	        }
	      }
	    };
	  },
	  __delete: esUtils.wrapPreventDefault(function () {
	    radio("StoredFile_remove").broadcast(-1, this.props.file_id, this.props.sids_to_apply_to);
	  }),
	  render: function render() {
	    var onClose = this.props.onClose;
	    if (this.state.deleting) {
	      return Modal({
	        title: "Deleting...",
	        onClose: null,
	        buttons: []
	      }, LoadingWrap({ is_loading: true, text: "Deleting..." }));
	    }
	    if (this.state.error_msg) {
	      return Modal({
	        title: "Error Deleting",
	        onClose: onClose
	      }, ErrorAlert({ message: this.state.error_msg }));
	    }
	
	    return Modal({
	      title: "Are you sure?",
	      onClose: null,
	      buttons: []
	    }, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-muted text-center" }, dd.i({ className: "fa fa-warning", style: { fontSize: 70 } })), dd.div({ className: "col-sm-9" }, dd.p(null, "Deleting a template affects all events for this speaker."), dd.p(null, "Are you sure you want to delete it?"))), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-danger", onClick: this.__delete }, "Yes, delete"), " ", dd.button({ className: "btn btn-default", onClick: onClose }, "No, don't delete")));
	  }
	});
	
	var MergeTemplateModal = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      merging: true, //right off the bat we'll start the merge
	      error_msg: null,
	      success_data: null
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var self = this;
	    self.radio = {
	      MergeDocument: function MergeDocument(event_id, template_id) {
	        if (self.props.event_id === event_id && self.props.file_id === template_id) {
	          self.setState({ merging: true, error_msg: null, success_data: null });
	        }
	      },
	      MergeDocument_succeeded: function MergeDocument_succeeded(event_id, template_id, data) {
	        if (self.props.event_id === event_id && self.props.file_id === template_id) {
	          self.setState({
	            merging: false,
	            error_msg: null,
	            success_data: data
	          });
	        }
	      },
	      MergeDocument_failed: function MergeDocument_failed(event_id, template_id, message) {
	        if (self.props.event_id === event_id && self.props.file_id === template_id) {
	          self.setState({
	            merging: false,
	            error_msg: message,
	            success_data: null
	          });
	        }
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    radio("MergeDocument").broadcast(this.props.event_id, this.props.file_id);
	  },
	  __clickDownload: esUtils.wrapPreventDefault(function (url) {
	    window.location.assign(url);
	    this.props.onClose();
	  }),
	
	  render: function render() {
	    var onClose = this.props.onClose;
	    if (this.state.merging) {
	      return Modal({
	        title: "Merging...",
	        onClose: null,
	        buttons: []
	      }, LoadingWrap({ is_loading: true, text: "Merging..." }));
	    }
	    if (this.state.error_msg) {
	      return Modal({
	        title: "Error Merging",
	        onClose: onClose
	      }, ErrorAlert({ message: this.state.error_msg }));
	    }
	    var data = this.state.success_data || {};
	
	    return Modal({
	      title: "Done Merging",
	      onClose: onClose,
	      buttons: []
	    }, dd.div({ className: "alert alert-success" }, data.message || "Finished merging!"), dd.div({ className: "text-center" }, dd.p(null, data.outputfilename), dd.a({
	      className: "btn btn-primary",
	      target: "_self",
	      onClick: this.__clickDownload.bind(this, data.download_url)
	    }, dd.i({ className: "fa fa-download" }), " Download")));
	  }
	});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var ProOnly = __webpack_require__(34);
	var AttachedFiles = __webpack_require__(307);
	var TemplateLibrary = __webpack_require__(309);
	var RelayOpportunity = __webpack_require__(308);
	
	module.exports = dd.createClass({
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
	
			return dd.div({ className: 'Library' }, ProOnly({
				sids: event.sids,
				custom_message: 'PRO users attach files like contracts and presentations right to the event so they are always available. Upload Word and Excel template documents and generate contracts, thank-you letters, and more with a touch.'
			}, dd.h2(null, 'Library'), _.get(event, ["relay"], 0) > 0 ? RelayOpportunity({ event: event, Displaylists: Displaylists }) : null, AttachedFiles({ event: event, Displaylists: Displaylists }), TemplateLibrary({ event: event, Displaylists: Displaylists })));
		}
	});

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ErrorAlert = __webpack_require__(6);
	
	var _ErrorAlert2 = _interopRequireDefault(_ErrorAlert);
	
	var _MessagePreview = __webpack_require__(341);
	
	var _MessagePreview2 = _interopRequireDefault(_MessagePreview);
	
	var _LoadingWrap = __webpack_require__(8);
	
	var _LoadingWrap2 = _interopRequireDefault(_LoadingWrap);
	
	var _ViewAgreement = __webpack_require__(338);
	
	var _ViewAgreement2 = _interopRequireDefault(_ViewAgreement);
	
	var _RadioServiceMixin = __webpack_require__(14);
	
	var _RadioServiceMixin2 = _interopRequireDefault(_RadioServiceMixin);
	
	var _getBuyerFirstName = __webpack_require__(132);
	
	var _getBuyerFirstName2 = _interopRequireDefault(_getBuyerFirstName);
	
	var _MPJobProgressBar = __webpack_require__(334);
	
	var _MPJobProgressBar2 = _interopRequireDefault(_MPJobProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = function Main(props) {
	    var sid = props.sid,
	        event = props.event,
	        Displaylists = props.Displaylists,
	        messages = props.messages,
	        mp_agreement = props.mp_agreement;
	
	
	    messages = _lodash2.default.filter(messages, function (msg) {
	        // filter out system messages because this is already an event
	        return !_lodash2.default.includes(_lodash2.default.get(msg, ["flags_as_array"]), "system_log");
	    });
	
	    if (!mp_agreement) {
	        //old MP events don't have an mp_agreement
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "h4",
	                null,
	                "Messages"
	            ),
	            _react2.default.createElement(_MessagePreview2.default, { thread: messages, sid: sid, eid: _lodash2.default.get(event, ["eid"]), show_send_form: false })
	        );
	    }
	
	    var bureau_name = _lodash2.default.find(_lodash2.default.get(Displaylists, "universal.bureaus", []), "bid", event.bureauID.toString());
	    bureau_name = _lodash2.default.result(bureau_name, "bname");
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-sm-12" },
	                _react2.default.createElement(_MPJobProgressBar2.default, {
	                    sid: sid,
	                    event: event,
	                    startataccepted: true
	                }),
	                _react2.default.createElement(
	                    "p",
	                    { className: "instruction" },
	                    "This client booked you through ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        bureau_name
	                    ),
	                    ". Get a great review from them to turn this engagement into more!"
	                ),
	                _react2.default.createElement(_ViewAgreement2.default, {
	                    event: event,
	                    Displaylists: Displaylists,
	                    mp_agreement: mp_agreement,
	                    display_payments: true
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-sm-12" },
	                _react2.default.createElement(
	                    "h4",
	                    null,
	                    "Messages with ",
	                    (0, _getBuyerFirstName2.default)(event)
	                ),
	                _react2.default.createElement(_MessagePreview2.default, { thread: messages, sid: sid, eid: _lodash2.default.get(event, ["eid"]) })
	            )
	        )
	    );
	};
	
	module.exports = _react2.default.createFactory(_react2.default.createClass({
	    displayName: "exports",
	
	    mixins: [_RadioServiceMixin2.default],
	    RadioService_setup: function RadioService_setup() {
	        return {
	            Marketplace_getMPMessages: {
	                key: function key() {
	                    var event = this.props.event || {};
	                    return event.eid;
	                }
	            },
	            Marketplace_getMPAgreement: {
	                key: function key() {
	                    var event = this.props.event || {};
	                    return event.eid + "|" + _lodash2.default.first(event.sids);
	                }
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.__loadEvent(this.props.event);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(next_props) {
	        var o_eid = _lodash2.default.get(this.props, ["event", "eid"]);
	        var n_eid = _lodash2.default.get(next_props, ["event", "eid"]);
	        if (o_eid !== n_eid) {
	            this.__loadEvent(next_props.event);
	        }
	    },
	    __loadEvent: function __loadEvent(event) {
	        if (!event) {
	            return;
	        }
	        this.RadioService_callService("Marketplace_getMPMessages", {
	            event_id: event.eid
	        });
	        this.RadioService_callService("Marketplace_getMPAgreement", {
	            event_id: event.eid,
	            speaker_id: _lodash2.default.first(event.sids)
	        });
	    },
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists;
	
	        var sid = _lodash2.default.first(event.sids);
	
	        var ajax_msgs = this.state.Marketplace_getMPMessages;
	        var ajax_mpag = this.state.Marketplace_getMPAgreement;
	
	        var mp_agreement = ajax_mpag.data;
	        var messages = _lodash2.default.filter(ajax_msgs.data && ajax_msgs.data.messages, function (msg) {
	            return msg.receiver_speaker_id === sid || msg.sender_speaker_id === sid;
	        });
	
	        var body = void 0;
	        if (ajax_msgs.waiting || ajax_mpag.waiting) {
	            body = (0, _LoadingWrap2.default)({ is_loading: true });
	        } else {
	            body = _react2.default.createElement(Main, {
	                sid: sid,
	                event: event,
	                Displaylists: Displaylists,
	                messages: messages,
	                mp_agreement: mp_agreement
	            });
	        }
	
	        return _react2.default.createElement(
	            "div",
	            { style: { minHeight: 300 } },
	            _react2.default.createElement(_ErrorAlert2.default, { message: ajax_msgs.error }),
	            _react2.default.createElement(_ErrorAlert2.default, { message: ajax_mpag.error }),
	            body
	        );
	    }
	}));

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createStandardEventForm = __webpack_require__(30);
	var _ = __webpack_require__(1);
	
	module.exports = createStandardEventForm({
	    eventToInitialValues: function eventToInitialValues(event) {
	        return {
	            nonCSP: !event.nonCSP,
	            salaried_job: _.get(event, 'flags_as_map.salaried_job.is_set', false),
	            cspDivision: event.cspDivision || ""
	        };
	    },
	    buildSchema: function buildSchema() {
	        return {
	            nonCSP: {
	                label: "Include on CSP application",
	                type: "checkbox"
	            },
	            salaried_job: {
	                label: "Performed for salaried job",
	                type: "checkbox"
	            },
	            cspDivision: {
	                label: "Company division",
	                type: "text"
	            }
	        };
	    },
	    writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	        event.nonCSP = !data.nonCSP;
	        event.cspDivision = data.cspDivision;
	        _.set(event, 'flags_as_map.salaried_job.is_set', data.salaried_job);
	    }
	});

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var ProOnly = __webpack_require__(34);
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var ezHorizontalFields = __webpack_require__(25);
	var createStandardEventForm = __webpack_require__(30);
	var isEventAccountingLockedForMe = __webpack_require__(55);
	
	module.exports = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	    var d = _.get(event, "key_values.CONTRACT_EXECUTION_DATE", null);
	    d = !_.isEmpty(d) ? esUtils.convertFromISO8601(d) : d;
	    return {
	      speechTitle: event.speechTitle || "",
	      dress: event.dress || "",
	      audienceSize: event.audienceSize || "",
	      source: event.source || "",
	      NCSID: esUtils.getIn(event, ["key_values", "NCSID"]) || "",
	      contract_execution_date: d,
	      flag_author: _.get(event, ["flags_as_map", "author", "is_set"], false),
	      flag_temporary: _.get(event, ["flags_as_map", "temporary", "is_set"], false),
	      publicInvited: !!event.publicInvited,
	      offerPending: !!event.offerPending,
	      presentingproductid: event.presentingproductid
	    };
	  },
	  buildSchema: function buildSchema(_ref) {
	    var event = _ref.event,
	        Displaylists = _ref.Displaylists,
	        is_limited_speaker = _ref.is_limited_speaker;
	
	    var event_speakers = _.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
	      return _.includes(event && event.sids, spkr.sid);
	    });
	    var presentations = _.sortBy(_.uniq(_.flattenDeep(_.map(event_speakers, "presentations"))), function (p) {
	      return p.trim().toLowerCase();
	    });
	    var event_sources = _.sortBy(_.uniq(_.map(_.flattenDeep(_.map(event_speakers, "event_sources")), "source")), function (s) {
	      return s.trim().toLowerCase();
	    });
	    var schema = {
	      speechTitle: {
	        label: "Presentation Title",
	        type: "combo",
	        read_only: isEventAccountingLockedForMe(event),
	        options: _.object(_.map(presentations, function (presentation) {
	          return [presentation, presentation];
	        })),
	        validate: FormUtils.v.optional
	      },
	      dress: {
	        label: "Dress",
	        type: "text"
	      },
	      audienceSize: {
	        label: "Audience Size",
	        type: "text"
	      },
	      source: {
	        label: "Lead Source",
	        type: "combo",
	        options: _.object(_.map(event_sources, function (source) {
	          return [source, source];
	        }))
	      },
	      publicInvited: {
	        label: "Public Invited",
	        type: "checkbox"
	      },
	      offerPending: {
	        label: "Offer Pending",
	        type: "checkbox"
	      }
	    };
	
	    if (AuthedUserSession.is_st_family) {
	      var presentationcategories = void 0,
	          presentingproduct = void 0;
	
	      if (AuthedUserSession.is_st_family) {
	        presentationcategories = _.map(_.get(Displaylists, ["universal", "presentationcategory", event.companyID], []), function (_ref2) {
	          var id = _ref2.id,
	              name = _ref2.name,
	              flags = _ref2.flags;
	
	          flags = parseInt(flags, 10);
	          if ((flags & Constants.PRESENTATION_CATEGORY_FLAGS.ARCHIVED) > 0 && parseInt(id, 10) !== parseInt(event.speechTitle, 10)) return null; //exclude items marked as "archive" (flag 1) unless it is this event's value
	          return [id, name];
	        });
	        presentationcategories = presentationcategories.filter(function (el) {
	          return el != null; //remove the entries that got filtered out by making them null above
	        });
	
	        presentingproduct = _.get(Displaylists, ["universal", "presentingproduct", event.companyID], []);
	        presentingproduct = _.map(_.filter(presentingproduct, function (p) {
	          return p.archived === 0 || p.id === event.presentingproductid;
	        }), function (_ref3) {
	          var id = _ref3.id,
	              description = _ref3.description;
	
	          return [id, description];
	        });
	      } else {
	        //ST family brands not yet converted to the 2020 team admin code
	        presentationcategories = _.map(_.get(Displaylists, "universal.presentationcategory", {}), function (_ref4) {
	          var id = _ref4.id,
	              name = _ref4.name;
	
	          return [id, name];
	        });
	        presentingproduct = _.filter(_.map(_.get(Displaylists, ["universal", "presentingproduct"], []), function (_ref5) {
	          var id = _ref5.id,
	              companyid = _ref5.companyid,
	              description = _ref5.description;
	
	          return event.companyID === companyid ? [id, description] : null;
	        }));
	      }
	
	      schema.speechTitle = {
	        label: "Pres Category",
	        type: "select",
	        options: _.object(presentationcategories),
	        read_only: isEventAccountingLockedForMe(event),
	        validate: FormUtils.v.optional
	      };
	      schema.presentingproductid = {
	        label: "Product",
	        type: "select",
	        options: _.object(presentingproduct),
	        read_only: isEventAccountingLockedForMe(event),
	        validate: FormUtils.v.optional
	      };
	      schema.NCSID = {
	        label: "NCSID",
	        type: "text"
	      };
	      schema.contract_execution_date = {
	        label: "Contract Execution",
	        type: "date",
	        validate: FormUtils.v.optional
	      };
	      schema.flag_author = {
	        label: "Author",
	        type: "checkbox"
	      };
	      schema.flag_temporary = {
	        label: "Temporary Date",
	        type: "checkbox"
	      };
	      schema.offerPending.label = "Ignore Product";
	
	      if (is_limited_speaker) {
	        delete schema.speechTitle;
	        delete schema.presentingproductid;
	        delete schema.NCSID;
	        delete schema.source;
	        delete schema.contract_execution_date;
	
	        schema.flag_temporary.read_only = true;
	        schema.flag_author.read_only = true;
	        schema.offerPending.read_only = true;
	        schema.publicInvited.read_only = true;
	        schema.audienceSize.read_only = true;
	      }
	    } else if (AuthedUserSession.is_privatelabel) {
	      if (is_limited_speaker) {
	        delete schema.speechTitle;
	        delete schema.source;
	
	        schema.offerPending.read_only = true;
	        schema.publicInvited.read_only = true;
	        schema.audienceSize.read_only = true;
	      }
	    }
	
	    return schema;
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    event.speechTitle = data.speechTitle;
	    event.dress = data.dress;
	    event.audienceSize = data.audienceSize;
	    event.source = data.source;
	    event.publicInvited = !!data.publicInvited;
	    event.offerPending = !!data.offerPending;
	
	    if (AuthedUserSession.is_st_family) {
	      event.presentingproductid = esUtils.toInt(data.presentingproductid);
	
	      event.flags_as_map.author.is_set = !!data.flag_author;
	      event.flags_as_map.temporary.is_set = !!data.flag_temporary;
	
	      if (!_.isPlainObject(event.key_values)) {
	        event.key_values = {};
	      }
	      event.key_values.NCSID = data.NCSID;
	      event.key_values.CONTRACT_EXECUTION_DATE = _.isDate(data.contract_execution_date) ? esUtils.returnISO8601(data.contract_execution_date) : data.contract_execution_date; //this way the Z is cut off the end to avoid timezone problems
	    }
	  },
	  renderFields: function renderFields() {
	    return dd.div(null, ezHorizontalFields(this, [["speechTitle"], ["dress"], ["audienceSize"]]), ProOnly({ sids: this.props.event.sids }, ezHorizontalFields(this, [["source"]])), ezHorizontalFields(this, [["presentingproductid"], ["NCSID"], ["contract_execution_date"], ["flag_author"], ["flag_temporary"], ["publicInvited"], ["offerPending"]]));
	  }
	});

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var React = __webpack_require__(15);
	var radio = __webpack_require__(24);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var ErrorAlert = __webpack_require__(6);
	var FormButtons = __webpack_require__(36);
	var LoadingWrap = __webpack_require__(8);
	var ezHorizontalFields = __webpack_require__(25);
	var RadioServiceMixin = __webpack_require__(14);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	var getListOfSpeakersWhoCanEditMasterStoriesList = __webpack_require__(126);
	
	var SIDPicker = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(props) {
			return { sid: props.sid };
		},
		buildSchema: function buildSchema() {
			var speakers_I_can_manage = getListOfSpeakersWhoCanEditMasterStoriesList(this.props.Displaylists);
	
			return {
				sid: {
					label: 'Speaker',
					type: 'select',
					options: _.object(_.map(speakers_I_can_manage, function (spkr) {
						return [spkr.sid, spkr.name_full];
					}))
				}
			};
		},
		onFormChanged: function onFormChanged() {
			this.Form_onSubmit();
		},
		render: function render() {
			return dd.form({ className: 'form-horizontal', onSubmit: this.Form_onSubmit }, ezHorizontalFields(this));
		}
	});
	
	var getSpeakerFromDisplaylists = function getSpeakerFromDisplaylists(sid, Displaylists) {
		return _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
			return sid == spkr.sid;
		}));
	};
	
	var StoriesMasterListForm = dd.createClass({
		mixins: [FormMixin, EventFormUnsavedChangeMixin],
		getInitialValues: function getInitialValues(_ref) {
			var sid = _ref.sid,
			    Displaylists = _ref.Displaylists;
	
			var speaker = getSpeakerFromDisplaylists(sid, Displaylists) || {};
			return _.object(_.map(speaker.stories, function (story) {
				return [story.id, story.ti];
			}));
		},
		buildSchema: function buildSchema() {
			var _props = this.props,
			    sid = _props.sid,
			    Displaylists = _props.Displaylists;
	
	
			var speaker = getSpeakerFromDisplaylists(sid, Displaylists) || {};
	
			var story_ids = _.sortBy(_.uniq(_.difference(_.flattenDeep([_.map(speaker.stories, 'id'), this.__getCustomList("ids_to_add")]), this.__getCustomList("ids_to_delete"))), function (id) {
				return (/^new_story_/.test(id) ? id : esUtils.toInt(id)
				);
			});
	
			return _.object(_.map(story_ids, function (id) {
				return [id, { type: 'text' }];
			}));
		},
		__delete: function __delete(id) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				self.Form_onChange("ids_to_delete", self.__getCustomList("ids_to_delete").concat([id]));
			});
		},
	
		__add: esUtils.wrapPreventDefault(function () {
			var ids_to_add = this.__getCustomList("ids_to_add");
			var new_id = "new_story_" + _.padLeft(_.uniqueId(), 10, '0'); //padding to make the sorting work properly
			this.Form_onChange("ids_to_add", _.uniq(ids_to_add.concat([new_id])));
		}),
		__getCustomList: function __getCustomList(name) {
			return _.uniq(_.flattenDeep([this.state.data && this.state.data[name]]));
		},
		render: function render() {
			var fields = this.Form_buildSchema();
			var onClose = this.props.onClose;
			var changes_made = this.Form_areChangesMade();
	
			return dd.form({ className: 'form-horizontal', onSubmit: this.Form_onSubmit }, dd.button({ className: 'btn btn-default btn-sm', style: { marginTop: '1.5em', marginBottom: '0.5em' }, onClick: this.__add }, dd.i({ className: 'fa fa-plus' }), ' Add Story'), dd.div({ className: 'masterstorylist' }, _.map(fields, function (field, name) {
				return dd.div({ key: name, className: 'form-group', style: { marginBottom: 0 } }, dd.div({ className: 'col-sm-10' }, this.Form_buildInput(field)), dd.div({ className: 'col-sm-2' }, dd.a({ href: '#', style: { display: 'inline-block', marginTop: 5 }, onClick: this.__delete(name) }, dd.i({ className: 'fa fa-trash-o' }), ' delete')));
			}, this)), dd.div({ className: 'form-group', style: { marginTop: '2em' } }, dd.div({ className: 'col-sm-12' }, FormButtons({
				onCancel: onClose,
				onDiscard: changes_made ? this.__discardChanges : null,
				right_align: true
			}))));
		}
	});
	
	module.exports = dd.createClass({
		propTypes: {
			event: React.PropTypes.object.isRequired,
			Displaylists: React.PropTypes.object.isRequired,
			onClose: React.PropTypes.func.isRequired
		},
		mixins: [RadioServiceMixin],
		getInitialState: function getInitialState() {
			return { sid: _.first(this.props.event && this.props.event.sids) };
		},
		RadioService_setup: function RadioService_setup() {
			return {
				StoriesList_save: {
					key: function key() {
						return this.state.sid;
					},
	
					on: {
						succeeded: function succeeded() {
							this.props.onClose();
						}
					}
				}
			};
		},
		__pickSID: function __pickSID(_ref2) {
			var sid = _ref2.sid;
	
			this.setState({ sid: sid });
		},
		__onSubmit: function __onSubmit(data) {
			var ids_to_delete = _.flattenDeep(data.ids_to_delete);
			var stories = _.object(_.filter(_.map(data, function (val, key) {
				if (!_.isString(val) || _.includes(ids_to_delete, key)) {
					return null;
				}
				return [key, val];
			})));
			radio("StoriesList_save").broadcast({ sid: this.state.sid, stories: stories });
		},
		render: function render() {
			var _props2 = this.props,
			    Displaylists = _props2.Displaylists,
			    onClose = _props2.onClose;
	
			var sid = this.state.sid;
			var ajax = this.state.StoriesList_save;
	
			var speakers_I_can_manage = getListOfSpeakersWhoCanEditMasterStoriesList(Displaylists);
			if (_.size(speakers_I_can_manage) === 1) {
				sid = _.first(speakers_I_can_manage).sid;
			}
	
			return Modal({
				title: 'Stories Master List',
				onClose: ajax.waiting ? null : onClose,
				buttons: []
			}, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: 'Saving...' }, dd.div({ className: 'alert alert-info' }, dd.b(null, 'NOTE: '), 'Changes applied to this list apply to ALL EVENTS and all OTHER USERS for this speaker.'), _.size(speakers_I_can_manage) > 1 ? SIDPicker({ sid: sid, Displaylists: Displaylists, onSubmit: this.__pickSID }) : null, StoriesMasterListForm({
				sid: sid,
				onClose: onClose,
				Displaylists: Displaylists,
				onSubmit: this.__onSubmit
			})));
		}
	});

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormButtons = __webpack_require__(36);
	var SlideOpenDown = __webpack_require__(27);
	var StoriesEditorModal = __webpack_require__(314);
	var createStandardEventForm = __webpack_require__(30);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	var AuthedUserSession = __webpack_require__(4);
	var getListOfSpeakersWhoCanEditMasterStoriesList = __webpack_require__(126);
	
	var mdl = null; //sloppy way to give eventToInitialValues() access to Displaylists
	
	var StoriesToldCheckList = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	
	    var Displaylists = mdl; //I'm sure there's a more elegant way to get to this
	    var story_ids = _.isString(event.storiesToldList) ? event.storiesToldList.split("|") : [];
	    var list_obj = void 0;
	
	    //try to translate story ids that were incorrectly stored by their position in alphabetical order
	    if (AuthedUserSession.is_st_family) {
	      if (AuthedUserSession.is_st_family) {
	        list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas", event.companyID], []), function (_ref) {
	          var id = _ref.id,
	              name = _ref.name;
	
	          return [id, name];
	        }));
	      } else {
	        //have not upgraded to team-admin yet
	        list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas"], []), function (_ref2) {
	          var id = _ref2.id,
	              name = _ref2.name;
	
	          return [id, name];
	        }));
	      }
	    } else {
	      list_obj = _.object(_.filter(_.map(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, event && event.sids), "stories")), function (story) {
	        return _.has(story, "id") && _.has(story, "ti") ? [story.id, story.ti] : null;
	      })));
	    }
	    if (!_.isEmpty(list_obj)) {
	
	      //sort alpha
	      var list_obj_alpha = _.sortBy(list_obj, function (o) {
	        return o;
	      });
	
	      story_ids = _.map(story_ids, function (story_id) {
	        if (!_.has(list_obj, story_id)) {
	          var story_text = list_obj_alpha[story_id];
	          story_id = _.findKey(list_obj, function (item) {
	            return item == story_text;
	          });
	        }
	        return story_id;
	      });
	      _.remove(story_ids, function (story_id) {
	        return !_.has(list_obj, story_id);
	      });
	    }
	
	    return _.object(_.map(story_ids, function (id) {
	      return [id, true];
	    }));
	  },
	  buildSchema: function buildSchema(_ref3) {
	    var event = _ref3.event,
	        Displaylists = _ref3.Displaylists;
	
	    var list_obj = void 0;
	
	    if (AuthedUserSession.is_st_family) {
	      if (AuthedUserSession.is_st_family) {
	        list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas", event.companyID], []), function (_ref4) {
	          var id = _ref4.id,
	              name = _ref4.name;
	
	          return [id, name];
	        }));
	      } else {
	        //have not upgraded to team-admin yet
	        list_obj = _.object(_.map(_.get(Displaylists, ["universal", "specific_content_areas"], []), function (_ref5) {
	          var id = _ref5.id,
	              name = _ref5.name;
	
	          return [id, name];
	        }));
	      }
	    } else {
	      list_obj = _.object(_.filter(_.map(_.flattenDeep(_.map(getSpeakersFromDisplaylists(Displaylists, event && event.sids), "stories")), function (story) {
	        return _.has(story, "id") && _.has(story, "ti") ? [story.id, story.ti] : null;
	      })));
	    }
	
	    return _.object(_.map(list_obj, function (name, id) {
	      return [id, { type: "checkbox", text: name, read_only: false }];
	    }));
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    event.storiesToldList = _.map(_.filter(_.pairs(data), 1), 0).join("|");
	  },
	  renderFields: function renderFields() {
	    var fields = this.Form_buildSchema();
	    var changes_made = this.Form_areChangesMade();
	    var toggleMasterListEditor = this.props.toggleMasterListEditor;
	
	    //sort the list of stories by the story title, not the id number
	
	    fields = _.values(fields);
	    fields.sort(function (a, b) {
	      try {
	        return a.text.toUpperCase() < b.text.toUpperCase() ? -1 : a.text.toUpperCase() > b.text.toUpperCase() ? 1 : 0;
	      } catch (e) {
	        return 0;
	      }
	    });
	
	    return dd.div(null, dd.div({ className: "panel panel-default storiestold" }, dd.div({ className: "panel-body" }, dd.table({ className: "table table-condensed" }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, AuthedUserSession.is_st_family ? "Requested" : "Told"), dd.th(null, AuthedUserSession.is_st_family ? "Topics" : "Story / Joke"))), dd.tbody(null, _.map(fields, function (field, name) {
	      return dd.tr({ key: name }, dd.td({ className: "text-center" }, this.Form_buildInput(field)), dd.td(null, field.text));
	    }, this))), !_.isEmpty(fields) ? null : dd.div({ className: "text-center" }, dd.div(null, AuthedUserSession.is_st_family ? "-- no topics --" : "-- no stories entered --"), toggleMasterListEditor ? dd.button({ className: "btn btn-primary", onClick: toggleMasterListEditor }, "Add some stories") : null))), SlideOpenDown({ open: changes_made }, FormButtons({ onDiscard: this.__discardChanges })));
	  },
	  renderButtons: function renderButtons() {
	    //we're overriding the standard button render
	    //so we can render it inside the renderFields
	    return dd.span();
	  }
	});
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { show_master_list_editor: false };
	  },
	
	  __toggleMasterListEditor: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_master_list_editor: !this.state.show_master_list_editor });
	  }),
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists;
	    var show_master_list_editor = this.state.show_master_list_editor;
	
	    var can_I_edit_stories = !_.isEmpty(getListOfSpeakersWhoCanEditMasterStoriesList(Displaylists));
	    var toggleMasterListEditor = AuthedUserSession.is_st_family ? null : this.__toggleMasterListEditor;
	    mdl = Displaylists;
	
	    return dd.div(null, can_I_edit_stories && toggleMasterListEditor ? dd.a({ className: "printlink pull-right", onClick: toggleMasterListEditor }, dd.i({ className: "fa fa-gear" }), " Customize Story List") : null, dd.h4({ style: { marginBottom: 21 }, className: "section-head" }, AuthedUserSession.is_st_family ? "Specific Content Areas" : "Stories / Jokes Told"), StoriesToldCheckList({ event: event, Displaylists: Displaylists, toggleMasterListEditor: toggleMasterListEditor }), show_master_list_editor && toggleMasterListEditor ? StoriesEditorModal({ event: event, Displaylists: Displaylists, onClose: toggleMasterListEditor }) : null);
	  }
	});

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var ProOnly = __webpack_require__(34);
	var MiscForm = __webpack_require__(313);
	var StoriesTold = __webpack_require__(315);
	var AuthedUserSession = __webpack_require__(4);
	
	var CSP = AuthedUserSession.is_privatelabel ? null : __webpack_require__(312);
	
	module.exports = dd.createClass({
		render: function render() {
			var _props = this.props,
			    event = _props.event,
			    Displaylists = _props.Displaylists;
	
			var is_limited_speaker = AuthedUserSession.doIHaveAccess.limited_speaker.any(event.sids);
	
			return dd.div({ className: "Misc" }, dd.h2({ style: { marginBottom: 0 } }, "Misc"), MiscForm({
				event: event,
				Displaylists: Displaylists,
				read_only: AuthedUserSession.privatelabel_code === "cs" ? !AuthedUserSession.doIHaveAccess.full.any(event.sids) : false,
				is_limited_speaker: is_limited_speaker
			}), ProOnly({
				sids: event.sids,
				custom_message: "Working toward your CSP? eSpeakers tracks all of the information needed for the CSP application, and generates the NSA-required application spreadsheet. PRO users also avoid repeating content by tracking stories told at each event."
			}, CSP ? CSP({ form_section_name: "CSP", event: event, Displaylists: Displaylists }) : null, StoriesTold({ event: event, Displaylists: Displaylists })));
		}
	});

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var FormButtons = __webpack_require__(36);
	var RadioServiceMixin = __webpack_require__(14);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	var getSpeakersFromDisplaylists = __webpack_require__(50);
	var AuthedUserSession = __webpack_require__(4);
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(_ref) {
			var event = _ref.event;
	
			var default_sid = esUtils.toInt(_.first(event && event.sids));
			return {
				speaker: default_sid > 0 ? default_sid : undefined
			};
		},
		buildSchema: function buildSchema() {
			var _props = this.props,
			    event = _props.event,
			    Displaylists = _props.Displaylists;
	
			return {
				speaker: {
					type: "select",
					options: _.object(_.map(getSpeakersFromDisplaylists(Displaylists, event.sids), function (speaker) {
						return [speaker.sid, speaker.name_full];
					})),
					validate: function validate(v) {
						var sid = esUtils.toInt(v);
						return sid > 0 ? true : "Please select a speaker";
					}
				},
				feeitem_fee: {
					type: "select",
					label: "fee",
					options: _.mapValues(this.__getSpeakerFees(), "description"),
					validate: FormUtils.v.optional
				},
				feeitem_description: {
					type: "text",
					label: "description",
					validate: FormUtils.v.optional
				},
				feeitem_amount: {
					type: "text",
					label: "amount",
					validate: FormUtils.v.blankOr(FormUtils.v.currency)
				},
				add_replace_royalties: {
					type: "checkbox",
					label: "add/replace royalties (if any)"
				},
				expenses_code: {
					type: "text",
					label: "group code",
					validate: FormUtils.v.optional
				},
				expenses_amount: {
					type: "text",
					label: "amount",
					validate: FormUtils.v.blankOr(FormUtils.v.currency)
				}
			};
		},
		onFormChanged: function onFormChanged(field_name, new_value) {
			if (field_name === "feeitem_fee") {
				var fees = this.__getSpeakerFees();
				var fee_id = esUtils.toInt(new_value);
				if (_.has(fees, fee_id)) {
					this.Form_onChange("feeitem_description", fees[fee_id].description);
					this.Form_onChange("feeitem_amount", fees[fee_id].amount);
				} else if (fee_id === 0) {
					this.Form_onChange("feeitem_description", "");
					this.Form_onChange("feeitem_amount", "");
				}
			} else if (field_name === "speaker") {
				this.Form_onChange("feeitem_fee", 0);
				this.Form_onChange("feeitem_description", "");
				this.Form_onChange("feeitem_amount", "");
			}
		},
		__getSpeakerFees: function __getSpeakerFees() {
			var data = this.state.data;
			var Displaylists = this.props.Displaylists;
	
			var selected_speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
				return spkr.sid == data.speaker;
			}) || {};
			return _.object(_.map(_.filter(selected_speaker.speaker_fee_dropdown, function (f) {
				return _.get(f, ["company_id"]) === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
			}), function (o) {
				return [o.id, o];
			}));
		},
		render: function render() {
			var onClose = this.props.onClose;
	
	
			var sectionHead = _.bind(function (title, desc, layout) {
				return dd.div(null, dd.h2({ style: { marginBottom: ".25em" } }, title), dd.p({ className: "help-block", style: { marginBottom: "1em" } }, desc), ezHorizontalFields(this, layout));
			}, this);
	
			return dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, ezHorizontalFields(this, [["speaker"]]), sectionHead("Fee Item", "Select one of the speaker's fee items to add as a service with group code \"ASC\"", [["feeitem_fee"], ["feeitem_description"], ["feeitem_amount"]]), sectionHead("Royalties", "Add/update the royalties based on event's company, delivery method, and product.", [["add_replace_royalties"]]), sectionHead("Expenses", "Add a new service item for the speaker's expenses.", [["expenses_code"], ["expenses_amount"]]), dd.br(), dd.br(), HorizontalFieldSpot(null, FormButtons({ right_align: true, onCancel: onClose, submit_btn_text: "Compute" })));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				EventServices_computeFamilyValues: {
					key: "callService",
					on: {
						succeeded: function succeeded() {
							radio("reload_Event").broadcast(this.props.event.eid);
							this.props.onClose();
						}
					}
				}
			};
		},
		__onSubmit: function __onSubmit(data) {
			this.RadioService_callService("EventServices_computeFamilyValues", _.assign({
				eid: this.props.event.eid
			}, data));
		},
		render: function render() {
			var _props2 = this.props,
			    event = _props2.event,
			    Displaylists = _props2.Displaylists,
			    onClose = _props2.onClose;
	
			var ajax = this.state.EventServices_computeFamilyValues;
			if (ajax.waiting) {
				return Modal({
					title: "Computing...",
					buttons: []
				}, LoadingWrap({ is_loading: true, text: "Computing..." }));
			}
			if (ajax.error) {
				return Modal({
					title: "Error",
					onClose: onClose
				}, ErrorAlert({ message: ajax.error }));
			}
	
			return Modal({
				title: "Compute",
				onClose: onClose,
				buttons: []
			}, DaForm({ event: event, Displaylists: Displaylists, onClose: onClose, onSubmit: this.__onSubmit }));
		}
	});

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var ezHorizontalFields = __webpack_require__(25);
	var HorizontalFieldSpot = __webpack_require__(47);
	var createStandardEventForm = __webpack_require__(30);
	
	var mkTrackingURL = function mkTrackingURL(tracking_number) {
		return esUtils.isBlank(tracking_number) ? null : "https://www.google.com/search?q=" + tracking_number;
	};
	
	module.exports = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				productQtyBoxes: event.productQtyBoxes,
				productShipper: event.productShipper,
				productTrackingNumbers: event.productTrackingNumbers
			};
		},
		buildSchema: function buildSchema() {
			return {
				productQtyBoxes: {
					label: "Qty Boxes",
					type: "text",
					validate: FormUtils.v.blankOr(FormUtils.v.positive_integer)
				},
				productShipper: {
					label: "Shipper",
					type: "select",
					placeholder: "--",
					dont_sort_options: true,
					options: _.object(_.map(["DHL", "FEDEX", "UPS", "USPS", "carry with", "other"], function (v) {
						return [v, v];
					})),
					validate: FormUtils.v.optional
				},
				productTrackingNumbers: {
					label: "Tracking Numbers",
					type: "text",
					validate: FormUtils.v.optional
				}
			};
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			event.productQtyBoxes = esUtils.isBlank(data.productQtyBoxes) ? null : esUtils.toInt(data.productQtyBoxes);
			event.productShipper = data.productShipper;
			event.productTrackingNumbers = data.productTrackingNumbers;
		},
		renderFields: function renderFields() {
			var data = this.state.data;
	
			var tracking_url = mkTrackingURL(data && data.productTrackingNumbers);
			return dd.div(null, ezHorizontalFields(this), tracking_url ? HorizontalFieldSpot(null, dd.a({ href: tracking_url, target: "_blank" }, "Live Tracking")) : null);
		}
	});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var HorizontalFields = __webpack_require__(23);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var product = this.props.product;
	
			if (!_.isArray(event.ProductSale)) {
				event.ProductSale = [];
			}
			if (!product || product.id < 0) {
				product = { id: 0, eid: event.eid };
				event.ProductSale.push(product);
			}
			_.each(event.ProductSale, function (p) {
				if (p.id == product.id) {
					p.groupcode = data.groupcode;
					p.description = data.description;
					p.qtysold = FormUtils.floatOr0(data.qtysold);
					p.qtyshipped = FormUtils.floatOr0(data.qtyshipped);
					p.priceeach = FormUtils.floatOr0(data.priceeach);
				}
			});
			radio('save_Event').broadcast(event);
			this.__close();
		},
		__onDelete: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var product = this.props.product;
			event.ProductSale = _.reject(event.ProductSale, function (p) {
				return p.id == product.id;
			});
			radio('save_Event').broadcast(event);
			this.__close();
		}),
		__close: function __close() {
			if (_.isFunction(this.props.onClose)) {
				this.props.onClose();
			}
		},
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
			var product = this.props.product;
			var onClose = this.props.onClose;
	
			return dd.div({ className: 'ProductSaleForm' }, DaForm({
				event: event,
				Displaylists: Displaylists,
				product: product,
				onSubmit: this.__onSubmit,
				onDelete: this.__onDelete,
				onClose: onClose
			}));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return esUtils.getEventVersionIdentifier(props.event) + '-' + (props.product && props.product.id || 0);
		},
		getInitialValues: function getInitialValues(props) {
			var product = props.product;
			if (!product || product.id < 1) {
				return null;
			}
			return {
				groupcode: product.groupcode,
				description: product.description,
				qtysold: product.qtysold,
				qtyshipped: product.qtyshipped,
				priceeach: product.priceeach
			};
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			if (field_path === 'groupcode') {
				var data = this.state.data || {};
				var product_codes = this.__getProductCodes();
				var code = product_codes[new_value];
				if (code) {
					data.qtysold = code.qtysold;
					data.groupcode = code.groupcode;
					data.priceeach = code.priceeach;
					data.qtyshipped = code.qtyshipped;
					data.description = code.description;
					this.setState({ data: data });
				}
			}
			//from EventFormUnsavedChangeMixin
			this.__checkForChangesMade();
		},
		__getProductCodes: function __getProductCodes() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
			return _.sortBy(_.uniq(_.filter(_.flattenDeep(_.map(_.filter(Displaylists && Displaylists.perspeaker, function (speaker) {
				return _.includes(event && event.sids, speaker.sid);
			}), 'productcodes')), function (code) {
				return _.isString(code && code.groupcode);
			}), 'groupcode'), function (code) {
				return _.get(code, "groupcode", "").toUpperCase();
			});
		},
		buildFields: function buildFields() {
			return {
				groupcode: {
					label: 'Code',
					type: 'combo',
					options: _.object(_.map(this.__getProductCodes(), function (code, i) {
						return [i, code.groupcode];
					})),
					placeholder: 'Code'
				},
				description: {
					label: 'Description',
					type: 'text',
					placeholder: 'Description',
					validate: FormUtils.v.optional
				},
				qtysold: {
					label: 'Number Sold',
					type: 'text',
					placeholder: 'Number Sold',
					validate: FormUtils.v.optional
				},
				qtyshipped: {
					label: 'Number Shipped',
					type: 'text',
					placeholder: 'Number Shipped',
					validate: FormUtils.v.optional
				},
				priceeach: {
					label: 'Price',
					type: 'text',
					placeholder: 'Price',
					validate: FormUtils.v.blankOr(FormUtils.v.currency)
				}
			};
		},
		__onCancel: esUtils.wrapPreventDefault(function () {
			this.updateUnsavedState(false);
			this.props.onClose();
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var onDelete = this.props.onDelete;
			var product = this.props.product;
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), HorizontalFields.FormButtons({
				right_align_buttons: true,
				submit_btn_text: product && product.id > 0 ? 'Save' : 'Add',
				onCancel: this.__onCancel,
				onDelete: product && product.id > 0 ? onDelete : null
			}));
		}
	});

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var ProductSaleForm = __webpack_require__(319);
	
	var numberOrZero = function numberOrZero(n) {
		var q = parseFloat(n);
		return _.isNaN(q) ? 0 : q;
	};
	
	module.exports = dd.createClass({
		getInitialState: function getInitialState() {
			return { editing_id: null };
		},
		__setEditingId: function __setEditingId(id) {
			return _.bind(esUtils.wrapPreventDefault(function () {
				this.setState({ editing_id: id });
			}), this);
		},
		render: function render() {
			var _props = this.props,
			    event = _props.event,
			    Displaylists = _props.Displaylists,
			    read_only = _props.read_only;
			var editing_id = this.state.editing_id;
	
	
			var products_by_id = _.object(_.map(event.ProductSale, function (product) {
				return [product.id, product];
			}));
	
			var rows = _.map(event.ProductSale, function (product) {
				return dd.tr({
					key: product.id,
					className: read_only ? null : "editable",
					onClick: read_only ? null : this.__setEditingId(product.id)
				}, dd.td(null, product.groupcode), dd.td(null, numberOrZero(product.qtysold)), dd.td(null, product.description), dd.td(null, esUtils.format_currency(numberOrZero(product.priceeach), 2)));
			}, this);
	
			return dd.div({ className: "ProductSaleTable" }, dd.table({ className: "table table-responsive table-condensed" + (read_only ? "" : " table-hover") }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, "Code"), dd.th({ style: { width: 1 } }, "Qty"), dd.th(null, "Description"), dd.th({ style: { width: 1 } }, "Price"))), dd.tbody(null, rows.length > 0 ? rows : dd.tr(null, dd.td({ colSpan: 4, style: { textAlign: "center" } }, "-- no products --"))), rows.length > 0 ? dd.tfoot(null, dd.tr(null, dd.td({ colSpan: 3 }, "TOTAL ", dd.span({ className: "text-muted" }, "(Qty x Price)")), dd.td(null, esUtils.format_currency(_.reduce(event.ProductSale, function (sum, product) {
				return sum + numberOrZero(product.qtysold) * numberOrZero(product.priceeach);
			}, 0), 2)))) : null), read_only ? null : dd.div(null, dd.button({ className: "btn btn-default btn-sm pull-right", onClick: this.__setEditingId(0) }, dd.i({ className: "fa fa-plus" }), " Add Product"), dd.div({ className: "clearfix" })), editing_id !== null ? Modal({
				title: editing_id > 0 ? "Edit Product" : "New Product",
				onClose: this.__setEditingId(null),
				buttons: []
			}, ProductSaleForm({ event: event, Displaylists: Displaylists, product: products_by_id[editing_id] || null, onClose: this.__setEditingId(null) })) : null);
		}
	});

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-unused-vars:0 no-trailing-spaces:0 */
	/*globals localStorage*/
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var radio = __webpack_require__(24);
	var RadioServiceMixin = __webpack_require__(14);
	var ProOnly = __webpack_require__(34);
	
	var serviceFee = function serviceFee(service) {
		if (!service) {
			return "";
		}
		if (_.includes(service.flags, "FREE")) {
			return "Free";
		} else if (_.includes(service.flags, "BILL_LATER")) {
			return "Actual";
		}
		return esUtils.format_currency(service.fee, 2);
	};
	
	var numberOrZero = function numberOrZero(n) {
		var q = parseFloat(n);
		return _.isNaN(q) ? 0 : q;
	};
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Quickbooks_findCustomerByName: {
					key: function key() {
						return 1;
					},
					on: {
						succeeded: function succeeded(data) {
							// send to connection page now since they aren't connected yet
							if (data.data && data.data.is_connected === false) {
								// set current EID in local storage first
								localStorage.setItem('origin_eid', this.props.event.eid);
								window.location.hash = '#/account_settings/connect/_/' + this.state.sid + '/quickbooks';
							}
							// save customer id in state if we found one
							if (data.data && data.data.customer) {
								this.setState({ customer_id: data.data.customer.id });
							}
						}
					}
				},
				Quickbooks_createInvoice: {
					key: function key() {
						return 1;
					}
				},
				Quickbooks_addInvoiceToQueue: {
					key: function key() {
						return 1;
					}
				}
			};
		},
		getInitialState: function getInitialState() {
			return {
				connection_type: localStorage.getItem('connection_type') ? localStorage.getItem('connection_type') : null,
				connection_type_set: localStorage.getItem('connection_type') ? true : false,
				sid: -1,
				create_customer: true,
				customer_id: 0,
				hide_notice: localStorage.getItem('hide_notice') ? true : false,
				desktop_notice_shown: localStorage.getItem('desktop_notice_shown') === null || localStorage.getItem('desktop_notice_shown') == 'true' ? true : false,
				services: this.props.event.Service,
				products: this.props.event.ProductSale
			};
		},
		componentDidMount: function componentDidMount() {
			this.__loadForSid(this.props.event.sids[0]);
		},
		__loadForSid: function __loadForSid(sid) {
			if (sid != this.state.sid) {
				this.setState({ sid: sid }, function () {
					var type = this.state.connection_type;
					if (type == 'online') {
						radio('Quickbooks_findCustomerByName').broadcast({ sid: sid, name: this.props.event.organization });
					}
				});
			}
		},
		__toggleCreateCustomer: function __toggleCreateCustomer() {
			this.setState({ create_customer: !this.state.create_customer });
		},
		__hideDesktopNotice: esUtils.wrapPreventDefault(function (e) {
			this.setState({ desktop_notice_shown: false });
			localStorage.setItem('desktop_notice_shown', false);
		}),
		__showDesktopNotice: esUtils.wrapPreventDefault(function (e) {
			this.setState({ desktop_notice_shown: true });
			localStorage.setItem('desktop_notice_shown', true);
		}),
	
		__connectionTypeSelected: function __connectionTypeSelected(type) {
			this.setState({ connection_type: type });
		},
		__setConnectionType: function __setConnectionType() {
			var type = this.state.connection_type;
			this.setState({ connection_type_set: true });
			localStorage.setItem('connection_type', type);
			if (type == 'online') {
				radio('Quickbooks_findCustomerByName').broadcast({ sid: this.state.sid, name: this.props.event.organization });
			}
		},
		__resetConnectionType: esUtils.wrapPreventDefault(function (e) {
			localStorage.removeItem('connection_type');
			this.setState({ connection_type: null });
			this.setState({ connection_type_set: false });
		}),
	
		__updateSelectedItems: function __updateSelectedItems(id, item) {
			var allItems, selectedItems;
			var newItems = [];
			var isSelected = false;
			if (item == 'service') {
				allItems = this.props.event.Service;
				selectedItems = this.state.services;
			} else if (item == 'product') {
				allItems = this.props.event.ProductSale;
				selectedItems = this.state.products;
			}
	
			selectedItems = _.isEmpty(selectedItems) ? [] : selectedItems;
			// loop over our current selected items
			_.forEach(selectedItems, function (item) {
				if (item.id == id) {
					isSelected = true;
				} else {
					newItems.push(item);
				}
			});
			// add the item if it wasn't found in selected array
			if (!isSelected) {
				_.forEach(allItems, function (item) {
					if (item.id == id) {
						newItems.push(item);
					}
				});
			}
			// set new items state
			if (item == 'service') {
				this.setState({ services: newItems });
			} else if (item == 'product') {
				this.setState({ products: newItems });
			}
		},
		__createInvoice: function __createInvoice() {
	
			if (this.state.disable_notice) {
				localStorage.setItem('hide_notice', true);
			}
	
			// broadcast our radio event with state data
			var service = this.state.connection_type == 'desktop' ? 'Quickbooks_addInvoiceToQueue' : 'Quickbooks_createInvoice';
			radio(service).broadcast({
				sid: this.state.sid,
				name: this.props.event.organization,
				customer_id: this.state.customer_id,
				services: JSON.stringify(this.state.services),
				products: JSON.stringify(this.state.products)
			});
		},
		render: function render() {
	
			var connectionType = this.state.connection_type;
			var connectionTypeSet = this.state.connection_type_set;
			var desktopNoticeShown = this.state.desktop_notice_shown;
	
			/*****/
	
			var ajax2 = this.state.Quickbooks_findCustomerByName;
			var ajax3 = this.state.Quickbooks_createInvoice;
			var ajax4 = this.state.Quickbooks_addInvoiceToQueue;
	
			var loadingText;
			if (ajax2.waiting) {
				loadingText = 'Connecting to QuickBooks Online...';
			}
			if (ajax3.waiting) {
				loadingText = 'Creating QuickBooks Online Invoice...';
			}
			if (ajax4.waiting) {
				loadingText = 'Sending Invoice to QuickBooks Desktop...';
			}
			var checkedStatus = ajax3.error !== null && ajax3.error.indexOf('at least') > -1 || ajax4.error !== null && ajax4.error.indexOf('at least') > -1 ? false : true;
			var isWaiting = ajax2.waiting || ajax3.waiting || ajax4.waiting;
			var isConnected = ajax2.data && ajax2.data.data.is_connected ? true : false;
			var event = this.props.event;
			var services = event.Service;
			var products = event.ProductSale;
			var customer = ajax2.data ? ajax2.data.data.customer : null;
			var invoiceCreated = ajax3.data && ajax3.data.data.invoice_id || ajax4.data && ajax4.data.data.queue_id ? true : false;
			var desktopCreate = connectionType == 'desktop' ? true : false;
			var invoiceQueued = false;
	
			if (desktopCreate) {
				isConnected = true;
				invoiceQueued = invoiceCreated ? true : false;
				invoiceCreated = false;
				customer = null;
			}
	
			var onClose = this.props.onClose;
	
			return Modal({
				title: 'Create Invoice in QuickBooks',
				onClose: onClose,
				buttons: !connectionTypeSet ? [{
					name: 'Continue',
					className: 'btn btn-primary ' + (connectionType === null ? 'disabled' : ''),
					onClick: this.__setConnectionType
				}] : invoiceCreated || invoiceQueued ? [{
					name: 'Okay',
					className: 'btn btn-default',
					onClick: onClose
				}] : [{
					name: 'Cancel',
					className: 'btn btn-default',
					onClick: onClose
				}, {
					name: 'Save',
					className: 'btn btn-primary' + (!this.state.create_customer || isWaiting || invoiceCreated || invoiceQueued ? ' disabled' : ''),
					onClick: !this.state.create_customer ? null : this.__createInvoice
				}]
			}, dd.div({ className: "row" }, LoadingWrap({ is_loading: isWaiting, text: loadingText }, ErrorAlert({ message: ajax2.error }), ErrorAlert({ message: ajax3.error }), ErrorAlert({ message: ajax4.error }), ProOnly({ sids: event.sids }, !connectionTypeSet ? dd.div({ className: 'col-sm-12' }, dd.div({ className: 'alert alert-info' }, 'It looks like you haven\'t selected a QuickBooks connection type yet.  Please choose one of the options below to continue.'), dd.div({ className: "row" }, dd.div({ className: "col-sm-6 text-center" }, dd.div({ className: 'radio' }, dd.label(null, dd.input({ type: 'radio', 'name': 'connection_type', style: { float: 'none' }, defaultChecked: false, onChange: this.__connectionTypeSelected.bind(this, 'online') }), dd.span({ style: { fontSize: '18px' } }, ' QuickBooks Online')))), dd.div({ className: "col-sm-6 text-center" }, dd.div({ className: 'radio' }, dd.label(null, dd.input({ type: 'radio', 'name': 'connection_type', style: { float: 'none' }, defaultChecked: false, onChange: this.__connectionTypeSelected.bind(this, 'desktop') }), dd.span({ style: { fontSize: '18px' } }, ' QuickBooks Desktop')))))) : dd.div({ className: 'col-sm-12' },
	
			// show success message if invoice was created
			invoiceCreated ? dd.div(null, dd.div({ className: 'alert alert-success' }, 'A new invoice within your QuickBooks account has been created successfully!')) : invoiceQueued ? dd.div(null, dd.div({ className: 'alert alert-success' }, dd.strong(null, 'A new invoice has been queued for creation!'), dd.br(null), dd.small(null, 'The next time that your QuickBooks Web Connector software runs the eSpeakers QWC application, the queued invoice will be created within your QuickBooks software.  If the invoice does not get created, the most likely cause of failure is having a service/product on your invoice that does not match an item within your QuickBooks software exactly.'))) : dd.div(null,
	
			// determine if we found a matching customer or not
			desktopCreate ? dd.div(null, !this.state.hide_notice ? dd.div({ className: 'alert alert-warning', style: { marginBottom: '15px', fontSize: '13px' } }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-6' }, dd.strong(null, 'Desktop Notice')), dd.div({ className: 'col-sm-6', style: { textAlign: 'right' } }, desktopNoticeShown ? dd.a({ href: '#', onClick: this.__hideDesktopNotice }, '- collapse') : dd.a({ href: '#', onClick: this.__showDesktopNotice }, '+ expand'))), desktopNoticeShown ? dd.div({ style: { marginTop: '10px' } }, dd.p(null, 'In order to create an invoice within your QuickBooks desktop software, the following conditions must be met:'), dd.ul({ style: { marginTop: '10px', marginBottom: '10px' } }, dd.li(null, 'Have the Quickbooks Web Connector software installed and configured. For help, please see the following wiki article: ', dd.a({ href: 'https://www.espeakers.com/wiki/Connect_Quickbooks_to_your_EventCX_account', target: '_blank' }, 'https://www.espeakers.com/wiki/Connect_Quickbooks_to_your_EventCX_account')), dd.li(null, 'If you do not have an existing customer within your QuickBooks software that matches the customer name shown below ', dd.strong(null, 'exactly'), ', then a new customer with that name will be created automatically.'), dd.li(null, 'For each service/product that you select below, ', dd.strong({ className: 'text-danger' }, 'you must have an existing item (or items) within your QuickBooks software that matches the service/product CODE exactly'), ', otherwise the invoice will NOT be created.'))) : '') : '', dd.div(null, 'Customer: ', dd.strong(null, event.organization))) : customer && customer.name ? dd.div(null, dd.div({ className: 'text-success' }, 'Matching QuickBooks customer found: ', dd.strong(null, customer.name))) : dd.div(null, dd.div({ className: 'text-warning' }, dd.strong(null, event.organization), ' was not found in your Quickbooks customers list.'), dd.div(null, dd.input({ className: '', type: 'checkbox', defaultChecked: true, onChange: this.__toggleCreateCustomer }), dd.small(null, ' Yes, I would like to create a new QuickBooks customer using this name.')), this.state.create_customer ? null : dd.div({ className: 'text-muted' }, dd.small(null, '(If you do not want to create a new QuickBooks customer, you must instead change the event PRESENTING TO field so it exactly matches a customer name in your QuickBooks account.)'))), dd.hr(), dd.h5({ style: { marginTop: '30px' } }, 'Select service(s) to include on invoice:'),
			// show services table
			dd.table({ className: 'table table-responsive table-condensed' }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, ''), dd.th({ style: { width: 1 } }, 'Code'), dd.th({ style: { width: 1 } }, 'Due'), dd.th(null, 'Description'), dd.th({ style: { width: 1 } }, 'Amount'))), _.isEmpty(services) ? null : dd.tbody(null, _.map(services, function (service) {
				return dd.tr({ key: service.id, className: '' }, dd.td(null, dd.input({ type: 'checkbox', defaultChecked: checkedStatus, onChange: this.__updateSelectedItems.bind(this, service.id, 'service') })), dd.td(null, service.groupcode), dd.td(null, !service.due ? '' : esUtils.format_date(service.due, 'mm/dd/yyyy')), dd.td(null, service.description), dd.td(null, serviceFee(service)));
			}, this)), _.isEmpty(services) ? dd.tbody(null, dd.tr(null, dd.td({ colSpan: 5, style: { textAlign: 'center' } }, '-- no services --'))) : null), dd.h5({ style: { marginTop: '30px' } }, 'Select product(s) to include on invoice:'),
			// show products table
			dd.table({ className: 'table table-responsive table-condensed' }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, ''), dd.th({ style: { width: 1 } }, "Code"), dd.th({ style: { width: 1 } }, "Qty"), dd.th(null, "Description"), dd.th({ style: { width: 1 } }, "Price"))), _.isEmpty(products) ? null : dd.tbody(null, _.map(products, function (product) {
				return dd.tr({ key: product.id, className: '' }, dd.td(null, dd.input({ type: 'checkbox', defaultChecked: checkedStatus, onChange: this.__updateSelectedItems.bind(this, product.id, 'product') })), dd.td(null, product.groupcode), dd.td(null, numberOrZero(product.qtysold)), dd.td(null, product.description), dd.td(null, esUtils.format_currency(numberOrZero(product.priceeach), 2)));
			}, this)), _.isEmpty(products) ? dd.tbody(null, dd.tr(null, dd.td({ colSpan: 5, style: { textAlign: 'center' } }, '-- no products --'))) : null), dd.div({ style: { marginTop: '50px', marginBottom: '-70px', float: 'left' } }, dd.small({ className: 'text-muted' }, 'connection type: ' + connectionType + ' (', dd.a({ href: '#', className: 'text-muted', onClick: this.__resetConnectionType }, dd.u(null, 'change')), ')'))))))));
		}
	});

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var FormUtils = __webpack_require__(9);
	var HorizontalFields = __webpack_require__(23);
	var AccountingLockedWarning = __webpack_require__(123);
	var EventFormUnsavedChangeMixin = __webpack_require__(45);
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var service = this.props.service;
	
			if (!_.isArray(event.Service)) {
				event.Service = [];
			}
			if (!service || service.id < 0) {
				service = { id: 0, eid: event.eid };
				event.Service.push(service);
			}
			_.each(event.Service, function (item) {
				if (item.id == service.id) {
	
					item.groupcode = _.get(data, "groupcode", "").trim().toUpperCase();
					item.description = (data.description || "").trim();
					item.due = _.isDate(data.due) ? data.due : 0;
	
					if (/actual/i.test(data.amount)) {
						item.fee = 0;
						_.set(item, ["flags_as_map", "bill_later", "is_set"], true);
					} else if (/free/i.test(data.amount)) {
						item.fee = 0;
						_.set(item, ["flags_as_map", "free", "is_set"], true);
					} else {
						item.fee = parseFloat(data.amount.replace(/(\$| )/g, ''));
					}
				}
			});
			radio('save_Event').broadcast(event);
			this.__close();
		},
		__deleteIt: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var service = this.props.service;
			event.Service = _.reject(event.Service, function (item) {
				return item.id == service.id;
			});
			radio("save_Event").broadcast(event);
			this.__close();
		}),
		__close: function __close() {
			if (_.isFunction(this.props.onCancel)) {
				this.props.onCancel();
			}
		},
		render: function render() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
			var service = this.props.service;
			var onCancel = this.props.onCancel;
	
			return dd.div({ className: 'ServiceForm' }, DaForm({
				event: event,
				Displaylists: Displaylists,
				service: service,
				onSubmit: this.__onSubmit,
				deleteIt: this.__deleteIt,
				onCancel: onCancel
			}));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			var service = this.props.service;
			return service && service.id > 0 ? service.id : 0;
		},
		getInitialValues: function getInitialValues(props) {
			var service = props.service;
			if (!service) {
				return null;
			}
			var isFlag = function isFlag(f) {
				return _.get(service, ["flags_as_map", f, "is_set"], false);
			};
			var amount = service.fee;
			if (isFlag('free')) {
				amount = 'Free';
			} else if (isFlag('bill_later')) {
				amount = 'Actual';
			}
			return {
				groupcode: service.groupcode,
				due: service.due,
				description: service.description,
				amount: amount + "" //must be string
			};
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			if (field_path === 'groupcode') {
				var data = this.state.data || {};
				var service_codes = this.__getServiceCodes();
				var code = service_codes[new_value];
				if (code) {
					data.description = code.description;
					data.amount = code.fee + ""; //must be string
					data.groupcode = code.groupcode;
					this.setState({ data: data });
				}
			}
			//from EventFormUnsavedChangeMixin
			this.__checkForChangesMade();
		},
		__getServiceCodes: function __getServiceCodes() {
			var event = this.props.event;
			var Displaylists = this.props.Displaylists;
	
			var service_codes = [];
			if (Displaylists && event) {
				service_codes = _.reduce(_.filter(Displaylists.perspeaker, function (speaker) {
					return _.includes(event.sids, speaker.sid);
				}), function (list, speaker) {
					return list.concat(speaker.servicecodes);
				}, []);
			}
			return service_codes;
		},
		buildFields: function buildFields() {
			var schema = {
				groupcode: {
					label: 'Code',
					type: 'combo',
					options: _.object(_.map(this.__getServiceCodes(), function (code, i) {
						return [i, code.groupcode];
					})),
					placeholder: 'Code',
					tooltip: 'A 4-character code you make up to categorize your income in eSpeakers reports. Not seen by customers - use whatever makes sense in your office. Examples: KEYN for "keynote fee", TRAV for "travel expenses", etc...'
				},
				due: {
					label: 'Due Date',
					type: 'date',
					tooltip: 'The date this item should be paid by the client.',
					validate: FormUtils.v.optional
				},
				description: {
					label: 'Description',
					type: 'text',
					placeholder: 'Description',
					tooltip: 'Describe the purpose of this item. Examples: "standard keynote fee", "flat travel fee".',
					validate: FormUtils.v.optional
				},
				amount: {
					label: 'Amount',
					type: 'combo',
					options: {
						Free: 'Free',
						Actual: 'Actual Cost'
					},
					validate: function validate(value) {
						var validAmount = /^ *(\-? *[$]? *\-? *[0-9,]*[.]?[0-9]?[0-9]?|Actual|Free) *$/i;
						return validAmount.test(value) && value.trim().length > 0 || 'Enter an amount or FREE or ACTUAL';
					},
					placeholder: 'Amount',
					tooltip: 'The amount, in USD, you are charging the customer. Most often you will enter dollars and cents here, but you can choose ACTUAL COST to indicate you will provide the amount later, or FREE to indicate there is no charge for this item. You can use a negative number to indicate a commission or other expense.'
				}
			};
			return schema;
		},
		__onCancel: esUtils.wrapPreventDefault(function () {
			this.updateUnsavedState(false);
			this.props.onCancel();
		}),
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var _props = this.props,
			    event = _props.event,
			    service = _props.service,
			    deleteIt = _props.deleteIt;
	
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}), HorizontalFields.FormButtons({
				right_align_buttons: true,
				submit_btn_text: service && service.id > 0 ? 'Save' : 'Add',
				onDelete: service && service.id > 0 ? deleteIt : null,
				onCancel: this.__onCancel
			}), AccountingLockedWarning({ event: event }));
		}
	});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	//let React = require("ES/lib/react");
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var AuthedUserSession = __webpack_require__(4);
	var ServiceForm = __webpack_require__(322);
	var FormButtons = __webpack_require__(36);
	var SlideOpenDown = __webpack_require__(27);
	var ComputeBtnModal = AuthedUserSession.is_st_family ? __webpack_require__(317) : null;
	var createStandardEventForm = __webpack_require__(30);
	var Constants = __webpack_require__(13);
	
	var DepositPercentForm = createStandardEventForm({
	  eventToInitialValues: function eventToInitialValues(event) {
	    return {
	      depositPercent: event.depositPercent + "",
	      depositLock: _.get(event, ["flags_as_map", "st_deposit_lock", "is_set"], false)
	    };
	  },
	  buildSchema: function buildSchema(props) {
	    var r = {
	      depositPercent: {
	        label: "Dep %",
	        type: "text",
	        validate: FormUtils.v.blankOr(FormUtils.v.percent)
	      }
	    };
	    if (AuthedUserSession.is_st_family && (_.get(props, "event.childids", []).length > 0 || Constants.EVENTTYPE_PD === _.get(props, "event.eventClass"))) {
	      _.set(r, "depositLock", {
	        label: "Lock Deposit",
	        type: "checkbox"
	      });
	    }
	    return r;
	  },
	  writeInputDataToEvent: function writeInputDataToEvent(data, event) {
	    _.set(event, "depositPercent", esUtils.isBlank(data.depositPercent) ? null : esUtils.toInt(data.depositPercent));
	    _.set(event, ["flags_as_map", "st_deposit_lock", "is_set"], _.get(data, "depositLock", false));
	  },
	  renderButtons: function renderButtons() {
	    var onDiscard = this.__discardChanges;
	    var changes_made = this.Form_areChangesMade();
	    return dd.div({ className: "text-right" }, SlideOpenDown({ open: changes_made }, FormButtons({ onDiscard: onDiscard })));
	  }
	});
	
	var serviceFee = function serviceFee(service) {
	  if (!service) {
	    return "";
	  }
	  var isFlag = function isFlag(f) {
	    return _.get(service, ["flags_as_map", f, "is_set"], false);
	  };
	  if (isFlag("free")) {
	    return "Free";
	  } else if (isFlag("bill_later")) {
	    return "Actual";
	  }
	
	  return esUtils.format_currency(service.fee, 2);
	};
	
	var serviceDate = function serviceDate(service) {
	  var r = "";
	
	  if (service.due) {
	    r = esUtils.format_date(service.due, "mm/dd/yyyy");
	  }
	
	  return r;
	};
	
	var serviceDescription = function serviceDescription(service) {
	  if (!service) {
	    return "";
	  }
	
	  return dd.div(null, service.description);
	};
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { editing_id: null, show_compute_modal: false };
	  },
	  __setEditingId: function __setEditingId(id) {
	    return _.bind(esUtils.wrapPreventDefault(function () {
	      this.setState({ editing_id: id });
	    }), this);
	  },
	
	  __addRoyalties: esUtils.wrapPreventDefault(function () {
	    radio("add_royalty_items").broadcast(this.props.event);
	  }),
	  __compute: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_compute_modal: !this.state.show_compute_modal });
	  }),
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        Displaylists = _props.Displaylists,
	        read_only = _props.read_only;
	    var _state = this.state,
	        editing_id = _state.editing_id,
	        show_compute_modal = _state.show_compute_modal;
	
	
	    var services = event.Service;
	    var mp_services = event.MPServices; // service combined with payments
	    var services_by_id = _.object(_.map(services, function (service) {
	      _.set(service, ["payment"], _.get(mp_services, [service.id, "payment"]));
	      return [service.id, service];
	    }));
	
	    if (!_.isEmpty(services) && AuthedUserSession.is_st_family) {
	      //pivotal story #146093113
	      services = _.sortByOrder(services, ['fee'], ['desc']);
	    }
	
	    return dd.div({ className: "ServicesTable" }, dd.table({ className: "table table-responsive table-condensed" + (read_only || event.is_mp_event ? "" : " table-hover") }, dd.thead(null, dd.tr(null, dd.th({ style: { width: 1 } }, "Code"), dd.th({ style: { width: 1 } }, "Due"), dd.th(null, "Description"), dd.th({ style: { width: 1 } }, "Amount"))), _.isEmpty(services) ? null : dd.tbody(null, _.map(services, function (service) {
	      var editable = !read_only && !event.is_mp_event;
	
	      var classes = [];
	      if (editable) {
	        classes.push("editable");
	      }
	
	      return dd.tr({ key: service.id, className: classes.join(" "), onClick: !editable ? null : this.__setEditingId(service.id) }, dd.td(null, service.groupcode), dd.td(null, serviceDate(service)), dd.td(null, serviceDescription(service)), dd.td(null, serviceFee(service)));
	    }, this)), _.isEmpty(services) ? dd.tbody(null, dd.tr(null, dd.td({ colSpan: 4, style: { textAlign: "center" } }, "-- no services --"))) : null, _.isEmpty(services) || AuthedUserSession.is_st_family || 'cs' === AuthedUserSession.privatelabel_code ? null : dd.tfoot(null, dd.tr({ className: "servicetotal" }, dd.td({ colSpan: 3 }, "TOTAL"), dd.td(null, esUtils.format_currency(_.reduce(services, function (sum, service) {
	      return sum + parseFloat(service.fee);
	    }, 0), 2) + (event.is_mp_event ? "*" : ""))))), event.is_mp_event ? null : dd.div({ className: "row" }, dd.div({ className: "col-sm-5" }, DepositPercentForm({ event: event, Displaylists: Displaylists, read_only: read_only })), read_only ? null : dd.div({ className: "col-sm-7 text-right" }, AuthedUserSession.is_st_family ? dd.button({ className: "btn btn-default btn-sm", onClick: this.__addRoyalties }, "Add Royalties") : null, " ", ComputeBtnModal ? dd.button({ className: "btn btn-default btn-sm", onClick: this.__compute }, "Compute") : null, " ", dd.button({ className: "btn btn-default btn-sm", onClick: this.__setEditingId(0) }, dd.i({ className: "fa fa-plus" }), " Add Service"))), dd.div({ className: "clearfix" }), show_compute_modal && !!ComputeBtnModal ? ComputeBtnModal({ event: event, Displaylists: Displaylists, onClose: this.__compute }) : null, editing_id !== null ? Modal({
	      title: editing_id > 0 ? "Edit Service" : "New Service",
	      onClose: this.__setEditingId(null),
	      buttons: []
	    }, ServiceForm({
	      event: event,
	      service: services_by_id[editing_id] || null,
	      onCancel: this.__setEditingId(null),
	      Displaylists: Displaylists
	    })) : null);
	  }
	});

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var FormUtils = __webpack_require__(9);
	var createStandardEventForm = __webpack_require__(30);
	
	var DaForm = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				month: esUtils.getIn(event, ["key_values", "UNSCHEDULED_MONTH"]),
				year: esUtils.getIn(event, ["key_values", "UNSCHEDULED_YEAR"])
			};
		},
		buildSchema: function buildSchema() {
			var curr_year = new Date().getFullYear();
			return {
				month: {
					label: "Month",
					type: "select",
					dont_sort_options: true,
					options: _.object(_.map(_.range(1, 13), function (m) {
						return [m, esUtils.get_month_name(m)];
					})),
					validate: FormUtils.v.blankOr(FormUtils.v.positive_integer)
				},
				year: {
					label: "Year",
					type: "select",
					dont_sort_options: true,
					options: _.object(_.map(_.range(curr_year - 1, curr_year + 5), function (y) {
						return [y, y];
					})),
					validate: FormUtils.v.positive_integer
				}
			};
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			if (!_.isPlainObject(event.key_values)) {
				event.key_values = {};
			}
			event.key_values.UNSCHEDULED_MONTH = esUtils.toInt(data.month);
			event.key_values.UNSCHEDULED_YEAR = esUtils.toInt(data.year);
		}
	});
	
	module.exports = dd.createClass({
		render: function render() {
			if (!_.isEmpty(this.props.event.Stagetime)) {
				return dd.span(); //nothing to see
			}
			return DaForm(_.assign({
				form_section_name: "Unscheduled Event"
			}, this.props));
		}
	});

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Ledger = __webpack_require__(127);
	
	var _Ledger2 = _interopRequireDefault(_Ledger);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	var _PackagesForm = __webpack_require__(318);
	
	var _PackagesForm2 = _interopRequireDefault(_PackagesForm);
	
	var _ServicesTable = __webpack_require__(323);
	
	var _ServicesTable2 = _interopRequireDefault(_ServicesTable);
	
	var _ProductSaleTable = __webpack_require__(320);
	
	var _ProductSaleTable2 = _interopRequireDefault(_ProductSaleTable);
	
	var _AuthedUserSession = __webpack_require__(4);
	
	var _AuthedUserSession2 = _interopRequireDefault(_AuthedUserSession);
	
	var _isEventAccountingLockedForMe = __webpack_require__(55);
	
	var _isEventAccountingLockedForMe2 = _interopRequireDefault(_isEventAccountingLockedForMe);
	
	var _getOfferStatusForJob = __webpack_require__(95);
	
	var _getOfferStatusForJob2 = _interopRequireDefault(_getOfferStatusForJob);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnscheduledEventEstimatedMonthAndYear = _AuthedUserSession2.default.is_st_family ? __webpack_require__(324) : null;
	var QuickBooks = !_AuthedUserSession2.default.is_privatelabel ? __webpack_require__(321) : null;
	
	module.exports = _react2.default.createFactory(_react2.default.createClass({
	    displayName: "exports",
	
	    getInitialState: function getInitialState() {
	        return {
	            show_quickbooks: false
	        };
	    },
	
	    __toggleQuickbooks: _esUtils2.default.wrapPreventDefault(function () {
	        this.setState({
	            show_quickbooks: !this.state.show_quickbooks
	        });
	    }),
	
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists;
	
	        var mp_agreement = _lodash2.default.get(event, ["MPAgreement", _lodash2.default.first(event.sids)]);
	        var offer_status = _getOfferStatusForJob2.default.statusForEvent(event, _lodash2.default.first(event.sids), false);
	        var body = void 0;
	        var read_only = _AuthedUserSession2.default.doIHaveAccess.read_or_travel.all(event.sids) || (0, _isEventAccountingLockedForMe2.default)(event);
	        var params = { event: event, Displaylists: Displaylists, read_only: read_only };
	
	        var money_tab_url = "#/marketplace/" + _lodash2.default.first(event.sids) + "/money";
	
	        if (event.is_mp_event) {
	            if (_lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "offer accepted")) {
	
	                //MP, ACCEPTED OFFER
	                body = _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Job Fees collected through Marketplace"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "instruction" },
	                        "These fees were set when the offer was accepted, and are collected for you by eSpeakers."
	                    ),
	                    _react2.default.createElement(_Ledger2.default, {
	                        event: event,
	                        Displaylists: Displaylists,
	                        mp_agreement: mp_agreement,
	                        display_payments: true
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-muted pull-left" },
	                        _react2.default.createElement(
	                            "a",
	                            { target: "_blank", href: "https://espeakers.com/wiki/How_do_I_pay_my_presenter_through_the_Marketplace_platform%3F" },
	                            "How does my client pay? \xBB"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-muted pull-right" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: money_tab_url },
	                            "Stripe balance \xBB"
	                        )
	                    ),
	                    _react2.default.createElement("div", { className: "clearfix" }),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "section-head" },
	                        "Products"
	                    ),
	                    (0, _ProductSaleTable2.default)(params),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "section-head" },
	                        "Packages"
	                    ),
	                    (0, _PackagesForm2.default)(params)
	                );
	            } else {
	                body = _react2.default.createElement(
	                    "div",
	                    { className: "text-muted", style: { marginTop: "2em", marginBottom: "2em" } },
	                    "Once this Marketplace job has an accepted offer, the price and payments will be displayed here."
	                );
	            }
	            //only an MP job with an accepted offer should ever be shown on this screen
	            // else if (_.indexOf(OFFER_STATII, offer_status) >= _.indexOf(OFFER_STATII, "waiting client")) {
	            //
	            //     //MP, OFFER MADE BUT NOT ACCEPTED YET -- we shouldn't ever get here
	            //     body = <div>
	            //         <h2>Job Fees
	            //         </h2>
	            //         <p className="instruction">
	            //             The offer is not finalized yet.
	            //         </p>
	            //         <Ledger
	            //             event={event}
	            //             Displaylists={Displaylists}
	            //             mp_agreement={mp_agreement}
	            //             display_payments={false}
	            //         />
	            //         <div className="text-muted text-right"><a href={money_tab_url}>Stripe balance &raquo;</a>
	            //         </div>
	            //
	            //         <h4 className="section-head">Products</h4>
	            //         {ProductSaleTable(params)}
	            //
	            //         <h4 className="section-head">Packages</h4>
	            //         {PackagesForm(params)}
	            //     </div>;
	            // } else {
	            //
	            //     //MP, NO OFFER
	            //     body = <div>
	            //         <h2>Job Fees</h2>
	            //         <p style={{fontStyle: "italic"}}>Once an offer has been made, payment details will be displayed here.</p>
	            //     </div>;
	            // }
	        } else {
	
	            //NOT MARKETPLACE
	            body = _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Services",
	                    QuickBooks && _react2.default.createElement(
	                        "span",
	                        { className: "pull-right" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: "btn btn-default btn-sm", onClick: this.__toggleQuickbooks },
	                            "Copy To QuickBooks"
	                        )
	                    )
	                ),
	                (0, _ServicesTable2.default)(params),
	                UnscheduledEventEstimatedMonthAndYear && UnscheduledEventEstimatedMonthAndYear(params),
	                _react2.default.createElement(
	                    "h4",
	                    { className: "section-head" },
	                    "Products"
	                ),
	                (0, _ProductSaleTable2.default)(params),
	                _react2.default.createElement(
	                    "h4",
	                    { className: "section-head" },
	                    "Packages"
	                ),
	                (0, _PackagesForm2.default)(params)
	            );
	        }
	
	        return _react2.default.createElement(
	            "div",
	            { className: "Services" },
	            body,
	            this.state.show_quickbooks && QuickBooks && QuickBooks({ onClose: this.__toggleQuickbooks, event: event })
	        );
	    }
	}));

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var dateformat = __webpack_require__(41);
	var FormUtils = __webpack_require__(9);
	var ErrorAlert = __webpack_require__(6);
	var RadioServiceMixin = __webpack_require__(14);
	
	var incomingPlanToSummaryMessage = function incomingPlanToSummaryMessage(incoming_plan) {
		var n_hotels = _.size(incoming_plan.Hotel);
		var n_flights = _.size(incoming_plan.Flight);
		var n_grounds = _.size(incoming_plan.Ground);
		var parts = [];
		if (n_flights > 0) {
			parts.push(n_flights + " Flight" + (n_flights > 1 ? "s" : ""));
		}
		if (n_grounds > 0) {
			parts.push(n_grounds + " Ground travel");
		}
		if (n_hotels > 0) {
			parts.push(n_hotels + " Hotel" + (n_hotels > 1 ? "s" : ""));
		}
	
		if (parts.length >= 3) {
			return _.take(parts, 2).join(", ") + " and " + _.last(parts);
		} else if (parts.length == 2) {
			return parts.join(" and ");
		} else if (parts.length == 1) {
			return _.first(parts);
		}
		return "";
	};
	
	var incomingPlanToOverwriteMessage = function incomingPlanToOverwriteMessage(incoming_plan) {
		var n_hotels = _.size(incoming_plan.Hotel);
		var n_flights = _.size(incoming_plan.Flight);
		var n_grounds = _.size(incoming_plan.Ground);
		var parts = [];
		if (n_flights > 0) {
			parts.push(" Flight");
		}
		if (n_grounds > 0) {
			parts.push(" Ground travel");
		}
		if (n_hotels > 0) {
			parts.push(" Hotel");
		}
	
		if (parts.length >= 3) {
			return _.take(parts, 2).join(", ") + " and " + _.last(parts);
		} else if (parts.length == 2) {
			return parts.join(" and ");
		} else if (parts.length == 1) {
			return _.first(parts);
		}
		return "";
	};
	
	var ApplyIncomingPlan = dd.createClass({
		getInitialState: function getInitialState() {
			return { clear_current: false };
		},
		__onChange: function __onChange(e) {
			this.setState({ clear_current: !!e.target.checked });
		},
	
		__applyIncomingPlan: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var clear_current = this.state.clear_current;
			var _props = this.props,
			    onClose = _props.onClose,
			    id = _props.id,
			    incoming_plan = _props.incoming_plan;
	
	
			if (incoming_plan.type === 'flight') {
				if (clear_current || !_.isArray(event['Flight'])) {
					event['Flight'] = [];
				}
				event['Flight'] = event['Flight'].concat(_.map(incoming_plan.data.Flight, esUtils.convertBalboa3ToJS['Flight']));
			} else if (incoming_plan.type === 'carRental') {
				if (clear_current || !_.isArray(event['Ground'])) {
					event['Ground'] = [];
				}
				event['Ground'] = event['Ground'].concat(_.map(incoming_plan.data.Ground, esUtils.convertBalboa3ToJS['Ground']));
			} else if (incoming_plan.type === 'hotelReservation') {
				if (clear_current || !_.isArray(event['Hotel'])) {
					event['Hotel'] = [];
				}
				event['Hotel'] = event['Hotel'].concat(_.map(incoming_plan.data.Hotel, esUtils.convertBalboa3ToJS['Hotel']));
			}
			event.tripitID = id;
			radio("save_Event").broadcast(event);
			onClose();
		}),
		render: function render() {
			var _props2 = this.props,
			    onClose = _props2.onClose,
			    incoming_plan = _props2.incoming_plan;
	
	
			return Modal({
				title: "Import Itinerary from AwardWallet",
				buttons: [],
				onClose: onClose
			}, dd.p(null, "Would you like to import ", dd.b(null, incomingPlanToSummaryMessage(incoming_plan.data)), " item(s) to your event?"), dd.p(null, dd.label({ style: { fontWeight: "normal" } }, dd.input({ type: "checkbox", checked: this.state.clear_current, onChange: this.__onChange }), " Overwrite my current", dd.b(null, incomingPlanToOverwriteMessage(incoming_plan.data)), " itinerary")), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: this.__applyIncomingPlan }, "Yes"), " ", dd.button({ className: "btn btn-default", onClick: onClose }, "No")));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [FormMixin, RadioServiceMixin],
		getInitialState: function getInitialState() {
			return {
				selected_trip: null
			};
		},
		RadioService_setup: function RadioService_setup() {
			return {
				AwardWallet_get_list: {
					key: function key() {
						return 1;
					}
				}
			};
		},
		componentDidMount: function componentDidMount() {
			radio("AwardWallet_get_list").broadcast({
				eid: this.props.event.eid,
				start_date: dateformat(this.props.event.starttime, 'yyyy-mm-dd'),
				end_date: dateformat(this.props.event.stoptime, 'yyyy-mm-dd')
			});
		},
		getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
			return esUtils.getEventVersionIdentifier(props.event);
		},
		getInitialValues: function getInitialValues(props) {
			return {
				id: props.event.id
			};
		},
		buildSchema: function buildSchema() {
			var event = this.props.event;
	
			var aw_list = this.state.AwardWallet_get_list.data;
	
			return {
				id: {
					label: "Copy from AwardWallet",
					type: "select",
					placeholder: "---",
					options: _.object(_.filter(_.flatten(_.map(aw_list, function (list, sid) {
						return _.includes(event.sids, esUtils.toInt(sid)) ? _.map(_.filter(list, "id"), function (l) {
							return [l.id, l.description];
						}) : null;
					})))),
					validate: FormUtils.v.required
				}
			};
		},
		onFormChanged: function onFormChanged(field_path, new_value) {
			var aw_list = this.state.AwardWallet_get_list.data;
			var tripid = new_value;
	
			var sid = _.first(_.filter(_.map(aw_list, function (list, sid) {
				return _.includes(_.map(list, "id"), tripid) ? sid : null;
			})));
	
			var trip = _.first(_.filter(_.get(aw_list, [sid]), function (item) {
				return _.get(item, ["id"]) === tripid;
			}));
	
			if (sid > 0 && trip) {
				this.setState({ selected_trip: trip });
				// build the trip from the list data
			}
		},
	
		__cancelIncomingPlan: esUtils.wrapPreventDefault(function () {
			this.setState({ selected_trip: null });
		}),
		render: function render() {
			var _props3 = this.props,
			    event = _props3.event,
			    Displaylists = _props3.Displaylists;
	
			var fields = this.Form_buildSchema();
			var data = this.state.data || {};
			var selected_trip = this.state.selected_trip;
	
			var ajax_list = this.state.AwardWallet_get_list;
	
			var name_by_sid = _.object(_.map(Displaylists && Displaylists.perspeaker, function (spkr) {
				return [spkr.sid, spkr.name_full];
			}));
	
			var fails_by_sid = _.object(_.filter(_.map(ajax_list.data, function (list, sid) {
				return _.includes(event.sids, esUtils.toInt(sid)) ? [sid, _.filter(_.map(list, "failed"))] : null;
			}), function (pair) {
				return _.isArray(pair) && pair[1].length > 0;
			}));
	
			return dd.div(null, ErrorAlert({ message: ajax_list.error }),
			//we need to check the _value_, not the _options_
	
			dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, dd.div({ className: "pull-right", style: { width: 245 } }, this.Form_buildInput(fields.id)), dd.label({ className: "text-muted", style: { fontWeight: "normal", marginTop: 6, marginRight: 5 } }, fields.id.label), dd.div({ className: "clearfix" })), _.map(fails_by_sid, function (fails, sid) {
				return dd.div({ key: sid, className: "text-warning" }, _.map(fails, function (fail, i) {
					return dd.div({ key: i }, fail + " (" + name_by_sid[sid] + ")");
				}));
			}),
	
			// Sits under the "To grab trips, first connect to your AwardWallet
			// account..." warning above, which is where someone who has not hooked
			// up AwardWallet yet ends up looking.
			dd.div({ className: "small", style: { marginBottom: 10 } }, dd.a({ href: "https://www.espeakers.com/kb/managing-event-travel", target: "_blank" }, "Learn more about AwardWallet and how to connect it to your account.", dd.i({ style: { marginLeft: "0.5em" }, className: "fa fa-external-link" }))), ajax_list.waiting ? dd.span(null, dd.i({ className: "fa fa-spinner fa-spin" }), " Pulling details from AwardWallet...") : null, selected_trip ? ApplyIncomingPlan({
				event: event,
				onClose: this.__cancelIncomingPlan,
				incoming_plan: selected_trip,
				id: data.id
			}) : null);
		}
	});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var _ = __webpack_require__(1);
	
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var HorizontalFields = __webpack_require__(23);
	var FormUtils = __webpack_require__(9);
	
	module.exports = dd.createClass({
	
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var flight = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (!_.isArray(event.Flight)) {
				event.Flight = [];
			}
			if (!flight || flight.id < 1) {
				flight = { id: 0, eid: event.eid };
				event.Flight.push(flight);
			}
			_.each(event.Flight, function (f) {
				if (f.id == flight.id) {
					f.groupcode = data.groupcode;
					f.description = data.description;
					f.agent = data.agent;
					f.cost = FormUtils.floatOr0(data.cost);
					f.legs = _.map(FormUtils.extractIdsFromKeys(data, /^leg_(\-?[0-9]+)_/), function (id) {
						var leg = { id: id > 0 ? id : 0 };
						leg.legto = data['leg_' + id + '_legto'];
						//leg.legcost = FormUtils.floatOr0(data['leg_' + id + '_legcost']);
						leg.legfrom = data['leg_' + id + '_legfrom'];
						leg.legseat = data['leg_' + id + '_legseat'];
						leg.legleave = data['leg_' + id + '_legleave'];
						leg.legarrive = data['leg_' + id + '_legarrive'];
						//leg.legticket = data['leg_' + id + '_legticket'];
						leg.legcarrier = data['leg_' + id + '_legcarrier'];
						leg.legflightnum = data['leg_' + id + '_legflightnum'];
						return leg;
					});
				}
			});
			radio('save_Event').broadcast(event);
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		},
		__onDelete: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var flight = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (flight && flight.id > 0) {
				event.Flight = _.reject(event.Flight, function (h) {
					return flight.id == h.id;
				});
				radio('save_Event').broadcast(event);
			}
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		}),
		render: function render() {
			return DaForm(_.assign({ onSubmit: this.__onSubmit, onDelete: this.__onDelete }, this.props));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(props) {
			var flight = props.data;
			if (!flight || flight.id < 1) {
				return null;
			}
			var data = {
				groupcode: flight.groupcode,
				description: flight.description,
				agent: flight.agent,
				cost: flight.cost
			};
			_.each(flight.legs, function (leg) {
				data['leg_' + leg.id + '_legto'] = leg.legto;
				//data['leg_' + leg.id + '_legcost'] = leg.legcost;
				data['leg_' + leg.id + '_legfrom'] = leg.legfrom;
				data['leg_' + leg.id + '_legseat'] = leg.legseat;
				data['leg_' + leg.id + '_legleave'] = leg.legleave;
				data['leg_' + leg.id + '_legarrive'] = leg.legarrive;
				//data['leg_' + leg.id + '_legticket'] = leg.legticket;
				data['leg_' + leg.id + '_legcarrier'] = leg.legcarrier;
				data['leg_' + leg.id + '_legflightnum'] = leg.legflightnum;
			});
			return data;
		},
		buildFields: function buildFields() {
			var Displaylists = this.props.Displaylists;
			var data = this.state.data || {};
			var schema = {
				description: { label: 'Description' },
				agent: { label: 'Conf #' },
				cost: {
					label: 'Cost',
					type: 'text',
					validate: FormUtils.v.blankOr(FormUtils.v.currency)
				}
			};
			var ids = FormUtils.extractIdsFromKeys(data, /^leg_(\-?[0-9]+)_/);
			_.each(ids, function (id) {
				schema['leg_' + id + '_legto'] = { label: 'To' };
				//			schema['leg_' + id + '_legcost'] = {
				//				label: 'Cost',
				//				type: 'text',
				//				validate: FormUtils.v.blankOr(FormUtils.v.currency)
				//			};
				schema['leg_' + id + '_legfrom'] = { label: 'From' };
				schema['leg_' + id + '_legseat'] = { label: 'Seat' };
				schema['leg_' + id + '_legleave'] = {
					label: 'Depart',
					type: 'date',
					pick_time: true
				};
				schema['leg_' + id + '_legarrive'] = {
					label: 'Arrive',
					type: 'date',
					pick_time: true
				};
				//schema['leg_' + id + '_legticket'] = {label: 'Ticket'};
				schema['leg_' + id + '_legcarrier'] = {
					label: 'Carrier',
					type: 'select',
					options: _.object(_.map(_.get(Displaylists, ["universal", "aircarriers"]), function (carrier) {
						return [carrier, carrier];
					}))
				};
				schema['leg_' + id + '_legflightnum'] = { label: 'Flight number' };
			});
			_.each(schema, function (field, name) {
				if (!_.has(field, 'type')) {
					field.type = 'text';
				}
				if (!_.has(field, 'validate')) {
					field.validate = FormUtils.optional;
				}
			});
			return schema;
		},
		__newLeg: esUtils.wrapPreventDefault(function () {
			var data = this.state.data || {};
			var id = -1;
			while (_.has(data, 'leg_' + id + '_legto')) {
				id -= 1;
			}
			data['leg_' + id + '_legto'] = 'new'; //just make one field then it'll pick up that there is a new leg
			this.setState({ data: data });
		}),
		__deleteLeg: function __deleteLeg(id) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				var data = self.state.data || {};
				self.setState({ data: FormUtils.filterKeysOut(data, new RegExp('^leg_' + id)) });
			});
		},
		render: function render() {
			var fields = this.buildFields(this.Displaylists);
			var errors = this.state.errors || {};
	
			var flight = this.props.data;
			var onCancel = this.props.onCancel;
			var onDelete = this.props.onDelete;
			var legCount = FormUtils.extractIdsFromKeys(fields, /^leg_(\-?[0-9]+)_/).length;
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				label_size: 2,
				layout: [['description'], ['agent', 'cost']]
			}), dd.h3({ style: { margin: '2em 0 0.5em 0' } }, legCount + ' Leg' + (legCount != 1 ? 's' : ''), dd.button({ className: 'btn btn-default btn-sm pull-right', onClick: this.__newLeg }, dd.i({ className: 'fa fa-plus' }), ' add leg')), dd.hr(), dd.div({ className: 'clearfix' }), dd.div(null, _.map(FormUtils.extractIdsFromKeys(fields, /^leg_(\-?[0-9]+)_/).sort(), function (id) {
				var prefix = 'leg_' + id + '_';
				return dd.div({ key: id }, HorizontalFields({
					fields: fields,
					errors: errors,
					buildInput: this._form_buildInput,
					label_size: 2,
					layout: [[dd.a({ href: '#', className: 'pull-right', onClick: this.__deleteLeg(id) }, 'delete leg')], [prefix + 'legfrom', prefix + 'legto'], [prefix + 'legleave'], [prefix + 'legarrive'], [prefix + 'legcarrier'], [prefix + 'legflightnum', prefix + 'legseat']]
				}), dd.hr());
			}, this)), HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				onCancel: onCancel,
				submit_btn_text: flight && flight.id > 0 ? 'Save' : 'Add',
				onDelete: flight && flight.id > 0 ? onDelete : null,
				right_align_buttons: true
			})
			//TODO dd.a({href: '#', className: 'pull-right', style: {fontSize: 14, marginTop: 4}}, 'copy from venue')
			);
		}
	});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var _ = __webpack_require__(1);
	
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var HorizontalFields = __webpack_require__(23);
	var FormUtils = __webpack_require__(9);
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var ground = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (!_.isArray(event.Ground)) {
				event.Ground = [];
			}
			if (!ground || ground.id < 1) {
				ground = { id: 0, eid: event.eid };
				event.Ground.push(ground);
			}
			_.each(event.Ground, function (g) {
				if (g.id == ground.id) {
					g.description = data.description;
					g.transportmode = data.transportmode;
					g.confirmation = data.confirmation;
					g.pickupinstructions = data.pickupinstructions;
					g.cost = FormUtils.floatOr0(data.cost);
					g.payment = data.payment;
					g.starttime = data.starttime;
				}
			});
			radio('save_Event').broadcast(event);
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		},
		__onDelete: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var ground = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (ground && ground.id > 0) {
				event.Ground = _.reject(event.Ground, function (g) {
					return ground.id == g.id;
				});
				radio('save_Event').broadcast(event);
			}
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		}),
		render: function render() {
			return DaForm(_.assign({ onSubmit: this.__onSubmit, onDelete: this.__onDelete }, this.props));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(props) {
			var ground = props.data;
			return ground && ground.id > 0 ? {
				description: ground.description,
				transportmode: ground.transportmode,
				confirmation: ground.confirmation,
				pickupinstructions: ground.pickupinstructions,
				cost: ground.cost,
				payment: ground.payment,
				starttime: ground.starttime
			} : null;
		},
		buildFields: function buildFields() {
			return {
				description: {
					label: 'Description',
					type: 'text',
					placeholder: 'Airport to hotel',
					validate: FormUtils.require
				},
				transportmode: {
					label: 'Transportation mode',
					type: 'text',
					placeholder: 'taxi',
					validate: FormUtils.optional
				},
				confirmation: {
					label: 'Conf #',
					type: 'text',
					validate: FormUtils.v.limitInputLength(20)
				},
				pickupinstructions: {
					label: 'Pickup Instructions',
					type: 'text',
					placeholder: 'driver with sign',
					validate: FormUtils.optional
				},
				cost: {
					label: 'Cost',
					type: 'text',
					validate: FormUtils.v.blankOr(FormUtils.v.currency)
				},
				payment: {
					label: 'Payment',
					type: 'combo',
					placeholder: '-select-',
					options: {
						PREPAID: "PREPAID",
						CASH: "CASH",
						CARD: "CARD",
						"N/A": ""
					},
					validate: FormUtils.optional
				},
				starttime: {
					label: 'Start time',
					type: 'date',
					pick_time: true
				}
			};
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
	
			var ground = this.props.data;
			var onCancel = this.props.onCancel;
			var onDelete = this.props.onDelete;
			var layout = [['description'], ['starttime'], ['transportmode', 'confirmation'], ['pickupinstructions'], ['cost', 'payment']];
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				layout: layout
			}), HorizontalFields.FormButtons({
				scale: 'md',
				submit_btn_text: ground && ground.id > 0 ? 'Save' : 'Add',
				onCancel: onCancel,
				onDelete: ground && ground.id > 0 ? onDelete : null,
				right_align_buttons: true
			}));
		}
	});

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var _ = __webpack_require__(1);
	
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(18);
	var HoverMixin = __webpack_require__(49);
	var HorizontalFields = __webpack_require__(23);
	var FormUtils = __webpack_require__(9);
	
	module.exports = dd.createClass({
		__onSubmit: function __onSubmit(data) {
			var event = _.cloneDeep(this.props.event);
			var hotel = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (!_.isArray(event.Hotel)) {
				event.Hotel = [];
			}
			if (!hotel || hotel.id < 1) {
				hotel = { id: 0, eid: event.eid };
				event.Hotel.push(hotel);
			}
			_.each(event.Hotel, function (h) {
				if (h.id == hotel.id) {
					h.checkindate = data.checkindate;
					h.checkoutdate = data.checkoutdate;
					h.name = data.name;
					h.confirmation = data.confirmation;
					h.phone = data.phone;
					h.fax = data.fax;
					h.address = data.address;
					h.city = data.city;
					h.st = data.st;
					h.country = data.country;
					h.zip = data.zip;
				}
			});
			radio('save_Event').broadcast(event);
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		},
		__onDelete: esUtils.wrapPreventDefault(function () {
			var event = _.cloneDeep(this.props.event);
			var hotel = this.props.data;
			var onCancel = this.props.onCancel;
	
			if (hotel && hotel.id > 0) {
				event.Hotel = _.reject(event.Hotel, function (h) {
					return hotel.id == h.id;
				});
				radio('save_Event').broadcast(event);
			}
			if (_.isFunction(onCancel)) {
				onCancel();
			}
		}),
		render: function render() {
			return DaForm(_.assign({ onSubmit: this.__onSubmit, onDelete: this.__onDelete }, this.props));
		}
	});
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		getInitialValues: function getInitialValues(props) {
			var hotel = props.data;
			var event = props.event || {};
			var stagetime = _.isEmpty(event.Stagetime) ? null : _.first(event.Stagetime);
			var venue = _.isEmpty(stagetime) ? null : _.first(_.first(event.Venue, { id: stagetime.venueid }));
	
			if (hotel && hotel.id > 0) {
				return {
					checkindate: hotel.checkindate,
					checkoutdate: hotel.checkoutdate,
					name: hotel.name,
					confirmation: hotel.confirmation,
					phone: hotel.phone,
					fax: hotel.fax,
					address: hotel.address,
					city: hotel.city,
					st: hotel.st,
					country: hotel.country,
					zip: hotel.zip
				};
			} else if (!_.isEmpty(stagetime) && !_.isEmpty(venue)) {
				//fill in some default data based on stagetime
				var checkin = new Date(stagetime.starttime);
				var checkout = new Date(stagetime.stoptime);
				checkin.setDate(checkin.getDate() - 1);
				checkout.setDate(checkout.getDate() + 1);
				return {
					checkindate: checkin,
					checkoutdate: checkout,
					name: '',
					confirmation: '',
					phone: '',
					fax: '',
					address: '',
					city: venue.city,
					st: venue.st,
					country: venue.country,
					zip: venue.zip
				};
			}
			return null;
		},
		buildFields: function buildFields() {
			var data = this.state.data || {};
			return _.assign(FormUtils.buildAddressFields(this.props.Displaylists, data), {
				checkindate: {
					label: 'Check in',
					type: 'date',
					pick_time: false
				},
				checkoutdate: {
					label: 'Check out',
					type: 'date',
					pick_time: false,
					validate: FormUtils.optional
				},
				name: {
					label: 'Hotel',
					type: 'text',
					placeholder: 'Marriott Downtown',
					validate: FormUtils.required
				},
				confirmation: {
					label: 'Conf #',
					type: 'text',
					placeholder: '123ABC',
					validate: FormUtils.optional
				},
				phone: {
					label: 'Phone',
					type: 'text',
					validate: FormUtils.optional
				},
				fax: {
					label: 'Fax',
					type: 'text',
					validate: FormUtils.optional
				}
			});
		},
		__copyFromVenue: function __copyFromVenue(venue) {
			_.each(['address', 'city', 'st', 'zip', 'country', 'phone', 'fax'], function (f) {
				this._form_onChange(f, venue[f]);
			}, this);
			this._form_onChange('name', venue.building);
		},
		render: function render() {
			var fields = this.buildFields();
			var errors = this.state.errors || {};
			var _form_buildInput = this._form_buildInput;
	
			var hotel = this.props.data;
			var event = this.props.event || {};
			var onCancel = this.props.onCancel;
			var onDelete = this.props.onDelete;
	
			var makeFields = function makeFields(layout) {
				return HorizontalFields({
					fields: fields,
					errors: errors,
					buildInput: _form_buildInput,
					label_size: 2,
					layout: layout
				});
			};
	
			return dd.form({ className: 'form-horizontal', onSubmit: this._form_onSubmit }, makeFields([['name'], ['checkindate', 'checkoutdate'], ['confirmation'], ['phone', 'fax']]), _.isEmpty(event.Venue) ? null : dd.div({ className: "HorizontalFields" }, dd.div({ className: "form-group" }, dd.div({ className: "col-sm-12" }, CopyFromVenueDropDown({ venues: event.Venue, copyFromVenue: this.__copyFromVenue })))), makeFields([['address'], ['city', 'st'], ['zip', 'country']]), HorizontalFields.FormButtons({
				label_size: 2,
				scale: 'md',
				submit_btn_text: hotel && hotel.id > 0 ? 'Save' : 'Add',
				onCancel: onCancel,
				onDelete: hotel && hotel.id > 0 ? onDelete : null,
				right_align_buttons: true
			}));
		}
	});
	
	var CopyFromVenueDropDown = dd.createClass({
		mixins: [HoverMixin],
		getInitialState: function getInitialState() {
			return { show_dd: false };
		},
		__toggleDropDown: esUtils.wrapPreventDefault(function () {
			this.setState({ show_dd: !this.state.show_dd });
		}),
		hoverable_onUserLeftHoverable: function hoverable_onUserLeftHoverable() {
			if (this.state.show_dd) {
				//only setState if needed
				this.setState({ show_dd: false });
			}
		},
		__venueClick: function __venueClick(venue) {
			var self = this;
			return esUtils.wrapPreventDefault(function () {
				self.setState({ show_dd: !self.state.show_dd });
				self.props.copyFromVenue(venue);
			});
		},
		render: function render() {
			return dd.div({
				className: "pull-right dropdown" + (this.state.show_dd ? " open" : ""),
				onMouseEnter: this.hoverable_onMouseEnter,
				onMouseLeave: this.hoverable_onMouseLeave
			}, dd.a({ href: '#', className: 'dropdown-toggle', onClick: this.__toggleDropDown }, "copy address from venue ", dd.b({ className: 'caret' })), dd.ul({ className: 'dropdown-menu', role: 'menu' }, _.map(this.props.venues, function (venue) {
				return dd.li({ key: venue.id, role: 'presentation' }, dd.a({ role: 'menuitem', href: '#', onClick: this.__venueClick(venue) }, esUtils.venue_to_string(venue)));
			}, this)));
		}
	});

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	
	var FormatTime = function FormatTime(t) {
		var time = esUtils.format_date(t, "h:MM TT");
		return time === "12:00 AM" ? null : dd.span({ className: "time" }, time);
	};
	
	// Time + description on one line, with an optional muted confirmation # below.
	var TimeLine = function TimeLine(date, description, conf) {
		return dd.div(null, FormatTime(date), " " + description, conf ? dd.span({ className: "text-muted" }, " (" + conf + ")") : null);
	};
	
	// legcarrier is picked from a dropdown formatted "Delta Air Lines - DL", so the
	// code is whatever trails the hyphen. The odd row carries no code at all
	// ("Allegiant Air", "Other") and the AwardWallet import stores a bare "DL";
	// both fall out of the same split, since pop() hands back the whole string
	// when there is no hyphen in it.
	var FlightNumber = function FlightNumber(carrier, flightnum) {
		var code = _.trim(_.trim(carrier || "").split("-").pop());
		return _.compact([code, _.trim(flightnum || "")]).join(" ") || null;
	};
	
	//These types keys correspond to the event object's
	var itinerary_types = {
		Flight: {
			icon: "fa-plane",
			name: "Flight",
			form: __webpack_require__(327),
			toItinerary: function toItinerary(flight) {
				// The flight description belongs to the whole flight, not each leg, so it
				// rides along as a separate header that DayItinerary shows only once for
				// back-to-back legs of the same flight.
				var header = flight.description ? dd.div(null, dd.span({ style: { fontWeight: "bold" } }, flight.description), flight.agent ? dd.span({ className: "text-muted" }, " (" + flight.agent + ")") : null) : null;
	
				// One itinerary entry per leg, each filed under its own departure
				// (legleave) day, so multi-day flights don't collapse onto a single date.
				return _.map(flight.legs, function (leg) {
					var flightnum = FlightNumber(leg.legcarrier, leg.legflightnum);
	
					return {
						date: leg.legleave,
						header: header,
						group: flight,
						custom: dd.div(null, FormatTime(leg.legleave), dd.span({}, " depart "), leg.legfrom, flightnum ? dd.span({}, " on " + flightnum) : null, dd.br(), FormatTime(leg.legarrive), dd.span({}, " arrive "), leg.legto)
					};
				});
			}
		},
		Hotel: {
			icon: "fa-building",
			name: "Hotel",
			form: __webpack_require__(329),
			toItinerary: function toItinerary(hotel) {
				return [{ date: hotel.checkindate, custom: TimeLine(hotel.checkindate, "Check-in " + hotel.name, hotel.confirmation) }, { date: hotel.checkoutdate, custom: TimeLine(hotel.checkoutdate, "Check-out " + hotel.name, hotel.confirmation) }];
			}
		},
		Ground: {
			icon: "fa-car",
			name: "Ground",
			form: __webpack_require__(328),
			toItinerary: function toItinerary(ground) {
				return { date: ground.starttime, custom: TimeLine(ground.starttime, ground.description, ground.confirmation) };
			}
		}
	};
	
	var eventToDayItinerary = function eventToDayItinerary(event) {
		return _.map(_.groupBy(_.sortBy(_.filter(_.flattenDeep(_.map(itinerary_types, function (itinerary_attributes, type) {
			return _.map(event[type], function (obj) {
				var conv = itinerary_attributes.toItinerary(obj);
				return _.map(_.flattenDeep([conv]), function (item) {
					item.id = obj.id;
					item.type = type;
					return item;
				});
			});
		})), function (item) {
			return -631126800 == item.date || -631134000 == item.date || _.isDate(item.date);
		}), "date"), function (item) {
			return esUtils.format_date(item.date, "yyyy-mm-dd"); //group by day
		}), function (legs) {
			return {
				head: -631126800 == legs[0].date || -631134000 == legs[0].date ? 'no date set' : esUtils.format_date(legs[0].date, "dddd, mmmm d, yyyy"),
				legs: _.sortBy(legs, "date")
			};
		});
	};
	
	var DayItinerary = dd.createClass({
		render: function render() {
			var _props = this.props,
			    itinerary = _props.itinerary,
			    showForm = _props.showForm,
			    read_only = _props.read_only;
	
	
			return dd.div({ className: "DayItinerary" }, dd.div({ className: "travel-head" }, itinerary.head), _.map(itinerary.legs, function (leg, i) {
				// Only the first of a run of same-flight legs shows the flight header.
				var prev = itinerary.legs[i - 1];
				var show_header = leg.header && !(prev && leg.group && prev.group === leg.group);
	
				return dd.div({
					key: i,
					className: "travel-leg" + (read_only ? "" : " clickable"),
					onClick: read_only ? null : showForm(leg.type, leg.id)
				}, dd.i({ className: "fa fa-lg " + itinerary_types[leg.type].icon }), dd.div({ className: "description" }, show_header ? leg.header : null, leg.custom ? leg.custom : dd.span(null, FormatTime(leg.date), " " + leg.description)), dd.div({ className: "clearfix" }));
			}));
		}
	});
	
	module.exports = dd.createClass({
		getInitialState: function getInitialState() {
			return { show_form: { type: null, id: -1 } };
		},
		__showForm: function __showForm(type, id) {
			return _.bind(esUtils.wrapPreventDefault(function () {
				this.setState({ show_form: { type: type, id: id } });
			}), this);
		},
		render: function render() {
			var _props2 = this.props,
			    event = _props2.event,
			    Displaylists = _props2.Displaylists,
			    read_only = _props2.read_only;
			var show_form = this.state.show_form;
	
			var closeModal = this.__showForm(null, -1);
	
			return dd.div(null, dd.div({ className: "panel panel-default" }, dd.div({ className: "panel-body" }, _.map(eventToDayItinerary(event), function (itinerary, i) {
				return DayItinerary({ key: i, itinerary: itinerary, showForm: this.__showForm, read_only: read_only });
			}, this), read_only ? null : dd.div({ style: { marginTop: 30, textAlign: "center" } }, dd.span({ className: "btn-group" }, _.map(itinerary_types, function (data, type) {
				return dd.button({ key: type, className: "btn btn-default btn-sm", onClick: this.__showForm(type, 0) }, dd.i({ className: "fa " + data.icon }), " Add " + data.name);
			}, this))))), _.has(itinerary_types, show_form.type) ? Modal({
				title: (show_form.id > 0 ? "Edit" : "Add") + " " + itinerary_types[show_form.type].name,
				onClose: closeModal,
				buttons: []
			}, itinerary_types[show_form.type].form({
				event: event,
				Displaylists: Displaylists,
				onCancel: closeModal,
				data: _.find(event && event[show_form.type], function (obj) {
					return obj.id == show_form.id;
				}) || null
			})) : null);
		}
	});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var createStandardEventForm = __webpack_require__(30);
	
	module.exports = createStandardEventForm({
		eventToInitialValues: function eventToInitialValues(event) {
			return {
				nearestAirport: event.nearestAirport,
				travelAgent: event.travelAgent,
				travelNotes: event.travelNotes
			};
		},
		buildSchema: function buildSchema() {
			return {
				nearestAirport: {
					label: "Nearest Airport",
					type: "text"
				},
				travelAgent: {
					label: "Travel Agent",
					type: "text"
				},
				travelNotes: {
					label: "Travel Notes",
					type: "textarea"
				}
			};
		},
		writeInputDataToEvent: function writeInputDataToEvent(data, event) {
			event.nearestAirport = data.nearestAirport;
			event.travelAgent = data.travelAgent;
			event.travelNotes = data.travelNotes;
		}
	});

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var React = __webpack_require__(15);
	// let Tripit = require("./Tripit");
	var AwardWallet = __webpack_require__(326);
	var ProOnly = __webpack_require__(34);
	var esUtils = __webpack_require__(2);
	var Itinerary = __webpack_require__(330);
	var TravelNotes = __webpack_require__(331);
	var AuthedUserSession = __webpack_require__(4);
	var isEventAccountingLockedForMe = __webpack_require__(55);
	
	module.exports = dd.createClass({
	    __print: esUtils.wrapPreventDefault(function () {
	        var event = this.props.event;
	
	        window.open("/reports/loader.php?" + esUtils.phpCompatibleParams({
	            report: "eventtravel.php",
	            eid: event.eid,
	            inc_air: "",
	            inc_ground: "",
	            inc_hotel: "",
	            inc_travelnotes: "",
	            output_format: "html"
	        }), "esReportWindow", "height=600,width=1024").focus();
	    }),
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists;
	
	
	        var read_only = AuthedUserSession.doIHaveAccess.read.any(event.sids) || isEventAccountingLockedForMe(event);
	
	        return dd.div({ className: "Travel" }, ProOnly({
	            sids: event.sids,
	            custom_message: "Attach air, ground and hotel plans right to the event so everyone is in sync. Import plans from TripIt or type in, then ease worried clients with the \"Event Travel\" report."
	        }, read_only ? null : dd.div({ className: "pull-right" }, AwardWallet({ event: event, Displaylists: Displaylists })),
	        // /* TripIt has deprecated their API, so we do not use it anymore - mh June 2024 */
	        // read_only ? null : dd.div({className: "pull-right"},
	        //         Tripit({event, Displaylists})
	        //     ),
	        dd.h2(null, "Travel"), dd.div({ className: "clearfix" }), event.is_mp_event ? React.createElement(
	            "div",
	            null,
	            React.createElement(
	                "p",
	                { className: "instruction" },
	                "Travel plans are shared automatically with the client through eSpeakers Marketplace."
	            )
	        ) : null, dd.h4({ className: "section-head" }, "Itinerary", dd.a({ href: "#", className: "pull-right printlink", onClick: this.__print }, dd.i({ className: "fa fa-print" }), " print")), Itinerary({ event: event, Displaylists: Displaylists, read_only: read_only }), TravelNotes({ event: event, Displaylists: Displaylists, read_only: read_only, form_section_name: "Notes" })));
	    }
	});

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modals = __webpack_require__(356);
	var EventArea = __webpack_require__(262);
	var FullLayout = __webpack_require__(84);
	var CalendarArea = __webpack_require__(257);
	var StandardLayout = __webpack_require__(67);
	var YourBrowserWindowIsTooSmall = __webpack_require__(245);
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        url_args = _props.url_args,
	        Displaylists = _props.Displaylists;
	
	
	    return StandardLayout({ Displaylists: Displaylists }, FullLayout({ horizontal: true }, [{
	      body: CalendarArea({ Displaylists: Displaylists })
	    }, {
	      width: 600,
	      body: EventArea({ Displaylists: Displaylists, url_args: url_args })
	    }]), Modals({ Displaylists: Displaylists, url_args: url_args }), YourBrowserWindowIsTooSmall());
	  }
	});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getOfferStatusForJob = __webpack_require__(95);
	
	var _getOfferStatusForJob2 = _interopRequireDefault(_getOfferStatusForJob);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(397);
	
	exports.default = _react2.default.createClass({
	    displayName: "MPJobProgressBar",
	
	    render: function render() {
	        var sid = this.props.sid;
	        var event = this.props.event;
	        var startataccepted = _lodash2.default.get(this.props, "startataccepted", false);
	
	        var offer_status = _getOfferStatusForJob2.default.statusForEvent(event, sid, false); //[null, "unread message", "waiting client", "waiting you", "offer accepted", "deposit paid", "paid in full", "event completed", "reviewed"]; //order of priority is important; the names are magic (if you change them you'll need to search & replace)
	
	        return _react2.default.createElement(
	            "div",
	            { className: "MPJobProgressBar no-select" },
	            _react2.default.createElement(
	                "ul",
	                null,
	                !startataccepted && _react2.default.createElement(
	                    "li",
	                    { className: "active" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "title" },
	                        "Shortlisted"
	                    ),
	                    _react2.default.createElement("span", { className: "circle" })
	                ),
	                !startataccepted && _react2.default.createElement(
	                    "li",
	                    { className: _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "waiting client") ? "active" : "" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "title" },
	                        "Offer Pending"
	                    ),
	                    _react2.default.createElement("span", { className: "circle" })
	                ),
	                _react2.default.createElement(
	                    "li",
	                    { className: _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "offer accepted") ? "active" : "" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "title" },
	                        "Offer Accepted"
	                    ),
	                    _react2.default.createElement("span", { className: "circle" })
	                ),
	                _react2.default.createElement(
	                    "li",
	                    { className: _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "deposit paid") ? "active" : "" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "title" },
	                        "Deposit Paid"
	                    ),
	                    _react2.default.createElement("span", { className: "circle" })
	                ),
	                _react2.default.createElement(
	                    "li",
	                    { className: _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "paid in full") ? "active" : "" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "title" },
	                        "Balance Paid"
	                    ),
	                    _react2.default.createElement("span", { className: "circle" })
	                )
	            )
	        );
	    }
	});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(29);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(51);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _simpleTimeago = __webpack_require__(176);
	
	var _simpleTimeago2 = _interopRequireDefault(_simpleTimeago);
	
	var _MessageWithRedactedContact = __webpack_require__(347);
	
	var _MessageWithRedactedContact2 = _interopRequireDefault(_MessageWithRedactedContact);
	
	__webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: "Message",
	
	  getInitialState: function getInitialState() {
	    return {
	      show_redacted_contact_modal: false
	    };
	  },
	  __toggleRedactedContactModal: function __toggleRedactedContactModal() {
	    this.setState({
	      show_redacted_contact_modal: !this.state.show_redacted_contact_modal
	    });
	  },
	
	  handleClick: function handleClick() {
	    var _props = this.props,
	        onMarkAsRead = _props.onMarkAsRead,
	        id = _props.id;
	    //console.log("Message.js", "handleClick", id, !_.isEmpty(id), _.isFunction(onMarkAsRead));
	
	    if (_lodash2.default.isFunction(onMarkAsRead)) {
	      return onMarkAsRead([id]);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props,
	        sender_name = _props2.sender_name,
	        is_you = _props2.is_you,
	        is_unread = _props2.is_unread,
	        timestamp = _props2.timestamp,
	        content = _props2.content,
	        _props2$blur_message = _props2.blur_message,
	        blur_message = _props2$blur_message === undefined ? false : _props2$blur_message,
	        _props2$justified = _props2.justified,
	        justified = _props2$justified === undefined ? true : _props2$justified,
	        is_marketplace_message = _props2.is_marketplace_message,
	        _props2$contact_info_ = _props2.contact_info_found,
	        contact_info_found = _props2$contact_info_ === undefined ? false : _props2$contact_info_,
	        onMarkAsRead = _props2.onMarkAsRead;
	
	    //console.log("Message.js", _.isFunction(onMarkAsRead));
	
	    var received_date = (0, _simpleTimeago2.default)(timestamp);
	    // let received_date = moment(timestamp).calendar(null, {
	    //     sameDay: '[Today at] h:mm a',
	    //     nextDay: '[Tomorrow]',
	    //     nextWeek: 'dddd',
	    //     lastDay: '[Yesterday at] h:mm a',
	    //     lastWeek: '[Last] dddd [at] h:mm a',
	    //     sameElse: 'MMM D, YYYY [at] h:mm a'
	    // });
	    if (is_marketplace_message) {
	      return _react2.default.createElement(
	        "div",
	        { className: "row MP-Message" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-8 col-xs-offset-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "strike" },
	            _react2.default.createElement(
	              "div",
	              { className: "mp" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: content } })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "footer" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  received_date
	                ),
	                is_unread && _react2.default.createElement(
	                  "div",
	                  null,
	                  _lodash2.default.isFunction(onMarkAsRead) ? _react2.default.createElement(
	                    "a",
	                    { style: { marginRight: "0.5rem", cursor: "pointer" }, onClick: this.handleClick },
	                    "mark read"
	                  ) : null,
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "label label-danger", style: { marginLeft: "1em" } },
	                    "NEW"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "row MP-Message" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-xs-12 " + (justified ? "col-sm-11 " + (is_you ? "col-sm-offset-1" : "") : "") },
	        _react2.default.createElement(
	          "div",
	          { className: "panel panel-default " + (is_you ? "spkr" : "me") },
	          _react2.default.createElement(
	            "div",
	            { className: "panel-body" },
	            _react2.default.createElement(
	              "div",
	              { style: { whiteSpace: "pre-wrap" }, className: "text-left" },
	              blur_message ? _react2.default.createElement("span", { style: { filter: "blur(4px)" }, dangerouslySetInnerHTML: { __html: content.replace(/[A-Za-z0-9]/g, "#") } }) : _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: content } })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "panel-footer" },
	            is_you ? _react2.default.createElement(
	              "i",
	              null,
	              "Sent by you",
	              " ",
	              received_date
	            ) : _react2.default.createElement(
	              "i",
	              null,
	              "Sent from",
	              " ",
	              sender_name,
	              " ",
	              received_date
	            ),
	            is_unread && _react2.default.createElement(
	              "div",
	              null,
	              _lodash2.default.isFunction(onMarkAsRead) ? _react2.default.createElement(
	                "a",
	                { style: { marginRight: "0.5rem", cursor: "pointer" }, onClick: this.handleClick },
	                "mark read"
	              ) : null,
	              " ",
	              _react2.default.createElement(
	                "span",
	                { className: "label label-danger", style: { marginLeft: "1em" } },
	                "NEW"
	              )
	            )
	          ),
	          contact_info_found && _react2.default.createElement(
	            "div",
	            { className: "panel-footer text-warning" },
	            "Contact information was detected in this message before it was sent."
	          )
	        )
	      ),
	      this.state.show_redacted_contact_modal && (0, _MessageWithRedactedContact2.default)({ onClose: this.__toggleRedactedContactModal })
	    );
	  }
	});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(51);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(29);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Message = __webpack_require__(335);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	__webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: "Messages",
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  render: function render() {
	    var _props = this.props,
	        _props$order = _props.order,
	        order = _props$order === undefined ? "asc" : _props$order,
	        messages = _props.messages,
	        onMarkAsRead = _props.onMarkAsRead,
	        blurMessages = _props.blurMessages;
	
	
	    messages = _lodash2.default.sortBy(messages, "created");
	    if (order === "desc") {
	      messages = messages.reverse();
	    }
	
	    messages = _lodash2.default.map(messages, function (msg, i) {
	      var name = null;
	      if (msg.sender_buyer_id > 0 && !_lodash2.default.includes(_lodash2.default.get(msg, ["flags_as_array"], []), "system_log")) {
	        name = _lodash2.default.get(msg, ["sender_buyer_name"]);
	      }
	      var is_marketplace_message = _lodash2.default.includes(_lodash2.default.get(msg, ["flags_as_array"], []), "system_log");
	      var is_you = !name && !is_marketplace_message;
	      var is_unread = !is_you && !msg.receiver_opened;
	
	      return _react2.default.createElement(_Message2.default, {
	        key: _lodash2.default.get(msg, ["id"], i),
	        id: _lodash2.default.get(msg, ["id"]),
	        blur_message: blurMessages,
	        sender_name: name,
	        is_you: is_you,
	        is_unread: is_unread,
	        timestamp: _lodash2.default.get(msg, ["created"]),
	        content: _lodash2.default.get(msg, ["content"]),
	        contact_info_found: _lodash2.default.get(msg, ["flags_as_map", "contact_info_found", "is_set"]),
	        is_marketplace_message: is_marketplace_message,
	        onMarkAsRead: onMarkAsRead
	      });
	    });
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "MP-Messages" },
	        _react2.default.createElement(
	          "div",
	          { style: {
	              position: "relative" /*fixes scroll hints*/
	            } },
	          messages
	        )
	      )
	    );
	  }
	});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	var _ErrorAlert = __webpack_require__(6);
	
	var _ErrorAlert2 = _interopRequireDefault(_ErrorAlert);
	
	var _ModalDialog = __webpack_require__(130);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _RadioServiceMixin = __webpack_require__(14);
	
	var _RadioServiceMixin2 = _interopRequireDefault(_RadioServiceMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBtn = function ActionBtn(props) {
	    var className = "btn btn-success";
	    var is_waiting = props.is_waiting,
	        onClick = props.onClick;
	
	
	    if (is_waiting) {
	        className += " disabled";
	    }
	
	    return _react2.default.createElement(
	        "button",
	        { className: className, onClick: onClick },
	        props.children,
	        is_waiting ? _react2.default.createElement("i", { className: "fa fa-spinner fa-spin", style: { marginLeft: "1em" } }) : null
	    );
	};
	
	exports.default = _react2.default.createClass({
	    displayName: "DisconnectStripeModal",
	
	    mixins: [_RadioServiceMixin2.default],
	    RadioService_setup: function RadioService_setup() {
	        return {
	            Marketplace_disconnectStripeAccount: {
	                key: function key() {
	                    var sid = this.props.sid;
	
	                    return sid;
	                },
	
	                on: {
	                    succeeded: function succeeded() {
	                        var _props = this.props,
	                            onClose = _props.onClose,
	                            reloadData = _props.reloadData;
	
	                        reloadData();
	                        onClose();
	                    }
	                }
	            }
	        };
	    },
	
	    __doIt: _esUtils2.default.wrapPreventDefault(function () {
	        var sid = this.props.sid;
	
	        this.RadioService_callService("Marketplace_disconnectStripeAccount", {
	            speaker_id: sid
	        });
	    }),
	    render: function render() {
	        var onClose = this.props.onClose;
	
	        var ajax = this.state.Marketplace_disconnectStripeAccount;
	
	        return _react2.default.createElement(
	            _ModalDialog2.default,
	            {
	                title: "Disconnect Stripe Account",
	                buttons: [],
	                onClose: ajax.waiting ? null : onClose
	            },
	            _react2.default.createElement(_ErrorAlert2.default, { message: ajax.error }),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Your Stripe account is the way that client's payments end up in your bank account."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "If you disconnect from your Stripe account, you will:"
	            ),
	            _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "not be able to make an offer to a client"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "not be able to accept a client's offer"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "not be able to receive payments for jobs already accepted"
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                { style: { marginBottom: '2em' } },
	                "...until you reconnect to a Stripe account."
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "modal-footer" },
	                _react2.default.createElement(
	                    ActionBtn,
	                    { onClick: this.__doIt, is_waiting: ajax.waiting },
	                    "Disconnect Stripe Account"
	                ),
	                !ajax.waiting && _react2.default.createElement(
	                    "button",
	                    { className: "btn btn-default", onClick: onClose },
	                    "Never Mind"
	                )
	            )
	        );
	    }
	});

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Ledger = __webpack_require__(127);
	
	var _Ledger2 = _interopRequireDefault(_Ledger);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	var _ModalWrap = __webpack_require__(92);
	
	var _ModalWrap2 = _interopRequireDefault(_ModalWrap);
	
	var _ModalDialog = __webpack_require__(130);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _getLedgerData2 = __webpack_require__(128);
	
	var _getLedgerData3 = _interopRequireDefault(_getLedgerData2);
	
	var _getOfferStatusForJob = __webpack_require__(95);
	
	var _getOfferStatusForJob2 = _interopRequireDefault(_getOfferStatusForJob);
	
	var _getBuyerNameCompany = __webpack_require__(385);
	
	var _getBuyerNameCompany2 = _interopRequireDefault(_getBuyerNameCompany);
	
	var _getBuyerFirstName = __webpack_require__(132);
	
	var _getBuyerFirstName2 = _interopRequireDefault(_getBuyerFirstName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthedUserSession = __webpack_require__(4);
	var DateRange = __webpack_require__(65);
	
	__webpack_require__(400);
	
	exports.default = _react2.default.createClass({
	    displayName: "ViewAgreement",
	
	    getInitialState: function getInitialState() {
	        return {
	            show_ledger: false
	        };
	    },
	    __toggleLedger: _esUtils2.default.wrapPreventDefault(function () {
	        this.setState({
	            show_ledger: !this.state.show_ledger
	        });
	    }),
	    render: function render() {
	        var _props = this.props,
	            event = _props.event,
	            Displaylists = _props.Displaylists,
	            mp_agreement = _props.mp_agreement;
	        var show_ledger = this.state.show_ledger;
	
	        var modal = void 0;
	        var sid = _lodash2.default.first(event.sids);
	        var event_time = null;
	        var event_venue = null;
	        var display_payments = _lodash2.default.get(this.props, "display_payments", false);
	
	        if (event.starttime || event.stoptime) {
	            event_time = DateRange({ start: event.starttime, start_format: "dddd, mmmm d, yyyy", stop: event.stoptime });
	        } else {
	            event_time = _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: "DateRange fa fa-calendar" },
	                    " (no stagetimes)"
	                )
	            );
	        }
	
	        var venue = _lodash2.default.first(event.Venue);
	
	        if (event.deliveryMethod === 1 && !_lodash2.default.isEmpty(venue)) {
	            event_venue = _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("i", { className: "fa fa-map-marker text-muted" }),
	                " ",
	                _esUtils2.default.venue_to_string(venue)
	            );
	        } else {
	            event_venue = _react2.default.createElement(
	                "div",
	                null,
	                _lodash2.default.map(_lodash2.default.filter(Displaylists && Displaylists.universal && Displaylists.universal.deliverymethods, function (dm) {
	                    return dm.id == event.deliveryMethod;
	                }), "description").join(", ")
	            );
	        }
	
	        if (show_ledger) {
	            modal = _react2.default.createElement(
	                _ModalDialog2.default,
	                {
	                    title: "Payout to you",
	                    onClose: this.__toggleLedger
	                },
	                _react2.default.createElement(_Ledger2.default, {
	                    event: event,
	                    Displaylists: Displaylists,
	                    mp_agreement: mp_agreement,
	                    display_payments: display_payments
	                })
	            );
	        }
	
	        var _getLedgerData = (0, _getLedgerData3.default)({
	            event: event,
	            Displaylists: Displaylists,
	            mp_agreement: mp_agreement
	        }),
	            grand_total = _getLedgerData.grand_total,
	            fee_speaking = _getLedgerData.fee_speaking;
	
	        var offer_status = _getOfferStatusForJob2.default.statusForEvent(event, sid, false);
	        var section_title = _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "offer accepted") ? "Contract" : "Offer";
	        var buyer_name = _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "offer accepted") ? (0, _getBuyerNameCompany2.default)(event) : (0, _getBuyerFirstName2.default)(event);
	        var contract_link_text = mp_agreement.is_contract_custom ? "Custom uploaded agreement (PDF) " : "Standard engagement agreement ";
	        var showprintlink = false && _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, offer_status) >= _lodash2.default.indexOf(_getOfferStatusForJob.OFFER_STATII, "offer accepted"); //disabled until complete
	
	        return _react2.default.createElement(
	            "div",
	            { className: "agreement" },
	            _react2.default.createElement(
	                "h2",
	                null,
	                section_title
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Client"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    buyer_name
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Event"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    event.organization
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Date"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    event_time
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Location"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    event_venue
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row", style: { marginTop: "3em" } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Contracted Speaking Fee"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    "USD $",
	                    _esUtils2.default.format_number(fee_speaking, 2)
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Payout To You"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    "USD $",
	                    _esUtils2.default.format_number(grand_total, 2),
	                    " ",
	                    _react2.default.createElement(
	                        "a",
	                        { href: "#", onClick: this.__toggleLedger },
	                        "view details"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Terms"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value preserve-whitespace" },
	                    mp_agreement.terms
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-4 text-right lbl" },
	                    "Agreement Document"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 value" },
	                    contract_link_text,
	                    _react2.default.createElement(
	                        "a",
	                        { href: mp_agreement.contract_url, target: "_blank" },
	                        "view",
	                        " ",
	                        _react2.default.createElement("i", { className: "fa fa-external-link" })
	                    )
	                )
	            ),
	            showprintlink && _react2.default.createElement(
	                "div",
	                { className: "row", style: { marginTop: "3em" } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-sm-8 col-sm-offset-4" },
	                    _react2.default.createElement(
	                        "a",
	                        { href: "/marketplace/event/printinvoice/" + event.eid + "?speaker_id=" + event.eid + "&token=" + AuthedUserSession.MY_USERNAME, target: "_blank" },
	                        "print contract ",
	                        _react2.default.createElement("i", { className: "fa fa-external-link" })
	                    )
	                )
	            ),
	            modal && _react2.default.createElement(_ModalWrap2.default, { body: modal })
	        );
	    }
	});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLooseForms = __webpack_require__(19);
	
	var _reactLooseForms2 = _interopRequireDefault(_reactLooseForms);
	
	var _ErrorAlert = __webpack_require__(6);
	
	var _ErrorAlert2 = _interopRequireDefault(_ErrorAlert);
	
	var _ModalForm = __webpack_require__(363);
	
	var _ModalForm2 = _interopRequireDefault(_ModalForm);
	
	var _SubmitButton = __webpack_require__(364);
	
	var _SubmitButton2 = _interopRequireDefault(_SubmitButton);
	
	var _ezVerticalFields = __webpack_require__(73);
	
	var _ezVerticalFields2 = _interopRequireDefault(_ezVerticalFields);
	
	var _RadioServiceMixin = __webpack_require__(14);
	
	var _RadioServiceMixin2 = _interopRequireDefault(_RadioServiceMixin);
	
	var _AuthedUserSession = __webpack_require__(4);
	
	var _AuthedUserSession2 = _interopRequireDefault(_AuthedUserSession);
	
	var _FormUtils = __webpack_require__(9);
	
	var _FormUtils2 = _interopRequireDefault(_FormUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import radio from "ES/lib/react-pubsub-via-radio.js/radio";
	// import esUtils from "ES/utils/esUtils";
	__webpack_require__(401);
	// import FormUtils from "../../../utils/FormUtils";
	
	
	var DaForm = _react2.default.createClass({
	  displayName: "DaForm",
	
	  mixins: [_reactLooseForms2.default],
	  getInitialValues: function getInitialValues(props) {
	    return {};
	  },
	  buildSchema: function buildSchema() {
	    return {
	      initials: {
	        label: "Initial Here",
	        type: "text",
	        validate: _FormUtils2.default.v.required
	      }
	    };
	  },
	
	  render: function render() {
	    var _props = this.props,
	        is_sending = _props.is_sending,
	        commission = _props.commission,
	        CloseModal = _props.CloseModal;
	
	
	    return _react2.default.createElement(
	      "form",
	      { onSubmit: this.Form_onSubmit },
	      _react2.default.createElement(
	        "div",
	        { className: "modal-body" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "It looks like the message you\u2019re about to send includes a way for the buyer to respond to you outside of this message board (phone number, email address, etc.)."
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "text-muted" },
	          "As a reminder, the Marketplace Finder\u2019s Fee applies whether the buyer pays through the platform or pays you directly. ",
	          _react2.default.createElement(
	            "i",
	            null,
	            "Jobs paid through the platform can increase your search rank and move you higher in results."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row", style: { marginTop: "2em", marginBottom: "2em" } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-2" },
	            (0, _ezVerticalFields2.default)(this, [["initials"]])
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-sm-9" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "p",
	              null,
	              "I understand and accept the ",
	              _react2.default.createElement(
	                "span",
	                { className: "commission" },
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  commission > 0 ? commission + '%' : '',
	                  " finder\u2019s fee"
	                )
	              ),
	              " due for work resulting from this lead."
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "modal-footer" },
	        _react2.default.createElement(
	          _SubmitButton2.default,
	          { is_waiting: is_sending },
	          "Accept & Send Message"
	        ),
	        !is_sending && _react2.default.createElement(
	          "button",
	          { className: "btn btn-default", onClick: CloseModal },
	          "Change Message"
	        )
	      )
	    );
	  }
	});
	
	exports.default = _react2.default.createClass({
	  displayName: "ComplianceMessageModal",
	
	  mixins: [_RadioServiceMixin2.default],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      Marketplace_acceptCompliance: {
	        key: function key() {
	          var _props2 = this.props,
	              eid = _props2.eid,
	              sid = _props2.sid;
	
	          return eid + "|" + sid;
	        },
	
	        on: {
	          succeeded: function succeeded() {
	            var _props3 = this.props,
	                eid = _props3.eid,
	                sid = _props3.sid,
	                message = _props3.message;
	
	            if (_lodash2.default.isFunction(this.props.onAcceptCompliance)) {
	              this.props.onAcceptCompliance({
	                eid: eid,
	                sid: sid,
	                message: message,
	                skip_compliance: true
	              });
	            }
	            this.props.onClose();
	          }
	        }
	      }
	    };
	  },
	
	  __onSubmit: function __onSubmit(data) {
	    this.RadioService_callService("Marketplace_acceptCompliance", {
	      sid: this.props.sid,
	      event_id: this.props.eid,
	      finders_fee: this.props.commission,
	      user_agent: window.navigator.userAgent,
	      created: new Date(),
	      initials: data.initials,
	      login: _AuthedUserSession2.default.MY_USERNAME,
	      extra: data,
	      skip_log: true
	    });
	  },
	  render: function render() {
	    var _props4 = this.props,
	        sid = _props4.sid,
	        eid = _props4.eid,
	        commission = _props4.commission,
	        onClose = _props4.onClose;
	
	    var ajax = this.state.Marketplace_acceptCompliance;
	
	    return _react2.default.createElement(
	      _ModalForm2.default,
	      {
	        title: "Direct contact information",
	        buttons: [],
	        raw_body: true,
	        onClose: ajax.waiting ? null : onClose
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "Marketplace-ComplianceModal" },
	        _react2.default.createElement(_ErrorAlert2.default, { message: ajax.error }),
	        _react2.default.createElement(DaForm, {
	          sid: sid,
	          eid: eid,
	          commission: commission,
	          onSubmit: this.__onSubmit,
	          is_sending: ajax.waiting,
	          CloseModal: onClose
	        })
	      )
	    );
	  }
	});

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _esUtils = __webpack_require__(2);
	
	var _esUtils2 = _interopRequireDefault(_esUtils);
	
	var _reactLooseForms = __webpack_require__(19);
	
	var _reactLooseForms2 = _interopRequireDefault(_reactLooseForms);
	
	var _RadioServiceMixin = __webpack_require__(14);
	
	var _RadioServiceMixin2 = _interopRequireDefault(_RadioServiceMixin);
	
	var _ModalWrap = __webpack_require__(92);
	
	var _ModalWrap2 = _interopRequireDefault(_ModalWrap);
	
	var _ComplianceMessageModal = __webpack_require__(339);
	
	var _ComplianceMessageModal2 = _interopRequireDefault(_ComplianceMessageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SendButton = _react2.default.createClass({
	    displayName: "SendButton",
	    render: function render() {
	        var is_sending = this.props.is_sending;
	
	
	        var size = 30;
	        is_sending = !!is_sending;
	
	        var className = "btn btn-default btn-flat";
	
	        if (is_sending) {
	            className += " disabled";
	        }
	
	        return _react2.default.createElement(
	            "button",
	            { type: "submit", className: className, style: {
	                    position: "absolute",
	                    bottom: "10px",
	                    right: "10px",
	
	                    height: size + "px",
	                    width: size + "px",
	                    lineHeight: size + "px",
	                    borderRadius: size + "px",
	                    fontSize: "15px",
	                    padding: "0px"
	                } },
	            _react2.default.createElement("i", { className: "fa " + (is_sending ? "fa-spinner fa-spin" : "fa-send") }),
	            _react2.default.createElement(
	                "span",
	                { className: "sr-only" },
	                "Send"
	            )
	        );
	    }
	});
	
	var MessageSendForm = _react2.default.createClass({
	    displayName: "MessageSendForm",
	
	    mixins: [_reactLooseForms2.default],
	    getInitialValuesSourceVersion: function getInitialValuesSourceVersion(props) {
	        return props.version_key;
	    },
	    getInitialValues: function getInitialValues() {
	        return {
	            message: ""
	        };
	    },
	    buildSchema: function buildSchema() {
	        var is_sending = !!this.props.is_sending;
	        return {
	            message: {
	                type: "textarea",
	                placeholder: "Type message here...",
	                disabled: is_sending,
	                rows: 5,
	                validate: function validate(v) {
	                    return _esUtils2.default.isBlank(v) ? "Please enter a message" : true;
	                }
	            }
	        };
	    },
	    render: function render() {
	        var fields = this.Form_buildSchema();
	        var buildInput = this.Form_buildInput;
	        var error = _lodash2.default.get(this, ["state", "errors", "message"]);
	        var ajax_error = this.props.error;
	        var is_sending = !!this.props.is_sending;
	
	        return _react2.default.createElement(
	            "form",
	            {
	                className: "MP-MessageSendForm",
	                onSubmit: this.Form_onSubmit
	            },
	            _react2.default.createElement(
	                "div",
	                { className: "form-group" + (error ? " has-error" : "") },
	                _react2.default.createElement(
	                    "div",
	                    { style: { position: "relative" } },
	                    buildInput(fields.message),
	                    _react2.default.createElement(SendButton, { is_sending: is_sending })
	                ),
	                error ? _react2.default.createElement(
	                    "span",
	                    { className: "help-block" },
	                    error
	                ) : null,
	                ajax_error ? _react2.default.createElement(
	                    "span",
	                    { className: "text-danger" },
	                    "Failed to send: ",
	                    ajax_error
	                ) : null
	            )
	        );
	    }
	});
	
	exports.default = _react2.default.createClass({
	    displayName: "MessageForm",
	
	    state: {
	        show_compliance_confirmation_modal: false
	    },
	    mixins: [_RadioServiceMixin2.default],
	    RadioService_setup: function RadioService_setup() {
	        return {
	            Marketplace_sendMPMessages: {
	                key: function key() {
	                    var _props = this.props,
	                        eid = _props.eid,
	                        sid = _props.sid;
	
	                    return eid + "|" + sid;
	                },
	
	                on: {
	                    succeeded: function succeeded(message) {
	                        if (_lodash2.default.isFunction(this.props.onSentMessage)) {
	                            this.props.onSentMessage(message);
	                        }
	                    },
	                    failed: function failed(message) {
	                        // show a popup for compliance, include the initials, and resubmit the message form
	                        if (_lodash2.default.startsWith(message, "CONTACT")) {
	                            this.setState({
	                                show_compliance_confirmation_modal: true
	                            });
	                        }
	                    }
	                }
	            }
	        };
	    },
	
	    __toggleMessageComplianceModal: function __toggleMessageComplianceModal() {
	        this.setState({
	            show_compliance_confirmation_modal: !this.state.show_compliance_confirmation_modal
	        });
	    },
	    __onSubmit: function __onSubmit(data) {
	        this.setState({
	            message: data.message
	        });
	        this.RadioService_callService("Marketplace_sendMPMessages", {
	            sid: this.props.sid,
	            eid: this.props.eid,
	            message: data.message,
	            skip_compliance: false
	        });
	    },
	    __onSubmitWithCompliance: function __onSubmitWithCompliance(data) {
	        this.RadioService_callService("Marketplace_sendMPMessages", data);
	    },
	    render: function render() {
	        var _props2 = this.props,
	            sid = _props2.sid,
	            eid = _props2.eid,
	            thread = _props2.thread,
	            event = _props2.event;
	
	
	        var ajax = this.state.Marketplace_sendMPMessages;
	        var sent_messages = this.state.sent_messages || [];
	        var version_key = sid + "," + eid + "," + _lodash2.default.size(thread);
	        // calculate the commission (accounting for nulls and bad data)
	        var commission = 0;
	        if (!_lodash2.default.isNull(_lodash2.default.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"]))) {
	            commission += parseFloat(_lodash2.default.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"], "0.1"));
	        }
	        if (!_lodash2.default.isNull(_lodash2.default.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"]))) {
	            commission += parseFloat(_lodash2.default.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"], "0.0"));
	        }
	        commission *= 100;
	
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(MessageSendForm, {
	                    version_key: version_key,
	                    onSubmit: this.__onSubmit,
	                    is_sending: ajax.waiting,
	                    error: ajax.error ? ajax.error + "" : null
	                }),
	                _lodash2.default.size(sent_messages) > 0 && !ajax.waiting && !ajax.error ? _react2.default.createElement(
	                    "p",
	                    { className: "text-success", style: { textAlign: "right", marginRight: "2em" } },
	                    "Message sent."
	                ) : null
	            ),
	            this.state.show_compliance_confirmation_modal && _react2.default.createElement(_ModalWrap2.default, { body: _react2.default.createElement(_ComplianceMessageModal2.default, {
	                    onClose: this.__toggleMessageComplianceModal,
	                    onAcceptCompliance: this.__onSubmitWithCompliance,
	                    message: this.state.message,
	                    sid: sid,
	                    eid: eid,
	                    commission: commission
	                }) })
	        );
	    }
	});

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(51);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(29);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Messages = __webpack_require__(336);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _simpleTimeago = __webpack_require__(176);
	
	var _simpleTimeago2 = _interopRequireDefault(_simpleTimeago);
	
	var _MessageForm = __webpack_require__(340);
	
	var _MessageForm2 = _interopRequireDefault(_MessageForm);
	
	__webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createFactory(_react2.default.createClass({
	
	  getInitialState: function getInitialState() {
	    return {
	      show_reply: false,
	      show_compliance_modal: false,
	      sent_messages: []
	    };
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var prev = _lodash2.default.map(_lodash2.default.filter(prevProps.thread, function (item) {
	      return !_lodash2.default.get(item, ["receiver_opened"], false);
	    }), "id");
	    var next = _lodash2.default.map(_lodash2.default.filter(this.props.thread, function (item) {
	      return !_lodash2.default.get(item, ["receiver_opened"], false);
	    }), "id");
	    //console.log("MessagePreview.js", "componentDidUpdate", prev, next);
	    if (!_lodash2.default.isEqual(prev, next) && _lodash2.default.size(next)) {
	      _lodash2.default.delay(this.__onMarkAsRead, 1000);
	    }
	    // _.delay(this.__onMarkAsRead, 5000);
	  },
	
	  __onShowReply: function __onShowReply() {
	    this.setState({
	      show_reply: !this.state.show_reply
	    });
	  },
	
	  __onMarkAsRead: function __onMarkAsRead(unread_ids) {
	    //console.log("MessagePreview", "__onMarkAsRead", _.isFunction(this.props.onMarkAsRead), unread_ids);
	    if (_lodash2.default.isFunction(this.props.onMarkAsRead)) {
	      if (_lodash2.default.size(unread_ids) < 1) {
	        unread_ids = _lodash2.default.map(_lodash2.default.filter(this.props.thread, function (item) {
	          return !_lodash2.default.get(item, ["receiver_opened"], false);
	        }), "id");
	      }
	      if (_lodash2.default.size(unread_ids) > 0) {
	        return this.props.onMarkAsRead(unread_ids);
	      }
	    }
	  },
	
	  __onSentMessage: function __onSentMessage(message) {
	    if (_lodash2.default.isFunction(this.props.onSentMessage)) {
	      this.props.onSentMessage(message);
	    } else {
	      this.setState({
	        sent_messages: this.state.sent_messages.concat([message])
	      });
	    }
	  },
	
	  __onToggleComplianceModal: function __onToggleComplianceModal() {
	    if (_lodash2.default.isFunction(this.props.onShowComplianceModal)) {
	      return this.props.onShowComplianceModal();
	    }
	  },
	
	  render: function render() {
	    var _props = this.props,
	        event_name = _props.event_name,
	        buyer_name = _props.buyer_name,
	        eid = _props.eid,
	        sid = _props.sid,
	        thread = _props.thread,
	        has_compliance = _props.has_compliance,
	        _props$show_send_form = _props.show_send_form,
	        show_send_form = _props$show_send_form === undefined ? true : _props$show_send_form;
	
	
	    var received_date = void 0;
	    var message = _lodash2.default.head(_lodash2.default.sortBy(thread, "sender_buyer_id").reverse());
	    if (message) {
	      if (!event_name) {
	        event_name = _lodash2.default.get(message, ["organization"]);
	      }
	      if (!buyer_name) {
	        buyer_name = _lodash2.default.get(message, ["buyer_name"]);
	      }
	      received_date = (0, _simpleTimeago2.default)(_lodash2.default.get(message, ["created"]));
	    }
	
	    thread = thread.concat(this.state.sent_messages);
	
	    return _react2.default.createElement(
	      "div",
	      { className: "mp-message-preview" },
	      _react2.default.createElement(
	        "div",
	        { className: "panel panel-default" },
	        _react2.default.createElement(
	          "div",
	          { className: "panel-body" },
	          _react2.default.createElement(
	            "div",
	            { className: "pull-right" },
	            _react2.default.createElement("span", { className: "sender-thumbnail" })
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "sender-name" },
	              buyer_name
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "pull-right received-date" },
	              received_date
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            event_name
	          ),
	          !has_compliance && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "div",
	              { className: "alert alert-warning" },
	              _react2.default.createElement(
	                "div",
	                { className: "alert-content" },
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  "You have a message from the event organizer.  The directory managing this event requires you to accept their agreement before responding to the event organizer."
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "btn btn-warning", onClick: this.__onToggleComplianceModal },
	                  "Accept Agreement"
	                )
	              )
	            )
	          ),
	          show_send_form && has_compliance && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(_MessageForm2.default, { thread: thread, eid: eid, event: _lodash2.default.get(message, ["event"]), sid: sid, onSentMessage: this.__onSentMessage })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "message-preview" },
	        _react2.default.createElement(_Messages2.default, { messages: thread, onMarkAsRead: this.__onMarkAsRead, order: "desc", blurMessages: !has_compliance })
	      )
	    );
	  }
	}));

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var AuthedUserSession = __webpack_require__(4);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	//let FormMixin = require("react-loose-forms");
	//let FormUtils = require("../../utils/FormUtils");
	//let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
	
	// let NewForm = dd.createClass({
	//   mixins: [FormMixin],
	//   getInitialValuesSourceVersion(props) {
	//     return {
	//       company: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
	//     };
	//   },
	//   getInitialValues(props) {
	//     return {
	//       company: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
	//     };
	//   },
	//   buildSchema(props) {
	//     return {
	//       company: {
	//         label: "Company",
	//         type: "select",
	//         placeholder: "Select a company",
	//         validate: FormUtils.v.optional,
	//         options: _.object(_.map(_.filter(_.get(AuthedUserSession, ["companies"]), function (company) {
	//           // Only show parent companies
	//           return _.get(company, ["PARENT_ID"]) === 0;
	//         }), function (company) {
	//           return [
	//             _.get(company, ["COMPANY_ID"]),
	//             _.get(company, ["NAME"])
	//           ];
	//         }))
	//       }
	//     };
	//   },
	//   __clickCompany(company_id) {
	//     AuthedUserSession.setLastSelectedCompany(company_id);
	//     window.location.reload();
	//   },
	//   render() {
	//     let self = this;
	//     let fields = this.Form_buildSchema();
	//     let {onCancel} = this.props;
	//     let renderFieldLayout = function (layout) {
	//       return ezHorizontalFields(self, _.filter(layout, function (row) {
	//         return _.size(row) === 1 ? _.has(fields, row[0]) : true;
	//       }), "sm", 2);
	//     };
	//     return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
	//       renderFieldLayout([["company"]]),
	//       dd.div({className: "form-group text-center", style: {marginTop: 30}},
	//         dd.button({type: "submit", className: "btn btn-primary"}, "Change Company"),
	//         " ",
	//         dd.button({className: "btn btn-default", onClick: onCancel}, "Cancel")
	//       ));
	//   }
	// });
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      show: false,
	      companies: _.get(AuthedUserSession, ["companies"])
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      change_active_company: function change_active_company() {
	        this.setState({
	          show: !this.state.show
	        });
	      }
	    };
	  },
	
	  __close: esUtils.wrapPreventDefault(function () {
	    this.setState({ show: false });
	  }),
	  __onSubmit: function __onSubmit(company) {
	    return esUtils.wrapPreventDefault(function () {
	      AuthedUserSession.setLastSelectedCompany(_.get(company, ["COMPANY_ID"]));
	      window.location.reload();
	    });
	  },
	  __onClose: function __onClose() {
	    this.setState({
	      show: false
	    });
	  },
	  render: function render() {
	    var show = this.state.show;
	
	    if (!show) {
	      return dd.div();
	    }
	    var cnames = _.get(AuthedUserSession, ["companies"], []);
	    cnames = _.filter(cnames, function (company) {
	      return _.get(company, ["PARENT_ID"]) === 0;
	    });
	    var that = this;
	    return Modal({
	      title: "Change Active Company",
	      buttons: [{
	        name: "Never mind",
	        onClick: this.__onClose,
	        className: "btn btn-default"
	      }]
	    }, dd.div({}, dd.p({}, "You are currently on the ", dd.b({}, _.get(AuthedUserSession, ["activeCompany", "NAME"])), " company."), dd.div({ className: 'text-center' }, dd.p({ className: 'text-center btn btn-success disabled', style: { margin: "5px" } }, _.get(AuthedUserSession, ["activeCompany", "NAME"]))), dd.p({}, "Choose another company you want to work with:"), dd.div({ className: 'text-center' }, _.map(_.filter(cnames, function (c) {
	      return _.get(c, "COMPANY_ID") !== _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]);
	    }), function (company) {
	      var classnames = "btn btn-primary";
	      if (_.get(company, "COMPANY_ID") === _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])) {
	        classnames += " disabled";
	      }
	      return dd.p({ key: _.get(company, "COMPANY_ID"), style: { margin: "5px" }, className: classnames, onClick: that.__onSubmit(company) }, _.get(company, ["NAME"], "???"));
	    }))));
	  }
	});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var dateformat = __webpack_require__(41);
	var ErrorAlert = __webpack_require__(6);
	var RadioMixin = __webpack_require__(20);
	var LoadingWrap = __webpack_require__(8);
	var FormButtons = __webpack_require__(36);
	var ezHorizontalFields = __webpack_require__(25);
	
	var getCoworkersFromEvent = function getCoworkersFromEvent(event) {
	  var usernames = [];
	  _.forEach(_.get(event, "CoWorkers", []), function (a, speaker_id) {
	    usernames.push(a);
	  });
	  usernames = _.flattenDeep(usernames);
	  usernames = _.uniq(usernames, function (n) {
	    return _.get(n, "id", "").toUpperCase();
	  });
	  return usernames;
	};
	
	var DaForm = dd.createClass({
	  mixins: [FormMixin],
	  getInitialValuesSourceVersion: function getInitialValuesSourceVersion(_ref) {
	    var event = _ref.event;
	
	    return esUtils.getEventVersionIdentifier(event);
	  },
	  getInitialValues: function getInitialValues(_ref2) {
	    var event = _ref2.event;
	
	    if (event && event.eid > 0) {
	      var subject = "Event";
	      if (!esUtils.isBlank(event.organization)) {
	        subject += " for " + event.organization;
	      }
	      if (_.isDate(event.starttime)) {
	        subject += " on " + dateformat(event.starttime, "mmm d, yyyy");
	      }
	      return { subject: subject };
	    }
	    return {};
	  },
	  buildSchema: function buildSchema() {
	    var coworkers = this.props.coworkers;
	
	    var schema = {};
	    _.each(coworkers, function (name, id) {
	      schema["coworker_" + id] = {
	        label: name,
	        type: "checkbox"
	      };
	    });
	    schema.subject = {
	      label: "Subject",
	      type: "text"
	    };
	    schema.note = {
	      label: "Note",
	      type: "textarea"
	    };
	    schema.email = {
	      label: "Additional Email(s)",
	      type: "text",
	      help_text: 'Additional email addresses to send to (comma separated)'
	    };
	    return schema;
	  },
	  render: function render() {
	    var onCancel = this.props.onCancel;
	
	    var fields = this.Form_buildSchema();
	
	    var checkboxes = [];
	    _.each(fields, function (field) {
	      if (field.type == 'checkbox') {
	        checkboxes.push([field.name]);
	      }
	    });
	    var inputs = [['email'], ['subject'], ['note']];
	
	    return dd.form({ className: "form-horizontal", onSubmit: this.Form_onSubmit }, dd.div({ style: { marginBottom: '15px', maxHeight: '295px', overflowY: 'auto' } }, ezHorizontalFields(this, checkboxes)), ezHorizontalFields(this, inputs), dd.br(), FormButtons({ submit_btn_text: "Send", onCancel: onCancel, right_align: true }));
	  }
	});
	
	var DaModal = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { loading: false, error_msg: null };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      email_Event_to_coworkers: function email_Event_to_coworkers(event_id) {
	        if (event_id === this.props.event.eid) {
	          this.setState({ loading: true, error_msg: null });
	        }
	      },
	      email_Event_to_coworkers_succeeded: function email_Event_to_coworkers_succeeded(event_id) {
	        if (event_id === this.props.event.eid) {
	          this.props.onClose();
	        }
	      },
	      email_Event_to_coworkers_failed: function email_Event_to_coworkers_failed(event_id, message) {
	        if (event_id === this.props.event.eid) {
	          this.setState({ loading: false, error_msg: "Failed to send email: " + message });
	        }
	      }
	    };
	  },
	  __onSubmit: function __onSubmit(data) {
	    var users = _.map(_.filter(_.pairs(data), function (pair) {
	      return (/^coworker_/.test(pair[0]) && pair[1] === true
	      );
	    }), function (pair) {
	      return pair[0].replace(/^coworker_/, "");
	    });
	    if (users.length === 0) {
	      this.setState({ error_msg: "You must select at least one co-worker to email this to." });
	      return;
	    }
	    radio("email_Event_to_coworkers").broadcast(this.props.event.eid, users, data.subject, data.note, data.email);
	  },
	  render: function render() {
	    var _props = this.props,
	        event = _props.event,
	        onClose = _props.onClose;
	
	    var coworkers = getCoworkersFromEvent(event);
	    coworkers = _.map(coworkers, function (coworker) {
	      return [_.get(coworker, "id"), _.get(coworker, "name", _.get(coworker, "id"))]; //.name isn't included where the list is long, so just re-use the login id
	    });
	    coworkers = _.sortBy(coworkers, function (n) {
	      return _.get(n, [1]);
	    });
	    coworkers = _.object(coworkers);
	
	    if (this.state.loading) {
	      return Modal({ title: "Sending...", buttons: [] }, LoadingWrap({ text: "Sending...", is_loading: true }));
	    }
	    return Modal({
	      title: "Email to Co-workers",
	      buttons: [],
	      onClose: onClose
	    }, ErrorAlert({ message: this.state.error_msg }), DaForm({
	      event: event,
	      coworkers: coworkers,
	      onSubmit: this.__onSubmit,
	      onCancel: onClose
	    }));
	  }
	});
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { event_to_email: null, showing_prompt_to_use_email: false };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      event_schedule_change: function event_schedule_change(event) {
	        var Displaylists = this.props.Displaylists;
	
	        var preferences = _.get(Displaylists, "user.myevents_preferences", {});
	
	        if (_.size(getCoworkersFromEvent(event)) <= 1) {
	          return; //don't notify if there is only one user for this event
	        }
	        if (_.get(preferences, "notify_coworkers_on_schedule_changes")) {
	          this.setState({ event_to_email: event, showing_prompt_to_use_email: true });
	        }
	      },
	      send_event_to_coworkers: function send_event_to_coworkers(event) {
	        var self = this;
	        setTimeout(function () {
	          self.setState({ event_to_email: event });
	        }, 10);
	      }
	    };
	  },
	
	  __close: esUtils.wrapPreventDefault(function () {
	    this.setState({ event_to_email: null });
	  }),
	  __togglePromptWindow: esUtils.wrapPreventDefault(function () {
	    this.setState({ showing_prompt_to_use_email: !this.state.showing_prompt_to_use_email });
	  }),
	  render: function render() {
	    var event = this.state.event_to_email;
	    var Displaylists = this.props.Displaylists;
	
	    if (_.isEmpty(event) || _.isEmpty(Displaylists)) {
	      return dd.div();
	    }
	    if (this.state.showing_prompt_to_use_email) {
	      return Modal({
	        title: "Notify co-workers?",
	        buttons: [],
	        onClose: this.__close
	      }, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({ className: "fa fa-users", style: { fontSize: 60 } })), dd.div({ className: "col-sm-9" }, dd.p(null, "Would you like to notify your co-workers of your schedule change to the event?"))), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: this.__togglePromptWindow }, "Yes, notify"), " ", dd.button({ className: "btn btn-default", onClick: this.__close }, "No thanks")));
	    }
	    return DaModal({ event: event, Displaylists: Displaylists, onClose: this.__close });
	  }
	});

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return {
				event_to_save: null
			};
		},
		Radio_setup: function Radio_setup() {
			return {
				EvaluationScore_show_modal: function EvaluationScore_show_modal(event, old_event) {
					var new_event = _.cloneDeep(event);
					// we need to look up the pd rep in the sitelists
					_.set(new_event, ["Evaluation", "service_recovery"], 1);
	
					if (!_.isEqual(event, new_event)) {
						this.setState({ event_to_save: new_event });
					}
				}
			};
		},
	
		__doIt: esUtils.wrapPreventDefault(function () {
			var event_to_save = this.state.event_to_save;
	
			radio("save_Event").broadcast(event_to_save);
			this.setState({ event_to_save: null });
		}),
		__close: esUtils.wrapPreventDefault(function () {
			this.setState({ event_to_save: null });
		}),
		render: function render() {
			var event_to_save = this.state.event_to_save;
	
			if (!event_to_save) {
				return dd.div();
			}
	
			return Modal({
				title: "Service Recovery Recommended.",
				buttons: [{
					name: "No",
					onClick: this.__close,
					className: "btn btn-default"
				}, {
					name: "Yes",
					onClick: this.__doIt,
					className: "btn btn-primary"
				}],
				onClose: this.__close
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({
				className: "fa fa-exclamation text-muted",
				style: { fontSize: 100 }
			})), dd.div({ className: "col-sm-9" }, dd.p({ className: "preserve-whitespace" }, "This eval score should cause the event to go into state 'service recovery needed'.\n\nOK to set?"))));
		}
	});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	//let _ = require("ES/lib/lodash");
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      event: null
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      company_change: function company_change(event) {
	        this.setState({ event: event });
	      }
	    };
	  },
	
	  __close: esUtils.wrapPreventDefault(function () {
	    this.setState({ event: null });
	  }),
	  render: function render() {
	    var event = this.state.event;
	
	    if (!event) {
	      return dd.span();
	    }
	    return Modal({
	      title: "Company change warning",
	      buttons: [{
	        name: "OK",
	        onClick: this.__close,
	        className: "btn btn-primary"
	      }]
	    }, "You have changed the event COMPANY, which cleared these fields: specific content area, PD Rep, Sales Rep.");
	  }
	});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(24);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var normalizeUsername = __webpack_require__(58);
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return {
				event_to_save: null
			};
		},
		Radio_setup: function Radio_setup() {
			return {
				EventRepChanged_show_modal: function EventRepChanged_show_modal(event, old_eventrep_login) {
					var new_event = _.cloneDeep(event);
					var Displaylists = this.props.Displaylists;
					// we need to look up the pd rep in the sitelists
					var old_login = normalizeUsername(_.get(_.indexBy(_.get(Displaylists, ["sitelists", "pd_reps"]), "id"), [old_eventrep_login, "login"]));
					var new_login = normalizeUsername(_.get(_.indexBy(_.get(Displaylists, ["sitelists", "pd_reps"]), "id"), [new_event.pd_rep_id, "login"]));
					new_event.EventTodo = _.map(new_event.EventTodo, function (todo) {
						var curr_login = normalizeUsername(todo && todo.assignedto);
						if (todo && todo.status == 1) {
							// ignore completed todos
							return todo;
						}
						if (old_login !== curr_login) {
							return todo;
						}
						return _.assign({}, todo, { assignedto: new_login });
					});
	
					if (!_.isEqual(event, new_event)) {
						this.setState({ event_to_save: new_event });
					}
				}
			};
		},
	
		__doIt: esUtils.wrapPreventDefault(function () {
			var event_to_save = this.state.event_to_save;
	
	
			radio("save_Event").broadcast(event_to_save);
			this.setState({ event_to_save: null });
		}),
		__close: esUtils.wrapPreventDefault(function () {
			this.setState({ event_to_save: null });
		}),
		render: function render() {
			var event_to_save = this.state.event_to_save;
	
			if (!event_to_save) {
				return dd.div();
			}
	
			return Modal({
				title: "The Event Rep was changed.",
				buttons: [{
					name: "No thanks",
					onClick: this.__close,
					className: "btn btn-default"
				}, {
					name: "Yes, please",
					onClick: this.__doIt,
					className: "btn btn-primary"
				}],
				onClose: this.__close
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({
				className: "fa fa-user text-muted",
				style: { fontSize: 100 }
			})), dd.div({ className: "col-sm-9" }, dd.p({ className: "preserve-whitespace" }, "The Event Rep was changed.\n\nDo you want to change applicable action items to the new person?"))));
		}
	});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	
	module.exports = dd.createClass({
		render: function render() {
			var onClose = this.props.onClose;
	
	
			return Modal({
				title: "Redacted Contact in Messages",
				buttons: [],
				onClose: onClose
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({ className: "fa fa-warning", style: { fontSize: 60 } })), dd.div({ className: "col-sm-9" }, dd.p(null, "Did you notice the ░░░'s? The message contains direct contact information that was removed from the message."), dd.p(null, "We encourage direct contact after an offer has been agreed to and a deposit paid, but until then we ask that you use only our messaging to communicate with the buyer."), dd.p(null, dd.b(null, dd.i(null, "Once an agreement is signed, the buyer will be given your direct contact information and can communicate with you directly."))), dd.p(null, "Direct communication prior to an agreement tends to take jobs out of the system and hurts everyone."), dd.br())), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: onClose }, "Close")));
		}
	});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var ApplyListModal = __webpack_require__(124);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return {
	      event_to_apply: null
	    };
	  },
	  Radio_setup: function Radio_setup() {
	    return {
	      PromptApplyActionList_set_event_to_apply: function PromptApplyActionList_set_event_to_apply(event) {
	        this.setState({ event_to_apply: event });
	      }
	    };
	  },
	
	  __close: esUtils.wrapPreventDefault(function () {
	    this.setState({ event_to_apply: null });
	  }),
	  render: function render() {
	    var event = this.state.event_to_apply;
	    var Displaylists = this.props.Displaylists;
	
	    var list_id = _.first(event && event.todolistids);
	    if (!event || _.isEmpty(list_id)) {
	      return dd.div();
	    }
	    return ApplyListModal({
	      event: event,
	      Displaylists: Displaylists,
	      list_id: _.parseInt(list_id),
	      onClose: this.__close,
	      custom_clear_message: "You have a new status set for this event."
	    });
	  }
	});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var radio = __webpack_require__(5);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var FormMixin = __webpack_require__(19);
	var RadioMixin = __webpack_require__(20);
	var ezVerticalFields = __webpack_require__(73);
	var AuthedUserSession = __webpack_require__(4);
	
	var DaForm = dd.createClass({
	    mixins: [FormMixin],
	    buildSchema: function buildSchema() {
	        return {
	            note: {
	                label: 'Enter a brief note explaining why you cancelled this event.',
	                type: 'textarea'
	            }
	        };
	    },
	    render: function render() {
	        return dd.form({ onSubmit: this.Form_onSubmit }, ezVerticalFields(this), dd.div(null, dd.button({ className: 'btn btn-primary', type: 'submit' }, 'Save'), ' ', dd.button({ className: 'btn btn-default', onClick: this.props.onCancel }, 'No thanks')));
	    }
	});
	
	module.exports = dd.createClass({
	    mixins: [RadioMixin],
	    getInitialState: function getInitialState() {
	        return { event_to_note_on: null };
	    },
	    Radio_setup: function Radio_setup() {
	        return {
	            prompt_for_why_canceling_event: function prompt_for_why_canceling_event(event) {
	                var Displaylists = this.props.Displaylists || {};
	                var preferences = Displaylists.user && Displaylists.user.myevents_preferences || {};
	                if (preferences.ask_for_reason_when_canceling_or_releasing) {
	                    this.setState({ event_to_note_on: event });
	                }
	            }
	        };
	    },
	
	    __close: esUtils.wrapPreventDefault(function () {
	        this.setState({ event_to_note_on: null });
	    }),
	    __onSubmit: function __onSubmit(data) {
	        var event = _.cloneDeep(this.state.event_to_note_on);
	        if (!_.isArray(event.Note)) {
	            event.Note = [];
	        }
	        event.Note.push({
	            id: 0,
	            eid: event.eid,
	            content: data.note,
	            datetime: new Date(),
	            enteredby: AuthedUserSession.MY_USERNAME
	        });
	        event.Note = _.sortBy(event.Note, 'datetime').reverse();
	        radio('save_Event').broadcast(event);
	        this.setState({ event_to_note_on: null });
	    },
	    render: function render() {
	        if (!this.state.event_to_note_on) {
	            return dd.div();
	        }
	        return Modal({
	            title: 'Make a note about why you canceled/released this event',
	            buttons: [{ name: "Got It.", onClick: this.__close, className: 'btn btn-default' }],
	            onClose: this.__close
	        }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-3 text-center text-muted' }, dd.i({ className: 'fa fa-pencil-square-o', style: { fontSize: "3em" } })), dd.div({ className: 'col-sm-9' }, DaForm({ onSubmit: this.__onSubmit, onCancel: this.__close }))));
	    }
	});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var ErrorAlert = __webpack_require__(6);
	var RadioServiceMixin = __webpack_require__(14);
	var LoadingWrap = __webpack_require__(8);
	
	var DaModal = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Event_update_children_reps: {
					key: "callService",
					on: {
						succeeded: function succeeded() {
							this.setState({
								children_updated: true
							});
						}
					}
				}
			};
		},
	
		__doIt: esUtils.wrapPreventDefault(function () {
			this.RadioService_callService("Event_update_children_reps", {
				eid: this.props.event.eid,
				pd_rep_id: this.props.event.pd_rep_id,
				sales_rep_id: this.props.event.sales_rep_id,
				project_manager_id: this.props.event.project_manager_id
			});
		}),
		render: function render() {
			var _props = this.props,
			    event = _props.event,
			    onClose = _props.onClose;
	
			var ajax = this.state.Event_update_children_reps;
			var children_updated = this.state.children_updated;
	
	
			var buttons = [{
				name: children_updated ? "Close" : "No thanks",
				onClick: onClose,
				className: "btn btn-default"
			}];
			if (!children_updated) {
				buttons.push({
					name: "Yes, please",
					onClick: this.__doIt,
					className: "btn btn-primary"
				});
			}
	
			var title = "Update children?";
			if (ajax.waiting) {
				title = "Updating children...";
			}
			if (children_updated) {
				title = "Updated children.";
			}
	
			return Modal({
				title: title,
				buttons: ajax.waiting ? [] : buttons,
				onClose: onClose
			}, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: 'Updating internal team...' }, children_updated ? dd.p(null, dd.b(null, _.size(_.filter(event.childevents, function (child) {
				return !((_.get(child, ["flags"], 0) & 4) > 0);
			}))), dd.span(null, " events have been updated.")) : dd.div(null, dd.p(null, "The team changed."), dd.p(null, "Would you like to update the internal team on open child events?"), dd.ul(null, _.map(_.filter(event.childevents, function (child) {
				return !((_.get(child, ["flags"], 0) & 4) > 0);
			}), function (child) {
				// filter events based on if they are still open
				return dd.li({ key: child.id }, child.organization);
			})))));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { event: null };
		},
		Radio_setup: function Radio_setup() {
			return {
				event_offer_to_update_children_reps: function event_offer_to_update_children_reps(event) {
					if (_.isEmpty(event && event.childevents)) {
						return;
					}
					this.setState({ event: event });
				}
			};
		},
	
		__close: esUtils.wrapPreventDefault(function () {
			this.setState({ event: null });
		}),
		render: function render() {
			var event = this.state.event;
	
			if (_.isEmpty(event && event.childevents)) {
				return dd.span();
			}
			return DaModal({ event: event, onClose: this.__close });
		}
	});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var ErrorAlert = __webpack_require__(6);
	var RadioServiceMixin = __webpack_require__(14);
	
	var DaModal = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Event_update_children_status: {
					key: "callService",
					on: {
						succeeded: function succeeded() {
							this.props.onClose();
						}
					}
				}
			};
		},
	
		__doIt: esUtils.wrapPreventDefault(function () {
			this.RadioService_callService("Event_update_children_status", {
				eid: this.props.event.eid,
				status: this.props.event.status,
				applyactionlist: true
			});
		}),
		render: function render() {
			var _props = this.props,
			    event = _props.event,
			    onClose = _props.onClose;
	
			var ajax = this.state.Event_update_children_status;
	
			if (ajax.waiting) {
				return dd.span(); //silently work, i.e. we don't need to show a loading bar b/c most of the time this will just work in the background
			}
			return Modal({
				title: "Update child event status?",
				buttons: [{
					name: "Nope",
					onClick: onClose,
					className: "btn btn-default"
				}, {
					name: "Update Children",
					onClick: this.__doIt,
					className: "btn btn-primary"
				}],
				onClose: onClose
			}, ErrorAlert({ message: ajax.error }), dd.p(null, "Would you like to update the status of these child events? This will also add anything on their Action Lists that applies to the new status."), dd.ul(null, _.map(event.childevents, function (child) {
				return dd.li({ key: child.id }, child.organization);
			})));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return { event: null };
		},
		Radio_setup: function Radio_setup() {
			return {
				event_offer_to_update_children_status: function event_offer_to_update_children_status(event) {
					if (_.isEmpty(event && event.childevents)) {
						return;
					}
					this.setState({ event: event });
				}
			};
		},
	
		__close: esUtils.wrapPreventDefault(function () {
			this.setState({ event: null });
		}),
		render: function render() {
			var event = this.state.event;
	
			if (_.isEmpty(event && event.childevents)) {
				return dd.span();
			}
			return DaModal({ event: event, onClose: this.__close });
		}
	});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	
	module.exports = dd.createClass({
	  mixins: [RadioMixin],
	  getInitialState: function getInitialState() {
	    return { show_confirmed_message: null };
	  },
	
	
	  __close: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_confirmed_message: null });
	  }),
	  Radio_setup: function Radio_setup() {
	    return {
	      PromptWhenEventConfirmed: function PromptWhenEventConfirmed(event) {
	        this.setState({ show_confirmed_message: event });
	      }
	    };
	  },
	  render: function render() {
	    if (!this.state.show_confirmed_message) {
	      return null;
	    }
	    return Modal({
	      title: "Confirmed Event",
	      buttons: [],
	      onClose: this.__close
	    }, dd.div({ className: 'row' }, dd.div({ className: 'col-sm-3 text-center text-muted' }, dd.i({ className: 'fa fa-check-circle-o', style: { fontSize: 115 } })), dd.div({ className: 'col-sm-9' }, dd.p({}, "Don't forget to set the CONTRACT EXECUTION DATE on the MISC tab."), dd.button({ className: 'btn-primary btn', onClick: this.__close }, 'I Definitely Will Not'))));
	  }
	});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var radio = __webpack_require__(24);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var RadioServiceMixin = __webpack_require__(14);
	
	var yesNoBtns = function yesNoBtns(onYes, onNo) {
		return [{
			name: "Yes",
			onClick: onYes,
			className: "btn btn-primary"
		}, {
			name: "No",
			onClick: onNo,
			className: "btn btn-default"
		}];
	};
	
	var AddRoyaltiesModal = dd.createClass({
		mixins: [RadioServiceMixin],
		getInitialState: function getInitialState() {
			return { all_done: false };
		},
		RadioService_setup: function RadioService_setup() {
			return {
				EventServices_computeAndAddRoyalties: {
					key: "callService",
					on: {
						succeeded: function succeeded() {
							radio("reload_Event").broadcast(this.props.eid);
							this.setState({ all_done: true });
						}
					}
				}
			};
		},
	
		__yesAddNewRoyalties: esUtils.wrapPreventDefault(function () {
			var _props = this.props,
			    eid = _props.eid,
			    clear_old_royalties = _props.clear_old_royalties;
	
			this.RadioService_callService("EventServices_computeAndAddRoyalties", { eid: eid, clear_old_royalties: clear_old_royalties });
		}),
		render: function render() {
			var onClose = this.props.onClose;
	
			var ajax = this.state.EventServices_computeAndAddRoyalties;
			if (ajax.waiting) {
				return Modal({
					title: "Adding royalties...",
					buttons: []
				}, LoadingWrap({ is_loading: true, text: "Adding royalties..." }));
			}
			if (ajax.error) {
				return Modal({
					title: "Unable to add royalties",
					onClose: onClose
				}, ErrorAlert({ message: ajax.error }));
			}
			if (this.state.all_done) {
				return Modal({
					title: "Added Royalties",
					onClose: onClose
				}, ajax.data || "Added Royalties");
			}
			return Modal({
				title: "Add Royalties",
				buttons: yesNoBtns(this.__yesAddNewRoyalties, onClose),
				onClose: onClose
			}, "Do you want to add new royalty items based on the EVENT TYPE, DELIVERY METHOD, PRESENTATION CATEGORY and PRODUCT?");
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return {
				event: null,
				asked_do_you_want_to_clear_old_royalties: false,
				clear_old_royalties: false
			};
		},
		Radio_setup: function Radio_setup() {
			return {
				royalty_dependant_item_changed: function royalty_dependant_item_changed(event) {
					this.setState({ event: event });
				},
				add_royalty_items: function add_royalty_items(event) {
					this.setState({ event: event });
				}
			};
		},
	
		__yesRemove: esUtils.wrapPreventDefault(function () {
			this.setState({ asked_do_you_want_to_clear_old_royalties: true, clear_old_royalties: true });
		}),
		__noRemove: esUtils.wrapPreventDefault(function () {
			this.setState({ asked_do_you_want_to_clear_old_royalties: true, clear_old_royalties: false });
		}),
		__close: esUtils.wrapPreventDefault(function () {
			this.setState({ event: null, asked_do_you_want_to_clear_old_royalties: false });
		}),
		render: function render() {
			var _state = this.state,
			    event = _state.event,
			    asked_do_you_want_to_clear_old_royalties = _state.asked_do_you_want_to_clear_old_royalties,
			    clear_old_royalties = _state.clear_old_royalties;
	
			if (!event) {
				return dd.span();
			}
			var has_royalties = _.any(event && event.Service, function (s) {
				return !!(s && s.flags_as_map && s.flags_as_map.is_royalty && s.flags_as_map.is_royalty.is_set);
			});
			if (has_royalties && !asked_do_you_want_to_clear_old_royalties) {
				return Modal({
					title: "Remove Royalties",
					buttons: yesNoBtns(this.__yesRemove, this.__noRemove)
				}, "Do you want to remove the current royalty items?");
			}
			return AddRoyaltiesModal({ eid: event.eid, clear_old_royalties: clear_old_royalties, onClose: this.__close });
		}
	});

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	
	var has_tip_been_shown = false;
	
	module.exports = dd.createClass({
		getInitialState: function getInitialState() {
			return { show_tip: !has_tip_been_shown };
		},
	
		__closeTip: esUtils.wrapPreventDefault(function () {
			has_tip_been_shown = true;
			this.setState({ show_tip: false });
		}),
		render: function render() {
			var _props = this.props,
			    Displaylists = _props.Displaylists,
			    url_args = _props.url_args;
	
			var tip = Displaylists && Displaylists.tip || {};
			if (!_.isString(tip && tip.tiptext)) {
				return dd.span(); //Displaylists must not be loaded yet
			}
			if (/^jobs$/i.test(_.first(url_args))) {
				return dd.span(); //Displaylists
			}
	
			if (this.state.show_tip && tip.priority >= 8) {//only show if it's critical
			} else {
				return dd.span();
			}
	
			return Modal({
				title: "Tip of the day",
				buttons: [],
				onClose: this.__closeTip
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({
				className: tip.priority >= 8 ? "fa fa-warning text-danger" : "fa fa-lightbulb-o",
				style: { fontSize: 100 }
			})), dd.div({ className: "col-sm-9" }, dd.p({ className: "preserve-whitespace" }, tip.tiptext.trim()), tip.link ? dd.p(null, dd.a({ href: tip.link, target: "_blank" }, tip.linktext || tip.link)) : null)), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: this.__closeTip }, "Ok")));
		}
	});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var Modal = __webpack_require__(10);
	var esUtils = __webpack_require__(2);
	var RadioMixin = __webpack_require__(20);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	
	var WarnOfUnsavedChangesModal = dd.createClass({
		render: function render() {
			var _props = this.props,
			    onSave = _props.onSave,
			    onClose = _props.onClose,
			    onDiscard = _props.onDiscard;
	
			return Modal({
				title: "Unsaved changes",
				buttons: [],
				onClose: onClose
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({ className: "fa fa-warning", style: { fontSize: 60 } })), dd.div({ className: "col-sm-9" }, dd.p(null, "You have some changes that are not saved."), dd.p(null, onSave ? "Would you like to save them?" : "Would you like to go back and save them?"), dd.br())), dd.div({ className: "text-center" }, onSave ? dd.button({ className: "btn btn-primary", onClick: onSave }, "Yes, save") : dd.button({ className: "btn btn-primary", onClick: onClose }, "Yes, go back so I can save"), " ", dd.button({ className: "btn btn-default", onClick: onDiscard }, "No, don't save")));
		}
	});
	
	var IncomingChangesModal = dd.createClass({
		render: function render() {
			var _props2 = this.props,
			    onClose = _props2.onClose,
			    message = _props2.message;
	
			return Modal({
				title: "Incoming Changes",
				buttons: [],
				onClose: onClose
			}, dd.div({ className: "row" }, dd.div({ className: "col-sm-3 text-center text-muted" }, dd.i({ className: "fa fa-warning", style: { fontSize: 60 } })), dd.div({ className: "col-sm-9" }, dd.p({ className: "preserve-whitespace" }, message), dd.br())), dd.div({ className: "text-center" }, dd.button({ className: "btn btn-primary", onClick: onClose }, "Ok")));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioMixin],
		getInitialState: function getInitialState() {
			return {
				continuation_fn: null,
				cancel_fn: null,
				unsaved_changes: {},
				saving_state: null,
				incoming_changes_message: null
			};
		},
		Radio_setup: function Radio_setup() {
			return {
				checkUnsavedEventChangesBeforeContinuing: function checkUnsavedEventChangesBeforeContinuing(eid, continuation_fn, cancel_fn) {
					var saveFns = this.__getSaveFns();
					if (_.size(saveFns) > 0) {
						this.setState({
							continuation_fn: continuation_fn,
							cancel_fn: cancel_fn
						});
					} else {
						continuation_fn();
					}
				},
				eventFormUnsavedState: function eventFormUnsavedState(eid, form_id, fn_to_save_the_changes) {
					var unsaved_changes = this.state.unsaved_changes || {};
					var made_a_change = false;
	
					if (fn_to_save_the_changes) {
						if (!_.has(unsaved_changes, eid)) {
							unsaved_changes[eid] = {};
							made_a_change = true;
						}
						if (!_.has(unsaved_changes[eid], form_id)) {
							unsaved_changes[eid][form_id] = fn_to_save_the_changes;
							made_a_change = true;
						}
					} else {
						if (_.has(unsaved_changes, eid) && _.has(unsaved_changes[eid], form_id)) {
							delete unsaved_changes[eid][form_id];
							made_a_change = true;
						}
						if (_.size(unsaved_changes[eid]) === 0) {
							delete unsaved_changes[eid];
							made_a_change = true;
						}
					}
					if (made_a_change) {
						this.setState({ unsaved_changes: unsaved_changes });
					}
				},
				save_Event_succeeded: function save_Event_succeeded(event, is_new, displaymessage) {
					this.__clearUnsavedChangesForEID(event && event.eid);
				},
				loadedNewEventVersion_diff: function loadedNewEventVersion_diff(diff, old_event, new_event) {
					var eid = old_event.eid;
					var is_dirty = _.has(this.state.unsaved_changes, eid);
					if (!is_dirty) {
						return;
					}
					var message = "Some changes were just made by ";
					if (_.isString(new_event.last_changed_by) && new_event.last_changed_by.length > 0) {
						message += new_event.last_changed_by;
					} else {
						message += "another user";
					}
					message += ". These changes were just automatically synced and may have overwritten a field you are currently editing.\n\nPlease check the fields you last edited.";
					//TODO show the paths that were changed
					//_.each(diff.added, prPaths);
					//_.each(diff.changed, prPaths);
					//_.each(diff.removed, prPaths);
					this.setState({ incoming_changes_message: message });
				}
			};
		},
		__clearUnsavedChangesForEID: function __clearUnsavedChangesForEID(eid, done) {
			this.setState({ unsaved_changes: _.omit(this.state.unsaved_changes, eid) }, done);
		},
	
		__continueToURL: esUtils.wrapPreventDefault(function () {
			var fn = this.state.continuation_fn;
			this.setState({ continuation_fn: null, cancel_fn: null, unsaved_changes: {} }, function () {
				fn();
			});
		}),
		__getSaveFns: function __getSaveFns() {
			return _.filter(_.flattenDeep(_.map(this.state.unsaved_changes, _.values)), _.isFunction);
		},
	
		__saveChanges: esUtils.wrapPreventDefault(function () {
			var self = this;
			this.setState({ saving_state: { waiting: true, has_error: null } }, function () {
				var has_error = false;
				var onDone = function onDone() {
					self.setState({ saving_state: { waiting: false, has_error: has_error } }, function () {
						if (!has_error) {
							self.__continueToURL();
						}
					});
				};
				var saveFns = self.__getSaveFns();
				if (_.isEmpty(saveFns)) {
					//catching a race condition where save is clicked after the save action is no longer needed
					onDone();
					return;
				}
				var done = _.after(_.size(saveFns), onDone);
				_.each(saveFns, function (saveFn) {
					saveFn(function (err) {
						if (err) {
							has_error = true;
						}
						done();
					});
				});
			});
		}),
		__closeUnsavedWarningURL: esUtils.wrapPreventDefault(function () {
			var fn = this.state.cancel_fn;
			this.setState({ continuation_fn: null, cancel_fn: null, saving_state: null }, function () {
				fn();
			});
		}),
		__clearIncommingChangesMessage: esUtils.wrapPreventDefault(function () {
			this.setState({ incoming_changes_message: null });
		}),
		render: function render() {
			var saving_state = this.state.saving_state || {};
			if (saving_state.waiting) {
				return Modal({ title: "Saving...", buttons: [] }, LoadingWrap({ is_loading: true, text: "Saving..." }));
			}
			if (saving_state.has_error) {
				return Modal({
					title: "Failed to save",
					onClose: this.__closeUnsavedWarningURL
				}, ErrorAlert({ message: "Unable to save. Check your input." }));
			}
			if (this.state.incoming_changes_message) {
				return IncomingChangesModal({
					message: this.state.incoming_changes_message,
					onClose: this.__clearIncommingChangesMessage
				});
			}
			if (this.state.continuation_fn) {
				var saveFns = this.__getSaveFns();
				return WarnOfUnsavedChangesModal({
					onClose: this.__closeUnsavedWarningURL,
					onDiscard: this.__continueToURL,
					onSave: _.size(saveFns) > 1 ? null : this.__saveChanges //only do the save if there is only one save fn otherwise there are some nasty race conditions we don't have an easy way of dealing with yet
				});
			}
			return dd.span();
		}
	});

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var AuthedUserSession = __webpack_require__(4);
	
	var modals = {
	  TipOfTheDay: __webpack_require__(354),
	  EmailToCoworkers: __webpack_require__(343),
	  WarnOfUnsavedChanges: __webpack_require__(355),
	  PromptApplyActionList: __webpack_require__(348),
	  PromptForReasonWhenCanceling: __webpack_require__(349),
	  PromptWhenEventConfirmed: __webpack_require__(352),
	  PromptToChangeStatusForChildren: __webpack_require__(351),
	  ChangeActiveCompany: __webpack_require__(342)
	};
	if (AuthedUserSession.is_st_family) {
	  modals.RoyaltyChange = __webpack_require__(353);
	  modals.EvaluationScoreChanged = __webpack_require__(344);
	  modals.EventRepChanged = __webpack_require__(346);
	  modals.EventCompanyChange = __webpack_require__(345);
	  modals.PromptToChangeRepsForChildren = __webpack_require__(350);
	  // modals.PromptRelayChanged = require("./PromptRelayChanged");
	}
	
	module.exports = dd.createClass({
	  render: function render() {
	    var _props = this.props,
	        url_args = _props.url_args,
	        Displaylists = _props.Displaylists;
	
	
	    return dd.div(null,
	    //All these modals need to be mounted on the page at all times
	    //b/c they are constantly listening for radio events
	    _.map(modals, function (Cmpt, name) {
	      return Cmpt({ key: name, Displaylists: Displaylists, url_args: url_args });
	    }, this));
	  }
	});

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _qs = __webpack_require__(140);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _AuthedUserSession = __webpack_require__(4);
	
	var _AuthedUserSession2 = _interopRequireDefault(_AuthedUserSession);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global btoa */
	module.exports = function CognitoForm() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      login_locked = _ref.login_locked;
	
	  var BALBOA_URL = ["https://", _AuthedUserSession2.default.is_privatelabel ? "balboa-st" : "balboa", _AuthedUserSession2.default.is_staging ? "-staging" : "", ".espeakers.com"].join("");
	
	  var state = btoa(encodeURIComponent([window.location.protocol + "//" + window.location.host + "/balboa3/oauth2/authviaestoken?estoken=[[token]]&redir=/myevents&error_redir=" + encodeURIComponent(window.location.protocol + "//" + window.location.host + "/myevents/signin?cognito=1"), window.location.protocol + "//" + window.location.host + "/myevents/signin?cognito=1&error=[[error]]"].join("|")));
	
	  var error = _lodash2.default.get(_qs2.default.parse(_lodash2.default.get(window.location, "search", "").replace("?", "")), ["error"]);
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    login_locked && _AuthedUserSession2.default.is_privatelabel ? _react2.default.createElement(
	      "a",
	      {
	        className: "btn btn-default btn-block",
	        href: BALBOA_URL + "/speaker/connect/cognito?state=" + state
	      },
	      "CLOSED DURING MAINTENANCE",
	      _react2.default.createElement("div", null)
	    ) : _react2.default.createElement(
	      "a",
	      {
	        className: "btn btn-default btn-block",
	        href: BALBOA_URL + "/speaker/connect/cognito?state=" + state
	      },
	      "Secure Sign-in",
	      _react2.default.createElement("div", null)
	    ),
	    _react2.default.createElement("br", null),
	    error && _react2.default.createElement(
	      "div",
	      { className: "alert alert-danger" },
	      error
	    )
	  );
	};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var FormMixin = __webpack_require__(19);
	var FormUtils = __webpack_require__(9);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var ezVerticalFields = __webpack_require__(73);
	var RadioServiceMixin = __webpack_require__(14);
	
	var DaForm = dd.createClass({
		mixins: [FormMixin],
		buildSchema: function buildSchema() {
			return {
				username: {
					type: "text",
					label: "Your username",
					placeholder: "Username",
					validate: FormUtils.v.required
				}
			};
		},
		render: function render() {
			return dd.form({ onSubmit: this.Form_onSubmit }, ezVerticalFields(this), dd.div(null, dd.button({ className: "btn btn-default btn-block" }, "Reset Password")));
		}
	});
	
	module.exports = dd.createClass({
		mixins: [RadioServiceMixin],
		RadioService_setup: function RadioService_setup() {
			return {
				Authenticate_forgotpassword: { key: "callService" }
			};
		},
		__onSubmit: function __onSubmit(data) {
			this.RadioService_callService("Authenticate_forgotpassword", data.username.toLowerCase().trim());
		},
		render: function render() {
			var ajax = this.state.Authenticate_forgotpassword;
	
			if (ajax.data) {
				return dd.div({ className: "alert alert-info" }, ajax.data);
			}
			return dd.div(null, ErrorAlert({ message: ajax.error }), LoadingWrap({ is_loading: ajax.waiting, text: "Looking up and sending email..." }, dd.h3({ style: { margin: "10px 0 20px 0" }, className: "text-muted" }, "Forgot Password"), DaForm({ onSubmit: this.__onSubmit })));
		}
	});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var dd = __webpack_require__(3);
	var _ = __webpack_require__(1);
	var Constants = __webpack_require__(13);
	
	function parseUTC(str) {
	  if (!str) return null;
	  // Oracle may return "2024-01-26 14:00:00" without a timezone indicator
	  var s = String(str).trim();
	  if (!s.includes("Z") && !s.includes("+")) {
	    s = s.replace(" ", "T") + "Z";
	  }
	  var d = new Date(s);
	  return isNaN(d.getTime()) ? null : d;
	}
	
	function formatLocalDate(utcStr) {
	  var d = parseUTC(utcStr);
	  if (!d) return "";
	  var parts = new Intl.DateTimeFormat("en-US", {
	    weekday: "long",
	    month: "long",
	    day: "numeric",
	    hour: "numeric",
	    minute: "2-digit",
	    hour12: true
	  }).formatToParts(d);
	  var get = function get(type) {
	    return (_.find(parts, { type: type }) || {}).value || "";
	  };
	  var dayPeriod = get("dayPeriod").toLowerCase().replace(/\s/g, "");
	  return get("weekday") + " " + get("month") + " " + get("day") + " at " + get("hour") + ":" + get("minute") + " " + dayPeriod;
	}
	
	function formatDuration(startStr, stopStr) {
	  var start = parseUTC(startStr);
	  var stop = parseUTC(stopStr);
	  if (!start || !stop) return "";
	  var totalMinutes = Math.round((stop - start) / 60000);
	  var hours = Math.floor(totalMinutes / 60);
	  var minutes = totalMinutes % 60;
	  var parts = [];
	  if (hours > 0) parts.push(hours + " hour" + (hours !== 1 ? "s" : ""));
	  if (minutes > 0) parts.push(minutes + " minute" + (minutes !== 1 ? "s" : ""));
	  return parts.join(" ") || "0 minutes";
	}
	
	module.exports = function MaintenanceNotices(_ref) {
	  var notices = _ref.notices;
	
	  if (!notices || notices.length === 0) return null;
	  return dd.div({
	    className: "alert alert-warning",
	    style: {
	      textAlign: "left",
	      backgroundColor: "#F5D020",
	      borderColor: "#D4A800",
	      color: "#6B4500",
	      marginTop: "2rem"
	    }
	  }, dd.strong(null, "Upcoming Maintenance"), dd.ul({ style: { marginTop: "1rem", marginBottom: 0, paddingLeft: "1.5em" } }, notices.map(function (n) {
	    var tipid = _.get(n, "tipid");
	    var tiptext = _.get(n, "message");
	    var link = _.get(n, "link");
	    var linktext = _.get(n, "linktext");
	    var startdate = _.get(n, "startdate");
	    var stopdate = _.get(n, "stopdate");
	    var priority = _.get(n, "priority");
	    var when = formatLocalDate(startdate);
	    var duration = formatDuration(startdate, stopdate);
	    var impactLabel = _.get(Constants.MAINTENANCE_IMPACT_LABELS, priority, "???");
	    return dd.li({
	      key: tipid,
	      style: {
	        listStyle: "none",
	        paddingLeft: "1.0rem",
	        textIndent: "-1.1rem",
	        marginBottom: "1rem"
	      }
	    }, dd.i({
	      className: "fa fa-wrench",
	      style: {
	        marginLeft: "-0.5em",
	        marginRight: "0.5em",
	        display: "inline"
	      }
	    }), when || duration ? dd.span(null, "Starts ", dd.strong(null, when), duration ? ", lasting " + duration + "." : ".", impactLabel ? " Expected impact: " + impactLabel + "." : null) : null, link && linktext ? dd.div({ style: { paddingLeft: "1.4rem" } }, dd.a({ href: link, target: "_blank" }, linktext)) : null, tiptext ? dd.div({ style: { marginTop: "1em", paddingLeft: "1.1rem", opacity: 0.8 } }, tiptext) : null);
	  })));
	};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var ErrorAlert = __webpack_require__(6);
	var LoadingWrap = __webpack_require__(8);
	var RadioServiceMixin = __webpack_require__(14);
	var AuthedUserSession = __webpack_require__(4);
	// const radio = require("ES/lib/react-pubsub-via-radio.js/radio");
	
	module.exports = dd.createClass({
	  mixins: [RadioServiceMixin],
	  RadioService_setup: function RadioService_setup() {
	    return {
	      Authenticate_signin: {
	        key: "callService",
	        on: {
	          succeeded: function succeeded() {
	            this.setState({ is_reloading: true });
	            window.location.reload(); //this will load in the new php session
	          }
	        }
	      }
	    };
	  },
	
	  // componentDidMount() {
	  // 	radio("invalidate_Displaylists_cache").broadcast();
	  // },
	  getInitialState: function getInitialState() {
	    return {
	      is_reloading: false,
	      field_errors: {},
	      default_values: {
	        username: AuthedUserSession.last_login_username
	      }
	    };
	  },
	  __getFieldValue: function __getFieldValue(ref_name) {
	    var node = _.has(this.refs, ref_name) ? this.refs[ref_name] : null;
	
	    return _.isString(node && node.value) ? node.value : "";
	  },
	
	  __onSubmit: esUtils.wrapPreventDefault(function () {
	    var username = this.__getFieldValue("username");
	    var password = this.__getFieldValue("password");
	
	    var field_errors = {};
	    if (esUtils.isBlank(username)) {
	      field_errors["username"] = true;
	    }
	    if (esUtils.isBlank(password)) {
	      field_errors["password"] = true;
	    }
	    this.setState({
	      field_errors: field_errors,
	      default_values: { username: username }
	    });
	    if (!_.isEmpty(field_errors)) {
	      return;
	    }
	    this.RadioService_callService("Authenticate_signin", {
	      username: username,
	      password: password
	    });
	  }),
	  render: function render() {
	    var ajax = this.state.Authenticate_signin;
	
	    var _state = this.state,
	        field_errors = _state.field_errors,
	        is_reloading = _state.is_reloading;
	
	    var login_locked = this.props.login_locked;
	    var default_values = this.state.default_values || {};
	
	    var renderField = function renderField(type, name, label) {
	      return dd.div({ className: "form-group " + (field_errors[name] ? " has-error" : "") }, dd.input({
	        type: type,
	        ref: name,
	        name: name,
	        placeholder: label,
	        className: "form-control",
	        defaultValue: default_values[name] || null,
	        autoComplete: "on"
	      }));
	    };
	    return dd.div(null, ErrorAlert({ message: ajax.error }), LoadingWrap({
	      is_loading: ajax.waiting || is_reloading,
	      text: "Signing in..."
	    }, dd.form({ onSubmit: this.__onSubmit }, renderField("text", "username", "Username"), renderField("password", "password", "Password"), dd.div(null, dd.button({ className: "btn btn-default btn-block" }, login_locked && AuthedUserSession.is_privatelabel ? "CLOSED DURING MAINTENANCE" : "Sign in")))));
	  }
	});

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global btoa */
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	var esUtils = __webpack_require__(2);
	var ImageURLs = __webpack_require__(93);
	var CognitoForm = __webpack_require__(357);
	var SigninForm = __webpack_require__(360);
	var MaintenanceNotices = __webpack_require__(359);
	var ForgotForm = __webpack_require__(358);
	var qs = __webpack_require__(140);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = dd.createClass({
	  getInitialState: function getInitialState() {
	    return { show_forgot_password: false };
	  },
	
	  __toggleForgotPasswordView: esUtils.wrapPreventDefault(function () {
	    this.setState({ show_forgot_password: !this.state.show_forgot_password });
	  }),
	  render: function render() {
	    var _props = this.props,
	        login_locked = _props.login_locked,
	        maintenance_notices = _props.maintenance_notices;
	
	    var body = null;
	    var footer = null;
	    if (this.state.show_forgot_password) {
	      body = ForgotForm();
	      footer = dd.div({ style: { marginTop: 10 }, className: "text-center" }, dd.a({ href: "#", onClick: this.__toggleForgotPasswordView }, dd.i({ className: "fa fa-arrow-left" }), " Back to sign in"));
	    } else {
	      var use_cognito = AuthedUserSession.is_cognito || _.has(qs.parse(_.get(window.location, "search").replace("?", "")), ["cognito"]);
	      body = SigninForm({ login_locked: login_locked });
	      if (use_cognito) {
	        body = CognitoForm({ login_locked: login_locked });
	      }
	      footer = dd.div({ style: { marginTop: 10 } }, !use_cognito && dd.a({
	        href: "#",
	        className: "pull-left",
	        onClick: this.__toggleForgotPasswordView
	      }, "Forgot Password?"), !AuthedUserSession.is_privatelabel ? dd.a({
	        href: "https://www.espeakers.com/speakers/plans-pricing",
	        className: "pull-right"
	      }, "Need an account?") : null, dd.div({ className: "clearfix" }));
	    }
	
	    // set up the staff login for solution tree
	    var pl_footer = dd.footer({ className: "text-muted text-center" }, dd.p({}, "powered by eSpeakers"));
	    var pl_header = null;
	    if (AuthedUserSession.is_st_family) {
	      var redirect_uri = "https://" + (AuthedUserSession.is_staging ? "balboa-st-staging.espeakers.com" : "balboa-st.espeakers.com") + "/admin/connect/cognito?state=" + btoa(window.location.protocol + "//" + window.location.host + "/admin/token-callback/[[token]]|" + window.location.protocol + "//" + window.location.host + "/admin/unverified?error=[[error]]");
	      pl_footer = dd.footer({ className: "text-muted text-center" }, dd.a({ claasName: "link", href: redirect_uri }, "Staff login here ", dd.i({ className: "fa fa-arrow-right" })), dd.p({}, "powered by eSpeakers"), AuthedUserSession.is_cognito && dd.p({ className: "small" }, "You may receive texts when signing into eSpeakers services. Message and data rates apply. You can reply with STOP to discontinue."));
	      pl_header = dd.h4({}, "Associate Login");
	    }
	
	    return dd.div({}, dd.div({ className: "clearfix" }), dd.div({ style: { margin: "50px auto 0 auto", width: 300 } }, dd.div({ className: "well text-center" }, dd.img({
	      src: ImageURLs.logo,
	      style: { marginBottom: 15, maxWidth: "100%" }
	    }), pl_header, body, footer), pl_footer), dd.div({ style: { margin: "50px auto 0 auto", width: 425 } }, MaintenanceNotices({ notices: maintenance_notices })));
	  }
	});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var dd = __webpack_require__(3);
	
	var icon_map = {
	  "onsite": "fa-users",
	  "1": "fa-users",
	  "virtual": "fa-video-camera",
	  "web": "fa-video-camera",
	  "2": "fa-video-camera",
	  "phone": "fa-phone",
	  "3": "fa-phone",
	  "not set": "",
	  "0": "",
	  null: ""
	};
	
	module.exports = dd.createClass({
	  render: function render() {
	    var delivery_method = this.props.delivery_method;
	
	
	    if (!_.has(icon_map, delivery_method)) {
	      return dd.span();
	    }
	
	    return dd.i({ className: "fa " + icon_map[delivery_method] });
	  }
	});

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(51);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(29);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalForm = _react2.default.createClass({
	    displayName: "ModalForm",
	
	    getInitialState: function getInitialState() {
	        return { mounted: false };
	    },
	    componentDidMount: function componentDidMount() {
	        this.setState({ mounted: true });
	    },
	    propTypes: {
	        title: _react2.default.PropTypes.string,
	        size: _react2.default.PropTypes.string,
	        raw_body: _react2.default.PropTypes.bool,
	        children: _react2.default.PropTypes.node
	    },
	    render: function render() {
	        var title = this.props.title;
	        var body = this.props.children;
	        var is_small = this.props.size == "small";
	        var is_large = this.props.size == "large";
	        var raw_body = !!this.props.raw_body;
	        var onClose = _lodash2.default.isFunction(this.props.onClose) ? this.props.onClose : undefined;
	        if (!raw_body) {
	            body = _react2.default.createElement(
	                "div",
	                { className: "modal-body" },
	                body
	            );
	        }
	
	        return _react2.default.createElement(
	            "div",
	            { className: "modal-dialog" + (is_large ? " modal-lg" : "") + (is_small ? " modal-sm" : ""), role: "document" },
	            _react2.default.createElement(
	                "div",
	                { className: "modal-content" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "modal-header" },
	                    _react2.default.createElement(
	                        "button",
	                        { type: "button", className: "close", onClick: onClose },
	                        _react2.default.createElement("i", { className: "fa fa-times" })
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "modal-title" },
	                        title
	                    )
	                ),
	                body
	            )
	        );
	    }
	});
	
	exports.default = ModalForm;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (props) {
		var className = _lodash2.default.isString(props.className) ? "btn " + props.className : "btn btn-success";
		var is_waiting = !!props.is_waiting;
		var is_disabled = !!props.is_disabled;
	
		if (is_waiting || is_disabled) {
			className += " disabled";
		}
	
		return _react2.default.createElement(
			"button",
			{ type: "submit", className: className },
			props.children,
			is_waiting ? _react2.default.createElement("i", { className: "fa fa-spinner fa-spin", style: { marginLeft: "1em" } }) : null
		);
	};
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
	
		RadioService("Authenticate_signin", function (data, callback) {
			Balboa.api("/oauth2/signinpassword", {
				username: data.username,
				password: data.password
			}, function (data) {
				callback();
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	
		RadioService("Authenticate_forgotpassword", function (username, callback) {
			Balboa.api("/authenticate/forgotpassword", {
				username: username
			}, function (data) {
				callback(null, "Check your email inbox. An email has just been sent to you with a password reset link that expires in 90 minutes.");
			}, function (data) {
				callback("Unable to send forgot password email: " + (data && data.message || " Check your internet connection."));
			});
		});
	};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
		RadioService("AwardWallet_get_list", function (params, callback) {
			Balboa.api("/event/returnawardwalletlist", {
				eid: params.eid,
				start_date: params.start_date,
				end_date: params.end_date
			}, function (data) {
				callback(null, _.mapValues(_.groupBy(data.data, "sid"), function (group) {
					return _.map(group, function (v) {
						if (v.failed) {
							return { failed: v.failed };
						}
						return {
							id: v.id, //don't parseInt b/c the tripit api may use strings not numbers
							type: v.type,
							description: v.description,
							data: v.data
						};
					});
				}));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function () {
			return 1;
		});
	
		// Not used for AwardWallet API
		// RadioService("AwardWallet_get_plans", function(params, callback){
		// 	Balboa.api("/event/returntripitplans", {
		// 		sid: params.sid,
		// 		tripid: params.tripid
		// 	}, function(data){
		// 		var r = {};
		// 		_.each(["Flight", "Hotel", "Ground"], function(key){
		// 			r[key] = _.map(data.data[key], esUtils.convertBalboa3ToJS[key]);
		// 		});
		// 		callback(null, r);
		// 	}, function(data){
		// 		callback((data && data.message) || "unknown cause");
		// 	});
		// });
	};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var RadioService = __webpack_require__(32);
	
	// {year: calendars_data}
	var calendars_cache = {};
	
	module.exports.init = function () {
	  RadioService("Calendar_get", function (_ref, callback) {
	    var year = _ref.year,
	        ignore_cache = _ref.ignore_cache,
	        just_re_load_cache = _ref.just_re_load_cache,
	        include_other_companies = _ref.include_other_companies,
	        empire_mode = _ref.empire_mode;
	
	
	    if (just_re_load_cache || calendars_cache[year] && !ignore_cache) {
	      //console.log("Calendar", "cache", calendars_cache);
	      callback(null, calendars_cache);
	      return;
	    }
	    Balboa.api("/calendar/index", {
	      year: year,
	      month: 1,
	      qtymonths: 12,
	      include_details: true,
	      include_other_companies: include_other_companies,
	      empire_mode: empire_mode,
	      version: '2.0'
	    }, function (data) {
	      calendars_cache[year] = data.data;
	      callback(null, calendars_cache);
	    }, function (data) {
	      callback(_.get(data, "message", "mysterious problem"));
	    });
	  }, function (_ref2) {
	    var year = _ref2.year,
	        include_other_companies = _ref2.include_other_companies;
	
	    return year;
	  });
	
	  radio("save_Event_succeeded").subscribe(function (event) {
	    var year = null;
	    var Stagetime = _.first(event && event.Stagetime) || {};
	    if (_.isDate(Stagetime.starttime)) {
	      year = Stagetime.starttime.getFullYear();
	    } else {
	      year = new Date().getFullYear();
	    }
	    radio("Calendar_get").broadcast({ year: year, ignore_cache: true });
	  });
	
	  radio("Event_destroy").subscribe(function (event_id) {
	    _.each(calendars_cache, function (calendars_data, year) {
	      var detail_ids = [];
	      _.each(calendars_data.details, function (detail, detail_id) {
	        if (event_id == detail.eid) {
	          detail_ids.push(detail_id);
	        }
	      });
	      detail_ids = esUtils.cleanup_ids(detail_ids);
	      _.each(calendars_data.calendar, function (months, year) {
	        _.each(months, function (days, month) {
	          _.each(days, function (day, date) {
	            day.detail_ids = _.difference(day.detail_ids, detail_ids);
	          });
	        });
	      });
	    });
	    radio("Calendar_get").broadcast({ just_re_load_cache: true });
	  });
	
	  RadioService("AccountingLock_read", function (params, callback) {
	    Balboa.api("/accountinglock/read", {}, function (data) {
	      callback(null, data.data);
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  });
	
	  RadioService("AccountingLock_toggle", function (_ref3, callback) {
	    var year = _ref3.year,
	        month = _ref3.month;
	
	    Balboa.api("/accountinglock/toggle", {
	      year: year,
	      month: month
	    }, function (data) {
	      callback(null, data.data);
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  });
	};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var ServicesUtils = __webpack_require__(33);
	
	module.exports.init = _.once(function () {
	
	    ServicesUtils.RadioAjax('read_ClientPortal_config', function (sid, success, failure) {
	        //reads everything but the questionnaire
	        Balboa.api('/clientportal/config/' + sid + '/read', {}, function (data) {
	            success(sid, data.data);
	        }, function (data) {
	            failure(sid, data && data.message || 'unknown cause');
	        });
	    });
	
	    ServicesUtils.RadioAjax('save_ClientPortal_links', function (sid, data, success, failure) {
	        Balboa.api('/clientportal/config/' + sid + '/change_urls', { config: data }, function (data) {
	            success(sid, data.data);
	        }, function (data) {
	            failure(sid, data && data.message || 'unknown cause');
	        });
	    });
	
	    ServicesUtils.RadioAjax('save_ClientPortal_questionnaire', function (sid, data, success, failure) {
	        Balboa.api('/clientportal/config/' + sid + '/change_questionnaire', { config: data }, function (data) {
	            success(sid, data.data);
	        }, function (data) {
	            failure(sid, data && data.message || 'unknown cause');
	        });
	    });
	
	    ServicesUtils.RadioAjax('save_ClientPortal_displayfields', function (sid, data, success, failure) {
	        Balboa.api('/clientportal/config/' + sid + '/change_displayfields', { config: data }, function (data) {
	            success(sid, data.data);
	        }, function (data) {
	            failure(sid, data && data.message || 'unknown cause');
	        });
	    });
	});

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
		RadioService('ContactGrabber_search', function (params, callback) {
			Balboa.api('/event/contactgrabsearch', params, function (data) {
				callback(null, data.data);
			}, function (data) {
				if (data && data.message && data.errortype && 'ExceptionContactGrabberNotConfigured' === data.errortype) {
					data.message += ' Click on your username in the upper-right corner, then choose SETTINGS -> CONNECT and choose your contact manager.';
				}
				callback(data && data.message || 'Failed to search: unknown cause');
			});
		}, function () {
			return 1;
		});
	
		RadioService('ContactGrabber_grab', function (params, callback) {
			Balboa.api('/event/contactgrab', params, function (data) {
				callback(null, data.data);
			}, function (data) {
				if (data && data.message && data.errortype && 'ExceptionContactGrabberNotConfigured' === data.errortype) {
					data.message += ' Click on your username in the upper-right corner, then choose SETTINGS -> CONNECT and choose your contact manager.';
				}
				callback(data && data.message || 'Failed to grab contact: unknown cause');
			});
		}, function () {
			return 1;
		});
	};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Balboa = __webpack_require__(21);
	var AuthedUserSession = __webpack_require__(4);
	var RadioService = __webpack_require__(32);
	
	var dashboard_cache = null;
	var dataIsDirty = false;
	
	module.exports.init = function () {
	  RadioService("Dashboard_get", function (params, callback) {
	    if (dashboard_cache !== null && !dataIsDirty) {
	      callback(null, dashboard_cache);
	      return;
	    }
	    Balboa.api("/calendar/dashboard", {
	      formatdates: true,
	      onlysections: [],
	      company_id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])
	    }, function (data) {
	      dashboard_cache = data.data;
	      dataIsDirty = false;
	      callback(null, dashboard_cache);
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  }, function () {
	    return 1;
	  });
	
	  radio("save_Event").subscribe(function (event) {
	    if (dashboard_cache) {
	      // remove old items for this event (so they can be replaced)
	      var prev_action_list = _.get(dashboard_cache, ["actionlist"]);
	      _.remove(prev_action_list, function (action_item) {
	        return _.get(action_item, ["eid"]) === _.get(event, ["eid"]);
	      });
	
	      // grab this event's action items & remove ones that are old, belong to another user, or are complete
	      var new_action_items = _.get(event, "EventTodo", []);
	      _.remove(new_action_items, function (a) {
	        var statusdate = new Date(_.get(a, "statusdate_ISO8601"));
	        var too_old = new Date().getTime() - statusdate.getTime() > 2764800000;
	        return too_old || _.get(a, "status") !== 0 || AuthedUserSession.MY_USERNAME.localeCompare(a.assignedto, undefined, { sensitivity: "accent" }) !== 0;
	      });
	
	      //map the new action items to expected format
	      new_action_items = _.map(new_action_items, function (event_todo) {
	        return {
	          id: _.get(event_todo, ["id"]),
	          status: _.get(event_todo, ["status"]),
	          psnl: _.get(event, ["isPersonal"]),
	          dsc: _.get(event_todo, ["description"]),
	          intls: _.get(event, ["initials"]),
	          date: _.get(event_todo, ["statusdate_ISO8601"]),
	          eid: _.get(event, ["eid"]),
	          org: _.get(event, ["organization"]),
	          sids: _.get(event, ["sids"])
	        };
	      });
	
	      // merge the updated event action items with the action list
	      var action_list = prev_action_list.concat(new_action_items);
	      _.set(dashboard_cache, ["actionlist"], action_list);
	    } else {
	      radio("Dashboard_get").broadcast();
	    }
	  });
	
	  radio("Event_destroy").subscribe(function (event_id) {
	    dataIsDirty = true;
	  });
	};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*global localStorage */
	var _ = __webpack_require__(51);
	var radio = __webpack_require__(37);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var RadioService = __webpack_require__(147);
	
	var convertBalboa3toJS = function convertBalboa3toJS(Displaylists) {
	  if (_.has(Displaylists, 'speaker_shared') && _.has(Displaylists.speaker_shared, 'templatefiles')) {
	    Displaylists.speaker_shared.templatefiles = _.mapValues(Displaylists.speaker_shared.templatefiles, esUtils.StoredFile_Balboa3toJS);
	  }
	  return Displaylists;
	};
	
	var Displaylists_cache = null;
	
	module.exports.init = function () {
	  radio('invalidate_Displaylists_cache').subscribe(function () {
	    Displaylists_cache = null;
	  });
	
	  RadioService('Displaylists_get', function (params, callback) {
	    if (Displaylists_cache) {
	      callback(null, Displaylists_cache);
	      return;
	    }
	    var signature = localStorage.getItem('Displaylists_signature') !== null ? localStorage.getItem('Displaylists_signature') : '';
	    Balboa.api('/authenticate/getdisplaylists', {
	      signature: signature,
	      clear_cache: _.get(params, ["clear_cache"], false)
	    }, function (data) {
	      Displaylists_cache = convertBalboa3toJS(data.data);
	      callback(null, Displaylists_cache);
	    }, function (data) {
	      callback(data && data.message || 'unknown cause');
	      console.error('Displaylists_get', data);
	    });
	  }, function () {
	    return 1;
	  });
	};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*eslint no-use-before-define:0 no-plusplus:0 */ //TODO REMOVE THIS
	/*global FileList */
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var Constants = __webpack_require__(13);
	var RadioService = __webpack_require__(32);
	var ServicesUtils = __webpack_require__(33);
	var reloadDisplaylists = __webpack_require__(69);
	var AuthedUserSession = __webpack_require__(4);
	
	var eventCache = function () {
	  var mutable_cache = {}; //only used internally
	  var immutable_cache = {}; //used for reading
	
	  var save = function save(event_id, event) {
	    if (_.isPlainObject(event)) {
	      mutable_cache[event_id] = event;
	
	      immutable_cache[event_id] = _.cloneDeep(event);
	      if (_.isFunction(Object.freeze)) {
	        Object.freeze(immutable_cache[event_id]);
	      }
	    } else {
	      mutable_cache[event_id] = null;
	      immutable_cache[event_id] = null;
	    }
	  };
	
	  return {
	    read: function read(event_id) {
	      return _.has(immutable_cache, event_id) ? immutable_cache[event_id] : null;
	    },
	    save: save,
	    extend: function extend(event_id, extension) {
	      if (_.isPlainObject(mutable_cache[event_id])) {
	        save(event_id, _.assign(mutable_cache[event_id], extension));
	      }
	    }
	  };
	}();
	
	var broadcastEvent = function broadcastEvent(event_id) {
	  radio("Event").broadcast(eventCache.read(event_id));
	};
	
	var EventPoller = function () {
	  var is_currently_polling = {};
	  var interval_handle = null;
	
	  var poll = function poll(event_id) {
	    if (_.has(is_currently_polling, event_id) && is_currently_polling[event_id]) {
	      return; //already pooling
	    }
	    is_currently_polling[event_id] = true;
	    var done = function done() {
	      is_currently_polling[event_id] = false;
	    };
	    Balboa.api("/event/lastmodified/" + event_id, {}, function (data) {
	      if (!interval_handle) {
	        //has the poller stopped?
	        return done(); //stop now b/c we stopped polling
	      }
	      var new_date = esUtils.convertFromISO8601(data.modified_ISO8601);
	      var curr_event = eventCache.read(event_id);
	      if (curr_event && _.isDate(curr_event.modified) && curr_event.modified.getTime() !== new_date.getTime()) {
	        Balboa.api("/event/read/" + event_id, {}, function (data) {
	          if (!interval_handle) {
	            //has the poller stopped?
	            return done(); //stop now b/c we stopped polling
	          }
	          var new_event = esUtils.convertBalboa3EventToJSEvent(data.data.event);
	
	          var diff = esUtils.deepDiff(eventCache.read(event_id), new_event);
	          radio("loadedNewEventVersion_diff").broadcast(diff, eventCache.read(event_id), new_event);
	
	          eventCache.save(event_id, new_event);
	          broadcastEvent(event_id);
	          done();
	        }, function (data) {
	          //TODO decide what to do
	          done();
	        });
	      } else {
	        done();
	      }
	    }, function () {
	      done();
	    });
	  };
	  var stop = function stop() {
	    clearInterval(interval_handle);
	    interval_handle = null; //so poll knows we're no longer listening
	  };
	  return {
	    start: function start(event_id) {
	      if (!(event_id > 0)) {
	        return;
	      }
	      stop();
	      interval_handle = setInterval(function () {
	        poll(event_id);
	      }, 30 * 1000);
	    },
	
	    stop: stop
	  };
	}();
	
	var getEventChangeSummary = function getEventChangeSummary(old_event, new_event) {
	  var changes = {
	    status_change: false,
	    rep_change: false,
	    bureauID_change: false,
	    pdrep_change: false,
	    status_changed_to_canceled: false,
	    status_changed_to_confirmed: false,
	    royalty_dependant_item_changed: false,
	    company_change: false,
	    evaluation_score_changed: false,
	    relay_changed: false
	  };
	  if (_.isEmpty(old_event) || !_.has(old_event, "status")) {
	    return changes;
	  }
	  if (old_event.status !== new_event.status) {
	    changes.status_change = true;
	    if (new_event.status === "canceled") {
	      changes.status_changed_to_canceled = true;
	    }
	    if (new_event.status === "confirmed") {
	      changes.status_changed_to_confirmed = true;
	    }
	  }
	  if (old_event.pd_rep_id !== new_event.pd_rep_id) {
	    changes.pdrep_change = true;
	    changes.rep_change = true;
	  }
	  if (old_event.event_rep_id !== new_event.event_rep_id || old_event.sales_rep_id !== new_event.sales_rep_id || old_event.project_manager_id !== new_event.project_manager_id) {
	    changes.rep_change = true;
	  }
	  if (old_event.bureauID !== new_event.bureauID) {
	    changes.bureauID_change = true;
	    changes.rep_change = true;
	  }
	
	  if (parseFloat(_.get(old_event, ["Evaluation", "score"], 0)) - parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) !== 0) {
	    if (parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) < 4.2 && parseFloat(_.get(new_event, ["Evaluation", "score"], 0)) > 0) {
	      if (_.get(new_event, ["Evaluation", "service_recovery"]) !== "1") {
	        changes.evaluation_score_changed = true;
	      }
	    }
	  }
	
	  changes.company_change = old_event.companyID !== new_event.companyID && old_event.companyID > 0;
	
	  changes.royalty_dependant_item_changed = _.any(["eventClass", "speechTitle", "deliveryMethod", "presentingproductid"], function (key) {
	    if (old_event[key] === new_event[key]) {
	      return false;
	    }
	    //this is to consider things like "" and null equal
	    return _.size(_.uniq(_.map([old_event[key], new_event[key]], function (e) {
	      return !e ? "" : _.isString(e) ? e.trim() : e;
	    }))) > 1;
	  });
	
	  //certain flags may trigger a new royalty
	  changes.royalty_dependant_item_changed = changes.royalty_dependant_item_changed || _.any(["coaching"], function (key) {
	    return old_event.flags_as_map[key].is_set !== new_event.flags_as_map[key].is_set;
	  });
	
	  // changes to the event, stagetime, venue, or services trigger a change to the relay
	  changes.relay_changed = _.any(["sids", "Stagetime", "Service", "Venue"], function (key) {
	    if (old_event[key] === new_event[key]) {
	      return false;
	    }
	    //this is to consider things like "" and null equal
	    return _.size(_.uniq(_.map([old_event[key], new_event[key]], function (e) {
	      return !e ? "" : _.isString(e) ? e.trim() : e;
	    }))) > 1;
	  });
	
	  return changes;
	};
	
	module.exports.init = function () {
	  radio("start_EventPoller").subscribe(EventPoller.start);
	  radio("stop_EventPoller").subscribe(EventPoller.stop);
	
	  ServicesUtils.RadioAjax("load_Event", function (event_id, success, failure) {
	    if (!esUtils.isNumber(event_id) || event_id < 1) {
	      failure("not a valid event id: " + event_id);
	      return;
	    }
	    if (eventCache.read(event_id) !== null) {
	      broadcastEvent(event_id);
	      success(eventCache.read(event_id));
	      return;
	    }
	    Balboa.api("/event/read/" + event_id, {}, function (data) {
	      eventCache.save(event_id, esUtils.convertBalboa3EventToJSEvent(data.data.event));
	      broadcastEvent(event_id);
	      success(eventCache.read(event_id));
	    }, function (data) {
	      failure(data && data.message || "unknown cause");
	    });
	  }, function (event_id) {
	    return event_id;
	  });
	
	  radio("reload_Event").subscribe(function (event_id) {
	    event_id = esUtils.toInt(event_id);
	    eventCache.save(event_id, null);
	    radio("load_Event").broadcast(event_id);
	  });
	
	  radio("save_Event").subscribe(function (new_event) {
	    var old_event = eventCache.read(new_event.eid);
	    var changes = getEventChangeSummary(old_event, new_event);
	    var old_eventrep_login = _.has(old_event, "pd_rep_id") ? old_event.pd_rep_id : undefined;
	
	    var event = esUtils.convertJSEventToBalboa3Event(_.cloneDeep(new_event));
	    if (event === null) {
	      return;
	    }
	    if (changes.status_change) {
	      radio("event_schedule_change").broadcast(new_event);
	      if (!_.isEmpty(new_event.childevents)) {
	        radio("event_offer_to_update_children_status").broadcast(new_event);
	      }
	    }
	    if (changes.royalty_dependant_item_changed) {
	      //TODO: this radio call triggers a dialog that reloads the event after the user submits, which
	      // might happen prior to the /event/update call below finishing, causing the event to be saved with previous data
	      // Ought to change it so the royalty change request rides along with /event/update instead of being a separate call
	      radio("royalty_dependant_item_changed").broadcast(new_event);
	    }
	
	    if (changes.company_change) {
	      radio("company_change").broadcast(new_event);
	    }
	
	    var is_new = event.eid < 1;
	    Balboa.api("/event/update/" + event.eid, {
	      event_json: event
	    }, function (data) {
	      var event = esUtils.convertBalboa3EventToJSEvent(data.data.event);
	      eventCache.save(event.eid, event);
	
	      radio("save_Event_succeeded").broadcast(eventCache.read(event.eid), is_new, data.data.hasOwnProperty("displaymessage") ? data.data.displaymessage : null);
	      broadcastEvent(event.eid);
	      if (changes.status_changed_to_canceled) {
	        radio("prompt_for_why_canceling_event").broadcast(eventCache.read(event.eid));
	      }
	      if (changes.status_change) {
	        radio("PromptApplyActionList_set_event_to_apply").broadcast(eventCache.read(event.eid));
	      }
	      if (AuthedUserSession.is_st_family && changes.pdrep_change && old_eventrep_login) {
	        radio("EventRepChanged_show_modal").broadcast(eventCache.read(event.eid), old_eventrep_login);
	      }
	      if (changes.rep_change) {
	        if (AuthedUserSession.is_st_family && !_.isEmpty(_.filter(new_event.childevents, function (c) {
	          return (_.get(c, ["flags"], 0) & 4) === 0;
	        }))) {
	          radio("event_offer_to_update_children_reps").broadcast(new_event);
	        }
	      }
	      if (AuthedUserSession.is_st_family && changes.evaluation_score_changed) {
	        radio("EvaluationScore_show_modal").broadcast(eventCache.read(event.eid));
	      }
	      if (!AuthedUserSession.is_st_family && changes.relay_changed) {
	        radio("PromptRelayChanged").broadcast(eventCache.read(event.eid));
	      }
	      if (AuthedUserSession.is_st_family && changes.status_changed_to_confirmed) {
	        radio("PromptWhenEventConfirmed").broadcast(eventCache.read(event.eid));
	      }
	    }, function (data) {
	      console.error("save_Event_failed", data);
	      radio("save_Event_failed").broadcast(event, data && data.message || "unknown cause", is_new);
	    });
	  });
	
	  radio("Event_destroy").subscribe(_.debounce(function (event_id) {
	    Balboa.api("/event/destroy/" + event_id, {
	      confirm: "y"
	    }, function (data) {
	      radio("Event_destroyed").broadcast(event_id, data.message);
	      eventCache.save(event_id, null);
	    }, function (data) {
	      radio("Event_destroy_failed").broadcast(event_id, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  }));
	
	  RadioService("Event_notify_contact", function (_ref, callback) {
	    var event_id = _ref.event_id,
	        recipientemail = _ref.recipientemail,
	        recipientname = _ref.recipientname,
	        messagetype = _ref.messagetype;
	
	    Balboa.api("/event/notifycontact/" + event_id, {
	      recipientemail: recipientemail,
	      recipientname: recipientname,
	      messagetype: messagetype
	    }, function (data) {
	      callback(null, data.data.displaymessage);
	    }, function (data) {
	      callback("Failed to send invite: " + (data && data.message || "unknown cause"));
	    });
	  });
	
	  ServicesUtils.RadioAjax("copy_Event", function (event_id, target_sid, copylists, success, failure) {
	    Balboa.api("/event/copyevent/" + event_id, {
	      target_sid: target_sid,
	      copylists: !!copylists
	    }, function (data) {
	      success(event_id, data.event_id);
	    }, function (data) {
	      failure(event_id, data && data.message || "unknown cause");
	    });
	  });
	
	  ServicesUtils.RadioAjax("email_Event_to_coworkers", function (event_id, coworkers, subject, note, email, success, failure) {
	    Balboa.api("/event/emailtocoworkers/" + event_id, {
	      coworkers: coworkers,
	      subject: subject,
	      note: note,
	      email: email
	    }, function (data) {
	      success(event_id);
	    }, function (data) {
	      failure(event_id, data && data.message || "unknown cause");
	    });
	  });
	
	  radio("StoredFile_remove").subscribe(function (eid, fileid, sids_to_apply_to) {
	    Balboa.api("/event/storedfileremove/" + eid, {
	      fileid: fileid,
	      sids_to_apply_to: JSON.stringify(esUtils.cleanup_ids(sids_to_apply_to))
	    }, function (data) {
	      var storedfiles = data.data;
	      var event = eventCache.read(eid);
	      if (event !== null) {
	        eventCache.extend(event.eid, {
	          storedfiles: _.map(storedfiles, esUtils.StoredFile_Balboa3toJS)
	        });
	        broadcastEvent(event.eid);
	      }
	      if (eid < 1) {
	        reloadDisplaylists();
	      }
	      radio("StoredFile_remove_succeeded").broadcast(eid, fileid, storedfiles);
	    }, function (data) {
	      radio("StoredFile_remove_failed").broadcast(eid, fileid, data && data.message || "unknown cause");
	      console.error("StoredFile_remove", data);
	    });
	  });
	
	  radio("StoredFile_save").subscribe(function (eid, fileid, description, upload_File, sids_to_apply_to) {
	    var params = {
	      fileid: fileid,
	      description: description,
	      sids_to_apply_to: JSON.stringify(esUtils.cleanup_ids(sids_to_apply_to))
	    };
	    if (upload_File) {
	      if (upload_File instanceof FileList) {
	        for (var i = 0; i < upload_File.length; i++) {
	          params[Constants.FileStore_UPLOAD_FILE_NAME + "_" + i] = upload_File[i];
	        }
	      } else {
	        params[Constants.FileStore_UPLOAD_FILE_NAME] = upload_File;
	      }
	    }
	    Balboa.api("/event/storedfileupdate/" + eid, params, function (data) {
	      var storedfiles = data.data;
	      var event = eventCache.read(eid);
	      if (event !== null) {
	        eventCache.extend(event.eid, {
	          storedfiles: _.map(storedfiles, esUtils.StoredFile_Balboa3toJS)
	        });
	        broadcastEvent(event.eid);
	      }
	      if (eid < 1) {
	        reloadDisplaylists();
	      }
	      radio("StoredFile_save_succeeded").broadcast(eid, fileid, storedfiles);
	    }, function (data) {
	      radio("StoredFile_save_failed").broadcast(eid, fileid, data && data.message || "unknown cause");
	      console.error("StoredFile_save", data);
	    }, function (percent) {
	      radio("StoredFile_save_progress").broadcast(eid, fileid, percent);
	    });
	  });
	
	  ServicesUtils.RadioAjax("MergeDocument", function (eid, template_id, success, failure) {
	    Balboa.api("/event/mergedocument/" + eid, {
	      templateid: template_id
	    }, function (data) {
	      success(eid, template_id, {
	        message: data.message,
	        download_url: data.download_url
	      });
	    }, function (data) {
	      failure(eid, template_id, data && data.message || "unknown cause");
	    });
	  });
	
	  RadioService("Event_change_parentID", function (params, callback) {
	    Balboa.api("/event/changeparentid/" + params.eid, {
	      parentID: params.parentID
	    }, function (data) {
	      eventCache.save(params.eid, esUtils.convertBalboa3EventToJSEvent(data.data));
	      broadcastEvent(params.eid);
	      callback(null, eventCache.read(params.eid));
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  });
	
	  RadioService("Event_update_children_status", function (params, callback) {
	    Balboa.api("/event/updatechildrenstatus/" + params.eid, {
	      status: params.status,
	      applyactionlist: !!_.get(params, "applyactionlist", false)
	    }, function (data) {
	      callback();
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  });
	
	  RadioService("Event_update_children_reps", function (params, callback) {
	    Balboa.api("/event/updatechildrenreps/" + params.eid, {
	      pd_rep_id: params.pd_rep_id,
	      sales_rep_id: params.sales_rep_id,
	      project_manager_id: params.project_manager_id
	    }, function (data) {
	      callback();
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  });
	
	  RadioService("Event_my_events_on_date", function (params, callback) {
	    Balboa.api("/event/myeventsondate", {
	      "yyyy-mm-dd": params["yyyy-mm-dd"],
	      speaker_ids: params.speaker_ids
	    }, function (data) {
	      callback(null, data.data);
	    }, function (data) {
	      callback("Failed to fetch events on date: " + (data && data.message || "unknown cause"));
	    });
	  });
	};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var RadioService = __webpack_require__(32);
	
	var toDate = function toDate(d) {
		return !_.isString(d) || d === "1950-01-01T00:00:00" ? null : esUtils.convertFromISO8601(d);
	};
	
	var balboa2JS_shortevent = function balboa2JS_shortevent(shortevent) {
		shortevent.stagetime_starttime = toDate(shortevent.stagetime_starttime);
		shortevent.stagetime_stoptime = toDate(shortevent.stagetime_stoptime);
		return shortevent;
	};
	
	module.exports.init = function () {
	
		RadioService("EventSearch_search", function (params, callback) {
			if (!_.isPlainObject(params)) {
				return;
			}
			var api_params = _.assign({
				//filter to selected speaker(s)
				speaker_ids: esUtils.cleanup_ids(_.flattenDeep([params.sids, params.speaker_ids]))
			}, params);
			if (/^\s*[0-9]+\s*/.test(params.searchterm)) {
				//if it's an EID search
				delete api_params.speaker_ids; //don't filter by speaker
			}
			Balboa.api("/search/event", api_params, function (data) {
				callback(null, _.map(data.data, balboa2JS_shortevent));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
		RadioService("EventServices_computeAndAddRoyalties", function (params, callback) {
			Balboa.api("/eventservices/computeandaddroyalties/" + params.eid, {
				clear_old_royalties: !!params.clear_old_royalties
			}, function (data) {
				callback(null, data.message);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	
		RadioService("EventServices_computeFamilyValues", function (params, callback) {
			Balboa.api("/eventservices/computefamilyvalues/" + params.eid, params, function (data) {
				callback(null, data.message);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var radio = __webpack_require__(24);
	var RadioService = __webpack_require__(32);
	
	var fetchJobBoard = function fetchJobBoard(callback) {
		Balboa.api("/search/jobboard", { include_lost: true }, function (data) {
	
			var JobBoard = data.data;
			_.each(JobBoard.jobs, function (job) {
				if (!_.has(job, "eid")) {
					job.eid = job.event_id;
				}
				job.starttime = esUtils.convertFromISO8601(job.starttime_ISO8601);
				job.stoptime = esUtils.convertFromISO8601(job.stoptime_ISO8601);
				job.created = esUtils.convertFromISO8601(job.date_created || job.created_ISO8601);
			});
	
			callback(null, JobBoard);
		}, function (data) {
			callback(data && data.message || "unknown cause");
		});
	};
	
	var msgToJS = function msgToJS(msg_orig) {
		var msg = _.cloneDeep(msg_orig);
		msg.created = esUtils.convertFromISO8601(msg_orig.created_ISO8601);
		_.each(msg, function (val, key) {
			if (/_id$/.test(key) || key === "id") {
				msg[key] = esUtils.toInt(val);
			}
		});
		return msg;
	};
	
	module.exports.init = function () {
		RadioService("Marketplace_getMyJobBoard", function (data, callback) {
			fetchJobBoard(callback);
		}, function () {
			return 1;
		});
	
		radio("Marketplace_refreshJobBoard").subscribe(function () {
			fetchJobBoard(function (err, JobBoard) {
				if (!err) {
					//hack for success response on Marketplace_getMyJobBoard
					radio("Marketplace_getMyJobBoard_succeeded").broadcast(1, JobBoard);
				}
			});
		});
	
		RadioService("Marketplace_acceptCompliance", function (params, callback) {
			Balboa.api("/mpshortlist/acceptcompliance/" + params.event_id, params, function (data) {
				callback(null, data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.sid;
		});
	
		RadioService("Marketplace_getEventLead", function (params, callback) {
			Balboa.api("/event/read/" + params.event_id, {}, function (data) {
	
				var event = esUtils.convertBalboa3EventToJSEvent(data.data.event);
	
				callback(null, event);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id;
		});
	
		RadioService("Marketplace_getMPMessages", function (params, callback) {
			Balboa.api("/mpmessage/read", params, function (data) {
				callback(null, {
					messages: _.map(data.messages, msgToJS)
				});
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return _.get(params, ["event_id"], "all");
		});
	
		RadioService("Marketplace_applyToJob", function (params, callback) {
			Balboa.api("/mpmessage/applytopublicjob", {
				content: params.content,
				event_id: params.eid,
				speaker_id: params.sid,
				agreement: params.agreement
			}, function (data) {
				callback(null, msgToJS(data.message));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.eid + "|" + params.sid;
		});
	
		RadioService("Marketplace_sendMPMessages", function (params, callback) {
			Balboa.api("/mpmessage/sendtobuyer", {
				content: params.message,
				event_id: params.eid,
				speaker_id: params.sid,
				skip_compliance: params.skip_compliance
			}, function (data) {
				callback(null, msgToJS(data.message));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.eid + "|" + params.sid;
		});
	
		RadioService("Marketplace_sendBureauMessages", function (params, callback) {
			Balboa.api("/mpmessage/sendtobureau", {
				content: params.message,
				event_id: params.eid,
				speaker_id: params.sid
			}, function (data) {
				callback(null);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.eid + "|" + params.sid;
		});
	
		RadioService("Marketplace_getMPAgreement", function (params, callback) {
			Balboa.api("/mpagreement/read", {
				event_id: params.event_id,
				speaker_id: params.speaker_id
			}, function (data) {
				var mpa = data.data;
	
				if (mpa) {
					mpa.created = esUtils.convertFromISO8601(mpa.created_ISO8601);
					_.each(mpa.fees, function (f) {
						f.due = esUtils.convertFromISO8601(f.due_ISO8601);
					});
				}
	
				callback(null, mpa);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.speaker_id;
		});
	
		RadioService("Marketplace_markAsRead", function (params, callback) {
			Balboa.api("/mpmessage/ireadit", {
				ids: params.message_ids
			}, function (data) {
				radio("Marketplace_refreshJobBoard").broadcast();
				callback(null, data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	
		RadioService("Marketplace_createMPAgreement", function (params, callback) {
			Balboa.api("/mpagreement/createdbyspeaker", {
				event_id: params.event_id,
				speaker_id: params.speaker_id,
	
				fee_main: params.fee_main,
				fee_materials: params.fee_materials,
				fee_travel: params.fee_travel,
	
				terms: params.terms,
	
				initials: params.initials,
	
				file: params.file
	
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.speaker_id;
		});
	
		RadioService("Marketplace_acceptAgreement", function (params, callback) {
			Balboa.api("/mpagreement/acceptasspeaker", {
				event_id: params.event_id,
				speaker_id: params.speaker_id,
				initials: params.initials
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.speaker_id;
		});
	
		RadioService("Marketplace_withdrawOffer", function (params, callback) {
			Balboa.api("/mpagreement/archivedbyspeaker", {
				event_id: params.event_id,
				speaker_id: params.speaker_id,
				initials: params.initials,
				message: params.message
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.speaker_id;
		});
	
		RadioService("Marketplace_withdrawShortlist", function (params, callback) {
			Balboa.api("/event/speakerwithdrawsfromshortlist/" + params.event_id, {
				speaker_id: params.speaker_id
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.event_id + "|" + params.speaker_id;
		});
	
		RadioService("Marketplace_readStripeSettings", function (params, callback) {
			Balboa.api("/stripe/getspeakerinfo", {
				speaker_id: params.speaker_id
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.speaker_id;
		});
	
		RadioService("Marketplace_disconnectStripeAccount", function (params, callback) {
			Balboa.api("/stripe/disconnectSpeaker", {
				speaker_id: params.speaker_id
			}, function (data) {
				callback(null, data.data);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.speaker_id;
		});
	
		RadioService("Marketplace_mpmembership", function (params, callback) {
			Balboa.api("/speaker/mpmembership/" + params.sid, {
				accepted: params.accepted,
				initials: params.initials
			}, function (data) {
				callback(null, data.message || "Recorded your response.");
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.sid;
		});
	
		RadioService("Marketplace_getShortprofile", function (params, callback) {
			Balboa.api("/speaker/shortprofile", {
				speaker_ids: params.sid
			}, function (data) {
				callback(null, _.get(data, ["data", params.sid]));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function (params) {
			return params.sid;
		});
	};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global ES_BUILD */
	var radio = __webpack_require__(5);
	var _ = __webpack_require__(1);
	var Ajax = __webpack_require__(83);
	
	module.exports.init = function () {
	    var url_to_check = window.location.pathname;
	
	    var original_version = null;
	    var is_new_version_available = false;
	    if ("undefined" == typeof ES_BUILD || "dev" !== ES_BUILD) {
	        //prevent annoying index loads in dev environment
	        Ajax.post(url_to_check, {}, function (err, resp, status) {
	            if (status === 200) {
	                original_version = resp;
	            }
	        });
	    }
	
	    var checker = setInterval(function () {
	        Ajax.post(url_to_check, {}, function (err, resp, status) {
	            if (status === 200 && original_version !== null && original_version !== resp) {
	                radio('NewAppVersionChecker_new_version_available').broadcast();
	                is_new_version_available = true;
	                clearInterval(checker); //done with it
	            }
	        });
	    }, 24 * 60 * 60 * 1000); //poll every 24 hours (effectively disable this; it was showing the new version message way too often)
	
	    radio('NewAppVersionChecker_get_status').subscribe(_.debounce(function () {
	        if (is_new_version_available) {
	            radio('NewAppVersionChecker_new_version_available').broadcast();
	        }
	    }, 10));
	};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*eslint no-unused-vars:0 */
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
	
	    RadioService('Quickbooks_readAuth', function (data, callback) {
	        Balboa.api('/quickbooks/readauth', {
	            sid: data.sid
	        }, function (data) {
	            callback(null, data);
	        }, function (data) {
	            callback(data && data.message || ' Check your internet connection.');
	        });
	    }, function (data) {
	        return 1;
	    });
	
	    RadioService('Quickbooks_disconnectAuth', function (data, callback) {
	        Balboa.api('/quickbooks/disconnectauth', {
	            sid: data.sid
	        }, function (data) {
	            callback(null, data);
	        }, function (data) {
	            callback(data && data.message || ' Check your internet connection.');
	        });
	    }, function (data) {
	        return 1;
	    });
	
	    RadioService('Quickbooks_findCustomerByName', function (data, callback) {
	        Balboa.api('/quickbooks/findcustomerbyname', {
	            sid: data.sid,
	            name: data.name
	        }, function (data) {
	            callback(null, data);
	        }, function (data) {
	            callback(data && data.message || ' Check your internet connection.');
	        });
	    }, function (data) {
	        return 1;
	    });
	
	    RadioService('Quickbooks_createInvoice', function (data, callback) {
	        Balboa.api('/quickbooks/createinvoice', {
	            sid: data.sid,
	            name: data.name,
	            customer_id: data.customer_id,
	            services: data.services,
	            products: data.products
	        }, function (data) {
	            callback(null, data);
	        }, function (data) {
	            callback(data && data.message || ' Check your internet connection.');
	        });
	    }, function (data) {
	        return 1;
	    });
	
	    RadioService('Quickbooks_addInvoiceToQueue', function (data, callback) {
	        Balboa.api('/quickbooks/addinvoicetoqueue', {
	            sid: data.sid,
	            name: data.name,
	            customer_id: data.customer_id,
	            services: data.services,
	            products: data.products
	        }, function (data) {
	            callback(null, data);
	        }, function (data) {
	            callback(data && data.message || ' Check your internet connection.');
	        });
	    }, function (data) {
	        return 1;
	    });
	};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global localStorage */
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	
	var sitelist_cache = null;
	// let dataIsDirty = false;
	
	module.exports.init = function () {
	  RadioService("Sitelists_get", function (params, callback) {
	    // if((sitelist_cache !== null) && !dataIsDirty){
	    //   callback(null, sitelist_cache);
	    //   return;
	    // }
	    var signature_key = 'Sitelists_signature_' + _.get(params, ["id"]);
	    var signature = localStorage.getItem(signature_key) !== null ? localStorage.getItem(signature_key) : '';
	    Balboa.api("/authenticate/getsitelists", {
	      signature: signature,
	      company: _.get(params, ["id"]),
	      clear_cache: _.get(params, ["clear_cache"], false)
	    }, function (data) {
	      sitelist_cache = data.data;
	      // dataIsDirty = false;
	      callback(null, sitelist_cache);
	    }, function (data) {
	      callback(data && data.message || "unknown cause");
	    });
	  }, function () {
	    return 1;
	  });
	
	  RadioService("clear_Cache", function (params, callback) {}, function () {
	    return 1;
	  });
	};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Balboa = __webpack_require__(21);
	var RadioService = __webpack_require__(32);
	var reloadDisplaylists = __webpack_require__(69);
	
	module.exports.init = function () {
	
	    radio('save_CustomFieldsLabels').subscribe(_.debounce(function (sid, company_id, labels) {
	        Balboa.api('/speaker/customfieldlabels/' + sid + '/save', {
	            labels: labels,
	            company_id: company_id
	        }, function (data) {
	            radio('save_CustomFieldsLabels_succeeded').broadcast(sid);
	            reloadDisplaylists();
	        }, function (data) {
	            console.error('save_CustomFieldsLabels', sid, data);
	            radio('save_CustomFieldsLabels_failed').broadcast(sid, data && data.message || 'unknown cause');
	        });
	    }, 10));
	
	    RadioService("StoriesList_save", function (data, callback) {
	        Balboa.api("/speaker/storieslist/" + data.sid + "/save", {
	            stories: data.stories
	        }, function (data) {
	            callback();
	            reloadDisplaylists();
	        }, function (data) {
	            callback(data && data.message || 'unknown cause');
	        });
	    }, function (data) {
	        return data.sid;
	    });
	
	    RadioService("Actionlists_save", function (actionlists, callback) {
	        Balboa.api("/speaker/actionlists/save", {
	            actionlists: actionlists
	        }, function (data) {
	            callback();
	            reloadDisplaylists();
	        }, function (data) {
	            callback(data && data.message || 'unknown cause');
	        });
	    }, function (actionlists) {
	        return 1;
	    });
	
	    radio('save_Actionlists').subscribe(_.debounce(function (actionlists) {
	        Balboa.api('/speaker/actionlists/save', {
	            actionlists: actionlists
	        }, function (data) {
	            radio('save_Actionlists_succeeded').broadcast();
	            reloadDisplaylists();
	        }, function (data) {
	            console.error('save_Actionlists', data);
	            radio('save_Actionlists_failed').broadcast(data && data.message || 'unknown cause');
	        });
	    }, 10));
	
	    radio('save_iCalFeed').subscribe(_.debounce(function (sid, ical_feed) {
	        Balboa.api('/speaker/seticalfeed/' + sid, {
	            url: ical_feed.url,
	            calid: ical_feed.calid,
	            tzoffset: ical_feed.tzoffset,
	            description: ical_feed.description
	        }, function (data) {
	            radio('save_iCalFeed_succeeded').broadcast(sid);
	            reloadDisplaylists();
	        }, function (data) {
	            console.error('save_iCalFeed', data);
	            radio('save_iCalFeed_failed').broadcast(sid, data && data.message || 'unknown cause');
	        });
	    }, 10));
	
	    radio('read_iCalExportURL').subscribe(_.debounce(function (sid, params) {
	        Balboa.api('/calendar/generateIcalendarFeed', params, function (data) {
	            radio('read_iCalExportURL_succeeded').broadcast(sid, _.get(data, 'data.icalendar_url'));
	        }, function (data) {
	            console.error('read_iCalExportURL', data);
	            radio('read_iCalExportURL_failed').broadcast(sid, _.get(data, 'message', 'unknown cause'));
	        });
	    }, 10));
	};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var Balboa = __webpack_require__(21);
	var ServicesUtils = __webpack_require__(33);
	
	module.exports.init = _.once(function () {
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Stripe_config", function (sid, success, failure) {
	    Balboa.api("/stripe/getspeakerinfo", { speaker_id: sid }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_Zimbra_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configzimbra/" + sid + "/save", {
	      zimbra_username: data.zimbra_username,
	      zimbra_password: data.zimbra_password
	    }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Zimbra_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configzimbra/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_Infusionsoft_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configinfusionsoft/" + sid + "/save", {
	      app_name: data.app_name,
	      app_key: data.app_key,
	      infusionsoft_username: data.infusionsoft_username,
	      infusionsoft_password: data.infusionsoft_password
	    }, function (data) {
	      success(data.data);
	    }, function (data) {
	      failure(data && data.message || "unknown cause");
	    });
	  }, function (sid, data) {
	    return sid;
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Infusionsoft_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configinfusionsoft/" + sid + "/read", {}, function (data) {
	      success(data.data);
	    }, function (data) {
	      failure(data && data.message || "unknown cause");
	    });
	  }, function (sid) {
	    return sid;
	  });
	
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_SalesForce_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configsalesforce/" + sid + "/save", {
	      salesforce_username: data.salesforce_username,
	      salesforce_password: data.salesforce_password,
	      salesforce_api_token: data.salesforce_api_token
	    }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_SalesForce_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configsalesforce/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_Insightly_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configinsightly/" + sid + "/save", {
	      insightly_api_token: data.insightly_api_token
	    }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Insightly_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configinsightly/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //KARMA
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_KarmaCRM_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configkarmacrm/" + sid + "/save", {
	      karmacrm_api_token: data.karmacrm_api_token
	    }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_KarmaCRM_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configkarmacrm/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //AwardWallet
	  ServicesUtils.RadioAjax("remove_Thirdpartyconnection_AwardWallet_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configawardwallet/" + sid + "/remove", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_AwardWallet_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configawardwallet/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //ZOHO
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_ZohoCRM_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configzohocrm/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("remove_Thirdpartyconnection_ZohoCRM_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configzohocrm/" + sid + "/remove", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //API KEY
	  ServicesUtils.RadioAjax("save_Thirdpartyconnection_APIkey_config", function (sid, data, success, failure) {
	    Balboa.api("/thirdpartyconnection/configapikey/" + sid + "/change", {
	      confirmreset: true
	    }, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_APIkey_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configapikey/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //GOOGLE CONTACTS
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Google_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configgoogle/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //HIGH LEVEL
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Highlevel_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/confighighlevel/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //GOOGLE TASKS
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_GoogleTasks_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configgoogletasks/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //HUBSPOT
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_Hubspot_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/confighubspot/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  ServicesUtils.RadioAjax("remove_Thirdpartyconnection_Hubspot_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/confighubspot/" + sid + "/remove", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //TRIPIT
	  ServicesUtils.RadioAjax("read_Thirdpartyconnection_TripIt_config", function (sid, success, failure) {
	    Balboa.api("/thirdpartyconnection/configtripit/" + sid + "/read", {}, function (data) {
	      success(sid, data.data);
	    }, function (data) {
	      failure(sid, data && data.message || "unknown cause");
	    });
	  });
	
	  //INFUSIONSOFT
	  radio("Thirdpartyconnection_Infusionsoft_get_stagetimes").subscribe(function (sid) {
	    Balboa.api("/thirdpartyconnection/getinfusionsoftstagetimes/" + sid, {}, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_stagetimes").broadcast(sid, data.data);
	    }, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_get_stagetimes_failed").broadcast(sid, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Infusionsoft_get_opportunities").subscribe(function (sid, stagetime_id) {
	    Balboa.api("/thirdpartyconnection/getinfusionsoftopportunitiesbystage/" + sid, {
	      stagetime_id: stagetime_id
	    }, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_opportunities").broadcast(sid, stagetime_id, data.data);
	    }, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_get_opportunities_failed").broadcast(sid, stagetime_id, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Infusionsoft_import_opportunities").subscribe(function (sid, opportunity_id, status, trash) {
	    Balboa.api("/thirdpartyconnection/importinfusionsoftopportunity/" + sid, {
	      opportunity_id: opportunity_id,
	      status: status
	    }, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_import_opportunities_succeeded").broadcast(sid, opportunity_id, status, data.event_id);
	    }, function (data) {
	      radio("Thirdpartyconnection_Infusionsoft_import_opportunities_failed").broadcast(sid, opportunity_id, status, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  //ZOHO
	  radio("Thirdpartyconnection_Zoho_get_opportunities").subscribe(function (sid, searchfor) {
	    Balboa.api("/thirdpartyconnection/getzohoopportunitiesbyname/" + sid, {
	      searchfor: searchfor
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_opportunities").broadcast(sid, searchfor, data.data);
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_get_opportunities_failed").broadcast(sid, searchfor, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Zoho_import_opportunities").subscribe(function (sid, opportunity_id, status, trash) {
	    Balboa.api("/thirdpartyconnection/importzohoopportunity/" + sid, {
	      opportunity_id: opportunity_id,
	      status: status
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_import_opportunities_succeeded").broadcast(sid, opportunity_id, status, data.event_id);
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_import_opportunities_failed").broadcast(sid, opportunity_id, status, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Zoho_link_opportunities").subscribe(function (sid, opportunity_id, status, event_id) {
	    Balboa.api("/thirdpartyconnection/linkzohoopportunity/" + sid, {
	      opportunity_id: opportunity_id,
	      event_id: event_id
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_import_opportunities_succeeded").broadcast(sid, opportunity_id, status, data.event_id);
	    }, function (data) {
	      radio("Thirdpartyconnection_Zoho_import_opportunities_failed").broadcast(sid, opportunity_id, status, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  //HIGHLEVEL
	  radio("Thirdpartyconnection_Hl_get_opportunities").subscribe(function (sid, searchfor) {
	    Balboa.api("/thirdpartyconnection/gethlopportunitiesbyname/" + sid, {
	      searchfor: searchfor
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_opportunities").broadcast(sid, searchfor, data.data);
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_get_opportunities_failed").broadcast(sid, searchfor, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Hl_import_opportunities").subscribe(function (sid, opportunity_id, status, trash) {
	    Balboa.api("/thirdpartyconnection/importhlopportunity/" + sid, {
	      opportunity_id: opportunity_id,
	      status: status
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_import_opportunities_succeeded").broadcast(sid, opportunity_id, status, data.event_id);
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_import_opportunities_failed").broadcast(sid, opportunity_id, status, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	
	  radio("Thirdpartyconnection_Hl_link_opportunities").subscribe(function (sid, opportunity_id, status, event_id) {
	    Balboa.api("/thirdpartyconnection/linkhlopportunity/" + sid, {
	      opportunity_id: opportunity_id,
	      event_id: event_id
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_import_opportunities_succeeded").broadcast(sid, opportunity_id, status, data.event_id);
	    }, function (data) {
	      radio("Thirdpartyconnection_Hl_import_opportunities_failed").broadcast(sid, opportunity_id, status, data && data.message || "unknown cause");
	      console.error(data);
	    });
	  });
	});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var Balboa = __webpack_require__(21);
	var esUtils = __webpack_require__(2);
	var RadioService = __webpack_require__(32);
	
	module.exports.init = function () {
		RadioService("TripIt_get_list", function (params, callback) {
			Balboa.api("/event/returntripitlist", {}, function (data) {
				callback(null, _.mapValues(_.groupBy(data.data, "sid"), function (group) {
					return _.map(group, function (v) {
						if (v.failed) {
							return { failed: v.failed };
						}
						return {
							id: v.tripid, //don't parseInt b/c the tripit api may use strings not numbers
							description: v.tripdescription
						};
					});
				}));
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		}, function () {
			return 1;
		});
	
		RadioService("TripIt_get_plans", function (params, callback) {
			Balboa.api("/event/returntripitplans", {
				sid: params.sid,
				tripid: params.tripid
			}, function (data) {
				var r = {};
				_.each(["Flight", "Hotel", "Ground"], function (key) {
					r[key] = _.map(data.data[key], esUtils.convertBalboa3ToJS[key]);
				});
				callback(null, r);
			}, function (data) {
				callback(data && data.message || "unknown cause");
			});
		});
	};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Balboa = __webpack_require__(21);
	var ServicesUtils = __webpack_require__(33);
	var reloadDisplaylists = __webpack_require__(69);
	
	module.exports.init = function () {
		ServicesUtils.RadioAjax('save_UserPreferences', function (keyvals, success, failure) {
			Balboa.api('/authenticate/myeventsuserpreferences/save', {
				keyvals: JSON.stringify(keyvals)
			}, function (data) {
				success();
				reloadDisplaylists();
			}, function (data) {
				failure(data && data.message || 'unknown cause');
			});
		});
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*global MYEVENTS_ELECTRON */
	var esUtils = __webpack_require__(2);
	
	if (typeof MYEVENTS_ELECTRON === "undefined") {
		module.exports = {
			is_on: false
		};
	} else {
		module.exports = {
			is_on: true,
			logout_url: function () {
				var url = "/balboa3/authenticate/destroysession";
				url += "?" + esUtils.phpCompatibleParams({
					redir: "/myevents/signin"
				});
				return url;
			}(),
			quit: MYEVENTS_ELECTRON.quit
		};
	}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(1);
	var esUtils = __webpack_require__(2);
	
	module.exports = function (session_data, private_label_config) {
	  var getSIDsAtAccessLevels = function getSIDsAtAccessLevels(levels) {
	    if (!_.isArray(levels)) {
	      levels = [levels];
	    }
	    var r = esUtils.cleanup_ids(_.map(_.filter(_.pairs(session_data.permissions), function (pair) {
	      return _.includes(levels, pair[1].access);
	    }), 0));
	    return r;
	  };
	
	  /**
	   * This is a map of the access level to user classes for that level
	   *
	   * The user classes may be different based on privatelabel
	   */
	  var access_type_to_user_classes = function () {
	    var cleanupUserClassArray = function cleanupUserClassArray(user_classes) {
	      return _.uniq(_.filter(_.flattenDeep([user_classes]), _.isString).sort());
	    };
	    var stringArrayOrDefault = function stringArrayOrDefault(arr, deflt) {
	      var l = cleanupUserClassArray(arr);
	      return _.isEmpty(l) ? deflt : l;
	    };
	
	    //////////////////////////////
	    //here is the meat of it
	    //
	    //WARNING
	    //  DO NOT CHANGE ANY KEYS without first doing a global search for uses of doIHaveAccess
	    //  since doIHaveAccess constructs objects based on these key names
	    //
	    var r = {
	      admin: stringArrayOrDefault(private_label_config.classes_with_admin_privs, ["ADMN", "SPKR"]),
	      full: stringArrayOrDefault(private_label_config.classes_with_full_privs, ["ADMN", "SPKR", "FULL"]),
	      spkr: ["SPKR"],
	      read: ["READ"],
	      travel: ["TRAV"]
	    };
	    r.view_fees = [r.admin, r.full, r.read];
	    r.read_or_travel = [r.read, r.travel];
	    r.limited_speaker = private_label_config.is_privatelabel ? [r.spkr] : [];
	    //end of meat
	    //////////////////////////////
	
	    r = _.mapValues(r, cleanupUserClassArray);
	    return r;
	  }();
	
	  return _.mapValues(access_type_to_user_classes, function (levels, name) {
	    var level_sids = getSIDsAtAccessLevels(levels);
	    var isLevelSID = _.partial(_.includes, level_sids);
	    //console.log("doIHaveAccess", access_type_to_user_classes, levels, name);
	    return {
	      all: function all() /* sids... */{
	        //console.log("  all", arguments);
	        var sids = esUtils.cleanup_ids(_.flattenDeep(_.toArray(arguments)));
	        return _.isEmpty(sids) ? false : _.every(sids, isLevelSID);
	      },
	      any: function any() /* sids... */{
	        //console.log("  any", arguments);
	        var sids = esUtils.cleanup_ids(_.flattenDeep(_.toArray(arguments)));
	        return _.isEmpty(sids) ? false : _.some(sids, isLevelSID);
	      },
	      getSIDs: function getSIDs() {
	        //console.log("  getSIDs", level_sids);
	        return _.cloneDeep(level_sids); //to ensure no mutating of level_sids
	      }
	    };
	  });
	};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (event) {
	    var company = null;
	    var buyer_names = _.map(_.get(event, "Buyers", {}), function (Buyer) {
	        company = _.get(Buyer, "company");
	        return [Buyer.firstname, Buyer.lastname].join(" ");
	    });
	    if (_.isEmpty(buyer_names)) {
	        buyer_names = ['The client'];
	    }
	
	    var r = buyer_names.join(', ');
	
	    if (!_.isEmpty(company)) {
	        r += ", " + company;
	    }
	    return r;
	};
	
	var _ = __webpack_require__(1);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (Displaylists, event) {
		if (!event.is_mp_event || _.includes(event.flags_as_array, "bookmenow")) {
			return 0;
		}
		var whitelabel = _.get(Displaylists, ["universal", "whitelabels", event.bureauID]);
	
		var espeakers_commission = parseFloat(_.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"], whitelabel ? whitelabel.mp_espeakers_commission : 0.1)) * 100;
		var thebureau_commission = parseFloat(_.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"], whitelabel ? whitelabel.mp_bureau_commission : 0)) * 100;
	
		return Math.max(0, espeakers_commission + thebureau_commission);
	};
	
	var _ = __webpack_require__(1);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(1);
	var radio = __webpack_require__(5);
	var AuthedUserSession = __webpack_require__(4);
	
	module.exports = function () {
		radio('invalidate_Sitelists_cache').broadcast();
		radio('Sitelists_get').broadcast({ id: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]), clear_cache: true });
	};

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	  var JSONP, computedUrl, createElement, encode, noop, objectToURI, random, randomString;
	
	  createElement = function(tag) {
	    return window.document.createElement(tag);
	  };
	
	  encode = window.encodeURIComponent;
	
	  random = Math.random;
	
	  JSONP = function(options) {
	    var callback, callbackFunc, callbackName, done, head, params, script;
	    if (options == null) {
	      options = {};
	    }
	    params = {
	      data: options.data || {},
	      error: options.error || noop,
	      success: options.success || noop,
	      beforeSend: options.beforeSend || noop,
	      complete: options.complete || noop,
	      url: options.url || ''
	    };
	    params.computedUrl = computedUrl(params);
	    if (params.url.length === 0) {
	      throw new Error('MissingUrl');
	    }
	    done = false;
	    if (params.beforeSend({}, params) !== false) {
	      callbackName = options.callbackName || 'callback';
	      callbackFunc = options.callbackFunc || 'jsonp_' + randomString(15);
	      callback = params.data[callbackName] = callbackFunc;
	      window[callback] = function(data) {
	        window[callback] = null;
	        params.success(data, params);
	        return params.complete(data, params);
	      };
	      script = createElement('script');
	      script.src = computedUrl(params);
	      script.async = true;
	      script.onerror = function(evt) {
	        params.error({
	          url: script.src,
	          event: evt
	        });
	        return params.complete({
	          url: script.src,
	          event: evt
	        }, params);
	      };
	      script.onload = script.onreadystatechange = function() {
	        var ref, ref1;
	        if (done || ((ref = this.readyState) !== 'loaded' && ref !== 'complete')) {
	          return;
	        }
	        done = true;
	        if (script) {
	          script.onload = script.onreadystatechange = null;
	          if ((ref1 = script.parentNode) != null) {
	            ref1.removeChild(script);
	          }
	          return script = null;
	        }
	      };
	      head = window.document.getElementsByTagName('head')[0] || window.document.documentElement;
	      head.insertBefore(script, head.firstChild);
	    }
	    return {
	      abort: function() {
	        window[callback] = function() {
	          return window[callback] = null;
	        };
	        done = true;
	        if (script != null ? script.parentNode : void 0) {
	          script.onload = script.onreadystatechange = null;
	          script.parentNode.removeChild(script);
	          return script = null;
	        }
	      }
	    };
	  };
	
	  noop = function() {
	    return void 0;
	  };
	
	  computedUrl = function(params) {
	    var url;
	    url = params.url;
	    url += params.url.indexOf('?') < 0 ? '?' : '&';
	    url += objectToURI(params.data);
	    return url;
	  };
	
	  randomString = function(length) {
	    var str;
	    str = '';
	    while (str.length < length) {
	      str += random().toString(36).slice(2, 3);
	    }
	    return str;
	  };
	
	  objectToURI = function(obj) {
	    var data, key, value;
	    data = (function() {
	      var results;
	      results = [];
	      for (key in obj) {
	        value = obj[key];
	        results.push(encode(key) + '=' + encode(value));
	      }
	      return results;
	    })();
	    return data.join('&');
	  };
	
	  if ("function" !== "undefined" && __webpack_require__(504) !== null ? __webpack_require__(505) : void 0) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return JSONP;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
	    module.exports = JSONP;
	  } else {
	    this.JSONP = JSONP;
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(82)(module)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(388)
	var ieee754 = __webpack_require__(416)
	var isArray = __webpack_require__(391)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(390).Buffer))

/***/ }),
/* 393 */
177,
/* 394 */
177,
/* 395 */
177,
/* 396 */
177,
/* 397 */
177,
/* 398 */
177,
/* 399 */
177,
/* 400 */
177,
/* 401 */
177,
/* 402 */
177,
/* 403 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(403);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(414);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var createArrayFromMixed = __webpack_require__(405);
	var getMarkupWrap = __webpack_require__(137);
	var invariant = __webpack_require__(11);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(408);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(410);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * # hasLocalStorage()
	 *
	 * returns `true` or `false` depending on whether localStorage is supported or not.
	 * Beware that some browsers like Safari do not support localStorage in private mode.
	 *
	 * inspired by this cappuccino commit
	 * https://github.com/cappuccino/cappuccino/commit/063b05d9643c35b303568a28809e4eb3224f71ec
	 *
	 * @returns {Boolean}
	 */
	function hasLocalStorage() {
	  try {
	
	    // we've to put this in here. I've seen Firefox throwing `Security error: 1000`
	    // when cookies have been disabled
	    if (typeof localStorage === 'undefined') {
	      return false;
	    }
	
	    // Just because localStorage exists does not mean it works. In particular it might be disabled
	    // as it is when Safari's private browsing mode is active.
	    localStorage.setItem('Storage-Test', '1');
	
	    // that should not happen ...
	    if (localStorage.getItem('Storage-Test') !== '1') {
	      return false;
	    }
	
	    // okay, let's clean up if we got here.
	    localStorage.removeItem('Storage-Test');
	  } catch (_error) {
	
	    // in case of an error, like Safari's Private Mode, return false
	    return false;
	  }
	
	  // we're good.
	  return true;
	}
	
	
	if (true) {
	  module.exports = hasLocalStorage;
	}


/***/ }),
/* 416 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(418)
	var isWindow = __webpack_require__(419)
	
	function isNode (val) {
	  if (!isObject(val) || !isWindow(window) || typeof window.Node !== 'function') {
	    return false
	  }
	
	  return typeof val.nodeType === 'number' &&
	    typeof val.nodeName === 'string'
	}
	
	module.exports = isNode


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isObject(x) {
		return typeof x === 'object' && x !== null;
	};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (obj) {
	
	  if (obj == null) {
	    return false;
	  }
	
	  var o = Object(obj);
	
	  return o === o.window;
	};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	/* globals window, HTMLElement */
	
	'use strict';
	
	/**!
	 * is
	 * the definitive JavaScript type testing library
	 *
	 * @copyright 2013-2014 Enrico Marino / Jordan Harband
	 * @license MIT
	 */
	
	var objProto = Object.prototype;
	var owns = objProto.hasOwnProperty;
	var toStr = objProto.toString;
	var symbolValueOf;
	if (typeof Symbol === 'function') {
	  symbolValueOf = Symbol.prototype.valueOf;
	}
	var bigIntValueOf;
	if (typeof BigInt === 'function') {
	  bigIntValueOf = BigInt.prototype.valueOf;
	}
	var isActualNaN = function (value) {
	  return value !== value;
	};
	var NON_HOST_TYPES = {
	  'boolean': 1,
	  number: 1,
	  string: 1,
	  undefined: 1
	};
	
	var base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
	var hexRegex = /^[A-Fa-f0-9]+$/;
	
	/**
	 * Expose `is`
	 */
	
	var is = {};
	
	/**
	 * Test general.
	 */
	
	/**
	 * is.type
	 * Test if `value` is a type of `type`.
	 *
	 * @param {*} value value to test
	 * @param {String} type type
	 * @return {Boolean} true if `value` is a type of `type`, false otherwise
	 * @api public
	 */
	
	is.a = is.type = function (value, type) {
	  return typeof value === type;
	};
	
	/**
	 * is.defined
	 * Test if `value` is defined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is defined, false otherwise
	 * @api public
	 */
	
	is.defined = function (value) {
	  return typeof value !== 'undefined';
	};
	
	/**
	 * is.empty
	 * Test if `value` is empty.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is empty, false otherwise
	 * @api public
	 */
	
	is.empty = function (value) {
	  var type = toStr.call(value);
	  var key;
	
	  if (type === '[object Array]' || type === '[object Arguments]' || type === '[object String]') {
	    return value.length === 0;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (owns.call(value, key)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  return !value;
	};
	
	/**
	 * is.equal
	 * Test if `value` is equal to `other`.
	 *
	 * @param {*} value value to test
	 * @param {*} other value to compare with
	 * @return {Boolean} true if `value` is equal to `other`, false otherwise
	 */
	
	is.equal = function equal(value, other) {
	  if (value === other) {
	    return true;
	  }
	
	  var type = toStr.call(value);
	  var key;
	
	  if (type !== toStr.call(other)) {
	    return false;
	  }
	
	  if (type === '[object Object]') {
	    for (key in value) {
	      if (!is.equal(value[key], other[key]) || !(key in other)) {
	        return false;
	      }
	    }
	    for (key in other) {
	      if (!is.equal(value[key], other[key]) || !(key in value)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Array]') {
	    key = value.length;
	    if (key !== other.length) {
	      return false;
	    }
	    while (key--) {
	      if (!is.equal(value[key], other[key])) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  if (type === '[object Function]') {
	    return value.prototype === other.prototype;
	  }
	
	  if (type === '[object Date]') {
	    return value.getTime() === other.getTime();
	  }
	
	  return false;
	};
	
	/**
	 * is.hosted
	 * Test if `value` is hosted by `host`.
	 *
	 * @param {*} value to test
	 * @param {*} host host to test with
	 * @return {Boolean} true if `value` is hosted by `host`, false otherwise
	 * @api public
	 */
	
	is.hosted = function (value, host) {
	  var type = typeof host[value];
	  return type === 'object' ? !!host[value] : !NON_HOST_TYPES[type];
	};
	
	/**
	 * is.instance
	 * Test if `value` is an instance of `constructor`.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an instance of `constructor`
	 * @api public
	 */
	
	is.instance = is['instanceof'] = function (value, constructor) {
	  return value instanceof constructor;
	};
	
	/**
	 * is.nil / is.null
	 * Test if `value` is null.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is null, false otherwise
	 * @api public
	 */
	
	is.nil = is['null'] = function (value) {
	  return value === null;
	};
	
	/**
	 * is.undef / is.undefined
	 * Test if `value` is undefined.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is undefined, false otherwise
	 * @api public
	 */
	
	is.undef = is.undefined = function (value) {
	  return typeof value === 'undefined';
	};
	
	/**
	 * Test arguments.
	 */
	
	/**
	 * is.args
	 * Test if `value` is an arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.args = is.arguments = function (value) {
	  var isStandardArguments = toStr.call(value) === '[object Arguments]';
	  var isOldArguments = !is.array(value) && is.arraylike(value) && is.object(value) && is.fn(value.callee);
	  return isStandardArguments || isOldArguments;
	};
	
	/**
	 * Test array.
	 */
	
	/**
	 * is.array
	 * Test if 'value' is an array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an array, false otherwise
	 * @api public
	 */
	
	is.array = Array.isArray || function (value) {
	  return toStr.call(value) === '[object Array]';
	};
	
	/**
	 * is.arguments.empty
	 * Test if `value` is an empty arguments object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty arguments object, false otherwise
	 * @api public
	 */
	is.args.empty = function (value) {
	  return is.args(value) && value.length === 0;
	};
	
	/**
	 * is.array.empty
	 * Test if `value` is an empty array.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an empty array, false otherwise
	 * @api public
	 */
	is.array.empty = function (value) {
	  return is.array(value) && value.length === 0;
	};
	
	/**
	 * is.arraylike
	 * Test if `value` is an arraylike object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an arguments object, false otherwise
	 * @api public
	 */
	
	is.arraylike = function (value) {
	  return !!value && !is.bool(value)
	    && owns.call(value, 'length')
	    && isFinite(value.length)
	    && is.number(value.length)
	    && value.length >= 0;
	};
	
	/**
	 * Test boolean.
	 */
	
	/**
	 * is.bool
	 * Test if `value` is a boolean.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a boolean, false otherwise
	 * @api public
	 */
	
	is.bool = is['boolean'] = function (value) {
	  return toStr.call(value) === '[object Boolean]';
	};
	
	/**
	 * is.false
	 * Test if `value` is false.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is false, false otherwise
	 * @api public
	 */
	
	is['false'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === false;
	};
	
	/**
	 * is.true
	 * Test if `value` is true.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is true, false otherwise
	 * @api public
	 */
	
	is['true'] = function (value) {
	  return is.bool(value) && Boolean(Number(value)) === true;
	};
	
	/**
	 * Test date.
	 */
	
	/**
	 * is.date
	 * Test if `value` is a date.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a date, false otherwise
	 * @api public
	 */
	
	is.date = function (value) {
	  return toStr.call(value) === '[object Date]';
	};
	
	/**
	 * is.date.valid
	 * Test if `value` is a valid date.
	 *
	 * @param {*} value value to test
	 * @returns {Boolean} true if `value` is a valid date, false otherwise
	 */
	is.date.valid = function (value) {
	  return is.date(value) && !isNaN(Number(value));
	};
	
	/**
	 * Test element.
	 */
	
	/**
	 * is.element
	 * Test if `value` is an html element.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an HTML Element, false otherwise
	 * @api public
	 */
	
	is.element = function (value) {
	  return value !== undefined
	    && typeof HTMLElement !== 'undefined'
	    && value instanceof HTMLElement
	    && value.nodeType === 1;
	};
	
	/**
	 * Test error.
	 */
	
	/**
	 * is.error
	 * Test if `value` is an error object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an error object, false otherwise
	 * @api public
	 */
	
	is.error = function (value) {
	  return toStr.call(value) === '[object Error]';
	};
	
	/**
	 * Test function.
	 */
	
	/**
	 * is.fn / is.function (deprecated)
	 * Test if `value` is a function.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a function, false otherwise
	 * @api public
	 */
	
	is.fn = is['function'] = function (value) {
	  var isAlert = typeof window !== 'undefined' && value === window.alert;
	  if (isAlert) {
	    return true;
	  }
	  var str = toStr.call(value);
	  return str === '[object Function]' || str === '[object GeneratorFunction]' || str === '[object AsyncFunction]';
	};
	
	/**
	 * Test number.
	 */
	
	/**
	 * is.number
	 * Test if `value` is a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a number, false otherwise
	 * @api public
	 */
	
	is.number = function (value) {
	  return toStr.call(value) === '[object Number]';
	};
	
	/**
	 * is.infinite
	 * Test if `value` is positive or negative infinity.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is positive or negative Infinity, false otherwise
	 * @api public
	 */
	is.infinite = function (value) {
	  return value === Infinity || value === -Infinity;
	};
	
	/**
	 * is.decimal
	 * Test if `value` is a decimal number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a decimal number, false otherwise
	 * @api public
	 */
	
	is.decimal = function (value) {
	  return is.number(value) && !isActualNaN(value) && !is.infinite(value) && value % 1 !== 0;
	};
	
	/**
	 * is.divisibleBy
	 * Test if `value` is divisible by `n`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} n dividend
	 * @return {Boolean} true if `value` is divisible by `n`, false otherwise
	 * @api public
	 */
	
	is.divisibleBy = function (value, n) {
	  var isDividendInfinite = is.infinite(value);
	  var isDivisorInfinite = is.infinite(n);
	  var isNonZeroNumber = is.number(value) && !isActualNaN(value) && is.number(n) && !isActualNaN(n) && n !== 0;
	  return isDividendInfinite || isDivisorInfinite || (isNonZeroNumber && value % n === 0);
	};
	
	/**
	 * is.integer
	 * Test if `value` is an integer.
	 *
	 * @param value to test
	 * @return {Boolean} true if `value` is an integer, false otherwise
	 * @api public
	 */
	
	is.integer = is['int'] = function (value) {
	  return is.number(value) && !isActualNaN(value) && value % 1 === 0;
	};
	
	/**
	 * is.maximum
	 * Test if `value` is greater than 'others' values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is greater than `others` values
	 * @api public
	 */
	
	is.maximum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value < others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.minimum
	 * Test if `value` is less than `others` values.
	 *
	 * @param {Number} value value to test
	 * @param {Array} others values to compare with
	 * @return {Boolean} true if `value` is less than `others` values
	 * @api public
	 */
	
	is.minimum = function (value, others) {
	  if (isActualNaN(value)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.arraylike(others)) {
	    throw new TypeError('second argument must be array-like');
	  }
	  var len = others.length;
	
	  while (--len >= 0) {
	    if (value > others[len]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * is.nan
	 * Test if `value` is not a number.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is not a number, false otherwise
	 * @api public
	 */
	
	is.nan = function (value) {
	  return !is.number(value) || value !== value;
	};
	
	/**
	 * is.even
	 * Test if `value` is an even number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an even number, false otherwise
	 * @api public
	 */
	
	is.even = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 === 0);
	};
	
	/**
	 * is.odd
	 * Test if `value` is an odd number.
	 *
	 * @param {Number} value value to test
	 * @return {Boolean} true if `value` is an odd number, false otherwise
	 * @api public
	 */
	
	is.odd = function (value) {
	  return is.infinite(value) || (is.number(value) && value === value && value % 2 !== 0);
	};
	
	/**
	 * is.ge
	 * Test if `value` is greater than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.ge = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value >= other;
	};
	
	/**
	 * is.gt
	 * Test if `value` is greater than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean}
	 * @api public
	 */
	
	is.gt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value > other;
	};
	
	/**
	 * is.le
	 * Test if `value` is less than or equal to `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if 'value' is less than or equal to 'other'
	 * @api public
	 */
	
	is.le = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value <= other;
	};
	
	/**
	 * is.lt
	 * Test if `value` is less than `other`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} other value to compare with
	 * @return {Boolean} if `value` is less than `other`
	 * @api public
	 */
	
	is.lt = function (value, other) {
	  if (isActualNaN(value) || isActualNaN(other)) {
	    throw new TypeError('NaN is not a valid value');
	  }
	  return !is.infinite(value) && !is.infinite(other) && value < other;
	};
	
	/**
	 * is.within
	 * Test if `value` is within `start` and `finish`.
	 *
	 * @param {Number} value value to test
	 * @param {Number} start lower bound
	 * @param {Number} finish upper bound
	 * @return {Boolean} true if 'value' is is within 'start' and 'finish'
	 * @api public
	 */
	is.within = function (value, start, finish) {
	  if (isActualNaN(value) || isActualNaN(start) || isActualNaN(finish)) {
	    throw new TypeError('NaN is not a valid value');
	  } else if (!is.number(value) || !is.number(start) || !is.number(finish)) {
	    throw new TypeError('all arguments must be numbers');
	  }
	  var isAnyInfinite = is.infinite(value) || is.infinite(start) || is.infinite(finish);
	  return isAnyInfinite || (value >= start && value <= finish);
	};
	
	/**
	 * Test object.
	 */
	
	/**
	 * is.object
	 * Test if `value` is an object.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is an object, false otherwise
	 * @api public
	 */
	is.object = function (value) {
	  return toStr.call(value) === '[object Object]';
	};
	
	/**
	 * is.primitive
	 * Test if `value` is a primitive.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a primitive, false otherwise
	 * @api public
	 */
	is.primitive = function isPrimitive(value) {
	  if (!value) {
	    return true;
	  }
	  if (typeof value === 'object' || is.object(value) || is.fn(value) || is.array(value)) {
	    return false;
	  }
	  return true;
	};
	
	/**
	 * is.hash
	 * Test if `value` is a hash - a plain object literal.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a hash, false otherwise
	 * @api public
	 */
	
	is.hash = function (value) {
	  return is.object(value) && value.constructor === Object && !value.nodeType && !value.setInterval;
	};
	
	/**
	 * Test regexp.
	 */
	
	/**
	 * is.regexp
	 * Test if `value` is a regular expression.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a regexp, false otherwise
	 * @api public
	 */
	
	is.regexp = function (value) {
	  return toStr.call(value) === '[object RegExp]';
	};
	
	/**
	 * Test string.
	 */
	
	/**
	 * is.string
	 * Test if `value` is a string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a string, false otherwise
	 * @api public
	 */
	
	is.string = function (value) {
	  return toStr.call(value) === '[object String]';
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.base64
	 * Test if `value` is a valid base64 encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a base64 encoded string, false otherwise
	 * @api public
	 */
	
	is.base64 = function (value) {
	  return is.string(value) && (!value.length || base64Regex.test(value));
	};
	
	/**
	 * Test base64 string.
	 */
	
	/**
	 * is.hex
	 * Test if `value` is a valid hex encoded string.
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if 'value' is a hex encoded string, false otherwise
	 * @api public
	 */
	
	is.hex = function (value) {
	  return is.string(value) && (!value.length || hexRegex.test(value));
	};
	
	/**
	 * is.symbol
	 * Test if `value` is an ES6 Symbol
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a Symbol, false otherise
	 * @api public
	 */
	
	is.symbol = function (value) {
	  return typeof Symbol === 'function' && toStr.call(value) === '[object Symbol]' && typeof symbolValueOf.call(value) === 'symbol';
	};
	
	/**
	 * is.bigint
	 * Test if `value` is an ES-proposed BigInt
	 *
	 * @param {*} value value to test
	 * @return {Boolean} true if `value` is a BigInt, false otherise
	 * @api public
	 */
	
	is.bigint = function (value) {
	  // eslint-disable-next-line valid-typeof
	  return typeof BigInt === 'function' && toStr.call(value) === '[object BigInt]' && typeof bigIntValueOf.call(value) === 'bigint';
	};
	
	module.exports = is;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	module.exports = [{"timezone":"US/Eastern","abbreviation":"ET","offset":"UTC-05:00"},{"timezone":"US/Central","abbreviation":"CT","offset":"UTC-06:00"},{"timezone":"US/Mountain","abbreviation":"MT","offset":"UTC-07:00"},{"timezone":"US/Pacific","abbreviation":"PT","offset":"UTC-08:00"},{"timezone":"America/Anchorage","abbreviation":"AK","offset":"UTC-09:00"},{"timezone":"Pacific/Honolulu","abbreviation":"HAST","offset":"UTC-10:00"},{"timezone":"US/Arizona","abbreviation":"MST","offset":"UTC-07:00"},{"timezone":"Canada/Atlantic","abbreviation":"AST","offset":"UTC-04:00"},{"timezone":"Africa/Casablanca","abbreviation":"MOST","offset":"UTC"},{"timezone":"UTC","abbreviation":"UTC","offset":"UTC"},{"timezone":"Europe/London","abbreviation":"GMT","offset":"UTC"},{"timezone":"Africa/Casablanca","abbreviation":"GST","offset":"UTC"},{"timezone":"Europe/Amsterdam","abbreviation":"WET","offset":"UTC+01:00"},{"timezone":"Europe/Belgrade","abbreviation":"CET","offset":"UTC+01:00"},{"timezone":"Europe/Brussels","abbreviation":"RST","offset":"UTC+01:00"},{"timezone":"Europe/Sarajevo","abbreviation":"CEST","offset":"UTC+01:00"},{"timezone":"Africa/Brazzaville","abbreviation":"ECT","offset":"UTC+01:00"},{"timezone":"Europe/Athens","abbreviation":"JST","offset":"UTC+02:00"},{"timezone":"Europe/Athens","abbreviation":"GTBST","offset":"UTC+02:00"},{"timezone":"Africa/Cairo","abbreviation":"MEST","offset":"UTC+02:00"},{"timezone":"Africa/Cairo","abbreviation":"EGST","offset":"UTC+02:00"},{"timezone":"Africa/Cairo","abbreviation":"SST","offset":"UTC+02:00"},{"timezone":"Africa/Harare","abbreviation":"SAST","offset":"UTC+02:00"},{"timezone":"Europe/Helsinki","abbreviation":"EET","offset":"UTC+02:00"},{"timezone":"Asia/Jerusalem","abbreviation":"ISST","offset":"UTC+02:00"},{"timezone":"Asia/Jerusalem","abbreviation":"EEST","offset":"UTC+02:00"},{"timezone":"Asia/Jerusalem","abbreviation":"NMST","offset":"UTC+02:00"},{"timezone":"Asia/Baghdad","abbreviation":"ARST","offset":"UTC+03:00"},{"timezone":"Asia/Kuwait","abbreviation":"ABST","offset":"UTC+03:00"},{"timezone":"Europe/Moscow","abbreviation":"MSK","offset":"UTC+03:00"},{"timezone":"Asia/Kuwait","abbreviation":"EAT","offset":"UTC+03:00"},{"timezone":"Asia/Tehran","abbreviation":"IRST","offset":"UTC+03:30"},{"timezone":"Asia/Muscat","abbreviation":"ARBST","offset":"UTC+04:00"},{"timezone":"Asia/Baku","abbreviation":"AZT","offset":"UTC+04:00"},{"timezone":"Asia/Baku","abbreviation":"MUT","offset":"UTC+04:00"},{"timezone":"Asia/Baku","abbreviation":"GET","offset":"UTC+04:00"},{"timezone":"Asia/Baku","abbreviation":"AMT","offset":"UTC+04:00"},{"timezone":"Asia/Baku","abbreviation":"AFT","offset":"UTC+04:30"},{"timezone":"Asia/Tashkent","abbreviation":"YEKT","offset":"UTC+05:00"},{"timezone":"Asia/Tashkent","abbreviation":"PKT","offset":"UTC+05:00"},{"timezone":"Asia/Tashkent","abbreviation":"WAST","offset":"UTC+05:00"},{"timezone":"Asia/Calcutta","abbreviation":"IST","offset":"UTC+05:30"},{"timezone":"Asia/Calcutta","abbreviation":"SLT","offset":"UTC+05:30"},{"timezone":"Asia/Katmandu","abbreviation":"NPT","offset":"UTC+05:45"},{"timezone":"Asia/Dhaka","abbreviation":"BTT","offset":"UTC+06:00"},{"timezone":"Asia/Dhaka","abbreviation":"BST","offset":"UTC+06:00"},{"timezone":"Asia/Almaty","abbreviation":"NCAST","offset":"UTC+06:00"},{"timezone":"Asia/Rangoon","abbreviation":"MYST","offset":"UTC+06:30"},{"timezone":"Asia/Bangkok","abbreviation":"THA","offset":"UTC+07:00"},{"timezone":"Asia/Bangkok","abbreviation":"KRAT","offset":"UTC+07:00"},{"timezone":"Asia/Hong Kong","abbreviation":"","offset":"UTC+08:00"},{"timezone":"Asia/Irkutsk","abbreviation":"IRKT","offset":"UTC+08:00"},{"timezone":"Asia/Singapore","abbreviation":"SNST","offset":"UTC+08:00"},{"timezone":"Australia/Perth","abbreviation":"AWST","offset":"UTC+08:00"},{"timezone":"Asia/Taipei","abbreviation":"TIST","offset":"UTC+08:00"},{"timezone":"Asia/Taipei","abbreviation":"UST","offset":"UTC+08:00"},{"timezone":"Asia/Tokyo","abbreviation":"TST","offset":"UTC+09:00"},{"timezone":"Asia/Seoul","abbreviation":"KST","offset":"UTC+09:00"},{"timezone":"Asia/Yakutsk","abbreviation":"YAKT","offset":"UTC+09:00"},{"timezone":"Australia/Adelaide","abbreviation":"CAUST","offset":"UTC+09:30"},{"timezone":"Australia/Darwin","abbreviation":"ACST","offset":"UTC+09:30"},{"timezone":"Australia/Brisbane","abbreviation":"EAST","offset":"UTC+10:00"},{"timezone":"Australia/Sydney","abbreviation":"AEST","offset":"UTC+10:00"},{"timezone":"Pacific/Guam","abbreviation":"WPST","offset":"UTC+10:00"},{"timezone":"Australia/Hobart","abbreviation":"TAST","offset":"UTC+10:00"},{"timezone":"Asia/Vladivostok","abbreviation":"VLAT","offset":"UTC+10:00"},{"timezone":"Pacific/Guadalcanal","abbreviation":"SBT","offset":"UTC+11:00"},{"timezone":"Pacific/Auckland","abbreviation":"NZST","offset":"UTC+12:00"},{"timezone":"Etc/GMT-12","abbreviation":"UTC12","offset":"UTC+12:00"},{"timezone":"Pacific/Fiji","abbreviation":"FJT","offset":"UTC+12:00"},{"timezone":"Asia/Kamchatka","abbreviation":"PETT","offset":"UTC+12:00"},{"timezone":"Pacific/Tongatapu","abbreviation":"PHOT","offset":"UTC+13:00"},{"timezone":"Atlantic/Azores","abbreviation":"AZOST","offset":"UTC-01:00"},{"timezone":"Atlantic/Cape Verde","abbreviation":"CVT","offset":"UTC-01:00"},{"timezone":"America/Sao_Paulo","abbreviation":"ESAST","offset":"UTC-03:00"},{"timezone":"America/Buenos Aires","abbreviation":"ART","offset":"UTC-03:00"},{"timezone":"SA Eastern Standard Time","abbreviation":"SAEST","offset":"UTC-03:00"},{"timezone":"America/Godthab","abbreviation":"GNST","offset":"UTC-03:00"},{"timezone":"America/Godthab","abbreviation":"MVST","offset":"UTC-03:00"},{"timezone":"Canada/Newfoundland","abbreviation":"NST","offset":"UTC-03:30"},{"timezone":"Canada/Atlantic","abbreviation":"PRST","offset":"UTC-04:00"},{"timezone":"Canada/Atlantic","abbreviation":"CBST","offset":"UTC-04:00"},{"timezone":"America/Santiago","abbreviation":"SAWST","offset":"UTC-04:00"},{"timezone":"America/Santiago","abbreviation":"PSAST","offset":"UTC-04:00"},{"timezone":"America/Caracas","abbreviation":"VST","offset":"UTC-04:30"},{"timezone":"America/Bogota","abbreviation":"SAPST","offset":"UTC-05:00"},{"timezone":"US/East-Indiana","abbreviation":"EST","offset":"UTC-05:00"},{"timezone":"America/El_Salvador","abbreviation":"CAST","offset":"UTC-06:00"},{"timezone":"America/Mexico_City","abbreviation":"CST","offset":"UTC-06:00"},{"timezone":"Canada/Saskatchewan","abbreviation":"CCST","offset":"UTC-06:00"},{"timezone":"America/Chihuahua","abbreviation":"MSTM","offset":"UTC-07:00"},{"timezone":"US/Pacific","abbreviation":"PST","offset":"UTC-08:00"},{"timezone":"Pacific/Midway","abbreviation":"SMST","offset":"UTC-11:00"},{"timezone":"Etc/GMT+12","abbreviation":"BIT","offset":"UTC-12:00"}]

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var dateTag = '[object Date]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Date` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isDate(new Date);
	 * // => true
	 *
	 * _.isDate('Mon April 23 2012');
	 * // => false
	 */
	function isDate(value) {
	  return isObjectLike(value) && objectToString.call(value) == dateTag;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isDate;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(141);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos));
	            val = options.decoder(part.slice(pos + 1));
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function parseObjectRecursive(chain, val, options) {
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj;
	    if (root === '[]' && options.parseArrays) {
	        obj = [];
	        obj = obj.concat(parseObject(chain, val, options));
	    } else {
	        obj = options.plainObjects ? Object.create(null) : {};
	        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	        var index = parseInt(cleanRoot, 10);
	        if (!options.parseArrays && cleanRoot === '') {
	            obj = { 0: val };
	        } else if (
	            !isNaN(index)
	            && root !== cleanRoot
	            && String(index) === cleanRoot
	            && index >= 0
	            && (options.parseArrays && index <= options.arrayLimit)
	        ) {
	            obj = [];
	            obj[index] = parseObject(chain, val, options);
	        } else if (cleanRoot !== '__proto__') {
	            obj[cleanRoot] = parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts || {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(141);
	var formats = __webpack_require__(139);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (isArray(obj)) {
	            pushToArray(values, stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            pushToArray(values, stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts || {};
	
	    if (options.encoder !== null && typeof options.encoder !== 'undefined' && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    return keys.join(delimiter);
	};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports.types = {
	  "checkbox": __webpack_require__(426),
	  "combo": __webpack_require__(427),
	  "date": __webpack_require__(431),
	  "file": __webpack_require__(433),
	  "initial": __webpack_require__(434),
	  "select": __webpack_require__(97),
	  "static": __webpack_require__(436),
	  "USD": __webpack_require__(438),
	  "text": __webpack_require__(144),
	  "textarea": __webpack_require__(437)
	};
	
	module.exports.install = function(InputTypes){
	  Object.keys(module.exports.types).forEach(function(type){
	    InputTypes.setInputType(type, module.exports.types[type]);
	  });
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	var component = dd.createClass({
	  __onChange: function(e){
	    this.props.onChange(!!e.target.checked);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    return dd.label({style: {fontWeight: 'normal'}},
	      dd.input({
	        type: 'checkbox',
	        checked: !!value,
	        name: field.name,
	        onChange: this.__onChange,
	        disabled: (field.read_only || field.disabled) ? 'disabled' : null
	      }),
	      ' ',
	      field.label
	    );
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function(){
	    return true;//can't go wrong with a checkbox
	  }
	};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var HoverMixin = __webpack_require__(143);
	
	var component = dd.createClass({
	  mixins: [HoverMixin],
	  __onChange: function(e){
	    this.props.onChange(e.target.value);
	  },
	  getInitialState: function(){
	    return {dd_open: false};
	  },
	  __toggleDropDown: function(e){
	    e.preventDefault();
	    e.stopPropagation();
	    this.setState({dd_open: !this.state.dd_open});
	  },
	  hoverable_onUserLeftHoverable: function(){
	    if(this.state.dd_open){//only setState if needed
	      this.setState({dd_open: false});
	    }
	  },
	  __itemSelected: function(value){
	    var self = this;
	    return function(e){
	      e.preventDefault();
	      e.stopPropagation();
	      if(_.isFunction(self.props.onSelectTransform)){
	        value = self.props.onSelectTransform(value);
	      }
	      self.setState({dd_open: false});
	      self.props.onChange(value);
	    };
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    if(field.read_only){
	      return dd.p({className: "form-control-static"},
	        _.has(field.options, value) ? field.options[value] : value
	      );
	    }
	
	    var type_in = dd.input({
	      type: "text",
	      name: field.name,
	      value: value || "",
	      onChange: this.__onChange,
	      className: "form-control",
	      placeholder: field.placeholder || null
	    });
	    if(_.isEmpty(field.options)){
	      return type_in;
	    }
	    return dd.div({className: "input-group"},
	      type_in,
	      dd.span({
	          className: "input-group-btn" + (this.state.dd_open ? " open" : ""),
	          onMouseEnter: this.hoverable_onMouseEnter,
	          onMouseLeave: this.hoverable_onMouseLeave
	        },
	        dd.button({className: "btn btn-default", onClick: this.__toggleDropDown},
	          dd.span({className: "caret"})
	        ),
	        dd.ul({className: "dropdown-menu pull-right", style: {overflowY: "auto", maxHeight: 150}},
	          _.map(field.options, function(name, val){
	            return dd.li({key: val}, dd.a({href: "#", onClick: this.__itemSelected(val)}, name));
	          }, this)
	        )
	      )
	    );
	  }
	});
	
	module.exports = {
	  component: component
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(60);
	var wrapPreventDefault = __webpack_require__(96);
	
	var getMonthName = function(month_input, use_short){
	  var month = parseInt(month_input);
	  if(!_.isNumber(month) || _.isNaN(month)){
	    return month_input;
	  }
	  month = (month - 1) % 12;
	  month = month < 0 ? 12 + month : month;
	  return _.isNumber(month) ? dateFormat.i18n.monthNames[!use_short ? month + 12 : month] : month;
	};
	
	var getDayOfWeek = function(day_input, use_short){
	  var day = parseInt(day_input);
	  if(!_.isNumber(day) || _.isNaN(day)){
	    return day_input;
	  }
	  day = (day - 1) % 7;
	  day = day < 0 ? 7 + day : day;
	  return dateFormat.i18n.dayNames[!use_short ? day + 7 : day];
	};
	
	var getNDaysInMonth = function(year, month){
	  return [31, ((((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	};
	
	var buildCalendarWeeks = function(year, month, must_be_six_weeks){
	  var d = new Date(year, month - 1, 1, 0, 0, 0, 0);
	  var daysInPrevMonth = d.getMonth() === 0 ? getNDaysInMonth(d.getFullYear() - 1, 11) : getNDaysInMonth(d.getFullYear(), d.getMonth() - 1);
	  var daysInThisMonth = getNDaysInMonth(d.getFullYear(), d.getMonth());
	  var dayOfWeekStartsOn = d.getDay();
	  var dateI = 1;
	  var i;
	  var weeks = [];
	
	  var curWeek = [];
	  for(i = 0; i < dayOfWeekStartsOn; i++){
	    curWeek.push({date: daysInPrevMonth - (dayOfWeekStartsOn - i) + 1, out_of_month: true});
	  }
	  while(dateI <= daysInThisMonth){
	    if(curWeek.length === 7){
	      weeks.push(curWeek);
	      curWeek = [];
	    }
	    curWeek.push({date: dateI});
	    dateI++;
	  }
	  if(curWeek.length > 0){
	    var daysToAdd = 7 - curWeek.length;
	    for(i = 0; i < daysToAdd; i++){
	      curWeek.push({date: i + 1, out_of_month: true});
	    }
	    weeks.push(curWeek);
	    if(must_be_six_weeks){
	      while(weeks.length < 6){
	        curWeek = [];
	        var j;
	        for(j = 0; j < 7; j++){
	          curWeek.push({date: i + 1, out_of_month: true});
	          i++;
	        }
	        weeks.push(curWeek);
	      }
	    }
	  }
	  return weeks;
	};
	
	module.exports = dd.createClass({
	  getInitialState: function(){
	    var today = new Date();
	    if(_.isDate(this.props.value)){
	      today = this.props.value;
	    }else{
	      var field = this.props.field;
	      var start = _.isDate(field.valid_range && field.valid_range.start) ? field.valid_range.start : null;
	      var stop = _.isDate(field.valid_range && field.valid_range.stop) ? field.valid_range.stop : null;
	      if(start && ((start.getFullYear() > today.getFullYear()) || (start.getMonth() > today.getMonth()))){
	        today = start;
	      }else if(stop && ((stop.getFullYear() < today.getFullYear()) || (stop.getMonth() < today.getMonth()))){
	        today = stop;
	      }
	    }
	    return {
	      year: today.getFullYear(),
	      month: today.getMonth() + 1
	    };
	  },
	  __incMonth: function(inc){
	    var year = this.state.year;
	    var month = this.state.month;
	    var d = new Date(year, month - 1, 1);
	    d.setMonth(d.getMonth() + inc);
	    this.setState({year: d.getFullYear(), month: d.getMonth() + 1});
	  },
	  __nextMonth: wrapPreventDefault(function(){
	    this.__incMonth(1);
	  }),
	  __prevMonth: wrapPreventDefault(function(){
	    this.__incMonth(-1);
	  }),
	  __onDayClick: function(day){
	    var self = this;
	    return wrapPreventDefault(function(){
	      var year = self.state.year;
	      var month = self.state.month;
	      self.props.onDatePicked(year, month, day);
	    });
	  },
	  render: function(){
	    var self = this;
	    var field = self.props.field;
	    var year = self.state.year;
	    var month = self.state.month;
	    var selected_day = getDayIfMatches(self.props.value, month, year);
	
	    var start_day = getDayIfMatches(field.valid_range && field.valid_range.start, month, year);
	    var stop_day = getDayIfMatches(field.valid_range && field.valid_range.stop, month, year);
	
	    var weeks = buildCalendarWeeks(year, month, true);
	    return dd.div({className: 'DatePickerCalendar'},
	      dd.table(null,
	        dd.thead(null,
	          dd.tr(null,
	            dd.th({colSpan: 7, className: 'month'},
	              start_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-left', onClick: this.__prevMonth},
	                dd.i({className: 'react-loose-forms-bs3-date-icon react-loose-forms-bs3-date-icon-angle-left'})
	              ),
	              getMonthName(month) + ' ' + year,
	              stop_day > 0 ? null : dd.button({className: 'btn btn-default btn-sm pull-right', onClick: this.__nextMonth},
	                dd.i({className: 'react-loose-forms-bs3-date-icon react-loose-forms-bs3-date-icon-angle-right'})
	              )
	            )
	          ),
	          dd.tr(null,
	            _.map([1, 2, 3, 4, 5, 6, 7], function(d){
	              return dd.th({key: d, className: 'dow'}, getDayOfWeek(d, true));
	            })
	          )
	        ),
	        dd.tbody(null,
	          _.map(weeks, function(week, i){
	            return dd.tr({key: i},
	              _.map(week, function(day, i){
	                var classes = [];
	                var onClick = null;
	                if(day.out_of_month || day.date < start_day || (stop_day > 0 && day.date > stop_day)){
	                  classes.push('out');
	                }else{
	                  classes.push('clickable');
	                  onClick = self.__onDayClick(day.date);
	                  if(day.date == selected_day){
	                    classes.push('selected');
	                  }
	                }
	                return dd.td({key: i},
	                  dd.span({className: classes.join(' '), onClick: onClick}, day.date)
	                );
	              })
	            );
	          })
	        )
	      )
	    );
	  }
	});
	
	
	var getDayIfMatches = function(date, month, year){
	  if(_.isDate(date)){
	    if(date.getFullYear() === year && date.getMonth() + 1 === month){
	      return date.getDate();
	    }
	  }
	  return -1;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(60);
	
	var time_placeholder = 'hh:mm am/pm';
	
	var isDateValid = function(d){
	  return _.isDate(d) && !_.isNaN(d.getTime());
	};
	
	var hashDate = function(d){
	  return isDateValid(d) ? d.toISOString() : null;
	};
	
	var formatDate = function(value, pick_date, pick_time){
	  var format_parts = [];
	  if(pick_date){
	    format_parts.push('mm/dd/yyyy');
	  }
	  var extra_append = '';
	  if(pick_time){
	    if(isDateValid(value) && value.getHours() === 0 && value.getMinutes() === 0){
	      if(pick_date){
	        //provide hint that there is a place to enter the time
	        extra_append += ' - ' + time_placeholder;
	      }else{
	        //let the placeholder take over
	      }
	    }else{
	      format_parts.push('- h:MM TT');
	    }
	  }
	  return isDateValid(value)
	    ? dateFormat(value, format_parts.join(' ')) + extra_append
	    : '';
	};
	
	module.exports = dd.createClass({
	  getInitialState: function(){
	    return {
	      text_value: formatDate(this.props.value, this.props.pick_date, this.props.pick_time),
	      is_text_invalid: false,
	      last_prop_value: hashDate(this.props.value)
	    };
	  },
	  componentWillReceiveProps: function(props){
	    var value = props.value;
	    var pick_date = props.pick_date;
	    var pick_time = props.pick_time;
	
	    if(this.state.last_prop_value !== hashDate(value)){
	      this.setState({
	        text_value: formatDate(value, pick_date, pick_time),
	        is_text_invalid: !!(this.state.is_text_invalid && _.isNull(value)),//set it false if it's a real value now
	        last_prop_value: hashDate(value)
	      });
	    }
	  },
	  __onChange: function(e){
	    var input = e.target.value;
	    this.setState({text_value: input});
	    this.__debouncedChange();
	  },
	  __debouncedChange: _.debounce(function(){
	    this.__parseInputToDate();
	  }, 3 * 1000),
	  __onBlur: function(e){
	    this.__parseInputToDate();
	  },
	  componentWillMount: function(){
	    var self = this;
	
	    self.__parseInputToDate = (function(){
	      var last_input_checked = "";
	
	      return function(){
	        var text_value = self.state.text_value;
	        if(last_input_checked === text_value){
	          return;//already checked this
	        }
	        last_input_checked = text_value;
	        var d = new Date(text_value);
	
	        //try different formats
	        if(!isDateValid(d)){
	          d = new Date(text_value.replace(/\-/g, " "));
	        }
	        if(!isDateValid(d)){
	          d = new Date(text_value.replace(/am\/pm/i, " ").replace(/\-/g, " ").replace(/m|h/g, "0"));
	        }
	
	        //final verdict if it's valid or not
	        if(isDateValid(d)){
	          self.props.onDateSet(d);
	        }else{
	          self.props.onDateSet(null);
	          self.setState({is_text_invalid: true, text_value: ''});
	
	          //auto hide the message
	          setTimeout(function(){
	            if(self.state.is_text_invalid){
	              self.setState({is_text_invalid: false});
	            }
	          }, 3 * 1000);
	        }
	      };
	    }());
	  },
	  render: function(){
	    var pick_date = this.props.pick_date;
	    var pick_time = this.props.pick_time;
	    var placeholder = this.props.placeholder;
	
	    var text_value = this.state.text_value;
	    var is_text_invalid = this.state.is_text_invalid;
	
	    var placeholder_parts = [];
	    if(pick_date){
	      placeholder_parts.push('mm/dd/yyyy');
	    }
	    if(pick_time){
	      placeholder_parts.push(time_placeholder);
	    }
	    return dd.span({className: is_text_invalid ? 'has-error' : null},
	      dd.input({
	        type: 'text',
	        className: 'form-control',
	        placeholder: placeholder || placeholder_parts.join(' - '),
	        value: text_value,
	        onChange: this.__onChange,
	        onBlur: this.__onBlur
	      }),
	      is_text_invalid ? dd.div({className: 'popover bottom', ref: 'popover', style: {
	          display: 'block',
	          top: 28,
	
	          //normalizing styles (so parent font styling doesn't mess with this)
	          fontSize: 14,
	          color: 'black',
	          textAlign: 'left',
	          fontWeight: 'normal'
	        }},
	        dd.div({className: 'arrow'}),
	        dd.div({className: 'popover-content'},
	          'Try again using the suggested format, or use the buttons to the right'
	        )
	      ) : null
	    );
	  }
	});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(60);
	var wrapPreventDefault = __webpack_require__(96);
	
	var icon_prefix = 'react-loose-forms-bs3-date-icon';
	var icon_classes = {
	  angle_up: icon_prefix + ' ' + icon_prefix + '-angle-up',
	  angle_down: icon_prefix + ' ' + icon_prefix + '-angle-down'
	};
	
	var TypeIn = dd.createClass({
	  getInitialState: function(){
	    return {text_value: this.props.value};
	  },
	  componentWillReceiveProps: function(next_props){
	    if(this.props.value !== next_props.value){
	      this.setState({text_value: next_props.value});
	    }
	  },
	  __onChange: function(e){
	    this.setState({text_value: e.target.value});
	  },
	  __onBlur: function(){
	    this.props.onValue(this.state.text_value);
	  },
	  __onKeyUp: function(e){
	    if(e.keyCode == 13){//enter key
	      e.preventDefault();
	      this.props.onValue(this.state.text_value);
	    }
	  },
	  render: function(){
	    return dd.input({
	      type: 'text',
	      className: 'form-control input-sm',
	      placeholder: this.props.placeholder,
	      maxLength: 2,
	      value: this.state.text_value,
	      onBlur: this.__onBlur,
	      onKeyUp: this.__onKeyUp,
	      onChange: this.__onChange
	    });
	  }
	});
	
	module.exports = dd.createClass({
	  __changeTime: function(doChange){
	    var onTimeChanged = this.props.onTimeChanged;
	    var d = _.isDate(this.props.value)
	      ? _.cloneDeep(this.props.value)
	      : new Date(0, -1, 0, 0, 0, 0, 0);
	
	    //save these so we ensure adding a bunch of hours doesn't change the day
	    var year = d.getFullYear();
	    var month = d.getMonth();
	    var day = d.getDate();
	
	    var changes = doChange(d.getHours(), d.getMinutes());
	    if(_.isNumber(changes.hour) && !_.isNaN(changes.hour)){
	      d.setHours(changes.hour);
	    }
	    if(_.isNumber(changes.minute) && !_.isNaN(changes.minute)){
	      d.setMinutes(changes.minute);
	    }
	    d.setFullYear(year);
	    d.setMonth(month);
	    d.setDate(day);
	
	    onTimeChanged(d.getHours(), d.getMinutes());
	  },
	  __increment: function(field, inc){
	    var self = this;
	    return wrapPreventDefault(function(){
	      self.__changeTime(function(hour, minute){
	        if(field === 'hour'){
	          return {hour: hour + inc};
	        }else if(field === 'min'){
	          return {minute: minute + inc};
	        }
	      });
	    });
	  },
	  __onTypeHour: function(str){
	    var new_hour = _.parseInt(str.replace(/[^[0-9]]/g, ""), 10) || 0;
	    this.__changeTime(function(){
	      return {hour: new_hour};
	    });
	  },
	  __onTypeMinutes: function(str){
	    var new_minute = _.parseInt(str.replace(/[^[0-9]]/g, ""), 10) || 0;
	    this.__changeTime(function(){
	      return {minute: new_minute};
	    });
	  },
	  __onTypeAMPM: function(ampm){
	    this.__changeTime(function(hour){
	      var inc = 0;
	      if(/am/i.test(ampm)){
	        inc += hour < 12 ? 0 : 12;
	      }else if(/pm/i.test(ampm)){
	        inc += hour < 12 ? 12 : 0;
	      }
	      return {hour: hour + inc};
	    });
	  },
	  render: function(){
	    var self = this;
	    var value = _.isDate(this.props.value) ? this.props.value : null;
	
	    var hours = value ? dateFormat(value, 'h') : '';
	    var minutes = value ? dateFormat(value, 'MM') : '';
	    var ampm = value ? dateFormat(value, 'TT') : '';
	
	    var incBtn = function(field, inc){
	      var onClick = self.__increment(field, inc);
	      return dd.button({className: 'btn btn-default', onClick: onClick},
	        dd.i({
	          className: inc > 0 ? icon_classes.angle_up : icon_classes.angle_down
	        })
	      );
	    };
	
	    return dd.div({className: 'TimePicker'},
	      dd.table(null,
	        dd.tbody(null,
	          dd.tr(null,
	            dd.td(null, incBtn('hour', 1)),
	            dd.td(),
	            dd.td(null, incBtn('min', 5)),
	            dd.td(),
	            dd.td(null, incBtn('hour', 12))
	          ),
	          dd.tr(null,
	            dd.td(null, TypeIn({
	              placeholder: 'HH',
	              value: hours,
	              onValue: this.__onTypeHour
	            })),
	            dd.td(null, ' : '),
	            dd.td(null, TypeIn({
	              placeholder: 'MM',
	              value: minutes,
	              onValue: this.__onTypeMinutes
	            })),
	            dd.td(null, ' : '),
	            dd.td(null, TypeIn({
	              placeholder: 'AM/PM',
	              value: ampm,
	              onValue: this.__onTypeAMPM
	            }))
	          ),
	          dd.tr(null,
	            dd.td(null, incBtn('hour', -1)),
	            dd.td(),
	            dd.td(null, incBtn('min', -5)),
	            dd.td(),
	            dd.td(null, incBtn('hour', -12))
	          )
	        )
	      )
	    );
	  }
	});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(60);
	var HoverMixin = __webpack_require__(143);
	var wrapPreventDefault = __webpack_require__(96);
	
	__webpack_require__(432);
	var DatePickerCalendar = __webpack_require__(428);
	var DateTypeIn = __webpack_require__(429);
	var TimePicker = __webpack_require__(430);
	
	var component = dd.createClass({
	  mixins: [HoverMixin],
	  __onChange: function(date){
	    this.props.onChange(_.isDate(date) ? date : null);
	  },
	
	  ////////////////////////////////////////////////////////////////////////
	  getInitialState: function(){
	    return {show_calendar: false, show_timepicker: false};
	  },
	  __toggleCalendar: wrapPreventDefault(function(){
	    this.setState({show_calendar: !this.state.show_calendar, show_timepicker: false});
	  }),
	  __toggleTimepicker: wrapPreventDefault(function(){
	    this.setState({show_calendar: false, show_timepicker: !this.state.show_timepicker});
	  }),
	  __onDatePicked: function(year, month, day){
	    var d = _.isDate(this.props.value) ? _.cloneDeep(this.props.value) : new Date(0, -1, 0, 0, 0, 0, 0);
	    d.setFullYear(year);
	    d.setMonth(month - 1, day);//You must set the date in setMonth b/c otherwise they will mess with each other in surprising ways (what the heck javascript!)
	    this.__onChange(d);
	    this.setState({show_calendar: false});
	  },
	  __onTimeChanged: function(hours, minute){
	    var d = _.isDate(this.props.value) ? _.cloneDeep(this.props.value) : new Date();
	    d.setHours(hours);
	    d.setMinutes(minute);
	    this.__onChange(d);
	  },
	  __onDateSet: function(new_date){
	    this.__onChange(_.cloneDeep(new_date));
	  },
	  hoverable_onUserLeftHoverable: function(){
	    if(this.state.show_calendar || this.state.show_timepicker){//only setState if needed
	      this.setState({show_calendar: false, show_timepicker: false});
	    }
	  },
	  __stopClick: wrapPreventDefault(_.noop),
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	    var show_calendar = this.state.show_calendar;
	    var show_timepicker = this.state.show_timepicker;
	
	    var pick_date = _.has(field, 'pick_date') ? !!field.pick_date : true;//by default be a date picker
	    var pick_time = !!field.pick_time;//by default don't pick time
	
	    if(field.read_only){
	      var format_parts = [];
	      if(pick_date){
	        format_parts.push('mm/dd/yyyy');
	      }
	      if(pick_time){
	        if(_.isDate(value) && value.getHours() === 0 && value.getMinutes() === 0){
	        }else{
	          format_parts.push('- h:MM TT');
	        }
	      }
	      return dd.p({className: 'form-control-static'},
	        _.isDate(value) ? dateFormat(value, format_parts.join(' ')) : ''
	      );
	    }
	
	    return dd.div({
	        className: 'react-loose-forms-bs3-date input-group',
	        onClick: this.__toggleCalendar,
	        onMouseEnter: this.hoverable_onMouseEnter,
	        onMouseLeave: this.hoverable_onMouseLeave
	      },
	      DateTypeIn({pick_date: pick_date, pick_time: pick_time, value: value, onDateSet: this.__onDateSet, placeholder: field.placeholder}),
	      dd.span({
	          className: 'input-group-btn'
	            + (show_calendar || show_timepicker ? ' open' : '')
	            + (field.dropup ? ' dropup' : ''),
	          style: {verticalAlign: 'top'}
	        },
	        pick_date ? dd.button({type: 'button', className: 'btn btn-default', onClick: this.__toggleCalendar},
	          dd.i({className: 'react-loose-forms-bs3-date-icon react-loose-forms-bs3-date-icon-calendar'})
	        ) : null,
	        pick_time ? dd.button({type: 'button', className: 'btn btn-default', onClick: this.__toggleTimepicker},
	          dd.i({className: 'react-loose-forms-bs3-date-icon react-loose-forms-bs3-date-icon-clock'})
	        ) : null,
	        show_calendar || show_timepicker ? dd.div({
	            className: 'dropdown-menu pull-right',
	            onClick: this.__stopClick
	          },
	          show_calendar ? DatePickerCalendar({field: field, value: value, onDatePicked: this.__onDatePicked}) : null,
	          show_timepicker ? TimePicker({field: field, value: value, onTimeChanged: this.__onTimeChanged}) : null
	        ) : null
	      )
	    );
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function(value){
	    if(!_.isDate(value)){
	      return 'Please enter your date';
	    }
	    return true;
	  }
	};


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})("@font-face{font-family:react-loose-forms-bs3-date-icon;src:url(data:application/octet-stream;base64,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)format('woff'),url(data:application/octet-stream;base64,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)format('truetype')}.react-loose-forms-bs3-date-icon{position:relative;top:1px;display:inline-block;font-family:react-loose-forms-bs3-date-icon;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.react-loose-forms-bs3-date-icon-angle-left:before{content:'\\3c'}.react-loose-forms-bs3-date-icon-angle-right:before{content:'\\3e'}.react-loose-forms-bs3-date-icon-calendar:before{content:'\\44'}.react-loose-forms-bs3-date-icon-clock:before{content:'\\54'}.react-loose-forms-bs3-date-icon-angle-up:before{content:'\\5e'}.react-loose-forms-bs3-date-icon-angle-down:before{content:'\\76'}.react-loose-forms-bs3-date .DatePickerCalendar{display:block;background-color:#FFF;padding:2px}.react-loose-forms-bs3-date .DatePickerCalendar table th{padding:3px 7.5px}.react-loose-forms-bs3-date .DatePickerCalendar table th.month{font-size:12px;line-height:20px;text-align:center}.react-loose-forms-bs3-date .DatePickerCalendar table th.month .btn{padding:0 10px}.react-loose-forms-bs3-date .DatePickerCalendar table th.dow{font-size:11px;padding:3px 1px;text-align:center}.react-loose-forms-bs3-date .DatePickerCalendar table td{padding:1px;text-align:center;position:relative}.react-loose-forms-bs3-date .DatePickerCalendar table td span{border-radius:2px;-moz-border-radius:2px;-webkit-border-radius:2px;display:block;font-size:10px;padding:2px 5.5px}.react-loose-forms-bs3-date .DatePickerCalendar table td span.out{color:#9e97a6}.react-loose-forms-bs3-date .DatePickerCalendar table td span.clickable:hover{cursor:pointer}.react-loose-forms-bs3-date .DatePickerCalendar table td span.clickable:hover:hover{background-color:#EEE}.react-loose-forms-bs3-date .DatePickerCalendar table td span.selected{background-color:#A4D5FF}.react-loose-forms-bs3-date .TimePicker{padding:0 5px}.react-loose-forms-bs3-date .TimePicker table{width:100%}.react-loose-forms-bs3-date .TimePicker table tbody>tr>td .btn{width:100%;padding-top:2px;padding-bottom:2px}.react-loose-forms-bs3-date .TimePicker table tbody>tr>td .form-control{margin:0!important;width:100%!important;text-align:center}");

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	var component = dd.createClass({
	  __onChange: function(e){
	    this.props.onChange(e.target.files);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    if(typeof FileList === 'undefined'){
	      return dd.p({className: 'form-control-static text-danger'},
	        'Your browser is outdated and will not work with this file upload.'
	      );
	    }
	    if(field.read_only){
	      return dd.p({className: 'form-control-static'},
	        value
	      );
	    }
	    return dd.input({
	      type: 'file',
	      disabled: field.disabled ? "disabled" : null,
	      name: field.name,
	      className: 'form-control',
	      style: {border: 0, boxShadow: 'none', paddingLeft: 0, paddingRight: 0},
	      onChange: this.__onChange,
	      multiple: field.multiple === true ? true : false
	    });
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function(value){
	    return ((value instanceof FileList) && value.length === 1) || 'You must select a file to upload';
	  }
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var dateFormat = __webpack_require__(60);
	
	__webpack_require__(435);
	
	var component = dd.createClass({
	  __onChange: function(e){
	    this.props.onChange(e.target.value);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    var initial_date = field.initial_date ? field.initial_date : dateFormat(new Date(), "m/dd/yyyy");
	    var initial_name = field.initial_name ? field.initial_name : "Name";
	
	    return (
	        dd.div(
	            {className: "signature-group row"},
	            dd.div({className: "col-xs-5 col-sm-5 signature-input-holder"},
	                dd.div({className: "input"}, initial_name),
	                dd.span({className: "help-block"}, "Name")
	            ),
	            dd.div({className: "col-xs-3 col-sm-2 signature-input-holder"},
	                dd.div(null,
	                    dd.input({
	                        name: field.name,
	                        disabled: field.disabled ? "disabled" : null,
	                        type: field.type || 'text',
	                        value: value || '',
	                        placeholder: field.placeholder || null,
	                        className: 'form-control',
	                        autoFocus: field.autofocus || false,
	                        onChange: this.__onChange
	                    })
	                ),
	                dd.span({className: "help-block"}, "Initials")
	            ),
	            dd.div({className: "col-xs-4 col-sm-5 signature-input-holder"},
	                dd.div({className: "input"},
	                    initial_date
	                ),
	                dd.span({className: "help-block"}, "Date")
	            )
	            // ),
	            // dd.div({className: "clearfix"})
	        )
	    );
	  }
	});
	
	module.exports = {
	  component: component,
	  validate: function(value){
	    if(_.isString(value) && str.trim().length == 0){
	        return 'Please enter your initials';
	    }
	    return true;
	  }
	};


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})(".signature-group{.signature-input-holder{text-align: center;font-size: 1em;color: #737373;.input {font-size: 1em;border-bottom: 1px solid #000000;line-height: 35px;color: #000000;}input.form-control {font-size: 1em;line-height: 36px;margin-bottom: 2px;}}}");

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	
	module.exports = {
	  component: dd.createClass({
	    render: function(){
	      var field = this.props.field;
	      var value = this.props.value;
	
	      return dd.p({className: 'form-control-static'},
	        field.options && _.has(field.options, value) ? field.options[value] : value
	      );
	    }
	  }),
	  validate: function(){
	    return true;
	  }
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	
	var component = dd.createClass({
	  __onChange: function(e){
	  	this.props.onChange(e.target.value);
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	
	    if(field.read_only){
	      return dd.p({className: 'form-control-static', style: {whiteSpace: 'pre-wrap'}},
	        value
	      );
	    }
	
	    return dd.textarea({
	      rows: field.rows > 0 ? field.rows : 3,
	      disabled: field.disabled ? "disabled" : null,
	      placeholder: field.placeholder || null,
	      className: 'form-control',
	      value: value || '',
	      name: field.name,
	      onChange: this.__onChange
	    });
	  }
	});
	
	module.exports = {
	  component: component
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	
	var strToNum = function(s){
	  return parseFloat(s.replace(/[^0-9.]/g, "")) || 0;
	};
	
	var numToStr = function(n){
	  if(!_.isNumber(n) || _.isNaN(n)){
	    return '0';
	  }
	  return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	
	var propVToText = function(v){
	  return _.isNumber(v) && !_.isNaN(v) && v !== 0
	    ? numToStr(v)
	    : ""
	};
	
	var component = dd.createClass({
	  getInitialState: function(){
	    return {text: propVToText(this.props.value)};
	  },
	  componentWillReceiveProps: function(next){
	    if(this.props.value !== next.value){
	      this.setState({text: propVToText(next.value)});
	    }
	  },
	  __onChange: function(e){
	    this.setState({text: e.target.value});
	  },
	  __onBlur: function(e){
	    this.props.onChange(strToNum(e.target.value));
	  },
	  render: function(){
	    var field = this.props.field;
	    var value = this.props.value;
	    var text = this.state.text;
	
	    if(field.read_only){
	      return dd.p({className: 'form-control-static'},
	        text
	      );
	    }
	
	    var p = {
	      name: field.name,
	      disabled: field.disabled ? "disabled" : null,
	      type: 'text',
	      value: text,
	      placeholder: field.placeholder || null,
	      className: 'form-control',
	      autoFocus: field.autofocus || false,
	      onBlur: this.__onBlur,
	      onChange: this.__onChange
	    };
	    return dd.div({className: 'input-group'},
	        dd.span({className: 'input-group-addon'}, '$ USD'),
	        dd.input(p)
	    );
	  }
	});
	
	module.exports = {
	  component: component
	};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

	(function(e){if("undefined"!=typeof document){var t=document;if(t.less_to_js__inserted=t.less_to_js__inserted||{},!t.less_to_js__inserted[e]){t.less_to_js__inserted[e]=!0;var s=t.createElement("style");s.setAttribute("type","text/css"),"textContent"in s?s.textContent=e:s.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(s)}}}("@font-face{font-family:'react-bootstrap3-tooltip-icon';src:url('data:application/octet-stream;base64,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') format('woff'),url('data:application/octet-stream;base64,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') format('truetype')}.react-bootstrap3-tooltip-icon{position:relative;top:1px;display:inline-block;font-family:'react-bootstrap3-tooltip-icon';font-style:normal;font-weight:normal;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.react-bootstrap3-tooltip-icon-help-circled:before{content:'\\3f'}"));

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var HelpTooltip = __webpack_require__(145);
	
	module.exports = dd.createClass({
	  propTypes: {
	    field: React.PropTypes.object.isRequired,
	    error: React.PropTypes.string,
	    buildInput: React.PropTypes.func.isRequired,
	
	    scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
	    label_size: React.PropTypes.number,
	    input_size: React.PropTypes.number
	  },
	  render: function(){
	    var field = this.props.field;
	    var error = this.props.error;
	    var buildInput = this.props.buildInput;
	
	    var scale = this.props.scale || 'sm';
	    var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
	    var input_size = this.props.input_size || (12 - label_size);
	
	    var field_label = field.label || field.name;
	    var tooltip = field.tooltip ? HelpTooltip({title: field_label, content: field.tooltip}) : null;
	
	    return dd.div({className: 'HorizontalField ' + (error ? ' has-error' : '')},
	      dd.label({className: 'control-label col-' + scale + '-' + label_size},
	        field.type == 'checkbox' ? null : field_label + ' ',
	        field.type !== 'checkbox' ? tooltip : null
	      ),
	      dd.div({className: ' col-' + scale + '-' + input_size},
	        buildInput(field),
	        field.type == 'checkbox' ? ' ' : null,
	        field.type == 'checkbox' ? tooltip : null,
	        error ? dd.span({className: 'help-block'}, error) : null,
	        field.help_text ? dd.span({className: 'help-block'}, field.help_text) : null
	      )
	    );
	  }
	});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var HorizontalField = __webpack_require__(440);
	
	module.exports = dd.createClass({
	  propTypes: {
	    fields: React.PropTypes.object.isRequired,
	    errors: React.PropTypes.object.isRequired,
	    buildInput: React.PropTypes.func.isRequired,
	
	    scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
	    label_size: React.PropTypes.number,
	    input_size: React.PropTypes.number
	  },
	  render: function(){
	    var fields = this.props.fields;
	    var errors = this.props.errors;
	    var buildInput = this.props.buildInput;
	
	    var scale = this.props.scale || 'sm';
	    var label_size = _.isNumber(this.props.label_size) ? this.props.label_size : 3;
	    var input_size = this.props.input_size || (12 - label_size);
	
	    var layout = this.props.layout;
	    if(!layout || !_.isArray(layout)){
	      layout = _.map(fields, function(f, name){
	        return [name];
	      });
	    }
	
	    return dd.div({className: 'HorizontalFields'},
	      _.map(layout, function(row, i){
	        return dd.div({key: i, className: 'form-group'},
	          _.map(row, function(name, j){
	            return _.has(fields, name) ? HorizontalField({
	              key: j,
	              field: fields[name],
	              error: errors[name],
	              buildInput: buildInput,
	
	              scale: scale,
	              label_size: label_size,
	              input_size: row.length > 1 ? (input_size - label_size) / 2 : input_size
	            }) : null;
	          })
	        );
	      })
	    );
	  }
	});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var HelpTooltip = __webpack_require__(145);
	
	module.exports = dd.createClass({
	  propTypes: {
	    field: React.PropTypes.object.isRequired,
	    error: React.PropTypes.string,
	    buildInput: React.PropTypes.func.isRequired
	  },
	  render: function(){
	    var field = this.props.field;
	    var error = this.props.error;
	    var buildInput = this.props.buildInput;
	
	    var field_label = field.label || field.name;
	    var tooltip = field.tooltip ? HelpTooltip({title: field_label, content: field.tooltip}) : null;
	
	    return dd.div({className: 'VerticalField form-group ' + (error ? ' has-error' : '')},
	      field.type !== 'checkbox' && !!(tooltip || field.label) ? dd.label({className: 'control-label'},
	        field_label + ' ', tooltip
	      ) : null,
	      buildInput(field),
	      field.type == 'checkbox' ? ' ' : null,
	      field.type == 'checkbox' ? tooltip : null,
	      error ? dd.span({className: 'help-block'}, error) : null,
	      field.help_text ? dd.span({className: 'help-block'}, field.help_text) : null
	    );
	  }
	});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(26);
	var dd = __webpack_require__(7);
	var React = __webpack_require__(29);
	var VerticalField = __webpack_require__(442);
	
	//read why vertical alignment of fields and labels is the best form layout
	//http://www.uxmatters.com/mt/archives/2006/07/label-placement-in-forms.php
	
	module.exports = dd.createClass({
	  propTypes: {
	    fields: React.PropTypes.object.isRequired,
	    errors: React.PropTypes.object.isRequired,
	    buildInput: React.PropTypes.func.isRequired,
	
	    scale: React.PropTypes.oneOf(['sm', 'md', 'lg']),
	    layout: React.PropTypes.array
	  },
	  render: function(){
	    var fields = this.props.fields;
	    var errors = this.props.errors;
	    var buildInput = this.props.buildInput;
	
	    var scale = this.props.scale || 'sm';
	    var layout = this.props.layout;
	    if(!layout || !_.isArray(layout)){
	      layout = _.map(fields, function(f, name){
	        return [name];
	      });
	    }
	
	    return dd.div({className: 'VerticalFields'},
	      _.map(layout, function(row, i){
	        if(!_.isArray(row) || row.length === 0 || row.length > 12){
	          return dd.div({key: i});
	        }
	        var col_size = Math.floor(12 / row.length);
	
	        return dd.div({key: i, className: 'row'},
	          _.map(row, function(name, i){
	            return dd.div({key: i, className: 'col-' + scale + '-' + col_size},
	              _.has(fields, name) ? VerticalField({
	                field: fields[name],
	                error: errors[name],
	                buildInput: buildInput
	              }) : null
	            );
	          })
	        );
	      })
	    );
	  }
	});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var is = __webpack_require__(420);
	var clone = __webpack_require__(392);
	var xtend = __webpack_require__(506);
	var InputTypes = __webpack_require__(146);
	
	var FormMixin = {
		getInitialState: function(){
			return {
				initial_values_source_version: this.____getInitialValuesSourceVersion(this.props),
				data: this.____getInitialValues(this.props),
				errors: {},
				submit_attempts: 0
			};
		},
		componentWillReceiveProps: function(new_props){
			var initial_values_source_version = this.____getInitialValuesSourceVersion(new_props);
			if(this.state.initial_values_source_version !== initial_values_source_version){
				this.setState({
					initial_values_source_version: initial_values_source_version,
					data: this.____getInitialValues(new_props),
					errors: {},
					submit_attempts: 0
				}, this.____onInitialValuesChanged);
			}
		},
		Form_validate: function(){
			var fields = this.Form_buildSchema();
			var data = this.state.data;
			return validateFields(fields, data);
		},
		Form_onSubmit: function(e){
			if(e && e.preventDefault){
				e.preventDefault();
			}
			var self = this;
			this.setState({
				submit_attempts: this.state.submit_attempts + 1,
				errors: this.Form_validate()
			}, function(){
				if(is.empty(self.state.errors)){
					self.____onSubmit(self.state.data);
				}else{
					self.____onSubmitFail(self.state.errors);
				}
			});
		},
		Form_onChange: function(field_name, new_value){
			var self = this;
			var fields = this.Form_buildSchema();
			var should_validate = this.state.submit_attempts > 0;
	
			//merge in the new value without mutating this.state.data
			var o = {};
			o[field_name] = new_value;
			var data = xtend(this.state.data, o);
	
			this.setState({
				data: data,
				errors: should_validate ? validateFields(fields, data) : null
			}, function(){
				self.____onFormChanged(field_name, new_value);
			});
		},
		Form_buildInput: function(field){
			var self = this;
			var input = InputTypes.getInputByType(field.type);
			return input.component({
				field: field,
				value: this.state.data[field.name],
				onChange: function(value){
					self.Form_onChange(field.name, value);
				}
			});
		},
		Form_reset: function(){
			this.setState({data: this.____getInitialValues(this.props), errors: {}, submit_attempts: 0});
		},
		Form_areChangesMade: function(props){
			return !is.equal(this.state.data, this.____getInitialValues(props || this.props));
		},
		Form_buildSchema: function(){
			var schema = this.____buildSchema();
			Object.keys(schema).forEach(function(name){
				schema[name].name = name;
			});
			return schema;
		},
	
		//Below are functions that the child can implement
		____buildSchema: function(){
			if(is.fn(this.buildSchema)){
				return this.buildSchema();
			}else{
				console.warn("react-loose-forms FormMixin expects there to be a funciton on the compoent called buildSchema that returns the schema for the form.");
				return {};
			}
		},
		____getInitialValuesSourceVersion: function(props){
			if(is.fn(this.getInitialValuesSourceVersion)){
				return this.getInitialValuesSourceVersion(props);
			}
			return JSON.stringify(this.____getInitialValues(props));
		},
		____getInitialValues: function(props){
			if(is.fn(this.getInitialValues)){
				return clone(this.getInitialValues(props) || {});
			}
			return {};
		},
		____onFormChanged: function(field_name, new_value){
			if(is.fn(this.onFormChanged)){
				this.onFormChanged(field_name, new_value);
			}
		},
		____onInitialValuesChanged: function(){
			if(is.fn(this.onInitialValuesChanged)){
				this.onInitialValuesChanged();
			}
		},
		____onSubmit: function(data){
			if(is.fn(this.props.onSubmit)){
				this.props.onSubmit(data);
			}
		},
		____onSubmitFail: function(errors){
			if(is.fn(this.props.onSubmitFail)){
				this.props.onSubmitFail(errors);
			}
		}
	};
	
	var defaultValidationFn = function(value, field){
		return true;
	};
	
	var validateFields = function(fields, data){
		var errors = {};
		Object.keys(fields).forEach(function(field_name){
			var field = fields[field_name];
			var validation_fn = defaultValidationFn;
			if(is.fn(field.validate)){
				validation_fn = field.validate;
			}else{
				var input = InputTypes.getInputByType(field.type);
				if(is.fn(input && input.validate)){
					validation_fn = input.validate;
				}
			}
			var resp = validation_fn(data[field_name], field);
			if(resp !== true){
				errors[field_name] = resp;
			}
		});
		return errors;
	};
	
	module.exports = FormMixin;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var radio = __webpack_require__(72);
	var toArray = __webpack_require__(502);
	var RadioMixin = __webpack_require__(98);
	
	var callServiceKey = function(service){
	  return "RadioService_callService-key-" + service;
	};
	
	module.exports = {
	  mixins: [RadioMixin],
	  getInitialState: function(){
	    var state = {};
	    var s = this.__RadioService_setup();
	    Object.keys(s).forEach(function(name){
	      state[name] = {
	        waiting: false,
	        data: null,
	        error: null
	      };
	      state[callServiceKey(name)] = null;
	    });
	    return state;
	  },
	  RadioService_setServiceState: function(name, new_state, onDone){
	    var state = {};
	    state[name] = new_state;
	    this.setState(state, onDone);
	  },
	  Radio_setup: function(){
	    var self = this;
	    var channels = {};
	    if(this.RadioService_Radio_setup){
	      channels = this.RadioService_Radio_setup();
	    }
	    var updateState = this.RadioService_setServiceState;
	
	    var s = this.__RadioService_setup();
	    var callEventListener = function(name, event_name){
	      if(s[name] && s[name].on && s[name].on[event_name]){
	        s[name].on[event_name].apply(self, toArray(arguments, 2));
	      }
	    };
	
	    Object.keys(s).forEach(function(name){
	      var settings = s[name];
	      if(!settings.key){
	        console.warn('RadioServiceMixin expects each service you listen to have a "key" method');
	        return;
	      }
	      var isMe = function(key){
	        if(settings.key === "callService"){
	          return self.state[callServiceKey(name)] === key;
	        }
	        return settings.key.apply(self) === key;
	      };
	
	      channels[name + "_waiting"] = function(key){
	        if(!isMe(key))
	          return;
	        updateState(name, {waiting: true, data: null, error: null}, function(){
	          callEventListener(name, "waiting");
	        });
	      };
	      channels[name + "_succeeded"] = function(key, data){
	        if(!isMe(key))
	          return;
	        updateState(name, {waiting: false, data: data, error: null}, function(){
	          callEventListener(name, "succeeded", data);
	        });
	      };
	      channels[name + "_failed"] = function(key, error){
	        if(!isMe(key))
	          return;
	        updateState(name, {waiting: false, data: null, error: error}, function(){
	          callEventListener(name, "failed", error);
	        });
	      };
	    });
	
	    return channels;
	  },
	  __RadioService_setup: function(){
	    if(!this.RadioService_setup){
	      console.warn("RadioServiceMixin expects you to define a method called RadioService_setup");
	      return {};
	    }
	    if(!this.__RadioService_setup_cache){
	      this.__RadioService_setup_cache = this.RadioService_setup();
	    }
	    return this.__RadioService_setup_cache;
	  },
	  RadioService_callService: function(service, params){
	    var s = {};
	    s[callServiceKey(service)] = JSON.stringify(params);
	    this.setState(s, function(){
	      radio(service).broadcast(params);
	    });
	  }
	};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(31);
	
	var findDOMNode = __webpack_require__(107);
	var focusNode = __webpack_require__(135);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(28);
	var FallbackCompositionState = __webpack_require__(455);
	var SyntheticCompositionEvent = __webpack_require__(485);
	var SyntheticInputEvent = __webpack_require__(488);
	
	var keyOf = __webpack_require__(46);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(148);
	var ExecutionEnvironment = __webpack_require__(28);
	var ReactPerf = __webpack_require__(39);
	
	var camelizeStyleName = __webpack_require__(404);
	var dangerousStyleValue = __webpack_require__(493);
	var hyphenateStyleName = __webpack_require__(409);
	var memoizeStringOnly = __webpack_require__(413);
	var warning = __webpack_require__(16);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPluginHub = __webpack_require__(61);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(40);
	var SyntheticEvent = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(110);
	var isEventSupported = __webpack_require__(113);
	var isTextInputElement = __webpack_require__(175);
	var keyOf = __webpack_require__(46);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var createNodesFromMarkup = __webpack_require__(406);
	var emptyFunction = __webpack_require__(42);
	var getMarkupWrap = __webpack_require__(137);
	var invariant = __webpack_require__(11);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(46);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPropagators = __webpack_require__(62);
	var SyntheticMouseEvent = __webpack_require__(77);
	
	var ReactMount = __webpack_require__(31);
	var keyOf = __webpack_require__(46);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var ReactErrorUtils = __webpack_require__(163);
	
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(48);
	
	var assign = __webpack_require__(17);
	var getTextContentAccessor = __webpack_require__(174);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var ExecutionEnvironment = __webpack_require__(28);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(154);
	var ReactDOMServer = __webpack_require__(467);
	var ReactIsomorphic = __webpack_require__(472);
	
	var assign = __webpack_require__(17);
	var deprecated = __webpack_require__(494);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(63);
	
	var findDOMNode = __webpack_require__(107);
	var warning = __webpack_require__(16);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(52);
	
	var instantiateReactComponent = __webpack_require__(112);
	var shouldUpdateReactComponent = __webpack_require__(115);
	var traverseAllChildren = __webpack_require__(116);
	var warning = __webpack_require__(16);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(103);
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceMap = __webpack_require__(63);
	var ReactPerf = __webpack_require__(39);
	var ReactPropTypeLocations = __webpack_require__(76);
	var ReactPropTypeLocationNames = __webpack_require__(75);
	var ReactReconciler = __webpack_require__(52);
	var ReactUpdateQueue = __webpack_require__(105);
	
	var assign = __webpack_require__(17);
	var emptyObject = __webpack_require__(59);
	var invariant = __webpack_require__(11);
	var shouldUpdateReactComponent = __webpack_require__(115);
	var warning = __webpack_require__(16);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(446);
	var CSSPropertyOperations = __webpack_require__(448);
	var DOMProperty = __webpack_require__(56);
	var DOMPropertyOperations = __webpack_require__(100);
	var EventConstants = __webpack_require__(43);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactComponentBrowserEnvironment = __webpack_require__(102);
	var ReactDOMButton = __webpack_require__(461);
	var ReactDOMInput = __webpack_require__(464);
	var ReactDOMOption = __webpack_require__(465);
	var ReactDOMSelect = __webpack_require__(156);
	var ReactDOMTextarea = __webpack_require__(468);
	var ReactMount = __webpack_require__(31);
	var ReactMultiChild = __webpack_require__(473);
	var ReactPerf = __webpack_require__(39);
	var ReactUpdateQueue = __webpack_require__(105);
	
	var assign = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(79);
	var escapeTextContentForBrowser = __webpack_require__(80);
	var invariant = __webpack_require__(11);
	var isEventSupported = __webpack_require__(113);
	var keyOf = __webpack_require__(46);
	var setInnerHTML = __webpack_require__(81);
	var setTextContent = __webpack_require__(114);
	var shallowEqual = __webpack_require__(138);
	var validateDOMNesting = __webpack_require__(117);
	var warning = __webpack_require__(16);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	var ReactElementValidator = __webpack_require__(160);
	
	var mapObject = __webpack_require__(412);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(104);
	var LinkedValueUtils = __webpack_require__(101);
	var ReactMount = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(151);
	var ReactDOMSelect = __webpack_require__(156);
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    nativeProps.children = content;
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(28);
	
	var getNodeForCharacterOffset = __webpack_require__(497);
	var getTextContentAccessor = __webpack_require__(174);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(159);
	var ReactServerRendering = __webpack_require__(478);
	var ReactVersion = __webpack_require__(106);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(101);
	var ReactDOMIDOperations = __webpack_require__(104);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var invariant = __webpack_require__(11);
	var warning = __webpack_require__(16);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(61);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(133);
	var ExecutionEnvironment = __webpack_require__(28);
	var PooledClass = __webpack_require__(48);
	var ReactInstanceHandles = __webpack_require__(57);
	var ReactMount = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(40);
	
	var assign = __webpack_require__(17);
	var getEventTarget = __webpack_require__(110);
	var getUnboundedScrollPosition = __webpack_require__(407);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var EventPluginHub = __webpack_require__(61);
	var ReactComponentEnvironment = __webpack_require__(103);
	var ReactClass = __webpack_require__(152);
	var ReactEmptyComponent = __webpack_require__(161);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactNativeComponent = __webpack_require__(167);
	var ReactPerf = __webpack_require__(39);
	var ReactRootIndex = __webpack_require__(170);
	var ReactUpdates = __webpack_require__(40);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(151);
	var ReactComponent = __webpack_require__(153);
	var ReactClass = __webpack_require__(152);
	var ReactDOMFactories = __webpack_require__(463);
	var ReactElement = __webpack_require__(35);
	var ReactElementValidator = __webpack_require__(160);
	var ReactPropTypes = __webpack_require__(169);
	var ReactVersion = __webpack_require__(106);
	
	var assign = __webpack_require__(17);
	var onlyChild = __webpack_require__(498);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(103);
	var ReactMultiChildUpdateTypes = __webpack_require__(166);
	
	var ReactCurrentOwner = __webpack_require__(44);
	var ReactReconciler = __webpack_require__(52);
	var ReactChildReconciler = __webpack_require__(459);
	
	var flattenChildren = __webpack_require__(495);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(11);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(99);
	var PooledClass = __webpack_require__(48);
	var ReactBrowserEventEmitter = __webpack_require__(74);
	var ReactDOMFeatureFlags = __webpack_require__(155);
	var ReactInputSelection = __webpack_require__(164);
	var Transaction = __webpack_require__(78);
	
	var assign = __webpack_require__(17);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(474);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(158);
	var ReactElement = __webpack_require__(35);
	var ReactInstanceHandles = __webpack_require__(57);
	var ReactMarkupChecksum = __webpack_require__(165);
	var ReactServerBatchingStrategy = __webpack_require__(477);
	var ReactServerRenderingTransaction = __webpack_require__(479);
	var ReactUpdates = __webpack_require__(40);
	
	var emptyObject = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(112);
	var invariant = __webpack_require__(11);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(48);
	var CallbackQueue = __webpack_require__(99);
	var Transaction = __webpack_require__(78);
	
	var assign = __webpack_require__(17);
	var emptyFunction = __webpack_require__(42);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventPropagators = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(28);
	var ReactInputSelection = __webpack_require__(164);
	var SyntheticEvent = __webpack_require__(53);
	
	var getActiveElement = __webpack_require__(136);
	var isTextInputElement = __webpack_require__(175);
	var keyOf = __webpack_require__(46);
	var shallowEqual = __webpack_require__(138);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(43);
	var EventListener = __webpack_require__(133);
	var EventPropagators = __webpack_require__(62);
	var ReactMount = __webpack_require__(31);
	var SyntheticClipboardEvent = __webpack_require__(484);
	var SyntheticEvent = __webpack_require__(53);
	var SyntheticFocusEvent = __webpack_require__(487);
	var SyntheticKeyboardEvent = __webpack_require__(489);
	var SyntheticMouseEvent = __webpack_require__(77);
	var SyntheticDragEvent = __webpack_require__(486);
	var SyntheticTouchEvent = __webpack_require__(490);
	var SyntheticUIEvent = __webpack_require__(64);
	var SyntheticWheelEvent = __webpack_require__(491);
	
	var emptyFunction = __webpack_require__(42);
	var getEventCharCode = __webpack_require__(108);
	var invariant = __webpack_require__(11);
	var keyOf = __webpack_require__(46);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(53);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventCharCode = __webpack_require__(108);
	var getEventKey = __webpack_require__(496);
	var getEventModifierState = __webpack_require__(109);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(64);
	
	var getEventModifierState = __webpack_require__(109);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(77);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 492 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(148);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(17);
	var warning = __webpack_require__(16);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(116);
	var warning = __webpack_require__(16);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(108);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(35);
	
	var invariant = __webpack_require__(11);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(80);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(31);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	'use strict';
	
	var settings = {
	    allowFuture: true,
	    prefixAgo: null,
	    prefixFromNow: null,
	    numbers: [],
	    suffixAgo: 'ago',
	    suffixFromNow: 'from now',
	    seconds: 'less than a minute',
	    minute: 'about a minute',
	    minutes: '%d minutes',
	    hour: 'about an hour',
	    hours: 'about %d hours',
	    day: 'a day',
	    days: '%d days',
	    month: 'about a month',
	    months: '%d months',
	    year: 'about a year',
	    years: '%d years'
	};
	
	function timeAgo (since, until) {
	    if (since == null) since = new Date();
	    if (until == null) until = new Date();
	
	    return inWords(until.getTime() - since.getTime());
	}
	
	function substitute (string, number) {
	    var value;
	    value = (settings.numbers && settings.numbers[number]) || number;
	    return string.replace(/%d/i, value);
	}
	
	function inWords (distanceMillis) {
	    var years, days, hours, minutes, prefix, seconds, suffix, words;
	
	    prefix = settings.prefixAgo;
	    suffix = settings.suffixAgo;
	
	    if (settings.allowFuture) {
	        if (distanceMillis < 0) {
	            prefix = settings.prefixFromNow;
	            suffix = settings.suffixFromNow;
	        }
	    }
	
	    seconds = Math.abs(distanceMillis) / 1000;
	    minutes = seconds / 60;
	    hours = minutes / 60;
	    days = hours / 24;
	    years = days / 365;
	    words = seconds < 45 && substitute(settings.seconds, Math.round(seconds)) ||
	            seconds < 90 && substitute(settings.minute, 1) ||
	            minutes < 45 && substitute(settings.minutes, Math.round(minutes)) ||
	            minutes < 90 && substitute(settings.hour, 1) ||
	            hours < 24 && substitute(settings.hours, Math.round(hours)) ||
	            hours < 48 && substitute(settings.day, 1) ||
	            days < 30 && substitute(settings.days, Math.floor(days)) ||
	            days < 60 && substitute(settings.month, 1) ||
	            days < 365 && substitute(settings.months, Math.floor(days / 30)) ||
	            years < 2 && substitute(settings.year, 1) ||
	            substitute(settings.years, Math.floor(years));
	
	    return [prefix, words, suffix].join(' ').toString().trim();
	}
	
	module.exports = timeAgo;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(s) {
	  return s.substr(0, 1).toUpperCase() + s.substring(1);
	};
	


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// beta.min.js